import { d as fe } from "./index-Buti0PLx.js";
import { c as Ge, a as Np } from "./_commonjsHelpers-CT_km90n.js";
import { b as or } from "./index-jyncyKHm.js";
var je = {
  // default options
  options: {
    usePureJavaScript: !1
  }
}, Ko = {}, kp = Ko, w0 = {};
Ko.encode = function(e, t, i) {
  if (typeof t != "string")
    throw new TypeError('"alphabet" must be a string.');
  if (i !== void 0 && typeof i != "number")
    throw new TypeError('"maxline" must be a number.');
  var r = "";
  if (!(e instanceof Uint8Array))
    r = Dp(e, t);
  else {
    var n = 0, a = t.length, f = t.charAt(0), s = [0];
    for (n = 0; n < e.length; ++n) {
      for (var c = 0, u = e[n]; c < s.length; ++c)
        u += s[c] << 8, s[c] = u % a, u = u / a | 0;
      for (; u > 0; )
        s.push(u % a), u = u / a | 0;
    }
    for (n = 0; e[n] === 0 && n < e.length - 1; ++n)
      r += f;
    for (n = s.length - 1; n >= 0; --n)
      r += t[s[n]];
  }
  if (i) {
    var o = new RegExp(".{1," + i + "}", "g");
    r = r.match(o).join(`\r
`);
  }
  return r;
};
Ko.decode = function(e, t) {
  if (typeof e != "string")
    throw new TypeError('"input" must be a string.');
  if (typeof t != "string")
    throw new TypeError('"alphabet" must be a string.');
  var i = w0[t];
  if (!i) {
    i = w0[t] = [];
    for (var r = 0; r < t.length; ++r)
      i[t.charCodeAt(r)] = r;
  }
  e = e.replace(/\s/g, "");
  for (var n = t.length, a = t.charAt(0), f = [0], r = 0; r < e.length; r++) {
    var s = i[e.charCodeAt(r)];
    if (s === void 0)
      return;
    for (var c = 0, u = s; c < f.length; ++c)
      u += f[c] * n, f[c] = u & 255, u >>= 8;
    for (; u > 0; )
      f.push(u & 255), u >>= 8;
  }
  for (var o = 0; e[o] === a && o < e.length - 1; ++o)
    f.push(0);
  return typeof fe.Buffer < "u" ? fe.Buffer.from(f.reverse()) : new Uint8Array(f.reverse());
};
function Dp(e, t) {
  var i = 0, r = t.length, n = t.charAt(0), a = [0];
  for (i = 0; i < e.length(); ++i) {
    for (var f = 0, s = e.at(i); f < a.length; ++f)
      s += a[f] << 8, a[f] = s % r, s = s / r | 0;
    for (; s > 0; )
      a.push(s % r), s = s / r | 0;
  }
  var c = "";
  for (i = 0; e.at(i) === 0 && i < e.length() - 1; ++i)
    c += n;
  for (i = a.length - 1; i >= 0; --i)
    c += t[a[i]];
  return c;
}
var C0 = je, A0 = kp, J = C0.util = C0.util || {};
(function() {
  if (typeof fe.process < "u" && fe.process.nextTick && !fe.process.browser) {
    J.nextTick = fe.process.nextTick, typeof setImmediate == "function" ? J.setImmediate = setImmediate : J.setImmediate = J.nextTick;
    return;
  }
  if (typeof setImmediate == "function") {
    J.setImmediate = function() {
      return setImmediate.apply(void 0, arguments);
    }, J.nextTick = function(f) {
      return setImmediate(f);
    };
    return;
  }
  if (J.setImmediate = function(f) {
    setTimeout(f, 0);
  }, typeof window < "u" && typeof window.postMessage == "function") {
    let f = function(s) {
      if (s.source === window && s.data === e) {
        s.stopPropagation();
        var c = t.slice();
        t.length = 0, c.forEach(function(u) {
          u();
        });
      }
    };
    var e = "forge.setImmediate", t = [];
    J.setImmediate = function(s) {
      t.push(s), t.length === 1 && window.postMessage(e, "*");
    }, window.addEventListener("message", f, !0);
  }
  if (typeof MutationObserver < "u") {
    var i = Date.now(), r = !0, n = document.createElement("div"), t = [];
    new MutationObserver(function() {
      var s = t.slice();
      t.length = 0, s.forEach(function(c) {
        c();
      });
    }).observe(n, { attributes: !0 });
    var a = J.setImmediate;
    J.setImmediate = function(s) {
      Date.now() - i > 15 ? (i = Date.now(), a(s)) : (t.push(s), t.length === 1 && n.setAttribute("a", r = !r));
    };
  }
  J.nextTick = J.setImmediate;
})();
J.isNodejs = typeof fe.process < "u" && fe.process.versions && fe.process.versions.node;
J.globalScope = function() {
  return J.isNodejs ? Ge : typeof self > "u" ? window : self;
}();
J.isArray = Array.isArray || function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
};
J.isArrayBuffer = function(e) {
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer;
};
J.isArrayBufferView = function(e) {
  return e && J.isArrayBuffer(e.buffer) && e.byteLength !== void 0;
};
function Ki(e) {
  if (!(e === 8 || e === 16 || e === 24 || e === 32))
    throw new Error("Only 8, 16, 24, or 32 bits supported: " + e);
}
J.ByteBuffer = Ho;
function Ho(e) {
  if (this.data = "", this.read = 0, typeof e == "string")
    this.data = e;
  else if (J.isArrayBuffer(e) || J.isArrayBufferView(e))
    if (typeof fe.Buffer < "u" && e instanceof fe.Buffer)
      this.data = e.toString("binary");
    else {
      var t = new Uint8Array(e);
      try {
        this.data = String.fromCharCode.apply(null, t);
      } catch {
        for (var i = 0; i < t.length; ++i)
          this.putByte(t[i]);
      }
    }
  else
    (e instanceof Ho || typeof e == "object" && typeof e.data == "string" && typeof e.read == "number") && (this.data = e.data, this.read = e.read);
  this._constructedStringLength = 0;
}
J.ByteStringBuffer = Ho;
var Lp = 4096;
J.ByteStringBuffer.prototype._optimizeConstructedString = function(e) {
  this._constructedStringLength += e, this._constructedStringLength > Lp && (this.data.substr(0, 1), this._constructedStringLength = 0);
};
J.ByteStringBuffer.prototype.length = function() {
  return this.data.length - this.read;
};
J.ByteStringBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
J.ByteStringBuffer.prototype.putByte = function(e) {
  return this.putBytes(String.fromCharCode(e));
};
J.ByteStringBuffer.prototype.fillWithByte = function(e, t) {
  e = String.fromCharCode(e);
  for (var i = this.data; t > 0; )
    t & 1 && (i += e), t >>>= 1, t > 0 && (e += e);
  return this.data = i, this._optimizeConstructedString(t), this;
};
J.ByteStringBuffer.prototype.putBytes = function(e) {
  return this.data += e, this._optimizeConstructedString(e.length), this;
};
J.ByteStringBuffer.prototype.putString = function(e) {
  return this.putBytes(J.encodeUtf8(e));
};
J.ByteStringBuffer.prototype.putInt16 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
J.ByteStringBuffer.prototype.putInt24 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
J.ByteStringBuffer.prototype.putInt32 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 24 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
J.ByteStringBuffer.prototype.putInt16Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255)
  );
};
J.ByteStringBuffer.prototype.putInt24Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e >> 16 & 255)
  );
};
J.ByteStringBuffer.prototype.putInt32Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 24 & 255)
  );
};
J.ByteStringBuffer.prototype.putInt = function(e, t) {
  Ki(t);
  var i = "";
  do
    t -= 8, i += String.fromCharCode(e >> t & 255);
  while (t > 0);
  return this.putBytes(i);
};
J.ByteStringBuffer.prototype.putSignedInt = function(e, t) {
  return e < 0 && (e += 2 << t - 1), this.putInt(e, t);
};
J.ByteStringBuffer.prototype.putBuffer = function(e) {
  return this.putBytes(e.getBytes());
};
J.ByteStringBuffer.prototype.getByte = function() {
  return this.data.charCodeAt(this.read++);
};
J.ByteStringBuffer.prototype.getInt16 = function() {
  var e = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
  return this.read += 2, e;
};
J.ByteStringBuffer.prototype.getInt24 = function() {
  var e = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
  return this.read += 3, e;
};
J.ByteStringBuffer.prototype.getInt32 = function() {
  var e = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
  return this.read += 4, e;
};
J.ByteStringBuffer.prototype.getInt16Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
  return this.read += 2, e;
};
J.ByteStringBuffer.prototype.getInt24Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
  return this.read += 3, e;
};
J.ByteStringBuffer.prototype.getInt32Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
  return this.read += 4, e;
};
J.ByteStringBuffer.prototype.getInt = function(e) {
  Ki(e);
  var t = 0;
  do
    t = (t << 8) + this.data.charCodeAt(this.read++), e -= 8;
  while (e > 0);
  return t;
};
J.ByteStringBuffer.prototype.getSignedInt = function(e) {
  var t = this.getInt(e), i = 2 << e - 2;
  return t >= i && (t -= i << 1), t;
};
J.ByteStringBuffer.prototype.getBytes = function(e) {
  var t;
  return e ? (e = Math.min(this.length(), e), t = this.data.slice(this.read, this.read + e), this.read += e) : e === 0 ? t = "" : (t = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t;
};
J.ByteStringBuffer.prototype.bytes = function(e) {
  return typeof e > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e);
};
J.ByteStringBuffer.prototype.at = function(e) {
  return this.data.charCodeAt(this.read + e);
};
J.ByteStringBuffer.prototype.setAt = function(e, t) {
  return this.data = this.data.substr(0, this.read + e) + String.fromCharCode(t) + this.data.substr(this.read + e + 1), this;
};
J.ByteStringBuffer.prototype.last = function() {
  return this.data.charCodeAt(this.data.length - 1);
};
J.ByteStringBuffer.prototype.copy = function() {
  var e = J.createBuffer(this.data);
  return e.read = this.read, e;
};
J.ByteStringBuffer.prototype.compact = function() {
  return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
};
J.ByteStringBuffer.prototype.clear = function() {
  return this.data = "", this.read = 0, this;
};
J.ByteStringBuffer.prototype.truncate = function(e) {
  var t = Math.max(0, this.length() - e);
  return this.data = this.data.substr(this.read, t), this.read = 0, this;
};
J.ByteStringBuffer.prototype.toHex = function() {
  for (var e = "", t = this.read; t < this.data.length; ++t) {
    var i = this.data.charCodeAt(t);
    i < 16 && (e += "0"), e += i.toString(16);
  }
  return e;
};
J.ByteStringBuffer.prototype.toString = function() {
  return J.decodeUtf8(this.bytes());
};
function Pp(e, t) {
  t = t || {}, this.read = t.readOffset || 0, this.growSize = t.growSize || 1024;
  var i = J.isArrayBuffer(e), r = J.isArrayBufferView(e);
  if (i || r) {
    i ? this.data = new DataView(e) : this.data = new DataView(e.buffer, e.byteOffset, e.byteLength), this.write = "writeOffset" in t ? t.writeOffset : this.data.byteLength;
    return;
  }
  this.data = new DataView(new ArrayBuffer(0)), this.write = 0, e != null && this.putBytes(e), "writeOffset" in t && (this.write = t.writeOffset);
}
J.DataBuffer = Pp;
J.DataBuffer.prototype.length = function() {
  return this.write - this.read;
};
J.DataBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
J.DataBuffer.prototype.accommodate = function(e, t) {
  if (this.length() >= e)
    return this;
  t = Math.max(t || this.growSize, e);
  var i = new Uint8Array(
    this.data.buffer,
    this.data.byteOffset,
    this.data.byteLength
  ), r = new Uint8Array(this.length() + t);
  return r.set(i), this.data = new DataView(r.buffer), this;
};
J.DataBuffer.prototype.putByte = function(e) {
  return this.accommodate(1), this.data.setUint8(this.write++, e), this;
};
J.DataBuffer.prototype.fillWithByte = function(e, t) {
  this.accommodate(t);
  for (var i = 0; i < t; ++i)
    this.data.setUint8(e);
  return this;
};
J.DataBuffer.prototype.putBytes = function(e, t) {
  if (J.isArrayBufferView(e)) {
    var i = new Uint8Array(e.buffer, e.byteOffset, e.byteLength), r = i.byteLength - i.byteOffset;
    this.accommodate(r);
    var n = new Uint8Array(this.data.buffer, this.write);
    return n.set(i), this.write += r, this;
  }
  if (J.isArrayBuffer(e)) {
    var i = new Uint8Array(e);
    this.accommodate(i.byteLength);
    var n = new Uint8Array(this.data.buffer);
    return n.set(i, this.write), this.write += i.byteLength, this;
  }
  if (e instanceof J.DataBuffer || typeof e == "object" && typeof e.read == "number" && typeof e.write == "number" && J.isArrayBufferView(e.data)) {
    var i = new Uint8Array(e.data.byteLength, e.read, e.length());
    this.accommodate(i.byteLength);
    var n = new Uint8Array(e.data.byteLength, this.write);
    return n.set(i), this.write += i.byteLength, this;
  }
  if (e instanceof J.ByteStringBuffer && (e = e.data, t = "binary"), t = t || "binary", typeof e == "string") {
    var a;
    if (t === "hex")
      return this.accommodate(Math.ceil(e.length / 2)), a = new Uint8Array(this.data.buffer, this.write), this.write += J.binary.hex.decode(e, a, this.write), this;
    if (t === "base64")
      return this.accommodate(Math.ceil(e.length / 4) * 3), a = new Uint8Array(this.data.buffer, this.write), this.write += J.binary.base64.decode(e, a, this.write), this;
    if (t === "utf8" && (e = J.encodeUtf8(e), t = "binary"), t === "binary" || t === "raw")
      return this.accommodate(e.length), a = new Uint8Array(this.data.buffer, this.write), this.write += J.binary.raw.decode(a), this;
    if (t === "utf16")
      return this.accommodate(e.length * 2), a = new Uint16Array(this.data.buffer, this.write), this.write += J.text.utf16.encode(a), this;
    throw new Error("Invalid encoding: " + t);
  }
  throw Error("Invalid parameter: " + e);
};
J.DataBuffer.prototype.putBuffer = function(e) {
  return this.putBytes(e), e.clear(), this;
};
J.DataBuffer.prototype.putString = function(e) {
  return this.putBytes(e, "utf16");
};
J.DataBuffer.prototype.putInt16 = function(e) {
  return this.accommodate(2), this.data.setInt16(this.write, e), this.write += 2, this;
};
J.DataBuffer.prototype.putInt24 = function(e) {
  return this.accommodate(3), this.data.setInt16(this.write, e >> 8 & 65535), this.data.setInt8(this.write, e >> 16 & 255), this.write += 3, this;
};
J.DataBuffer.prototype.putInt32 = function(e) {
  return this.accommodate(4), this.data.setInt32(this.write, e), this.write += 4, this;
};
J.DataBuffer.prototype.putInt16Le = function(e) {
  return this.accommodate(2), this.data.setInt16(this.write, e, !0), this.write += 2, this;
};
J.DataBuffer.prototype.putInt24Le = function(e) {
  return this.accommodate(3), this.data.setInt8(this.write, e >> 16 & 255), this.data.setInt16(this.write, e >> 8 & 65535, !0), this.write += 3, this;
};
J.DataBuffer.prototype.putInt32Le = function(e) {
  return this.accommodate(4), this.data.setInt32(this.write, e, !0), this.write += 4, this;
};
J.DataBuffer.prototype.putInt = function(e, t) {
  Ki(t), this.accommodate(t / 8);
  do
    t -= 8, this.data.setInt8(this.write++, e >> t & 255);
  while (t > 0);
  return this;
};
J.DataBuffer.prototype.putSignedInt = function(e, t) {
  return Ki(t), this.accommodate(t / 8), e < 0 && (e += 2 << t - 1), this.putInt(e, t);
};
J.DataBuffer.prototype.getByte = function() {
  return this.data.getInt8(this.read++);
};
J.DataBuffer.prototype.getInt16 = function() {
  var e = this.data.getInt16(this.read);
  return this.read += 2, e;
};
J.DataBuffer.prototype.getInt24 = function() {
  var e = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
  return this.read += 3, e;
};
J.DataBuffer.prototype.getInt32 = function() {
  var e = this.data.getInt32(this.read);
  return this.read += 4, e;
};
J.DataBuffer.prototype.getInt16Le = function() {
  var e = this.data.getInt16(this.read, !0);
  return this.read += 2, e;
};
J.DataBuffer.prototype.getInt24Le = function() {
  var e = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, !0) << 8;
  return this.read += 3, e;
};
J.DataBuffer.prototype.getInt32Le = function() {
  var e = this.data.getInt32(this.read, !0);
  return this.read += 4, e;
};
J.DataBuffer.prototype.getInt = function(e) {
  Ki(e);
  var t = 0;
  do
    t = (t << 8) + this.data.getInt8(this.read++), e -= 8;
  while (e > 0);
  return t;
};
J.DataBuffer.prototype.getSignedInt = function(e) {
  var t = this.getInt(e), i = 2 << e - 2;
  return t >= i && (t -= i << 1), t;
};
J.DataBuffer.prototype.getBytes = function(e) {
  var t;
  return e ? (e = Math.min(this.length(), e), t = this.data.slice(this.read, this.read + e), this.read += e) : e === 0 ? t = "" : (t = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t;
};
J.DataBuffer.prototype.bytes = function(e) {
  return typeof e > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e);
};
J.DataBuffer.prototype.at = function(e) {
  return this.data.getUint8(this.read + e);
};
J.DataBuffer.prototype.setAt = function(e, t) {
  return this.data.setUint8(e, t), this;
};
J.DataBuffer.prototype.last = function() {
  return this.data.getUint8(this.write - 1);
};
J.DataBuffer.prototype.copy = function() {
  return new J.DataBuffer(this);
};
J.DataBuffer.prototype.compact = function() {
  if (this.read > 0) {
    var e = new Uint8Array(this.data.buffer, this.read), t = new Uint8Array(e.byteLength);
    t.set(e), this.data = new DataView(t), this.write -= this.read, this.read = 0;
  }
  return this;
};
J.DataBuffer.prototype.clear = function() {
  return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
};
J.DataBuffer.prototype.truncate = function(e) {
  return this.write = Math.max(0, this.length() - e), this.read = Math.min(this.read, this.write), this;
};
J.DataBuffer.prototype.toHex = function() {
  for (var e = "", t = this.read; t < this.data.byteLength; ++t) {
    var i = this.data.getUint8(t);
    i < 16 && (e += "0"), e += i.toString(16);
  }
  return e;
};
J.DataBuffer.prototype.toString = function(e) {
  var t = new Uint8Array(this.data, this.read, this.length());
  if (e = e || "utf8", e === "binary" || e === "raw")
    return J.binary.raw.encode(t);
  if (e === "hex")
    return J.binary.hex.encode(t);
  if (e === "base64")
    return J.binary.base64.encode(t);
  if (e === "utf8")
    return J.text.utf8.decode(t);
  if (e === "utf16")
    return J.text.utf16.decode(t);
  throw new Error("Invalid encoding: " + e);
};
J.createBuffer = function(e, t) {
  return t = t || "raw", e !== void 0 && t === "utf8" && (e = J.encodeUtf8(e)), new J.ByteBuffer(e);
};
J.fillString = function(e, t) {
  for (var i = ""; t > 0; )
    t & 1 && (i += e), t >>>= 1, t > 0 && (e += e);
  return i;
};
J.xorBytes = function(e, t, i) {
  for (var r = "", n = "", a = "", f = 0, s = 0; i > 0; --i, ++f)
    n = e.charCodeAt(f) ^ t.charCodeAt(f), s >= 10 && (r += a, a = "", s = 0), a += String.fromCharCode(n), ++s;
  return r += a, r;
};
J.hexToBytes = function(e) {
  var t = "", i = 0;
  for (e.length & !0 && (i = 1, t += String.fromCharCode(parseInt(e[0], 16))); i < e.length; i += 2)
    t += String.fromCharCode(parseInt(e.substr(i, 2), 16));
  return t;
};
J.bytesToHex = function(e) {
  return J.createBuffer(e).toHex();
};
J.int32ToBytes = function(e) {
  return String.fromCharCode(e >> 24 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255);
};
var Ir = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Rr = [
  /*43 -43 = 0*/
  /*'+',  1,  2,  3,'/' */
  62,
  -1,
  -1,
  -1,
  63,
  /*'0','1','2','3','4','5','6','7','8','9' */
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  /*15, 16, 17,'=', 19, 20, 21 */
  -1,
  -1,
  -1,
  64,
  -1,
  -1,
  -1,
  /*65 - 43 = 22*/
  /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  /*91 - 43 = 48 */
  /*48, 49, 50, 51, 52, 53 */
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  /*97 - 43 = 54*/
  /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51
], Hh = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
J.encode64 = function(e, t) {
  for (var i = "", r = "", n, a, f, s = 0; s < e.length; )
    n = e.charCodeAt(s++), a = e.charCodeAt(s++), f = e.charCodeAt(s++), i += Ir.charAt(n >> 2), i += Ir.charAt((n & 3) << 4 | a >> 4), isNaN(a) ? i += "==" : (i += Ir.charAt((a & 15) << 2 | f >> 6), i += isNaN(f) ? "=" : Ir.charAt(f & 63)), t && i.length > t && (r += i.substr(0, t) + `\r
`, i = i.substr(t));
  return r += i, r;
};
J.decode64 = function(e) {
  e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  for (var t = "", i, r, n, a, f = 0; f < e.length; )
    i = Rr[e.charCodeAt(f++) - 43], r = Rr[e.charCodeAt(f++) - 43], n = Rr[e.charCodeAt(f++) - 43], a = Rr[e.charCodeAt(f++) - 43], t += String.fromCharCode(i << 2 | r >> 4), n !== 64 && (t += String.fromCharCode((r & 15) << 4 | n >> 2), a !== 64 && (t += String.fromCharCode((n & 3) << 6 | a)));
  return t;
};
J.encodeUtf8 = function(e) {
  return unescape(encodeURIComponent(e));
};
J.decodeUtf8 = function(e) {
  return decodeURIComponent(escape(e));
};
J.binary = {
  raw: {},
  hex: {},
  base64: {},
  base58: {},
  baseN: {
    encode: A0.encode,
    decode: A0.decode
  }
};
J.binary.raw.encode = function(e) {
  return String.fromCharCode.apply(null, e);
};
J.binary.raw.decode = function(e, t, i) {
  var r = t;
  r || (r = new Uint8Array(e.length)), i = i || 0;
  for (var n = i, a = 0; a < e.length; ++a)
    r[n++] = e.charCodeAt(a);
  return t ? n - i : r;
};
J.binary.hex.encode = J.bytesToHex;
J.binary.hex.decode = function(e, t, i) {
  var r = t;
  r || (r = new Uint8Array(Math.ceil(e.length / 2))), i = i || 0;
  var n = 0, a = i;
  for (e.length & 1 && (n = 1, r[a++] = parseInt(e[0], 16)); n < e.length; n += 2)
    r[a++] = parseInt(e.substr(n, 2), 16);
  return t ? a - i : r;
};
J.binary.base64.encode = function(e, t) {
  for (var i = "", r = "", n, a, f, s = 0; s < e.byteLength; )
    n = e[s++], a = e[s++], f = e[s++], i += Ir.charAt(n >> 2), i += Ir.charAt((n & 3) << 4 | a >> 4), isNaN(a) ? i += "==" : (i += Ir.charAt((a & 15) << 2 | f >> 6), i += isNaN(f) ? "=" : Ir.charAt(f & 63)), t && i.length > t && (r += i.substr(0, t) + `\r
`, i = i.substr(t));
  return r += i, r;
};
J.binary.base64.decode = function(e, t, i) {
  var r = t;
  r || (r = new Uint8Array(Math.ceil(e.length / 4) * 3)), e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""), i = i || 0;
  for (var n, a, f, s, c = 0, u = i; c < e.length; )
    n = Rr[e.charCodeAt(c++) - 43], a = Rr[e.charCodeAt(c++) - 43], f = Rr[e.charCodeAt(c++) - 43], s = Rr[e.charCodeAt(c++) - 43], r[u++] = n << 2 | a >> 4, f !== 64 && (r[u++] = (a & 15) << 4 | f >> 2, s !== 64 && (r[u++] = (f & 3) << 6 | s));
  return t ? u - i : r.subarray(0, u);
};
J.binary.base58.encode = function(e, t) {
  return J.binary.baseN.encode(e, Hh, t);
};
J.binary.base58.decode = function(e, t) {
  return J.binary.baseN.decode(e, Hh, t);
};
J.text = {
  utf8: {},
  utf16: {}
};
J.text.utf8.encode = function(e, t, i) {
  e = J.encodeUtf8(e);
  var r = t;
  r || (r = new Uint8Array(e.length)), i = i || 0;
  for (var n = i, a = 0; a < e.length; ++a)
    r[n++] = e.charCodeAt(a);
  return t ? n - i : r;
};
J.text.utf8.decode = function(e) {
  return J.decodeUtf8(String.fromCharCode.apply(null, e));
};
J.text.utf16.encode = function(e, t, i) {
  var r = t;
  r || (r = new Uint8Array(e.length * 2));
  var n = new Uint16Array(r.buffer);
  i = i || 0;
  for (var a = i, f = i, s = 0; s < e.length; ++s)
    n[f++] = e.charCodeAt(s), a += 2;
  return t ? a - i : r;
};
J.text.utf16.decode = function(e) {
  return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
};
J.deflate = function(e, t, i) {
  if (t = J.decode64(e.deflate(J.encode64(t)).rval), i) {
    var r = 2, n = t.charCodeAt(1);
    n & 32 && (r = 6), t = t.substring(r, t.length - 4);
  }
  return t;
};
J.inflate = function(e, t, i) {
  var r = e.inflate(J.encode64(t)).rval;
  return r === null ? null : J.decode64(r);
};
var jo = function(e, t, i) {
  if (!e)
    throw new Error("WebStorage not available.");
  var r;
  if (i === null ? r = e.removeItem(t) : (i = J.encode64(JSON.stringify(i)), r = e.setItem(t, i)), typeof r < "u" && r.rval !== !0) {
    var n = new Error(r.error.message);
    throw n.id = r.error.id, n.name = r.error.name, n;
  }
}, zo = function(e, t) {
  if (!e)
    throw new Error("WebStorage not available.");
  var i = e.getItem(t);
  if (e.init)
    if (i.rval === null) {
      if (i.error) {
        var r = new Error(i.error.message);
        throw r.id = i.error.id, r.name = i.error.name, r;
      }
      i = null;
    } else
      i = i.rval;
  return i !== null && (i = JSON.parse(J.decode64(i))), i;
}, Up = function(e, t, i, r) {
  var n = zo(e, t);
  n === null && (n = {}), n[i] = r, jo(e, t, n);
}, Op = function(e, t, i) {
  var r = zo(e, t);
  return r !== null && (r = i in r ? r[i] : null), r;
}, qp = function(e, t, i) {
  var r = zo(e, t);
  if (r !== null && i in r) {
    delete r[i];
    var n = !0;
    for (var a in r) {
      n = !1;
      break;
    }
    n && (r = null), jo(e, t, r);
  }
}, Fp = function(e, t) {
  jo(e, t, null);
}, ka = function(e, t, i) {
  var r = null;
  typeof i > "u" && (i = ["web", "flash"]);
  var n, a = !1, f = null;
  for (var s in i) {
    n = i[s];
    try {
      if (n === "flash" || n === "both") {
        if (t[0] === null)
          throw new Error("Flash local storage not available.");
        r = e.apply(this, t), a = n === "flash";
      }
      (n === "web" || n === "both") && (t[0] = localStorage, r = e.apply(this, t), a = !0);
    } catch (c) {
      f = c;
    }
    if (a)
      break;
  }
  if (!a)
    throw f;
  return r;
};
J.setItem = function(e, t, i, r, n) {
  ka(Up, arguments, n);
};
J.getItem = function(e, t, i, r) {
  return ka(Op, arguments, r);
};
J.removeItem = function(e, t, i, r) {
  ka(qp, arguments, r);
};
J.clearItems = function(e, t, i) {
  ka(Fp, arguments, i);
};
J.isEmpty = function(e) {
  for (var t in e)
    if (e.hasOwnProperty(t))
      return !1;
  return !0;
};
J.format = function(e) {
  for (var t = /%./g, i, r, n = 0, a = [], f = 0; i = t.exec(e); ) {
    r = e.substring(f, t.lastIndex - 2), r.length > 0 && a.push(r), f = t.lastIndex;
    var s = i[0][1];
    switch (s) {
      case "s":
      case "o":
        n < arguments.length ? a.push(arguments[n++ + 1]) : a.push("<?>");
        break;
      case "%":
        a.push("%");
        break;
      default:
        a.push("<%" + s + "?>");
    }
  }
  return a.push(e.substring(f)), a.join("");
};
J.formatNumber = function(e, t, i, r) {
  var n = e, a = isNaN(t = Math.abs(t)) ? 2 : t, f = i === void 0 ? "," : i, s = r === void 0 ? "." : r, c = n < 0 ? "-" : "", u = parseInt(n = Math.abs(+n || 0).toFixed(a), 10) + "", o = u.length > 3 ? u.length % 3 : 0;
  return c + (o ? u.substr(0, o) + s : "") + u.substr(o).replace(/(\d{3})(?=\d)/g, "$1" + s) + (a ? f + Math.abs(n - u).toFixed(a).slice(2) : "");
};
J.formatSize = function(e) {
  return e >= 1073741824 ? e = J.formatNumber(e / 1073741824, 2, ".", "") + " GiB" : e >= 1048576 ? e = J.formatNumber(e / 1048576, 2, ".", "") + " MiB" : e >= 1024 ? e = J.formatNumber(e / 1024, 0) + " KiB" : e = J.formatNumber(e, 0) + " bytes", e;
};
J.bytesFromIP = function(e) {
  return e.indexOf(".") !== -1 ? J.bytesFromIPv4(e) : e.indexOf(":") !== -1 ? J.bytesFromIPv6(e) : null;
};
J.bytesFromIPv4 = function(e) {
  if (e = e.split("."), e.length !== 4)
    return null;
  for (var t = J.createBuffer(), i = 0; i < e.length; ++i) {
    var r = parseInt(e[i], 10);
    if (isNaN(r))
      return null;
    t.putByte(r);
  }
  return t.getBytes();
};
J.bytesFromIPv6 = function(e) {
  var t = 0;
  e = e.split(":").filter(function(f) {
    return f.length === 0 && ++t, !0;
  });
  for (var i = (8 - e.length + t) * 2, r = J.createBuffer(), n = 0; n < 8; ++n) {
    if (!e[n] || e[n].length === 0) {
      r.fillWithByte(0, i), i = 0;
      continue;
    }
    var a = J.hexToBytes(e[n]);
    a.length < 2 && r.putByte(0), r.putBytes(a);
  }
  return r.getBytes();
};
J.bytesToIP = function(e) {
  return e.length === 4 ? J.bytesToIPv4(e) : e.length === 16 ? J.bytesToIPv6(e) : null;
};
J.bytesToIPv4 = function(e) {
  if (e.length !== 4)
    return null;
  for (var t = [], i = 0; i < e.length; ++i)
    t.push(e.charCodeAt(i));
  return t.join(".");
};
J.bytesToIPv6 = function(e) {
  if (e.length !== 16)
    return null;
  for (var t = [], i = [], r = 0, n = 0; n < e.length; n += 2) {
    for (var a = J.bytesToHex(e[n] + e[n + 1]); a[0] === "0" && a !== "0"; )
      a = a.substr(1);
    if (a === "0") {
      var f = i[i.length - 1], s = t.length;
      !f || s !== f.end + 1 ? i.push({ start: s, end: s }) : (f.end = s, f.end - f.start > i[r].end - i[r].start && (r = i.length - 1));
    }
    t.push(a);
  }
  if (i.length > 0) {
    var c = i[r];
    c.end - c.start > 0 && (t.splice(c.start, c.end - c.start + 1, ""), c.start === 0 && t.unshift(""), c.end === 7 && t.push(""));
  }
  return t.join(":");
};
J.estimateCores = function(e, t) {
  if (typeof e == "function" && (t = e, e = {}), e = e || {}, "cores" in J && !e.update)
    return t(null, J.cores);
  if (typeof navigator < "u" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0)
    return J.cores = navigator.hardwareConcurrency, t(null, J.cores);
  if (typeof Worker > "u")
    return J.cores = 1, t(null, J.cores);
  if (typeof Blob > "u")
    return J.cores = 2, t(null, J.cores);
  var i = URL.createObjectURL(new Blob([
    "(",
    function() {
      self.addEventListener("message", function(f) {
        var s = Date.now(), c = s + 4;
        self.postMessage({ st: s, et: c });
      });
    }.toString(),
    ")()"
  ], { type: "application/javascript" }));
  r([], 5, 16);
  function r(f, s, c) {
    if (s === 0) {
      var u = Math.floor(f.reduce(function(o, l) {
        return o + l;
      }, 0) / f.length);
      return J.cores = Math.max(1, u), URL.revokeObjectURL(i), t(null, J.cores);
    }
    n(c, function(o, l) {
      f.push(a(c, l)), r(f, s - 1, c);
    });
  }
  function n(f, s) {
    for (var c = [], u = [], o = 0; o < f; ++o) {
      var l = new Worker(i);
      l.addEventListener("message", function(h) {
        if (u.push(h.data), u.length === f) {
          for (var p = 0; p < f; ++p)
            c[p].terminate();
          s(null, u);
        }
      }), c.push(l);
    }
    for (var o = 0; o < f; ++o)
      c[o].postMessage(o);
  }
  function a(f, s) {
    for (var c = [], u = 0; u < f; ++u)
      for (var o = s[u], l = c[u] = [], h = 0; h < f; ++h)
        if (u !== h) {
          var p = s[h];
          (o.st > p.st && o.st < p.et || p.st > o.st && p.st < o.et) && l.push(h);
        }
    return c.reduce(function(v, y) {
      return Math.max(v, y.length);
    }, 0);
  }
};
var qt = je;
qt.cipher = qt.cipher || {};
qt.cipher.algorithms = qt.cipher.algorithms || {};
qt.cipher.createCipher = function(e, t) {
  var i = e;
  if (typeof i == "string" && (i = qt.cipher.getAlgorithm(i), i && (i = i())), !i)
    throw new Error("Unsupported algorithm: " + e);
  return new qt.cipher.BlockCipher({
    algorithm: i,
    key: t,
    decrypt: !1
  });
};
qt.cipher.createDecipher = function(e, t) {
  var i = e;
  if (typeof i == "string" && (i = qt.cipher.getAlgorithm(i), i && (i = i())), !i)
    throw new Error("Unsupported algorithm: " + e);
  return new qt.cipher.BlockCipher({
    algorithm: i,
    key: t,
    decrypt: !0
  });
};
qt.cipher.registerAlgorithm = function(e, t) {
  e = e.toUpperCase(), qt.cipher.algorithms[e] = t;
};
qt.cipher.getAlgorithm = function(e) {
  return e = e.toUpperCase(), e in qt.cipher.algorithms ? qt.cipher.algorithms[e] : null;
};
var Go = qt.cipher.BlockCipher = function(e) {
  this.algorithm = e.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = !1, this._input = null, this.output = null, this._op = e.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = e.decrypt, this.algorithm.initialize(e);
};
Go.prototype.start = function(e) {
  e = e || {};
  var t = {};
  for (var i in e)
    t[i] = e[i];
  t.decrypt = this._decrypt, this._finish = !1, this._input = qt.util.createBuffer(), this.output = e.output || qt.util.createBuffer(), this.mode.start(t);
};
Go.prototype.update = function(e) {
  for (e && this._input.putBuffer(e); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish; )
    ;
  this._input.compact();
};
Go.prototype.finish = function(e) {
  e && (this.mode.name === "ECB" || this.mode.name === "CBC") && (this.mode.pad = function(i) {
    return e(this.blockSize, i, !1);
  }, this.mode.unpad = function(i) {
    return e(this.blockSize, i, !0);
  });
  var t = {};
  return t.decrypt = this._decrypt, t.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, t) || (this._finish = !0, this.update(), this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, t)) || this.mode.afterFinish && !this.mode.afterFinish(this.output, t));
};
var Ot = je;
Ot.cipher = Ot.cipher || {};
var Qe = Ot.cipher.modes = Ot.cipher.modes || {};
Qe.ecb = function(e) {
  e = e || {}, this.name = "ECB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
Qe.ecb.prototype.start = function(e) {
};
Qe.ecb.prototype.encrypt = function(e, t, i) {
  if (e.length() < this.blockSize && !(i && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
};
Qe.ecb.prototype.decrypt = function(e, t, i) {
  if (e.length() < this.blockSize && !(i && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
};
Qe.ecb.prototype.pad = function(e, t) {
  var i = e.length() === this.blockSize ? this.blockSize : this.blockSize - e.length();
  return e.fillWithByte(i, i), !0;
};
Qe.ecb.prototype.unpad = function(e, t) {
  if (t.overflow > 0)
    return !1;
  var i = e.length(), r = e.at(i - 1);
  return r > this.blockSize << 2 ? !1 : (e.truncate(r), !0);
};
Qe.cbc = function(e) {
  e = e || {}, this.name = "CBC", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
Qe.cbc.prototype.start = function(e) {
  if (e.iv === null) {
    if (!this._prev)
      throw new Error("Invalid IV parameter.");
    this._iv = this._prev.slice(0);
  } else if ("iv" in e)
    this._iv = Da(e.iv, this.blockSize), this._prev = this._iv.slice(0);
  else
    throw new Error("Invalid IV parameter.");
};
Qe.cbc.prototype.encrypt = function(e, t, i) {
  if (e.length() < this.blockSize && !(i && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = this._prev[r] ^ e.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
  this._prev = this._outBlock;
};
Qe.cbc.prototype.decrypt = function(e, t, i) {
  if (e.length() < this.blockSize && !(i && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._prev[r] ^ this._outBlock[r]);
  this._prev = this._inBlock.slice(0);
};
Qe.cbc.prototype.pad = function(e, t) {
  var i = e.length() === this.blockSize ? this.blockSize : this.blockSize - e.length();
  return e.fillWithByte(i, i), !0;
};
Qe.cbc.prototype.unpad = function(e, t) {
  if (t.overflow > 0)
    return !1;
  var i = e.length(), r = e.at(i - 1);
  return r > this.blockSize << 2 ? !1 : (e.truncate(r), !0);
};
Qe.cfb = function(e) {
  e = e || {}, this.name = "CFB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = Ot.util.createBuffer(), this._partialBytes = 0;
};
Qe.cfb.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = Da(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Qe.cfb.prototype.encrypt = function(e, t, i) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = e.getInt32() ^ this._outBlock[n], t.putInt32(this._inBlock[n]);
    return;
  }
  var a = (this.blockSize - r) % this.blockSize;
  a > 0 && (a = this.blockSize - a), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialBlock[n] = e.getInt32() ^ this._outBlock[n], this._partialOutput.putInt32(this._partialBlock[n]);
  if (a > 0)
    e.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._partialBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !i)
    return t.putBytes(this._partialOutput.getBytes(
      a - this._partialBytes
    )), this._partialBytes = a, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Qe.cfb.prototype.decrypt = function(e, t, i) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = e.getInt32(), t.putInt32(this._inBlock[n] ^ this._outBlock[n]);
    return;
  }
  var a = (this.blockSize - r) % this.blockSize;
  a > 0 && (a = this.blockSize - a), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialBlock[n] = e.getInt32(), this._partialOutput.putInt32(this._partialBlock[n] ^ this._outBlock[n]);
  if (a > 0)
    e.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._partialBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !i)
    return t.putBytes(this._partialOutput.getBytes(
      a - this._partialBytes
    )), this._partialBytes = a, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Qe.ofb = function(e) {
  e = e || {}, this.name = "OFB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = Ot.util.createBuffer(), this._partialBytes = 0;
};
Qe.ofb.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = Da(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Qe.ofb.prototype.encrypt = function(e, t, i) {
  var r = e.length();
  if (e.length() === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      t.putInt32(e.getInt32() ^ this._outBlock[n]), this._inBlock[n] = this._outBlock[n];
    return;
  }
  var a = (this.blockSize - r) % this.blockSize;
  a > 0 && (a = this.blockSize - a), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[n]);
  if (a > 0)
    e.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._outBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !i)
    return t.putBytes(this._partialOutput.getBytes(
      a - this._partialBytes
    )), this._partialBytes = a, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Qe.ofb.prototype.decrypt = Qe.ofb.prototype.encrypt;
Qe.ctr = function(e) {
  e = e || {}, this.name = "CTR", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = Ot.util.createBuffer(), this._partialBytes = 0;
};
Qe.ctr.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = Da(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Qe.ctr.prototype.encrypt = function(e, t, i) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize)
    for (var n = 0; n < this._ints; ++n)
      t.putInt32(e.getInt32() ^ this._outBlock[n]);
  else {
    var a = (this.blockSize - r) % this.blockSize;
    a > 0 && (a = this.blockSize - a), this._partialOutput.clear();
    for (var n = 0; n < this._ints; ++n)
      this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[n]);
    if (a > 0 && (e.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !i)
      return t.putBytes(this._partialOutput.getBytes(
        a - this._partialBytes
      )), this._partialBytes = a, !0;
    t.putBytes(this._partialOutput.getBytes(
      r - this._partialBytes
    )), this._partialBytes = 0;
  }
  La(this._inBlock);
};
Qe.ctr.prototype.decrypt = Qe.ctr.prototype.encrypt;
Qe.gcm = function(e) {
  e = e || {}, this.name = "GCM", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = Ot.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
};
Qe.gcm.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  var t = Ot.util.createBuffer(e.iv);
  this._cipherLength = 0;
  var i;
  if ("additionalData" in e ? i = Ot.util.createBuffer(e.additionalData) : i = Ot.util.createBuffer(), "tagLength" in e ? this._tagLength = e.tagLength : this._tagLength = 128, this._tag = null, e.decrypt && (this._tag = Ot.util.createBuffer(e.tag).getBytes(), this._tag.length !== this._tagLength / 8))
    throw new Error("Authentication tag does not match tag length.");
  this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
  var r = t.length();
  if (r === 12)
    this._j0 = [t.getInt32(), t.getInt32(), t.getInt32(), 1];
  else {
    for (this._j0 = [0, 0, 0, 0]; t.length() > 0; )
      this._j0 = this.ghash(
        this._hashSubkey,
        this._j0,
        [t.getInt32(), t.getInt32(), t.getInt32(), t.getInt32()]
      );
    this._j0 = this.ghash(
      this._hashSubkey,
      this._j0,
      [0, 0].concat(wo(r * 8))
    );
  }
  this._inBlock = this._j0.slice(0), La(this._inBlock), this._partialBytes = 0, i = Ot.util.createBuffer(i), this._aDataLength = wo(i.length() * 8);
  var n = i.length() % this.blockSize;
  for (n && i.fillWithByte(0, this.blockSize - n), this._s = [0, 0, 0, 0]; i.length() > 0; )
    this._s = this.ghash(this._hashSubkey, this._s, [
      i.getInt32(),
      i.getInt32(),
      i.getInt32(),
      i.getInt32()
    ]);
};
Qe.gcm.prototype.encrypt = function(e, t, i) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      t.putInt32(this._outBlock[n] ^= e.getInt32());
    this._cipherLength += this.blockSize;
  } else {
    var a = (this.blockSize - r) % this.blockSize;
    a > 0 && (a = this.blockSize - a), this._partialOutput.clear();
    for (var n = 0; n < this._ints; ++n)
      this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[n]);
    if (a <= 0 || i) {
      if (i) {
        var f = r % this.blockSize;
        this._cipherLength += f, this._partialOutput.truncate(this.blockSize - f);
      } else
        this._cipherLength += this.blockSize;
      for (var n = 0; n < this._ints; ++n)
        this._outBlock[n] = this._partialOutput.getInt32();
      this._partialOutput.read -= this.blockSize;
    }
    if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !i)
      return e.read -= this.blockSize, t.putBytes(this._partialOutput.getBytes(
        a - this._partialBytes
      )), this._partialBytes = a, !0;
    t.putBytes(this._partialOutput.getBytes(
      r - this._partialBytes
    )), this._partialBytes = 0;
  }
  this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), La(this._inBlock);
};
Qe.gcm.prototype.decrypt = function(e, t, i) {
  var r = e.length();
  if (r < this.blockSize && !(i && r > 0))
    return !0;
  this.cipher.encrypt(this._inBlock, this._outBlock), La(this._inBlock), this._hashBlock[0] = e.getInt32(), this._hashBlock[1] = e.getInt32(), this._hashBlock[2] = e.getInt32(), this._hashBlock[3] = e.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
  for (var n = 0; n < this._ints; ++n)
    t.putInt32(this._outBlock[n] ^ this._hashBlock[n]);
  r < this.blockSize ? this._cipherLength += r % this.blockSize : this._cipherLength += this.blockSize;
};
Qe.gcm.prototype.afterFinish = function(e, t) {
  var i = !0;
  t.decrypt && t.overflow && e.truncate(this.blockSize - t.overflow), this.tag = Ot.util.createBuffer();
  var r = this._aDataLength.concat(wo(this._cipherLength * 8));
  this._s = this.ghash(this._hashSubkey, this._s, r);
  var n = [];
  this.cipher.encrypt(this._j0, n);
  for (var a = 0; a < this._ints; ++a)
    this.tag.putInt32(this._s[a] ^ n[a]);
  return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), t.decrypt && this.tag.bytes() !== this._tag && (i = !1), i;
};
Qe.gcm.prototype.multiply = function(e, t) {
  for (var i = [0, 0, 0, 0], r = t.slice(0), n = 0; n < 128; ++n) {
    var a = e[n / 32 | 0] & 1 << 31 - n % 32;
    a && (i[0] ^= r[0], i[1] ^= r[1], i[2] ^= r[2], i[3] ^= r[3]), this.pow(r, r);
  }
  return i;
};
Qe.gcm.prototype.pow = function(e, t) {
  for (var i = e[3] & 1, r = 3; r > 0; --r)
    t[r] = e[r] >>> 1 | (e[r - 1] & 1) << 31;
  t[0] = e[0] >>> 1, i && (t[0] ^= this._R);
};
Qe.gcm.prototype.tableMultiply = function(e) {
  for (var t = [0, 0, 0, 0], i = 0; i < 32; ++i) {
    var r = i / 8 | 0, n = e[r] >>> (7 - i % 8) * 4 & 15, a = this._m[i][n];
    t[0] ^= a[0], t[1] ^= a[1], t[2] ^= a[2], t[3] ^= a[3];
  }
  return t;
};
Qe.gcm.prototype.ghash = function(e, t, i) {
  return t[0] ^= i[0], t[1] ^= i[1], t[2] ^= i[2], t[3] ^= i[3], this.tableMultiply(t);
};
Qe.gcm.prototype.generateHashTable = function(e, t) {
  for (var i = 8 / t, r = 4 * i, n = 16 * i, a = new Array(n), f = 0; f < n; ++f) {
    var s = [0, 0, 0, 0], c = f / r | 0, u = (r - 1 - f % r) * t;
    s[c] = 1 << t - 1 << u, a[f] = this.generateSubHashTable(this.multiply(s, e), t);
  }
  return a;
};
Qe.gcm.prototype.generateSubHashTable = function(e, t) {
  var i = 1 << t, r = i >>> 1, n = new Array(i);
  n[r] = e.slice(0);
  for (var a = r >>> 1; a > 0; )
    this.pow(n[2 * a], n[a] = []), a >>= 1;
  for (a = 2; a < r; ) {
    for (var f = 1; f < a; ++f) {
      var s = n[a], c = n[f];
      n[a + f] = [
        s[0] ^ c[0],
        s[1] ^ c[1],
        s[2] ^ c[2],
        s[3] ^ c[3]
      ];
    }
    a *= 2;
  }
  for (n[0] = [0, 0, 0, 0], a = r + 1; a < i; ++a) {
    var u = n[a ^ r];
    n[a] = [e[0] ^ u[0], e[1] ^ u[1], e[2] ^ u[2], e[3] ^ u[3]];
  }
  return n;
};
function Da(e, t) {
  if (typeof e == "string" && (e = Ot.util.createBuffer(e)), Ot.util.isArray(e) && e.length > 4) {
    var i = e;
    e = Ot.util.createBuffer();
    for (var r = 0; r < i.length; ++r)
      e.putByte(i[r]);
  }
  if (e.length() < t)
    throw new Error(
      "Invalid IV length; got " + e.length() + " bytes and expected " + t + " bytes."
    );
  if (!Ot.util.isArray(e)) {
    for (var n = [], a = t / 4, r = 0; r < a; ++r)
      n.push(e.getInt32());
    e = n;
  }
  return e;
}
function La(e) {
  e[e.length - 1] = e[e.length - 1] + 1 & 4294967295;
}
function wo(e) {
  return [e / 4294967296 | 0, e & 4294967295];
}
var ft = je;
ft.aes = ft.aes || {};
ft.aes.startEncrypting = function(e, t, i, r) {
  var n = Pa({
    key: e,
    output: i,
    decrypt: !1,
    mode: r
  });
  return n.start(t), n;
};
ft.aes.createEncryptionCipher = function(e, t) {
  return Pa({
    key: e,
    output: null,
    decrypt: !1,
    mode: t
  });
};
ft.aes.startDecrypting = function(e, t, i, r) {
  var n = Pa({
    key: e,
    output: i,
    decrypt: !0,
    mode: r
  });
  return n.start(t), n;
};
ft.aes.createDecryptionCipher = function(e, t) {
  return Pa({
    key: e,
    output: null,
    decrypt: !0,
    mode: t
  });
};
ft.aes.Algorithm = function(e, t) {
  $o || zh();
  var i = this;
  i.name = e, i.mode = new t({
    blockSize: 16,
    cipher: {
      encrypt: function(r, n) {
        return Ao(i._w, r, n, !1);
      },
      decrypt: function(r, n) {
        return Ao(i._w, r, n, !0);
      }
    }
  }), i._init = !1;
};
ft.aes.Algorithm.prototype.initialize = function(e) {
  if (!this._init) {
    var t = e.key, i;
    if (typeof t == "string" && (t.length === 16 || t.length === 24 || t.length === 32))
      t = ft.util.createBuffer(t);
    else if (ft.util.isArray(t) && (t.length === 16 || t.length === 24 || t.length === 32)) {
      i = t, t = ft.util.createBuffer();
      for (var r = 0; r < i.length; ++r)
        t.putByte(i[r]);
    }
    if (!ft.util.isArray(t)) {
      i = t, t = [];
      var n = i.length();
      if (n === 16 || n === 24 || n === 32) {
        n = n >>> 2;
        for (var r = 0; r < n; ++r)
          t.push(i.getInt32());
      }
    }
    if (!ft.util.isArray(t) || !(t.length === 4 || t.length === 6 || t.length === 8))
      throw new Error("Invalid key parameter.");
    var a = this.mode.name, f = ["CFB", "OFB", "CTR", "GCM"].indexOf(a) !== -1;
    this._w = Gh(t, e.decrypt && !f), this._init = !0;
  }
};
ft.aes._expandKey = function(e, t) {
  return $o || zh(), Gh(e, t);
};
ft.aes._updateBlock = Ao;
Ei("AES-ECB", ft.cipher.modes.ecb);
Ei("AES-CBC", ft.cipher.modes.cbc);
Ei("AES-CFB", ft.cipher.modes.cfb);
Ei("AES-OFB", ft.cipher.modes.ofb);
Ei("AES-CTR", ft.cipher.modes.ctr);
Ei("AES-GCM", ft.cipher.modes.gcm);
function Ei(e, t) {
  var i = function() {
    return new ft.aes.Algorithm(e, t);
  };
  ft.cipher.registerAlgorithm(e, i);
}
var $o = !1, hi = 4, zt, Co, jh, oi, hr;
function zh() {
  $o = !0, jh = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
  for (var e = new Array(256), t = 0; t < 128; ++t)
    e[t] = t << 1, e[t + 128] = t + 128 << 1 ^ 283;
  zt = new Array(256), Co = new Array(256), oi = new Array(4), hr = new Array(4);
  for (var t = 0; t < 4; ++t)
    oi[t] = new Array(256), hr[t] = new Array(256);
  for (var i = 0, r = 0, n, a, f, s, c, u, o, t = 0; t < 256; ++t) {
    s = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4, s = s >> 8 ^ s & 255 ^ 99, zt[i] = s, Co[s] = i, c = e[s], n = e[i], a = e[n], f = e[a], u = c << 24 ^ // 2
    s << 16 ^ // 1
    s << 8 ^ // 1
    (s ^ c), o = (n ^ a ^ f) << 24 ^ // E (14)
    (i ^ f) << 16 ^ // 9
    (i ^ a ^ f) << 8 ^ // D (13)
    (i ^ n ^ f);
    for (var l = 0; l < 4; ++l)
      oi[l][i] = u, hr[l][s] = o, u = u << 24 | u >>> 8, o = o << 24 | o >>> 8;
    i === 0 ? i = r = 1 : (i = n ^ e[e[e[n ^ f]]], r ^= e[e[r]]);
  }
}
function Gh(e, t) {
  for (var i = e.slice(0), r, n = 1, a = i.length, f = a + 6 + 1, s = hi * f, c = a; c < s; ++c)
    r = i[c - 1], c % a === 0 ? (r = zt[r >>> 16 & 255] << 24 ^ zt[r >>> 8 & 255] << 16 ^ zt[r & 255] << 8 ^ zt[r >>> 24] ^ jh[n] << 24, n++) : a > 6 && c % a === 4 && (r = zt[r >>> 24] << 24 ^ zt[r >>> 16 & 255] << 16 ^ zt[r >>> 8 & 255] << 8 ^ zt[r & 255]), i[c] = i[c - a] ^ r;
  if (t) {
    var u, o = hr[0], l = hr[1], h = hr[2], p = hr[3], v = i.slice(0);
    s = i.length;
    for (var c = 0, y = s - hi; c < s; c += hi, y -= hi)
      if (c === 0 || c === s - hi)
        v[c] = i[y], v[c + 1] = i[y + 3], v[c + 2] = i[y + 2], v[c + 3] = i[y + 1];
      else
        for (var w = 0; w < hi; ++w)
          u = i[y + w], v[c + (3 & -w)] = o[zt[u >>> 24]] ^ l[zt[u >>> 16 & 255]] ^ h[zt[u >>> 8 & 255]] ^ p[zt[u & 255]];
    i = v;
  }
  return i;
}
function Ao(e, t, i, r) {
  var n = e.length / 4 - 1, a, f, s, c, u;
  r ? (a = hr[0], f = hr[1], s = hr[2], c = hr[3], u = Co) : (a = oi[0], f = oi[1], s = oi[2], c = oi[3], u = zt);
  var o, l, h, p, v, y, w;
  o = t[0] ^ e[0], l = t[r ? 3 : 1] ^ e[1], h = t[2] ^ e[2], p = t[r ? 1 : 3] ^ e[3];
  for (var x = 3, A = 1; A < n; ++A)
    v = a[o >>> 24] ^ f[l >>> 16 & 255] ^ s[h >>> 8 & 255] ^ c[p & 255] ^ e[++x], y = a[l >>> 24] ^ f[h >>> 16 & 255] ^ s[p >>> 8 & 255] ^ c[o & 255] ^ e[++x], w = a[h >>> 24] ^ f[p >>> 16 & 255] ^ s[o >>> 8 & 255] ^ c[l & 255] ^ e[++x], p = a[p >>> 24] ^ f[o >>> 16 & 255] ^ s[l >>> 8 & 255] ^ c[h & 255] ^ e[++x], o = v, l = y, h = w;
  i[0] = u[o >>> 24] << 24 ^ u[l >>> 16 & 255] << 16 ^ u[h >>> 8 & 255] << 8 ^ u[p & 255] ^ e[++x], i[r ? 3 : 1] = u[l >>> 24] << 24 ^ u[h >>> 16 & 255] << 16 ^ u[p >>> 8 & 255] << 8 ^ u[o & 255] ^ e[++x], i[2] = u[h >>> 24] << 24 ^ u[p >>> 16 & 255] << 16 ^ u[o >>> 8 & 255] << 8 ^ u[l & 255] ^ e[++x], i[r ? 1 : 3] = u[p >>> 24] << 24 ^ u[o >>> 16 & 255] << 16 ^ u[l >>> 8 & 255] << 8 ^ u[h & 255] ^ e[++x];
}
function Pa(e) {
  e = e || {};
  var t = (e.mode || "CBC").toUpperCase(), i = "AES-" + t, r;
  e.decrypt ? r = ft.cipher.createDecipher(i, e.key) : r = ft.cipher.createCipher(i, e.key);
  var n = r.start;
  return r.start = function(a, f) {
    var s = null;
    f instanceof ft.util.ByteBuffer && (s = f, f = {}), f = f || {}, f.output = s, f.iv = a, n.call(r, f);
  }, r;
}
var Pi = je;
Pi.pki = Pi.pki || {};
var Bo = Pi.pki.oids = Pi.oids = Pi.oids || {};
function ce(e, t) {
  Bo[e] = t, Bo[t] = e;
}
function rt(e, t) {
  Bo[e] = t;
}
ce("1.2.840.113549.1.1.1", "rsaEncryption");
ce("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
ce("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
ce("1.2.840.113549.1.1.7", "RSAES-OAEP");
ce("1.2.840.113549.1.1.8", "mgf1");
ce("1.2.840.113549.1.1.9", "pSpecified");
ce("1.2.840.113549.1.1.10", "RSASSA-PSS");
ce("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
ce("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
ce("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
ce("1.3.101.112", "EdDSA25519");
ce("1.2.840.10040.4.3", "dsa-with-sha1");
ce("1.3.14.3.2.7", "desCBC");
ce("1.3.14.3.2.26", "sha1");
ce("1.3.14.3.2.29", "sha1WithRSASignature");
ce("2.16.840.1.101.3.4.2.1", "sha256");
ce("2.16.840.1.101.3.4.2.2", "sha384");
ce("2.16.840.1.101.3.4.2.3", "sha512");
ce("2.16.840.1.101.3.4.2.4", "sha224");
ce("2.16.840.1.101.3.4.2.5", "sha512-224");
ce("2.16.840.1.101.3.4.2.6", "sha512-256");
ce("1.2.840.113549.2.2", "md2");
ce("1.2.840.113549.2.5", "md5");
ce("1.2.840.113549.1.7.1", "data");
ce("1.2.840.113549.1.7.2", "signedData");
ce("1.2.840.113549.1.7.3", "envelopedData");
ce("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
ce("1.2.840.113549.1.7.5", "digestedData");
ce("1.2.840.113549.1.7.6", "encryptedData");
ce("1.2.840.113549.1.9.1", "emailAddress");
ce("1.2.840.113549.1.9.2", "unstructuredName");
ce("1.2.840.113549.1.9.3", "contentType");
ce("1.2.840.113549.1.9.4", "messageDigest");
ce("1.2.840.113549.1.9.5", "signingTime");
ce("1.2.840.113549.1.9.6", "counterSignature");
ce("1.2.840.113549.1.9.7", "challengePassword");
ce("1.2.840.113549.1.9.8", "unstructuredAddress");
ce("1.2.840.113549.1.9.14", "extensionRequest");
ce("1.2.840.113549.1.9.20", "friendlyName");
ce("1.2.840.113549.1.9.21", "localKeyId");
ce("1.2.840.113549.1.9.22.1", "x509Certificate");
ce("1.2.840.113549.1.12.10.1.1", "keyBag");
ce("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
ce("1.2.840.113549.1.12.10.1.3", "certBag");
ce("1.2.840.113549.1.12.10.1.4", "crlBag");
ce("1.2.840.113549.1.12.10.1.5", "secretBag");
ce("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
ce("1.2.840.113549.1.5.13", "pkcs5PBES2");
ce("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
ce("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
ce("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
ce("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
ce("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
ce("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
ce("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
ce("1.2.840.113549.2.7", "hmacWithSHA1");
ce("1.2.840.113549.2.8", "hmacWithSHA224");
ce("1.2.840.113549.2.9", "hmacWithSHA256");
ce("1.2.840.113549.2.10", "hmacWithSHA384");
ce("1.2.840.113549.2.11", "hmacWithSHA512");
ce("1.2.840.113549.3.7", "des-EDE3-CBC");
ce("2.16.840.1.101.3.4.1.2", "aes128-CBC");
ce("2.16.840.1.101.3.4.1.22", "aes192-CBC");
ce("2.16.840.1.101.3.4.1.42", "aes256-CBC");
ce("2.5.4.3", "commonName");
ce("2.5.4.4", "surname");
ce("2.5.4.5", "serialNumber");
ce("2.5.4.6", "countryName");
ce("2.5.4.7", "localityName");
ce("2.5.4.8", "stateOrProvinceName");
ce("2.5.4.9", "streetAddress");
ce("2.5.4.10", "organizationName");
ce("2.5.4.11", "organizationalUnitName");
ce("2.5.4.12", "title");
ce("2.5.4.13", "description");
ce("2.5.4.15", "businessCategory");
ce("2.5.4.17", "postalCode");
ce("2.5.4.42", "givenName");
ce("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
ce("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
ce("2.16.840.1.113730.1.1", "nsCertType");
ce("2.16.840.1.113730.1.13", "nsComment");
rt("2.5.29.1", "authorityKeyIdentifier");
rt("2.5.29.2", "keyAttributes");
rt("2.5.29.3", "certificatePolicies");
rt("2.5.29.4", "keyUsageRestriction");
rt("2.5.29.5", "policyMapping");
rt("2.5.29.6", "subtreesConstraint");
rt("2.5.29.7", "subjectAltName");
rt("2.5.29.8", "issuerAltName");
rt("2.5.29.9", "subjectDirectoryAttributes");
rt("2.5.29.10", "basicConstraints");
rt("2.5.29.11", "nameConstraints");
rt("2.5.29.12", "policyConstraints");
rt("2.5.29.13", "basicConstraints");
ce("2.5.29.14", "subjectKeyIdentifier");
ce("2.5.29.15", "keyUsage");
rt("2.5.29.16", "privateKeyUsagePeriod");
ce("2.5.29.17", "subjectAltName");
ce("2.5.29.18", "issuerAltName");
ce("2.5.29.19", "basicConstraints");
rt("2.5.29.20", "cRLNumber");
rt("2.5.29.21", "cRLReason");
rt("2.5.29.22", "expirationDate");
rt("2.5.29.23", "instructionCode");
rt("2.5.29.24", "invalidityDate");
rt("2.5.29.25", "cRLDistributionPoints");
rt("2.5.29.26", "issuingDistributionPoint");
rt("2.5.29.27", "deltaCRLIndicator");
rt("2.5.29.28", "issuingDistributionPoint");
rt("2.5.29.29", "certificateIssuer");
rt("2.5.29.30", "nameConstraints");
ce("2.5.29.31", "cRLDistributionPoints");
ce("2.5.29.32", "certificatePolicies");
rt("2.5.29.33", "policyMappings");
rt("2.5.29.34", "policyConstraints");
ce("2.5.29.35", "authorityKeyIdentifier");
rt("2.5.29.36", "policyConstraints");
ce("2.5.29.37", "extKeyUsage");
rt("2.5.29.46", "freshestCRL");
rt("2.5.29.54", "inhibitAnyPolicy");
ce("1.3.6.1.4.1.11129.2.4.2", "timestampList");
ce("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
ce("1.3.6.1.5.5.7.3.1", "serverAuth");
ce("1.3.6.1.5.5.7.3.2", "clientAuth");
ce("1.3.6.1.5.5.7.3.3", "codeSigning");
ce("1.3.6.1.5.5.7.3.4", "emailProtection");
ce("1.3.6.1.5.5.7.3.8", "timeStamping");
var st = je, ve = st.asn1 = st.asn1 || {};
ve.Class = {
  UNIVERSAL: 0,
  APPLICATION: 64,
  CONTEXT_SPECIFIC: 128,
  PRIVATE: 192
};
ve.Type = {
  NONE: 0,
  BOOLEAN: 1,
  INTEGER: 2,
  BITSTRING: 3,
  OCTETSTRING: 4,
  NULL: 5,
  OID: 6,
  ODESC: 7,
  EXTERNAL: 8,
  REAL: 9,
  ENUMERATED: 10,
  EMBEDDED: 11,
  UTF8: 12,
  ROID: 13,
  SEQUENCE: 16,
  SET: 17,
  PRINTABLESTRING: 19,
  IA5STRING: 22,
  UTCTIME: 23,
  GENERALIZEDTIME: 24,
  BMPSTRING: 30
};
ve.create = function(e, t, i, r, n) {
  if (st.util.isArray(r)) {
    for (var a = [], f = 0; f < r.length; ++f)
      r[f] !== void 0 && a.push(r[f]);
    r = a;
  }
  var s = {
    tagClass: e,
    type: t,
    constructed: i,
    composed: i || st.util.isArray(r),
    value: r
  };
  return n && "bitStringContents" in n && (s.bitStringContents = n.bitStringContents, s.original = ve.copy(s)), s;
};
ve.copy = function(e, t) {
  var i;
  if (st.util.isArray(e)) {
    i = [];
    for (var r = 0; r < e.length; ++r)
      i.push(ve.copy(e[r], t));
    return i;
  }
  return typeof e == "string" ? e : (i = {
    tagClass: e.tagClass,
    type: e.type,
    constructed: e.constructed,
    composed: e.composed,
    value: ve.copy(e.value, t)
  }, t && !t.excludeBitStringContents && (i.bitStringContents = e.bitStringContents), i);
};
ve.equals = function(e, t, i) {
  if (st.util.isArray(e)) {
    if (!st.util.isArray(t) || e.length !== t.length)
      return !1;
    for (var r = 0; r < e.length; ++r)
      if (!ve.equals(e[r], t[r]))
        return !1;
    return !0;
  }
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "string")
    return e === t;
  var n = e.tagClass === t.tagClass && e.type === t.type && e.constructed === t.constructed && e.composed === t.composed && ve.equals(e.value, t.value);
  return i && i.includeBitStringContents && (n = n && e.bitStringContents === t.bitStringContents), n;
};
ve.getBerValueLength = function(e) {
  var t = e.getByte();
  if (t !== 128) {
    var i, r = t & 128;
    return r ? i = e.getInt((t & 127) << 3) : i = t, i;
  }
};
function Di(e, t, i) {
  if (i > t) {
    var r = new Error("Too few bytes to parse DER.");
    throw r.available = e.length(), r.remaining = t, r.requested = i, r;
  }
}
var Vp = function(e, t) {
  var i = e.getByte();
  if (t--, i !== 128) {
    var r, n = i & 128;
    if (!n)
      r = i;
    else {
      var a = i & 127;
      Di(e, t, a), r = e.getInt(a << 3);
    }
    if (r < 0)
      throw new Error("Negative length: " + r);
    return r;
  }
};
ve.fromDer = function(e, t) {
  t === void 0 && (t = {
    strict: !0,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), typeof t == "boolean" && (t = {
    strict: t,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), "strict" in t || (t.strict = !0), "parseAllBytes" in t || (t.parseAllBytes = !0), "decodeBitStrings" in t || (t.decodeBitStrings = !0), typeof e == "string" && (e = st.util.createBuffer(e));
  var i = e.length(), r = ba(e, e.length(), 0, t);
  if (t.parseAllBytes && e.length() !== 0) {
    var n = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
    throw n.byteCount = i, n.remaining = e.length(), n;
  }
  return r;
};
function ba(e, t, i, r) {
  var n;
  Di(e, t, 2);
  var a = e.getByte();
  t--;
  var f = a & 192, s = a & 31;
  n = e.length();
  var c = Vp(e, t);
  if (t -= n - e.length(), c !== void 0 && c > t) {
    if (r.strict) {
      var u = new Error("Too few bytes to read ASN.1 value.");
      throw u.available = e.length(), u.remaining = t, u.requested = c, u;
    }
    c = t;
  }
  var o, l, h = (a & 32) === 32;
  if (h)
    if (o = [], c === void 0)
      for (; ; ) {
        if (Di(e, t, 2), e.bytes(2) === "\0\0") {
          e.getBytes(2), t -= 2;
          break;
        }
        n = e.length(), o.push(ba(e, t, i + 1, r)), t -= n - e.length();
      }
    else
      for (; c > 0; )
        n = e.length(), o.push(ba(e, c, i + 1, r)), t -= n - e.length(), c -= n - e.length();
  if (o === void 0 && f === ve.Class.UNIVERSAL && s === ve.Type.BITSTRING && (l = e.bytes(c)), o === void 0 && r.decodeBitStrings && f === ve.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
  // .. other parts of forge expect to decode OCTET STRINGs manually
  s === ve.Type.BITSTRING && c > 1) {
    var p = e.read, v = t, y = 0;
    if (s === ve.Type.BITSTRING && (Di(e, t, 1), y = e.getByte(), t--), y === 0)
      try {
        n = e.length();
        var w = {
          // enforce strict mode to avoid parsing ASN.1 from plain data
          strict: !0,
          decodeBitStrings: !0
        }, x = ba(e, t, i + 1, w), A = n - e.length();
        t -= A, s == ve.Type.BITSTRING && A++;
        var R = x.tagClass;
        A === c && (R === ve.Class.UNIVERSAL || R === ve.Class.CONTEXT_SPECIFIC) && (o = [x]);
      } catch {
      }
    o === void 0 && (e.read = p, t = v);
  }
  if (o === void 0) {
    if (c === void 0) {
      if (r.strict)
        throw new Error("Non-constructed ASN.1 object of indefinite length.");
      c = t;
    }
    if (s === ve.Type.BMPSTRING)
      for (o = ""; c > 0; c -= 2)
        Di(e, t, 2), o += String.fromCharCode(e.getInt16()), t -= 2;
    else
      o = e.getBytes(c), t -= c;
  }
  var M = l === void 0 ? null : {
    bitStringContents: l
  };
  return ve.create(f, s, h, o, M);
}
ve.toDer = function(e) {
  var t = st.util.createBuffer(), i = e.tagClass | e.type, r = st.util.createBuffer(), n = !1;
  if ("bitStringContents" in e && (n = !0, e.original && (n = ve.equals(e, e.original))), n)
    r.putBytes(e.bitStringContents);
  else if (e.composed) {
    e.constructed ? i |= 32 : r.putByte(0);
    for (var a = 0; a < e.value.length; ++a)
      e.value[a] !== void 0 && r.putBuffer(ve.toDer(e.value[a]));
  } else if (e.type === ve.Type.BMPSTRING)
    for (var a = 0; a < e.value.length; ++a)
      r.putInt16(e.value.charCodeAt(a));
  else
    e.type === ve.Type.INTEGER && e.value.length > 1 && // leading 0x00 for positive integer
    (e.value.charCodeAt(0) === 0 && !(e.value.charCodeAt(1) & 128) || // leading 0xFF for negative integer
    e.value.charCodeAt(0) === 255 && (e.value.charCodeAt(1) & 128) === 128) ? r.putBytes(e.value.substr(1)) : r.putBytes(e.value);
  if (t.putByte(i), r.length() <= 127)
    t.putByte(r.length() & 127);
  else {
    var f = r.length(), s = "";
    do
      s += String.fromCharCode(f & 255), f = f >>> 8;
    while (f > 0);
    t.putByte(s.length | 128);
    for (var a = s.length - 1; a >= 0; --a)
      t.putByte(s.charCodeAt(a));
  }
  return t.putBuffer(r), t;
};
ve.oidToDer = function(e) {
  var t = e.split("."), i = st.util.createBuffer();
  i.putByte(40 * parseInt(t[0], 10) + parseInt(t[1], 10));
  for (var r, n, a, f, s = 2; s < t.length; ++s) {
    r = !0, n = [], a = parseInt(t[s], 10);
    do
      f = a & 127, a = a >>> 7, r || (f |= 128), n.push(f), r = !1;
    while (a > 0);
    for (var c = n.length - 1; c >= 0; --c)
      i.putByte(n[c]);
  }
  return i;
};
ve.derToOid = function(e) {
  var t;
  typeof e == "string" && (e = st.util.createBuffer(e));
  var i = e.getByte();
  t = Math.floor(i / 40) + "." + i % 40;
  for (var r = 0; e.length() > 0; )
    i = e.getByte(), r = r << 7, i & 128 ? r += i & 127 : (t += "." + (r + i), r = 0);
  return t;
};
ve.utcTimeToDate = function(e) {
  var t = /* @__PURE__ */ new Date(), i = parseInt(e.substr(0, 2), 10);
  i = i >= 50 ? 1900 + i : 2e3 + i;
  var r = parseInt(e.substr(2, 2), 10) - 1, n = parseInt(e.substr(4, 2), 10), a = parseInt(e.substr(6, 2), 10), f = parseInt(e.substr(8, 2), 10), s = 0;
  if (e.length > 11) {
    var c = e.charAt(10), u = 10;
    c !== "+" && c !== "-" && (s = parseInt(e.substr(10, 2), 10), u += 2);
  }
  if (t.setUTCFullYear(i, r, n), t.setUTCHours(a, f, s, 0), u && (c = e.charAt(u), c === "+" || c === "-")) {
    var o = parseInt(e.substr(u + 1, 2), 10), l = parseInt(e.substr(u + 4, 2), 10), h = o * 60 + l;
    h *= 6e4, c === "+" ? t.setTime(+t - h) : t.setTime(+t + h);
  }
  return t;
};
ve.generalizedTimeToDate = function(e) {
  var t = /* @__PURE__ */ new Date(), i = parseInt(e.substr(0, 4), 10), r = parseInt(e.substr(4, 2), 10) - 1, n = parseInt(e.substr(6, 2), 10), a = parseInt(e.substr(8, 2), 10), f = parseInt(e.substr(10, 2), 10), s = parseInt(e.substr(12, 2), 10), c = 0, u = 0, o = !1;
  e.charAt(e.length - 1) === "Z" && (o = !0);
  var l = e.length - 5, h = e.charAt(l);
  if (h === "+" || h === "-") {
    var p = parseInt(e.substr(l + 1, 2), 10), v = parseInt(e.substr(l + 4, 2), 10);
    u = p * 60 + v, u *= 6e4, h === "+" && (u *= -1), o = !0;
  }
  return e.charAt(14) === "." && (c = parseFloat(e.substr(14), 10) * 1e3), o ? (t.setUTCFullYear(i, r, n), t.setUTCHours(a, f, s, c), t.setTime(+t + u)) : (t.setFullYear(i, r, n), t.setHours(a, f, s, c)), t;
};
ve.dateToUtcTime = function(e) {
  if (typeof e == "string")
    return e;
  var t = "", i = [];
  i.push(("" + e.getUTCFullYear()).substr(2)), i.push("" + (e.getUTCMonth() + 1)), i.push("" + e.getUTCDate()), i.push("" + e.getUTCHours()), i.push("" + e.getUTCMinutes()), i.push("" + e.getUTCSeconds());
  for (var r = 0; r < i.length; ++r)
    i[r].length < 2 && (t += "0"), t += i[r];
  return t += "Z", t;
};
ve.dateToGeneralizedTime = function(e) {
  if (typeof e == "string")
    return e;
  var t = "", i = [];
  i.push("" + e.getUTCFullYear()), i.push("" + (e.getUTCMonth() + 1)), i.push("" + e.getUTCDate()), i.push("" + e.getUTCHours()), i.push("" + e.getUTCMinutes()), i.push("" + e.getUTCSeconds());
  for (var r = 0; r < i.length; ++r)
    i[r].length < 2 && (t += "0"), t += i[r];
  return t += "Z", t;
};
ve.integerToDer = function(e) {
  var t = st.util.createBuffer();
  if (e >= -128 && e < 128)
    return t.putSignedInt(e, 8);
  if (e >= -32768 && e < 32768)
    return t.putSignedInt(e, 16);
  if (e >= -8388608 && e < 8388608)
    return t.putSignedInt(e, 24);
  if (e >= -2147483648 && e < 2147483648)
    return t.putSignedInt(e, 32);
  var i = new Error("Integer too large; max is 32-bits.");
  throw i.integer = e, i;
};
ve.derToInteger = function(e) {
  typeof e == "string" && (e = st.util.createBuffer(e));
  var t = e.length() * 8;
  if (t > 32)
    throw new Error("Integer too large; max is 32-bits.");
  return e.getSignedInt(t);
};
ve.validate = function(e, t, i, r) {
  var n = !1;
  if ((e.tagClass === t.tagClass || typeof t.tagClass > "u") && (e.type === t.type || typeof t.type > "u"))
    if (e.constructed === t.constructed || typeof t.constructed > "u") {
      if (n = !0, t.value && st.util.isArray(t.value))
        for (var a = 0, f = 0; n && f < t.value.length; ++f)
          n = t.value[f].optional || !1, e.value[a] && (n = ve.validate(e.value[a], t.value[f], i, r), n ? ++a : t.value[f].optional && (n = !0)), !n && r && r.push(
            "[" + t.name + '] Tag class "' + t.tagClass + '", type "' + t.type + '" expected value length "' + t.value.length + '", got "' + e.value.length + '"'
          );
      if (n && i && (t.capture && (i[t.capture] = e.value), t.captureAsn1 && (i[t.captureAsn1] = e), t.captureBitStringContents && "bitStringContents" in e && (i[t.captureBitStringContents] = e.bitStringContents), t.captureBitStringValue && "bitStringContents" in e))
        if (e.bitStringContents.length < 2)
          i[t.captureBitStringValue] = "";
        else {
          var s = e.bitStringContents.charCodeAt(0);
          if (s !== 0)
            throw new Error(
              "captureBitStringValue only supported for zero unused bits"
            );
          i[t.captureBitStringValue] = e.bitStringContents.slice(1);
        }
    } else
      r && r.push(
        "[" + t.name + '] Expected constructed "' + t.constructed + '", got "' + e.constructed + '"'
      );
  else
    r && (e.tagClass !== t.tagClass && r.push(
      "[" + t.name + '] Expected tag class "' + t.tagClass + '", got "' + e.tagClass + '"'
    ), e.type !== t.type && r.push(
      "[" + t.name + '] Expected type "' + t.type + '", got "' + e.type + '"'
    ));
  return n;
};
var B0 = /[^\\u0000-\\u00ff]/;
ve.prettyPrint = function(e, t, i) {
  var r = "";
  t = t || 0, i = i || 2, t > 0 && (r += `
`);
  for (var n = "", a = 0; a < t * i; ++a)
    n += " ";
  switch (r += n + "Tag: ", e.tagClass) {
    case ve.Class.UNIVERSAL:
      r += "Universal:";
      break;
    case ve.Class.APPLICATION:
      r += "Application:";
      break;
    case ve.Class.CONTEXT_SPECIFIC:
      r += "Context-Specific:";
      break;
    case ve.Class.PRIVATE:
      r += "Private:";
      break;
  }
  if (e.tagClass === ve.Class.UNIVERSAL)
    switch (r += e.type, e.type) {
      case ve.Type.NONE:
        r += " (None)";
        break;
      case ve.Type.BOOLEAN:
        r += " (Boolean)";
        break;
      case ve.Type.INTEGER:
        r += " (Integer)";
        break;
      case ve.Type.BITSTRING:
        r += " (Bit string)";
        break;
      case ve.Type.OCTETSTRING:
        r += " (Octet string)";
        break;
      case ve.Type.NULL:
        r += " (Null)";
        break;
      case ve.Type.OID:
        r += " (Object Identifier)";
        break;
      case ve.Type.ODESC:
        r += " (Object Descriptor)";
        break;
      case ve.Type.EXTERNAL:
        r += " (External or Instance of)";
        break;
      case ve.Type.REAL:
        r += " (Real)";
        break;
      case ve.Type.ENUMERATED:
        r += " (Enumerated)";
        break;
      case ve.Type.EMBEDDED:
        r += " (Embedded PDV)";
        break;
      case ve.Type.UTF8:
        r += " (UTF8)";
        break;
      case ve.Type.ROID:
        r += " (Relative Object Identifier)";
        break;
      case ve.Type.SEQUENCE:
        r += " (Sequence)";
        break;
      case ve.Type.SET:
        r += " (Set)";
        break;
      case ve.Type.PRINTABLESTRING:
        r += " (Printable String)";
        break;
      case ve.Type.IA5String:
        r += " (IA5String (ASCII))";
        break;
      case ve.Type.UTCTIME:
        r += " (UTC time)";
        break;
      case ve.Type.GENERALIZEDTIME:
        r += " (Generalized time)";
        break;
      case ve.Type.BMPSTRING:
        r += " (BMP String)";
        break;
    }
  else
    r += e.type;
  if (r += `
`, r += n + "Constructed: " + e.constructed + `
`, e.composed) {
    for (var f = 0, s = "", a = 0; a < e.value.length; ++a)
      e.value[a] !== void 0 && (f += 1, s += ve.prettyPrint(e.value[a], t + 1, i), a + 1 < e.value.length && (s += ","));
    r += n + "Sub values: " + f + s;
  } else {
    if (r += n + "Value: ", e.type === ve.Type.OID) {
      var c = ve.derToOid(e.value);
      r += c, st.pki && st.pki.oids && c in st.pki.oids && (r += " (" + st.pki.oids[c] + ") ");
    }
    if (e.type === ve.Type.INTEGER)
      try {
        r += ve.derToInteger(e.value);
      } catch {
        r += "0x" + st.util.bytesToHex(e.value);
      }
    else if (e.type === ve.Type.BITSTRING) {
      if (e.value.length > 1 ? r += "0x" + st.util.bytesToHex(e.value.slice(1)) : r += "(none)", e.value.length > 0) {
        var u = e.value.charCodeAt(0);
        u == 1 ? r += " (1 unused bit shown)" : u > 1 && (r += " (" + u + " unused bits shown)");
      }
    } else if (e.type === ve.Type.OCTETSTRING)
      B0.test(e.value) || (r += "(" + e.value + ") "), r += "0x" + st.util.bytesToHex(e.value);
    else if (e.type === ve.Type.UTF8)
      try {
        r += st.util.decodeUtf8(e.value);
      } catch (o) {
        if (o.message === "URI malformed")
          r += "0x" + st.util.bytesToHex(e.value) + " (malformed UTF8)";
        else
          throw o;
      }
    else
      e.type === ve.Type.PRINTABLESTRING || e.type === ve.Type.IA5String ? r += e.value : B0.test(e.value) ? r += "0x" + st.util.bytesToHex(e.value) : e.value.length === 0 ? r += "[null]" : r += e.value;
  }
  return r;
};
var Ea = je;
Ea.md = Ea.md || {};
Ea.md.algorithms = Ea.md.algorithms || {};
var wr = je, Kp = wr.hmac = wr.hmac || {};
Kp.create = function() {
  var e = null, t = null, i = null, r = null, n = {};
  return n.start = function(a, f) {
    if (a !== null)
      if (typeof a == "string")
        if (a = a.toLowerCase(), a in wr.md.algorithms)
          t = wr.md.algorithms[a].create();
        else
          throw new Error('Unknown hash algorithm "' + a + '"');
      else
        t = a;
    if (f === null)
      f = e;
    else {
      if (typeof f == "string")
        f = wr.util.createBuffer(f);
      else if (wr.util.isArray(f)) {
        var s = f;
        f = wr.util.createBuffer();
        for (var c = 0; c < s.length; ++c)
          f.putByte(s[c]);
      }
      var u = f.length();
      u > t.blockLength && (t.start(), t.update(f.bytes()), f = t.digest()), i = wr.util.createBuffer(), r = wr.util.createBuffer(), u = f.length();
      for (var c = 0; c < u; ++c) {
        var s = f.at(c);
        i.putByte(54 ^ s), r.putByte(92 ^ s);
      }
      if (u < t.blockLength)
        for (var s = t.blockLength - u, c = 0; c < s; ++c)
          i.putByte(54), r.putByte(92);
      e = f, i = i.bytes(), r = r.bytes();
    }
    t.start(), t.update(i);
  }, n.update = function(a) {
    t.update(a);
  }, n.getMac = function() {
    var a = t.digest().bytes();
    return t.start(), t.update(r), t.update(a), t.digest();
  }, n.digest = n.getMac, n;
};
var gr = je, $h = gr.md5 = gr.md5 || {};
gr.md.md5 = gr.md.algorithms.md5 = $h;
$h.create = function() {
  Wh || Hp();
  var e = null, t = gr.util.createBuffer(), i = new Array(16), r = {
    algorithm: "md5",
    blockLength: 64,
    digestLength: 16,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var n = r.messageLengthSize / 4, a = 0; a < n; ++a)
      r.fullMessageLength.push(0);
    return t = gr.util.createBuffer(), e = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878
    }, r;
  }, r.start(), r.update = function(n, a) {
    a === "utf8" && (n = gr.util.encodeUtf8(n));
    var f = n.length;
    r.messageLength += f, f = [f / 4294967296 >>> 0, f >>> 0];
    for (var s = r.fullMessageLength.length - 1; s >= 0; --s)
      r.fullMessageLength[s] += f[1], f[1] = f[0] + (r.fullMessageLength[s] / 4294967296 >>> 0), r.fullMessageLength[s] = r.fullMessageLength[s] >>> 0, f[0] = f[1] / 4294967296 >>> 0;
    return t.putBytes(n), T0(e, i, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var n = gr.util.createBuffer();
    n.putBytes(t.bytes());
    var a = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, f = a & r.blockLength - 1;
    n.putBytes(To.substr(0, r.blockLength - f));
    for (var s, c = 0, u = r.fullMessageLength.length - 1; u >= 0; --u)
      s = r.fullMessageLength[u] * 8 + c, c = s / 4294967296 >>> 0, n.putInt32Le(s >>> 0);
    var o = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3
    };
    T0(o, i, n);
    var l = gr.util.createBuffer();
    return l.putInt32Le(o.h0), l.putInt32Le(o.h1), l.putInt32Le(o.h2), l.putInt32Le(o.h3), l;
  }, r;
};
var To = null, ma = null, Li = null, vi = null, Wh = !1;
function Hp() {
  To = "", To += gr.util.fillString("\0", 64), ma = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    1,
    6,
    11,
    0,
    5,
    10,
    15,
    4,
    9,
    14,
    3,
    8,
    13,
    2,
    7,
    12,
    5,
    8,
    11,
    14,
    1,
    4,
    7,
    10,
    13,
    0,
    3,
    6,
    9,
    12,
    15,
    2,
    0,
    7,
    14,
    5,
    12,
    3,
    10,
    1,
    8,
    15,
    6,
    13,
    4,
    11,
    2,
    9
  ], Li = [
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21
  ], vi = new Array(64);
  for (var e = 0; e < 64; ++e)
    vi[e] = Math.floor(Math.abs(Math.sin(e + 1)) * 4294967296);
  Wh = !0;
}
function T0(e, t, i) {
  for (var r, n, a, f, s, c, u, o, l = i.length(); l >= 64; ) {
    for (n = e.h0, a = e.h1, f = e.h2, s = e.h3, o = 0; o < 16; ++o)
      t[o] = i.getInt32Le(), c = s ^ a & (f ^ s), r = n + c + vi[o] + t[o], u = Li[o], n = s, s = f, f = a, a += r << u | r >>> 32 - u;
    for (; o < 32; ++o)
      c = f ^ s & (a ^ f), r = n + c + vi[o] + t[ma[o]], u = Li[o], n = s, s = f, f = a, a += r << u | r >>> 32 - u;
    for (; o < 48; ++o)
      c = a ^ f ^ s, r = n + c + vi[o] + t[ma[o]], u = Li[o], n = s, s = f, f = a, a += r << u | r >>> 32 - u;
    for (; o < 64; ++o)
      c = f ^ (a | ~s), r = n + c + vi[o] + t[ma[o]], u = Li[o], n = s, s = f, f = a, a += r << u | r >>> 32 - u;
    e.h0 = e.h0 + n | 0, e.h1 = e.h1 + a | 0, e.h2 = e.h2 + f | 0, e.h3 = e.h3 + s | 0, l -= 64;
  }
}
var wa = je, Qh = wa.pem = wa.pem || {};
Qh.encode = function(e, t) {
  t = t || {};
  var i = "-----BEGIN " + e.type + `-----\r
`, r;
  if (e.procType && (r = {
    name: "Proc-Type",
    values: [String(e.procType.version), e.procType.type]
  }, i += ea(r)), e.contentDomain && (r = { name: "Content-Domain", values: [e.contentDomain] }, i += ea(r)), e.dekInfo && (r = { name: "DEK-Info", values: [e.dekInfo.algorithm] }, e.dekInfo.parameters && r.values.push(e.dekInfo.parameters), i += ea(r)), e.headers)
    for (var n = 0; n < e.headers.length; ++n)
      i += ea(e.headers[n]);
  return e.procType && (i += `\r
`), i += wa.util.encode64(e.body, t.maxline || 64) + `\r
`, i += "-----END " + e.type + `-----\r
`, i;
};
Qh.decode = function(e) {
  for (var t = [], i = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, r = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, n = /\r?\n/, a; a = i.exec(e), !!a; ) {
    var f = a[1];
    f === "NEW CERTIFICATE REQUEST" && (f = "CERTIFICATE REQUEST");
    var s = {
      type: f,
      procType: null,
      contentDomain: null,
      dekInfo: null,
      headers: [],
      body: wa.util.decode64(a[3])
    };
    if (t.push(s), !!a[2]) {
      for (var c = a[2].split(n), u = 0; a && u < c.length; ) {
        for (var o = c[u].replace(/\s+$/, ""), l = u + 1; l < c.length; ++l) {
          var h = c[l];
          if (!/\s/.test(h[0]))
            break;
          o += h, u = l;
        }
        if (a = o.match(r), a) {
          for (var p = { name: a[1], values: [] }, v = a[2].split(","), y = 0; y < v.length; ++y)
            p.values.push(jp(v[y]));
          if (s.procType)
            if (!s.contentDomain && p.name === "Content-Domain")
              s.contentDomain = v[0] || "";
            else if (!s.dekInfo && p.name === "DEK-Info") {
              if (p.values.length === 0)
                throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
              s.dekInfo = { algorithm: v[0], parameters: v[1] || null };
            } else
              s.headers.push(p);
          else {
            if (p.name !== "Proc-Type")
              throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
            if (p.values.length !== 2)
              throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
            s.procType = { version: v[0], type: v[1] };
          }
        }
        ++u;
      }
      if (s.procType === "ENCRYPTED" && !s.dekInfo)
        throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
  }
  if (t.length === 0)
    throw new Error("Invalid PEM formatted message.");
  return t;
};
function ea(e) {
  for (var t = e.name + ": ", i = [], r = function(c, u) {
    return " " + u;
  }, n = 0; n < e.values.length; ++n)
    i.push(e.values[n].replace(/^(\S+\r\n)/, r));
  t += i.join(",") + `\r
`;
  for (var a = 0, f = -1, n = 0; n < t.length; ++n, ++a)
    if (a > 65 && f !== -1) {
      var s = t[f];
      s === "," ? (++f, t = t.substr(0, f) + `\r
 ` + t.substr(f)) : t = t.substr(0, f) + `\r
` + s + t.substr(f + 1), a = n - f - 1, f = -1, ++n;
    } else
      (t[n] === " " || t[n] === "	" || t[n] === ",") && (f = n);
  return t;
}
function jp(e) {
  return e.replace(/^\s+/, "");
}
var lt = je;
lt.des = lt.des || {};
lt.des.startEncrypting = function(e, t, i, r) {
  var n = Ua({
    key: e,
    output: i,
    decrypt: !1,
    mode: r || (t === null ? "ECB" : "CBC")
  });
  return n.start(t), n;
};
lt.des.createEncryptionCipher = function(e, t) {
  return Ua({
    key: e,
    output: null,
    decrypt: !1,
    mode: t
  });
};
lt.des.startDecrypting = function(e, t, i, r) {
  var n = Ua({
    key: e,
    output: i,
    decrypt: !0,
    mode: r || (t === null ? "ECB" : "CBC")
  });
  return n.start(t), n;
};
lt.des.createDecryptionCipher = function(e, t) {
  return Ua({
    key: e,
    output: null,
    decrypt: !0,
    mode: t
  });
};
lt.des.Algorithm = function(e, t) {
  var i = this;
  i.name = e, i.mode = new t({
    blockSize: 8,
    cipher: {
      encrypt: function(r, n) {
        return I0(i._keys, r, n, !1);
      },
      decrypt: function(r, n) {
        return I0(i._keys, r, n, !0);
      }
    }
  }), i._init = !1;
};
lt.des.Algorithm.prototype.initialize = function(e) {
  if (!this._init) {
    var t = lt.util.createBuffer(e.key);
    if (this.name.indexOf("3DES") === 0 && t.length() !== 24)
      throw new Error("Invalid Triple-DES key size: " + t.length() * 8);
    this._keys = Jp(t), this._init = !0;
  }
};
_r("DES-ECB", lt.cipher.modes.ecb);
_r("DES-CBC", lt.cipher.modes.cbc);
_r("DES-CFB", lt.cipher.modes.cfb);
_r("DES-OFB", lt.cipher.modes.ofb);
_r("DES-CTR", lt.cipher.modes.ctr);
_r("3DES-ECB", lt.cipher.modes.ecb);
_r("3DES-CBC", lt.cipher.modes.cbc);
_r("3DES-CFB", lt.cipher.modes.cfb);
_r("3DES-OFB", lt.cipher.modes.ofb);
_r("3DES-CTR", lt.cipher.modes.ctr);
function _r(e, t) {
  var i = function() {
    return new lt.des.Algorithm(e, t);
  };
  lt.cipher.registerAlgorithm(e, i);
}
var zp = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756], Gp = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344], $p = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584], Wp = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928], Qp = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080], Yp = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312], Xp = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154], Zp = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
function Jp(e) {
  for (var t = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], i = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], r = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], n = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], a = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], f = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], s = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], c = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], u = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], o = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], l = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], h = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], p = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], v = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], y = e.length() > 8 ? 3 : 1, w = [], x = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], A = 0, R, M = 0; M < y; M++) {
    var D = e.getInt32(), U = e.getInt32();
    R = (D >>> 4 ^ U) & 252645135, U ^= R, D ^= R << 4, R = (U >>> -16 ^ D) & 65535, D ^= R, U ^= R << -16, R = (D >>> 2 ^ U) & 858993459, U ^= R, D ^= R << 2, R = (U >>> -16 ^ D) & 65535, D ^= R, U ^= R << -16, R = (D >>> 1 ^ U) & 1431655765, U ^= R, D ^= R << 1, R = (U >>> 8 ^ D) & 16711935, D ^= R, U ^= R << 8, R = (D >>> 1 ^ U) & 1431655765, U ^= R, D ^= R << 1, R = D << 8 | U >>> 20 & 240, D = U << 24 | U << 8 & 16711680 | U >>> 8 & 65280 | U >>> 24 & 240, U = R;
    for (var z = 0; z < x.length; ++z) {
      x[z] ? (D = D << 2 | D >>> 26, U = U << 2 | U >>> 26) : (D = D << 1 | D >>> 27, U = U << 1 | U >>> 27), D &= -15, U &= -15;
      var W = t[D >>> 28] | i[D >>> 24 & 15] | r[D >>> 20 & 15] | n[D >>> 16 & 15] | a[D >>> 12 & 15] | f[D >>> 8 & 15] | s[D >>> 4 & 15], G = c[U >>> 28] | u[U >>> 24 & 15] | o[U >>> 20 & 15] | l[U >>> 16 & 15] | h[U >>> 12 & 15] | p[U >>> 8 & 15] | v[U >>> 4 & 15];
      R = (G >>> 16 ^ W) & 65535, w[A++] = W ^ R, w[A++] = G ^ R << 16;
    }
  }
  return w;
}
function I0(e, t, i, r) {
  var n = e.length === 32 ? 3 : 9, a;
  n === 3 ? a = r ? [30, -2, -2] : [0, 32, 2] : a = r ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
  var f, s = t[0], c = t[1];
  f = (s >>> 4 ^ c) & 252645135, c ^= f, s ^= f << 4, f = (s >>> 16 ^ c) & 65535, c ^= f, s ^= f << 16, f = (c >>> 2 ^ s) & 858993459, s ^= f, c ^= f << 2, f = (c >>> 8 ^ s) & 16711935, s ^= f, c ^= f << 8, f = (s >>> 1 ^ c) & 1431655765, c ^= f, s ^= f << 1, s = s << 1 | s >>> 31, c = c << 1 | c >>> 31;
  for (var u = 0; u < n; u += 3) {
    for (var o = a[u + 1], l = a[u + 2], h = a[u]; h != o; h += l) {
      var p = c ^ e[h], v = (c >>> 4 | c << 28) ^ e[h + 1];
      f = s, s = c, c = f ^ (Gp[p >>> 24 & 63] | Wp[p >>> 16 & 63] | Yp[p >>> 8 & 63] | Zp[p & 63] | zp[v >>> 24 & 63] | $p[v >>> 16 & 63] | Qp[v >>> 8 & 63] | Xp[v & 63]);
    }
    f = s, s = c, c = f;
  }
  s = s >>> 1 | s << 31, c = c >>> 1 | c << 31, f = (s >>> 1 ^ c) & 1431655765, c ^= f, s ^= f << 1, f = (c >>> 8 ^ s) & 16711935, s ^= f, c ^= f << 8, f = (c >>> 2 ^ s) & 858993459, s ^= f, c ^= f << 2, f = (s >>> 16 ^ c) & 65535, c ^= f, s ^= f << 16, f = (s >>> 4 ^ c) & 252645135, c ^= f, s ^= f << 4, i[0] = s, i[1] = c;
}
function Ua(e) {
  e = e || {};
  var t = (e.mode || "CBC").toUpperCase(), i = "DES-" + t, r;
  e.decrypt ? r = lt.cipher.createDecipher(i, e.key) : r = lt.cipher.createCipher(i, e.key);
  var n = r.start;
  return r.start = function(a, f) {
    var s = null;
    f instanceof lt.util.ByteBuffer && (s = f, f = {}), f = f || {}, f.output = s, f.iv = a, n.call(r, f);
  }, r;
}
var Ve = {}, ta = { exports: {} }, ra = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var R0;
function He() {
  return R0 || (R0 = 1, function(e, t) {
    var i = or, r = i.Buffer;
    function n(f, s) {
      for (var c in f)
        s[c] = f[c];
    }
    r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = i : (n(i, t), t.Buffer = a);
    function a(f, s, c) {
      return r(f, s, c);
    }
    a.prototype = Object.create(r.prototype), n(r, a), a.from = function(f, s, c) {
      if (typeof f == "number")
        throw new TypeError("Argument must not be a number");
      return r(f, s, c);
    }, a.alloc = function(f, s, c) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      var u = r(f);
      return s !== void 0 ? typeof c == "string" ? u.fill(s, c) : u.fill(s) : u.fill(0), u;
    }, a.allocUnsafe = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return r(f);
    }, a.allocUnsafeSlow = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return i.SlowBuffer(f);
    };
  }(ra, ra.exports)), ra.exports;
}
var M0;
function wi() {
  if (M0)
    return ta.exports;
  M0 = 1;
  var e = 65536, t = 4294967295;
  function i() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var r = He().Buffer, n = Ge.crypto || Ge.msCrypto;
  n && n.getRandomValues ? ta.exports = a : ta.exports = i;
  function a(f, s) {
    if (f > t)
      throw new RangeError("requested too many random bytes");
    var c = r.allocUnsafe(f);
    if (f > 0)
      if (f > e)
        for (var u = 0; u < f; u += e)
          n.getRandomValues(c.slice(u, u + e));
      else
        n.getRandomValues(c);
    return typeof s == "function" ? fe.process.nextTick(function() {
      s(null, c);
    }) : c;
  }
  return ta.exports;
}
var ia = { exports: {} }, N0;
function Ae() {
  return N0 || (N0 = 1, typeof Object.create == "function" ? ia.exports = function(t, i) {
    i && (t.super_ = i, t.prototype = Object.create(i.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : ia.exports = function(t, i) {
    if (i) {
      t.super_ = i;
      var r = function() {
      };
      r.prototype = i.prototype, t.prototype = new r(), t.prototype.constructor = t;
    }
  }), ia.exports;
}
var aa = { exports: {} }, k0;
function Hi() {
  if (k0)
    return aa.exports;
  k0 = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(D, U, z) {
    return Function.prototype.apply.call(D, U, z);
  }, i;
  e && typeof e.ownKeys == "function" ? i = e.ownKeys : Object.getOwnPropertySymbols ? i = function(D) {
    return Object.getOwnPropertyNames(D).concat(Object.getOwnPropertySymbols(D));
  } : i = function(D) {
    return Object.getOwnPropertyNames(D);
  };
  function r(M) {
    console && console.warn && console.warn(M);
  }
  var n = Number.isNaN || function(D) {
    return D !== D;
  };
  function a() {
    a.init.call(this);
  }
  aa.exports = a, aa.exports.once = x, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
  var f = 10;
  function s(M) {
    if (typeof M != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof M);
  }
  Object.defineProperty(a, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return f;
    },
    set: function(M) {
      if (typeof M != "number" || M < 0 || n(M))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + M + ".");
      f = M;
    }
  }), a.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, a.prototype.setMaxListeners = function(D) {
    if (typeof D != "number" || D < 0 || n(D))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + D + ".");
    return this._maxListeners = D, this;
  };
  function c(M) {
    return M._maxListeners === void 0 ? a.defaultMaxListeners : M._maxListeners;
  }
  a.prototype.getMaxListeners = function() {
    return c(this);
  }, a.prototype.emit = function(D) {
    for (var U = [], z = 1; z < arguments.length; z++)
      U.push(arguments[z]);
    var W = D === "error", G = this._events;
    if (G !== void 0)
      W = W && G.error === void 0;
    else if (!W)
      return !1;
    if (W) {
      var re;
      if (U.length > 0 && (re = U[0]), re instanceof Error)
        throw re;
      var V = new Error("Unhandled error." + (re ? " (" + re.message + ")" : ""));
      throw V.context = re, V;
    }
    var m = G[D];
    if (m === void 0)
      return !1;
    if (typeof m == "function")
      t(m, this, U);
    else
      for (var g = m.length, d = v(m, g), z = 0; z < g; ++z)
        t(d[z], this, U);
    return !0;
  };
  function u(M, D, U, z) {
    var W, G, re;
    if (s(U), G = M._events, G === void 0 ? (G = M._events = /* @__PURE__ */ Object.create(null), M._eventsCount = 0) : (G.newListener !== void 0 && (M.emit(
      "newListener",
      D,
      U.listener ? U.listener : U
    ), G = M._events), re = G[D]), re === void 0)
      re = G[D] = U, ++M._eventsCount;
    else if (typeof re == "function" ? re = G[D] = z ? [U, re] : [re, U] : z ? re.unshift(U) : re.push(U), W = c(M), W > 0 && re.length > W && !re.warned) {
      re.warned = !0;
      var V = new Error("Possible EventEmitter memory leak detected. " + re.length + " " + String(D) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      V.name = "MaxListenersExceededWarning", V.emitter = M, V.type = D, V.count = re.length, r(V);
    }
    return M;
  }
  a.prototype.addListener = function(D, U) {
    return u(this, D, U, !1);
  }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(D, U) {
    return u(this, D, U, !0);
  };
  function o() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function l(M, D, U) {
    var z = { fired: !1, wrapFn: void 0, target: M, type: D, listener: U }, W = o.bind(z);
    return W.listener = U, z.wrapFn = W, W;
  }
  a.prototype.once = function(D, U) {
    return s(U), this.on(D, l(this, D, U)), this;
  }, a.prototype.prependOnceListener = function(D, U) {
    return s(U), this.prependListener(D, l(this, D, U)), this;
  }, a.prototype.removeListener = function(D, U) {
    var z, W, G, re, V;
    if (s(U), W = this._events, W === void 0)
      return this;
    if (z = W[D], z === void 0)
      return this;
    if (z === U || z.listener === U)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete W[D], W.removeListener && this.emit("removeListener", D, z.listener || U));
    else if (typeof z != "function") {
      for (G = -1, re = z.length - 1; re >= 0; re--)
        if (z[re] === U || z[re].listener === U) {
          V = z[re].listener, G = re;
          break;
        }
      if (G < 0)
        return this;
      G === 0 ? z.shift() : y(z, G), z.length === 1 && (W[D] = z[0]), W.removeListener !== void 0 && this.emit("removeListener", D, V || U);
    }
    return this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(D) {
    var U, z, W;
    if (z = this._events, z === void 0)
      return this;
    if (z.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[D] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[D]), this;
    if (arguments.length === 0) {
      var G = Object.keys(z), re;
      for (W = 0; W < G.length; ++W)
        re = G[W], re !== "removeListener" && this.removeAllListeners(re);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (U = z[D], typeof U == "function")
      this.removeListener(D, U);
    else if (U !== void 0)
      for (W = U.length - 1; W >= 0; W--)
        this.removeListener(D, U[W]);
    return this;
  };
  function h(M, D, U) {
    var z = M._events;
    if (z === void 0)
      return [];
    var W = z[D];
    return W === void 0 ? [] : typeof W == "function" ? U ? [W.listener || W] : [W] : U ? w(W) : v(W, W.length);
  }
  a.prototype.listeners = function(D) {
    return h(this, D, !0);
  }, a.prototype.rawListeners = function(D) {
    return h(this, D, !1);
  }, a.listenerCount = function(M, D) {
    return typeof M.listenerCount == "function" ? M.listenerCount(D) : p.call(M, D);
  }, a.prototype.listenerCount = p;
  function p(M) {
    var D = this._events;
    if (D !== void 0) {
      var U = D[M];
      if (typeof U == "function")
        return 1;
      if (U !== void 0)
        return U.length;
    }
    return 0;
  }
  a.prototype.eventNames = function() {
    return this._eventsCount > 0 ? i(this._events) : [];
  };
  function v(M, D) {
    for (var U = new Array(D), z = 0; z < D; ++z)
      U[z] = M[z];
    return U;
  }
  function y(M, D) {
    for (; D + 1 < M.length; D++)
      M[D] = M[D + 1];
    M.pop();
  }
  function w(M) {
    for (var D = new Array(M.length), U = 0; U < D.length; ++U)
      D[U] = M[U].listener || M[U];
    return D;
  }
  function x(M, D) {
    return new Promise(function(U, z) {
      function W(re) {
        M.removeListener(D, G), z(re);
      }
      function G() {
        typeof M.removeListener == "function" && M.removeListener("error", W), U([].slice.call(arguments));
      }
      R(M, D, G, { once: !0 }), D !== "error" && A(M, W, { once: !0 });
    });
  }
  function A(M, D, U) {
    typeof M.on == "function" && R(M, "error", D, U);
  }
  function R(M, D, U, z) {
    if (typeof M.on == "function")
      z.once ? M.once(D, U) : M.on(D, U);
    else if (typeof M.addEventListener == "function")
      M.addEventListener(D, function W(G) {
        z.once && M.removeEventListener(D, W), U(G);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof M);
  }
  return aa.exports;
}
var en, D0;
function Yh() {
  return D0 || (D0 = 1, en = Hi().EventEmitter), en;
}
var tn = {}, rn = {}, an, L0;
function Xh() {
  return L0 || (L0 = 1, an = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, i = Symbol("test"), r = Object(i);
    if (typeof i == "string" || Object.prototype.toString.call(i) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var n = 42;
    t[i] = n;
    for (var a in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var f = Object.getOwnPropertySymbols(t);
    if (f.length !== 1 || f[0] !== i || !Object.prototype.propertyIsEnumerable.call(t, i))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, i)
      );
      if (s.value !== n || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), an;
}
var nn, P0;
function Oa() {
  if (P0)
    return nn;
  P0 = 1;
  var e = Xh();
  return nn = function() {
    return e() && !!Symbol.toStringTag;
  }, nn;
}
var fn, U0;
function Zh() {
  return U0 || (U0 = 1, fn = Object), fn;
}
var sn, O0;
function e1() {
  return O0 || (O0 = 1, sn = Error), sn;
}
var on, q0;
function t1() {
  return q0 || (q0 = 1, on = EvalError), on;
}
var un, F0;
function r1() {
  return F0 || (F0 = 1, un = RangeError), un;
}
var cn, V0;
function i1() {
  return V0 || (V0 = 1, cn = ReferenceError), cn;
}
var ln, K0;
function Jh() {
  return K0 || (K0 = 1, ln = SyntaxError), ln;
}
var hn, H0;
function ji() {
  return H0 || (H0 = 1, hn = TypeError), hn;
}
var dn, j0;
function a1() {
  return j0 || (j0 = 1, dn = URIError), dn;
}
var pn, z0;
function n1() {
  return z0 || (z0 = 1, pn = Math.abs), pn;
}
var vn, G0;
function f1() {
  return G0 || (G0 = 1, vn = Math.floor), vn;
}
var yn, $0;
function s1() {
  return $0 || ($0 = 1, yn = Math.max), yn;
}
var gn, W0;
function o1() {
  return W0 || (W0 = 1, gn = Math.min), gn;
}
var bn, Q0;
function u1() {
  return Q0 || (Q0 = 1, bn = Math.pow), bn;
}
var mn, Y0;
function c1() {
  return Y0 || (Y0 = 1, mn = Math.round), mn;
}
var xn, X0;
function l1() {
  return X0 || (X0 = 1, xn = Number.isNaN || function(t) {
    return t !== t;
  }), xn;
}
var _n, Z0;
function h1() {
  if (Z0)
    return _n;
  Z0 = 1;
  var e = l1();
  return _n = function(i) {
    return e(i) || i === 0 ? i : i < 0 ? -1 : 1;
  }, _n;
}
var Sn, J0;
function d1() {
  return J0 || (J0 = 1, Sn = Object.getOwnPropertyDescriptor), Sn;
}
var En, eu;
function Ci() {
  if (eu)
    return En;
  eu = 1;
  var e = d1();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return En = e, En;
}
var wn, tu;
function qa() {
  if (tu)
    return wn;
  tu = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return wn = e, wn;
}
var Cn, ru;
function p1() {
  if (ru)
    return Cn;
  ru = 1;
  var e = typeof Symbol < "u" && Symbol, t = Xh();
  return Cn = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Cn;
}
var An, iu;
function ed() {
  return iu || (iu = 1, An = typeof Reflect < "u" && Reflect.getPrototypeOf || null), An;
}
var Bn, au;
function td() {
  if (au)
    return Bn;
  au = 1;
  var e = Zh();
  return Bn = e.getPrototypeOf || null, Bn;
}
var Tn, nu;
function v1() {
  if (nu)
    return Tn;
  nu = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, i = Math.max, r = "[object Function]", n = function(c, u) {
    for (var o = [], l = 0; l < c.length; l += 1)
      o[l] = c[l];
    for (var h = 0; h < u.length; h += 1)
      o[h + c.length] = u[h];
    return o;
  }, a = function(c, u) {
    for (var o = [], l = u, h = 0; l < c.length; l += 1, h += 1)
      o[h] = c[l];
    return o;
  }, f = function(s, c) {
    for (var u = "", o = 0; o < s.length; o += 1)
      u += s[o], o + 1 < s.length && (u += c);
    return u;
  };
  return Tn = function(c) {
    var u = this;
    if (typeof u != "function" || t.apply(u) !== r)
      throw new TypeError(e + u);
    for (var o = a(arguments, 1), l, h = function() {
      if (this instanceof l) {
        var x = u.apply(
          this,
          n(o, arguments)
        );
        return Object(x) === x ? x : this;
      }
      return u.apply(
        c,
        n(o, arguments)
      );
    }, p = i(0, u.length - o.length), v = [], y = 0; y < p; y++)
      v[y] = "$" + y;
    if (l = Function("binder", "return function (" + f(v, ",") + "){ return binder.apply(this,arguments); }")(h), u.prototype) {
      var w = function() {
      };
      w.prototype = u.prototype, l.prototype = new w(), w.prototype = null;
    }
    return l;
  }, Tn;
}
var In, fu;
function zi() {
  if (fu)
    return In;
  fu = 1;
  var e = v1();
  return In = Function.prototype.bind || e, In;
}
var Rn, su;
function Wo() {
  return su || (su = 1, Rn = Function.prototype.call), Rn;
}
var Mn, ou;
function Qo() {
  return ou || (ou = 1, Mn = Function.prototype.apply), Mn;
}
var Nn, uu;
function y1() {
  return uu || (uu = 1, Nn = typeof Reflect < "u" && Reflect && Reflect.apply), Nn;
}
var kn, cu;
function rd() {
  if (cu)
    return kn;
  cu = 1;
  var e = zi(), t = Qo(), i = Wo(), r = y1();
  return kn = r || e.call(i, t), kn;
}
var Dn, lu;
function Yo() {
  if (lu)
    return Dn;
  lu = 1;
  var e = zi(), t = ji(), i = Wo(), r = rd();
  return Dn = function(a) {
    if (a.length < 1 || typeof a[0] != "function")
      throw new t("a function is required");
    return r(e, i, a);
  }, Dn;
}
var Ln, hu;
function g1() {
  if (hu)
    return Ln;
  hu = 1;
  var e = Yo(), t = Ci(), i;
  try {
    i = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (f) {
    if (!f || typeof f != "object" || !("code" in f) || f.code !== "ERR_PROTO_ACCESS")
      throw f;
  }
  var r = !!i && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), n = Object, a = n.getPrototypeOf;
  return Ln = r && typeof r.get == "function" ? e([r.get]) : typeof a == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return a(s == null ? s : n(s));
    }
  ) : !1, Ln;
}
var Pn, du;
function Xo() {
  if (du)
    return Pn;
  du = 1;
  var e = ed(), t = td(), i = g1();
  return Pn = e ? function(n) {
    return e(n);
  } : t ? function(n) {
    if (!n || typeof n != "object" && typeof n != "function")
      throw new TypeError("getProto: not an object");
    return t(n);
  } : i ? function(n) {
    return i(n);
  } : null, Pn;
}
var Un, pu;
function id() {
  if (pu)
    return Un;
  pu = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, i = zi();
  return Un = i.call(e, t), Un;
}
var On, vu;
function ad() {
  if (vu)
    return On;
  vu = 1;
  var e, t = Zh(), i = e1(), r = t1(), n = r1(), a = i1(), f = Jh(), s = ji(), c = a1(), u = n1(), o = f1(), l = s1(), h = o1(), p = u1(), v = c1(), y = h1(), w = Function, x = function(j) {
    try {
      return w('"use strict"; return (' + j + ").constructor;")();
    } catch {
    }
  }, A = Ci(), R = qa(), M = function() {
    throw new s();
  }, D = A ? function() {
    try {
      return arguments.callee, M;
    } catch {
      try {
        return A(arguments, "callee").get;
      } catch {
        return M;
      }
    }
  }() : M, U = p1()(), z = Xo(), W = td(), G = ed(), re = Qo(), V = Wo(), m = {}, g = typeof Uint8Array > "u" || !z ? e : z(Uint8Array), d = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": U && z ? z([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": m,
    "%AsyncGenerator%": m,
    "%AsyncGeneratorFunction%": m,
    "%AsyncIteratorPrototype%": m,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": i,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": w,
    "%GeneratorFunction%": m,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": U && z ? z(z([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !U || !z ? e : z((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": A,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": n,
    "%ReferenceError%": a,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !U || !z ? e : z((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": U && z ? z(""[Symbol.iterator]()) : e,
    "%Symbol%": U ? Symbol : e,
    "%SyntaxError%": f,
    "%ThrowTypeError%": D,
    "%TypedArray%": g,
    "%TypeError%": s,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": V,
    "%Function.prototype.apply%": re,
    "%Object.defineProperty%": R,
    "%Object.getPrototypeOf%": W,
    "%Math.abs%": u,
    "%Math.floor%": o,
    "%Math.max%": l,
    "%Math.min%": h,
    "%Math.pow%": p,
    "%Math.round%": v,
    "%Math.sign%": y,
    "%Reflect.getPrototypeOf%": G
  };
  if (z)
    try {
      null.error;
    } catch (j) {
      var b = z(z(j));
      d["%Error.prototype%"] = b;
    }
  var C = function j(Y) {
    var F;
    if (Y === "%AsyncFunction%")
      F = x("async function () {}");
    else if (Y === "%GeneratorFunction%")
      F = x("function* () {}");
    else if (Y === "%AsyncGeneratorFunction%")
      F = x("async function* () {}");
    else if (Y === "%AsyncGenerator%") {
      var P = j("%AsyncGeneratorFunction%");
      P && (F = P.prototype);
    } else if (Y === "%AsyncIteratorPrototype%") {
      var Z = j("%AsyncGenerator%");
      Z && z && (F = z(Z.prototype));
    }
    return d[Y] = F, F;
  }, E = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, B = zi(), T = id(), _ = B.call(V, Array.prototype.concat), I = B.call(re, Array.prototype.splice), S = B.call(V, String.prototype.replace), k = B.call(V, String.prototype.slice), $ = B.call(V, RegExp.prototype.exec), ee = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, H = /\\(\\)?/g, N = function(Y) {
    var F = k(Y, 0, 1), P = k(Y, -1);
    if (F === "%" && P !== "%")
      throw new f("invalid intrinsic syntax, expected closing `%`");
    if (P === "%" && F !== "%")
      throw new f("invalid intrinsic syntax, expected opening `%`");
    var Z = [];
    return S(Y, ee, function(ae, se, le, be) {
      Z[Z.length] = le ? S(be, H, "$1") : se || ae;
    }), Z;
  }, L = function(Y, F) {
    var P = Y, Z;
    if (T(E, P) && (Z = E[P], P = "%" + Z[0] + "%"), T(d, P)) {
      var ae = d[P];
      if (ae === m && (ae = C(P)), typeof ae > "u" && !F)
        throw new s("intrinsic " + Y + " exists, but is not available. Please file an issue!");
      return {
        alias: Z,
        name: P,
        value: ae
      };
    }
    throw new f("intrinsic " + Y + " does not exist!");
  };
  return On = function(Y, F) {
    if (typeof Y != "string" || Y.length === 0)
      throw new s("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof F != "boolean")
      throw new s('"allowMissing" argument must be a boolean');
    if ($(/^%?[^%]*%?$/, Y) === null)
      throw new f("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var P = N(Y), Z = P.length > 0 ? P[0] : "", ae = L("%" + Z + "%", F), se = ae.name, le = ae.value, be = !1, me = ae.alias;
    me && (Z = me[0], I(P, _([0, 1], me)));
    for (var ie = 1, Be = !0; ie < P.length; ie += 1) {
      var pe = P[ie], Ce = k(pe, 0, 1), Te = k(pe, -1);
      if ((Ce === '"' || Ce === "'" || Ce === "`" || Te === '"' || Te === "'" || Te === "`") && Ce !== Te)
        throw new f("property names with quotes must have matching quotes");
      if ((pe === "constructor" || !Be) && (be = !0), Z += "." + pe, se = "%" + Z + "%", T(d, se))
        le = d[se];
      else if (le != null) {
        if (!(pe in le)) {
          if (!F)
            throw new s("base intrinsic for " + Y + " exists, but the property is not available.");
          return;
        }
        if (A && ie + 1 >= P.length) {
          var xe = A(le, pe);
          Be = !!xe, Be && "get" in xe && !("originalValue" in xe.get) ? le = xe.get : le = le[pe];
        } else
          Be = T(le, pe), le = le[pe];
        Be && !be && (d[se] = le);
      }
    }
    return le;
  }, On;
}
var qn, yu;
function Gi() {
  if (yu)
    return qn;
  yu = 1;
  var e = ad(), t = Yo(), i = t([e("%String.prototype.indexOf%")]);
  return qn = function(n, a) {
    var f = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(n, !!a)
    );
    return typeof f == "function" && i(n, ".prototype.") > -1 ? t(
      /** @type {const} */
      [f]
    ) : f;
  }, qn;
}
var Fn, gu;
function b1() {
  if (gu)
    return Fn;
  gu = 1;
  var e = Oa()(), t = Gi(), i = t("Object.prototype.toString"), r = function(s) {
    return e && s && typeof s == "object" && Symbol.toStringTag in s ? !1 : i(s) === "[object Arguments]";
  }, n = function(s) {
    return r(s) ? !0 : s !== null && typeof s == "object" && "length" in s && typeof s.length == "number" && s.length >= 0 && i(s) !== "[object Array]" && "callee" in s && i(s.callee) === "[object Function]";
  }, a = function() {
    return r(arguments);
  }();
  return r.isLegacyArguments = n, Fn = a ? r : n, Fn;
}
var Vn, bu;
function m1() {
  if (bu)
    return Vn;
  bu = 1;
  var e = Gi(), t = Oa()(), i = id(), r = Ci(), n;
  if (t) {
    var a = e("RegExp.prototype.exec"), f = {}, s = function() {
      throw f;
    }, c = {
      toString: s,
      valueOf: s
    };
    typeof Symbol.toPrimitive == "symbol" && (c[Symbol.toPrimitive] = s), n = function(h) {
      if (!h || typeof h != "object")
        return !1;
      var p = (
        /** @type {NonNullable<typeof gOPD>} */
        r(
          /** @type {{ lastIndex?: unknown }} */
          h,
          "lastIndex"
        )
      ), v = p && i(p, "value");
      if (!v)
        return !1;
      try {
        a(
          h,
          /** @type {string} */
          /** @type {unknown} */
          c
        );
      } catch (y) {
        return y === f;
      }
    };
  } else {
    var u = e("Object.prototype.toString"), o = "[object RegExp]";
    n = function(h) {
      return !h || typeof h != "object" && typeof h != "function" ? !1 : u(h) === o;
    };
  }
  return Vn = n, Vn;
}
var Kn, mu;
function x1() {
  if (mu)
    return Kn;
  mu = 1;
  var e = Gi(), t = m1(), i = e("RegExp.prototype.exec"), r = ji();
  return Kn = function(a) {
    if (!t(a))
      throw new r("`regex` must be a RegExp");
    return function(s) {
      return i(a, s) !== null;
    };
  }, Kn;
}
var Hn, xu;
function _1() {
  if (xu)
    return Hn;
  xu = 1;
  var e = Gi(), t = x1(), i = t(/^\s*(?:function)?\*/), r = Oa()(), n = Xo(), a = e("Object.prototype.toString"), f = e("Function.prototype.toString"), s = function() {
    if (!r)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, c;
  return Hn = function(o) {
    if (typeof o != "function")
      return !1;
    if (i(f(o)))
      return !0;
    if (!r) {
      var l = a(o);
      return l === "[object GeneratorFunction]";
    }
    if (!n)
      return !1;
    if (typeof c > "u") {
      var h = s();
      c = h ? (
        /** @type {GeneratorFunctionConstructor} */
        n(h)
      ) : !1;
    }
    return n(o) === c;
  }, Hn;
}
var jn, _u;
function S1() {
  if (_u)
    return jn;
  _u = 1;
  var e = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, i, r;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      i = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, t(function() {
        throw 42;
      }, null, i);
    } catch (A) {
      A !== r && (t = null);
    }
  else
    t = null;
  var n = /^\s*class\b/, a = function(R) {
    try {
      var M = e.call(R);
      return n.test(M);
    } catch {
      return !1;
    }
  }, f = function(R) {
    try {
      return a(R) ? !1 : (e.call(R), !0);
    } catch {
      return !1;
    }
  }, s = Object.prototype.toString, c = "[object Object]", u = "[object Function]", o = "[object GeneratorFunction]", l = "[object HTMLAllCollection]", h = "[object HTML document.all class]", p = "[object HTMLCollection]", v = typeof Symbol == "function" && !!Symbol.toStringTag, y = !(0 in [,]), w = function() {
    return !1;
  };
  if (typeof document == "object") {
    var x = document.all;
    s.call(x) === s.call(document.all) && (w = function(R) {
      if ((y || !R) && (typeof R > "u" || typeof R == "object"))
        try {
          var M = s.call(R);
          return (M === l || M === h || M === p || M === c) && R("") == null;
        } catch {
        }
      return !1;
    });
  }
  return jn = t ? function(R) {
    if (w(R))
      return !0;
    if (!R || typeof R != "function" && typeof R != "object")
      return !1;
    try {
      t(R, null, i);
    } catch (M) {
      if (M !== r)
        return !1;
    }
    return !a(R) && f(R);
  } : function(R) {
    if (w(R))
      return !0;
    if (!R || typeof R != "function" && typeof R != "object")
      return !1;
    if (v)
      return f(R);
    if (a(R))
      return !1;
    var M = s.call(R);
    return M !== u && M !== o && !/^\[object HTML/.test(M) ? !1 : f(R);
  }, jn;
}
var zn, Su;
function E1() {
  if (Su)
    return zn;
  Su = 1;
  var e = S1(), t = Object.prototype.toString, i = Object.prototype.hasOwnProperty, r = function(c, u, o) {
    for (var l = 0, h = c.length; l < h; l++)
      i.call(c, l) && (o == null ? u(c[l], l, c) : u.call(o, c[l], l, c));
  }, n = function(c, u, o) {
    for (var l = 0, h = c.length; l < h; l++)
      o == null ? u(c.charAt(l), l, c) : u.call(o, c.charAt(l), l, c);
  }, a = function(c, u, o) {
    for (var l in c)
      i.call(c, l) && (o == null ? u(c[l], l, c) : u.call(o, c[l], l, c));
  };
  function f(s) {
    return t.call(s) === "[object Array]";
  }
  return zn = function(c, u, o) {
    if (!e(u))
      throw new TypeError("iterator must be a function");
    var l;
    arguments.length >= 3 && (l = o), f(c) ? r(c, u, l) : typeof c == "string" ? n(c, u, l) : a(c, u, l);
  }, zn;
}
var Gn, Eu;
function w1() {
  return Eu || (Eu = 1, Gn = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), Gn;
}
var $n, wu;
function C1() {
  if (wu)
    return $n;
  wu = 1;
  var e = w1(), t = typeof globalThis > "u" ? Ge : globalThis;
  return $n = function() {
    for (var r = [], n = 0; n < e.length; n++)
      typeof t[e[n]] == "function" && (r[r.length] = e[n]);
    return r;
  }, $n;
}
var Wn = { exports: {} }, Qn, Cu;
function A1() {
  if (Cu)
    return Qn;
  Cu = 1;
  var e = qa(), t = Jh(), i = ji(), r = Ci();
  return Qn = function(a, f, s) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new i("`obj` must be an object or a function`");
    if (typeof f != "string" && typeof f != "symbol")
      throw new i("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new i("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new i("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new i("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new i("`loose`, if provided, must be a boolean");
    var c = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, l = arguments.length > 6 ? arguments[6] : !1, h = !!r && r(a, f);
    if (e)
      e(a, f, {
        configurable: o === null && h ? h.configurable : !o,
        enumerable: c === null && h ? h.enumerable : !c,
        value: s,
        writable: u === null && h ? h.writable : !u
      });
    else if (l || !c && !u && !o)
      a[f] = s;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Qn;
}
var Yn, Au;
function B1() {
  if (Au)
    return Yn;
  Au = 1;
  var e = qa(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Yn = t, Yn;
}
var Xn, Bu;
function T1() {
  if (Bu)
    return Xn;
  Bu = 1;
  var e = ad(), t = A1(), i = B1()(), r = Ci(), n = ji(), a = e("%Math.floor%");
  return Xn = function(s, c) {
    if (typeof s != "function")
      throw new n("`fn` is not a function");
    if (typeof c != "number" || c < 0 || c > 4294967295 || a(c) !== c)
      throw new n("`length` must be a positive 32-bit integer");
    var u = arguments.length > 2 && !!arguments[2], o = !0, l = !0;
    if ("length" in s && r) {
      var h = r(s, "length");
      h && !h.configurable && (o = !1), h && !h.writable && (l = !1);
    }
    return (o || l || !u) && (i ? t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      c,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      c
    )), s;
  }, Xn;
}
var Zn, Tu;
function I1() {
  if (Tu)
    return Zn;
  Tu = 1;
  var e = zi(), t = Qo(), i = rd();
  return Zn = function() {
    return i(e, t, arguments);
  }, Zn;
}
var Iu;
function R1() {
  return Iu || (Iu = 1, function(e) {
    var t = T1(), i = qa(), r = Yo(), n = I1();
    e.exports = function(f) {
      var s = r(arguments), c = f.length - (arguments.length - 1);
      return t(
        s,
        1 + (c > 0 ? c : 0),
        !0
      );
    }, i ? i(e.exports, "apply", { value: n }) : e.exports.apply = n;
  }(Wn)), Wn.exports;
}
var Jn, Ru;
function nd() {
  if (Ru)
    return Jn;
  Ru = 1;
  var e = E1(), t = C1(), i = R1(), r = Gi(), n = Ci(), a = Xo(), f = r("Object.prototype.toString"), s = Oa()(), c = typeof globalThis > "u" ? Ge : globalThis, u = t(), o = r("String.prototype.slice"), l = r("Array.prototype.indexOf", !0) || function(w, x) {
    for (var A = 0; A < w.length; A += 1)
      if (w[A] === x)
        return A;
    return -1;
  }, h = { __proto__: null };
  s && n && a ? e(u, function(y) {
    var w = new c[y]();
    if (Symbol.toStringTag in w && a) {
      var x = a(w), A = n(x, Symbol.toStringTag);
      if (!A && x) {
        var R = a(x);
        A = n(R, Symbol.toStringTag);
      }
      h["$" + y] = i(A.get);
    }
  }) : e(u, function(y) {
    var w = new c[y](), x = w.slice || w.set;
    x && (h[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + y
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    i(x));
  });
  var p = function(w) {
    var x = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      h,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(A, R) {
        if (!x)
          try {
            "$" + A(w) === R && (x = /** @type {import('.').TypedArrayName} */
            o(R, 1));
          } catch {
          }
      }
    ), x;
  }, v = function(w) {
    var x = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      h,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(A, R) {
        if (!x)
          try {
            A(w), x = /** @type {import('.').TypedArrayName} */
            o(R, 1);
          } catch {
          }
      }
    ), x;
  };
  return Jn = function(w) {
    if (!w || typeof w != "object")
      return !1;
    if (!s) {
      var x = o(f(w), 8, -1);
      return l(u, x) > -1 ? x : x !== "Object" ? !1 : v(w);
    }
    return n ? p(w) : null;
  }, Jn;
}
var ef, Mu;
function M1() {
  if (Mu)
    return ef;
  Mu = 1;
  var e = nd();
  return ef = function(i) {
    return !!e(i);
  }, ef;
}
var Nu;
function N1() {
  return Nu || (Nu = 1, function(e) {
    var t = b1(), i = _1(), r = nd(), n = M1();
    function a(ie) {
      return ie.call.bind(ie);
    }
    var f = typeof BigInt < "u", s = typeof Symbol < "u", c = a(Object.prototype.toString), u = a(Number.prototype.valueOf), o = a(String.prototype.valueOf), l = a(Boolean.prototype.valueOf);
    if (f)
      var h = a(BigInt.prototype.valueOf);
    if (s)
      var p = a(Symbol.prototype.valueOf);
    function v(ie, Be) {
      if (typeof ie != "object")
        return !1;
      try {
        return Be(ie), !0;
      } catch {
        return !1;
      }
    }
    e.isArgumentsObject = t, e.isGeneratorFunction = i, e.isTypedArray = n;
    function y(ie) {
      return typeof Promise < "u" && ie instanceof Promise || ie !== null && typeof ie == "object" && typeof ie.then == "function" && typeof ie.catch == "function";
    }
    e.isPromise = y;
    function w(ie) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ie) : n(ie) || k(ie);
    }
    e.isArrayBufferView = w;
    function x(ie) {
      return r(ie) === "Uint8Array";
    }
    e.isUint8Array = x;
    function A(ie) {
      return r(ie) === "Uint8ClampedArray";
    }
    e.isUint8ClampedArray = A;
    function R(ie) {
      return r(ie) === "Uint16Array";
    }
    e.isUint16Array = R;
    function M(ie) {
      return r(ie) === "Uint32Array";
    }
    e.isUint32Array = M;
    function D(ie) {
      return r(ie) === "Int8Array";
    }
    e.isInt8Array = D;
    function U(ie) {
      return r(ie) === "Int16Array";
    }
    e.isInt16Array = U;
    function z(ie) {
      return r(ie) === "Int32Array";
    }
    e.isInt32Array = z;
    function W(ie) {
      return r(ie) === "Float32Array";
    }
    e.isFloat32Array = W;
    function G(ie) {
      return r(ie) === "Float64Array";
    }
    e.isFloat64Array = G;
    function re(ie) {
      return r(ie) === "BigInt64Array";
    }
    e.isBigInt64Array = re;
    function V(ie) {
      return r(ie) === "BigUint64Array";
    }
    e.isBigUint64Array = V;
    function m(ie) {
      return c(ie) === "[object Map]";
    }
    m.working = typeof Map < "u" && m(/* @__PURE__ */ new Map());
    function g(ie) {
      return typeof Map > "u" ? !1 : m.working ? m(ie) : ie instanceof Map;
    }
    e.isMap = g;
    function d(ie) {
      return c(ie) === "[object Set]";
    }
    d.working = typeof Set < "u" && d(/* @__PURE__ */ new Set());
    function b(ie) {
      return typeof Set > "u" ? !1 : d.working ? d(ie) : ie instanceof Set;
    }
    e.isSet = b;
    function C(ie) {
      return c(ie) === "[object WeakMap]";
    }
    C.working = typeof WeakMap < "u" && C(/* @__PURE__ */ new WeakMap());
    function E(ie) {
      return typeof WeakMap > "u" ? !1 : C.working ? C(ie) : ie instanceof WeakMap;
    }
    e.isWeakMap = E;
    function B(ie) {
      return c(ie) === "[object WeakSet]";
    }
    B.working = typeof WeakSet < "u" && B(/* @__PURE__ */ new WeakSet());
    function T(ie) {
      return B(ie);
    }
    e.isWeakSet = T;
    function _(ie) {
      return c(ie) === "[object ArrayBuffer]";
    }
    _.working = typeof ArrayBuffer < "u" && _(new ArrayBuffer());
    function I(ie) {
      return typeof ArrayBuffer > "u" ? !1 : _.working ? _(ie) : ie instanceof ArrayBuffer;
    }
    e.isArrayBuffer = I;
    function S(ie) {
      return c(ie) === "[object DataView]";
    }
    S.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && S(new DataView(new ArrayBuffer(1), 0, 1));
    function k(ie) {
      return typeof DataView > "u" ? !1 : S.working ? S(ie) : ie instanceof DataView;
    }
    e.isDataView = k;
    var $ = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function ee(ie) {
      return c(ie) === "[object SharedArrayBuffer]";
    }
    function H(ie) {
      return typeof $ > "u" ? !1 : (typeof ee.working > "u" && (ee.working = ee(new $())), ee.working ? ee(ie) : ie instanceof $);
    }
    e.isSharedArrayBuffer = H;
    function N(ie) {
      return c(ie) === "[object AsyncFunction]";
    }
    e.isAsyncFunction = N;
    function L(ie) {
      return c(ie) === "[object Map Iterator]";
    }
    e.isMapIterator = L;
    function j(ie) {
      return c(ie) === "[object Set Iterator]";
    }
    e.isSetIterator = j;
    function Y(ie) {
      return c(ie) === "[object Generator]";
    }
    e.isGeneratorObject = Y;
    function F(ie) {
      return c(ie) === "[object WebAssembly.Module]";
    }
    e.isWebAssemblyCompiledModule = F;
    function P(ie) {
      return v(ie, u);
    }
    e.isNumberObject = P;
    function Z(ie) {
      return v(ie, o);
    }
    e.isStringObject = Z;
    function ae(ie) {
      return v(ie, l);
    }
    e.isBooleanObject = ae;
    function se(ie) {
      return f && v(ie, h);
    }
    e.isBigIntObject = se;
    function le(ie) {
      return s && v(ie, p);
    }
    e.isSymbolObject = le;
    function be(ie) {
      return P(ie) || Z(ie) || ae(ie) || se(ie) || le(ie);
    }
    e.isBoxedPrimitive = be;
    function me(ie) {
      return typeof Uint8Array < "u" && (I(ie) || H(ie));
    }
    e.isAnyArrayBuffer = me, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ie) {
      Object.defineProperty(e, ie, {
        enumerable: !1,
        value: function() {
          throw new Error(ie + " is not supported in userland");
        }
      });
    });
  }(rn)), rn;
}
var tf, ku;
function k1() {
  return ku || (ku = 1, tf = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), tf;
}
var Du;
function Fa() {
  return Du || (Du = 1, function(e) {
    var t = Object.getOwnPropertyDescriptors || function(k) {
      for (var $ = Object.keys(k), ee = {}, H = 0; H < $.length; H++)
        ee[$[H]] = Object.getOwnPropertyDescriptor(k, $[H]);
      return ee;
    }, i = /%[sdj%]/g;
    e.format = function(S) {
      if (!D(S)) {
        for (var k = [], $ = 0; $ < arguments.length; $++)
          k.push(f(arguments[$]));
        return k.join(" ");
      }
      for (var $ = 1, ee = arguments, H = ee.length, N = String(S).replace(i, function(j) {
        if (j === "%%")
          return "%";
        if ($ >= H)
          return j;
        switch (j) {
          case "%s":
            return String(ee[$++]);
          case "%d":
            return Number(ee[$++]);
          case "%j":
            try {
              return JSON.stringify(ee[$++]);
            } catch {
              return "[Circular]";
            }
          default:
            return j;
        }
      }), L = ee[$]; $ < H; L = ee[++$])
        A(L) || !G(L) ? N += " " + L : N += " " + f(L);
      return N;
    }, e.deprecate = function(S, k) {
      if (typeof fe.process < "u" && fe.process.noDeprecation === !0)
        return S;
      if (typeof fe.process > "u")
        return function() {
          return e.deprecate(S, k).apply(this, arguments);
        };
      var $ = !1;
      function ee() {
        if (!$) {
          if (fe.process.throwDeprecation)
            throw new Error(k);
          fe.process.traceDeprecation ? console.trace(k) : console.error(k), $ = !0;
        }
        return S.apply(this, arguments);
      }
      return ee;
    };
    var r = {}, n = /^$/;
    if (fe.process.env.NODE_DEBUG) {
      var a = fe.process.env.NODE_DEBUG;
      a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), n = new RegExp("^" + a + "$", "i");
    }
    e.debuglog = function(S) {
      if (S = S.toUpperCase(), !r[S])
        if (n.test(S)) {
          var k = fe.process.pid;
          r[S] = function() {
            var $ = e.format.apply(e, arguments);
            console.error("%s %d: %s", S, k, $);
          };
        } else
          r[S] = function() {
          };
      return r[S];
    };
    function f(S, k) {
      var $ = {
        seen: [],
        stylize: c
      };
      return arguments.length >= 3 && ($.depth = arguments[2]), arguments.length >= 4 && ($.colors = arguments[3]), x(k) ? $.showHidden = k : k && e._extend($, k), z($.showHidden) && ($.showHidden = !1), z($.depth) && ($.depth = 2), z($.colors) && ($.colors = !1), z($.customInspect) && ($.customInspect = !0), $.colors && ($.stylize = s), o($, S, $.depth);
    }
    e.inspect = f, f.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, f.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function s(S, k) {
      var $ = f.styles[k];
      return $ ? "\x1B[" + f.colors[$][0] + "m" + S + "\x1B[" + f.colors[$][1] + "m" : S;
    }
    function c(S, k) {
      return S;
    }
    function u(S) {
      var k = {};
      return S.forEach(function($, ee) {
        k[$] = !0;
      }), k;
    }
    function o(S, k, $) {
      if (S.customInspect && k && m(k.inspect) && // Filter out the util module, it's inspect function is special
      k.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
      !(k.constructor && k.constructor.prototype === k)) {
        var ee = k.inspect($, S);
        return D(ee) || (ee = o(S, ee, $)), ee;
      }
      var H = l(S, k);
      if (H)
        return H;
      var N = Object.keys(k), L = u(N);
      if (S.showHidden && (N = Object.getOwnPropertyNames(k)), V(k) && (N.indexOf("message") >= 0 || N.indexOf("description") >= 0))
        return h(k);
      if (N.length === 0) {
        if (m(k)) {
          var j = k.name ? ": " + k.name : "";
          return S.stylize("[Function" + j + "]", "special");
        }
        if (W(k))
          return S.stylize(RegExp.prototype.toString.call(k), "regexp");
        if (re(k))
          return S.stylize(Date.prototype.toString.call(k), "date");
        if (V(k))
          return h(k);
      }
      var Y = "", F = !1, P = ["{", "}"];
      if (w(k) && (F = !0, P = ["[", "]"]), m(k)) {
        var Z = k.name ? ": " + k.name : "";
        Y = " [Function" + Z + "]";
      }
      if (W(k) && (Y = " " + RegExp.prototype.toString.call(k)), re(k) && (Y = " " + Date.prototype.toUTCString.call(k)), V(k) && (Y = " " + h(k)), N.length === 0 && (!F || k.length == 0))
        return P[0] + Y + P[1];
      if ($ < 0)
        return W(k) ? S.stylize(RegExp.prototype.toString.call(k), "regexp") : S.stylize("[Object]", "special");
      S.seen.push(k);
      var ae;
      return F ? ae = p(S, k, $, L, N) : ae = N.map(function(se) {
        return v(S, k, $, L, se, F);
      }), S.seen.pop(), y(ae, Y, P);
    }
    function l(S, k) {
      if (z(k))
        return S.stylize("undefined", "undefined");
      if (D(k)) {
        var $ = "'" + JSON.stringify(k).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return S.stylize($, "string");
      }
      if (M(k))
        return S.stylize("" + k, "number");
      if (x(k))
        return S.stylize("" + k, "boolean");
      if (A(k))
        return S.stylize("null", "null");
    }
    function h(S) {
      return "[" + Error.prototype.toString.call(S) + "]";
    }
    function p(S, k, $, ee, H) {
      for (var N = [], L = 0, j = k.length; L < j; ++L)
        B(k, String(L)) ? N.push(v(
          S,
          k,
          $,
          ee,
          String(L),
          !0
        )) : N.push("");
      return H.forEach(function(Y) {
        Y.match(/^\d+$/) || N.push(v(
          S,
          k,
          $,
          ee,
          Y,
          !0
        ));
      }), N;
    }
    function v(S, k, $, ee, H, N) {
      var L, j, Y;
      if (Y = Object.getOwnPropertyDescriptor(k, H) || { value: k[H] }, Y.get ? Y.set ? j = S.stylize("[Getter/Setter]", "special") : j = S.stylize("[Getter]", "special") : Y.set && (j = S.stylize("[Setter]", "special")), B(ee, H) || (L = "[" + H + "]"), j || (S.seen.indexOf(Y.value) < 0 ? (A($) ? j = o(S, Y.value, null) : j = o(S, Y.value, $ - 1), j.indexOf(`
`) > -1 && (N ? j = j.split(`
`).map(function(F) {
        return "  " + F;
      }).join(`
`).slice(2) : j = `
` + j.split(`
`).map(function(F) {
        return "   " + F;
      }).join(`
`))) : j = S.stylize("[Circular]", "special")), z(L)) {
        if (N && H.match(/^\d+$/))
          return j;
        L = JSON.stringify("" + H), L.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (L = L.slice(1, -1), L = S.stylize(L, "name")) : (L = L.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), L = S.stylize(L, "string"));
      }
      return L + ": " + j;
    }
    function y(S, k, $) {
      var ee = S.reduce(function(H, N) {
        return N.indexOf(`
`) >= 0, H + N.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return ee > 60 ? $[0] + (k === "" ? "" : k + `
 `) + " " + S.join(`,
  `) + " " + $[1] : $[0] + k + " " + S.join(", ") + " " + $[1];
    }
    e.types = N1();
    function w(S) {
      return Array.isArray(S);
    }
    e.isArray = w;
    function x(S) {
      return typeof S == "boolean";
    }
    e.isBoolean = x;
    function A(S) {
      return S === null;
    }
    e.isNull = A;
    function R(S) {
      return S == null;
    }
    e.isNullOrUndefined = R;
    function M(S) {
      return typeof S == "number";
    }
    e.isNumber = M;
    function D(S) {
      return typeof S == "string";
    }
    e.isString = D;
    function U(S) {
      return typeof S == "symbol";
    }
    e.isSymbol = U;
    function z(S) {
      return S === void 0;
    }
    e.isUndefined = z;
    function W(S) {
      return G(S) && d(S) === "[object RegExp]";
    }
    e.isRegExp = W, e.types.isRegExp = W;
    function G(S) {
      return typeof S == "object" && S !== null;
    }
    e.isObject = G;
    function re(S) {
      return G(S) && d(S) === "[object Date]";
    }
    e.isDate = re, e.types.isDate = re;
    function V(S) {
      return G(S) && (d(S) === "[object Error]" || S instanceof Error);
    }
    e.isError = V, e.types.isNativeError = V;
    function m(S) {
      return typeof S == "function";
    }
    e.isFunction = m;
    function g(S) {
      return S === null || typeof S == "boolean" || typeof S == "number" || typeof S == "string" || typeof S == "symbol" || // ES6 symbol
      typeof S > "u";
    }
    e.isPrimitive = g, e.isBuffer = k1();
    function d(S) {
      return Object.prototype.toString.call(S);
    }
    function b(S) {
      return S < 10 ? "0" + S.toString(10) : S.toString(10);
    }
    var C = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function E() {
      var S = /* @__PURE__ */ new Date(), k = [
        b(S.getHours()),
        b(S.getMinutes()),
        b(S.getSeconds())
      ].join(":");
      return [S.getDate(), C[S.getMonth()], k].join(" ");
    }
    e.log = function() {
      console.log("%s - %s", E(), e.format.apply(e, arguments));
    }, e.inherits = Ae(), e._extend = function(S, k) {
      if (!k || !G(k))
        return S;
      for (var $ = Object.keys(k), ee = $.length; ee--; )
        S[$[ee]] = k[$[ee]];
      return S;
    };
    function B(S, k) {
      return Object.prototype.hasOwnProperty.call(S, k);
    }
    var T = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    e.promisify = function(k) {
      if (typeof k != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (T && k[T]) {
        var $ = k[T];
        if (typeof $ != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty($, T, {
          value: $,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), $;
      }
      function $() {
        for (var ee, H, N = new Promise(function(Y, F) {
          ee = Y, H = F;
        }), L = [], j = 0; j < arguments.length; j++)
          L.push(arguments[j]);
        L.push(function(Y, F) {
          Y ? H(Y) : ee(F);
        });
        try {
          k.apply(this, L);
        } catch (Y) {
          H(Y);
        }
        return N;
      }
      return Object.setPrototypeOf($, Object.getPrototypeOf(k)), T && Object.defineProperty($, T, {
        value: $,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        $,
        t(k)
      );
    }, e.promisify.custom = T;
    function _(S, k) {
      if (!S) {
        var $ = new Error("Promise was rejected with a falsy value");
        $.reason = S, S = $;
      }
      return k(S);
    }
    function I(S) {
      if (typeof S != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function k() {
        for (var $ = [], ee = 0; ee < arguments.length; ee++)
          $.push(arguments[ee]);
        var H = $.pop();
        if (typeof H != "function")
          throw new TypeError("The last argument must be of type Function");
        var N = this, L = function() {
          return H.apply(N, arguments);
        };
        S.apply(this, $).then(
          function(j) {
            fe.process.nextTick(L.bind(null, null, j));
          },
          function(j) {
            fe.process.nextTick(_.bind(null, j, L));
          }
        );
      }
      return Object.setPrototypeOf(k, Object.getPrototypeOf(S)), Object.defineProperties(
        k,
        t(S)
      ), k;
    }
    e.callbackify = I;
  }(tn)), tn;
}
var rf, Lu;
function D1() {
  if (Lu)
    return rf;
  Lu = 1;
  function e(v, y) {
    var w = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(v);
      y && (x = x.filter(function(A) {
        return Object.getOwnPropertyDescriptor(v, A).enumerable;
      })), w.push.apply(w, x);
    }
    return w;
  }
  function t(v) {
    for (var y = 1; y < arguments.length; y++) {
      var w = arguments[y] != null ? arguments[y] : {};
      y % 2 ? e(Object(w), !0).forEach(function(x) {
        i(v, x, w[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(w)) : e(Object(w)).forEach(function(x) {
        Object.defineProperty(v, x, Object.getOwnPropertyDescriptor(w, x));
      });
    }
    return v;
  }
  function i(v, y, w) {
    return y = f(y), y in v ? Object.defineProperty(v, y, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : v[y] = w, v;
  }
  function r(v, y) {
    if (!(v instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(v, y) {
    for (var w = 0; w < y.length; w++) {
      var x = y[w];
      x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(v, f(x.key), x);
    }
  }
  function a(v, y, w) {
    return y && n(v.prototype, y), Object.defineProperty(v, "prototype", { writable: !1 }), v;
  }
  function f(v) {
    var y = s(v, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function s(v, y) {
    if (typeof v != "object" || v === null)
      return v;
    var w = v[Symbol.toPrimitive];
    if (w !== void 0) {
      var x = w.call(v, y);
      if (typeof x != "object")
        return x;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(v);
  }
  var c = or, u = c.Buffer, o = Fa(), l = o.inspect, h = l && l.custom || "inspect";
  function p(v, y, w) {
    u.prototype.copy.call(v, y, w);
  }
  return rf = /* @__PURE__ */ function() {
    function v() {
      r(this, v), this.head = null, this.tail = null, this.length = 0;
    }
    return a(v, [{
      key: "push",
      value: function(w) {
        var x = {
          data: w,
          next: null
        };
        this.length > 0 ? this.tail.next = x : this.head = x, this.tail = x, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(w) {
        var x = {
          data: w,
          next: this.head
        };
        this.length === 0 && (this.tail = x), this.head = x, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var w = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, w;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(w) {
        if (this.length === 0)
          return "";
        for (var x = this.head, A = "" + x.data; x = x.next; )
          A += w + x.data;
        return A;
      }
    }, {
      key: "concat",
      value: function(w) {
        if (this.length === 0)
          return u.alloc(0);
        for (var x = u.allocUnsafe(w >>> 0), A = this.head, R = 0; A; )
          p(A.data, x, R), R += A.data.length, A = A.next;
        return x;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(w, x) {
        var A;
        return w < this.head.data.length ? (A = this.head.data.slice(0, w), this.head.data = this.head.data.slice(w)) : w === this.head.data.length ? A = this.shift() : A = x ? this._getString(w) : this._getBuffer(w), A;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(w) {
        var x = this.head, A = 1, R = x.data;
        for (w -= R.length; x = x.next; ) {
          var M = x.data, D = w > M.length ? M.length : w;
          if (D === M.length ? R += M : R += M.slice(0, w), w -= D, w === 0) {
            D === M.length ? (++A, x.next ? this.head = x.next : this.head = this.tail = null) : (this.head = x, x.data = M.slice(D));
            break;
          }
          ++A;
        }
        return this.length -= A, R;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(w) {
        var x = u.allocUnsafe(w), A = this.head, R = 1;
        for (A.data.copy(x), w -= A.data.length; A = A.next; ) {
          var M = A.data, D = w > M.length ? M.length : w;
          if (M.copy(x, x.length - w, 0, D), w -= D, w === 0) {
            D === M.length ? (++R, A.next ? this.head = A.next : this.head = this.tail = null) : (this.head = A, A.data = M.slice(D));
            break;
          }
          ++R;
        }
        return this.length -= R, x;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: h,
      value: function(w, x) {
        return l(this, t(t({}, x), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), v;
  }(), rf;
}
var af, Pu;
function fd() {
  if (Pu)
    return af;
  Pu = 1;
  function e(f, s) {
    var c = this, u = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
    return u || o ? (s ? s(f) : f && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, fe.process.nextTick(n, this, f)) : fe.process.nextTick(n, this, f)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(f || null, function(l) {
      !s && l ? c._writableState ? c._writableState.errorEmitted ? fe.process.nextTick(i, c) : (c._writableState.errorEmitted = !0, fe.process.nextTick(t, c, l)) : fe.process.nextTick(t, c, l) : s ? (fe.process.nextTick(i, c), s(l)) : fe.process.nextTick(i, c);
    }), this);
  }
  function t(f, s) {
    n(f, s), i(f);
  }
  function i(f) {
    f._writableState && !f._writableState.emitClose || f._readableState && !f._readableState.emitClose || f.emit("close");
  }
  function r() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function n(f, s) {
    f.emit("error", s);
  }
  function a(f, s) {
    var c = f._readableState, u = f._writableState;
    c && c.autoDestroy || u && u.autoDestroy ? f.destroy(s) : f.emit("error", s);
  }
  return af = {
    destroy: e,
    undestroy: r,
    errorOrDestroy: a
  }, af;
}
var nf = {}, Uu;
function Ai() {
  if (Uu)
    return nf;
  Uu = 1;
  function e(s, c) {
    s.prototype = Object.create(c.prototype), s.prototype.constructor = s, s.__proto__ = c;
  }
  var t = {};
  function i(s, c, u) {
    u || (u = Error);
    function o(h, p, v) {
      return typeof c == "string" ? c : c(h, p, v);
    }
    var l = /* @__PURE__ */ function(h) {
      e(p, h);
      function p(v, y, w) {
        return h.call(this, o(v, y, w)) || this;
      }
      return p;
    }(u);
    l.prototype.name = u.name, l.prototype.code = s, t[s] = l;
  }
  function r(s, c) {
    if (Array.isArray(s)) {
      var u = s.length;
      return s = s.map(function(o) {
        return String(o);
      }), u > 2 ? "one of ".concat(c, " ").concat(s.slice(0, u - 1).join(", "), ", or ") + s[u - 1] : u === 2 ? "one of ".concat(c, " ").concat(s[0], " or ").concat(s[1]) : "of ".concat(c, " ").concat(s[0]);
    } else
      return "of ".concat(c, " ").concat(String(s));
  }
  function n(s, c, u) {
    return s.substr(0, c.length) === c;
  }
  function a(s, c, u) {
    return (u === void 0 || u > s.length) && (u = s.length), s.substring(u - c.length, u) === c;
  }
  function f(s, c, u) {
    return typeof u != "number" && (u = 0), u + c.length > s.length ? !1 : s.indexOf(c, u) !== -1;
  }
  return i("ERR_INVALID_OPT_VALUE", function(s, c) {
    return 'The value "' + c + '" is invalid for option "' + s + '"';
  }, TypeError), i("ERR_INVALID_ARG_TYPE", function(s, c, u) {
    var o;
    typeof c == "string" && n(c, "not ") ? (o = "must not be", c = c.replace(/^not /, "")) : o = "must be";
    var l;
    if (a(s, " argument"))
      l = "The ".concat(s, " ").concat(o, " ").concat(r(c, "type"));
    else {
      var h = f(s, ".") ? "property" : "argument";
      l = 'The "'.concat(s, '" ').concat(h, " ").concat(o, " ").concat(r(c, "type"));
    }
    return l += ". Received type ".concat(typeof u), l;
  }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(s) {
    return "The " + s + " method is not implemented";
  }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(s) {
    return "Cannot call " + s + " after a stream was destroyed";
  }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(s) {
    return "Unknown encoding: " + s;
  }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), nf.codes = t, nf;
}
var ff, Ou;
function sd() {
  if (Ou)
    return ff;
  Ou = 1;
  var e = Ai().codes.ERR_INVALID_OPT_VALUE;
  function t(r, n, a) {
    return r.highWaterMark != null ? r.highWaterMark : n ? r[a] : null;
  }
  function i(r, n, a, f) {
    var s = t(n, f, a);
    if (s != null) {
      if (!(isFinite(s) && Math.floor(s) === s) || s < 0) {
        var c = f ? a : "highWaterMark";
        throw new e(c, s);
      }
      return Math.floor(s);
    }
    return r.objectMode ? 16 : 16 * 1024;
  }
  return ff = {
    getHighWaterMark: i
  }, ff;
}
var sf, qu;
function od() {
  if (qu)
    return sf;
  qu = 1, sf = e;
  function e(i, r) {
    if (t("noDeprecation"))
      return i;
    var n = !1;
    function a() {
      if (!n) {
        if (t("throwDeprecation"))
          throw new Error(r);
        t("traceDeprecation") ? console.trace(r) : console.warn(r), n = !0;
      }
      return i.apply(this, arguments);
    }
    return a;
  }
  function t(i) {
    try {
      if (!Ge.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var r = Ge.localStorage[i];
    return r == null ? !1 : String(r).toLowerCase() === "true";
  }
  return sf;
}
var of, Fu;
function ud() {
  if (Fu)
    return of;
  Fu = 1, of = W;
  function e(H) {
    var N = this;
    this.next = null, this.entry = null, this.finish = function() {
      ee(N, H);
    };
  }
  var t;
  W.WritableState = U;
  var i = {
    deprecate: od()
  }, r = Yh(), n = or.Buffer, a = (typeof Ge < "u" ? Ge : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function f(H) {
    return n.from(H);
  }
  function s(H) {
    return n.isBuffer(H) || H instanceof a;
  }
  var c = fd(), u = sd(), o = u.getHighWaterMark, l = Ai().codes, h = l.ERR_INVALID_ARG_TYPE, p = l.ERR_METHOD_NOT_IMPLEMENTED, v = l.ERR_MULTIPLE_CALLBACK, y = l.ERR_STREAM_CANNOT_PIPE, w = l.ERR_STREAM_DESTROYED, x = l.ERR_STREAM_NULL_VALUES, A = l.ERR_STREAM_WRITE_AFTER_END, R = l.ERR_UNKNOWN_ENCODING, M = c.errorOrDestroy;
  Ae()(W, r);
  function D() {
  }
  function U(H, N, L) {
    t = t || bi(), H = H || {}, typeof L != "boolean" && (L = N instanceof t), this.objectMode = !!H.objectMode, L && (this.objectMode = this.objectMode || !!H.writableObjectMode), this.highWaterMark = o(this, H, "writableHighWaterMark", L), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var j = H.decodeStrings === !1;
    this.decodeStrings = !j, this.defaultEncoding = H.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Y) {
      C(N, Y);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = H.emitClose !== !1, this.autoDestroy = !!H.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  U.prototype.getBuffer = function() {
    for (var N = this.bufferedRequest, L = []; N; )
      L.push(N), N = N.next;
    return L;
  }, function() {
    try {
      Object.defineProperty(U.prototype, "buffer", {
        get: i.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var z;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (z = Function.prototype[Symbol.hasInstance], Object.defineProperty(W, Symbol.hasInstance, {
    value: function(N) {
      return z.call(this, N) ? !0 : this !== W ? !1 : N && N._writableState instanceof U;
    }
  })) : z = function(N) {
    return N instanceof this;
  };
  function W(H) {
    t = t || bi();
    var N = this instanceof t;
    if (!N && !z.call(W, this))
      return new W(H);
    this._writableState = new U(H, this, N), this.writable = !0, H && (typeof H.write == "function" && (this._write = H.write), typeof H.writev == "function" && (this._writev = H.writev), typeof H.destroy == "function" && (this._destroy = H.destroy), typeof H.final == "function" && (this._final = H.final)), r.call(this);
  }
  W.prototype.pipe = function() {
    M(this, new y());
  };
  function G(H, N) {
    var L = new A();
    M(H, L), fe.process.nextTick(N, L);
  }
  function re(H, N, L, j) {
    var Y;
    return L === null ? Y = new x() : typeof L != "string" && !N.objectMode && (Y = new h("chunk", ["string", "Buffer"], L)), Y ? (M(H, Y), fe.process.nextTick(j, Y), !1) : !0;
  }
  W.prototype.write = function(H, N, L) {
    var j = this._writableState, Y = !1, F = !j.objectMode && s(H);
    return F && !n.isBuffer(H) && (H = f(H)), typeof N == "function" && (L = N, N = null), F ? N = "buffer" : N || (N = j.defaultEncoding), typeof L != "function" && (L = D), j.ending ? G(this, L) : (F || re(this, j, H, L)) && (j.pendingcb++, Y = m(this, j, F, H, N, L)), Y;
  }, W.prototype.cork = function() {
    this._writableState.corked++;
  }, W.prototype.uncork = function() {
    var H = this._writableState;
    H.corked && (H.corked--, !H.writing && !H.corked && !H.bufferProcessing && H.bufferedRequest && T(this, H));
  }, W.prototype.setDefaultEncoding = function(N) {
    if (typeof N == "string" && (N = N.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((N + "").toLowerCase()) > -1))
      throw new R(N);
    return this._writableState.defaultEncoding = N, this;
  }, Object.defineProperty(W.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function V(H, N, L) {
    return !H.objectMode && H.decodeStrings !== !1 && typeof N == "string" && (N = n.from(N, L)), N;
  }
  Object.defineProperty(W.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function m(H, N, L, j, Y, F) {
    if (!L) {
      var P = V(N, j, Y);
      j !== P && (L = !0, Y = "buffer", j = P);
    }
    var Z = N.objectMode ? 1 : j.length;
    N.length += Z;
    var ae = N.length < N.highWaterMark;
    if (ae || (N.needDrain = !0), N.writing || N.corked) {
      var se = N.lastBufferedRequest;
      N.lastBufferedRequest = {
        chunk: j,
        encoding: Y,
        isBuf: L,
        callback: F,
        next: null
      }, se ? se.next = N.lastBufferedRequest : N.bufferedRequest = N.lastBufferedRequest, N.bufferedRequestCount += 1;
    } else
      g(H, N, !1, Z, j, Y, F);
    return ae;
  }
  function g(H, N, L, j, Y, F, P) {
    N.writelen = j, N.writecb = P, N.writing = !0, N.sync = !0, N.destroyed ? N.onwrite(new w("write")) : L ? H._writev(Y, N.onwrite) : H._write(Y, F, N.onwrite), N.sync = !1;
  }
  function d(H, N, L, j, Y) {
    --N.pendingcb, L ? (fe.process.nextTick(Y, j), fe.process.nextTick(k, H, N), H._writableState.errorEmitted = !0, M(H, j)) : (Y(j), H._writableState.errorEmitted = !0, M(H, j), k(H, N));
  }
  function b(H) {
    H.writing = !1, H.writecb = null, H.length -= H.writelen, H.writelen = 0;
  }
  function C(H, N) {
    var L = H._writableState, j = L.sync, Y = L.writecb;
    if (typeof Y != "function")
      throw new v();
    if (b(L), N)
      d(H, L, j, N, Y);
    else {
      var F = _(L) || H.destroyed;
      !F && !L.corked && !L.bufferProcessing && L.bufferedRequest && T(H, L), j ? fe.process.nextTick(E, H, L, F, Y) : E(H, L, F, Y);
    }
  }
  function E(H, N, L, j) {
    L || B(H, N), N.pendingcb--, j(), k(H, N);
  }
  function B(H, N) {
    N.length === 0 && N.needDrain && (N.needDrain = !1, H.emit("drain"));
  }
  function T(H, N) {
    N.bufferProcessing = !0;
    var L = N.bufferedRequest;
    if (H._writev && L && L.next) {
      var j = N.bufferedRequestCount, Y = new Array(j), F = N.corkedRequestsFree;
      F.entry = L;
      for (var P = 0, Z = !0; L; )
        Y[P] = L, L.isBuf || (Z = !1), L = L.next, P += 1;
      Y.allBuffers = Z, g(H, N, !0, N.length, Y, "", F.finish), N.pendingcb++, N.lastBufferedRequest = null, F.next ? (N.corkedRequestsFree = F.next, F.next = null) : N.corkedRequestsFree = new e(N), N.bufferedRequestCount = 0;
    } else {
      for (; L; ) {
        var ae = L.chunk, se = L.encoding, le = L.callback, be = N.objectMode ? 1 : ae.length;
        if (g(H, N, !1, be, ae, se, le), L = L.next, N.bufferedRequestCount--, N.writing)
          break;
      }
      L === null && (N.lastBufferedRequest = null);
    }
    N.bufferedRequest = L, N.bufferProcessing = !1;
  }
  W.prototype._write = function(H, N, L) {
    L(new p("_write()"));
  }, W.prototype._writev = null, W.prototype.end = function(H, N, L) {
    var j = this._writableState;
    return typeof H == "function" ? (L = H, H = null, N = null) : typeof N == "function" && (L = N, N = null), H != null && this.write(H, N), j.corked && (j.corked = 1, this.uncork()), j.ending || $(this, j, L), this;
  }, Object.defineProperty(W.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function _(H) {
    return H.ending && H.length === 0 && H.bufferedRequest === null && !H.finished && !H.writing;
  }
  function I(H, N) {
    H._final(function(L) {
      N.pendingcb--, L && M(H, L), N.prefinished = !0, H.emit("prefinish"), k(H, N);
    });
  }
  function S(H, N) {
    !N.prefinished && !N.finalCalled && (typeof H._final == "function" && !N.destroyed ? (N.pendingcb++, N.finalCalled = !0, fe.process.nextTick(I, H, N)) : (N.prefinished = !0, H.emit("prefinish")));
  }
  function k(H, N) {
    var L = _(N);
    if (L && (S(H, N), N.pendingcb === 0 && (N.finished = !0, H.emit("finish"), N.autoDestroy))) {
      var j = H._readableState;
      (!j || j.autoDestroy && j.endEmitted) && H.destroy();
    }
    return L;
  }
  function $(H, N, L) {
    N.ending = !0, k(H, N), L && (N.finished ? fe.process.nextTick(L) : H.once("finish", L)), N.ended = !0, H.writable = !1;
  }
  function ee(H, N, L) {
    var j = H.entry;
    for (H.entry = null; j; ) {
      var Y = j.callback;
      N.pendingcb--, Y(L), j = j.next;
    }
    N.corkedRequestsFree.next = H;
  }
  return Object.defineProperty(W.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(N) {
      this._writableState && (this._writableState.destroyed = N);
    }
  }), W.prototype.destroy = c.destroy, W.prototype._undestroy = c.undestroy, W.prototype._destroy = function(H, N) {
    N(H);
  }, of;
}
var uf, Vu;
function bi() {
  if (Vu)
    return uf;
  Vu = 1;
  var e = Object.keys || function(u) {
    var o = [];
    for (var l in u)
      o.push(l);
    return o;
  };
  uf = f;
  var t = cd(), i = ud();
  Ae()(f, t);
  for (var r = e(i.prototype), n = 0; n < r.length; n++) {
    var a = r[n];
    f.prototype[a] || (f.prototype[a] = i.prototype[a]);
  }
  function f(u) {
    if (!(this instanceof f))
      return new f(u);
    t.call(this, u), i.call(this, u), this.allowHalfOpen = !0, u && (u.readable === !1 && (this.readable = !1), u.writable === !1 && (this.writable = !1), u.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", s)));
  }
  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(f.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function s() {
    this._writableState.ended || fe.process.nextTick(c, this);
  }
  function c(u) {
    u.end();
  }
  return Object.defineProperty(f.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(o) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = o, this._writableState.destroyed = o);
    }
  }), uf;
}
var cf = {}, Ku;
function Fi() {
  if (Ku)
    return cf;
  Ku = 1;
  var e = He().Buffer, t = e.isEncoding || function(x) {
    switch (x = "" + x, x && x.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function i(x) {
    if (!x)
      return "utf8";
    for (var A; ; )
      switch (x) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return x;
        default:
          if (A)
            return;
          x = ("" + x).toLowerCase(), A = !0;
      }
  }
  function r(x) {
    var A = i(x);
    if (typeof A != "string" && (e.isEncoding === t || !t(x)))
      throw new Error("Unknown encoding: " + x);
    return A || x;
  }
  cf.StringDecoder = n;
  function n(x) {
    this.encoding = r(x);
    var A;
    switch (this.encoding) {
      case "utf16le":
        this.text = l, this.end = h, A = 4;
        break;
      case "utf8":
        this.fillLast = c, A = 4;
        break;
      case "base64":
        this.text = p, this.end = v, A = 3;
        break;
      default:
        this.write = y, this.end = w;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(A);
  }
  n.prototype.write = function(x) {
    if (x.length === 0)
      return "";
    var A, R;
    if (this.lastNeed) {
      if (A = this.fillLast(x), A === void 0)
        return "";
      R = this.lastNeed, this.lastNeed = 0;
    } else
      R = 0;
    return R < x.length ? A ? A + this.text(x, R) : this.text(x, R) : A || "";
  }, n.prototype.end = o, n.prototype.text = u, n.prototype.fillLast = function(x) {
    if (this.lastNeed <= x.length)
      return x.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    x.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, x.length), this.lastNeed -= x.length;
  };
  function a(x) {
    return x <= 127 ? 0 : x >> 5 === 6 ? 2 : x >> 4 === 14 ? 3 : x >> 3 === 30 ? 4 : x >> 6 === 2 ? -1 : -2;
  }
  function f(x, A, R) {
    var M = A.length - 1;
    if (M < R)
      return 0;
    var D = a(A[M]);
    return D >= 0 ? (D > 0 && (x.lastNeed = D - 1), D) : --M < R || D === -2 ? 0 : (D = a(A[M]), D >= 0 ? (D > 0 && (x.lastNeed = D - 2), D) : --M < R || D === -2 ? 0 : (D = a(A[M]), D >= 0 ? (D > 0 && (D === 2 ? D = 0 : x.lastNeed = D - 3), D) : 0));
  }
  function s(x, A, R) {
    if ((A[0] & 192) !== 128)
      return x.lastNeed = 0, "�";
    if (x.lastNeed > 1 && A.length > 1) {
      if ((A[1] & 192) !== 128)
        return x.lastNeed = 1, "�";
      if (x.lastNeed > 2 && A.length > 2 && (A[2] & 192) !== 128)
        return x.lastNeed = 2, "�";
    }
  }
  function c(x) {
    var A = this.lastTotal - this.lastNeed, R = s(this, x);
    if (R !== void 0)
      return R;
    if (this.lastNeed <= x.length)
      return x.copy(this.lastChar, A, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    x.copy(this.lastChar, A, 0, x.length), this.lastNeed -= x.length;
  }
  function u(x, A) {
    var R = f(this, x, A);
    if (!this.lastNeed)
      return x.toString("utf8", A);
    this.lastTotal = R;
    var M = x.length - (R - this.lastNeed);
    return x.copy(this.lastChar, 0, M), x.toString("utf8", A, M);
  }
  function o(x) {
    var A = x && x.length ? this.write(x) : "";
    return this.lastNeed ? A + "�" : A;
  }
  function l(x, A) {
    if ((x.length - A) % 2 === 0) {
      var R = x.toString("utf16le", A);
      if (R) {
        var M = R.charCodeAt(R.length - 1);
        if (M >= 55296 && M <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = x[x.length - 2], this.lastChar[1] = x[x.length - 1], R.slice(0, -1);
      }
      return R;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = x[x.length - 1], x.toString("utf16le", A, x.length - 1);
  }
  function h(x) {
    var A = x && x.length ? this.write(x) : "";
    if (this.lastNeed) {
      var R = this.lastTotal - this.lastNeed;
      return A + this.lastChar.toString("utf16le", 0, R);
    }
    return A;
  }
  function p(x, A) {
    var R = (x.length - A) % 3;
    return R === 0 ? x.toString("base64", A) : (this.lastNeed = 3 - R, this.lastTotal = 3, R === 1 ? this.lastChar[0] = x[x.length - 1] : (this.lastChar[0] = x[x.length - 2], this.lastChar[1] = x[x.length - 1]), x.toString("base64", A, x.length - R));
  }
  function v(x) {
    var A = x && x.length ? this.write(x) : "";
    return this.lastNeed ? A + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : A;
  }
  function y(x) {
    return x.toString(this.encoding);
  }
  function w(x) {
    return x && x.length ? this.write(x) : "";
  }
  return cf;
}
var lf, Hu;
function Zo() {
  if (Hu)
    return lf;
  Hu = 1;
  var e = Ai().codes.ERR_STREAM_PREMATURE_CLOSE;
  function t(a) {
    var f = !1;
    return function() {
      if (!f) {
        f = !0;
        for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
          c[u] = arguments[u];
        a.apply(this, c);
      }
    };
  }
  function i() {
  }
  function r(a) {
    return a.setHeader && typeof a.abort == "function";
  }
  function n(a, f, s) {
    if (typeof f == "function")
      return n(a, null, f);
    f || (f = {}), s = t(s || i);
    var c = f.readable || f.readable !== !1 && a.readable, u = f.writable || f.writable !== !1 && a.writable, o = function() {
      a.writable || h();
    }, l = a._writableState && a._writableState.finished, h = function() {
      u = !1, l = !0, c || s.call(a);
    }, p = a._readableState && a._readableState.endEmitted, v = function() {
      c = !1, p = !0, u || s.call(a);
    }, y = function(R) {
      s.call(a, R);
    }, w = function() {
      var R;
      if (c && !p)
        return (!a._readableState || !a._readableState.ended) && (R = new e()), s.call(a, R);
      if (u && !l)
        return (!a._writableState || !a._writableState.ended) && (R = new e()), s.call(a, R);
    }, x = function() {
      a.req.on("finish", h);
    };
    return r(a) ? (a.on("complete", h), a.on("abort", w), a.req ? x() : a.on("request", x)) : u && !a._writableState && (a.on("end", o), a.on("close", o)), a.on("end", v), a.on("finish", h), f.error !== !1 && a.on("error", y), a.on("close", w), function() {
      a.removeListener("complete", h), a.removeListener("abort", w), a.removeListener("request", x), a.req && a.req.removeListener("finish", h), a.removeListener("end", o), a.removeListener("close", o), a.removeListener("finish", h), a.removeListener("end", v), a.removeListener("error", y), a.removeListener("close", w);
    };
  }
  return lf = n, lf;
}
var hf, ju;
function L1() {
  if (ju)
    return hf;
  ju = 1;
  var e;
  function t(R, M, D) {
    return M = i(M), M in R ? Object.defineProperty(R, M, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : R[M] = D, R;
  }
  function i(R) {
    var M = r(R, "string");
    return typeof M == "symbol" ? M : String(M);
  }
  function r(R, M) {
    if (typeof R != "object" || R === null)
      return R;
    var D = R[Symbol.toPrimitive];
    if (D !== void 0) {
      var U = D.call(R, M);
      if (typeof U != "object")
        return U;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (M === "string" ? String : Number)(R);
  }
  var n = Zo(), a = Symbol("lastResolve"), f = Symbol("lastReject"), s = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), o = Symbol("handlePromise"), l = Symbol("stream");
  function h(R, M) {
    return {
      value: R,
      done: M
    };
  }
  function p(R) {
    var M = R[a];
    if (M !== null) {
      var D = R[l].read();
      D !== null && (R[u] = null, R[a] = null, R[f] = null, M(h(D, !1)));
    }
  }
  function v(R) {
    fe.process.nextTick(p, R);
  }
  function y(R, M) {
    return function(D, U) {
      R.then(function() {
        if (M[c]) {
          D(h(void 0, !0));
          return;
        }
        M[o](D, U);
      }, U);
    };
  }
  var w = Object.getPrototypeOf(function() {
  }), x = Object.setPrototypeOf((e = {
    get stream() {
      return this[l];
    },
    next: function() {
      var M = this, D = this[s];
      if (D !== null)
        return Promise.reject(D);
      if (this[c])
        return Promise.resolve(h(void 0, !0));
      if (this[l].destroyed)
        return new Promise(function(G, re) {
          fe.process.nextTick(function() {
            M[s] ? re(M[s]) : G(h(void 0, !0));
          });
        });
      var U = this[u], z;
      if (U)
        z = new Promise(y(U, this));
      else {
        var W = this[l].read();
        if (W !== null)
          return Promise.resolve(h(W, !1));
        z = new Promise(this[o]);
      }
      return this[u] = z, z;
    }
  }, t(e, Symbol.asyncIterator, function() {
    return this;
  }), t(e, "return", function() {
    var M = this;
    return new Promise(function(D, U) {
      M[l].destroy(null, function(z) {
        if (z) {
          U(z);
          return;
        }
        D(h(void 0, !0));
      });
    });
  }), e), w), A = function(M) {
    var D, U = Object.create(x, (D = {}, t(D, l, {
      value: M,
      writable: !0
    }), t(D, a, {
      value: null,
      writable: !0
    }), t(D, f, {
      value: null,
      writable: !0
    }), t(D, s, {
      value: null,
      writable: !0
    }), t(D, c, {
      value: M._readableState.endEmitted,
      writable: !0
    }), t(D, o, {
      value: function(W, G) {
        var re = U[l].read();
        re ? (U[u] = null, U[a] = null, U[f] = null, W(h(re, !1))) : (U[a] = W, U[f] = G);
      },
      writable: !0
    }), D));
    return U[u] = null, n(M, function(z) {
      if (z && z.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var W = U[f];
        W !== null && (U[u] = null, U[a] = null, U[f] = null, W(z)), U[s] = z;
        return;
      }
      var G = U[a];
      G !== null && (U[u] = null, U[a] = null, U[f] = null, G(h(void 0, !0))), U[c] = !0;
    }), M.on("readable", v.bind(null, U)), U;
  };
  return hf = A, hf;
}
var df, zu;
function P1() {
  return zu || (zu = 1, df = function() {
    throw new Error("Readable.from is not available in the browser");
  }), df;
}
var pf, Gu;
function cd() {
  if (Gu)
    return pf;
  Gu = 1, pf = G;
  var e;
  G.ReadableState = W, Hi().EventEmitter;
  var t = function(P, Z) {
    return P.listeners(Z).length;
  }, i = Yh(), r = or.Buffer, n = (typeof Ge < "u" ? Ge : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(F) {
    return r.from(F);
  }
  function f(F) {
    return r.isBuffer(F) || F instanceof n;
  }
  var s = Fa(), c;
  s && s.debuglog ? c = s.debuglog("stream") : c = function() {
  };
  var u = D1(), o = fd(), l = sd(), h = l.getHighWaterMark, p = Ai().codes, v = p.ERR_INVALID_ARG_TYPE, y = p.ERR_STREAM_PUSH_AFTER_EOF, w = p.ERR_METHOD_NOT_IMPLEMENTED, x = p.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, A, R, M;
  Ae()(G, i);
  var D = o.errorOrDestroy, U = ["error", "close", "destroy", "pause", "resume"];
  function z(F, P, Z) {
    if (typeof F.prependListener == "function")
      return F.prependListener(P, Z);
    !F._events || !F._events[P] ? F.on(P, Z) : Array.isArray(F._events[P]) ? F._events[P].unshift(Z) : F._events[P] = [Z, F._events[P]];
  }
  function W(F, P, Z) {
    e = e || bi(), F = F || {}, typeof Z != "boolean" && (Z = P instanceof e), this.objectMode = !!F.objectMode, Z && (this.objectMode = this.objectMode || !!F.readableObjectMode), this.highWaterMark = h(this, F, "readableHighWaterMark", Z), this.buffer = new u(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = F.emitClose !== !1, this.autoDestroy = !!F.autoDestroy, this.destroyed = !1, this.defaultEncoding = F.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, F.encoding && (A || (A = Fi().StringDecoder), this.decoder = new A(F.encoding), this.encoding = F.encoding);
  }
  function G(F) {
    if (e = e || bi(), !(this instanceof G))
      return new G(F);
    var P = this instanceof e;
    this._readableState = new W(F, this, P), this.readable = !0, F && (typeof F.read == "function" && (this._read = F.read), typeof F.destroy == "function" && (this._destroy = F.destroy)), i.call(this);
  }
  Object.defineProperty(G.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(P) {
      this._readableState && (this._readableState.destroyed = P);
    }
  }), G.prototype.destroy = o.destroy, G.prototype._undestroy = o.undestroy, G.prototype._destroy = function(F, P) {
    P(F);
  }, G.prototype.push = function(F, P) {
    var Z = this._readableState, ae;
    return Z.objectMode ? ae = !0 : typeof F == "string" && (P = P || Z.defaultEncoding, P !== Z.encoding && (F = r.from(F, P), P = ""), ae = !0), re(this, F, P, !1, ae);
  }, G.prototype.unshift = function(F) {
    return re(this, F, null, !0, !1);
  };
  function re(F, P, Z, ae, se) {
    c("readableAddChunk", P);
    var le = F._readableState;
    if (P === null)
      le.reading = !1, C(F, le);
    else {
      var be;
      if (se || (be = m(le, P)), be)
        D(F, be);
      else if (le.objectMode || P && P.length > 0)
        if (typeof P != "string" && !le.objectMode && Object.getPrototypeOf(P) !== r.prototype && (P = a(P)), ae)
          le.endEmitted ? D(F, new x()) : V(F, le, P, !0);
        else if (le.ended)
          D(F, new y());
        else {
          if (le.destroyed)
            return !1;
          le.reading = !1, le.decoder && !Z ? (P = le.decoder.write(P), le.objectMode || P.length !== 0 ? V(F, le, P, !1) : T(F, le)) : V(F, le, P, !1);
        }
      else
        ae || (le.reading = !1, T(F, le));
    }
    return !le.ended && (le.length < le.highWaterMark || le.length === 0);
  }
  function V(F, P, Z, ae) {
    P.flowing && P.length === 0 && !P.sync ? (P.awaitDrain = 0, F.emit("data", Z)) : (P.length += P.objectMode ? 1 : Z.length, ae ? P.buffer.unshift(Z) : P.buffer.push(Z), P.needReadable && E(F)), T(F, P);
  }
  function m(F, P) {
    var Z;
    return !f(P) && typeof P != "string" && P !== void 0 && !F.objectMode && (Z = new v("chunk", ["string", "Buffer", "Uint8Array"], P)), Z;
  }
  G.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, G.prototype.setEncoding = function(F) {
    A || (A = Fi().StringDecoder);
    var P = new A(F);
    this._readableState.decoder = P, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Z = this._readableState.buffer.head, ae = ""; Z !== null; )
      ae += P.write(Z.data), Z = Z.next;
    return this._readableState.buffer.clear(), ae !== "" && this._readableState.buffer.push(ae), this._readableState.length = ae.length, this;
  };
  var g = 1073741824;
  function d(F) {
    return F >= g ? F = g : (F--, F |= F >>> 1, F |= F >>> 2, F |= F >>> 4, F |= F >>> 8, F |= F >>> 16, F++), F;
  }
  function b(F, P) {
    return F <= 0 || P.length === 0 && P.ended ? 0 : P.objectMode ? 1 : F !== F ? P.flowing && P.length ? P.buffer.head.data.length : P.length : (F > P.highWaterMark && (P.highWaterMark = d(F)), F <= P.length ? F : P.ended ? P.length : (P.needReadable = !0, 0));
  }
  G.prototype.read = function(F) {
    c("read", F), F = parseInt(F, 10);
    var P = this._readableState, Z = F;
    if (F !== 0 && (P.emittedReadable = !1), F === 0 && P.needReadable && ((P.highWaterMark !== 0 ? P.length >= P.highWaterMark : P.length > 0) || P.ended))
      return c("read: emitReadable", P.length, P.ended), P.length === 0 && P.ended ? L(this) : E(this), null;
    if (F = b(F, P), F === 0 && P.ended)
      return P.length === 0 && L(this), null;
    var ae = P.needReadable;
    c("need readable", ae), (P.length === 0 || P.length - F < P.highWaterMark) && (ae = !0, c("length less than watermark", ae)), P.ended || P.reading ? (ae = !1, c("reading or ended", ae)) : ae && (c("do read"), P.reading = !0, P.sync = !0, P.length === 0 && (P.needReadable = !0), this._read(P.highWaterMark), P.sync = !1, P.reading || (F = b(Z, P)));
    var se;
    return F > 0 ? se = N(F, P) : se = null, se === null ? (P.needReadable = P.length <= P.highWaterMark, F = 0) : (P.length -= F, P.awaitDrain = 0), P.length === 0 && (P.ended || (P.needReadable = !0), Z !== F && P.ended && L(this)), se !== null && this.emit("data", se), se;
  };
  function C(F, P) {
    if (c("onEofChunk"), !P.ended) {
      if (P.decoder) {
        var Z = P.decoder.end();
        Z && Z.length && (P.buffer.push(Z), P.length += P.objectMode ? 1 : Z.length);
      }
      P.ended = !0, P.sync ? E(F) : (P.needReadable = !1, P.emittedReadable || (P.emittedReadable = !0, B(F)));
    }
  }
  function E(F) {
    var P = F._readableState;
    c("emitReadable", P.needReadable, P.emittedReadable), P.needReadable = !1, P.emittedReadable || (c("emitReadable", P.flowing), P.emittedReadable = !0, fe.process.nextTick(B, F));
  }
  function B(F) {
    var P = F._readableState;
    c("emitReadable_", P.destroyed, P.length, P.ended), !P.destroyed && (P.length || P.ended) && (F.emit("readable"), P.emittedReadable = !1), P.needReadable = !P.flowing && !P.ended && P.length <= P.highWaterMark, H(F);
  }
  function T(F, P) {
    P.readingMore || (P.readingMore = !0, fe.process.nextTick(_, F, P));
  }
  function _(F, P) {
    for (; !P.reading && !P.ended && (P.length < P.highWaterMark || P.flowing && P.length === 0); ) {
      var Z = P.length;
      if (c("maybeReadMore read 0"), F.read(0), Z === P.length)
        break;
    }
    P.readingMore = !1;
  }
  G.prototype._read = function(F) {
    D(this, new w("_read()"));
  }, G.prototype.pipe = function(F, P) {
    var Z = this, ae = this._readableState;
    switch (ae.pipesCount) {
      case 0:
        ae.pipes = F;
        break;
      case 1:
        ae.pipes = [ae.pipes, F];
        break;
      default:
        ae.pipes.push(F);
        break;
    }
    ae.pipesCount += 1, c("pipe count=%d opts=%j", ae.pipesCount, P);
    var se = (!P || P.end !== !1) && F !== fe.process.stdout && F !== fe.process.stderr, le = se ? me : et;
    ae.endEmitted ? fe.process.nextTick(le) : Z.once("end", le), F.on("unpipe", be);
    function be(Ee, tt) {
      c("onunpipe"), Ee === Z && tt && tt.hasUnpiped === !1 && (tt.hasUnpiped = !0, pe());
    }
    function me() {
      c("onend"), F.end();
    }
    var ie = I(Z);
    F.on("drain", ie);
    var Be = !1;
    function pe() {
      c("cleanup"), F.removeListener("close", xe), F.removeListener("finish", ze), F.removeListener("drain", ie), F.removeListener("error", Te), F.removeListener("unpipe", be), Z.removeListener("end", me), Z.removeListener("end", et), Z.removeListener("data", Ce), Be = !0, ae.awaitDrain && (!F._writableState || F._writableState.needDrain) && ie();
    }
    Z.on("data", Ce);
    function Ce(Ee) {
      c("ondata");
      var tt = F.write(Ee);
      c("dest.write", tt), tt === !1 && ((ae.pipesCount === 1 && ae.pipes === F || ae.pipesCount > 1 && Y(ae.pipes, F) !== -1) && !Be && (c("false write response, pause", ae.awaitDrain), ae.awaitDrain++), Z.pause());
    }
    function Te(Ee) {
      c("onerror", Ee), et(), F.removeListener("error", Te), t(F, "error") === 0 && D(F, Ee);
    }
    z(F, "error", Te);
    function xe() {
      F.removeListener("finish", ze), et();
    }
    F.once("close", xe);
    function ze() {
      c("onfinish"), F.removeListener("close", xe), et();
    }
    F.once("finish", ze);
    function et() {
      c("unpipe"), Z.unpipe(F);
    }
    return F.emit("pipe", Z), ae.flowing || (c("pipe resume"), Z.resume()), F;
  };
  function I(F) {
    return function() {
      var Z = F._readableState;
      c("pipeOnDrain", Z.awaitDrain), Z.awaitDrain && Z.awaitDrain--, Z.awaitDrain === 0 && t(F, "data") && (Z.flowing = !0, H(F));
    };
  }
  G.prototype.unpipe = function(F) {
    var P = this._readableState, Z = {
      hasUnpiped: !1
    };
    if (P.pipesCount === 0)
      return this;
    if (P.pipesCount === 1)
      return F && F !== P.pipes ? this : (F || (F = P.pipes), P.pipes = null, P.pipesCount = 0, P.flowing = !1, F && F.emit("unpipe", this, Z), this);
    if (!F) {
      var ae = P.pipes, se = P.pipesCount;
      P.pipes = null, P.pipesCount = 0, P.flowing = !1;
      for (var le = 0; le < se; le++)
        ae[le].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var be = Y(P.pipes, F);
    return be === -1 ? this : (P.pipes.splice(be, 1), P.pipesCount -= 1, P.pipesCount === 1 && (P.pipes = P.pipes[0]), F.emit("unpipe", this, Z), this);
  }, G.prototype.on = function(F, P) {
    var Z = i.prototype.on.call(this, F, P), ae = this._readableState;
    return F === "data" ? (ae.readableListening = this.listenerCount("readable") > 0, ae.flowing !== !1 && this.resume()) : F === "readable" && !ae.endEmitted && !ae.readableListening && (ae.readableListening = ae.needReadable = !0, ae.flowing = !1, ae.emittedReadable = !1, c("on readable", ae.length, ae.reading), ae.length ? E(this) : ae.reading || fe.process.nextTick(k, this)), Z;
  }, G.prototype.addListener = G.prototype.on, G.prototype.removeListener = function(F, P) {
    var Z = i.prototype.removeListener.call(this, F, P);
    return F === "readable" && fe.process.nextTick(S, this), Z;
  }, G.prototype.removeAllListeners = function(F) {
    var P = i.prototype.removeAllListeners.apply(this, arguments);
    return (F === "readable" || F === void 0) && fe.process.nextTick(S, this), P;
  };
  function S(F) {
    var P = F._readableState;
    P.readableListening = F.listenerCount("readable") > 0, P.resumeScheduled && !P.paused ? P.flowing = !0 : F.listenerCount("data") > 0 && F.resume();
  }
  function k(F) {
    c("readable nexttick read 0"), F.read(0);
  }
  G.prototype.resume = function() {
    var F = this._readableState;
    return F.flowing || (c("resume"), F.flowing = !F.readableListening, $(this, F)), F.paused = !1, this;
  };
  function $(F, P) {
    P.resumeScheduled || (P.resumeScheduled = !0, fe.process.nextTick(ee, F, P));
  }
  function ee(F, P) {
    c("resume", P.reading), P.reading || F.read(0), P.resumeScheduled = !1, F.emit("resume"), H(F), P.flowing && !P.reading && F.read(0);
  }
  G.prototype.pause = function() {
    return c("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function H(F) {
    var P = F._readableState;
    for (c("flow", P.flowing); P.flowing && F.read() !== null; )
      ;
  }
  G.prototype.wrap = function(F) {
    var P = this, Z = this._readableState, ae = !1;
    F.on("end", function() {
      if (c("wrapped end"), Z.decoder && !Z.ended) {
        var be = Z.decoder.end();
        be && be.length && P.push(be);
      }
      P.push(null);
    }), F.on("data", function(be) {
      if (c("wrapped data"), Z.decoder && (be = Z.decoder.write(be)), !(Z.objectMode && be == null) && !(!Z.objectMode && (!be || !be.length))) {
        var me = P.push(be);
        me || (ae = !0, F.pause());
      }
    });
    for (var se in F)
      this[se] === void 0 && typeof F[se] == "function" && (this[se] = /* @__PURE__ */ function(me) {
        return function() {
          return F[me].apply(F, arguments);
        };
      }(se));
    for (var le = 0; le < U.length; le++)
      F.on(U[le], this.emit.bind(this, U[le]));
    return this._read = function(be) {
      c("wrapped _read", be), ae && (ae = !1, F.resume());
    }, this;
  }, typeof Symbol == "function" && (G.prototype[Symbol.asyncIterator] = function() {
    return R === void 0 && (R = L1()), R(this);
  }), Object.defineProperty(G.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(G.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(G.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(P) {
      this._readableState && (this._readableState.flowing = P);
    }
  }), G._fromList = N, Object.defineProperty(G.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function N(F, P) {
    if (P.length === 0)
      return null;
    var Z;
    return P.objectMode ? Z = P.buffer.shift() : !F || F >= P.length ? (P.decoder ? Z = P.buffer.join("") : P.buffer.length === 1 ? Z = P.buffer.first() : Z = P.buffer.concat(P.length), P.buffer.clear()) : Z = P.buffer.consume(F, P.decoder), Z;
  }
  function L(F) {
    var P = F._readableState;
    c("endReadable", P.endEmitted), P.endEmitted || (P.ended = !0, fe.process.nextTick(j, P, F));
  }
  function j(F, P) {
    if (c("endReadableNT", F.endEmitted, F.length), !F.endEmitted && F.length === 0 && (F.endEmitted = !0, P.readable = !1, P.emit("end"), F.autoDestroy)) {
      var Z = P._writableState;
      (!Z || Z.autoDestroy && Z.finished) && P.destroy();
    }
  }
  typeof Symbol == "function" && (G.from = function(F, P) {
    return M === void 0 && (M = P1()), M(G, F, P);
  });
  function Y(F, P) {
    for (var Z = 0, ae = F.length; Z < ae; Z++)
      if (F[Z] === P)
        return Z;
    return -1;
  }
  return pf;
}
var vf, $u;
function ld() {
  if ($u)
    return vf;
  $u = 1, vf = s;
  var e = Ai().codes, t = e.ERR_METHOD_NOT_IMPLEMENTED, i = e.ERR_MULTIPLE_CALLBACK, r = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, n = e.ERR_TRANSFORM_WITH_LENGTH_0, a = bi();
  Ae()(s, a);
  function f(o, l) {
    var h = this._transformState;
    h.transforming = !1;
    var p = h.writecb;
    if (p === null)
      return this.emit("error", new i());
    h.writechunk = null, h.writecb = null, l != null && this.push(l), p(o);
    var v = this._readableState;
    v.reading = !1, (v.needReadable || v.length < v.highWaterMark) && this._read(v.highWaterMark);
  }
  function s(o) {
    if (!(this instanceof s))
      return new s(o);
    a.call(this, o), this._transformState = {
      afterTransform: f.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, o && (typeof o.transform == "function" && (this._transform = o.transform), typeof o.flush == "function" && (this._flush = o.flush)), this.on("prefinish", c);
  }
  function c() {
    var o = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(l, h) {
      u(o, l, h);
    }) : u(this, null, null);
  }
  s.prototype.push = function(o, l) {
    return this._transformState.needTransform = !1, a.prototype.push.call(this, o, l);
  }, s.prototype._transform = function(o, l, h) {
    h(new t("_transform()"));
  }, s.prototype._write = function(o, l, h) {
    var p = this._transformState;
    if (p.writecb = h, p.writechunk = o, p.writeencoding = l, !p.transforming) {
      var v = this._readableState;
      (p.needTransform || v.needReadable || v.length < v.highWaterMark) && this._read(v.highWaterMark);
    }
  }, s.prototype._read = function(o) {
    var l = this._transformState;
    l.writechunk !== null && !l.transforming ? (l.transforming = !0, this._transform(l.writechunk, l.writeencoding, l.afterTransform)) : l.needTransform = !0;
  }, s.prototype._destroy = function(o, l) {
    a.prototype._destroy.call(this, o, function(h) {
      l(h);
    });
  };
  function u(o, l, h) {
    if (l)
      return o.emit("error", l);
    if (h != null && o.push(h), o._writableState.length)
      throw new n();
    if (o._transformState.transforming)
      throw new r();
    return o.push(null);
  }
  return vf;
}
var yf, Wu;
function U1() {
  if (Wu)
    return yf;
  Wu = 1, yf = t;
  var e = ld();
  Ae()(t, e);
  function t(i) {
    if (!(this instanceof t))
      return new t(i);
    e.call(this, i);
  }
  return t.prototype._transform = function(i, r, n) {
    n(null, i);
  }, yf;
}
var gf, Qu;
function O1() {
  if (Qu)
    return gf;
  Qu = 1;
  var e;
  function t(h) {
    var p = !1;
    return function() {
      p || (p = !0, h.apply(void 0, arguments));
    };
  }
  var i = Ai().codes, r = i.ERR_MISSING_ARGS, n = i.ERR_STREAM_DESTROYED;
  function a(h) {
    if (h)
      throw h;
  }
  function f(h) {
    return h.setHeader && typeof h.abort == "function";
  }
  function s(h, p, v, y) {
    y = t(y);
    var w = !1;
    h.on("close", function() {
      w = !0;
    }), e === void 0 && (e = Zo()), e(h, {
      readable: p,
      writable: v
    }, function(A) {
      if (A)
        return y(A);
      w = !0, y();
    });
    var x = !1;
    return function(A) {
      if (!w && !x) {
        if (x = !0, f(h))
          return h.abort();
        if (typeof h.destroy == "function")
          return h.destroy();
        y(A || new n("pipe"));
      }
    };
  }
  function c(h) {
    h();
  }
  function u(h, p) {
    return h.pipe(p);
  }
  function o(h) {
    return !h.length || typeof h[h.length - 1] != "function" ? a : h.pop();
  }
  function l() {
    for (var h = arguments.length, p = new Array(h), v = 0; v < h; v++)
      p[v] = arguments[v];
    var y = o(p);
    if (Array.isArray(p[0]) && (p = p[0]), p.length < 2)
      throw new r("streams");
    var w, x = p.map(function(A, R) {
      var M = R < p.length - 1, D = R > 0;
      return s(A, M, D, function(U) {
        w || (w = U), U && x.forEach(c), !M && (x.forEach(c), y(w));
      });
    });
    return p.reduce(u);
  }
  return gf = l, gf;
}
var bf, Yu;
function hd() {
  if (Yu)
    return bf;
  Yu = 1, bf = i;
  var e = Hi().EventEmitter, t = Ae();
  t(i, e), i.Readable = cd(), i.Writable = ud(), i.Duplex = bi(), i.Transform = ld(), i.PassThrough = U1(), i.finished = Zo(), i.pipeline = O1(), i.Stream = i;
  function i() {
    e.call(this);
  }
  return i.prototype.pipe = function(r, n) {
    var a = this;
    function f(p) {
      r.writable && r.write(p) === !1 && a.pause && a.pause();
    }
    a.on("data", f);
    function s() {
      a.readable && a.resume && a.resume();
    }
    r.on("drain", s), !r._isStdio && (!n || n.end !== !1) && (a.on("end", u), a.on("close", o));
    var c = !1;
    function u() {
      c || (c = !0, r.end());
    }
    function o() {
      c || (c = !0, typeof r.destroy == "function" && r.destroy());
    }
    function l(p) {
      if (h(), e.listenerCount(this, "error") === 0)
        throw p;
    }
    a.on("error", l), r.on("error", l);
    function h() {
      a.removeListener("data", f), r.removeListener("drain", s), a.removeListener("end", u), a.removeListener("close", o), a.removeListener("error", l), r.removeListener("error", l), a.removeListener("end", h), a.removeListener("close", h), r.removeListener("close", h);
    }
    return a.on("end", h), a.on("close", h), r.on("close", h), r.emit("pipe", a), r;
  }, bf;
}
var mf, Xu;
function dd() {
  if (Xu)
    return mf;
  Xu = 1;
  var e = He().Buffer, t = hd().Transform, i = Ae();
  function r(s) {
    t.call(this), this._block = e.allocUnsafe(s), this._blockSize = s, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  i(r, t), r.prototype._transform = function(s, c, u) {
    var o = null;
    try {
      this.update(s, c);
    } catch (l) {
      o = l;
    }
    u(o);
  }, r.prototype._flush = function(s) {
    var c = null;
    try {
      this.push(this.digest());
    } catch (u) {
      c = u;
    }
    s(c);
  };
  var n = typeof Uint8Array < "u", a = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (e.prototype instanceof Uint8Array || e.TYPED_ARRAY_SUPPORT);
  function f(s, c) {
    if (s instanceof e)
      return s;
    if (typeof s == "string")
      return e.from(s, c);
    if (a && ArrayBuffer.isView(s)) {
      if (s.byteLength === 0)
        return e.alloc(0);
      var u = e.from(s.buffer, s.byteOffset, s.byteLength);
      if (u.byteLength === s.byteLength)
        return u;
    }
    if (n && s instanceof Uint8Array || e.isBuffer(s) && s.constructor && typeof s.constructor.isBuffer == "function" && s.constructor.isBuffer(s))
      return e.from(s);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return r.prototype.update = function(s, c) {
    if (this._finalized)
      throw new Error("Digest already called");
    s = f(s, c);
    for (var u = this._block, o = 0; this._blockOffset + s.length - o >= this._blockSize; ) {
      for (var l = this._blockOffset; l < this._blockSize; )
        u[l++] = s[o++];
      this._update(), this._blockOffset = 0;
    }
    for (; o < s.length; )
      u[this._blockOffset++] = s[o++];
    for (var h = 0, p = s.length * 8; p > 0; ++h)
      this._length[h] += p, p = this._length[h] / 4294967296 | 0, p > 0 && (this._length[h] -= 4294967296 * p);
    return this;
  }, r.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, r.prototype.digest = function(s) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var c = this._digest();
    s !== void 0 && (c = c.toString(s)), this._block.fill(0), this._blockOffset = 0;
    for (var u = 0; u < 4; ++u)
      this._length[u] = 0;
    return c;
  }, r.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, mf = r, mf;
}
var xf, Zu;
function Jo() {
  if (Zu)
    return xf;
  Zu = 1;
  var e = Ae(), t = dd(), i = He().Buffer, r = new Array(16);
  function n() {
    t.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  e(n, t), n.prototype._update = function() {
    for (var o = r, l = 0; l < 16; ++l)
      o[l] = this._block.readInt32LE(l * 4);
    var h = this._a, p = this._b, v = this._c, y = this._d;
    h = f(h, p, v, y, o[0], 3614090360, 7), y = f(y, h, p, v, o[1], 3905402710, 12), v = f(v, y, h, p, o[2], 606105819, 17), p = f(p, v, y, h, o[3], 3250441966, 22), h = f(h, p, v, y, o[4], 4118548399, 7), y = f(y, h, p, v, o[5], 1200080426, 12), v = f(v, y, h, p, o[6], 2821735955, 17), p = f(p, v, y, h, o[7], 4249261313, 22), h = f(h, p, v, y, o[8], 1770035416, 7), y = f(y, h, p, v, o[9], 2336552879, 12), v = f(v, y, h, p, o[10], 4294925233, 17), p = f(p, v, y, h, o[11], 2304563134, 22), h = f(h, p, v, y, o[12], 1804603682, 7), y = f(y, h, p, v, o[13], 4254626195, 12), v = f(v, y, h, p, o[14], 2792965006, 17), p = f(p, v, y, h, o[15], 1236535329, 22), h = s(h, p, v, y, o[1], 4129170786, 5), y = s(y, h, p, v, o[6], 3225465664, 9), v = s(v, y, h, p, o[11], 643717713, 14), p = s(p, v, y, h, o[0], 3921069994, 20), h = s(h, p, v, y, o[5], 3593408605, 5), y = s(y, h, p, v, o[10], 38016083, 9), v = s(v, y, h, p, o[15], 3634488961, 14), p = s(p, v, y, h, o[4], 3889429448, 20), h = s(h, p, v, y, o[9], 568446438, 5), y = s(y, h, p, v, o[14], 3275163606, 9), v = s(v, y, h, p, o[3], 4107603335, 14), p = s(p, v, y, h, o[8], 1163531501, 20), h = s(h, p, v, y, o[13], 2850285829, 5), y = s(y, h, p, v, o[2], 4243563512, 9), v = s(v, y, h, p, o[7], 1735328473, 14), p = s(p, v, y, h, o[12], 2368359562, 20), h = c(h, p, v, y, o[5], 4294588738, 4), y = c(y, h, p, v, o[8], 2272392833, 11), v = c(v, y, h, p, o[11], 1839030562, 16), p = c(p, v, y, h, o[14], 4259657740, 23), h = c(h, p, v, y, o[1], 2763975236, 4), y = c(y, h, p, v, o[4], 1272893353, 11), v = c(v, y, h, p, o[7], 4139469664, 16), p = c(p, v, y, h, o[10], 3200236656, 23), h = c(h, p, v, y, o[13], 681279174, 4), y = c(y, h, p, v, o[0], 3936430074, 11), v = c(v, y, h, p, o[3], 3572445317, 16), p = c(p, v, y, h, o[6], 76029189, 23), h = c(h, p, v, y, o[9], 3654602809, 4), y = c(y, h, p, v, o[12], 3873151461, 11), v = c(v, y, h, p, o[15], 530742520, 16), p = c(p, v, y, h, o[2], 3299628645, 23), h = u(h, p, v, y, o[0], 4096336452, 6), y = u(y, h, p, v, o[7], 1126891415, 10), v = u(v, y, h, p, o[14], 2878612391, 15), p = u(p, v, y, h, o[5], 4237533241, 21), h = u(h, p, v, y, o[12], 1700485571, 6), y = u(y, h, p, v, o[3], 2399980690, 10), v = u(v, y, h, p, o[10], 4293915773, 15), p = u(p, v, y, h, o[1], 2240044497, 21), h = u(h, p, v, y, o[8], 1873313359, 6), y = u(y, h, p, v, o[15], 4264355552, 10), v = u(v, y, h, p, o[6], 2734768916, 15), p = u(p, v, y, h, o[13], 1309151649, 21), h = u(h, p, v, y, o[4], 4149444226, 6), y = u(y, h, p, v, o[11], 3174756917, 10), v = u(v, y, h, p, o[2], 718787259, 15), p = u(p, v, y, h, o[9], 3951481745, 21), this._a = this._a + h | 0, this._b = this._b + p | 0, this._c = this._c + v | 0, this._d = this._d + y | 0;
  }, n.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var o = i.allocUnsafe(16);
    return o.writeInt32LE(this._a, 0), o.writeInt32LE(this._b, 4), o.writeInt32LE(this._c, 8), o.writeInt32LE(this._d, 12), o;
  };
  function a(o, l) {
    return o << l | o >>> 32 - l;
  }
  function f(o, l, h, p, v, y, w) {
    return a(o + (l & h | ~l & p) + v + y | 0, w) + l | 0;
  }
  function s(o, l, h, p, v, y, w) {
    return a(o + (l & p | h & ~p) + v + y | 0, w) + l | 0;
  }
  function c(o, l, h, p, v, y, w) {
    return a(o + (l ^ h ^ p) + v + y | 0, w) + l | 0;
  }
  function u(o, l, h, p, v, y, w) {
    return a(o + (h ^ (l | ~p)) + v + y | 0, w) + l | 0;
  }
  return xf = n, xf;
}
var _f, Ju;
function e0() {
  if (Ju)
    return _f;
  Ju = 1;
  var e = or.Buffer, t = Ae(), i = dd(), r = new Array(16), n = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], a = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], f = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], s = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], c = [0, 1518500249, 1859775393, 2400959708, 2840853838], u = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function o() {
    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  t(o, i), o.prototype._update = function() {
    for (var x = r, A = 0; A < 16; ++A)
      x[A] = this._block.readInt32LE(A * 4);
    for (var R = this._a | 0, M = this._b | 0, D = this._c | 0, U = this._d | 0, z = this._e | 0, W = this._a | 0, G = this._b | 0, re = this._c | 0, V = this._d | 0, m = this._e | 0, g = 0; g < 80; g += 1) {
      var d, b;
      g < 16 ? (d = h(R, M, D, U, z, x[n[g]], c[0], f[g]), b = w(W, G, re, V, m, x[a[g]], u[0], s[g])) : g < 32 ? (d = p(R, M, D, U, z, x[n[g]], c[1], f[g]), b = y(W, G, re, V, m, x[a[g]], u[1], s[g])) : g < 48 ? (d = v(R, M, D, U, z, x[n[g]], c[2], f[g]), b = v(W, G, re, V, m, x[a[g]], u[2], s[g])) : g < 64 ? (d = y(R, M, D, U, z, x[n[g]], c[3], f[g]), b = p(W, G, re, V, m, x[a[g]], u[3], s[g])) : (d = w(R, M, D, U, z, x[n[g]], c[4], f[g]), b = h(W, G, re, V, m, x[a[g]], u[4], s[g])), R = z, z = U, U = l(D, 10), D = M, M = d, W = m, m = V, V = l(re, 10), re = G, G = b;
    }
    var C = this._b + D + V | 0;
    this._b = this._c + U + m | 0, this._c = this._d + z + W | 0, this._d = this._e + R + G | 0, this._e = this._a + M + re | 0, this._a = C;
  }, o.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var x = e.alloc ? e.alloc(20) : new e(20);
    return x.writeInt32LE(this._a, 0), x.writeInt32LE(this._b, 4), x.writeInt32LE(this._c, 8), x.writeInt32LE(this._d, 12), x.writeInt32LE(this._e, 16), x;
  };
  function l(x, A) {
    return x << A | x >>> 32 - A;
  }
  function h(x, A, R, M, D, U, z, W) {
    return l(x + (A ^ R ^ M) + U + z | 0, W) + D | 0;
  }
  function p(x, A, R, M, D, U, z, W) {
    return l(x + (A & R | ~A & M) + U + z | 0, W) + D | 0;
  }
  function v(x, A, R, M, D, U, z, W) {
    return l(x + ((A | ~R) ^ M) + U + z | 0, W) + D | 0;
  }
  function y(x, A, R, M, D, U, z, W) {
    return l(x + (A & M | R & ~M) + U + z | 0, W) + D | 0;
  }
  function w(x, A, R, M, D, U, z, W) {
    return l(x + (A ^ (R | ~M)) + U + z | 0, W) + D | 0;
  }
  return _f = o, _f;
}
var Sf = { exports: {} }, Ef, ec;
function Bi() {
  if (ec)
    return Ef;
  ec = 1;
  var e = He().Buffer;
  function t(i, r) {
    this._block = e.alloc(i), this._finalSize = r, this._blockSize = i, this._len = 0;
  }
  return t.prototype.update = function(i, r) {
    typeof i == "string" && (r = r || "utf8", i = e.from(i, r));
    for (var n = this._block, a = this._blockSize, f = i.length, s = this._len, c = 0; c < f; ) {
      for (var u = s % a, o = Math.min(f - c, a - u), l = 0; l < o; l++)
        n[u + l] = i[c + l];
      s += o, c += o, s % a === 0 && this._update(n);
    }
    return this._len += f, this;
  }, t.prototype.digest = function(i) {
    var r = this._len % this._blockSize;
    this._block[r] = 128, this._block.fill(0, r + 1), r >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var n = this._len * 8;
    if (n <= 4294967295)
      this._block.writeUInt32BE(n, this._blockSize - 4);
    else {
      var a = (n & 4294967295) >>> 0, f = (n - a) / 4294967296;
      this._block.writeUInt32BE(f, this._blockSize - 8), this._block.writeUInt32BE(a, this._blockSize - 4);
    }
    this._update(this._block);
    var s = this._hash();
    return i ? s.toString(i) : s;
  }, t.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, Ef = t, Ef;
}
var wf, tc;
function q1() {
  if (tc)
    return wf;
  tc = 1;
  var e = Ae(), t = Bi(), i = He().Buffer, r = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], n = new Array(80);
  function a() {
    this.init(), this._w = n, t.call(this, 64, 56);
  }
  e(a, t), a.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function f(u) {
    return u << 5 | u >>> 27;
  }
  function s(u) {
    return u << 30 | u >>> 2;
  }
  function c(u, o, l, h) {
    return u === 0 ? o & l | ~o & h : u === 2 ? o & l | o & h | l & h : o ^ l ^ h;
  }
  return a.prototype._update = function(u) {
    for (var o = this._w, l = this._a | 0, h = this._b | 0, p = this._c | 0, v = this._d | 0, y = this._e | 0, w = 0; w < 16; ++w)
      o[w] = u.readInt32BE(w * 4);
    for (; w < 80; ++w)
      o[w] = o[w - 3] ^ o[w - 8] ^ o[w - 14] ^ o[w - 16];
    for (var x = 0; x < 80; ++x) {
      var A = ~~(x / 20), R = f(l) + c(A, h, p, v) + y + o[x] + r[A] | 0;
      y = v, v = p, p = s(h), h = l, l = R;
    }
    this._a = l + this._a | 0, this._b = h + this._b | 0, this._c = p + this._c | 0, this._d = v + this._d | 0, this._e = y + this._e | 0;
  }, a.prototype._hash = function() {
    var u = i.allocUnsafe(20);
    return u.writeInt32BE(this._a | 0, 0), u.writeInt32BE(this._b | 0, 4), u.writeInt32BE(this._c | 0, 8), u.writeInt32BE(this._d | 0, 12), u.writeInt32BE(this._e | 0, 16), u;
  }, wf = a, wf;
}
var Cf, rc;
function F1() {
  if (rc)
    return Cf;
  rc = 1;
  var e = Ae(), t = Bi(), i = He().Buffer, r = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], n = new Array(80);
  function a() {
    this.init(), this._w = n, t.call(this, 64, 56);
  }
  e(a, t), a.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function f(o) {
    return o << 1 | o >>> 31;
  }
  function s(o) {
    return o << 5 | o >>> 27;
  }
  function c(o) {
    return o << 30 | o >>> 2;
  }
  function u(o, l, h, p) {
    return o === 0 ? l & h | ~l & p : o === 2 ? l & h | l & p | h & p : l ^ h ^ p;
  }
  return a.prototype._update = function(o) {
    for (var l = this._w, h = this._a | 0, p = this._b | 0, v = this._c | 0, y = this._d | 0, w = this._e | 0, x = 0; x < 16; ++x)
      l[x] = o.readInt32BE(x * 4);
    for (; x < 80; ++x)
      l[x] = f(l[x - 3] ^ l[x - 8] ^ l[x - 14] ^ l[x - 16]);
    for (var A = 0; A < 80; ++A) {
      var R = ~~(A / 20), M = s(h) + u(R, p, v, y) + w + l[A] + r[R] | 0;
      w = y, y = v, v = c(p), p = h, h = M;
    }
    this._a = h + this._a | 0, this._b = p + this._b | 0, this._c = v + this._c | 0, this._d = y + this._d | 0, this._e = w + this._e | 0;
  }, a.prototype._hash = function() {
    var o = i.allocUnsafe(20);
    return o.writeInt32BE(this._a | 0, 0), o.writeInt32BE(this._b | 0, 4), o.writeInt32BE(this._c | 0, 8), o.writeInt32BE(this._d | 0, 12), o.writeInt32BE(this._e | 0, 16), o;
  }, Cf = a, Cf;
}
var Af, ic;
function pd() {
  if (ic)
    return Af;
  ic = 1;
  var e = Ae(), t = Bi(), i = He().Buffer, r = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], n = new Array(64);
  function a() {
    this.init(), this._w = n, t.call(this, 64, 56);
  }
  e(a, t), a.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function f(h, p, v) {
    return v ^ h & (p ^ v);
  }
  function s(h, p, v) {
    return h & p | v & (h | p);
  }
  function c(h) {
    return (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10);
  }
  function u(h) {
    return (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
  }
  function o(h) {
    return (h >>> 7 | h << 25) ^ (h >>> 18 | h << 14) ^ h >>> 3;
  }
  function l(h) {
    return (h >>> 17 | h << 15) ^ (h >>> 19 | h << 13) ^ h >>> 10;
  }
  return a.prototype._update = function(h) {
    for (var p = this._w, v = this._a | 0, y = this._b | 0, w = this._c | 0, x = this._d | 0, A = this._e | 0, R = this._f | 0, M = this._g | 0, D = this._h | 0, U = 0; U < 16; ++U)
      p[U] = h.readInt32BE(U * 4);
    for (; U < 64; ++U)
      p[U] = l(p[U - 2]) + p[U - 7] + o(p[U - 15]) + p[U - 16] | 0;
    for (var z = 0; z < 64; ++z) {
      var W = D + u(A) + f(A, R, M) + r[z] + p[z] | 0, G = c(v) + s(v, y, w) | 0;
      D = M, M = R, R = A, A = x + W | 0, x = w, w = y, y = v, v = W + G | 0;
    }
    this._a = v + this._a | 0, this._b = y + this._b | 0, this._c = w + this._c | 0, this._d = x + this._d | 0, this._e = A + this._e | 0, this._f = R + this._f | 0, this._g = M + this._g | 0, this._h = D + this._h | 0;
  }, a.prototype._hash = function() {
    var h = i.allocUnsafe(32);
    return h.writeInt32BE(this._a, 0), h.writeInt32BE(this._b, 4), h.writeInt32BE(this._c, 8), h.writeInt32BE(this._d, 12), h.writeInt32BE(this._e, 16), h.writeInt32BE(this._f, 20), h.writeInt32BE(this._g, 24), h.writeInt32BE(this._h, 28), h;
  }, Af = a, Af;
}
var Bf, ac;
function V1() {
  if (ac)
    return Bf;
  ac = 1;
  var e = Ae(), t = pd(), i = Bi(), r = He().Buffer, n = new Array(64);
  function a() {
    this.init(), this._w = n, i.call(this, 64, 56);
  }
  return e(a, t), a.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, a.prototype._hash = function() {
    var f = r.allocUnsafe(28);
    return f.writeInt32BE(this._a, 0), f.writeInt32BE(this._b, 4), f.writeInt32BE(this._c, 8), f.writeInt32BE(this._d, 12), f.writeInt32BE(this._e, 16), f.writeInt32BE(this._f, 20), f.writeInt32BE(this._g, 24), f;
  }, Bf = a, Bf;
}
var Tf, nc;
function vd() {
  if (nc)
    return Tf;
  nc = 1;
  var e = Ae(), t = Bi(), i = He().Buffer, r = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], n = new Array(160);
  function a() {
    this.init(), this._w = n, t.call(this, 128, 112);
  }
  e(a, t), a.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function f(y, w, x) {
    return x ^ y & (w ^ x);
  }
  function s(y, w, x) {
    return y & w | x & (y | w);
  }
  function c(y, w) {
    return (y >>> 28 | w << 4) ^ (w >>> 2 | y << 30) ^ (w >>> 7 | y << 25);
  }
  function u(y, w) {
    return (y >>> 14 | w << 18) ^ (y >>> 18 | w << 14) ^ (w >>> 9 | y << 23);
  }
  function o(y, w) {
    return (y >>> 1 | w << 31) ^ (y >>> 8 | w << 24) ^ y >>> 7;
  }
  function l(y, w) {
    return (y >>> 1 | w << 31) ^ (y >>> 8 | w << 24) ^ (y >>> 7 | w << 25);
  }
  function h(y, w) {
    return (y >>> 19 | w << 13) ^ (w >>> 29 | y << 3) ^ y >>> 6;
  }
  function p(y, w) {
    return (y >>> 19 | w << 13) ^ (w >>> 29 | y << 3) ^ (y >>> 6 | w << 26);
  }
  function v(y, w) {
    return y >>> 0 < w >>> 0 ? 1 : 0;
  }
  return a.prototype._update = function(y) {
    for (var w = this._w, x = this._ah | 0, A = this._bh | 0, R = this._ch | 0, M = this._dh | 0, D = this._eh | 0, U = this._fh | 0, z = this._gh | 0, W = this._hh | 0, G = this._al | 0, re = this._bl | 0, V = this._cl | 0, m = this._dl | 0, g = this._el | 0, d = this._fl | 0, b = this._gl | 0, C = this._hl | 0, E = 0; E < 32; E += 2)
      w[E] = y.readInt32BE(E * 4), w[E + 1] = y.readInt32BE(E * 4 + 4);
    for (; E < 160; E += 2) {
      var B = w[E - 30], T = w[E - 15 * 2 + 1], _ = o(B, T), I = l(T, B);
      B = w[E - 2 * 2], T = w[E - 2 * 2 + 1];
      var S = h(B, T), k = p(T, B), $ = w[E - 7 * 2], ee = w[E - 7 * 2 + 1], H = w[E - 16 * 2], N = w[E - 16 * 2 + 1], L = I + ee | 0, j = _ + $ + v(L, I) | 0;
      L = L + k | 0, j = j + S + v(L, k) | 0, L = L + N | 0, j = j + H + v(L, N) | 0, w[E] = j, w[E + 1] = L;
    }
    for (var Y = 0; Y < 160; Y += 2) {
      j = w[Y], L = w[Y + 1];
      var F = s(x, A, R), P = s(G, re, V), Z = c(x, G), ae = c(G, x), se = u(D, g), le = u(g, D), be = r[Y], me = r[Y + 1], ie = f(D, U, z), Be = f(g, d, b), pe = C + le | 0, Ce = W + se + v(pe, C) | 0;
      pe = pe + Be | 0, Ce = Ce + ie + v(pe, Be) | 0, pe = pe + me | 0, Ce = Ce + be + v(pe, me) | 0, pe = pe + L | 0, Ce = Ce + j + v(pe, L) | 0;
      var Te = ae + P | 0, xe = Z + F + v(Te, ae) | 0;
      W = z, C = b, z = U, b = d, U = D, d = g, g = m + pe | 0, D = M + Ce + v(g, m) | 0, M = R, m = V, R = A, V = re, A = x, re = G, G = pe + Te | 0, x = Ce + xe + v(G, pe) | 0;
    }
    this._al = this._al + G | 0, this._bl = this._bl + re | 0, this._cl = this._cl + V | 0, this._dl = this._dl + m | 0, this._el = this._el + g | 0, this._fl = this._fl + d | 0, this._gl = this._gl + b | 0, this._hl = this._hl + C | 0, this._ah = this._ah + x + v(this._al, G) | 0, this._bh = this._bh + A + v(this._bl, re) | 0, this._ch = this._ch + R + v(this._cl, V) | 0, this._dh = this._dh + M + v(this._dl, m) | 0, this._eh = this._eh + D + v(this._el, g) | 0, this._fh = this._fh + U + v(this._fl, d) | 0, this._gh = this._gh + z + v(this._gl, b) | 0, this._hh = this._hh + W + v(this._hl, C) | 0;
  }, a.prototype._hash = function() {
    var y = i.allocUnsafe(64);
    function w(x, A, R) {
      y.writeInt32BE(x, R), y.writeInt32BE(A, R + 4);
    }
    return w(this._ah, this._al, 0), w(this._bh, this._bl, 8), w(this._ch, this._cl, 16), w(this._dh, this._dl, 24), w(this._eh, this._el, 32), w(this._fh, this._fl, 40), w(this._gh, this._gl, 48), w(this._hh, this._hl, 56), y;
  }, Tf = a, Tf;
}
var If, fc;
function K1() {
  if (fc)
    return If;
  fc = 1;
  var e = Ae(), t = vd(), i = Bi(), r = He().Buffer, n = new Array(160);
  function a() {
    this.init(), this._w = n, i.call(this, 128, 112);
  }
  return e(a, t), a.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, a.prototype._hash = function() {
    var f = r.allocUnsafe(48);
    function s(c, u, o) {
      f.writeInt32BE(c, o), f.writeInt32BE(u, o + 4);
    }
    return s(this._ah, this._al, 0), s(this._bh, this._bl, 8), s(this._ch, this._cl, 16), s(this._dh, this._dl, 24), s(this._eh, this._el, 32), s(this._fh, this._fl, 40), f;
  }, If = a, If;
}
var sc;
function t0() {
  if (sc)
    return Sf.exports;
  sc = 1;
  var e = Sf.exports = function(i) {
    i = i.toLowerCase();
    var r = e[i];
    if (!r)
      throw new Error(i + " is not supported (we accept pull requests)");
    return new r();
  };
  return e.sha = q1(), e.sha1 = F1(), e.sha224 = V1(), e.sha256 = pd(), e.sha384 = K1(), e.sha512 = vd(), Sf.exports;
}
var Rf, oc;
function Ur() {
  if (oc)
    return Rf;
  oc = 1;
  var e = He().Buffer, t = hd().Transform, i = Fi().StringDecoder, r = Ae();
  function n(c) {
    t.call(this), this.hashMode = typeof c == "string", this.hashMode ? this[c] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  r(n, t);
  var a = typeof Uint8Array < "u", f = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (e.prototype instanceof Uint8Array || e.TYPED_ARRAY_SUPPORT);
  function s(c, u) {
    if (c instanceof e)
      return c;
    if (typeof c == "string")
      return e.from(c, u);
    if (f && ArrayBuffer.isView(c)) {
      if (c.byteLength === 0)
        return e.alloc(0);
      var o = e.from(c.buffer, c.byteOffset, c.byteLength);
      if (o.byteLength === c.byteLength)
        return o;
    }
    if (a && c instanceof Uint8Array || e.isBuffer(c) && c.constructor && typeof c.constructor.isBuffer == "function" && c.constructor.isBuffer(c))
      return e.from(c);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return n.prototype.update = function(c, u, o) {
    var l = s(c, u), h = this._update(l);
    return this.hashMode ? this : (o && (h = this._toString(h, o)), h);
  }, n.prototype.setAutoPadding = function() {
  }, n.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, n.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, n.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, n.prototype._transform = function(c, u, o) {
    var l;
    try {
      this.hashMode ? this._update(c) : this.push(this._update(c));
    } catch (h) {
      l = h;
    } finally {
      o(l);
    }
  }, n.prototype._flush = function(c) {
    var u;
    try {
      this.push(this.__final());
    } catch (o) {
      u = o;
    }
    c(u);
  }, n.prototype._finalOrDigest = function(c) {
    var u = this.__final() || e.alloc(0);
    return c && (u = this._toString(u, c, !0)), u;
  }, n.prototype._toString = function(c, u, o) {
    if (this._decoder || (this._decoder = new i(u), this._encoding = u), this._encoding !== u)
      throw new Error("can’t switch encodings");
    var l = this._decoder.write(c);
    return o && (l += this._decoder.end()), l;
  }, Rf = n, Rf;
}
var Mf, uc;
function $i() {
  if (uc)
    return Mf;
  uc = 1;
  var e = Ae(), t = Jo(), i = e0(), r = t0(), n = Ur();
  function a(f) {
    n.call(this, "digest"), this._hash = f;
  }
  return e(a, n), a.prototype._update = function(f) {
    this._hash.update(f);
  }, a.prototype._final = function() {
    return this._hash.digest();
  }, Mf = function(s) {
    return s = s.toLowerCase(), s === "md5" ? new t() : s === "rmd160" || s === "ripemd160" ? new i() : new a(r(s));
  }, Mf;
}
var Nf, cc;
function H1() {
  if (cc)
    return Nf;
  cc = 1;
  var e = Ae(), t = He().Buffer, i = Ur(), r = t.alloc(128), n = 64;
  function a(f, s) {
    i.call(this, "digest"), typeof s == "string" && (s = t.from(s)), this._alg = f, this._key = s, s.length > n ? s = f(s) : s.length < n && (s = t.concat([s, r], n));
    for (var c = this._ipad = t.allocUnsafe(n), u = this._opad = t.allocUnsafe(n), o = 0; o < n; o++)
      c[o] = s[o] ^ 54, u[o] = s[o] ^ 92;
    this._hash = [c];
  }
  return e(a, i), a.prototype._update = function(f) {
    this._hash.push(f);
  }, a.prototype._final = function() {
    var f = this._alg(t.concat(this._hash));
    return this._alg(t.concat([this._opad, f]));
  }, Nf = a, Nf;
}
var kf, lc;
function yd() {
  if (lc)
    return kf;
  lc = 1;
  var e = Jo();
  return kf = function(t) {
    return new e().update(t).digest();
  }, kf;
}
var Df, hc;
function gd() {
  if (hc)
    return Df;
  hc = 1;
  var e = Ae(), t = H1(), i = Ur(), r = He().Buffer, n = yd(), a = e0(), f = t0(), s = r.alloc(128);
  function c(u, o) {
    i.call(this, "digest"), typeof o == "string" && (o = r.from(o));
    var l = u === "sha512" || u === "sha384" ? 128 : 64;
    if (this._alg = u, this._key = o, o.length > l) {
      var h = u === "rmd160" ? new a() : f(u);
      o = h.update(o).digest();
    } else
      o.length < l && (o = r.concat([o, s], l));
    for (var p = this._ipad = r.allocUnsafe(l), v = this._opad = r.allocUnsafe(l), y = 0; y < l; y++)
      p[y] = o[y] ^ 54, v[y] = o[y] ^ 92;
    this._hash = u === "rmd160" ? new a() : f(u), this._hash.update(p);
  }
  return e(c, i), c.prototype._update = function(u) {
    this._hash.update(u);
  }, c.prototype._final = function() {
    var u = this._hash.digest(), o = this._alg === "rmd160" ? new a() : f(this._alg);
    return o.update(this._opad).update(u).digest();
  }, Df = function(o, l) {
    return o = o.toLowerCase(), o === "rmd160" || o === "ripemd160" ? new c("rmd160", l) : o === "md5" ? new t(n, l) : new c(o, l);
  }, Df;
}
const j1 = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, z1 = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, G1 = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, $1 = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, W1 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, Q1 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, Y1 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, X1 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, Z1 = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, J1 = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, ev = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, bd = {
  sha224WithRSAEncryption: j1,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: z1,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: G1,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: $1,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: W1,
  sha224: Q1,
  sha384: Y1,
  sha512: X1,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: Z1,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: J1,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: ev,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var Lf, dc;
function tv() {
  return dc || (dc = 1, Lf = bd), Lf;
}
var na = {}, Pf, pc;
function md() {
  if (pc)
    return Pf;
  pc = 1;
  var e = Math.pow(2, 30) - 1;
  return Pf = function(t, i) {
    if (typeof t != "number")
      throw new TypeError("Iterations not a number");
    if (t < 0)
      throw new TypeError("Bad iterations");
    if (typeof i != "number")
      throw new TypeError("Key length not a number");
    if (i < 0 || i > e || i !== i)
      throw new TypeError("Bad key length");
  }, Pf;
}
var Uf, vc;
function xd() {
  if (vc)
    return Uf;
  vc = 1;
  var e;
  if (Ge.process && Ge.process.browser)
    e = "utf-8";
  else if (Ge.process && Ge.process.version) {
    var t = parseInt(fe.process.version.split(".")[0].slice(1), 10);
    e = t >= 6 ? "utf-8" : "binary";
  } else
    e = "utf-8";
  return Uf = e, Uf;
}
var Of, yc;
function _d() {
  if (yc)
    return Of;
  yc = 1;
  var e = He().Buffer;
  return Of = function(t, i, r) {
    if (e.isBuffer(t))
      return t;
    if (typeof t == "string")
      return e.from(t, i);
    if (ArrayBuffer.isView(t))
      return e.from(t.buffer);
    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
  }, Of;
}
var qf, gc;
function Sd() {
  if (gc)
    return qf;
  gc = 1;
  var e = yd(), t = e0(), i = t0(), r = He().Buffer, n = md(), a = xd(), f = _d(), s = r.alloc(128), c = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function u(h, p, v) {
    var y = o(h), w = h === "sha512" || h === "sha384" ? 128 : 64;
    p.length > w ? p = y(p) : p.length < w && (p = r.concat([p, s], w));
    for (var x = r.allocUnsafe(w + c[h]), A = r.allocUnsafe(w + c[h]), R = 0; R < w; R++)
      x[R] = p[R] ^ 54, A[R] = p[R] ^ 92;
    var M = r.allocUnsafe(w + v + 4);
    x.copy(M, 0, 0, w), this.ipad1 = M, this.ipad2 = x, this.opad = A, this.alg = h, this.blocksize = w, this.hash = y, this.size = c[h];
  }
  u.prototype.run = function(h, p) {
    h.copy(p, this.blocksize);
    var v = this.hash(p);
    return v.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function o(h) {
    function p(y) {
      return i(h).update(y).digest();
    }
    function v(y) {
      return new t().update(y).digest();
    }
    return h === "rmd160" || h === "ripemd160" ? v : h === "md5" ? e : p;
  }
  function l(h, p, v, y, w) {
    n(v, y), h = f(h, a, "Password"), p = f(p, a, "Salt"), w = w || "sha1";
    var x = new u(w, h, p.length), A = r.allocUnsafe(y), R = r.allocUnsafe(p.length + 4);
    p.copy(R, 0, 0, p.length);
    for (var M = 0, D = c[w], U = Math.ceil(y / D), z = 1; z <= U; z++) {
      R.writeUInt32BE(z, p.length);
      for (var W = x.run(R, x.ipad1), G = W, re = 1; re < v; re++) {
        G = x.run(G, x.ipad2);
        for (var V = 0; V < D; V++)
          W[V] ^= G[V];
      }
      W.copy(A, M), M += D;
    }
    return A;
  }
  return qf = l, qf;
}
var Ff, bc;
function rv() {
  if (bc)
    return Ff;
  bc = 1;
  var e = He().Buffer, t = md(), i = xd(), r = Sd(), n = _d(), a, f = Ge.crypto && Ge.crypto.subtle, s = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, c = [];
  function u(v) {
    if (Ge.process && !Ge.process.browser || !f || !f.importKey || !f.deriveBits)
      return Promise.resolve(!1);
    if (c[v] !== void 0)
      return c[v];
    a = a || e.alloc(8);
    var y = h(a, a, 10, 128, v).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return c[v] = y, y;
  }
  var o;
  function l() {
    return o || (Ge.process && Ge.process.nextTick ? o = Ge.process.nextTick : Ge.queueMicrotask ? o = Ge.queueMicrotask : Ge.setImmediate ? o = Ge.setImmediate : o = Ge.setTimeout, o);
  }
  function h(v, y, w, x, A) {
    return f.importKey(
      "raw",
      v,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(R) {
      return f.deriveBits({
        name: "PBKDF2",
        salt: y,
        iterations: w,
        hash: {
          name: A
        }
      }, R, x << 3);
    }).then(function(R) {
      return e.from(R);
    });
  }
  function p(v, y) {
    v.then(function(w) {
      l()(function() {
        y(null, w);
      });
    }, function(w) {
      l()(function() {
        y(w);
      });
    });
  }
  return Ff = function(v, y, w, x, A, R) {
    typeof A == "function" && (R = A, A = void 0), A = A || "sha1";
    var M = s[A.toLowerCase()];
    if (!M || typeof Ge.Promise != "function") {
      l()(function() {
        var D;
        try {
          D = r(v, y, w, x, A);
        } catch (U) {
          return R(U);
        }
        R(null, D);
      });
      return;
    }
    if (t(w, x), v = n(v, i, "Password"), y = n(y, i, "Salt"), typeof R != "function")
      throw new Error("No callback provided to pbkdf2");
    p(u(M).then(function(D) {
      return D ? h(v, y, w, x, M) : r(v, y, w, x, A);
    }), R);
  }, Ff;
}
var mc;
function Ed() {
  return mc || (mc = 1, na.pbkdf2 = rv(), na.pbkdf2Sync = Sd()), na;
}
var er = {}, ti = {}, Xt = {}, xc;
function wd() {
  if (xc)
    return Xt;
  xc = 1, Xt.readUInt32BE = function(n, a) {
    var f = n[0 + a] << 24 | n[1 + a] << 16 | n[2 + a] << 8 | n[3 + a];
    return f >>> 0;
  }, Xt.writeUInt32BE = function(n, a, f) {
    n[0 + f] = a >>> 24, n[1 + f] = a >>> 16 & 255, n[2 + f] = a >>> 8 & 255, n[3 + f] = a & 255;
  }, Xt.ip = function(n, a, f, s) {
    for (var c = 0, u = 0, o = 6; o >= 0; o -= 2) {
      for (var l = 0; l <= 24; l += 8)
        c <<= 1, c |= a >>> l + o & 1;
      for (var l = 0; l <= 24; l += 8)
        c <<= 1, c |= n >>> l + o & 1;
    }
    for (var o = 6; o >= 0; o -= 2) {
      for (var l = 1; l <= 25; l += 8)
        u <<= 1, u |= a >>> l + o & 1;
      for (var l = 1; l <= 25; l += 8)
        u <<= 1, u |= n >>> l + o & 1;
    }
    f[s + 0] = c >>> 0, f[s + 1] = u >>> 0;
  }, Xt.rip = function(n, a, f, s) {
    for (var c = 0, u = 0, o = 0; o < 4; o++)
      for (var l = 24; l >= 0; l -= 8)
        c <<= 1, c |= a >>> l + o & 1, c <<= 1, c |= n >>> l + o & 1;
    for (var o = 4; o < 8; o++)
      for (var l = 24; l >= 0; l -= 8)
        u <<= 1, u |= a >>> l + o & 1, u <<= 1, u |= n >>> l + o & 1;
    f[s + 0] = c >>> 0, f[s + 1] = u >>> 0;
  }, Xt.pc1 = function(n, a, f, s) {
    for (var c = 0, u = 0, o = 7; o >= 5; o--) {
      for (var l = 0; l <= 24; l += 8)
        c <<= 1, c |= a >> l + o & 1;
      for (var l = 0; l <= 24; l += 8)
        c <<= 1, c |= n >> l + o & 1;
    }
    for (var l = 0; l <= 24; l += 8)
      c <<= 1, c |= a >> l + o & 1;
    for (var o = 1; o <= 3; o++) {
      for (var l = 0; l <= 24; l += 8)
        u <<= 1, u |= a >> l + o & 1;
      for (var l = 0; l <= 24; l += 8)
        u <<= 1, u |= n >> l + o & 1;
    }
    for (var l = 0; l <= 24; l += 8)
      u <<= 1, u |= n >> l + o & 1;
    f[s + 0] = c >>> 0, f[s + 1] = u >>> 0;
  }, Xt.r28shl = function(n, a) {
    return n << a & 268435455 | n >>> 28 - a;
  };
  var e = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  Xt.pc2 = function(n, a, f, s) {
    for (var c = 0, u = 0, o = e.length >>> 1, l = 0; l < o; l++)
      c <<= 1, c |= n >>> e[l] & 1;
    for (var l = o; l < e.length; l++)
      u <<= 1, u |= a >>> e[l] & 1;
    f[s + 0] = c >>> 0, f[s + 1] = u >>> 0;
  }, Xt.expand = function(n, a, f) {
    var s = 0, c = 0;
    s = (n & 1) << 5 | n >>> 27;
    for (var u = 23; u >= 15; u -= 4)
      s <<= 6, s |= n >>> u & 63;
    for (var u = 11; u >= 3; u -= 4)
      c |= n >>> u & 63, c <<= 6;
    c |= (n & 31) << 1 | n >>> 31, a[f + 0] = s >>> 0, a[f + 1] = c >>> 0;
  };
  var t = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  Xt.substitute = function(n, a) {
    for (var f = 0, s = 0; s < 4; s++) {
      var c = n >>> 18 - s * 6 & 63, u = t[s * 64 + c];
      f <<= 4, f |= u;
    }
    for (var s = 0; s < 4; s++) {
      var c = a >>> 18 - s * 6 & 63, u = t[4 * 64 + s * 64 + c];
      f <<= 4, f |= u;
    }
    return f >>> 0;
  };
  var i = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return Xt.permute = function(n) {
    for (var a = 0, f = 0; f < i.length; f++)
      a <<= 1, a |= n >>> i[f] & 1;
    return a >>> 0;
  }, Xt.padSplit = function(n, a, f) {
    for (var s = n.toString(2); s.length < a; )
      s = "0" + s;
    for (var c = [], u = 0; u < a; u += f)
      c.push(s.slice(u, u + f));
    return c.join(" ");
  }, Xt;
}
var Vf, _c;
function ur() {
  if (_c)
    return Vf;
  _c = 1, Vf = e;
  function e(t, i) {
    if (!t)
      throw new Error(i || "Assertion failed");
  }
  return e.equal = function(i, r, n) {
    if (i != r)
      throw new Error(n || "Assertion failed: " + i + " != " + r);
  }, Vf;
}
var Kf, Sc;
function r0() {
  if (Sc)
    return Kf;
  Sc = 1;
  var e = ur();
  function t(i) {
    this.options = i, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = i.padding !== !1;
  }
  return Kf = t, t.prototype._init = function() {
  }, t.prototype.update = function(r) {
    return r.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(r) : this._updateEncrypt(r);
  }, t.prototype._buffer = function(r, n) {
    for (var a = Math.min(this.buffer.length - this.bufferOff, r.length - n), f = 0; f < a; f++)
      this.buffer[this.bufferOff + f] = r[n + f];
    return this.bufferOff += a, a;
  }, t.prototype._flushBuffer = function(r, n) {
    return this._update(this.buffer, 0, r, n), this.bufferOff = 0, this.blockSize;
  }, t.prototype._updateEncrypt = function(r) {
    var n = 0, a = 0, f = (this.bufferOff + r.length) / this.blockSize | 0, s = new Array(f * this.blockSize);
    this.bufferOff !== 0 && (n += this._buffer(r, n), this.bufferOff === this.buffer.length && (a += this._flushBuffer(s, a)));
    for (var c = r.length - (r.length - n) % this.blockSize; n < c; n += this.blockSize)
      this._update(r, n, s, a), a += this.blockSize;
    for (; n < r.length; n++, this.bufferOff++)
      this.buffer[this.bufferOff] = r[n];
    return s;
  }, t.prototype._updateDecrypt = function(r) {
    for (var n = 0, a = 0, f = Math.ceil((this.bufferOff + r.length) / this.blockSize) - 1, s = new Array(f * this.blockSize); f > 0; f--)
      n += this._buffer(r, n), a += this._flushBuffer(s, a);
    return n += this._buffer(r, n), s;
  }, t.prototype.final = function(r) {
    var n;
    r && (n = this.update(r));
    var a;
    return this.type === "encrypt" ? a = this._finalEncrypt() : a = this._finalDecrypt(), n ? n.concat(a) : a;
  }, t.prototype._pad = function(r, n) {
    if (n === 0)
      return !1;
    for (; n < r.length; )
      r[n++] = 0;
    return !0;
  }, t.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var r = new Array(this.blockSize);
    return this._update(this.buffer, 0, r, 0), r;
  }, t.prototype._unpad = function(r) {
    return r;
  }, t.prototype._finalDecrypt = function() {
    e.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var r = new Array(this.blockSize);
    return this._flushBuffer(r, 0), this._unpad(r);
  }, Kf;
}
var Hf, Ec;
function Cd() {
  if (Ec)
    return Hf;
  Ec = 1;
  var e = ur(), t = Ae(), i = wd(), r = r0();
  function n() {
    this.tmp = new Array(2), this.keys = null;
  }
  function a(s) {
    r.call(this, s);
    var c = new n();
    this._desState = c, this.deriveKeys(c, s.key);
  }
  t(a, r), Hf = a, a.create = function(c) {
    return new a(c);
  };
  var f = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return a.prototype.deriveKeys = function(c, u) {
    c.keys = new Array(16 * 2), e.equal(u.length, this.blockSize, "Invalid key length");
    var o = i.readUInt32BE(u, 0), l = i.readUInt32BE(u, 4);
    i.pc1(o, l, c.tmp, 0), o = c.tmp[0], l = c.tmp[1];
    for (var h = 0; h < c.keys.length; h += 2) {
      var p = f[h >>> 1];
      o = i.r28shl(o, p), l = i.r28shl(l, p), i.pc2(o, l, c.keys, h);
    }
  }, a.prototype._update = function(c, u, o, l) {
    var h = this._desState, p = i.readUInt32BE(c, u), v = i.readUInt32BE(c, u + 4);
    i.ip(p, v, h.tmp, 0), p = h.tmp[0], v = h.tmp[1], this.type === "encrypt" ? this._encrypt(h, p, v, h.tmp, 0) : this._decrypt(h, p, v, h.tmp, 0), p = h.tmp[0], v = h.tmp[1], i.writeUInt32BE(o, p, l), i.writeUInt32BE(o, v, l + 4);
  }, a.prototype._pad = function(c, u) {
    if (this.padding === !1)
      return !1;
    for (var o = c.length - u, l = u; l < c.length; l++)
      c[l] = o;
    return !0;
  }, a.prototype._unpad = function(c) {
    if (this.padding === !1)
      return c;
    for (var u = c[c.length - 1], o = c.length - u; o < c.length; o++)
      e.equal(c[o], u);
    return c.slice(0, c.length - u);
  }, a.prototype._encrypt = function(c, u, o, l, h) {
    for (var p = u, v = o, y = 0; y < c.keys.length; y += 2) {
      var w = c.keys[y], x = c.keys[y + 1];
      i.expand(v, c.tmp, 0), w ^= c.tmp[0], x ^= c.tmp[1];
      var A = i.substitute(w, x), R = i.permute(A), M = v;
      v = (p ^ R) >>> 0, p = M;
    }
    i.rip(v, p, l, h);
  }, a.prototype._decrypt = function(c, u, o, l, h) {
    for (var p = o, v = u, y = c.keys.length - 2; y >= 0; y -= 2) {
      var w = c.keys[y], x = c.keys[y + 1];
      i.expand(p, c.tmp, 0), w ^= c.tmp[0], x ^= c.tmp[1];
      var A = i.substitute(w, x), R = i.permute(A), M = p;
      p = (v ^ R) >>> 0, v = M;
    }
    i.rip(p, v, l, h);
  }, Hf;
}
var jf = {}, wc;
function iv() {
  if (wc)
    return jf;
  wc = 1;
  var e = ur(), t = Ae(), i = {};
  function r(a) {
    e.equal(a.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var f = 0; f < this.iv.length; f++)
      this.iv[f] = a[f];
  }
  function n(a) {
    function f(o) {
      a.call(this, o), this._cbcInit();
    }
    t(f, a);
    for (var s = Object.keys(i), c = 0; c < s.length; c++) {
      var u = s[c];
      f.prototype[u] = i[u];
    }
    return f.create = function(l) {
      return new f(l);
    }, f;
  }
  return jf.instantiate = n, i._cbcInit = function() {
    var f = new r(this.options.iv);
    this._cbcState = f;
  }, i._update = function(f, s, c, u) {
    var o = this._cbcState, l = this.constructor.super_.prototype, h = o.iv;
    if (this.type === "encrypt") {
      for (var p = 0; p < this.blockSize; p++)
        h[p] ^= f[s + p];
      l._update.call(this, h, 0, c, u);
      for (var p = 0; p < this.blockSize; p++)
        h[p] = c[u + p];
    } else {
      l._update.call(this, f, s, c, u);
      for (var p = 0; p < this.blockSize; p++)
        c[u + p] ^= h[p];
      for (var p = 0; p < this.blockSize; p++)
        h[p] = f[s + p];
    }
  }, jf;
}
var zf, Cc;
function av() {
  if (Cc)
    return zf;
  Cc = 1;
  var e = ur(), t = Ae(), i = r0(), r = Cd();
  function n(f, s) {
    e.equal(s.length, 24, "Invalid key length");
    var c = s.slice(0, 8), u = s.slice(8, 16), o = s.slice(16, 24);
    f === "encrypt" ? this.ciphers = [
      r.create({ type: "encrypt", key: c }),
      r.create({ type: "decrypt", key: u }),
      r.create({ type: "encrypt", key: o })
    ] : this.ciphers = [
      r.create({ type: "decrypt", key: o }),
      r.create({ type: "encrypt", key: u }),
      r.create({ type: "decrypt", key: c })
    ];
  }
  function a(f) {
    i.call(this, f);
    var s = new n(this.type, this.options.key);
    this._edeState = s;
  }
  return t(a, i), zf = a, a.create = function(s) {
    return new a(s);
  }, a.prototype._update = function(s, c, u, o) {
    var l = this._edeState;
    l.ciphers[0]._update(s, c, u, o), l.ciphers[1]._update(u, o, u, o), l.ciphers[2]._update(u, o, u, o);
  }, a.prototype._pad = r.prototype._pad, a.prototype._unpad = r.prototype._unpad, zf;
}
var Ac;
function nv() {
  return Ac || (Ac = 1, ti.utils = wd(), ti.Cipher = r0(), ti.DES = Cd(), ti.CBC = iv(), ti.EDE = av()), ti;
}
var Gf, Bc;
function fv() {
  if (Bc)
    return Gf;
  Bc = 1;
  var e = Ur(), t = nv(), i = Ae(), r = He().Buffer, n = {
    "des-ede3-cbc": t.CBC.instantiate(t.EDE),
    "des-ede3": t.EDE,
    "des-ede-cbc": t.CBC.instantiate(t.EDE),
    "des-ede": t.EDE,
    "des-cbc": t.CBC.instantiate(t.DES),
    "des-ecb": t.DES
  };
  n.des = n["des-cbc"], n.des3 = n["des-ede3-cbc"], Gf = a, i(a, e);
  function a(f) {
    e.call(this);
    var s = f.mode.toLowerCase(), c = n[s], u;
    f.decrypt ? u = "decrypt" : u = "encrypt";
    var o = f.key;
    r.isBuffer(o) || (o = r.from(o)), (s === "des-ede" || s === "des-ede-cbc") && (o = r.concat([o, o.slice(0, 8)]));
    var l = f.iv;
    r.isBuffer(l) || (l = r.from(l)), this._des = c.create({
      key: o,
      iv: l,
      type: u
    });
  }
  return a.prototype._update = function(f) {
    return r.from(this._des.update(f));
  }, a.prototype._final = function() {
    return r.from(this._des.final());
  }, Gf;
}
var tr = {}, fa = {}, sa = {}, Tc;
function sv() {
  return Tc || (Tc = 1, sa.encrypt = function(e, t) {
    return e._cipher.encryptBlock(t);
  }, sa.decrypt = function(e, t) {
    return e._cipher.decryptBlock(t);
  }), sa;
}
var oa = {}, $f, Ic;
function Wi() {
  return Ic || (Ic = 1, $f = function(t, i) {
    for (var r = Math.min(t.length, i.length), n = new fe.Buffer(r), a = 0; a < r; ++a)
      n[a] = t[a] ^ i[a];
    return n;
  }), $f;
}
var Rc;
function ov() {
  if (Rc)
    return oa;
  Rc = 1;
  var e = Wi();
  return oa.encrypt = function(t, i) {
    var r = e(i, t._prev);
    return t._prev = t._cipher.encryptBlock(r), t._prev;
  }, oa.decrypt = function(t, i) {
    var r = t._prev;
    t._prev = i;
    var n = t._cipher.decryptBlock(i);
    return e(n, r);
  }, oa;
}
var Wf = {}, Mc;
function uv() {
  if (Mc)
    return Wf;
  Mc = 1;
  var e = He().Buffer, t = Wi();
  function i(r, n, a) {
    var f = n.length, s = t(n, r._cache);
    return r._cache = r._cache.slice(f), r._prev = e.concat([r._prev, a ? n : s]), s;
  }
  return Wf.encrypt = function(r, n, a) {
    for (var f = e.allocUnsafe(0), s; n.length; )
      if (r._cache.length === 0 && (r._cache = r._cipher.encryptBlock(r._prev), r._prev = e.allocUnsafe(0)), r._cache.length <= n.length)
        s = r._cache.length, f = e.concat([f, i(r, n.slice(0, s), a)]), n = n.slice(s);
      else {
        f = e.concat([f, i(r, n, a)]);
        break;
      }
    return f;
  }, Wf;
}
var Qf = {}, Nc;
function cv() {
  if (Nc)
    return Qf;
  Nc = 1;
  var e = He().Buffer;
  function t(i, r, n) {
    var a = i._cipher.encryptBlock(i._prev), f = a[0] ^ r;
    return i._prev = e.concat([
      i._prev.slice(1),
      e.from([n ? r : f])
    ]), f;
  }
  return Qf.encrypt = function(i, r, n) {
    for (var a = r.length, f = e.allocUnsafe(a), s = -1; ++s < a; )
      f[s] = t(i, r[s], n);
    return f;
  }, Qf;
}
var Yf = {}, kc;
function lv() {
  if (kc)
    return Yf;
  kc = 1;
  var e = He().Buffer;
  function t(r, n, a) {
    for (var f, s = -1, c = 8, u = 0, o, l; ++s < c; )
      f = r._cipher.encryptBlock(r._prev), o = n & 1 << 7 - s ? 128 : 0, l = f[0] ^ o, u += (l & 128) >> s % 8, r._prev = i(r._prev, a ? o : l);
    return u;
  }
  function i(r, n) {
    var a = r.length, f = -1, s = e.allocUnsafe(r.length);
    for (r = e.concat([r, e.from([n])]); ++f < a; )
      s[f] = r[f] << 1 | r[f + 1] >> 7;
    return s;
  }
  return Yf.encrypt = function(r, n, a) {
    for (var f = n.length, s = e.allocUnsafe(f), c = -1; ++c < f; )
      s[c] = t(r, n[c], a);
    return s;
  }, Yf;
}
var Xf = {}, Dc;
function hv() {
  if (Dc)
    return Xf;
  Dc = 1;
  var e = Wi();
  function t(i) {
    return i._prev = i._cipher.encryptBlock(i._prev), i._prev;
  }
  return Xf.encrypt = function(i, r) {
    for (; i._cache.length < r.length; )
      i._cache = fe.Buffer.concat([i._cache, t(i)]);
    var n = i._cache.slice(0, r.length);
    return i._cache = i._cache.slice(r.length), e(r, n);
  }, Xf;
}
var Zf = {}, Jf, Lc;
function Ad() {
  if (Lc)
    return Jf;
  Lc = 1;
  function e(t) {
    for (var i = t.length, r; i--; )
      if (r = t.readUInt8(i), r === 255)
        t.writeUInt8(0, i);
      else {
        r++, t.writeUInt8(r, i);
        break;
      }
  }
  return Jf = e, Jf;
}
var Pc;
function Uc() {
  if (Pc)
    return Zf;
  Pc = 1;
  var e = Wi(), t = He().Buffer, i = Ad();
  function r(a) {
    var f = a._cipher.encryptBlockRaw(a._prev);
    return i(a._prev), f;
  }
  var n = 16;
  return Zf.encrypt = function(a, f) {
    var s = Math.ceil(f.length / n), c = a._cache.length;
    a._cache = t.concat([
      a._cache,
      t.allocUnsafe(s * n)
    ]);
    for (var u = 0; u < s; u++) {
      var o = r(a), l = c + u * n;
      a._cache.writeUInt32BE(o[0], l + 0), a._cache.writeUInt32BE(o[1], l + 4), a._cache.writeUInt32BE(o[2], l + 8), a._cache.writeUInt32BE(o[3], l + 12);
    }
    var h = a._cache.slice(0, f.length);
    return a._cache = a._cache.slice(f.length), e(f, h);
  }, Zf;
}
const dv = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, pv = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, vv = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, Bd = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: dv,
  aes192: pv,
  aes256: vv,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var es, Oc;
function i0() {
  if (Oc)
    return es;
  Oc = 1;
  var e = {
    ECB: sv(),
    CBC: ov(),
    CFB: uv(),
    CFB8: cv(),
    CFB1: lv(),
    OFB: hv(),
    CTR: Uc(),
    GCM: Uc()
  }, t = Bd;
  for (var i in t)
    t[i].module = e[t[i].mode];
  return es = t, es;
}
var ts = {}, qc;
function Va() {
  if (qc)
    return ts;
  qc = 1;
  var e = He().Buffer;
  function t(s) {
    e.isBuffer(s) || (s = e.from(s));
    for (var c = s.length / 4 | 0, u = new Array(c), o = 0; o < c; o++)
      u[o] = s.readUInt32BE(o * 4);
    return u;
  }
  function i(s) {
    for (var c = 0; c < s.length; s++)
      s[c] = 0;
  }
  function r(s, c, u, o, l) {
    for (var h = u[0], p = u[1], v = u[2], y = u[3], w = s[0] ^ c[0], x = s[1] ^ c[1], A = s[2] ^ c[2], R = s[3] ^ c[3], M, D, U, z, W = 4, G = 1; G < l; G++)
      M = h[w >>> 24] ^ p[x >>> 16 & 255] ^ v[A >>> 8 & 255] ^ y[R & 255] ^ c[W++], D = h[x >>> 24] ^ p[A >>> 16 & 255] ^ v[R >>> 8 & 255] ^ y[w & 255] ^ c[W++], U = h[A >>> 24] ^ p[R >>> 16 & 255] ^ v[w >>> 8 & 255] ^ y[x & 255] ^ c[W++], z = h[R >>> 24] ^ p[w >>> 16 & 255] ^ v[x >>> 8 & 255] ^ y[A & 255] ^ c[W++], w = M, x = D, A = U, R = z;
    return M = (o[w >>> 24] << 24 | o[x >>> 16 & 255] << 16 | o[A >>> 8 & 255] << 8 | o[R & 255]) ^ c[W++], D = (o[x >>> 24] << 24 | o[A >>> 16 & 255] << 16 | o[R >>> 8 & 255] << 8 | o[w & 255]) ^ c[W++], U = (o[A >>> 24] << 24 | o[R >>> 16 & 255] << 16 | o[w >>> 8 & 255] << 8 | o[x & 255]) ^ c[W++], z = (o[R >>> 24] << 24 | o[w >>> 16 & 255] << 16 | o[x >>> 8 & 255] << 8 | o[A & 255]) ^ c[W++], M = M >>> 0, D = D >>> 0, U = U >>> 0, z = z >>> 0, [M, D, U, z];
  }
  var n = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], a = function() {
    for (var s = new Array(256), c = 0; c < 256; c++)
      c < 128 ? s[c] = c << 1 : s[c] = c << 1 ^ 283;
    for (var u = [], o = [], l = [[], [], [], []], h = [[], [], [], []], p = 0, v = 0, y = 0; y < 256; ++y) {
      var w = v ^ v << 1 ^ v << 2 ^ v << 3 ^ v << 4;
      w = w >>> 8 ^ w & 255 ^ 99, u[p] = w, o[w] = p;
      var x = s[p], A = s[x], R = s[A], M = s[w] * 257 ^ w * 16843008;
      l[0][p] = M << 24 | M >>> 8, l[1][p] = M << 16 | M >>> 16, l[2][p] = M << 8 | M >>> 24, l[3][p] = M, M = R * 16843009 ^ A * 65537 ^ x * 257 ^ p * 16843008, h[0][w] = M << 24 | M >>> 8, h[1][w] = M << 16 | M >>> 16, h[2][w] = M << 8 | M >>> 24, h[3][w] = M, p === 0 ? p = v = 1 : (p = x ^ s[s[s[R ^ x]]], v ^= s[s[v]]);
    }
    return {
      SBOX: u,
      INV_SBOX: o,
      SUB_MIX: l,
      INV_SUB_MIX: h
    };
  }();
  function f(s) {
    this._key = t(s), this._reset();
  }
  return f.blockSize = 4 * 4, f.keySize = 256 / 8, f.prototype.blockSize = f.blockSize, f.prototype.keySize = f.keySize, f.prototype._reset = function() {
    for (var s = this._key, c = s.length, u = c + 6, o = (u + 1) * 4, l = [], h = 0; h < c; h++)
      l[h] = s[h];
    for (h = c; h < o; h++) {
      var p = l[h - 1];
      h % c === 0 ? (p = p << 8 | p >>> 24, p = a.SBOX[p >>> 24] << 24 | a.SBOX[p >>> 16 & 255] << 16 | a.SBOX[p >>> 8 & 255] << 8 | a.SBOX[p & 255], p ^= n[h / c | 0] << 24) : c > 6 && h % c === 4 && (p = a.SBOX[p >>> 24] << 24 | a.SBOX[p >>> 16 & 255] << 16 | a.SBOX[p >>> 8 & 255] << 8 | a.SBOX[p & 255]), l[h] = l[h - c] ^ p;
    }
    for (var v = [], y = 0; y < o; y++) {
      var w = o - y, x = l[w - (y % 4 ? 0 : 4)];
      y < 4 || w <= 4 ? v[y] = x : v[y] = a.INV_SUB_MIX[0][a.SBOX[x >>> 24]] ^ a.INV_SUB_MIX[1][a.SBOX[x >>> 16 & 255]] ^ a.INV_SUB_MIX[2][a.SBOX[x >>> 8 & 255]] ^ a.INV_SUB_MIX[3][a.SBOX[x & 255]];
    }
    this._nRounds = u, this._keySchedule = l, this._invKeySchedule = v;
  }, f.prototype.encryptBlockRaw = function(s) {
    return s = t(s), r(s, this._keySchedule, a.SUB_MIX, a.SBOX, this._nRounds);
  }, f.prototype.encryptBlock = function(s) {
    var c = this.encryptBlockRaw(s), u = e.allocUnsafe(16);
    return u.writeUInt32BE(c[0], 0), u.writeUInt32BE(c[1], 4), u.writeUInt32BE(c[2], 8), u.writeUInt32BE(c[3], 12), u;
  }, f.prototype.decryptBlock = function(s) {
    s = t(s);
    var c = s[1];
    s[1] = s[3], s[3] = c;
    var u = r(s, this._invKeySchedule, a.INV_SUB_MIX, a.INV_SBOX, this._nRounds), o = e.allocUnsafe(16);
    return o.writeUInt32BE(u[0], 0), o.writeUInt32BE(u[3], 4), o.writeUInt32BE(u[2], 8), o.writeUInt32BE(u[1], 12), o;
  }, f.prototype.scrub = function() {
    i(this._keySchedule), i(this._invKeySchedule), i(this._key);
  }, ts.AES = f, ts;
}
var rs, Fc;
function yv() {
  if (Fc)
    return rs;
  Fc = 1;
  var e = He().Buffer, t = e.alloc(16, 0);
  function i(a) {
    return [
      a.readUInt32BE(0),
      a.readUInt32BE(4),
      a.readUInt32BE(8),
      a.readUInt32BE(12)
    ];
  }
  function r(a) {
    var f = e.allocUnsafe(16);
    return f.writeUInt32BE(a[0] >>> 0, 0), f.writeUInt32BE(a[1] >>> 0, 4), f.writeUInt32BE(a[2] >>> 0, 8), f.writeUInt32BE(a[3] >>> 0, 12), f;
  }
  function n(a) {
    this.h = a, this.state = e.alloc(16, 0), this.cache = e.allocUnsafe(0);
  }
  return n.prototype.ghash = function(a) {
    for (var f = -1; ++f < a.length; )
      this.state[f] ^= a[f];
    this._multiply();
  }, n.prototype._multiply = function() {
    for (var a = i(this.h), f = [0, 0, 0, 0], s, c, u, o = -1; ++o < 128; ) {
      for (c = (this.state[~~(o / 8)] & 1 << 7 - o % 8) !== 0, c && (f[0] ^= a[0], f[1] ^= a[1], f[2] ^= a[2], f[3] ^= a[3]), u = (a[3] & 1) !== 0, s = 3; s > 0; s--)
        a[s] = a[s] >>> 1 | (a[s - 1] & 1) << 31;
      a[0] = a[0] >>> 1, u && (a[0] = a[0] ^ 225 << 24);
    }
    this.state = r(f);
  }, n.prototype.update = function(a) {
    this.cache = e.concat([this.cache, a]);
    for (var f; this.cache.length >= 16; )
      f = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(f);
  }, n.prototype.final = function(a, f) {
    return this.cache.length && this.ghash(e.concat([this.cache, t], 16)), this.ghash(r([0, a, 0, f])), this.state;
  }, rs = n, rs;
}
var is, Vc;
function Td() {
  if (Vc)
    return is;
  Vc = 1;
  var e = Va(), t = He().Buffer, i = Ur(), r = Ae(), n = yv(), a = Wi(), f = Ad();
  function s(o, l) {
    var h = 0;
    o.length !== l.length && h++;
    for (var p = Math.min(o.length, l.length), v = 0; v < p; ++v)
      h += o[v] ^ l[v];
    return h;
  }
  function c(o, l, h) {
    if (l.length === 12)
      return o._finID = t.concat([l, t.from([0, 0, 0, 1])]), t.concat([l, t.from([0, 0, 0, 2])]);
    var p = new n(h), v = l.length, y = v % 16;
    p.update(l), y && (y = 16 - y, p.update(t.alloc(y, 0))), p.update(t.alloc(8, 0));
    var w = v * 8, x = t.alloc(8);
    x.writeUIntBE(w, 0, 8), p.update(x), o._finID = p.state;
    var A = t.from(o._finID);
    return f(A), A;
  }
  function u(o, l, h, p) {
    i.call(this);
    var v = t.alloc(4, 0);
    this._cipher = new e.AES(l);
    var y = this._cipher.encryptBlock(v);
    this._ghash = new n(y), h = c(this, h, y), this._prev = t.from(h), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = p, this._alen = 0, this._len = 0, this._mode = o, this._authTag = null, this._called = !1;
  }
  return r(u, i), u.prototype._update = function(o) {
    if (!this._called && this._alen) {
      var l = 16 - this._alen % 16;
      l < 16 && (l = t.alloc(l, 0), this._ghash.update(l));
    }
    this._called = !0;
    var h = this._mode.encrypt(this, o);
    return this._decrypt ? this._ghash.update(o) : this._ghash.update(h), this._len += o.length, h;
  }, u.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var o = a(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && s(o, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = o, this._cipher.scrub();
  }, u.prototype.getAuthTag = function() {
    if (this._decrypt || !t.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, u.prototype.setAuthTag = function(l) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = l;
  }, u.prototype.setAAD = function(l) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(l), this._alen += l.length;
  }, is = u, is;
}
var as, Kc;
function Id() {
  if (Kc)
    return as;
  Kc = 1;
  var e = Va(), t = He().Buffer, i = Ur(), r = Ae();
  function n(a, f, s, c) {
    i.call(this), this._cipher = new e.AES(f), this._prev = t.from(s), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = c, this._mode = a;
  }
  return r(n, i), n.prototype._update = function(a) {
    return this._mode.encrypt(this, a, this._decrypt);
  }, n.prototype._final = function() {
    this._cipher.scrub();
  }, as = n, as;
}
var ns, Hc;
function Ka() {
  if (Hc)
    return ns;
  Hc = 1;
  var e = He().Buffer, t = Jo();
  function i(r, n, a, f) {
    if (e.isBuffer(r) || (r = e.from(r, "binary")), n && (e.isBuffer(n) || (n = e.from(n, "binary")), n.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var s = a / 8, c = e.alloc(s), u = e.alloc(f || 0), o = e.alloc(0); s > 0 || f > 0; ) {
      var l = new t();
      l.update(o), l.update(r), n && l.update(n), o = l.digest();
      var h = 0;
      if (s > 0) {
        var p = c.length - s;
        h = Math.min(s, o.length), o.copy(c, p, 0, h), s -= h;
      }
      if (h < o.length && f > 0) {
        var v = u.length - f, y = Math.min(f, o.length - h);
        o.copy(u, v, h, h + y), f -= y;
      }
    }
    return o.fill(0), { key: c, iv: u };
  }
  return ns = i, ns;
}
var jc;
function gv() {
  if (jc)
    return fa;
  jc = 1;
  var e = i0(), t = Td(), i = He().Buffer, r = Id(), n = Ur(), a = Va(), f = Ka(), s = Ae();
  function c(p, v, y) {
    n.call(this), this._cache = new o(), this._cipher = new a.AES(v), this._prev = i.from(y), this._mode = p, this._autopadding = !0;
  }
  s(c, n), c.prototype._update = function(p) {
    this._cache.add(p);
    for (var v, y, w = []; v = this._cache.get(); )
      y = this._mode.encrypt(this, v), w.push(y);
    return i.concat(w);
  };
  var u = i.alloc(16, 16);
  c.prototype._final = function() {
    var p = this._cache.flush();
    if (this._autopadding)
      return p = this._mode.encrypt(this, p), this._cipher.scrub(), p;
    if (!p.equals(u))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, c.prototype.setAutoPadding = function(p) {
    return this._autopadding = !!p, this;
  };
  function o() {
    this.cache = i.allocUnsafe(0);
  }
  o.prototype.add = function(p) {
    this.cache = i.concat([this.cache, p]);
  }, o.prototype.get = function() {
    if (this.cache.length > 15) {
      var p = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), p;
    }
    return null;
  }, o.prototype.flush = function() {
    for (var p = 16 - this.cache.length, v = i.allocUnsafe(p), y = -1; ++y < p; )
      v.writeUInt8(p, y);
    return i.concat([this.cache, v]);
  };
  function l(p, v, y) {
    var w = e[p.toLowerCase()];
    if (!w)
      throw new TypeError("invalid suite type");
    if (typeof v == "string" && (v = i.from(v)), v.length !== w.key / 8)
      throw new TypeError("invalid key length " + v.length);
    if (typeof y == "string" && (y = i.from(y)), w.mode !== "GCM" && y.length !== w.iv)
      throw new TypeError("invalid iv length " + y.length);
    return w.type === "stream" ? new r(w.module, v, y) : w.type === "auth" ? new t(w.module, v, y) : new c(w.module, v, y);
  }
  function h(p, v) {
    var y = e[p.toLowerCase()];
    if (!y)
      throw new TypeError("invalid suite type");
    var w = f(v, !1, y.key, y.iv);
    return l(p, w.key, w.iv);
  }
  return fa.createCipheriv = l, fa.createCipher = h, fa;
}
var ua = {}, zc;
function bv() {
  if (zc)
    return ua;
  zc = 1;
  var e = Td(), t = He().Buffer, i = i0(), r = Id(), n = Ur(), a = Va(), f = Ka(), s = Ae();
  function c(p, v, y) {
    n.call(this), this._cache = new u(), this._last = void 0, this._cipher = new a.AES(v), this._prev = t.from(y), this._mode = p, this._autopadding = !0;
  }
  s(c, n), c.prototype._update = function(p) {
    this._cache.add(p);
    for (var v, y, w = []; v = this._cache.get(this._autopadding); )
      y = this._mode.decrypt(this, v), w.push(y);
    return t.concat(w);
  }, c.prototype._final = function() {
    var p = this._cache.flush();
    if (this._autopadding)
      return o(this._mode.decrypt(this, p));
    if (p)
      throw new Error("data not multiple of block length");
  }, c.prototype.setAutoPadding = function(p) {
    return this._autopadding = !!p, this;
  };
  function u() {
    this.cache = t.allocUnsafe(0);
  }
  u.prototype.add = function(p) {
    this.cache = t.concat([this.cache, p]);
  }, u.prototype.get = function(p) {
    var v;
    if (p) {
      if (this.cache.length > 16)
        return v = this.cache.slice(0, 16), this.cache = this.cache.slice(16), v;
    } else if (this.cache.length >= 16)
      return v = this.cache.slice(0, 16), this.cache = this.cache.slice(16), v;
    return null;
  }, u.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function o(p) {
    var v = p[15];
    if (v < 1 || v > 16)
      throw new Error("unable to decrypt data");
    for (var y = -1; ++y < v; )
      if (p[y + (16 - v)] !== v)
        throw new Error("unable to decrypt data");
    if (v !== 16)
      return p.slice(0, 16 - v);
  }
  function l(p, v, y) {
    var w = i[p.toLowerCase()];
    if (!w)
      throw new TypeError("invalid suite type");
    if (typeof y == "string" && (y = t.from(y)), w.mode !== "GCM" && y.length !== w.iv)
      throw new TypeError("invalid iv length " + y.length);
    if (typeof v == "string" && (v = t.from(v)), v.length !== w.key / 8)
      throw new TypeError("invalid key length " + v.length);
    return w.type === "stream" ? new r(w.module, v, y, !0) : w.type === "auth" ? new e(w.module, v, y, !0) : new c(w.module, v, y);
  }
  function h(p, v) {
    var y = i[p.toLowerCase()];
    if (!y)
      throw new TypeError("invalid suite type");
    var w = f(v, !1, y.key, y.iv);
    return l(p, w.key, w.iv);
  }
  return ua.createDecipher = h, ua.createDecipheriv = l, ua;
}
var Gc;
function a0() {
  if (Gc)
    return tr;
  Gc = 1;
  var e = gv(), t = bv(), i = Bd;
  function r() {
    return Object.keys(i);
  }
  return tr.createCipher = tr.Cipher = e.createCipher, tr.createCipheriv = tr.Cipheriv = e.createCipheriv, tr.createDecipher = tr.Decipher = t.createDecipher, tr.createDecipheriv = tr.Decipheriv = t.createDecipheriv, tr.listCiphers = tr.getCiphers = r, tr;
}
var fs = {}, $c;
function mv() {
  return $c || ($c = 1, function(e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(fs)), fs;
}
var Wc;
function xv() {
  if (Wc)
    return er;
  Wc = 1;
  var e = fv(), t = a0(), i = i0(), r = mv(), n = Ka();
  function a(o, l) {
    o = o.toLowerCase();
    var h, p;
    if (i[o])
      h = i[o].key, p = i[o].iv;
    else if (r[o])
      h = r[o].key * 8, p = r[o].iv;
    else
      throw new TypeError("invalid suite type");
    var v = n(l, !1, h, p);
    return s(o, v.key, v.iv);
  }
  function f(o, l) {
    o = o.toLowerCase();
    var h, p;
    if (i[o])
      h = i[o].key, p = i[o].iv;
    else if (r[o])
      h = r[o].key * 8, p = r[o].iv;
    else
      throw new TypeError("invalid suite type");
    var v = n(l, !1, h, p);
    return c(o, v.key, v.iv);
  }
  function s(o, l, h) {
    if (o = o.toLowerCase(), i[o])
      return t.createCipheriv(o, l, h);
    if (r[o])
      return new e({ key: l, iv: h, mode: o });
    throw new TypeError("invalid suite type");
  }
  function c(o, l, h) {
    if (o = o.toLowerCase(), i[o])
      return t.createDecipheriv(o, l, h);
    if (r[o])
      return new e({ key: l, iv: h, mode: o, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function u() {
    return Object.keys(r).concat(t.getCiphers());
  }
  return er.createCipher = er.Cipher = a, er.createCipheriv = er.Cipheriv = s, er.createDecipher = er.Decipher = f, er.createDecipheriv = er.Decipheriv = c, er.listCiphers = er.getCiphers = u, er;
}
var ri = {}, xa = { exports: {} };
xa.exports;
var Qc;
function jt() {
  return Qc || (Qc = 1, function(e) {
    (function(t, i) {
      function r(V, m) {
        if (!V)
          throw new Error(m || "Assertion failed");
      }
      function n(V, m) {
        V.super_ = m;
        var g = function() {
        };
        g.prototype = m.prototype, V.prototype = new g(), V.prototype.constructor = V;
      }
      function a(V, m, g) {
        if (a.isBN(V))
          return V;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, V !== null && ((m === "le" || m === "be") && (g = m, m = 10), this._init(V || 0, m || 10, g || "be"));
      }
      typeof t == "object" ? t.exports = a : i.BN = a, a.BN = a, a.wordSize = 26;
      var f;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = or.Buffer;
      } catch {
      }
      a.isBN = function(m) {
        return m instanceof a ? !0 : m !== null && typeof m == "object" && m.constructor.wordSize === a.wordSize && Array.isArray(m.words);
      }, a.max = function(m, g) {
        return m.cmp(g) > 0 ? m : g;
      }, a.min = function(m, g) {
        return m.cmp(g) < 0 ? m : g;
      }, a.prototype._init = function(m, g, d) {
        if (typeof m == "number")
          return this._initNumber(m, g, d);
        if (typeof m == "object")
          return this._initArray(m, g, d);
        g === "hex" && (g = 16), r(g === (g | 0) && g >= 2 && g <= 36), m = m.toString().replace(/\s+/g, "");
        var b = 0;
        m[0] === "-" && (b++, this.negative = 1), b < m.length && (g === 16 ? this._parseHex(m, b, d) : (this._parseBase(m, g, b), d === "le" && this._initArray(this.toArray(), g, d)));
      }, a.prototype._initNumber = function(m, g, d) {
        m < 0 && (this.negative = 1, m = -m), m < 67108864 ? (this.words = [m & 67108863], this.length = 1) : m < 4503599627370496 ? (this.words = [
          m & 67108863,
          m / 67108864 & 67108863
        ], this.length = 2) : (r(m < 9007199254740992), this.words = [
          m & 67108863,
          m / 67108864 & 67108863,
          1
        ], this.length = 3), d === "le" && this._initArray(this.toArray(), g, d);
      }, a.prototype._initArray = function(m, g, d) {
        if (r(typeof m.length == "number"), m.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(m.length / 3), this.words = new Array(this.length);
        for (var b = 0; b < this.length; b++)
          this.words[b] = 0;
        var C, E, B = 0;
        if (d === "be")
          for (b = m.length - 1, C = 0; b >= 0; b -= 3)
            E = m[b] | m[b - 1] << 8 | m[b - 2] << 16, this.words[C] |= E << B & 67108863, this.words[C + 1] = E >>> 26 - B & 67108863, B += 24, B >= 26 && (B -= 26, C++);
        else if (d === "le")
          for (b = 0, C = 0; b < m.length; b += 3)
            E = m[b] | m[b + 1] << 8 | m[b + 2] << 16, this.words[C] |= E << B & 67108863, this.words[C + 1] = E >>> 26 - B & 67108863, B += 24, B >= 26 && (B -= 26, C++);
        return this.strip();
      };
      function s(V, m) {
        var g = V.charCodeAt(m);
        return g >= 65 && g <= 70 ? g - 55 : g >= 97 && g <= 102 ? g - 87 : g - 48 & 15;
      }
      function c(V, m, g) {
        var d = s(V, g);
        return g - 1 >= m && (d |= s(V, g - 1) << 4), d;
      }
      a.prototype._parseHex = function(m, g, d) {
        this.length = Math.ceil((m.length - g) / 6), this.words = new Array(this.length);
        for (var b = 0; b < this.length; b++)
          this.words[b] = 0;
        var C = 0, E = 0, B;
        if (d === "be")
          for (b = m.length - 1; b >= g; b -= 2)
            B = c(m, g, b) << C, this.words[E] |= B & 67108863, C >= 18 ? (C -= 18, E += 1, this.words[E] |= B >>> 26) : C += 8;
        else {
          var T = m.length - g;
          for (b = T % 2 === 0 ? g + 1 : g; b < m.length; b += 2)
            B = c(m, g, b) << C, this.words[E] |= B & 67108863, C >= 18 ? (C -= 18, E += 1, this.words[E] |= B >>> 26) : C += 8;
        }
        this.strip();
      };
      function u(V, m, g, d) {
        for (var b = 0, C = Math.min(V.length, g), E = m; E < C; E++) {
          var B = V.charCodeAt(E) - 48;
          b *= d, B >= 49 ? b += B - 49 + 10 : B >= 17 ? b += B - 17 + 10 : b += B;
        }
        return b;
      }
      a.prototype._parseBase = function(m, g, d) {
        this.words = [0], this.length = 1;
        for (var b = 0, C = 1; C <= 67108863; C *= g)
          b++;
        b--, C = C / g | 0;
        for (var E = m.length - d, B = E % b, T = Math.min(E, E - B) + d, _ = 0, I = d; I < T; I += b)
          _ = u(m, I, I + b, g), this.imuln(C), this.words[0] + _ < 67108864 ? this.words[0] += _ : this._iaddn(_);
        if (B !== 0) {
          var S = 1;
          for (_ = u(m, I, m.length, g), I = 0; I < B; I++)
            S *= g;
          this.imuln(S), this.words[0] + _ < 67108864 ? this.words[0] += _ : this._iaddn(_);
        }
        this.strip();
      }, a.prototype.copy = function(m) {
        m.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          m.words[g] = this.words[g];
        m.length = this.length, m.negative = this.negative, m.red = this.red;
      }, a.prototype.clone = function() {
        var m = new a(null);
        return this.copy(m), m;
      }, a.prototype._expand = function(m) {
        for (; this.length < m; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var o = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], l = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], h = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(m, g) {
        m = m || 10, g = g | 0 || 1;
        var d;
        if (m === 16 || m === "hex") {
          d = "";
          for (var b = 0, C = 0, E = 0; E < this.length; E++) {
            var B = this.words[E], T = ((B << b | C) & 16777215).toString(16);
            C = B >>> 24 - b & 16777215, b += 2, b >= 26 && (b -= 26, E--), C !== 0 || E !== this.length - 1 ? d = o[6 - T.length] + T + d : d = T + d;
          }
          for (C !== 0 && (d = C.toString(16) + d); d.length % g !== 0; )
            d = "0" + d;
          return this.negative !== 0 && (d = "-" + d), d;
        }
        if (m === (m | 0) && m >= 2 && m <= 36) {
          var _ = l[m], I = h[m];
          d = "";
          var S = this.clone();
          for (S.negative = 0; !S.isZero(); ) {
            var k = S.modn(I).toString(m);
            S = S.idivn(I), S.isZero() ? d = k + d : d = o[_ - k.length] + k + d;
          }
          for (this.isZero() && (d = "0" + d); d.length % g !== 0; )
            d = "0" + d;
          return this.negative !== 0 && (d = "-" + d), d;
        }
        r(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var m = this.words[0];
        return this.length === 2 ? m += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? m += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -m : m;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(m, g) {
        return r(typeof f < "u"), this.toArrayLike(f, m, g);
      }, a.prototype.toArray = function(m, g) {
        return this.toArrayLike(Array, m, g);
      }, a.prototype.toArrayLike = function(m, g, d) {
        var b = this.byteLength(), C = d || Math.max(1, b);
        r(b <= C, "byte array longer than desired length"), r(C > 0, "Requested array length <= 0"), this.strip();
        var E = g === "le", B = new m(C), T, _, I = this.clone();
        if (E) {
          for (_ = 0; !I.isZero(); _++)
            T = I.andln(255), I.iushrn(8), B[_] = T;
          for (; _ < C; _++)
            B[_] = 0;
        } else {
          for (_ = 0; _ < C - b; _++)
            B[_] = 0;
          for (_ = 0; !I.isZero(); _++)
            T = I.andln(255), I.iushrn(8), B[C - _ - 1] = T;
        }
        return B;
      }, Math.clz32 ? a.prototype._countBits = function(m) {
        return 32 - Math.clz32(m);
      } : a.prototype._countBits = function(m) {
        var g = m, d = 0;
        return g >= 4096 && (d += 13, g >>>= 13), g >= 64 && (d += 7, g >>>= 7), g >= 8 && (d += 4, g >>>= 4), g >= 2 && (d += 2, g >>>= 2), d + g;
      }, a.prototype._zeroBits = function(m) {
        if (m === 0)
          return 26;
        var g = m, d = 0;
        return g & 8191 || (d += 13, g >>>= 13), g & 127 || (d += 7, g >>>= 7), g & 15 || (d += 4, g >>>= 4), g & 3 || (d += 2, g >>>= 2), g & 1 || d++, d;
      }, a.prototype.bitLength = function() {
        var m = this.words[this.length - 1], g = this._countBits(m);
        return (this.length - 1) * 26 + g;
      };
      function p(V) {
        for (var m = new Array(V.bitLength()), g = 0; g < m.length; g++) {
          var d = g / 26 | 0, b = g % 26;
          m[g] = (V.words[d] & 1 << b) >>> b;
        }
        return m;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var m = 0, g = 0; g < this.length; g++) {
          var d = this._zeroBits(this.words[g]);
          if (m += d, d !== 26)
            break;
        }
        return m;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(m) {
        return this.negative !== 0 ? this.abs().inotn(m).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(m) {
        return this.testn(m - 1) ? this.notn(m).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(m) {
        for (; this.length < m.length; )
          this.words[this.length++] = 0;
        for (var g = 0; g < m.length; g++)
          this.words[g] = this.words[g] | m.words[g];
        return this.strip();
      }, a.prototype.ior = function(m) {
        return r((this.negative | m.negative) === 0), this.iuor(m);
      }, a.prototype.or = function(m) {
        return this.length > m.length ? this.clone().ior(m) : m.clone().ior(this);
      }, a.prototype.uor = function(m) {
        return this.length > m.length ? this.clone().iuor(m) : m.clone().iuor(this);
      }, a.prototype.iuand = function(m) {
        var g;
        this.length > m.length ? g = m : g = this;
        for (var d = 0; d < g.length; d++)
          this.words[d] = this.words[d] & m.words[d];
        return this.length = g.length, this.strip();
      }, a.prototype.iand = function(m) {
        return r((this.negative | m.negative) === 0), this.iuand(m);
      }, a.prototype.and = function(m) {
        return this.length > m.length ? this.clone().iand(m) : m.clone().iand(this);
      }, a.prototype.uand = function(m) {
        return this.length > m.length ? this.clone().iuand(m) : m.clone().iuand(this);
      }, a.prototype.iuxor = function(m) {
        var g, d;
        this.length > m.length ? (g = this, d = m) : (g = m, d = this);
        for (var b = 0; b < d.length; b++)
          this.words[b] = g.words[b] ^ d.words[b];
        if (this !== g)
          for (; b < g.length; b++)
            this.words[b] = g.words[b];
        return this.length = g.length, this.strip();
      }, a.prototype.ixor = function(m) {
        return r((this.negative | m.negative) === 0), this.iuxor(m);
      }, a.prototype.xor = function(m) {
        return this.length > m.length ? this.clone().ixor(m) : m.clone().ixor(this);
      }, a.prototype.uxor = function(m) {
        return this.length > m.length ? this.clone().iuxor(m) : m.clone().iuxor(this);
      }, a.prototype.inotn = function(m) {
        r(typeof m == "number" && m >= 0);
        var g = Math.ceil(m / 26) | 0, d = m % 26;
        this._expand(g), d > 0 && g--;
        for (var b = 0; b < g; b++)
          this.words[b] = ~this.words[b] & 67108863;
        return d > 0 && (this.words[b] = ~this.words[b] & 67108863 >> 26 - d), this.strip();
      }, a.prototype.notn = function(m) {
        return this.clone().inotn(m);
      }, a.prototype.setn = function(m, g) {
        r(typeof m == "number" && m >= 0);
        var d = m / 26 | 0, b = m % 26;
        return this._expand(d + 1), g ? this.words[d] = this.words[d] | 1 << b : this.words[d] = this.words[d] & ~(1 << b), this.strip();
      }, a.prototype.iadd = function(m) {
        var g;
        if (this.negative !== 0 && m.negative === 0)
          return this.negative = 0, g = this.isub(m), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && m.negative !== 0)
          return m.negative = 0, g = this.isub(m), m.negative = 1, g._normSign();
        var d, b;
        this.length > m.length ? (d = this, b = m) : (d = m, b = this);
        for (var C = 0, E = 0; E < b.length; E++)
          g = (d.words[E] | 0) + (b.words[E] | 0) + C, this.words[E] = g & 67108863, C = g >>> 26;
        for (; C !== 0 && E < d.length; E++)
          g = (d.words[E] | 0) + C, this.words[E] = g & 67108863, C = g >>> 26;
        if (this.length = d.length, C !== 0)
          this.words[this.length] = C, this.length++;
        else if (d !== this)
          for (; E < d.length; E++)
            this.words[E] = d.words[E];
        return this;
      }, a.prototype.add = function(m) {
        var g;
        return m.negative !== 0 && this.negative === 0 ? (m.negative = 0, g = this.sub(m), m.negative ^= 1, g) : m.negative === 0 && this.negative !== 0 ? (this.negative = 0, g = m.sub(this), this.negative = 1, g) : this.length > m.length ? this.clone().iadd(m) : m.clone().iadd(this);
      }, a.prototype.isub = function(m) {
        if (m.negative !== 0) {
          m.negative = 0;
          var g = this.iadd(m);
          return m.negative = 1, g._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(m), this.negative = 1, this._normSign();
        var d = this.cmp(m);
        if (d === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var b, C;
        d > 0 ? (b = this, C = m) : (b = m, C = this);
        for (var E = 0, B = 0; B < C.length; B++)
          g = (b.words[B] | 0) - (C.words[B] | 0) + E, E = g >> 26, this.words[B] = g & 67108863;
        for (; E !== 0 && B < b.length; B++)
          g = (b.words[B] | 0) + E, E = g >> 26, this.words[B] = g & 67108863;
        if (E === 0 && B < b.length && b !== this)
          for (; B < b.length; B++)
            this.words[B] = b.words[B];
        return this.length = Math.max(this.length, B), b !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(m) {
        return this.clone().isub(m);
      };
      function v(V, m, g) {
        g.negative = m.negative ^ V.negative;
        var d = V.length + m.length | 0;
        g.length = d, d = d - 1 | 0;
        var b = V.words[0] | 0, C = m.words[0] | 0, E = b * C, B = E & 67108863, T = E / 67108864 | 0;
        g.words[0] = B;
        for (var _ = 1; _ < d; _++) {
          for (var I = T >>> 26, S = T & 67108863, k = Math.min(_, m.length - 1), $ = Math.max(0, _ - V.length + 1); $ <= k; $++) {
            var ee = _ - $ | 0;
            b = V.words[ee] | 0, C = m.words[$] | 0, E = b * C + S, I += E / 67108864 | 0, S = E & 67108863;
          }
          g.words[_] = S | 0, T = I | 0;
        }
        return T !== 0 ? g.words[_] = T | 0 : g.length--, g.strip();
      }
      var y = function(m, g, d) {
        var b = m.words, C = g.words, E = d.words, B = 0, T, _, I, S = b[0] | 0, k = S & 8191, $ = S >>> 13, ee = b[1] | 0, H = ee & 8191, N = ee >>> 13, L = b[2] | 0, j = L & 8191, Y = L >>> 13, F = b[3] | 0, P = F & 8191, Z = F >>> 13, ae = b[4] | 0, se = ae & 8191, le = ae >>> 13, be = b[5] | 0, me = be & 8191, ie = be >>> 13, Be = b[6] | 0, pe = Be & 8191, Ce = Be >>> 13, Te = b[7] | 0, xe = Te & 8191, ze = Te >>> 13, et = b[8] | 0, Ee = et & 8191, tt = et >>> 13, ht = b[9] | 0, Re = ht & 8191, dt = ht >>> 13, pt = C[0] | 0, Me = pt & 8191, vt = pt >>> 13, yt = C[1] | 0, Ne = yt & 8191, gt = yt >>> 13, bt = C[2] | 0, ke = bt & 8191, mt = bt >>> 13, xt = C[3] | 0, De = xt & 8191, _t = xt >>> 13, St = C[4] | 0, Le = St & 8191, Et = St >>> 13, wt = C[5] | 0, Pe = wt & 8191, Ct = wt >>> 13, At = C[6] | 0, Ue = At & 8191, Bt = At >>> 13, Tt = C[7] | 0, Oe = Tt & 8191, It = Tt >>> 13, Rt = C[8] | 0, qe = Rt & 8191, Mt = Rt >>> 13, Nt = C[9] | 0, Fe = Nt & 8191, kt = Nt >>> 13;
        d.negative = m.negative ^ g.negative, d.length = 19, T = Math.imul(k, Me), _ = Math.imul(k, vt), _ = _ + Math.imul($, Me) | 0, I = Math.imul($, vt);
        var ut = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (ut >>> 26) | 0, ut &= 67108863, T = Math.imul(H, Me), _ = Math.imul(H, vt), _ = _ + Math.imul(N, Me) | 0, I = Math.imul(N, vt), T = T + Math.imul(k, Ne) | 0, _ = _ + Math.imul(k, gt) | 0, _ = _ + Math.imul($, Ne) | 0, I = I + Math.imul($, gt) | 0;
        var ct = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, T = Math.imul(j, Me), _ = Math.imul(j, vt), _ = _ + Math.imul(Y, Me) | 0, I = Math.imul(Y, vt), T = T + Math.imul(H, Ne) | 0, _ = _ + Math.imul(H, gt) | 0, _ = _ + Math.imul(N, Ne) | 0, I = I + Math.imul(N, gt) | 0, T = T + Math.imul(k, ke) | 0, _ = _ + Math.imul(k, mt) | 0, _ = _ + Math.imul($, ke) | 0, I = I + Math.imul($, mt) | 0;
        var Or = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Or >>> 26) | 0, Or &= 67108863, T = Math.imul(P, Me), _ = Math.imul(P, vt), _ = _ + Math.imul(Z, Me) | 0, I = Math.imul(Z, vt), T = T + Math.imul(j, Ne) | 0, _ = _ + Math.imul(j, gt) | 0, _ = _ + Math.imul(Y, Ne) | 0, I = I + Math.imul(Y, gt) | 0, T = T + Math.imul(H, ke) | 0, _ = _ + Math.imul(H, mt) | 0, _ = _ + Math.imul(N, ke) | 0, I = I + Math.imul(N, mt) | 0, T = T + Math.imul(k, De) | 0, _ = _ + Math.imul(k, _t) | 0, _ = _ + Math.imul($, De) | 0, I = I + Math.imul($, _t) | 0;
        var qr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, T = Math.imul(se, Me), _ = Math.imul(se, vt), _ = _ + Math.imul(le, Me) | 0, I = Math.imul(le, vt), T = T + Math.imul(P, Ne) | 0, _ = _ + Math.imul(P, gt) | 0, _ = _ + Math.imul(Z, Ne) | 0, I = I + Math.imul(Z, gt) | 0, T = T + Math.imul(j, ke) | 0, _ = _ + Math.imul(j, mt) | 0, _ = _ + Math.imul(Y, ke) | 0, I = I + Math.imul(Y, mt) | 0, T = T + Math.imul(H, De) | 0, _ = _ + Math.imul(H, _t) | 0, _ = _ + Math.imul(N, De) | 0, I = I + Math.imul(N, _t) | 0, T = T + Math.imul(k, Le) | 0, _ = _ + Math.imul(k, Et) | 0, _ = _ + Math.imul($, Le) | 0, I = I + Math.imul($, Et) | 0;
        var Fr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, T = Math.imul(me, Me), _ = Math.imul(me, vt), _ = _ + Math.imul(ie, Me) | 0, I = Math.imul(ie, vt), T = T + Math.imul(se, Ne) | 0, _ = _ + Math.imul(se, gt) | 0, _ = _ + Math.imul(le, Ne) | 0, I = I + Math.imul(le, gt) | 0, T = T + Math.imul(P, ke) | 0, _ = _ + Math.imul(P, mt) | 0, _ = _ + Math.imul(Z, ke) | 0, I = I + Math.imul(Z, mt) | 0, T = T + Math.imul(j, De) | 0, _ = _ + Math.imul(j, _t) | 0, _ = _ + Math.imul(Y, De) | 0, I = I + Math.imul(Y, _t) | 0, T = T + Math.imul(H, Le) | 0, _ = _ + Math.imul(H, Et) | 0, _ = _ + Math.imul(N, Le) | 0, I = I + Math.imul(N, Et) | 0, T = T + Math.imul(k, Pe) | 0, _ = _ + Math.imul(k, Ct) | 0, _ = _ + Math.imul($, Pe) | 0, I = I + Math.imul($, Ct) | 0;
        var Vr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, T = Math.imul(pe, Me), _ = Math.imul(pe, vt), _ = _ + Math.imul(Ce, Me) | 0, I = Math.imul(Ce, vt), T = T + Math.imul(me, Ne) | 0, _ = _ + Math.imul(me, gt) | 0, _ = _ + Math.imul(ie, Ne) | 0, I = I + Math.imul(ie, gt) | 0, T = T + Math.imul(se, ke) | 0, _ = _ + Math.imul(se, mt) | 0, _ = _ + Math.imul(le, ke) | 0, I = I + Math.imul(le, mt) | 0, T = T + Math.imul(P, De) | 0, _ = _ + Math.imul(P, _t) | 0, _ = _ + Math.imul(Z, De) | 0, I = I + Math.imul(Z, _t) | 0, T = T + Math.imul(j, Le) | 0, _ = _ + Math.imul(j, Et) | 0, _ = _ + Math.imul(Y, Le) | 0, I = I + Math.imul(Y, Et) | 0, T = T + Math.imul(H, Pe) | 0, _ = _ + Math.imul(H, Ct) | 0, _ = _ + Math.imul(N, Pe) | 0, I = I + Math.imul(N, Ct) | 0, T = T + Math.imul(k, Ue) | 0, _ = _ + Math.imul(k, Bt) | 0, _ = _ + Math.imul($, Ue) | 0, I = I + Math.imul($, Bt) | 0;
        var Kr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Kr >>> 26) | 0, Kr &= 67108863, T = Math.imul(xe, Me), _ = Math.imul(xe, vt), _ = _ + Math.imul(ze, Me) | 0, I = Math.imul(ze, vt), T = T + Math.imul(pe, Ne) | 0, _ = _ + Math.imul(pe, gt) | 0, _ = _ + Math.imul(Ce, Ne) | 0, I = I + Math.imul(Ce, gt) | 0, T = T + Math.imul(me, ke) | 0, _ = _ + Math.imul(me, mt) | 0, _ = _ + Math.imul(ie, ke) | 0, I = I + Math.imul(ie, mt) | 0, T = T + Math.imul(se, De) | 0, _ = _ + Math.imul(se, _t) | 0, _ = _ + Math.imul(le, De) | 0, I = I + Math.imul(le, _t) | 0, T = T + Math.imul(P, Le) | 0, _ = _ + Math.imul(P, Et) | 0, _ = _ + Math.imul(Z, Le) | 0, I = I + Math.imul(Z, Et) | 0, T = T + Math.imul(j, Pe) | 0, _ = _ + Math.imul(j, Ct) | 0, _ = _ + Math.imul(Y, Pe) | 0, I = I + Math.imul(Y, Ct) | 0, T = T + Math.imul(H, Ue) | 0, _ = _ + Math.imul(H, Bt) | 0, _ = _ + Math.imul(N, Ue) | 0, I = I + Math.imul(N, Bt) | 0, T = T + Math.imul(k, Oe) | 0, _ = _ + Math.imul(k, It) | 0, _ = _ + Math.imul($, Oe) | 0, I = I + Math.imul($, It) | 0;
        var Hr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Hr >>> 26) | 0, Hr &= 67108863, T = Math.imul(Ee, Me), _ = Math.imul(Ee, vt), _ = _ + Math.imul(tt, Me) | 0, I = Math.imul(tt, vt), T = T + Math.imul(xe, Ne) | 0, _ = _ + Math.imul(xe, gt) | 0, _ = _ + Math.imul(ze, Ne) | 0, I = I + Math.imul(ze, gt) | 0, T = T + Math.imul(pe, ke) | 0, _ = _ + Math.imul(pe, mt) | 0, _ = _ + Math.imul(Ce, ke) | 0, I = I + Math.imul(Ce, mt) | 0, T = T + Math.imul(me, De) | 0, _ = _ + Math.imul(me, _t) | 0, _ = _ + Math.imul(ie, De) | 0, I = I + Math.imul(ie, _t) | 0, T = T + Math.imul(se, Le) | 0, _ = _ + Math.imul(se, Et) | 0, _ = _ + Math.imul(le, Le) | 0, I = I + Math.imul(le, Et) | 0, T = T + Math.imul(P, Pe) | 0, _ = _ + Math.imul(P, Ct) | 0, _ = _ + Math.imul(Z, Pe) | 0, I = I + Math.imul(Z, Ct) | 0, T = T + Math.imul(j, Ue) | 0, _ = _ + Math.imul(j, Bt) | 0, _ = _ + Math.imul(Y, Ue) | 0, I = I + Math.imul(Y, Bt) | 0, T = T + Math.imul(H, Oe) | 0, _ = _ + Math.imul(H, It) | 0, _ = _ + Math.imul(N, Oe) | 0, I = I + Math.imul(N, It) | 0, T = T + Math.imul(k, qe) | 0, _ = _ + Math.imul(k, Mt) | 0, _ = _ + Math.imul($, qe) | 0, I = I + Math.imul($, Mt) | 0;
        var jr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (jr >>> 26) | 0, jr &= 67108863, T = Math.imul(Re, Me), _ = Math.imul(Re, vt), _ = _ + Math.imul(dt, Me) | 0, I = Math.imul(dt, vt), T = T + Math.imul(Ee, Ne) | 0, _ = _ + Math.imul(Ee, gt) | 0, _ = _ + Math.imul(tt, Ne) | 0, I = I + Math.imul(tt, gt) | 0, T = T + Math.imul(xe, ke) | 0, _ = _ + Math.imul(xe, mt) | 0, _ = _ + Math.imul(ze, ke) | 0, I = I + Math.imul(ze, mt) | 0, T = T + Math.imul(pe, De) | 0, _ = _ + Math.imul(pe, _t) | 0, _ = _ + Math.imul(Ce, De) | 0, I = I + Math.imul(Ce, _t) | 0, T = T + Math.imul(me, Le) | 0, _ = _ + Math.imul(me, Et) | 0, _ = _ + Math.imul(ie, Le) | 0, I = I + Math.imul(ie, Et) | 0, T = T + Math.imul(se, Pe) | 0, _ = _ + Math.imul(se, Ct) | 0, _ = _ + Math.imul(le, Pe) | 0, I = I + Math.imul(le, Ct) | 0, T = T + Math.imul(P, Ue) | 0, _ = _ + Math.imul(P, Bt) | 0, _ = _ + Math.imul(Z, Ue) | 0, I = I + Math.imul(Z, Bt) | 0, T = T + Math.imul(j, Oe) | 0, _ = _ + Math.imul(j, It) | 0, _ = _ + Math.imul(Y, Oe) | 0, I = I + Math.imul(Y, It) | 0, T = T + Math.imul(H, qe) | 0, _ = _ + Math.imul(H, Mt) | 0, _ = _ + Math.imul(N, qe) | 0, I = I + Math.imul(N, Mt) | 0, T = T + Math.imul(k, Fe) | 0, _ = _ + Math.imul(k, kt) | 0, _ = _ + Math.imul($, Fe) | 0, I = I + Math.imul($, kt) | 0;
        var zr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, T = Math.imul(Re, Ne), _ = Math.imul(Re, gt), _ = _ + Math.imul(dt, Ne) | 0, I = Math.imul(dt, gt), T = T + Math.imul(Ee, ke) | 0, _ = _ + Math.imul(Ee, mt) | 0, _ = _ + Math.imul(tt, ke) | 0, I = I + Math.imul(tt, mt) | 0, T = T + Math.imul(xe, De) | 0, _ = _ + Math.imul(xe, _t) | 0, _ = _ + Math.imul(ze, De) | 0, I = I + Math.imul(ze, _t) | 0, T = T + Math.imul(pe, Le) | 0, _ = _ + Math.imul(pe, Et) | 0, _ = _ + Math.imul(Ce, Le) | 0, I = I + Math.imul(Ce, Et) | 0, T = T + Math.imul(me, Pe) | 0, _ = _ + Math.imul(me, Ct) | 0, _ = _ + Math.imul(ie, Pe) | 0, I = I + Math.imul(ie, Ct) | 0, T = T + Math.imul(se, Ue) | 0, _ = _ + Math.imul(se, Bt) | 0, _ = _ + Math.imul(le, Ue) | 0, I = I + Math.imul(le, Bt) | 0, T = T + Math.imul(P, Oe) | 0, _ = _ + Math.imul(P, It) | 0, _ = _ + Math.imul(Z, Oe) | 0, I = I + Math.imul(Z, It) | 0, T = T + Math.imul(j, qe) | 0, _ = _ + Math.imul(j, Mt) | 0, _ = _ + Math.imul(Y, qe) | 0, I = I + Math.imul(Y, Mt) | 0, T = T + Math.imul(H, Fe) | 0, _ = _ + Math.imul(H, kt) | 0, _ = _ + Math.imul(N, Fe) | 0, I = I + Math.imul(N, kt) | 0;
        var Gr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, T = Math.imul(Re, ke), _ = Math.imul(Re, mt), _ = _ + Math.imul(dt, ke) | 0, I = Math.imul(dt, mt), T = T + Math.imul(Ee, De) | 0, _ = _ + Math.imul(Ee, _t) | 0, _ = _ + Math.imul(tt, De) | 0, I = I + Math.imul(tt, _t) | 0, T = T + Math.imul(xe, Le) | 0, _ = _ + Math.imul(xe, Et) | 0, _ = _ + Math.imul(ze, Le) | 0, I = I + Math.imul(ze, Et) | 0, T = T + Math.imul(pe, Pe) | 0, _ = _ + Math.imul(pe, Ct) | 0, _ = _ + Math.imul(Ce, Pe) | 0, I = I + Math.imul(Ce, Ct) | 0, T = T + Math.imul(me, Ue) | 0, _ = _ + Math.imul(me, Bt) | 0, _ = _ + Math.imul(ie, Ue) | 0, I = I + Math.imul(ie, Bt) | 0, T = T + Math.imul(se, Oe) | 0, _ = _ + Math.imul(se, It) | 0, _ = _ + Math.imul(le, Oe) | 0, I = I + Math.imul(le, It) | 0, T = T + Math.imul(P, qe) | 0, _ = _ + Math.imul(P, Mt) | 0, _ = _ + Math.imul(Z, qe) | 0, I = I + Math.imul(Z, Mt) | 0, T = T + Math.imul(j, Fe) | 0, _ = _ + Math.imul(j, kt) | 0, _ = _ + Math.imul(Y, Fe) | 0, I = I + Math.imul(Y, kt) | 0;
        var $r = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, T = Math.imul(Re, De), _ = Math.imul(Re, _t), _ = _ + Math.imul(dt, De) | 0, I = Math.imul(dt, _t), T = T + Math.imul(Ee, Le) | 0, _ = _ + Math.imul(Ee, Et) | 0, _ = _ + Math.imul(tt, Le) | 0, I = I + Math.imul(tt, Et) | 0, T = T + Math.imul(xe, Pe) | 0, _ = _ + Math.imul(xe, Ct) | 0, _ = _ + Math.imul(ze, Pe) | 0, I = I + Math.imul(ze, Ct) | 0, T = T + Math.imul(pe, Ue) | 0, _ = _ + Math.imul(pe, Bt) | 0, _ = _ + Math.imul(Ce, Ue) | 0, I = I + Math.imul(Ce, Bt) | 0, T = T + Math.imul(me, Oe) | 0, _ = _ + Math.imul(me, It) | 0, _ = _ + Math.imul(ie, Oe) | 0, I = I + Math.imul(ie, It) | 0, T = T + Math.imul(se, qe) | 0, _ = _ + Math.imul(se, Mt) | 0, _ = _ + Math.imul(le, qe) | 0, I = I + Math.imul(le, Mt) | 0, T = T + Math.imul(P, Fe) | 0, _ = _ + Math.imul(P, kt) | 0, _ = _ + Math.imul(Z, Fe) | 0, I = I + Math.imul(Z, kt) | 0;
        var Wr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, T = Math.imul(Re, Le), _ = Math.imul(Re, Et), _ = _ + Math.imul(dt, Le) | 0, I = Math.imul(dt, Et), T = T + Math.imul(Ee, Pe) | 0, _ = _ + Math.imul(Ee, Ct) | 0, _ = _ + Math.imul(tt, Pe) | 0, I = I + Math.imul(tt, Ct) | 0, T = T + Math.imul(xe, Ue) | 0, _ = _ + Math.imul(xe, Bt) | 0, _ = _ + Math.imul(ze, Ue) | 0, I = I + Math.imul(ze, Bt) | 0, T = T + Math.imul(pe, Oe) | 0, _ = _ + Math.imul(pe, It) | 0, _ = _ + Math.imul(Ce, Oe) | 0, I = I + Math.imul(Ce, It) | 0, T = T + Math.imul(me, qe) | 0, _ = _ + Math.imul(me, Mt) | 0, _ = _ + Math.imul(ie, qe) | 0, I = I + Math.imul(ie, Mt) | 0, T = T + Math.imul(se, Fe) | 0, _ = _ + Math.imul(se, kt) | 0, _ = _ + Math.imul(le, Fe) | 0, I = I + Math.imul(le, kt) | 0;
        var Qr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, T = Math.imul(Re, Pe), _ = Math.imul(Re, Ct), _ = _ + Math.imul(dt, Pe) | 0, I = Math.imul(dt, Ct), T = T + Math.imul(Ee, Ue) | 0, _ = _ + Math.imul(Ee, Bt) | 0, _ = _ + Math.imul(tt, Ue) | 0, I = I + Math.imul(tt, Bt) | 0, T = T + Math.imul(xe, Oe) | 0, _ = _ + Math.imul(xe, It) | 0, _ = _ + Math.imul(ze, Oe) | 0, I = I + Math.imul(ze, It) | 0, T = T + Math.imul(pe, qe) | 0, _ = _ + Math.imul(pe, Mt) | 0, _ = _ + Math.imul(Ce, qe) | 0, I = I + Math.imul(Ce, Mt) | 0, T = T + Math.imul(me, Fe) | 0, _ = _ + Math.imul(me, kt) | 0, _ = _ + Math.imul(ie, Fe) | 0, I = I + Math.imul(ie, kt) | 0;
        var Yr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, T = Math.imul(Re, Ue), _ = Math.imul(Re, Bt), _ = _ + Math.imul(dt, Ue) | 0, I = Math.imul(dt, Bt), T = T + Math.imul(Ee, Oe) | 0, _ = _ + Math.imul(Ee, It) | 0, _ = _ + Math.imul(tt, Oe) | 0, I = I + Math.imul(tt, It) | 0, T = T + Math.imul(xe, qe) | 0, _ = _ + Math.imul(xe, Mt) | 0, _ = _ + Math.imul(ze, qe) | 0, I = I + Math.imul(ze, Mt) | 0, T = T + Math.imul(pe, Fe) | 0, _ = _ + Math.imul(pe, kt) | 0, _ = _ + Math.imul(Ce, Fe) | 0, I = I + Math.imul(Ce, kt) | 0;
        var Xr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, T = Math.imul(Re, Oe), _ = Math.imul(Re, It), _ = _ + Math.imul(dt, Oe) | 0, I = Math.imul(dt, It), T = T + Math.imul(Ee, qe) | 0, _ = _ + Math.imul(Ee, Mt) | 0, _ = _ + Math.imul(tt, qe) | 0, I = I + Math.imul(tt, Mt) | 0, T = T + Math.imul(xe, Fe) | 0, _ = _ + Math.imul(xe, kt) | 0, _ = _ + Math.imul(ze, Fe) | 0, I = I + Math.imul(ze, kt) | 0;
        var Zr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, T = Math.imul(Re, qe), _ = Math.imul(Re, Mt), _ = _ + Math.imul(dt, qe) | 0, I = Math.imul(dt, Mt), T = T + Math.imul(Ee, Fe) | 0, _ = _ + Math.imul(Ee, kt) | 0, _ = _ + Math.imul(tt, Fe) | 0, I = I + Math.imul(tt, kt) | 0;
        var Jr = (B + T | 0) + ((_ & 8191) << 13) | 0;
        B = (I + (_ >>> 13) | 0) + (Jr >>> 26) | 0, Jr &= 67108863, T = Math.imul(Re, Fe), _ = Math.imul(Re, kt), _ = _ + Math.imul(dt, Fe) | 0, I = Math.imul(dt, kt);
        var ei = (B + T | 0) + ((_ & 8191) << 13) | 0;
        return B = (I + (_ >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, E[0] = ut, E[1] = ct, E[2] = Or, E[3] = qr, E[4] = Fr, E[5] = Vr, E[6] = Kr, E[7] = Hr, E[8] = jr, E[9] = zr, E[10] = Gr, E[11] = $r, E[12] = Wr, E[13] = Qr, E[14] = Yr, E[15] = Xr, E[16] = Zr, E[17] = Jr, E[18] = ei, B !== 0 && (E[19] = B, d.length++), d;
      };
      Math.imul || (y = v);
      function w(V, m, g) {
        g.negative = m.negative ^ V.negative, g.length = V.length + m.length;
        for (var d = 0, b = 0, C = 0; C < g.length - 1; C++) {
          var E = b;
          b = 0;
          for (var B = d & 67108863, T = Math.min(C, m.length - 1), _ = Math.max(0, C - V.length + 1); _ <= T; _++) {
            var I = C - _, S = V.words[I] | 0, k = m.words[_] | 0, $ = S * k, ee = $ & 67108863;
            E = E + ($ / 67108864 | 0) | 0, ee = ee + B | 0, B = ee & 67108863, E = E + (ee >>> 26) | 0, b += E >>> 26, E &= 67108863;
          }
          g.words[C] = B, d = E, E = b;
        }
        return d !== 0 ? g.words[C] = d : g.length--, g.strip();
      }
      function x(V, m, g) {
        var d = new A();
        return d.mulp(V, m, g);
      }
      a.prototype.mulTo = function(m, g) {
        var d, b = this.length + m.length;
        return this.length === 10 && m.length === 10 ? d = y(this, m, g) : b < 63 ? d = v(this, m, g) : b < 1024 ? d = w(this, m, g) : d = x(this, m, g), d;
      };
      function A(V, m) {
        this.x = V, this.y = m;
      }
      A.prototype.makeRBT = function(m) {
        for (var g = new Array(m), d = a.prototype._countBits(m) - 1, b = 0; b < m; b++)
          g[b] = this.revBin(b, d, m);
        return g;
      }, A.prototype.revBin = function(m, g, d) {
        if (m === 0 || m === d - 1)
          return m;
        for (var b = 0, C = 0; C < g; C++)
          b |= (m & 1) << g - C - 1, m >>= 1;
        return b;
      }, A.prototype.permute = function(m, g, d, b, C, E) {
        for (var B = 0; B < E; B++)
          b[B] = g[m[B]], C[B] = d[m[B]];
      }, A.prototype.transform = function(m, g, d, b, C, E) {
        this.permute(E, m, g, d, b, C);
        for (var B = 1; B < C; B <<= 1)
          for (var T = B << 1, _ = Math.cos(2 * Math.PI / T), I = Math.sin(2 * Math.PI / T), S = 0; S < C; S += T)
            for (var k = _, $ = I, ee = 0; ee < B; ee++) {
              var H = d[S + ee], N = b[S + ee], L = d[S + ee + B], j = b[S + ee + B], Y = k * L - $ * j;
              j = k * j + $ * L, L = Y, d[S + ee] = H + L, b[S + ee] = N + j, d[S + ee + B] = H - L, b[S + ee + B] = N - j, ee !== T && (Y = _ * k - I * $, $ = _ * $ + I * k, k = Y);
            }
      }, A.prototype.guessLen13b = function(m, g) {
        var d = Math.max(g, m) | 1, b = d & 1, C = 0;
        for (d = d / 2 | 0; d; d = d >>> 1)
          C++;
        return 1 << C + 1 + b;
      }, A.prototype.conjugate = function(m, g, d) {
        if (!(d <= 1))
          for (var b = 0; b < d / 2; b++) {
            var C = m[b];
            m[b] = m[d - b - 1], m[d - b - 1] = C, C = g[b], g[b] = -g[d - b - 1], g[d - b - 1] = -C;
          }
      }, A.prototype.normalize13b = function(m, g) {
        for (var d = 0, b = 0; b < g / 2; b++) {
          var C = Math.round(m[2 * b + 1] / g) * 8192 + Math.round(m[2 * b] / g) + d;
          m[b] = C & 67108863, C < 67108864 ? d = 0 : d = C / 67108864 | 0;
        }
        return m;
      }, A.prototype.convert13b = function(m, g, d, b) {
        for (var C = 0, E = 0; E < g; E++)
          C = C + (m[E] | 0), d[2 * E] = C & 8191, C = C >>> 13, d[2 * E + 1] = C & 8191, C = C >>> 13;
        for (E = 2 * g; E < b; ++E)
          d[E] = 0;
        r(C === 0), r((C & -8192) === 0);
      }, A.prototype.stub = function(m) {
        for (var g = new Array(m), d = 0; d < m; d++)
          g[d] = 0;
        return g;
      }, A.prototype.mulp = function(m, g, d) {
        var b = 2 * this.guessLen13b(m.length, g.length), C = this.makeRBT(b), E = this.stub(b), B = new Array(b), T = new Array(b), _ = new Array(b), I = new Array(b), S = new Array(b), k = new Array(b), $ = d.words;
        $.length = b, this.convert13b(m.words, m.length, B, b), this.convert13b(g.words, g.length, I, b), this.transform(B, E, T, _, b, C), this.transform(I, E, S, k, b, C);
        for (var ee = 0; ee < b; ee++) {
          var H = T[ee] * S[ee] - _[ee] * k[ee];
          _[ee] = T[ee] * k[ee] + _[ee] * S[ee], T[ee] = H;
        }
        return this.conjugate(T, _, b), this.transform(T, _, $, E, b, C), this.conjugate($, E, b), this.normalize13b($, b), d.negative = m.negative ^ g.negative, d.length = m.length + g.length, d.strip();
      }, a.prototype.mul = function(m) {
        var g = new a(null);
        return g.words = new Array(this.length + m.length), this.mulTo(m, g);
      }, a.prototype.mulf = function(m) {
        var g = new a(null);
        return g.words = new Array(this.length + m.length), x(this, m, g);
      }, a.prototype.imul = function(m) {
        return this.clone().mulTo(m, this);
      }, a.prototype.imuln = function(m) {
        r(typeof m == "number"), r(m < 67108864);
        for (var g = 0, d = 0; d < this.length; d++) {
          var b = (this.words[d] | 0) * m, C = (b & 67108863) + (g & 67108863);
          g >>= 26, g += b / 67108864 | 0, g += C >>> 26, this.words[d] = C & 67108863;
        }
        return g !== 0 && (this.words[d] = g, this.length++), this;
      }, a.prototype.muln = function(m) {
        return this.clone().imuln(m);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(m) {
        var g = p(m);
        if (g.length === 0)
          return new a(1);
        for (var d = this, b = 0; b < g.length && g[b] === 0; b++, d = d.sqr())
          ;
        if (++b < g.length)
          for (var C = d.sqr(); b < g.length; b++, C = C.sqr())
            g[b] !== 0 && (d = d.mul(C));
        return d;
      }, a.prototype.iushln = function(m) {
        r(typeof m == "number" && m >= 0);
        var g = m % 26, d = (m - g) / 26, b = 67108863 >>> 26 - g << 26 - g, C;
        if (g !== 0) {
          var E = 0;
          for (C = 0; C < this.length; C++) {
            var B = this.words[C] & b, T = (this.words[C] | 0) - B << g;
            this.words[C] = T | E, E = B >>> 26 - g;
          }
          E && (this.words[C] = E, this.length++);
        }
        if (d !== 0) {
          for (C = this.length - 1; C >= 0; C--)
            this.words[C + d] = this.words[C];
          for (C = 0; C < d; C++)
            this.words[C] = 0;
          this.length += d;
        }
        return this.strip();
      }, a.prototype.ishln = function(m) {
        return r(this.negative === 0), this.iushln(m);
      }, a.prototype.iushrn = function(m, g, d) {
        r(typeof m == "number" && m >= 0);
        var b;
        g ? b = (g - g % 26) / 26 : b = 0;
        var C = m % 26, E = Math.min((m - C) / 26, this.length), B = 67108863 ^ 67108863 >>> C << C, T = d;
        if (b -= E, b = Math.max(0, b), T) {
          for (var _ = 0; _ < E; _++)
            T.words[_] = this.words[_];
          T.length = E;
        }
        if (E !== 0)
          if (this.length > E)
            for (this.length -= E, _ = 0; _ < this.length; _++)
              this.words[_] = this.words[_ + E];
          else
            this.words[0] = 0, this.length = 1;
        var I = 0;
        for (_ = this.length - 1; _ >= 0 && (I !== 0 || _ >= b); _--) {
          var S = this.words[_] | 0;
          this.words[_] = I << 26 - C | S >>> C, I = S & B;
        }
        return T && I !== 0 && (T.words[T.length++] = I), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(m, g, d) {
        return r(this.negative === 0), this.iushrn(m, g, d);
      }, a.prototype.shln = function(m) {
        return this.clone().ishln(m);
      }, a.prototype.ushln = function(m) {
        return this.clone().iushln(m);
      }, a.prototype.shrn = function(m) {
        return this.clone().ishrn(m);
      }, a.prototype.ushrn = function(m) {
        return this.clone().iushrn(m);
      }, a.prototype.testn = function(m) {
        r(typeof m == "number" && m >= 0);
        var g = m % 26, d = (m - g) / 26, b = 1 << g;
        if (this.length <= d)
          return !1;
        var C = this.words[d];
        return !!(C & b);
      }, a.prototype.imaskn = function(m) {
        r(typeof m == "number" && m >= 0);
        var g = m % 26, d = (m - g) / 26;
        if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= d)
          return this;
        if (g !== 0 && d++, this.length = Math.min(d, this.length), g !== 0) {
          var b = 67108863 ^ 67108863 >>> g << g;
          this.words[this.length - 1] &= b;
        }
        return this.strip();
      }, a.prototype.maskn = function(m) {
        return this.clone().imaskn(m);
      }, a.prototype.iaddn = function(m) {
        return r(typeof m == "number"), r(m < 67108864), m < 0 ? this.isubn(-m) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < m ? (this.words[0] = m - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(m), this.negative = 1, this) : this._iaddn(m);
      }, a.prototype._iaddn = function(m) {
        this.words[0] += m;
        for (var g = 0; g < this.length && this.words[g] >= 67108864; g++)
          this.words[g] -= 67108864, g === this.length - 1 ? this.words[g + 1] = 1 : this.words[g + 1]++;
        return this.length = Math.max(this.length, g + 1), this;
      }, a.prototype.isubn = function(m) {
        if (r(typeof m == "number"), r(m < 67108864), m < 0)
          return this.iaddn(-m);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(m), this.negative = 1, this;
        if (this.words[0] -= m, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var g = 0; g < this.length && this.words[g] < 0; g++)
            this.words[g] += 67108864, this.words[g + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(m) {
        return this.clone().iaddn(m);
      }, a.prototype.subn = function(m) {
        return this.clone().isubn(m);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(m, g, d) {
        var b = m.length + d, C;
        this._expand(b);
        var E, B = 0;
        for (C = 0; C < m.length; C++) {
          E = (this.words[C + d] | 0) + B;
          var T = (m.words[C] | 0) * g;
          E -= T & 67108863, B = (E >> 26) - (T / 67108864 | 0), this.words[C + d] = E & 67108863;
        }
        for (; C < this.length - d; C++)
          E = (this.words[C + d] | 0) + B, B = E >> 26, this.words[C + d] = E & 67108863;
        if (B === 0)
          return this.strip();
        for (r(B === -1), B = 0, C = 0; C < this.length; C++)
          E = -(this.words[C] | 0) + B, B = E >> 26, this.words[C] = E & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(m, g) {
        var d = this.length - m.length, b = this.clone(), C = m, E = C.words[C.length - 1] | 0, B = this._countBits(E);
        d = 26 - B, d !== 0 && (C = C.ushln(d), b.iushln(d), E = C.words[C.length - 1] | 0);
        var T = b.length - C.length, _;
        if (g !== "mod") {
          _ = new a(null), _.length = T + 1, _.words = new Array(_.length);
          for (var I = 0; I < _.length; I++)
            _.words[I] = 0;
        }
        var S = b.clone()._ishlnsubmul(C, 1, T);
        S.negative === 0 && (b = S, _ && (_.words[T] = 1));
        for (var k = T - 1; k >= 0; k--) {
          var $ = (b.words[C.length + k] | 0) * 67108864 + (b.words[C.length + k - 1] | 0);
          for ($ = Math.min($ / E | 0, 67108863), b._ishlnsubmul(C, $, k); b.negative !== 0; )
            $--, b.negative = 0, b._ishlnsubmul(C, 1, k), b.isZero() || (b.negative ^= 1);
          _ && (_.words[k] = $);
        }
        return _ && _.strip(), b.strip(), g !== "div" && d !== 0 && b.iushrn(d), {
          div: _ || null,
          mod: b
        };
      }, a.prototype.divmod = function(m, g, d) {
        if (r(!m.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var b, C, E;
        return this.negative !== 0 && m.negative === 0 ? (E = this.neg().divmod(m, g), g !== "mod" && (b = E.div.neg()), g !== "div" && (C = E.mod.neg(), d && C.negative !== 0 && C.iadd(m)), {
          div: b,
          mod: C
        }) : this.negative === 0 && m.negative !== 0 ? (E = this.divmod(m.neg(), g), g !== "mod" && (b = E.div.neg()), {
          div: b,
          mod: E.mod
        }) : this.negative & m.negative ? (E = this.neg().divmod(m.neg(), g), g !== "div" && (C = E.mod.neg(), d && C.negative !== 0 && C.isub(m)), {
          div: E.div,
          mod: C
        }) : m.length > this.length || this.cmp(m) < 0 ? {
          div: new a(0),
          mod: this
        } : m.length === 1 ? g === "div" ? {
          div: this.divn(m.words[0]),
          mod: null
        } : g === "mod" ? {
          div: null,
          mod: new a(this.modn(m.words[0]))
        } : {
          div: this.divn(m.words[0]),
          mod: new a(this.modn(m.words[0]))
        } : this._wordDiv(m, g);
      }, a.prototype.div = function(m) {
        return this.divmod(m, "div", !1).div;
      }, a.prototype.mod = function(m) {
        return this.divmod(m, "mod", !1).mod;
      }, a.prototype.umod = function(m) {
        return this.divmod(m, "mod", !0).mod;
      }, a.prototype.divRound = function(m) {
        var g = this.divmod(m);
        if (g.mod.isZero())
          return g.div;
        var d = g.div.negative !== 0 ? g.mod.isub(m) : g.mod, b = m.ushrn(1), C = m.andln(1), E = d.cmp(b);
        return E < 0 || C === 1 && E === 0 ? g.div : g.div.negative !== 0 ? g.div.isubn(1) : g.div.iaddn(1);
      }, a.prototype.modn = function(m) {
        r(m <= 67108863);
        for (var g = (1 << 26) % m, d = 0, b = this.length - 1; b >= 0; b--)
          d = (g * d + (this.words[b] | 0)) % m;
        return d;
      }, a.prototype.idivn = function(m) {
        r(m <= 67108863);
        for (var g = 0, d = this.length - 1; d >= 0; d--) {
          var b = (this.words[d] | 0) + g * 67108864;
          this.words[d] = b / m | 0, g = b % m;
        }
        return this.strip();
      }, a.prototype.divn = function(m) {
        return this.clone().idivn(m);
      }, a.prototype.egcd = function(m) {
        r(m.negative === 0), r(!m.isZero());
        var g = this, d = m.clone();
        g.negative !== 0 ? g = g.umod(m) : g = g.clone();
        for (var b = new a(1), C = new a(0), E = new a(0), B = new a(1), T = 0; g.isEven() && d.isEven(); )
          g.iushrn(1), d.iushrn(1), ++T;
        for (var _ = d.clone(), I = g.clone(); !g.isZero(); ) {
          for (var S = 0, k = 1; !(g.words[0] & k) && S < 26; ++S, k <<= 1)
            ;
          if (S > 0)
            for (g.iushrn(S); S-- > 0; )
              (b.isOdd() || C.isOdd()) && (b.iadd(_), C.isub(I)), b.iushrn(1), C.iushrn(1);
          for (var $ = 0, ee = 1; !(d.words[0] & ee) && $ < 26; ++$, ee <<= 1)
            ;
          if ($ > 0)
            for (d.iushrn($); $-- > 0; )
              (E.isOdd() || B.isOdd()) && (E.iadd(_), B.isub(I)), E.iushrn(1), B.iushrn(1);
          g.cmp(d) >= 0 ? (g.isub(d), b.isub(E), C.isub(B)) : (d.isub(g), E.isub(b), B.isub(C));
        }
        return {
          a: E,
          b: B,
          gcd: d.iushln(T)
        };
      }, a.prototype._invmp = function(m) {
        r(m.negative === 0), r(!m.isZero());
        var g = this, d = m.clone();
        g.negative !== 0 ? g = g.umod(m) : g = g.clone();
        for (var b = new a(1), C = new a(0), E = d.clone(); g.cmpn(1) > 0 && d.cmpn(1) > 0; ) {
          for (var B = 0, T = 1; !(g.words[0] & T) && B < 26; ++B, T <<= 1)
            ;
          if (B > 0)
            for (g.iushrn(B); B-- > 0; )
              b.isOdd() && b.iadd(E), b.iushrn(1);
          for (var _ = 0, I = 1; !(d.words[0] & I) && _ < 26; ++_, I <<= 1)
            ;
          if (_ > 0)
            for (d.iushrn(_); _-- > 0; )
              C.isOdd() && C.iadd(E), C.iushrn(1);
          g.cmp(d) >= 0 ? (g.isub(d), b.isub(C)) : (d.isub(g), C.isub(b));
        }
        var S;
        return g.cmpn(1) === 0 ? S = b : S = C, S.cmpn(0) < 0 && S.iadd(m), S;
      }, a.prototype.gcd = function(m) {
        if (this.isZero())
          return m.abs();
        if (m.isZero())
          return this.abs();
        var g = this.clone(), d = m.clone();
        g.negative = 0, d.negative = 0;
        for (var b = 0; g.isEven() && d.isEven(); b++)
          g.iushrn(1), d.iushrn(1);
        do {
          for (; g.isEven(); )
            g.iushrn(1);
          for (; d.isEven(); )
            d.iushrn(1);
          var C = g.cmp(d);
          if (C < 0) {
            var E = g;
            g = d, d = E;
          } else if (C === 0 || d.cmpn(1) === 0)
            break;
          g.isub(d);
        } while (!0);
        return d.iushln(b);
      }, a.prototype.invm = function(m) {
        return this.egcd(m).a.umod(m);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(m) {
        return this.words[0] & m;
      }, a.prototype.bincn = function(m) {
        r(typeof m == "number");
        var g = m % 26, d = (m - g) / 26, b = 1 << g;
        if (this.length <= d)
          return this._expand(d + 1), this.words[d] |= b, this;
        for (var C = b, E = d; C !== 0 && E < this.length; E++) {
          var B = this.words[E] | 0;
          B += C, C = B >>> 26, B &= 67108863, this.words[E] = B;
        }
        return C !== 0 && (this.words[E] = C, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(m) {
        var g = m < 0;
        if (this.negative !== 0 && !g)
          return -1;
        if (this.negative === 0 && g)
          return 1;
        this.strip();
        var d;
        if (this.length > 1)
          d = 1;
        else {
          g && (m = -m), r(m <= 67108863, "Number is too big");
          var b = this.words[0] | 0;
          d = b === m ? 0 : b < m ? -1 : 1;
        }
        return this.negative !== 0 ? -d | 0 : d;
      }, a.prototype.cmp = function(m) {
        if (this.negative !== 0 && m.negative === 0)
          return -1;
        if (this.negative === 0 && m.negative !== 0)
          return 1;
        var g = this.ucmp(m);
        return this.negative !== 0 ? -g | 0 : g;
      }, a.prototype.ucmp = function(m) {
        if (this.length > m.length)
          return 1;
        if (this.length < m.length)
          return -1;
        for (var g = 0, d = this.length - 1; d >= 0; d--) {
          var b = this.words[d] | 0, C = m.words[d] | 0;
          if (b !== C) {
            b < C ? g = -1 : b > C && (g = 1);
            break;
          }
        }
        return g;
      }, a.prototype.gtn = function(m) {
        return this.cmpn(m) === 1;
      }, a.prototype.gt = function(m) {
        return this.cmp(m) === 1;
      }, a.prototype.gten = function(m) {
        return this.cmpn(m) >= 0;
      }, a.prototype.gte = function(m) {
        return this.cmp(m) >= 0;
      }, a.prototype.ltn = function(m) {
        return this.cmpn(m) === -1;
      }, a.prototype.lt = function(m) {
        return this.cmp(m) === -1;
      }, a.prototype.lten = function(m) {
        return this.cmpn(m) <= 0;
      }, a.prototype.lte = function(m) {
        return this.cmp(m) <= 0;
      }, a.prototype.eqn = function(m) {
        return this.cmpn(m) === 0;
      }, a.prototype.eq = function(m) {
        return this.cmp(m) === 0;
      }, a.red = function(m) {
        return new G(m);
      }, a.prototype.toRed = function(m) {
        return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), m.convertTo(this)._forceRed(m);
      }, a.prototype.fromRed = function() {
        return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(m) {
        return this.red = m, this;
      }, a.prototype.forceRed = function(m) {
        return r(!this.red, "Already a number in reduction context"), this._forceRed(m);
      }, a.prototype.redAdd = function(m) {
        return r(this.red, "redAdd works only with red numbers"), this.red.add(this, m);
      }, a.prototype.redIAdd = function(m) {
        return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, m);
      }, a.prototype.redSub = function(m) {
        return r(this.red, "redSub works only with red numbers"), this.red.sub(this, m);
      }, a.prototype.redISub = function(m) {
        return r(this.red, "redISub works only with red numbers"), this.red.isub(this, m);
      }, a.prototype.redShl = function(m) {
        return r(this.red, "redShl works only with red numbers"), this.red.shl(this, m);
      }, a.prototype.redMul = function(m) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, m), this.red.mul(this, m);
      }, a.prototype.redIMul = function(m) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, m), this.red.imul(this, m);
      }, a.prototype.redSqr = function() {
        return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(m) {
        return r(this.red && !m.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, m);
      };
      var R = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function M(V, m) {
        this.name = V, this.p = new a(m, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      M.prototype._tmp = function() {
        var m = new a(null);
        return m.words = new Array(Math.ceil(this.n / 13)), m;
      }, M.prototype.ireduce = function(m) {
        var g = m, d;
        do
          this.split(g, this.tmp), g = this.imulK(g), g = g.iadd(this.tmp), d = g.bitLength();
        while (d > this.n);
        var b = d < this.n ? -1 : g.ucmp(this.p);
        return b === 0 ? (g.words[0] = 0, g.length = 1) : b > 0 ? g.isub(this.p) : g.strip !== void 0 ? g.strip() : g._strip(), g;
      }, M.prototype.split = function(m, g) {
        m.iushrn(this.n, 0, g);
      }, M.prototype.imulK = function(m) {
        return m.imul(this.k);
      };
      function D() {
        M.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      n(D, M), D.prototype.split = function(m, g) {
        for (var d = 4194303, b = Math.min(m.length, 9), C = 0; C < b; C++)
          g.words[C] = m.words[C];
        if (g.length = b, m.length <= 9) {
          m.words[0] = 0, m.length = 1;
          return;
        }
        var E = m.words[9];
        for (g.words[g.length++] = E & d, C = 10; C < m.length; C++) {
          var B = m.words[C] | 0;
          m.words[C - 10] = (B & d) << 4 | E >>> 22, E = B;
        }
        E >>>= 22, m.words[C - 10] = E, E === 0 && m.length > 10 ? m.length -= 10 : m.length -= 9;
      }, D.prototype.imulK = function(m) {
        m.words[m.length] = 0, m.words[m.length + 1] = 0, m.length += 2;
        for (var g = 0, d = 0; d < m.length; d++) {
          var b = m.words[d] | 0;
          g += b * 977, m.words[d] = g & 67108863, g = b * 64 + (g / 67108864 | 0);
        }
        return m.words[m.length - 1] === 0 && (m.length--, m.words[m.length - 1] === 0 && m.length--), m;
      };
      function U() {
        M.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      n(U, M);
      function z() {
        M.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      n(z, M);
      function W() {
        M.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      n(W, M), W.prototype.imulK = function(m) {
        for (var g = 0, d = 0; d < m.length; d++) {
          var b = (m.words[d] | 0) * 19 + g, C = b & 67108863;
          b >>>= 26, m.words[d] = C, g = b;
        }
        return g !== 0 && (m.words[m.length++] = g), m;
      }, a._prime = function(m) {
        if (R[m])
          return R[m];
        var g;
        if (m === "k256")
          g = new D();
        else if (m === "p224")
          g = new U();
        else if (m === "p192")
          g = new z();
        else if (m === "p25519")
          g = new W();
        else
          throw new Error("Unknown prime " + m);
        return R[m] = g, g;
      };
      function G(V) {
        if (typeof V == "string") {
          var m = a._prime(V);
          this.m = m.p, this.prime = m;
        } else
          r(V.gtn(1), "modulus must be greater than 1"), this.m = V, this.prime = null;
      }
      G.prototype._verify1 = function(m) {
        r(m.negative === 0, "red works only with positives"), r(m.red, "red works only with red numbers");
      }, G.prototype._verify2 = function(m, g) {
        r((m.negative | g.negative) === 0, "red works only with positives"), r(
          m.red && m.red === g.red,
          "red works only with red numbers"
        );
      }, G.prototype.imod = function(m) {
        return this.prime ? this.prime.ireduce(m)._forceRed(this) : m.umod(this.m)._forceRed(this);
      }, G.prototype.neg = function(m) {
        return m.isZero() ? m.clone() : this.m.sub(m)._forceRed(this);
      }, G.prototype.add = function(m, g) {
        this._verify2(m, g);
        var d = m.add(g);
        return d.cmp(this.m) >= 0 && d.isub(this.m), d._forceRed(this);
      }, G.prototype.iadd = function(m, g) {
        this._verify2(m, g);
        var d = m.iadd(g);
        return d.cmp(this.m) >= 0 && d.isub(this.m), d;
      }, G.prototype.sub = function(m, g) {
        this._verify2(m, g);
        var d = m.sub(g);
        return d.cmpn(0) < 0 && d.iadd(this.m), d._forceRed(this);
      }, G.prototype.isub = function(m, g) {
        this._verify2(m, g);
        var d = m.isub(g);
        return d.cmpn(0) < 0 && d.iadd(this.m), d;
      }, G.prototype.shl = function(m, g) {
        return this._verify1(m), this.imod(m.ushln(g));
      }, G.prototype.imul = function(m, g) {
        return this._verify2(m, g), this.imod(m.imul(g));
      }, G.prototype.mul = function(m, g) {
        return this._verify2(m, g), this.imod(m.mul(g));
      }, G.prototype.isqr = function(m) {
        return this.imul(m, m.clone());
      }, G.prototype.sqr = function(m) {
        return this.mul(m, m);
      }, G.prototype.sqrt = function(m) {
        if (m.isZero())
          return m.clone();
        var g = this.m.andln(3);
        if (r(g % 2 === 1), g === 3) {
          var d = this.m.add(new a(1)).iushrn(2);
          return this.pow(m, d);
        }
        for (var b = this.m.subn(1), C = 0; !b.isZero() && b.andln(1) === 0; )
          C++, b.iushrn(1);
        r(!b.isZero());
        var E = new a(1).toRed(this), B = E.redNeg(), T = this.m.subn(1).iushrn(1), _ = this.m.bitLength();
        for (_ = new a(2 * _ * _).toRed(this); this.pow(_, T).cmp(B) !== 0; )
          _.redIAdd(B);
        for (var I = this.pow(_, b), S = this.pow(m, b.addn(1).iushrn(1)), k = this.pow(m, b), $ = C; k.cmp(E) !== 0; ) {
          for (var ee = k, H = 0; ee.cmp(E) !== 0; H++)
            ee = ee.redSqr();
          r(H < $);
          var N = this.pow(I, new a(1).iushln($ - H - 1));
          S = S.redMul(N), I = N.redSqr(), k = k.redMul(I), $ = H;
        }
        return S;
      }, G.prototype.invm = function(m) {
        var g = m._invmp(this.m);
        return g.negative !== 0 ? (g.negative = 0, this.imod(g).redNeg()) : this.imod(g);
      }, G.prototype.pow = function(m, g) {
        if (g.isZero())
          return new a(1).toRed(this);
        if (g.cmpn(1) === 0)
          return m.clone();
        var d = 4, b = new Array(1 << d);
        b[0] = new a(1).toRed(this), b[1] = m;
        for (var C = 2; C < b.length; C++)
          b[C] = this.mul(b[C - 1], m);
        var E = b[0], B = 0, T = 0, _ = g.bitLength() % 26;
        for (_ === 0 && (_ = 26), C = g.length - 1; C >= 0; C--) {
          for (var I = g.words[C], S = _ - 1; S >= 0; S--) {
            var k = I >> S & 1;
            if (E !== b[0] && (E = this.sqr(E)), k === 0 && B === 0) {
              T = 0;
              continue;
            }
            B <<= 1, B |= k, T++, !(T !== d && (C !== 0 || S !== 0)) && (E = this.mul(E, b[B]), T = 0, B = 0);
          }
          _ = 26;
        }
        return E;
      }, G.prototype.convertTo = function(m) {
        var g = m.umod(this.m);
        return g === m ? g.clone() : g;
      }, G.prototype.convertFrom = function(m) {
        var g = m.clone();
        return g.red = null, g;
      }, a.mont = function(m) {
        return new re(m);
      };
      function re(V) {
        G.call(this, V), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      n(re, G), re.prototype.convertTo = function(m) {
        return this.imod(m.ushln(this.shift));
      }, re.prototype.convertFrom = function(m) {
        var g = this.imod(m.mul(this.rinv));
        return g.red = null, g;
      }, re.prototype.imul = function(m, g) {
        if (m.isZero() || g.isZero())
          return m.words[0] = 0, m.length = 1, m;
        var d = m.imul(g), b = d.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), C = d.isub(b).iushrn(this.shift), E = C;
        return C.cmp(this.m) >= 0 ? E = C.isub(this.m) : C.cmpn(0) < 0 && (E = C.iadd(this.m)), E._forceRed(this);
      }, re.prototype.mul = function(m, g) {
        if (m.isZero() || g.isZero())
          return new a(0)._forceRed(this);
        var d = m.mul(g), b = d.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), C = d.isub(b).iushrn(this.shift), E = C;
        return C.cmp(this.m) >= 0 ? E = C.isub(this.m) : C.cmpn(0) < 0 && (E = C.iadd(this.m)), E._forceRed(this);
      }, re.prototype.invm = function(m) {
        var g = this.imod(m._invmp(this.m).mul(this.r2));
        return g._forceRed(this);
      };
    })(e, Ge);
  }(xa)), xa.exports;
}
var ca = { exports: {} }, Yc;
function n0() {
  if (Yc)
    return ca.exports;
  Yc = 1;
  var e;
  ca.exports = function(n) {
    return e || (e = new t(null)), e.generate(n);
  };
  function t(r) {
    this.rand = r;
  }
  if (ca.exports.Rand = t, t.prototype.generate = function(n) {
    return this._rand(n);
  }, t.prototype._rand = function(n) {
    if (this.rand.getBytes)
      return this.rand.getBytes(n);
    for (var a = new Uint8Array(n), f = 0; f < a.length; f++)
      a[f] = this.rand.getByte();
    return a;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? t.prototype._rand = function(n) {
      var a = new Uint8Array(n);
      return self.crypto.getRandomValues(a), a;
    } : self.msCrypto && self.msCrypto.getRandomValues ? t.prototype._rand = function(n) {
      var a = new Uint8Array(n);
      return self.msCrypto.getRandomValues(a), a;
    } : typeof window == "object" && (t.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var i = Ga();
      if (typeof i.randomBytes != "function")
        throw new Error("Not supported");
      t.prototype._rand = function(n) {
        return i.randomBytes(n);
      };
    } catch {
    }
  return ca.exports;
}
var ss, Xc;
function Rd() {
  if (Xc)
    return ss;
  Xc = 1;
  var e = jt(), t = n0();
  function i(r) {
    this.rand = r || new t.Rand();
  }
  return ss = i, i.create = function(n) {
    return new i(n);
  }, i.prototype._randbelow = function(n) {
    var a = n.bitLength(), f = Math.ceil(a / 8);
    do
      var s = new e(this.rand.generate(f));
    while (s.cmp(n) >= 0);
    return s;
  }, i.prototype._randrange = function(n, a) {
    var f = a.sub(n);
    return n.add(this._randbelow(f));
  }, i.prototype.test = function(n, a, f) {
    var s = n.bitLength(), c = e.mont(n), u = new e(1).toRed(c);
    a || (a = Math.max(1, s / 48 | 0));
    for (var o = n.subn(1), l = 0; !o.testn(l); l++)
      ;
    for (var h = n.shrn(l), p = o.toRed(c), v = !0; a > 0; a--) {
      var y = this._randrange(new e(2), o);
      f && f(y);
      var w = y.toRed(c).redPow(h);
      if (!(w.cmp(u) === 0 || w.cmp(p) === 0)) {
        for (var x = 1; x < l; x++) {
          if (w = w.redSqr(), w.cmp(u) === 0)
            return !1;
          if (w.cmp(p) === 0)
            break;
        }
        if (x === l)
          return !1;
      }
    }
    return v;
  }, i.prototype.getDivisor = function(n, a) {
    var f = n.bitLength(), s = e.mont(n), c = new e(1).toRed(s);
    a || (a = Math.max(1, f / 48 | 0));
    for (var u = n.subn(1), o = 0; !u.testn(o); o++)
      ;
    for (var l = n.shrn(o), h = u.toRed(s); a > 0; a--) {
      var p = this._randrange(new e(2), u), v = n.gcd(p);
      if (v.cmpn(1) !== 0)
        return v;
      var y = p.toRed(s).redPow(l);
      if (!(y.cmp(c) === 0 || y.cmp(h) === 0)) {
        for (var w = 1; w < o; w++) {
          if (y = y.redSqr(), y.cmp(c) === 0)
            return y.fromRed().subn(1).gcd(n);
          if (y.cmp(h) === 0)
            break;
        }
        if (w === o)
          return y = y.redSqr(), y.fromRed().subn(1).gcd(n);
      }
    }
    return !1;
  }, ss;
}
var os, Zc;
function Md() {
  if (Zc)
    return os;
  Zc = 1;
  var e = wi();
  os = w, w.simpleSieve = v, w.fermatTest = y;
  var t = jt(), i = new t(24), r = Rd(), n = new r(), a = new t(1), f = new t(2), s = new t(5);
  new t(16), new t(8);
  var c = new t(10), u = new t(3);
  new t(7);
  var o = new t(11), l = new t(4);
  new t(12);
  var h = null;
  function p() {
    if (h !== null)
      return h;
    var x = 1048576, A = [];
    A[0] = 2;
    for (var R = 1, M = 3; M < x; M += 2) {
      for (var D = Math.ceil(Math.sqrt(M)), U = 0; U < R && A[U] <= D && M % A[U] !== 0; U++)
        ;
      R !== U && A[U] <= D || (A[R++] = M);
    }
    return h = A, A;
  }
  function v(x) {
    for (var A = p(), R = 0; R < A.length; R++)
      if (x.modn(A[R]) === 0)
        return x.cmpn(A[R]) === 0;
    return !0;
  }
  function y(x) {
    var A = t.mont(x);
    return f.toRed(A).redPow(x.subn(1)).fromRed().cmpn(1) === 0;
  }
  function w(x, A) {
    if (x < 16)
      return A === 2 || A === 5 ? new t([140, 123]) : new t([140, 39]);
    A = new t(A);
    for (var R, M; ; ) {
      for (R = new t(e(Math.ceil(x / 8))); R.bitLength() > x; )
        R.ishrn(1);
      if (R.isEven() && R.iadd(a), R.testn(1) || R.iadd(f), A.cmp(f)) {
        if (!A.cmp(s))
          for (; R.mod(c).cmp(u); )
            R.iadd(l);
      } else
        for (; R.mod(i).cmp(o); )
          R.iadd(l);
      if (M = R.shrn(1), v(M) && v(R) && y(M) && y(R) && n.test(M) && n.test(R))
        return R;
    }
  }
  return os;
}
const _v = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, Sv = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, Ev = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, wv = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, Cv = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, Av = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, Bv = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, Tv = {
  gen: "02",
  prime: "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"
}, Iv = {
  modp1: _v,
  modp2: Sv,
  modp5: Ev,
  modp14: wv,
  modp15: Cv,
  modp16: Av,
  modp17: Bv,
  modp18: Tv
};
var us, Jc;
function Rv() {
  if (Jc)
    return us;
  Jc = 1;
  var e = jt(), t = Rd(), i = new t(), r = new e(24), n = new e(11), a = new e(10), f = new e(3), s = new e(7), c = Md(), u = wi();
  us = v;
  function o(w, x) {
    return x = x || "utf8", fe.Buffer.isBuffer(w) || (w = new fe.Buffer(w, x)), this._pub = new e(w), this;
  }
  function l(w, x) {
    return x = x || "utf8", fe.Buffer.isBuffer(w) || (w = new fe.Buffer(w, x)), this._priv = new e(w), this;
  }
  var h = {};
  function p(w, x) {
    var A = x.toString("hex"), R = [A, w.toString(16)].join("_");
    if (R in h)
      return h[R];
    var M = 0;
    if (w.isEven() || !c.simpleSieve || !c.fermatTest(w) || !i.test(w))
      return M += 1, A === "02" || A === "05" ? M += 8 : M += 4, h[R] = M, M;
    i.test(w.shrn(1)) || (M += 2);
    var D;
    switch (A) {
      case "02":
        w.mod(r).cmp(n) && (M += 8);
        break;
      case "05":
        D = w.mod(a), D.cmp(f) && D.cmp(s) && (M += 8);
        break;
      default:
        M += 4;
    }
    return h[R] = M, M;
  }
  function v(w, x, A) {
    this.setGenerator(x), this.__prime = new e(w), this._prime = e.mont(this.__prime), this._primeLen = w.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, A ? (this.setPublicKey = o, this.setPrivateKey = l) : this._primeCode = 8;
  }
  Object.defineProperty(v.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = p(this.__prime, this.__gen)), this._primeCode;
    }
  }), v.prototype.generateKeys = function() {
    return this._priv || (this._priv = new e(u(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, v.prototype.computeSecret = function(w) {
    w = new e(w), w = w.toRed(this._prime);
    var x = w.redPow(this._priv).fromRed(), A = new fe.Buffer(x.toArray()), R = this.getPrime();
    if (A.length < R.length) {
      var M = new fe.Buffer(R.length - A.length);
      M.fill(0), A = fe.Buffer.concat([M, A]);
    }
    return A;
  }, v.prototype.getPublicKey = function(x) {
    return y(this._pub, x);
  }, v.prototype.getPrivateKey = function(x) {
    return y(this._priv, x);
  }, v.prototype.getPrime = function(w) {
    return y(this.__prime, w);
  }, v.prototype.getGenerator = function(w) {
    return y(this._gen, w);
  }, v.prototype.setGenerator = function(w, x) {
    return x = x || "utf8", fe.Buffer.isBuffer(w) || (w = new fe.Buffer(w, x)), this.__gen = w, this._gen = new e(w), this;
  };
  function y(w, x) {
    var A = new fe.Buffer(w.toArray());
    return x ? A.toString(x) : A;
  }
  return us;
}
var el;
function Mv() {
  if (el)
    return ri;
  el = 1;
  var e = Md(), t = Iv, i = Rv();
  function r(f) {
    var s = new fe.Buffer(t[f].prime, "hex"), c = new fe.Buffer(t[f].gen, "hex");
    return new i(s, c);
  }
  var n = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function a(f, s, c, u) {
    return fe.Buffer.isBuffer(s) || n[s] === void 0 ? a(f, "binary", s, c) : (s = s || "binary", u = u || "binary", c = c || new fe.Buffer([2]), fe.Buffer.isBuffer(c) || (c = new fe.Buffer(c, u)), typeof f == "number" ? new i(e(f, c), c, !0) : (fe.Buffer.isBuffer(f) || (f = new fe.Buffer(f, s)), new i(f, c, !0)));
  }
  return ri.DiffieHellmanGroup = ri.createDiffieHellmanGroup = ri.getDiffieHellman = r, ri.createDiffieHellman = ri.DiffieHellman = a, ri;
}
var la = { exports: {} }, ha = { exports: {} }, tl;
function Ha() {
  if (tl)
    return ha.exports;
  tl = 1, typeof fe.process > "u" || !fe.process.version || fe.process.version.indexOf("v0.") === 0 || fe.process.version.indexOf("v1.") === 0 && fe.process.version.indexOf("v1.8.") !== 0 ? ha.exports = { nextTick: e } : ha.exports = fe.process;
  function e(t, i, r, n) {
    if (typeof t != "function")
      throw new TypeError('"callback" argument must be a function');
    var a = arguments.length, f, s;
    switch (a) {
      case 0:
      case 1:
        return fe.process.nextTick(t);
      case 2:
        return fe.process.nextTick(function() {
          t.call(null, i);
        });
      case 3:
        return fe.process.nextTick(function() {
          t.call(null, i, r);
        });
      case 4:
        return fe.process.nextTick(function() {
          t.call(null, i, r, n);
        });
      default:
        for (f = new Array(a - 1), s = 0; s < f.length; )
          f[s++] = arguments[s];
        return fe.process.nextTick(function() {
          t.apply(null, f);
        });
    }
  }
  return ha.exports;
}
var cs, rl;
function Nv() {
  if (rl)
    return cs;
  rl = 1;
  var e = {}.toString;
  return cs = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, cs;
}
var ls, il;
function Nd() {
  return il || (il = 1, ls = Hi().EventEmitter), ls;
}
var da = { exports: {} }, al;
function f0() {
  return al || (al = 1, function(e, t) {
    var i = or, r = i.Buffer;
    function n(f, s) {
      for (var c in f)
        s[c] = f[c];
    }
    r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = i : (n(i, t), t.Buffer = a);
    function a(f, s, c) {
      return r(f, s, c);
    }
    n(r, a), a.from = function(f, s, c) {
      if (typeof f == "number")
        throw new TypeError("Argument must not be a number");
      return r(f, s, c);
    }, a.alloc = function(f, s, c) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      var u = r(f);
      return s !== void 0 ? typeof c == "string" ? u.fill(s, c) : u.fill(s) : u.fill(0), u;
    }, a.allocUnsafe = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return r(f);
    }, a.allocUnsafeSlow = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return i.SlowBuffer(f);
    };
  }(da, da.exports)), da.exports;
}
var Ft = {}, nl;
function Qi() {
  if (nl)
    return Ft;
  nl = 1;
  function e(y) {
    return Array.isArray ? Array.isArray(y) : v(y) === "[object Array]";
  }
  Ft.isArray = e;
  function t(y) {
    return typeof y == "boolean";
  }
  Ft.isBoolean = t;
  function i(y) {
    return y === null;
  }
  Ft.isNull = i;
  function r(y) {
    return y == null;
  }
  Ft.isNullOrUndefined = r;
  function n(y) {
    return typeof y == "number";
  }
  Ft.isNumber = n;
  function a(y) {
    return typeof y == "string";
  }
  Ft.isString = a;
  function f(y) {
    return typeof y == "symbol";
  }
  Ft.isSymbol = f;
  function s(y) {
    return y === void 0;
  }
  Ft.isUndefined = s;
  function c(y) {
    return v(y) === "[object RegExp]";
  }
  Ft.isRegExp = c;
  function u(y) {
    return typeof y == "object" && y !== null;
  }
  Ft.isObject = u;
  function o(y) {
    return v(y) === "[object Date]";
  }
  Ft.isDate = o;
  function l(y) {
    return v(y) === "[object Error]" || y instanceof Error;
  }
  Ft.isError = l;
  function h(y) {
    return typeof y == "function";
  }
  Ft.isFunction = h;
  function p(y) {
    return y === null || typeof y == "boolean" || typeof y == "number" || typeof y == "string" || typeof y == "symbol" || // ES6 symbol
    typeof y > "u";
  }
  Ft.isPrimitive = p, Ft.isBuffer = or.Buffer.isBuffer;
  function v(y) {
    return Object.prototype.toString.call(y);
  }
  return Ft;
}
var hs = { exports: {} }, fl;
function kv() {
  return fl || (fl = 1, function(e) {
    function t(a, f) {
      if (!(a instanceof f))
        throw new TypeError("Cannot call a class as a function");
    }
    var i = f0().Buffer, r = Fa();
    function n(a, f, s) {
      a.copy(f, s);
    }
    e.exports = function() {
      function a() {
        t(this, a), this.head = null, this.tail = null, this.length = 0;
      }
      return a.prototype.push = function(s) {
        var c = { data: s, next: null };
        this.length > 0 ? this.tail.next = c : this.head = c, this.tail = c, ++this.length;
      }, a.prototype.unshift = function(s) {
        var c = { data: s, next: this.head };
        this.length === 0 && (this.tail = c), this.head = c, ++this.length;
      }, a.prototype.shift = function() {
        if (this.length !== 0) {
          var s = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, s;
        }
      }, a.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, a.prototype.join = function(s) {
        if (this.length === 0)
          return "";
        for (var c = this.head, u = "" + c.data; c = c.next; )
          u += s + c.data;
        return u;
      }, a.prototype.concat = function(s) {
        if (this.length === 0)
          return i.alloc(0);
        for (var c = i.allocUnsafe(s >>> 0), u = this.head, o = 0; u; )
          n(u.data, c, o), o += u.data.length, u = u.next;
        return c;
      }, a;
    }(), r && r.inspect && r.inspect.custom && (e.exports.prototype[r.inspect.custom] = function() {
      var a = r.inspect({ length: this.length });
      return this.constructor.name + " " + a;
    });
  }(hs)), hs.exports;
}
var ds, sl;
function kd() {
  if (sl)
    return ds;
  sl = 1;
  var e = Ha();
  function t(n, a) {
    var f = this, s = this._readableState && this._readableState.destroyed, c = this._writableState && this._writableState.destroyed;
    return s || c ? (a ? a(n) : n && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(r, this, n)) : e.nextTick(r, this, n)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(n || null, function(u) {
      !a && u ? f._writableState ? f._writableState.errorEmitted || (f._writableState.errorEmitted = !0, e.nextTick(r, f, u)) : e.nextTick(r, f, u) : a && a(u);
    }), this);
  }
  function i() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function r(n, a) {
    n.emit("error", a);
  }
  return ds = {
    destroy: t,
    undestroy: i
  }, ds;
}
var ps, ol;
function Dd() {
  if (ol)
    return ps;
  ol = 1;
  var e = Ha();
  ps = y;
  function t(E) {
    var B = this;
    this.next = null, this.entry = null, this.finish = function() {
      C(B, E);
    };
  }
  var i = !fe.process.browser && ["v0.10", "v0.9."].indexOf(fe.process.version.slice(0, 5)) > -1 ? setImmediate : e.nextTick, r;
  y.WritableState = p;
  var n = Object.create(Qi());
  n.inherits = Ae();
  var a = {
    deprecate: od()
  }, f = Nd(), s = f0().Buffer, c = (typeof Ge < "u" ? Ge : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function u(E) {
    return s.from(E);
  }
  function o(E) {
    return s.isBuffer(E) || E instanceof c;
  }
  var l = kd();
  n.inherits(y, f);
  function h() {
  }
  function p(E, B) {
    r = r || mi(), E = E || {};
    var T = B instanceof r;
    this.objectMode = !!E.objectMode, T && (this.objectMode = this.objectMode || !!E.writableObjectMode);
    var _ = E.highWaterMark, I = E.writableHighWaterMark, S = this.objectMode ? 16 : 16 * 1024;
    _ || _ === 0 ? this.highWaterMark = _ : T && (I || I === 0) ? this.highWaterMark = I : this.highWaterMark = S, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var k = E.decodeStrings === !1;
    this.decodeStrings = !k, this.defaultEncoding = E.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function($) {
      z(B, $);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  p.prototype.getBuffer = function() {
    for (var B = this.bufferedRequest, T = []; B; )
      T.push(B), B = B.next;
    return T;
  }, function() {
    try {
      Object.defineProperty(p.prototype, "buffer", {
        get: a.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var v;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (v = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
    value: function(E) {
      return v.call(this, E) ? !0 : this !== y ? !1 : E && E._writableState instanceof p;
    }
  })) : v = function(E) {
    return E instanceof this;
  };
  function y(E) {
    if (r = r || mi(), !v.call(y, this) && !(this instanceof r))
      return new y(E);
    this._writableState = new p(E, this), this.writable = !0, E && (typeof E.write == "function" && (this._write = E.write), typeof E.writev == "function" && (this._writev = E.writev), typeof E.destroy == "function" && (this._destroy = E.destroy), typeof E.final == "function" && (this._final = E.final)), f.call(this);
  }
  y.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function w(E, B) {
    var T = new Error("write after end");
    E.emit("error", T), e.nextTick(B, T);
  }
  function x(E, B, T, _) {
    var I = !0, S = !1;
    return T === null ? S = new TypeError("May not write null values to stream") : typeof T != "string" && T !== void 0 && !B.objectMode && (S = new TypeError("Invalid non-string/buffer chunk")), S && (E.emit("error", S), e.nextTick(_, S), I = !1), I;
  }
  y.prototype.write = function(E, B, T) {
    var _ = this._writableState, I = !1, S = !_.objectMode && o(E);
    return S && !s.isBuffer(E) && (E = u(E)), typeof B == "function" && (T = B, B = null), S ? B = "buffer" : B || (B = _.defaultEncoding), typeof T != "function" && (T = h), _.ended ? w(this, T) : (S || x(this, _, E, T)) && (_.pendingcb++, I = R(this, _, S, E, B, T)), I;
  }, y.prototype.cork = function() {
    var E = this._writableState;
    E.corked++;
  }, y.prototype.uncork = function() {
    var E = this._writableState;
    E.corked && (E.corked--, !E.writing && !E.corked && !E.bufferProcessing && E.bufferedRequest && re(this, E));
  }, y.prototype.setDefaultEncoding = function(B) {
    if (typeof B == "string" && (B = B.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((B + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + B);
    return this._writableState.defaultEncoding = B, this;
  };
  function A(E, B, T) {
    return !E.objectMode && E.decodeStrings !== !1 && typeof B == "string" && (B = s.from(B, T)), B;
  }
  Object.defineProperty(y.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function R(E, B, T, _, I, S) {
    if (!T) {
      var k = A(B, _, I);
      _ !== k && (T = !0, I = "buffer", _ = k);
    }
    var $ = B.objectMode ? 1 : _.length;
    B.length += $;
    var ee = B.length < B.highWaterMark;
    if (ee || (B.needDrain = !0), B.writing || B.corked) {
      var H = B.lastBufferedRequest;
      B.lastBufferedRequest = {
        chunk: _,
        encoding: I,
        isBuf: T,
        callback: S,
        next: null
      }, H ? H.next = B.lastBufferedRequest : B.bufferedRequest = B.lastBufferedRequest, B.bufferedRequestCount += 1;
    } else
      M(E, B, !1, $, _, I, S);
    return ee;
  }
  function M(E, B, T, _, I, S, k) {
    B.writelen = _, B.writecb = k, B.writing = !0, B.sync = !0, T ? E._writev(I, B.onwrite) : E._write(I, S, B.onwrite), B.sync = !1;
  }
  function D(E, B, T, _, I) {
    --B.pendingcb, T ? (e.nextTick(I, _), e.nextTick(d, E, B), E._writableState.errorEmitted = !0, E.emit("error", _)) : (I(_), E._writableState.errorEmitted = !0, E.emit("error", _), d(E, B));
  }
  function U(E) {
    E.writing = !1, E.writecb = null, E.length -= E.writelen, E.writelen = 0;
  }
  function z(E, B) {
    var T = E._writableState, _ = T.sync, I = T.writecb;
    if (U(T), B)
      D(E, T, _, B, I);
    else {
      var S = V(T);
      !S && !T.corked && !T.bufferProcessing && T.bufferedRequest && re(E, T), _ ? i(W, E, T, S, I) : W(E, T, S, I);
    }
  }
  function W(E, B, T, _) {
    T || G(E, B), B.pendingcb--, _(), d(E, B);
  }
  function G(E, B) {
    B.length === 0 && B.needDrain && (B.needDrain = !1, E.emit("drain"));
  }
  function re(E, B) {
    B.bufferProcessing = !0;
    var T = B.bufferedRequest;
    if (E._writev && T && T.next) {
      var _ = B.bufferedRequestCount, I = new Array(_), S = B.corkedRequestsFree;
      S.entry = T;
      for (var k = 0, $ = !0; T; )
        I[k] = T, T.isBuf || ($ = !1), T = T.next, k += 1;
      I.allBuffers = $, M(E, B, !0, B.length, I, "", S.finish), B.pendingcb++, B.lastBufferedRequest = null, S.next ? (B.corkedRequestsFree = S.next, S.next = null) : B.corkedRequestsFree = new t(B), B.bufferedRequestCount = 0;
    } else {
      for (; T; ) {
        var ee = T.chunk, H = T.encoding, N = T.callback, L = B.objectMode ? 1 : ee.length;
        if (M(E, B, !1, L, ee, H, N), T = T.next, B.bufferedRequestCount--, B.writing)
          break;
      }
      T === null && (B.lastBufferedRequest = null);
    }
    B.bufferedRequest = T, B.bufferProcessing = !1;
  }
  y.prototype._write = function(E, B, T) {
    T(new Error("_write() is not implemented"));
  }, y.prototype._writev = null, y.prototype.end = function(E, B, T) {
    var _ = this._writableState;
    typeof E == "function" ? (T = E, E = null, B = null) : typeof B == "function" && (T = B, B = null), E != null && this.write(E, B), _.corked && (_.corked = 1, this.uncork()), _.ending || b(this, _, T);
  };
  function V(E) {
    return E.ending && E.length === 0 && E.bufferedRequest === null && !E.finished && !E.writing;
  }
  function m(E, B) {
    E._final(function(T) {
      B.pendingcb--, T && E.emit("error", T), B.prefinished = !0, E.emit("prefinish"), d(E, B);
    });
  }
  function g(E, B) {
    !B.prefinished && !B.finalCalled && (typeof E._final == "function" ? (B.pendingcb++, B.finalCalled = !0, e.nextTick(m, E, B)) : (B.prefinished = !0, E.emit("prefinish")));
  }
  function d(E, B) {
    var T = V(B);
    return T && (g(E, B), B.pendingcb === 0 && (B.finished = !0, E.emit("finish"))), T;
  }
  function b(E, B, T) {
    B.ending = !0, d(E, B), T && (B.finished ? e.nextTick(T) : E.once("finish", T)), B.ended = !0, E.writable = !1;
  }
  function C(E, B, T) {
    var _ = E.entry;
    for (E.entry = null; _; ) {
      var I = _.callback;
      B.pendingcb--, I(T), _ = _.next;
    }
    B.corkedRequestsFree.next = E;
  }
  return Object.defineProperty(y.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(E) {
      this._writableState && (this._writableState.destroyed = E);
    }
  }), y.prototype.destroy = l.destroy, y.prototype._undestroy = l.undestroy, y.prototype._destroy = function(E, B) {
    this.end(), B(E);
  }, ps;
}
var vs, ul;
function mi() {
  if (ul)
    return vs;
  ul = 1;
  var e = Ha(), t = Object.keys || function(l) {
    var h = [];
    for (var p in l)
      h.push(p);
    return h;
  };
  vs = c;
  var i = Object.create(Qi());
  i.inherits = Ae();
  var r = Ld(), n = Dd();
  i.inherits(c, r);
  for (var a = t(n.prototype), f = 0; f < a.length; f++) {
    var s = a[f];
    c.prototype[s] || (c.prototype[s] = n.prototype[s]);
  }
  function c(l) {
    if (!(this instanceof c))
      return new c(l);
    r.call(this, l), n.call(this, l), l && l.readable === !1 && (this.readable = !1), l && l.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, l && l.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", u);
  }
  Object.defineProperty(c.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function u() {
    this.allowHalfOpen || this._writableState.ended || e.nextTick(o, this);
  }
  function o(l) {
    l.end();
  }
  return Object.defineProperty(c.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(l) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = l, this._writableState.destroyed = l);
    }
  }), c.prototype._destroy = function(l, h) {
    this.push(null), this.end(), e.nextTick(h, l);
  }, vs;
}
var ys, cl;
function Ld() {
  if (cl)
    return ys;
  cl = 1;
  var e = Ha();
  ys = A;
  var t = Nv(), i;
  A.ReadableState = x, Hi().EventEmitter;
  var r = function(N, L) {
    return N.listeners(L).length;
  }, n = Nd(), a = f0().Buffer, f = (typeof Ge < "u" ? Ge : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function s(N) {
    return a.from(N);
  }
  function c(N) {
    return a.isBuffer(N) || N instanceof f;
  }
  var u = Object.create(Qi());
  u.inherits = Ae();
  var o = Fa(), l = void 0;
  o && o.debuglog ? l = o.debuglog("stream") : l = function() {
  };
  var h = kv(), p = kd(), v;
  u.inherits(A, n);
  var y = ["error", "close", "destroy", "pause", "resume"];
  function w(N, L, j) {
    if (typeof N.prependListener == "function")
      return N.prependListener(L, j);
    !N._events || !N._events[L] ? N.on(L, j) : t(N._events[L]) ? N._events[L].unshift(j) : N._events[L] = [j, N._events[L]];
  }
  function x(N, L) {
    i = i || mi(), N = N || {};
    var j = L instanceof i;
    this.objectMode = !!N.objectMode, j && (this.objectMode = this.objectMode || !!N.readableObjectMode);
    var Y = N.highWaterMark, F = N.readableHighWaterMark, P = this.objectMode ? 16 : 16 * 1024;
    Y || Y === 0 ? this.highWaterMark = Y : j && (F || F === 0) ? this.highWaterMark = F : this.highWaterMark = P, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new h(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = N.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, N.encoding && (v || (v = Fi().StringDecoder), this.decoder = new v(N.encoding), this.encoding = N.encoding);
  }
  function A(N) {
    if (i = i || mi(), !(this instanceof A))
      return new A(N);
    this._readableState = new x(N, this), this.readable = !0, N && (typeof N.read == "function" && (this._read = N.read), typeof N.destroy == "function" && (this._destroy = N.destroy)), n.call(this);
  }
  Object.defineProperty(A.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(N) {
      this._readableState && (this._readableState.destroyed = N);
    }
  }), A.prototype.destroy = p.destroy, A.prototype._undestroy = p.undestroy, A.prototype._destroy = function(N, L) {
    this.push(null), L(N);
  }, A.prototype.push = function(N, L) {
    var j = this._readableState, Y;
    return j.objectMode ? Y = !0 : typeof N == "string" && (L = L || j.defaultEncoding, L !== j.encoding && (N = a.from(N, L), L = ""), Y = !0), R(this, N, L, !1, Y);
  }, A.prototype.unshift = function(N) {
    return R(this, N, null, !0, !1);
  };
  function R(N, L, j, Y, F) {
    var P = N._readableState;
    if (L === null)
      P.reading = !1, re(N, P);
    else {
      var Z;
      F || (Z = D(P, L)), Z ? N.emit("error", Z) : P.objectMode || L && L.length > 0 ? (typeof L != "string" && !P.objectMode && Object.getPrototypeOf(L) !== a.prototype && (L = s(L)), Y ? P.endEmitted ? N.emit("error", new Error("stream.unshift() after end event")) : M(N, P, L, !0) : P.ended ? N.emit("error", new Error("stream.push() after EOF")) : (P.reading = !1, P.decoder && !j ? (L = P.decoder.write(L), P.objectMode || L.length !== 0 ? M(N, P, L, !1) : g(N, P)) : M(N, P, L, !1))) : Y || (P.reading = !1);
    }
    return U(P);
  }
  function M(N, L, j, Y) {
    L.flowing && L.length === 0 && !L.sync ? (N.emit("data", j), N.read(0)) : (L.length += L.objectMode ? 1 : j.length, Y ? L.buffer.unshift(j) : L.buffer.push(j), L.needReadable && V(N)), g(N, L);
  }
  function D(N, L) {
    var j;
    return !c(L) && typeof L != "string" && L !== void 0 && !N.objectMode && (j = new TypeError("Invalid non-string/buffer chunk")), j;
  }
  function U(N) {
    return !N.ended && (N.needReadable || N.length < N.highWaterMark || N.length === 0);
  }
  A.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, A.prototype.setEncoding = function(N) {
    return v || (v = Fi().StringDecoder), this._readableState.decoder = new v(N), this._readableState.encoding = N, this;
  };
  var z = 8388608;
  function W(N) {
    return N >= z ? N = z : (N--, N |= N >>> 1, N |= N >>> 2, N |= N >>> 4, N |= N >>> 8, N |= N >>> 16, N++), N;
  }
  function G(N, L) {
    return N <= 0 || L.length === 0 && L.ended ? 0 : L.objectMode ? 1 : N !== N ? L.flowing && L.length ? L.buffer.head.data.length : L.length : (N > L.highWaterMark && (L.highWaterMark = W(N)), N <= L.length ? N : L.ended ? L.length : (L.needReadable = !0, 0));
  }
  A.prototype.read = function(N) {
    l("read", N), N = parseInt(N, 10);
    var L = this._readableState, j = N;
    if (N !== 0 && (L.emittedReadable = !1), N === 0 && L.needReadable && (L.length >= L.highWaterMark || L.ended))
      return l("read: emitReadable", L.length, L.ended), L.length === 0 && L.ended ? $(this) : V(this), null;
    if (N = G(N, L), N === 0 && L.ended)
      return L.length === 0 && $(this), null;
    var Y = L.needReadable;
    l("need readable", Y), (L.length === 0 || L.length - N < L.highWaterMark) && (Y = !0, l("length less than watermark", Y)), L.ended || L.reading ? (Y = !1, l("reading or ended", Y)) : Y && (l("do read"), L.reading = !0, L.sync = !0, L.length === 0 && (L.needReadable = !0), this._read(L.highWaterMark), L.sync = !1, L.reading || (N = G(j, L)));
    var F;
    return N > 0 ? F = _(N, L) : F = null, F === null ? (L.needReadable = !0, N = 0) : L.length -= N, L.length === 0 && (L.ended || (L.needReadable = !0), j !== N && L.ended && $(this)), F !== null && this.emit("data", F), F;
  };
  function re(N, L) {
    if (!L.ended) {
      if (L.decoder) {
        var j = L.decoder.end();
        j && j.length && (L.buffer.push(j), L.length += L.objectMode ? 1 : j.length);
      }
      L.ended = !0, V(N);
    }
  }
  function V(N) {
    var L = N._readableState;
    L.needReadable = !1, L.emittedReadable || (l("emitReadable", L.flowing), L.emittedReadable = !0, L.sync ? e.nextTick(m, N) : m(N));
  }
  function m(N) {
    l("emit readable"), N.emit("readable"), T(N);
  }
  function g(N, L) {
    L.readingMore || (L.readingMore = !0, e.nextTick(d, N, L));
  }
  function d(N, L) {
    for (var j = L.length; !L.reading && !L.flowing && !L.ended && L.length < L.highWaterMark && (l("maybeReadMore read 0"), N.read(0), j !== L.length); )
      j = L.length;
    L.readingMore = !1;
  }
  A.prototype._read = function(N) {
    this.emit("error", new Error("_read() is not implemented"));
  }, A.prototype.pipe = function(N, L) {
    var j = this, Y = this._readableState;
    switch (Y.pipesCount) {
      case 0:
        Y.pipes = N;
        break;
      case 1:
        Y.pipes = [Y.pipes, N];
        break;
      default:
        Y.pipes.push(N);
        break;
    }
    Y.pipesCount += 1, l("pipe count=%d opts=%j", Y.pipesCount, L);
    var F = (!L || L.end !== !1) && N !== fe.process.stdout && N !== fe.process.stderr, P = F ? ae : Te;
    Y.endEmitted ? e.nextTick(P) : j.once("end", P), N.on("unpipe", Z);
    function Z(xe, ze) {
      l("onunpipe"), xe === j && ze && ze.hasUnpiped === !1 && (ze.hasUnpiped = !0, be());
    }
    function ae() {
      l("onend"), N.end();
    }
    var se = b(j);
    N.on("drain", se);
    var le = !1;
    function be() {
      l("cleanup"), N.removeListener("close", pe), N.removeListener("finish", Ce), N.removeListener("drain", se), N.removeListener("error", Be), N.removeListener("unpipe", Z), j.removeListener("end", ae), j.removeListener("end", Te), j.removeListener("data", ie), le = !0, Y.awaitDrain && (!N._writableState || N._writableState.needDrain) && se();
    }
    var me = !1;
    j.on("data", ie);
    function ie(xe) {
      l("ondata"), me = !1;
      var ze = N.write(xe);
      ze === !1 && !me && ((Y.pipesCount === 1 && Y.pipes === N || Y.pipesCount > 1 && H(Y.pipes, N) !== -1) && !le && (l("false write response, pause", Y.awaitDrain), Y.awaitDrain++, me = !0), j.pause());
    }
    function Be(xe) {
      l("onerror", xe), Te(), N.removeListener("error", Be), r(N, "error") === 0 && N.emit("error", xe);
    }
    w(N, "error", Be);
    function pe() {
      N.removeListener("finish", Ce), Te();
    }
    N.once("close", pe);
    function Ce() {
      l("onfinish"), N.removeListener("close", pe), Te();
    }
    N.once("finish", Ce);
    function Te() {
      l("unpipe"), j.unpipe(N);
    }
    return N.emit("pipe", j), Y.flowing || (l("pipe resume"), j.resume()), N;
  };
  function b(N) {
    return function() {
      var L = N._readableState;
      l("pipeOnDrain", L.awaitDrain), L.awaitDrain && L.awaitDrain--, L.awaitDrain === 0 && r(N, "data") && (L.flowing = !0, T(N));
    };
  }
  A.prototype.unpipe = function(N) {
    var L = this._readableState, j = { hasUnpiped: !1 };
    if (L.pipesCount === 0)
      return this;
    if (L.pipesCount === 1)
      return N && N !== L.pipes ? this : (N || (N = L.pipes), L.pipes = null, L.pipesCount = 0, L.flowing = !1, N && N.emit("unpipe", this, j), this);
    if (!N) {
      var Y = L.pipes, F = L.pipesCount;
      L.pipes = null, L.pipesCount = 0, L.flowing = !1;
      for (var P = 0; P < F; P++)
        Y[P].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Z = H(L.pipes, N);
    return Z === -1 ? this : (L.pipes.splice(Z, 1), L.pipesCount -= 1, L.pipesCount === 1 && (L.pipes = L.pipes[0]), N.emit("unpipe", this, j), this);
  }, A.prototype.on = function(N, L) {
    var j = n.prototype.on.call(this, N, L);
    if (N === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (N === "readable") {
      var Y = this._readableState;
      !Y.endEmitted && !Y.readableListening && (Y.readableListening = Y.needReadable = !0, Y.emittedReadable = !1, Y.reading ? Y.length && V(this) : e.nextTick(C, this));
    }
    return j;
  }, A.prototype.addListener = A.prototype.on;
  function C(N) {
    l("readable nexttick read 0"), N.read(0);
  }
  A.prototype.resume = function() {
    var N = this._readableState;
    return N.flowing || (l("resume"), N.flowing = !0, E(this, N)), this;
  };
  function E(N, L) {
    L.resumeScheduled || (L.resumeScheduled = !0, e.nextTick(B, N, L));
  }
  function B(N, L) {
    L.reading || (l("resume read 0"), N.read(0)), L.resumeScheduled = !1, L.awaitDrain = 0, N.emit("resume"), T(N), L.flowing && !L.reading && N.read(0);
  }
  A.prototype.pause = function() {
    return l("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (l("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function T(N) {
    var L = N._readableState;
    for (l("flow", L.flowing); L.flowing && N.read() !== null; )
      ;
  }
  A.prototype.wrap = function(N) {
    var L = this, j = this._readableState, Y = !1;
    N.on("end", function() {
      if (l("wrapped end"), j.decoder && !j.ended) {
        var Z = j.decoder.end();
        Z && Z.length && L.push(Z);
      }
      L.push(null);
    }), N.on("data", function(Z) {
      if (l("wrapped data"), j.decoder && (Z = j.decoder.write(Z)), !(j.objectMode && Z == null) && !(!j.objectMode && (!Z || !Z.length))) {
        var ae = L.push(Z);
        ae || (Y = !0, N.pause());
      }
    });
    for (var F in N)
      this[F] === void 0 && typeof N[F] == "function" && (this[F] = /* @__PURE__ */ function(Z) {
        return function() {
          return N[Z].apply(N, arguments);
        };
      }(F));
    for (var P = 0; P < y.length; P++)
      N.on(y[P], this.emit.bind(this, y[P]));
    return this._read = function(Z) {
      l("wrapped _read", Z), Y && (Y = !1, N.resume());
    }, this;
  }, Object.defineProperty(A.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), A._fromList = _;
  function _(N, L) {
    if (L.length === 0)
      return null;
    var j;
    return L.objectMode ? j = L.buffer.shift() : !N || N >= L.length ? (L.decoder ? j = L.buffer.join("") : L.buffer.length === 1 ? j = L.buffer.head.data : j = L.buffer.concat(L.length), L.buffer.clear()) : j = I(N, L.buffer, L.decoder), j;
  }
  function I(N, L, j) {
    var Y;
    return N < L.head.data.length ? (Y = L.head.data.slice(0, N), L.head.data = L.head.data.slice(N)) : N === L.head.data.length ? Y = L.shift() : Y = j ? S(N, L) : k(N, L), Y;
  }
  function S(N, L) {
    var j = L.head, Y = 1, F = j.data;
    for (N -= F.length; j = j.next; ) {
      var P = j.data, Z = N > P.length ? P.length : N;
      if (Z === P.length ? F += P : F += P.slice(0, N), N -= Z, N === 0) {
        Z === P.length ? (++Y, j.next ? L.head = j.next : L.head = L.tail = null) : (L.head = j, j.data = P.slice(Z));
        break;
      }
      ++Y;
    }
    return L.length -= Y, F;
  }
  function k(N, L) {
    var j = a.allocUnsafe(N), Y = L.head, F = 1;
    for (Y.data.copy(j), N -= Y.data.length; Y = Y.next; ) {
      var P = Y.data, Z = N > P.length ? P.length : N;
      if (P.copy(j, j.length - N, 0, Z), N -= Z, N === 0) {
        Z === P.length ? (++F, Y.next ? L.head = Y.next : L.head = L.tail = null) : (L.head = Y, Y.data = P.slice(Z));
        break;
      }
      ++F;
    }
    return L.length -= F, j;
  }
  function $(N) {
    var L = N._readableState;
    if (L.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    L.endEmitted || (L.ended = !0, e.nextTick(ee, L, N));
  }
  function ee(N, L) {
    !N.endEmitted && N.length === 0 && (N.endEmitted = !0, L.readable = !1, L.emit("end"));
  }
  function H(N, L) {
    for (var j = 0, Y = N.length; j < Y; j++)
      if (N[j] === L)
        return j;
    return -1;
  }
  return ys;
}
var gs, ll;
function Pd() {
  if (ll)
    return gs;
  ll = 1, gs = r;
  var e = mi(), t = Object.create(Qi());
  t.inherits = Ae(), t.inherits(r, e);
  function i(f, s) {
    var c = this._transformState;
    c.transforming = !1;
    var u = c.writecb;
    if (!u)
      return this.emit("error", new Error("write callback called multiple times"));
    c.writechunk = null, c.writecb = null, s != null && this.push(s), u(f);
    var o = this._readableState;
    o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
  }
  function r(f) {
    if (!(this instanceof r))
      return new r(f);
    e.call(this, f), this._transformState = {
      afterTransform: i.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, f && (typeof f.transform == "function" && (this._transform = f.transform), typeof f.flush == "function" && (this._flush = f.flush)), this.on("prefinish", n);
  }
  function n() {
    var f = this;
    typeof this._flush == "function" ? this._flush(function(s, c) {
      a(f, s, c);
    }) : a(this, null, null);
  }
  r.prototype.push = function(f, s) {
    return this._transformState.needTransform = !1, e.prototype.push.call(this, f, s);
  }, r.prototype._transform = function(f, s, c) {
    throw new Error("_transform() is not implemented");
  }, r.prototype._write = function(f, s, c) {
    var u = this._transformState;
    if (u.writecb = c, u.writechunk = f, u.writeencoding = s, !u.transforming) {
      var o = this._readableState;
      (u.needTransform || o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
    }
  }, r.prototype._read = function(f) {
    var s = this._transformState;
    s.writechunk !== null && s.writecb && !s.transforming ? (s.transforming = !0, this._transform(s.writechunk, s.writeencoding, s.afterTransform)) : s.needTransform = !0;
  }, r.prototype._destroy = function(f, s) {
    var c = this;
    e.prototype._destroy.call(this, f, function(u) {
      s(u), c.emit("close");
    });
  };
  function a(f, s, c) {
    if (s)
      return f.emit("error", s);
    if (c != null && f.push(c), f._writableState.length)
      throw new Error("Calling transform done when ws.length != 0");
    if (f._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return f.push(null);
  }
  return gs;
}
var bs, hl;
function Dv() {
  if (hl)
    return bs;
  hl = 1, bs = i;
  var e = Pd(), t = Object.create(Qi());
  t.inherits = Ae(), t.inherits(i, e);
  function i(r) {
    if (!(this instanceof i))
      return new i(r);
    e.call(this, r);
  }
  return i.prototype._transform = function(r, n, a) {
    a(null, r);
  }, bs;
}
var dl;
function Lv() {
  return dl || (dl = 1, function(e, t) {
    t = e.exports = Ld(), t.Stream = t, t.Readable = t, t.Writable = Dd(), t.Duplex = mi(), t.Transform = Pd(), t.PassThrough = Dv();
  }(la, la.exports)), la.exports;
}
var Mi = { exports: {} }, _a = { exports: {} };
_a.exports;
var pl;
function s0() {
  return pl || (pl = 1, function(e) {
    (function(t, i) {
      function r(g, d) {
        if (!g)
          throw new Error(d || "Assertion failed");
      }
      function n(g, d) {
        g.super_ = d;
        var b = function() {
        };
        b.prototype = d.prototype, g.prototype = new b(), g.prototype.constructor = g;
      }
      function a(g, d, b) {
        if (a.isBN(g))
          return g;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((d === "le" || d === "be") && (b = d, d = 10), this._init(g || 0, d || 10, b || "be"));
      }
      typeof t == "object" ? t.exports = a : i.BN = a, a.BN = a, a.wordSize = 26;
      var f;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = or.Buffer;
      } catch {
      }
      a.isBN = function(d) {
        return d instanceof a ? !0 : d !== null && typeof d == "object" && d.constructor.wordSize === a.wordSize && Array.isArray(d.words);
      }, a.max = function(d, b) {
        return d.cmp(b) > 0 ? d : b;
      }, a.min = function(d, b) {
        return d.cmp(b) < 0 ? d : b;
      }, a.prototype._init = function(d, b, C) {
        if (typeof d == "number")
          return this._initNumber(d, b, C);
        if (typeof d == "object")
          return this._initArray(d, b, C);
        b === "hex" && (b = 16), r(b === (b | 0) && b >= 2 && b <= 36), d = d.toString().replace(/\s+/g, "");
        var E = 0;
        d[0] === "-" && (E++, this.negative = 1), E < d.length && (b === 16 ? this._parseHex(d, E, C) : (this._parseBase(d, b, E), C === "le" && this._initArray(this.toArray(), b, C)));
      }, a.prototype._initNumber = function(d, b, C) {
        d < 0 && (this.negative = 1, d = -d), d < 67108864 ? (this.words = [d & 67108863], this.length = 1) : d < 4503599627370496 ? (this.words = [
          d & 67108863,
          d / 67108864 & 67108863
        ], this.length = 2) : (r(d < 9007199254740992), this.words = [
          d & 67108863,
          d / 67108864 & 67108863,
          1
        ], this.length = 3), C === "le" && this._initArray(this.toArray(), b, C);
      }, a.prototype._initArray = function(d, b, C) {
        if (r(typeof d.length == "number"), d.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(d.length / 3), this.words = new Array(this.length);
        for (var E = 0; E < this.length; E++)
          this.words[E] = 0;
        var B, T, _ = 0;
        if (C === "be")
          for (E = d.length - 1, B = 0; E >= 0; E -= 3)
            T = d[E] | d[E - 1] << 8 | d[E - 2] << 16, this.words[B] |= T << _ & 67108863, this.words[B + 1] = T >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, B++);
        else if (C === "le")
          for (E = 0, B = 0; E < d.length; E += 3)
            T = d[E] | d[E + 1] << 8 | d[E + 2] << 16, this.words[B] |= T << _ & 67108863, this.words[B + 1] = T >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, B++);
        return this._strip();
      };
      function s(g, d) {
        var b = g.charCodeAt(d);
        if (b >= 48 && b <= 57)
          return b - 48;
        if (b >= 65 && b <= 70)
          return b - 55;
        if (b >= 97 && b <= 102)
          return b - 87;
        r(!1, "Invalid character in " + g);
      }
      function c(g, d, b) {
        var C = s(g, b);
        return b - 1 >= d && (C |= s(g, b - 1) << 4), C;
      }
      a.prototype._parseHex = function(d, b, C) {
        this.length = Math.ceil((d.length - b) / 6), this.words = new Array(this.length);
        for (var E = 0; E < this.length; E++)
          this.words[E] = 0;
        var B = 0, T = 0, _;
        if (C === "be")
          for (E = d.length - 1; E >= b; E -= 2)
            _ = c(d, b, E) << B, this.words[T] |= _ & 67108863, B >= 18 ? (B -= 18, T += 1, this.words[T] |= _ >>> 26) : B += 8;
        else {
          var I = d.length - b;
          for (E = I % 2 === 0 ? b + 1 : b; E < d.length; E += 2)
            _ = c(d, b, E) << B, this.words[T] |= _ & 67108863, B >= 18 ? (B -= 18, T += 1, this.words[T] |= _ >>> 26) : B += 8;
        }
        this._strip();
      };
      function u(g, d, b, C) {
        for (var E = 0, B = 0, T = Math.min(g.length, b), _ = d; _ < T; _++) {
          var I = g.charCodeAt(_) - 48;
          E *= C, I >= 49 ? B = I - 49 + 10 : I >= 17 ? B = I - 17 + 10 : B = I, r(I >= 0 && B < C, "Invalid character"), E += B;
        }
        return E;
      }
      a.prototype._parseBase = function(d, b, C) {
        this.words = [0], this.length = 1;
        for (var E = 0, B = 1; B <= 67108863; B *= b)
          E++;
        E--, B = B / b | 0;
        for (var T = d.length - C, _ = T % E, I = Math.min(T, T - _) + C, S = 0, k = C; k < I; k += E)
          S = u(d, k, k + E, b), this.imuln(B), this.words[0] + S < 67108864 ? this.words[0] += S : this._iaddn(S);
        if (_ !== 0) {
          var $ = 1;
          for (S = u(d, k, d.length, b), k = 0; k < _; k++)
            $ *= b;
          this.imuln($), this.words[0] + S < 67108864 ? this.words[0] += S : this._iaddn(S);
        }
        this._strip();
      }, a.prototype.copy = function(d) {
        d.words = new Array(this.length);
        for (var b = 0; b < this.length; b++)
          d.words[b] = this.words[b];
        d.length = this.length, d.negative = this.negative, d.red = this.red;
      };
      function o(g, d) {
        g.words = d.words, g.length = d.length, g.negative = d.negative, g.red = d.red;
      }
      if (a.prototype._move = function(d) {
        o(d, this);
      }, a.prototype.clone = function() {
        var d = new a(null);
        return this.copy(d), d;
      }, a.prototype._expand = function(d) {
        for (; this.length < d; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          a.prototype[Symbol.for("nodejs.util.inspect.custom")] = l;
        } catch {
          a.prototype.inspect = l;
        }
      else
        a.prototype.inspect = l;
      function l() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], p = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], v = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(d, b) {
        d = d || 10, b = b | 0 || 1;
        var C;
        if (d === 16 || d === "hex") {
          C = "";
          for (var E = 0, B = 0, T = 0; T < this.length; T++) {
            var _ = this.words[T], I = ((_ << E | B) & 16777215).toString(16);
            B = _ >>> 24 - E & 16777215, E += 2, E >= 26 && (E -= 26, T--), B !== 0 || T !== this.length - 1 ? C = h[6 - I.length] + I + C : C = I + C;
          }
          for (B !== 0 && (C = B.toString(16) + C); C.length % b !== 0; )
            C = "0" + C;
          return this.negative !== 0 && (C = "-" + C), C;
        }
        if (d === (d | 0) && d >= 2 && d <= 36) {
          var S = p[d], k = v[d];
          C = "";
          var $ = this.clone();
          for ($.negative = 0; !$.isZero(); ) {
            var ee = $.modrn(k).toString(d);
            $ = $.idivn(k), $.isZero() ? C = ee + C : C = h[S - ee.length] + ee + C;
          }
          for (this.isZero() && (C = "0" + C); C.length % b !== 0; )
            C = "0" + C;
          return this.negative !== 0 && (C = "-" + C), C;
        }
        r(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var d = this.words[0];
        return this.length === 2 ? d += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? d += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -d : d;
      }, a.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, f && (a.prototype.toBuffer = function(d, b) {
        return this.toArrayLike(f, d, b);
      }), a.prototype.toArray = function(d, b) {
        return this.toArrayLike(Array, d, b);
      };
      var y = function(d, b) {
        return d.allocUnsafe ? d.allocUnsafe(b) : new d(b);
      };
      a.prototype.toArrayLike = function(d, b, C) {
        this._strip();
        var E = this.byteLength(), B = C || Math.max(1, E);
        r(E <= B, "byte array longer than desired length"), r(B > 0, "Requested array length <= 0");
        var T = y(d, B), _ = b === "le" ? "LE" : "BE";
        return this["_toArrayLike" + _](T, E), T;
      }, a.prototype._toArrayLikeLE = function(d, b) {
        for (var C = 0, E = 0, B = 0, T = 0; B < this.length; B++) {
          var _ = this.words[B] << T | E;
          d[C++] = _ & 255, C < d.length && (d[C++] = _ >> 8 & 255), C < d.length && (d[C++] = _ >> 16 & 255), T === 6 ? (C < d.length && (d[C++] = _ >> 24 & 255), E = 0, T = 0) : (E = _ >>> 24, T += 2);
        }
        if (C < d.length)
          for (d[C++] = E; C < d.length; )
            d[C++] = 0;
      }, a.prototype._toArrayLikeBE = function(d, b) {
        for (var C = d.length - 1, E = 0, B = 0, T = 0; B < this.length; B++) {
          var _ = this.words[B] << T | E;
          d[C--] = _ & 255, C >= 0 && (d[C--] = _ >> 8 & 255), C >= 0 && (d[C--] = _ >> 16 & 255), T === 6 ? (C >= 0 && (d[C--] = _ >> 24 & 255), E = 0, T = 0) : (E = _ >>> 24, T += 2);
        }
        if (C >= 0)
          for (d[C--] = E; C >= 0; )
            d[C--] = 0;
      }, Math.clz32 ? a.prototype._countBits = function(d) {
        return 32 - Math.clz32(d);
      } : a.prototype._countBits = function(d) {
        var b = d, C = 0;
        return b >= 4096 && (C += 13, b >>>= 13), b >= 64 && (C += 7, b >>>= 7), b >= 8 && (C += 4, b >>>= 4), b >= 2 && (C += 2, b >>>= 2), C + b;
      }, a.prototype._zeroBits = function(d) {
        if (d === 0)
          return 26;
        var b = d, C = 0;
        return b & 8191 || (C += 13, b >>>= 13), b & 127 || (C += 7, b >>>= 7), b & 15 || (C += 4, b >>>= 4), b & 3 || (C += 2, b >>>= 2), b & 1 || C++, C;
      }, a.prototype.bitLength = function() {
        var d = this.words[this.length - 1], b = this._countBits(d);
        return (this.length - 1) * 26 + b;
      };
      function w(g) {
        for (var d = new Array(g.bitLength()), b = 0; b < d.length; b++) {
          var C = b / 26 | 0, E = b % 26;
          d[b] = g.words[C] >>> E & 1;
        }
        return d;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var d = 0, b = 0; b < this.length; b++) {
          var C = this._zeroBits(this.words[b]);
          if (d += C, C !== 26)
            break;
        }
        return d;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(d) {
        return this.negative !== 0 ? this.abs().inotn(d).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(d) {
        return this.testn(d - 1) ? this.notn(d).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(d) {
        for (; this.length < d.length; )
          this.words[this.length++] = 0;
        for (var b = 0; b < d.length; b++)
          this.words[b] = this.words[b] | d.words[b];
        return this._strip();
      }, a.prototype.ior = function(d) {
        return r((this.negative | d.negative) === 0), this.iuor(d);
      }, a.prototype.or = function(d) {
        return this.length > d.length ? this.clone().ior(d) : d.clone().ior(this);
      }, a.prototype.uor = function(d) {
        return this.length > d.length ? this.clone().iuor(d) : d.clone().iuor(this);
      }, a.prototype.iuand = function(d) {
        var b;
        this.length > d.length ? b = d : b = this;
        for (var C = 0; C < b.length; C++)
          this.words[C] = this.words[C] & d.words[C];
        return this.length = b.length, this._strip();
      }, a.prototype.iand = function(d) {
        return r((this.negative | d.negative) === 0), this.iuand(d);
      }, a.prototype.and = function(d) {
        return this.length > d.length ? this.clone().iand(d) : d.clone().iand(this);
      }, a.prototype.uand = function(d) {
        return this.length > d.length ? this.clone().iuand(d) : d.clone().iuand(this);
      }, a.prototype.iuxor = function(d) {
        var b, C;
        this.length > d.length ? (b = this, C = d) : (b = d, C = this);
        for (var E = 0; E < C.length; E++)
          this.words[E] = b.words[E] ^ C.words[E];
        if (this !== b)
          for (; E < b.length; E++)
            this.words[E] = b.words[E];
        return this.length = b.length, this._strip();
      }, a.prototype.ixor = function(d) {
        return r((this.negative | d.negative) === 0), this.iuxor(d);
      }, a.prototype.xor = function(d) {
        return this.length > d.length ? this.clone().ixor(d) : d.clone().ixor(this);
      }, a.prototype.uxor = function(d) {
        return this.length > d.length ? this.clone().iuxor(d) : d.clone().iuxor(this);
      }, a.prototype.inotn = function(d) {
        r(typeof d == "number" && d >= 0);
        var b = Math.ceil(d / 26) | 0, C = d % 26;
        this._expand(b), C > 0 && b--;
        for (var E = 0; E < b; E++)
          this.words[E] = ~this.words[E] & 67108863;
        return C > 0 && (this.words[E] = ~this.words[E] & 67108863 >> 26 - C), this._strip();
      }, a.prototype.notn = function(d) {
        return this.clone().inotn(d);
      }, a.prototype.setn = function(d, b) {
        r(typeof d == "number" && d >= 0);
        var C = d / 26 | 0, E = d % 26;
        return this._expand(C + 1), b ? this.words[C] = this.words[C] | 1 << E : this.words[C] = this.words[C] & ~(1 << E), this._strip();
      }, a.prototype.iadd = function(d) {
        var b;
        if (this.negative !== 0 && d.negative === 0)
          return this.negative = 0, b = this.isub(d), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && d.negative !== 0)
          return d.negative = 0, b = this.isub(d), d.negative = 1, b._normSign();
        var C, E;
        this.length > d.length ? (C = this, E = d) : (C = d, E = this);
        for (var B = 0, T = 0; T < E.length; T++)
          b = (C.words[T] | 0) + (E.words[T] | 0) + B, this.words[T] = b & 67108863, B = b >>> 26;
        for (; B !== 0 && T < C.length; T++)
          b = (C.words[T] | 0) + B, this.words[T] = b & 67108863, B = b >>> 26;
        if (this.length = C.length, B !== 0)
          this.words[this.length] = B, this.length++;
        else if (C !== this)
          for (; T < C.length; T++)
            this.words[T] = C.words[T];
        return this;
      }, a.prototype.add = function(d) {
        var b;
        return d.negative !== 0 && this.negative === 0 ? (d.negative = 0, b = this.sub(d), d.negative ^= 1, b) : d.negative === 0 && this.negative !== 0 ? (this.negative = 0, b = d.sub(this), this.negative = 1, b) : this.length > d.length ? this.clone().iadd(d) : d.clone().iadd(this);
      }, a.prototype.isub = function(d) {
        if (d.negative !== 0) {
          d.negative = 0;
          var b = this.iadd(d);
          return d.negative = 1, b._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(d), this.negative = 1, this._normSign();
        var C = this.cmp(d);
        if (C === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var E, B;
        C > 0 ? (E = this, B = d) : (E = d, B = this);
        for (var T = 0, _ = 0; _ < B.length; _++)
          b = (E.words[_] | 0) - (B.words[_] | 0) + T, T = b >> 26, this.words[_] = b & 67108863;
        for (; T !== 0 && _ < E.length; _++)
          b = (E.words[_] | 0) + T, T = b >> 26, this.words[_] = b & 67108863;
        if (T === 0 && _ < E.length && E !== this)
          for (; _ < E.length; _++)
            this.words[_] = E.words[_];
        return this.length = Math.max(this.length, _), E !== this && (this.negative = 1), this._strip();
      }, a.prototype.sub = function(d) {
        return this.clone().isub(d);
      };
      function x(g, d, b) {
        b.negative = d.negative ^ g.negative;
        var C = g.length + d.length | 0;
        b.length = C, C = C - 1 | 0;
        var E = g.words[0] | 0, B = d.words[0] | 0, T = E * B, _ = T & 67108863, I = T / 67108864 | 0;
        b.words[0] = _;
        for (var S = 1; S < C; S++) {
          for (var k = I >>> 26, $ = I & 67108863, ee = Math.min(S, d.length - 1), H = Math.max(0, S - g.length + 1); H <= ee; H++) {
            var N = S - H | 0;
            E = g.words[N] | 0, B = d.words[H] | 0, T = E * B + $, k += T / 67108864 | 0, $ = T & 67108863;
          }
          b.words[S] = $ | 0, I = k | 0;
        }
        return I !== 0 ? b.words[S] = I | 0 : b.length--, b._strip();
      }
      var A = function(d, b, C) {
        var E = d.words, B = b.words, T = C.words, _ = 0, I, S, k, $ = E[0] | 0, ee = $ & 8191, H = $ >>> 13, N = E[1] | 0, L = N & 8191, j = N >>> 13, Y = E[2] | 0, F = Y & 8191, P = Y >>> 13, Z = E[3] | 0, ae = Z & 8191, se = Z >>> 13, le = E[4] | 0, be = le & 8191, me = le >>> 13, ie = E[5] | 0, Be = ie & 8191, pe = ie >>> 13, Ce = E[6] | 0, Te = Ce & 8191, xe = Ce >>> 13, ze = E[7] | 0, et = ze & 8191, Ee = ze >>> 13, tt = E[8] | 0, ht = tt & 8191, Re = tt >>> 13, dt = E[9] | 0, pt = dt & 8191, Me = dt >>> 13, vt = B[0] | 0, yt = vt & 8191, Ne = vt >>> 13, gt = B[1] | 0, bt = gt & 8191, ke = gt >>> 13, mt = B[2] | 0, xt = mt & 8191, De = mt >>> 13, _t = B[3] | 0, St = _t & 8191, Le = _t >>> 13, Et = B[4] | 0, wt = Et & 8191, Pe = Et >>> 13, Ct = B[5] | 0, At = Ct & 8191, Ue = Ct >>> 13, Bt = B[6] | 0, Tt = Bt & 8191, Oe = Bt >>> 13, It = B[7] | 0, Rt = It & 8191, qe = It >>> 13, Mt = B[8] | 0, Nt = Mt & 8191, Fe = Mt >>> 13, kt = B[9] | 0, ut = kt & 8191, ct = kt >>> 13;
        C.negative = d.negative ^ b.negative, C.length = 19, I = Math.imul(ee, yt), S = Math.imul(ee, Ne), S = S + Math.imul(H, yt) | 0, k = Math.imul(H, Ne);
        var Or = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Or >>> 26) | 0, Or &= 67108863, I = Math.imul(L, yt), S = Math.imul(L, Ne), S = S + Math.imul(j, yt) | 0, k = Math.imul(j, Ne), I = I + Math.imul(ee, bt) | 0, S = S + Math.imul(ee, ke) | 0, S = S + Math.imul(H, bt) | 0, k = k + Math.imul(H, ke) | 0;
        var qr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, I = Math.imul(F, yt), S = Math.imul(F, Ne), S = S + Math.imul(P, yt) | 0, k = Math.imul(P, Ne), I = I + Math.imul(L, bt) | 0, S = S + Math.imul(L, ke) | 0, S = S + Math.imul(j, bt) | 0, k = k + Math.imul(j, ke) | 0, I = I + Math.imul(ee, xt) | 0, S = S + Math.imul(ee, De) | 0, S = S + Math.imul(H, xt) | 0, k = k + Math.imul(H, De) | 0;
        var Fr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, I = Math.imul(ae, yt), S = Math.imul(ae, Ne), S = S + Math.imul(se, yt) | 0, k = Math.imul(se, Ne), I = I + Math.imul(F, bt) | 0, S = S + Math.imul(F, ke) | 0, S = S + Math.imul(P, bt) | 0, k = k + Math.imul(P, ke) | 0, I = I + Math.imul(L, xt) | 0, S = S + Math.imul(L, De) | 0, S = S + Math.imul(j, xt) | 0, k = k + Math.imul(j, De) | 0, I = I + Math.imul(ee, St) | 0, S = S + Math.imul(ee, Le) | 0, S = S + Math.imul(H, St) | 0, k = k + Math.imul(H, Le) | 0;
        var Vr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, I = Math.imul(be, yt), S = Math.imul(be, Ne), S = S + Math.imul(me, yt) | 0, k = Math.imul(me, Ne), I = I + Math.imul(ae, bt) | 0, S = S + Math.imul(ae, ke) | 0, S = S + Math.imul(se, bt) | 0, k = k + Math.imul(se, ke) | 0, I = I + Math.imul(F, xt) | 0, S = S + Math.imul(F, De) | 0, S = S + Math.imul(P, xt) | 0, k = k + Math.imul(P, De) | 0, I = I + Math.imul(L, St) | 0, S = S + Math.imul(L, Le) | 0, S = S + Math.imul(j, St) | 0, k = k + Math.imul(j, Le) | 0, I = I + Math.imul(ee, wt) | 0, S = S + Math.imul(ee, Pe) | 0, S = S + Math.imul(H, wt) | 0, k = k + Math.imul(H, Pe) | 0;
        var Kr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Kr >>> 26) | 0, Kr &= 67108863, I = Math.imul(Be, yt), S = Math.imul(Be, Ne), S = S + Math.imul(pe, yt) | 0, k = Math.imul(pe, Ne), I = I + Math.imul(be, bt) | 0, S = S + Math.imul(be, ke) | 0, S = S + Math.imul(me, bt) | 0, k = k + Math.imul(me, ke) | 0, I = I + Math.imul(ae, xt) | 0, S = S + Math.imul(ae, De) | 0, S = S + Math.imul(se, xt) | 0, k = k + Math.imul(se, De) | 0, I = I + Math.imul(F, St) | 0, S = S + Math.imul(F, Le) | 0, S = S + Math.imul(P, St) | 0, k = k + Math.imul(P, Le) | 0, I = I + Math.imul(L, wt) | 0, S = S + Math.imul(L, Pe) | 0, S = S + Math.imul(j, wt) | 0, k = k + Math.imul(j, Pe) | 0, I = I + Math.imul(ee, At) | 0, S = S + Math.imul(ee, Ue) | 0, S = S + Math.imul(H, At) | 0, k = k + Math.imul(H, Ue) | 0;
        var Hr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Hr >>> 26) | 0, Hr &= 67108863, I = Math.imul(Te, yt), S = Math.imul(Te, Ne), S = S + Math.imul(xe, yt) | 0, k = Math.imul(xe, Ne), I = I + Math.imul(Be, bt) | 0, S = S + Math.imul(Be, ke) | 0, S = S + Math.imul(pe, bt) | 0, k = k + Math.imul(pe, ke) | 0, I = I + Math.imul(be, xt) | 0, S = S + Math.imul(be, De) | 0, S = S + Math.imul(me, xt) | 0, k = k + Math.imul(me, De) | 0, I = I + Math.imul(ae, St) | 0, S = S + Math.imul(ae, Le) | 0, S = S + Math.imul(se, St) | 0, k = k + Math.imul(se, Le) | 0, I = I + Math.imul(F, wt) | 0, S = S + Math.imul(F, Pe) | 0, S = S + Math.imul(P, wt) | 0, k = k + Math.imul(P, Pe) | 0, I = I + Math.imul(L, At) | 0, S = S + Math.imul(L, Ue) | 0, S = S + Math.imul(j, At) | 0, k = k + Math.imul(j, Ue) | 0, I = I + Math.imul(ee, Tt) | 0, S = S + Math.imul(ee, Oe) | 0, S = S + Math.imul(H, Tt) | 0, k = k + Math.imul(H, Oe) | 0;
        var jr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (jr >>> 26) | 0, jr &= 67108863, I = Math.imul(et, yt), S = Math.imul(et, Ne), S = S + Math.imul(Ee, yt) | 0, k = Math.imul(Ee, Ne), I = I + Math.imul(Te, bt) | 0, S = S + Math.imul(Te, ke) | 0, S = S + Math.imul(xe, bt) | 0, k = k + Math.imul(xe, ke) | 0, I = I + Math.imul(Be, xt) | 0, S = S + Math.imul(Be, De) | 0, S = S + Math.imul(pe, xt) | 0, k = k + Math.imul(pe, De) | 0, I = I + Math.imul(be, St) | 0, S = S + Math.imul(be, Le) | 0, S = S + Math.imul(me, St) | 0, k = k + Math.imul(me, Le) | 0, I = I + Math.imul(ae, wt) | 0, S = S + Math.imul(ae, Pe) | 0, S = S + Math.imul(se, wt) | 0, k = k + Math.imul(se, Pe) | 0, I = I + Math.imul(F, At) | 0, S = S + Math.imul(F, Ue) | 0, S = S + Math.imul(P, At) | 0, k = k + Math.imul(P, Ue) | 0, I = I + Math.imul(L, Tt) | 0, S = S + Math.imul(L, Oe) | 0, S = S + Math.imul(j, Tt) | 0, k = k + Math.imul(j, Oe) | 0, I = I + Math.imul(ee, Rt) | 0, S = S + Math.imul(ee, qe) | 0, S = S + Math.imul(H, Rt) | 0, k = k + Math.imul(H, qe) | 0;
        var zr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, I = Math.imul(ht, yt), S = Math.imul(ht, Ne), S = S + Math.imul(Re, yt) | 0, k = Math.imul(Re, Ne), I = I + Math.imul(et, bt) | 0, S = S + Math.imul(et, ke) | 0, S = S + Math.imul(Ee, bt) | 0, k = k + Math.imul(Ee, ke) | 0, I = I + Math.imul(Te, xt) | 0, S = S + Math.imul(Te, De) | 0, S = S + Math.imul(xe, xt) | 0, k = k + Math.imul(xe, De) | 0, I = I + Math.imul(Be, St) | 0, S = S + Math.imul(Be, Le) | 0, S = S + Math.imul(pe, St) | 0, k = k + Math.imul(pe, Le) | 0, I = I + Math.imul(be, wt) | 0, S = S + Math.imul(be, Pe) | 0, S = S + Math.imul(me, wt) | 0, k = k + Math.imul(me, Pe) | 0, I = I + Math.imul(ae, At) | 0, S = S + Math.imul(ae, Ue) | 0, S = S + Math.imul(se, At) | 0, k = k + Math.imul(se, Ue) | 0, I = I + Math.imul(F, Tt) | 0, S = S + Math.imul(F, Oe) | 0, S = S + Math.imul(P, Tt) | 0, k = k + Math.imul(P, Oe) | 0, I = I + Math.imul(L, Rt) | 0, S = S + Math.imul(L, qe) | 0, S = S + Math.imul(j, Rt) | 0, k = k + Math.imul(j, qe) | 0, I = I + Math.imul(ee, Nt) | 0, S = S + Math.imul(ee, Fe) | 0, S = S + Math.imul(H, Nt) | 0, k = k + Math.imul(H, Fe) | 0;
        var Gr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, I = Math.imul(pt, yt), S = Math.imul(pt, Ne), S = S + Math.imul(Me, yt) | 0, k = Math.imul(Me, Ne), I = I + Math.imul(ht, bt) | 0, S = S + Math.imul(ht, ke) | 0, S = S + Math.imul(Re, bt) | 0, k = k + Math.imul(Re, ke) | 0, I = I + Math.imul(et, xt) | 0, S = S + Math.imul(et, De) | 0, S = S + Math.imul(Ee, xt) | 0, k = k + Math.imul(Ee, De) | 0, I = I + Math.imul(Te, St) | 0, S = S + Math.imul(Te, Le) | 0, S = S + Math.imul(xe, St) | 0, k = k + Math.imul(xe, Le) | 0, I = I + Math.imul(Be, wt) | 0, S = S + Math.imul(Be, Pe) | 0, S = S + Math.imul(pe, wt) | 0, k = k + Math.imul(pe, Pe) | 0, I = I + Math.imul(be, At) | 0, S = S + Math.imul(be, Ue) | 0, S = S + Math.imul(me, At) | 0, k = k + Math.imul(me, Ue) | 0, I = I + Math.imul(ae, Tt) | 0, S = S + Math.imul(ae, Oe) | 0, S = S + Math.imul(se, Tt) | 0, k = k + Math.imul(se, Oe) | 0, I = I + Math.imul(F, Rt) | 0, S = S + Math.imul(F, qe) | 0, S = S + Math.imul(P, Rt) | 0, k = k + Math.imul(P, qe) | 0, I = I + Math.imul(L, Nt) | 0, S = S + Math.imul(L, Fe) | 0, S = S + Math.imul(j, Nt) | 0, k = k + Math.imul(j, Fe) | 0, I = I + Math.imul(ee, ut) | 0, S = S + Math.imul(ee, ct) | 0, S = S + Math.imul(H, ut) | 0, k = k + Math.imul(H, ct) | 0;
        var $r = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, I = Math.imul(pt, bt), S = Math.imul(pt, ke), S = S + Math.imul(Me, bt) | 0, k = Math.imul(Me, ke), I = I + Math.imul(ht, xt) | 0, S = S + Math.imul(ht, De) | 0, S = S + Math.imul(Re, xt) | 0, k = k + Math.imul(Re, De) | 0, I = I + Math.imul(et, St) | 0, S = S + Math.imul(et, Le) | 0, S = S + Math.imul(Ee, St) | 0, k = k + Math.imul(Ee, Le) | 0, I = I + Math.imul(Te, wt) | 0, S = S + Math.imul(Te, Pe) | 0, S = S + Math.imul(xe, wt) | 0, k = k + Math.imul(xe, Pe) | 0, I = I + Math.imul(Be, At) | 0, S = S + Math.imul(Be, Ue) | 0, S = S + Math.imul(pe, At) | 0, k = k + Math.imul(pe, Ue) | 0, I = I + Math.imul(be, Tt) | 0, S = S + Math.imul(be, Oe) | 0, S = S + Math.imul(me, Tt) | 0, k = k + Math.imul(me, Oe) | 0, I = I + Math.imul(ae, Rt) | 0, S = S + Math.imul(ae, qe) | 0, S = S + Math.imul(se, Rt) | 0, k = k + Math.imul(se, qe) | 0, I = I + Math.imul(F, Nt) | 0, S = S + Math.imul(F, Fe) | 0, S = S + Math.imul(P, Nt) | 0, k = k + Math.imul(P, Fe) | 0, I = I + Math.imul(L, ut) | 0, S = S + Math.imul(L, ct) | 0, S = S + Math.imul(j, ut) | 0, k = k + Math.imul(j, ct) | 0;
        var Wr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, I = Math.imul(pt, xt), S = Math.imul(pt, De), S = S + Math.imul(Me, xt) | 0, k = Math.imul(Me, De), I = I + Math.imul(ht, St) | 0, S = S + Math.imul(ht, Le) | 0, S = S + Math.imul(Re, St) | 0, k = k + Math.imul(Re, Le) | 0, I = I + Math.imul(et, wt) | 0, S = S + Math.imul(et, Pe) | 0, S = S + Math.imul(Ee, wt) | 0, k = k + Math.imul(Ee, Pe) | 0, I = I + Math.imul(Te, At) | 0, S = S + Math.imul(Te, Ue) | 0, S = S + Math.imul(xe, At) | 0, k = k + Math.imul(xe, Ue) | 0, I = I + Math.imul(Be, Tt) | 0, S = S + Math.imul(Be, Oe) | 0, S = S + Math.imul(pe, Tt) | 0, k = k + Math.imul(pe, Oe) | 0, I = I + Math.imul(be, Rt) | 0, S = S + Math.imul(be, qe) | 0, S = S + Math.imul(me, Rt) | 0, k = k + Math.imul(me, qe) | 0, I = I + Math.imul(ae, Nt) | 0, S = S + Math.imul(ae, Fe) | 0, S = S + Math.imul(se, Nt) | 0, k = k + Math.imul(se, Fe) | 0, I = I + Math.imul(F, ut) | 0, S = S + Math.imul(F, ct) | 0, S = S + Math.imul(P, ut) | 0, k = k + Math.imul(P, ct) | 0;
        var Qr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, I = Math.imul(pt, St), S = Math.imul(pt, Le), S = S + Math.imul(Me, St) | 0, k = Math.imul(Me, Le), I = I + Math.imul(ht, wt) | 0, S = S + Math.imul(ht, Pe) | 0, S = S + Math.imul(Re, wt) | 0, k = k + Math.imul(Re, Pe) | 0, I = I + Math.imul(et, At) | 0, S = S + Math.imul(et, Ue) | 0, S = S + Math.imul(Ee, At) | 0, k = k + Math.imul(Ee, Ue) | 0, I = I + Math.imul(Te, Tt) | 0, S = S + Math.imul(Te, Oe) | 0, S = S + Math.imul(xe, Tt) | 0, k = k + Math.imul(xe, Oe) | 0, I = I + Math.imul(Be, Rt) | 0, S = S + Math.imul(Be, qe) | 0, S = S + Math.imul(pe, Rt) | 0, k = k + Math.imul(pe, qe) | 0, I = I + Math.imul(be, Nt) | 0, S = S + Math.imul(be, Fe) | 0, S = S + Math.imul(me, Nt) | 0, k = k + Math.imul(me, Fe) | 0, I = I + Math.imul(ae, ut) | 0, S = S + Math.imul(ae, ct) | 0, S = S + Math.imul(se, ut) | 0, k = k + Math.imul(se, ct) | 0;
        var Yr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, I = Math.imul(pt, wt), S = Math.imul(pt, Pe), S = S + Math.imul(Me, wt) | 0, k = Math.imul(Me, Pe), I = I + Math.imul(ht, At) | 0, S = S + Math.imul(ht, Ue) | 0, S = S + Math.imul(Re, At) | 0, k = k + Math.imul(Re, Ue) | 0, I = I + Math.imul(et, Tt) | 0, S = S + Math.imul(et, Oe) | 0, S = S + Math.imul(Ee, Tt) | 0, k = k + Math.imul(Ee, Oe) | 0, I = I + Math.imul(Te, Rt) | 0, S = S + Math.imul(Te, qe) | 0, S = S + Math.imul(xe, Rt) | 0, k = k + Math.imul(xe, qe) | 0, I = I + Math.imul(Be, Nt) | 0, S = S + Math.imul(Be, Fe) | 0, S = S + Math.imul(pe, Nt) | 0, k = k + Math.imul(pe, Fe) | 0, I = I + Math.imul(be, ut) | 0, S = S + Math.imul(be, ct) | 0, S = S + Math.imul(me, ut) | 0, k = k + Math.imul(me, ct) | 0;
        var Xr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, I = Math.imul(pt, At), S = Math.imul(pt, Ue), S = S + Math.imul(Me, At) | 0, k = Math.imul(Me, Ue), I = I + Math.imul(ht, Tt) | 0, S = S + Math.imul(ht, Oe) | 0, S = S + Math.imul(Re, Tt) | 0, k = k + Math.imul(Re, Oe) | 0, I = I + Math.imul(et, Rt) | 0, S = S + Math.imul(et, qe) | 0, S = S + Math.imul(Ee, Rt) | 0, k = k + Math.imul(Ee, qe) | 0, I = I + Math.imul(Te, Nt) | 0, S = S + Math.imul(Te, Fe) | 0, S = S + Math.imul(xe, Nt) | 0, k = k + Math.imul(xe, Fe) | 0, I = I + Math.imul(Be, ut) | 0, S = S + Math.imul(Be, ct) | 0, S = S + Math.imul(pe, ut) | 0, k = k + Math.imul(pe, ct) | 0;
        var Zr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, I = Math.imul(pt, Tt), S = Math.imul(pt, Oe), S = S + Math.imul(Me, Tt) | 0, k = Math.imul(Me, Oe), I = I + Math.imul(ht, Rt) | 0, S = S + Math.imul(ht, qe) | 0, S = S + Math.imul(Re, Rt) | 0, k = k + Math.imul(Re, qe) | 0, I = I + Math.imul(et, Nt) | 0, S = S + Math.imul(et, Fe) | 0, S = S + Math.imul(Ee, Nt) | 0, k = k + Math.imul(Ee, Fe) | 0, I = I + Math.imul(Te, ut) | 0, S = S + Math.imul(Te, ct) | 0, S = S + Math.imul(xe, ut) | 0, k = k + Math.imul(xe, ct) | 0;
        var Jr = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Jr >>> 26) | 0, Jr &= 67108863, I = Math.imul(pt, Rt), S = Math.imul(pt, qe), S = S + Math.imul(Me, Rt) | 0, k = Math.imul(Me, qe), I = I + Math.imul(ht, Nt) | 0, S = S + Math.imul(ht, Fe) | 0, S = S + Math.imul(Re, Nt) | 0, k = k + Math.imul(Re, Fe) | 0, I = I + Math.imul(et, ut) | 0, S = S + Math.imul(et, ct) | 0, S = S + Math.imul(Ee, ut) | 0, k = k + Math.imul(Ee, ct) | 0;
        var ei = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, I = Math.imul(pt, Nt), S = Math.imul(pt, Fe), S = S + Math.imul(Me, Nt) | 0, k = Math.imul(Me, Fe), I = I + Math.imul(ht, ut) | 0, S = S + Math.imul(ht, ct) | 0, S = S + Math.imul(Re, ut) | 0, k = k + Math.imul(Re, ct) | 0;
        var Za = (_ + I | 0) + ((S & 8191) << 13) | 0;
        _ = (k + (S >>> 13) | 0) + (Za >>> 26) | 0, Za &= 67108863, I = Math.imul(pt, ut), S = Math.imul(pt, ct), S = S + Math.imul(Me, ut) | 0, k = Math.imul(Me, ct);
        var Ja = (_ + I | 0) + ((S & 8191) << 13) | 0;
        return _ = (k + (S >>> 13) | 0) + (Ja >>> 26) | 0, Ja &= 67108863, T[0] = Or, T[1] = qr, T[2] = Fr, T[3] = Vr, T[4] = Kr, T[5] = Hr, T[6] = jr, T[7] = zr, T[8] = Gr, T[9] = $r, T[10] = Wr, T[11] = Qr, T[12] = Yr, T[13] = Xr, T[14] = Zr, T[15] = Jr, T[16] = ei, T[17] = Za, T[18] = Ja, _ !== 0 && (T[19] = _, C.length++), C;
      };
      Math.imul || (A = x);
      function R(g, d, b) {
        b.negative = d.negative ^ g.negative, b.length = g.length + d.length;
        for (var C = 0, E = 0, B = 0; B < b.length - 1; B++) {
          var T = E;
          E = 0;
          for (var _ = C & 67108863, I = Math.min(B, d.length - 1), S = Math.max(0, B - g.length + 1); S <= I; S++) {
            var k = B - S, $ = g.words[k] | 0, ee = d.words[S] | 0, H = $ * ee, N = H & 67108863;
            T = T + (H / 67108864 | 0) | 0, N = N + _ | 0, _ = N & 67108863, T = T + (N >>> 26) | 0, E += T >>> 26, T &= 67108863;
          }
          b.words[B] = _, C = T, T = E;
        }
        return C !== 0 ? b.words[B] = C : b.length--, b._strip();
      }
      function M(g, d, b) {
        return R(g, d, b);
      }
      a.prototype.mulTo = function(d, b) {
        var C, E = this.length + d.length;
        return this.length === 10 && d.length === 10 ? C = A(this, d, b) : E < 63 ? C = x(this, d, b) : E < 1024 ? C = R(this, d, b) : C = M(this, d, b), C;
      }, a.prototype.mul = function(d) {
        var b = new a(null);
        return b.words = new Array(this.length + d.length), this.mulTo(d, b);
      }, a.prototype.mulf = function(d) {
        var b = new a(null);
        return b.words = new Array(this.length + d.length), M(this, d, b);
      }, a.prototype.imul = function(d) {
        return this.clone().mulTo(d, this);
      }, a.prototype.imuln = function(d) {
        var b = d < 0;
        b && (d = -d), r(typeof d == "number"), r(d < 67108864);
        for (var C = 0, E = 0; E < this.length; E++) {
          var B = (this.words[E] | 0) * d, T = (B & 67108863) + (C & 67108863);
          C >>= 26, C += B / 67108864 | 0, C += T >>> 26, this.words[E] = T & 67108863;
        }
        return C !== 0 && (this.words[E] = C, this.length++), b ? this.ineg() : this;
      }, a.prototype.muln = function(d) {
        return this.clone().imuln(d);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(d) {
        var b = w(d);
        if (b.length === 0)
          return new a(1);
        for (var C = this, E = 0; E < b.length && b[E] === 0; E++, C = C.sqr())
          ;
        if (++E < b.length)
          for (var B = C.sqr(); E < b.length; E++, B = B.sqr())
            b[E] !== 0 && (C = C.mul(B));
        return C;
      }, a.prototype.iushln = function(d) {
        r(typeof d == "number" && d >= 0);
        var b = d % 26, C = (d - b) / 26, E = 67108863 >>> 26 - b << 26 - b, B;
        if (b !== 0) {
          var T = 0;
          for (B = 0; B < this.length; B++) {
            var _ = this.words[B] & E, I = (this.words[B] | 0) - _ << b;
            this.words[B] = I | T, T = _ >>> 26 - b;
          }
          T && (this.words[B] = T, this.length++);
        }
        if (C !== 0) {
          for (B = this.length - 1; B >= 0; B--)
            this.words[B + C] = this.words[B];
          for (B = 0; B < C; B++)
            this.words[B] = 0;
          this.length += C;
        }
        return this._strip();
      }, a.prototype.ishln = function(d) {
        return r(this.negative === 0), this.iushln(d);
      }, a.prototype.iushrn = function(d, b, C) {
        r(typeof d == "number" && d >= 0);
        var E;
        b ? E = (b - b % 26) / 26 : E = 0;
        var B = d % 26, T = Math.min((d - B) / 26, this.length), _ = 67108863 ^ 67108863 >>> B << B, I = C;
        if (E -= T, E = Math.max(0, E), I) {
          for (var S = 0; S < T; S++)
            I.words[S] = this.words[S];
          I.length = T;
        }
        if (T !== 0)
          if (this.length > T)
            for (this.length -= T, S = 0; S < this.length; S++)
              this.words[S] = this.words[S + T];
          else
            this.words[0] = 0, this.length = 1;
        var k = 0;
        for (S = this.length - 1; S >= 0 && (k !== 0 || S >= E); S--) {
          var $ = this.words[S] | 0;
          this.words[S] = k << 26 - B | $ >>> B, k = $ & _;
        }
        return I && k !== 0 && (I.words[I.length++] = k), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, a.prototype.ishrn = function(d, b, C) {
        return r(this.negative === 0), this.iushrn(d, b, C);
      }, a.prototype.shln = function(d) {
        return this.clone().ishln(d);
      }, a.prototype.ushln = function(d) {
        return this.clone().iushln(d);
      }, a.prototype.shrn = function(d) {
        return this.clone().ishrn(d);
      }, a.prototype.ushrn = function(d) {
        return this.clone().iushrn(d);
      }, a.prototype.testn = function(d) {
        r(typeof d == "number" && d >= 0);
        var b = d % 26, C = (d - b) / 26, E = 1 << b;
        if (this.length <= C)
          return !1;
        var B = this.words[C];
        return !!(B & E);
      }, a.prototype.imaskn = function(d) {
        r(typeof d == "number" && d >= 0);
        var b = d % 26, C = (d - b) / 26;
        if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= C)
          return this;
        if (b !== 0 && C++, this.length = Math.min(C, this.length), b !== 0) {
          var E = 67108863 ^ 67108863 >>> b << b;
          this.words[this.length - 1] &= E;
        }
        return this._strip();
      }, a.prototype.maskn = function(d) {
        return this.clone().imaskn(d);
      }, a.prototype.iaddn = function(d) {
        return r(typeof d == "number"), r(d < 67108864), d < 0 ? this.isubn(-d) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= d ? (this.words[0] = d - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(d), this.negative = 1, this) : this._iaddn(d);
      }, a.prototype._iaddn = function(d) {
        this.words[0] += d;
        for (var b = 0; b < this.length && this.words[b] >= 67108864; b++)
          this.words[b] -= 67108864, b === this.length - 1 ? this.words[b + 1] = 1 : this.words[b + 1]++;
        return this.length = Math.max(this.length, b + 1), this;
      }, a.prototype.isubn = function(d) {
        if (r(typeof d == "number"), r(d < 67108864), d < 0)
          return this.iaddn(-d);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(d), this.negative = 1, this;
        if (this.words[0] -= d, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var b = 0; b < this.length && this.words[b] < 0; b++)
            this.words[b] += 67108864, this.words[b + 1] -= 1;
        return this._strip();
      }, a.prototype.addn = function(d) {
        return this.clone().iaddn(d);
      }, a.prototype.subn = function(d) {
        return this.clone().isubn(d);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(d, b, C) {
        var E = d.length + C, B;
        this._expand(E);
        var T, _ = 0;
        for (B = 0; B < d.length; B++) {
          T = (this.words[B + C] | 0) + _;
          var I = (d.words[B] | 0) * b;
          T -= I & 67108863, _ = (T >> 26) - (I / 67108864 | 0), this.words[B + C] = T & 67108863;
        }
        for (; B < this.length - C; B++)
          T = (this.words[B + C] | 0) + _, _ = T >> 26, this.words[B + C] = T & 67108863;
        if (_ === 0)
          return this._strip();
        for (r(_ === -1), _ = 0, B = 0; B < this.length; B++)
          T = -(this.words[B] | 0) + _, _ = T >> 26, this.words[B] = T & 67108863;
        return this.negative = 1, this._strip();
      }, a.prototype._wordDiv = function(d, b) {
        var C = this.length - d.length, E = this.clone(), B = d, T = B.words[B.length - 1] | 0, _ = this._countBits(T);
        C = 26 - _, C !== 0 && (B = B.ushln(C), E.iushln(C), T = B.words[B.length - 1] | 0);
        var I = E.length - B.length, S;
        if (b !== "mod") {
          S = new a(null), S.length = I + 1, S.words = new Array(S.length);
          for (var k = 0; k < S.length; k++)
            S.words[k] = 0;
        }
        var $ = E.clone()._ishlnsubmul(B, 1, I);
        $.negative === 0 && (E = $, S && (S.words[I] = 1));
        for (var ee = I - 1; ee >= 0; ee--) {
          var H = (E.words[B.length + ee] | 0) * 67108864 + (E.words[B.length + ee - 1] | 0);
          for (H = Math.min(H / T | 0, 67108863), E._ishlnsubmul(B, H, ee); E.negative !== 0; )
            H--, E.negative = 0, E._ishlnsubmul(B, 1, ee), E.isZero() || (E.negative ^= 1);
          S && (S.words[ee] = H);
        }
        return S && S._strip(), E._strip(), b !== "div" && C !== 0 && E.iushrn(C), {
          div: S || null,
          mod: E
        };
      }, a.prototype.divmod = function(d, b, C) {
        if (r(!d.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var E, B, T;
        return this.negative !== 0 && d.negative === 0 ? (T = this.neg().divmod(d, b), b !== "mod" && (E = T.div.neg()), b !== "div" && (B = T.mod.neg(), C && B.negative !== 0 && B.iadd(d)), {
          div: E,
          mod: B
        }) : this.negative === 0 && d.negative !== 0 ? (T = this.divmod(d.neg(), b), b !== "mod" && (E = T.div.neg()), {
          div: E,
          mod: T.mod
        }) : this.negative & d.negative ? (T = this.neg().divmod(d.neg(), b), b !== "div" && (B = T.mod.neg(), C && B.negative !== 0 && B.isub(d)), {
          div: T.div,
          mod: B
        }) : d.length > this.length || this.cmp(d) < 0 ? {
          div: new a(0),
          mod: this
        } : d.length === 1 ? b === "div" ? {
          div: this.divn(d.words[0]),
          mod: null
        } : b === "mod" ? {
          div: null,
          mod: new a(this.modrn(d.words[0]))
        } : {
          div: this.divn(d.words[0]),
          mod: new a(this.modrn(d.words[0]))
        } : this._wordDiv(d, b);
      }, a.prototype.div = function(d) {
        return this.divmod(d, "div", !1).div;
      }, a.prototype.mod = function(d) {
        return this.divmod(d, "mod", !1).mod;
      }, a.prototype.umod = function(d) {
        return this.divmod(d, "mod", !0).mod;
      }, a.prototype.divRound = function(d) {
        var b = this.divmod(d);
        if (b.mod.isZero())
          return b.div;
        var C = b.div.negative !== 0 ? b.mod.isub(d) : b.mod, E = d.ushrn(1), B = d.andln(1), T = C.cmp(E);
        return T < 0 || B === 1 && T === 0 ? b.div : b.div.negative !== 0 ? b.div.isubn(1) : b.div.iaddn(1);
      }, a.prototype.modrn = function(d) {
        var b = d < 0;
        b && (d = -d), r(d <= 67108863);
        for (var C = (1 << 26) % d, E = 0, B = this.length - 1; B >= 0; B--)
          E = (C * E + (this.words[B] | 0)) % d;
        return b ? -E : E;
      }, a.prototype.modn = function(d) {
        return this.modrn(d);
      }, a.prototype.idivn = function(d) {
        var b = d < 0;
        b && (d = -d), r(d <= 67108863);
        for (var C = 0, E = this.length - 1; E >= 0; E--) {
          var B = (this.words[E] | 0) + C * 67108864;
          this.words[E] = B / d | 0, C = B % d;
        }
        return this._strip(), b ? this.ineg() : this;
      }, a.prototype.divn = function(d) {
        return this.clone().idivn(d);
      }, a.prototype.egcd = function(d) {
        r(d.negative === 0), r(!d.isZero());
        var b = this, C = d.clone();
        b.negative !== 0 ? b = b.umod(d) : b = b.clone();
        for (var E = new a(1), B = new a(0), T = new a(0), _ = new a(1), I = 0; b.isEven() && C.isEven(); )
          b.iushrn(1), C.iushrn(1), ++I;
        for (var S = C.clone(), k = b.clone(); !b.isZero(); ) {
          for (var $ = 0, ee = 1; !(b.words[0] & ee) && $ < 26; ++$, ee <<= 1)
            ;
          if ($ > 0)
            for (b.iushrn($); $-- > 0; )
              (E.isOdd() || B.isOdd()) && (E.iadd(S), B.isub(k)), E.iushrn(1), B.iushrn(1);
          for (var H = 0, N = 1; !(C.words[0] & N) && H < 26; ++H, N <<= 1)
            ;
          if (H > 0)
            for (C.iushrn(H); H-- > 0; )
              (T.isOdd() || _.isOdd()) && (T.iadd(S), _.isub(k)), T.iushrn(1), _.iushrn(1);
          b.cmp(C) >= 0 ? (b.isub(C), E.isub(T), B.isub(_)) : (C.isub(b), T.isub(E), _.isub(B));
        }
        return {
          a: T,
          b: _,
          gcd: C.iushln(I)
        };
      }, a.prototype._invmp = function(d) {
        r(d.negative === 0), r(!d.isZero());
        var b = this, C = d.clone();
        b.negative !== 0 ? b = b.umod(d) : b = b.clone();
        for (var E = new a(1), B = new a(0), T = C.clone(); b.cmpn(1) > 0 && C.cmpn(1) > 0; ) {
          for (var _ = 0, I = 1; !(b.words[0] & I) && _ < 26; ++_, I <<= 1)
            ;
          if (_ > 0)
            for (b.iushrn(_); _-- > 0; )
              E.isOdd() && E.iadd(T), E.iushrn(1);
          for (var S = 0, k = 1; !(C.words[0] & k) && S < 26; ++S, k <<= 1)
            ;
          if (S > 0)
            for (C.iushrn(S); S-- > 0; )
              B.isOdd() && B.iadd(T), B.iushrn(1);
          b.cmp(C) >= 0 ? (b.isub(C), E.isub(B)) : (C.isub(b), B.isub(E));
        }
        var $;
        return b.cmpn(1) === 0 ? $ = E : $ = B, $.cmpn(0) < 0 && $.iadd(d), $;
      }, a.prototype.gcd = function(d) {
        if (this.isZero())
          return d.abs();
        if (d.isZero())
          return this.abs();
        var b = this.clone(), C = d.clone();
        b.negative = 0, C.negative = 0;
        for (var E = 0; b.isEven() && C.isEven(); E++)
          b.iushrn(1), C.iushrn(1);
        do {
          for (; b.isEven(); )
            b.iushrn(1);
          for (; C.isEven(); )
            C.iushrn(1);
          var B = b.cmp(C);
          if (B < 0) {
            var T = b;
            b = C, C = T;
          } else if (B === 0 || C.cmpn(1) === 0)
            break;
          b.isub(C);
        } while (!0);
        return C.iushln(E);
      }, a.prototype.invm = function(d) {
        return this.egcd(d).a.umod(d);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(d) {
        return this.words[0] & d;
      }, a.prototype.bincn = function(d) {
        r(typeof d == "number");
        var b = d % 26, C = (d - b) / 26, E = 1 << b;
        if (this.length <= C)
          return this._expand(C + 1), this.words[C] |= E, this;
        for (var B = E, T = C; B !== 0 && T < this.length; T++) {
          var _ = this.words[T] | 0;
          _ += B, B = _ >>> 26, _ &= 67108863, this.words[T] = _;
        }
        return B !== 0 && (this.words[T] = B, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(d) {
        var b = d < 0;
        if (this.negative !== 0 && !b)
          return -1;
        if (this.negative === 0 && b)
          return 1;
        this._strip();
        var C;
        if (this.length > 1)
          C = 1;
        else {
          b && (d = -d), r(d <= 67108863, "Number is too big");
          var E = this.words[0] | 0;
          C = E === d ? 0 : E < d ? -1 : 1;
        }
        return this.negative !== 0 ? -C | 0 : C;
      }, a.prototype.cmp = function(d) {
        if (this.negative !== 0 && d.negative === 0)
          return -1;
        if (this.negative === 0 && d.negative !== 0)
          return 1;
        var b = this.ucmp(d);
        return this.negative !== 0 ? -b | 0 : b;
      }, a.prototype.ucmp = function(d) {
        if (this.length > d.length)
          return 1;
        if (this.length < d.length)
          return -1;
        for (var b = 0, C = this.length - 1; C >= 0; C--) {
          var E = this.words[C] | 0, B = d.words[C] | 0;
          if (E !== B) {
            E < B ? b = -1 : E > B && (b = 1);
            break;
          }
        }
        return b;
      }, a.prototype.gtn = function(d) {
        return this.cmpn(d) === 1;
      }, a.prototype.gt = function(d) {
        return this.cmp(d) === 1;
      }, a.prototype.gten = function(d) {
        return this.cmpn(d) >= 0;
      }, a.prototype.gte = function(d) {
        return this.cmp(d) >= 0;
      }, a.prototype.ltn = function(d) {
        return this.cmpn(d) === -1;
      }, a.prototype.lt = function(d) {
        return this.cmp(d) === -1;
      }, a.prototype.lten = function(d) {
        return this.cmpn(d) <= 0;
      }, a.prototype.lte = function(d) {
        return this.cmp(d) <= 0;
      }, a.prototype.eqn = function(d) {
        return this.cmpn(d) === 0;
      }, a.prototype.eq = function(d) {
        return this.cmp(d) === 0;
      }, a.red = function(d) {
        return new V(d);
      }, a.prototype.toRed = function(d) {
        return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), d.convertTo(this)._forceRed(d);
      }, a.prototype.fromRed = function() {
        return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(d) {
        return this.red = d, this;
      }, a.prototype.forceRed = function(d) {
        return r(!this.red, "Already a number in reduction context"), this._forceRed(d);
      }, a.prototype.redAdd = function(d) {
        return r(this.red, "redAdd works only with red numbers"), this.red.add(this, d);
      }, a.prototype.redIAdd = function(d) {
        return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, d);
      }, a.prototype.redSub = function(d) {
        return r(this.red, "redSub works only with red numbers"), this.red.sub(this, d);
      }, a.prototype.redISub = function(d) {
        return r(this.red, "redISub works only with red numbers"), this.red.isub(this, d);
      }, a.prototype.redShl = function(d) {
        return r(this.red, "redShl works only with red numbers"), this.red.shl(this, d);
      }, a.prototype.redMul = function(d) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, d), this.red.mul(this, d);
      }, a.prototype.redIMul = function(d) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, d), this.red.imul(this, d);
      }, a.prototype.redSqr = function() {
        return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(d) {
        return r(this.red && !d.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, d);
      };
      var D = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function U(g, d) {
        this.name = g, this.p = new a(d, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      U.prototype._tmp = function() {
        var d = new a(null);
        return d.words = new Array(Math.ceil(this.n / 13)), d;
      }, U.prototype.ireduce = function(d) {
        var b = d, C;
        do
          this.split(b, this.tmp), b = this.imulK(b), b = b.iadd(this.tmp), C = b.bitLength();
        while (C > this.n);
        var E = C < this.n ? -1 : b.ucmp(this.p);
        return E === 0 ? (b.words[0] = 0, b.length = 1) : E > 0 ? b.isub(this.p) : b.strip !== void 0 ? b.strip() : b._strip(), b;
      }, U.prototype.split = function(d, b) {
        d.iushrn(this.n, 0, b);
      }, U.prototype.imulK = function(d) {
        return d.imul(this.k);
      };
      function z() {
        U.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      n(z, U), z.prototype.split = function(d, b) {
        for (var C = 4194303, E = Math.min(d.length, 9), B = 0; B < E; B++)
          b.words[B] = d.words[B];
        if (b.length = E, d.length <= 9) {
          d.words[0] = 0, d.length = 1;
          return;
        }
        var T = d.words[9];
        for (b.words[b.length++] = T & C, B = 10; B < d.length; B++) {
          var _ = d.words[B] | 0;
          d.words[B - 10] = (_ & C) << 4 | T >>> 22, T = _;
        }
        T >>>= 22, d.words[B - 10] = T, T === 0 && d.length > 10 ? d.length -= 10 : d.length -= 9;
      }, z.prototype.imulK = function(d) {
        d.words[d.length] = 0, d.words[d.length + 1] = 0, d.length += 2;
        for (var b = 0, C = 0; C < d.length; C++) {
          var E = d.words[C] | 0;
          b += E * 977, d.words[C] = b & 67108863, b = E * 64 + (b / 67108864 | 0);
        }
        return d.words[d.length - 1] === 0 && (d.length--, d.words[d.length - 1] === 0 && d.length--), d;
      };
      function W() {
        U.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      n(W, U);
      function G() {
        U.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      n(G, U);
      function re() {
        U.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      n(re, U), re.prototype.imulK = function(d) {
        for (var b = 0, C = 0; C < d.length; C++) {
          var E = (d.words[C] | 0) * 19 + b, B = E & 67108863;
          E >>>= 26, d.words[C] = B, b = E;
        }
        return b !== 0 && (d.words[d.length++] = b), d;
      }, a._prime = function(d) {
        if (D[d])
          return D[d];
        var b;
        if (d === "k256")
          b = new z();
        else if (d === "p224")
          b = new W();
        else if (d === "p192")
          b = new G();
        else if (d === "p25519")
          b = new re();
        else
          throw new Error("Unknown prime " + d);
        return D[d] = b, b;
      };
      function V(g) {
        if (typeof g == "string") {
          var d = a._prime(g);
          this.m = d.p, this.prime = d;
        } else
          r(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
      }
      V.prototype._verify1 = function(d) {
        r(d.negative === 0, "red works only with positives"), r(d.red, "red works only with red numbers");
      }, V.prototype._verify2 = function(d, b) {
        r((d.negative | b.negative) === 0, "red works only with positives"), r(
          d.red && d.red === b.red,
          "red works only with red numbers"
        );
      }, V.prototype.imod = function(d) {
        return this.prime ? this.prime.ireduce(d)._forceRed(this) : (o(d, d.umod(this.m)._forceRed(this)), d);
      }, V.prototype.neg = function(d) {
        return d.isZero() ? d.clone() : this.m.sub(d)._forceRed(this);
      }, V.prototype.add = function(d, b) {
        this._verify2(d, b);
        var C = d.add(b);
        return C.cmp(this.m) >= 0 && C.isub(this.m), C._forceRed(this);
      }, V.prototype.iadd = function(d, b) {
        this._verify2(d, b);
        var C = d.iadd(b);
        return C.cmp(this.m) >= 0 && C.isub(this.m), C;
      }, V.prototype.sub = function(d, b) {
        this._verify2(d, b);
        var C = d.sub(b);
        return C.cmpn(0) < 0 && C.iadd(this.m), C._forceRed(this);
      }, V.prototype.isub = function(d, b) {
        this._verify2(d, b);
        var C = d.isub(b);
        return C.cmpn(0) < 0 && C.iadd(this.m), C;
      }, V.prototype.shl = function(d, b) {
        return this._verify1(d), this.imod(d.ushln(b));
      }, V.prototype.imul = function(d, b) {
        return this._verify2(d, b), this.imod(d.imul(b));
      }, V.prototype.mul = function(d, b) {
        return this._verify2(d, b), this.imod(d.mul(b));
      }, V.prototype.isqr = function(d) {
        return this.imul(d, d.clone());
      }, V.prototype.sqr = function(d) {
        return this.mul(d, d);
      }, V.prototype.sqrt = function(d) {
        if (d.isZero())
          return d.clone();
        var b = this.m.andln(3);
        if (r(b % 2 === 1), b === 3) {
          var C = this.m.add(new a(1)).iushrn(2);
          return this.pow(d, C);
        }
        for (var E = this.m.subn(1), B = 0; !E.isZero() && E.andln(1) === 0; )
          B++, E.iushrn(1);
        r(!E.isZero());
        var T = new a(1).toRed(this), _ = T.redNeg(), I = this.m.subn(1).iushrn(1), S = this.m.bitLength();
        for (S = new a(2 * S * S).toRed(this); this.pow(S, I).cmp(_) !== 0; )
          S.redIAdd(_);
        for (var k = this.pow(S, E), $ = this.pow(d, E.addn(1).iushrn(1)), ee = this.pow(d, E), H = B; ee.cmp(T) !== 0; ) {
          for (var N = ee, L = 0; N.cmp(T) !== 0; L++)
            N = N.redSqr();
          r(L < H);
          var j = this.pow(k, new a(1).iushln(H - L - 1));
          $ = $.redMul(j), k = j.redSqr(), ee = ee.redMul(k), H = L;
        }
        return $;
      }, V.prototype.invm = function(d) {
        var b = d._invmp(this.m);
        return b.negative !== 0 ? (b.negative = 0, this.imod(b).redNeg()) : this.imod(b);
      }, V.prototype.pow = function(d, b) {
        if (b.isZero())
          return new a(1).toRed(this);
        if (b.cmpn(1) === 0)
          return d.clone();
        var C = 4, E = new Array(1 << C);
        E[0] = new a(1).toRed(this), E[1] = d;
        for (var B = 2; B < E.length; B++)
          E[B] = this.mul(E[B - 1], d);
        var T = E[0], _ = 0, I = 0, S = b.bitLength() % 26;
        for (S === 0 && (S = 26), B = b.length - 1; B >= 0; B--) {
          for (var k = b.words[B], $ = S - 1; $ >= 0; $--) {
            var ee = k >> $ & 1;
            if (T !== E[0] && (T = this.sqr(T)), ee === 0 && _ === 0) {
              I = 0;
              continue;
            }
            _ <<= 1, _ |= ee, I++, !(I !== C && (B !== 0 || $ !== 0)) && (T = this.mul(T, E[_]), I = 0, _ = 0);
          }
          S = 26;
        }
        return T;
      }, V.prototype.convertTo = function(d) {
        var b = d.umod(this.m);
        return b === d ? b.clone() : b;
      }, V.prototype.convertFrom = function(d) {
        var b = d.clone();
        return b.red = null, b;
      }, a.mont = function(d) {
        return new m(d);
      };
      function m(g) {
        V.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      n(m, V), m.prototype.convertTo = function(d) {
        return this.imod(d.ushln(this.shift));
      }, m.prototype.convertFrom = function(d) {
        var b = this.imod(d.mul(this.rinv));
        return b.red = null, b;
      }, m.prototype.imul = function(d, b) {
        if (d.isZero() || b.isZero())
          return d.words[0] = 0, d.length = 1, d;
        var C = d.imul(b), E = C.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), B = C.isub(E).iushrn(this.shift), T = B;
        return B.cmp(this.m) >= 0 ? T = B.isub(this.m) : B.cmpn(0) < 0 && (T = B.iadd(this.m)), T._forceRed(this);
      }, m.prototype.mul = function(d, b) {
        if (d.isZero() || b.isZero())
          return new a(0)._forceRed(this);
        var C = d.mul(b), E = C.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), B = C.isub(E).iushrn(this.shift), T = B;
        return B.cmp(this.m) >= 0 ? T = B.isub(this.m) : B.cmpn(0) < 0 && (T = B.iadd(this.m)), T._forceRed(this);
      }, m.prototype.invm = function(d) {
        var b = this.imod(d._invmp(this.m).mul(this.r2));
        return b._forceRed(this);
      };
    })(e, Ge);
  }(_a)), _a.exports;
}
var ms, vl;
function o0() {
  if (vl)
    return ms;
  vl = 1;
  var e = s0(), t = wi(), i = He().Buffer;
  function r(f) {
    var s = f.modulus.byteLength(), c;
    do
      c = new e(t(s));
    while (c.cmp(f.modulus) >= 0 || !c.umod(f.prime1) || !c.umod(f.prime2));
    return c;
  }
  function n(f) {
    var s = r(f), c = s.toRed(e.mont(f.modulus)).redPow(new e(f.publicExponent)).fromRed();
    return { blinder: c, unblinder: s.invm(f.modulus) };
  }
  function a(f, s) {
    var c = n(s), u = s.modulus.byteLength(), o = new e(f).mul(c.blinder).umod(s.modulus), l = o.toRed(e.mont(s.prime1)), h = o.toRed(e.mont(s.prime2)), p = s.coefficient, v = s.prime1, y = s.prime2, w = l.redPow(s.exponent1).fromRed(), x = h.redPow(s.exponent2).fromRed(), A = w.isub(x).imul(p).umod(v).imul(y);
    return x.iadd(A).imul(c.unblinder).umod(s.modulus).toArrayLike(i, "be", u);
  }
  return a.getr = r, ms = a, ms;
}
var xs = {};
const Pv = "6.6.1", Uv = {
  version: Pv
};
var _s = {}, Ss = {}, yl;
function Ud() {
  return yl || (yl = 1, function(e) {
    var t = e;
    function i(a, f) {
      if (Array.isArray(a))
        return a.slice();
      if (!a)
        return [];
      var s = [];
      if (typeof a != "string") {
        for (var c = 0; c < a.length; c++)
          s[c] = a[c] | 0;
        return s;
      }
      if (f === "hex") {
        a = a.replace(/[^a-z0-9]+/ig, ""), a.length % 2 !== 0 && (a = "0" + a);
        for (var c = 0; c < a.length; c += 2)
          s.push(parseInt(a[c] + a[c + 1], 16));
      } else
        for (var c = 0; c < a.length; c++) {
          var u = a.charCodeAt(c), o = u >> 8, l = u & 255;
          o ? s.push(o, l) : s.push(l);
        }
      return s;
    }
    t.toArray = i;
    function r(a) {
      return a.length === 1 ? "0" + a : a;
    }
    t.zero2 = r;
    function n(a) {
      for (var f = "", s = 0; s < a.length; s++)
        f += r(a[s].toString(16));
      return f;
    }
    t.toHex = n, t.encode = function(f, s) {
      return s === "hex" ? n(f) : f;
    };
  }(Ss)), Ss;
}
var gl;
function cr() {
  return gl || (gl = 1, function(e) {
    var t = e, i = jt(), r = ur(), n = Ud();
    t.assert = r, t.toArray = n.toArray, t.zero2 = n.zero2, t.toHex = n.toHex, t.encode = n.encode;
    function a(o, l, h) {
      var p = new Array(Math.max(o.bitLength(), h) + 1), v;
      for (v = 0; v < p.length; v += 1)
        p[v] = 0;
      var y = 1 << l + 1, w = o.clone();
      for (v = 0; v < p.length; v++) {
        var x, A = w.andln(y - 1);
        w.isOdd() ? (A > (y >> 1) - 1 ? x = (y >> 1) - A : x = A, w.isubn(x)) : x = 0, p[v] = x, w.iushrn(1);
      }
      return p;
    }
    t.getNAF = a;
    function f(o, l) {
      var h = [
        [],
        []
      ];
      o = o.clone(), l = l.clone();
      for (var p = 0, v = 0, y; o.cmpn(-p) > 0 || l.cmpn(-v) > 0; ) {
        var w = o.andln(3) + p & 3, x = l.andln(3) + v & 3;
        w === 3 && (w = -1), x === 3 && (x = -1);
        var A;
        w & 1 ? (y = o.andln(7) + p & 7, (y === 3 || y === 5) && x === 2 ? A = -w : A = w) : A = 0, h[0].push(A);
        var R;
        x & 1 ? (y = l.andln(7) + v & 7, (y === 3 || y === 5) && w === 2 ? R = -x : R = x) : R = 0, h[1].push(R), 2 * p === A + 1 && (p = 1 - p), 2 * v === R + 1 && (v = 1 - v), o.iushrn(1), l.iushrn(1);
      }
      return h;
    }
    t.getJSF = f;
    function s(o, l, h) {
      var p = "_" + l;
      o.prototype[l] = function() {
        return this[p] !== void 0 ? this[p] : this[p] = h.call(this);
      };
    }
    t.cachedProperty = s;
    function c(o) {
      return typeof o == "string" ? t.toArray(o, "hex") : o;
    }
    t.parseBytes = c;
    function u(o) {
      return new i(o, "hex", "le");
    }
    t.intFromLE = u;
  }(_s)), _s;
}
var Es = {}, ws, bl;
function ja() {
  if (bl)
    return ws;
  bl = 1;
  var e = jt(), t = cr(), i = t.getNAF, r = t.getJSF, n = t.assert;
  function a(s, c) {
    this.type = s, this.p = new e(c.p, 16), this.red = c.prime ? e.red(c.prime) : e.mont(this.p), this.zero = new e(0).toRed(this.red), this.one = new e(1).toRed(this.red), this.two = new e(2).toRed(this.red), this.n = c.n && new e(c.n, 16), this.g = c.g && this.pointFromJSON(c.g, c.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var u = this.n && this.p.div(this.n);
    !u || u.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  ws = a, a.prototype.point = function() {
    throw new Error("Not implemented");
  }, a.prototype.validate = function() {
    throw new Error("Not implemented");
  }, a.prototype._fixedNafMul = function(c, u) {
    n(c.precomputed);
    var o = c._getDoubles(), l = i(u, 1, this._bitLength), h = (1 << o.step + 1) - (o.step % 2 === 0 ? 2 : 1);
    h /= 3;
    var p = [], v, y;
    for (v = 0; v < l.length; v += o.step) {
      y = 0;
      for (var w = v + o.step - 1; w >= v; w--)
        y = (y << 1) + l[w];
      p.push(y);
    }
    for (var x = this.jpoint(null, null, null), A = this.jpoint(null, null, null), R = h; R > 0; R--) {
      for (v = 0; v < p.length; v++)
        y = p[v], y === R ? A = A.mixedAdd(o.points[v]) : y === -R && (A = A.mixedAdd(o.points[v].neg()));
      x = x.add(A);
    }
    return x.toP();
  }, a.prototype._wnafMul = function(c, u) {
    var o = 4, l = c._getNAFPoints(o);
    o = l.wnd;
    for (var h = l.points, p = i(u, o, this._bitLength), v = this.jpoint(null, null, null), y = p.length - 1; y >= 0; y--) {
      for (var w = 0; y >= 0 && p[y] === 0; y--)
        w++;
      if (y >= 0 && w++, v = v.dblp(w), y < 0)
        break;
      var x = p[y];
      n(x !== 0), c.type === "affine" ? x > 0 ? v = v.mixedAdd(h[x - 1 >> 1]) : v = v.mixedAdd(h[-x - 1 >> 1].neg()) : x > 0 ? v = v.add(h[x - 1 >> 1]) : v = v.add(h[-x - 1 >> 1].neg());
    }
    return c.type === "affine" ? v.toP() : v;
  }, a.prototype._wnafMulAdd = function(c, u, o, l, h) {
    var p = this._wnafT1, v = this._wnafT2, y = this._wnafT3, w = 0, x, A, R;
    for (x = 0; x < l; x++) {
      R = u[x];
      var M = R._getNAFPoints(c);
      p[x] = M.wnd, v[x] = M.points;
    }
    for (x = l - 1; x >= 1; x -= 2) {
      var D = x - 1, U = x;
      if (p[D] !== 1 || p[U] !== 1) {
        y[D] = i(o[D], p[D], this._bitLength), y[U] = i(o[U], p[U], this._bitLength), w = Math.max(y[D].length, w), w = Math.max(y[U].length, w);
        continue;
      }
      var z = [
        u[D],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        u[U]
        /* 7 */
      ];
      u[D].y.cmp(u[U].y) === 0 ? (z[1] = u[D].add(u[U]), z[2] = u[D].toJ().mixedAdd(u[U].neg())) : u[D].y.cmp(u[U].y.redNeg()) === 0 ? (z[1] = u[D].toJ().mixedAdd(u[U]), z[2] = u[D].add(u[U].neg())) : (z[1] = u[D].toJ().mixedAdd(u[U]), z[2] = u[D].toJ().mixedAdd(u[U].neg()));
      var W = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], G = r(o[D], o[U]);
      for (w = Math.max(G[0].length, w), y[D] = new Array(w), y[U] = new Array(w), A = 0; A < w; A++) {
        var re = G[0][A] | 0, V = G[1][A] | 0;
        y[D][A] = W[(re + 1) * 3 + (V + 1)], y[U][A] = 0, v[D] = z;
      }
    }
    var m = this.jpoint(null, null, null), g = this._wnafT4;
    for (x = w; x >= 0; x--) {
      for (var d = 0; x >= 0; ) {
        var b = !0;
        for (A = 0; A < l; A++)
          g[A] = y[A][x] | 0, g[A] !== 0 && (b = !1);
        if (!b)
          break;
        d++, x--;
      }
      if (x >= 0 && d++, m = m.dblp(d), x < 0)
        break;
      for (A = 0; A < l; A++) {
        var C = g[A];
        C !== 0 && (C > 0 ? R = v[A][C - 1 >> 1] : C < 0 && (R = v[A][-C - 1 >> 1].neg()), R.type === "affine" ? m = m.mixedAdd(R) : m = m.add(R));
      }
    }
    for (x = 0; x < l; x++)
      v[x] = null;
    return h ? m : m.toP();
  };
  function f(s, c) {
    this.curve = s, this.type = c, this.precomputed = null;
  }
  return a.BasePoint = f, f.prototype.eq = function() {
    throw new Error("Not implemented");
  }, f.prototype.validate = function() {
    return this.curve.validate(this);
  }, a.prototype.decodePoint = function(c, u) {
    c = t.toArray(c, u);
    var o = this.p.byteLength();
    if ((c[0] === 4 || c[0] === 6 || c[0] === 7) && c.length - 1 === 2 * o) {
      c[0] === 6 ? n(c[c.length - 1] % 2 === 0) : c[0] === 7 && n(c[c.length - 1] % 2 === 1);
      var l = this.point(
        c.slice(1, 1 + o),
        c.slice(1 + o, 1 + 2 * o)
      );
      return l;
    } else if ((c[0] === 2 || c[0] === 3) && c.length - 1 === o)
      return this.pointFromX(c.slice(1, 1 + o), c[0] === 3);
    throw new Error("Unknown point format");
  }, f.prototype.encodeCompressed = function(c) {
    return this.encode(c, !0);
  }, f.prototype._encode = function(c) {
    var u = this.curve.p.byteLength(), o = this.getX().toArray("be", u);
    return c ? [this.getY().isEven() ? 2 : 3].concat(o) : [4].concat(o, this.getY().toArray("be", u));
  }, f.prototype.encode = function(c, u) {
    return t.encode(this._encode(u), c);
  }, f.prototype.precompute = function(c) {
    if (this.precomputed)
      return this;
    var u = {
      doubles: null,
      naf: null,
      beta: null
    };
    return u.naf = this._getNAFPoints(8), u.doubles = this._getDoubles(4, c), u.beta = this._getBeta(), this.precomputed = u, this;
  }, f.prototype._hasDoubles = function(c) {
    if (!this.precomputed)
      return !1;
    var u = this.precomputed.doubles;
    return u ? u.points.length >= Math.ceil((c.bitLength() + 1) / u.step) : !1;
  }, f.prototype._getDoubles = function(c, u) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var o = [this], l = this, h = 0; h < u; h += c) {
      for (var p = 0; p < c; p++)
        l = l.dbl();
      o.push(l);
    }
    return {
      step: c,
      points: o
    };
  }, f.prototype._getNAFPoints = function(c) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var u = [this], o = (1 << c) - 1, l = o === 1 ? null : this.dbl(), h = 1; h < o; h++)
      u[h] = u[h - 1].add(l);
    return {
      wnd: c,
      points: u
    };
  }, f.prototype._getBeta = function() {
    return null;
  }, f.prototype.dblp = function(c) {
    for (var u = this, o = 0; o < c; o++)
      u = u.dbl();
    return u;
  }, ws;
}
var Cs, ml;
function Ov() {
  if (ml)
    return Cs;
  ml = 1;
  var e = cr(), t = jt(), i = Ae(), r = ja(), n = e.assert;
  function a(c) {
    r.call(this, "short", c), this.a = new t(c.a, 16).toRed(this.red), this.b = new t(c.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(c), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  i(a, r), Cs = a, a.prototype._getEndomorphism = function(u) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var o, l;
      if (u.beta)
        o = new t(u.beta, 16).toRed(this.red);
      else {
        var h = this._getEndoRoots(this.p);
        o = h[0].cmp(h[1]) < 0 ? h[0] : h[1], o = o.toRed(this.red);
      }
      if (u.lambda)
        l = new t(u.lambda, 16);
      else {
        var p = this._getEndoRoots(this.n);
        this.g.mul(p[0]).x.cmp(this.g.x.redMul(o)) === 0 ? l = p[0] : (l = p[1], n(this.g.mul(l).x.cmp(this.g.x.redMul(o)) === 0));
      }
      var v;
      return u.basis ? v = u.basis.map(function(y) {
        return {
          a: new t(y.a, 16),
          b: new t(y.b, 16)
        };
      }) : v = this._getEndoBasis(l), {
        beta: o,
        lambda: l,
        basis: v
      };
    }
  }, a.prototype._getEndoRoots = function(u) {
    var o = u === this.p ? this.red : t.mont(u), l = new t(2).toRed(o).redInvm(), h = l.redNeg(), p = new t(3).toRed(o).redNeg().redSqrt().redMul(l), v = h.redAdd(p).fromRed(), y = h.redSub(p).fromRed();
    return [v, y];
  }, a.prototype._getEndoBasis = function(u) {
    for (var o = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = u, h = this.n.clone(), p = new t(1), v = new t(0), y = new t(0), w = new t(1), x, A, R, M, D, U, z, W = 0, G, re; l.cmpn(0) !== 0; ) {
      var V = h.div(l);
      G = h.sub(V.mul(l)), re = y.sub(V.mul(p));
      var m = w.sub(V.mul(v));
      if (!R && G.cmp(o) < 0)
        x = z.neg(), A = p, R = G.neg(), M = re;
      else if (R && ++W === 2)
        break;
      z = G, h = l, l = G, y = p, p = re, w = v, v = m;
    }
    D = G.neg(), U = re;
    var g = R.sqr().add(M.sqr()), d = D.sqr().add(U.sqr());
    return d.cmp(g) >= 0 && (D = x, U = A), R.negative && (R = R.neg(), M = M.neg()), D.negative && (D = D.neg(), U = U.neg()), [
      { a: R, b: M },
      { a: D, b: U }
    ];
  }, a.prototype._endoSplit = function(u) {
    var o = this.endo.basis, l = o[0], h = o[1], p = h.b.mul(u).divRound(this.n), v = l.b.neg().mul(u).divRound(this.n), y = p.mul(l.a), w = v.mul(h.a), x = p.mul(l.b), A = v.mul(h.b), R = u.sub(y).sub(w), M = x.add(A).neg();
    return { k1: R, k2: M };
  }, a.prototype.pointFromX = function(u, o) {
    u = new t(u, 16), u.red || (u = u.toRed(this.red));
    var l = u.redSqr().redMul(u).redIAdd(u.redMul(this.a)).redIAdd(this.b), h = l.redSqrt();
    if (h.redSqr().redSub(l).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var p = h.fromRed().isOdd();
    return (o && !p || !o && p) && (h = h.redNeg()), this.point(u, h);
  }, a.prototype.validate = function(u) {
    if (u.inf)
      return !0;
    var o = u.x, l = u.y, h = this.a.redMul(o), p = o.redSqr().redMul(o).redIAdd(h).redIAdd(this.b);
    return l.redSqr().redISub(p).cmpn(0) === 0;
  }, a.prototype._endoWnafMulAdd = function(u, o, l) {
    for (var h = this._endoWnafT1, p = this._endoWnafT2, v = 0; v < u.length; v++) {
      var y = this._endoSplit(o[v]), w = u[v], x = w._getBeta();
      y.k1.negative && (y.k1.ineg(), w = w.neg(!0)), y.k2.negative && (y.k2.ineg(), x = x.neg(!0)), h[v * 2] = w, h[v * 2 + 1] = x, p[v * 2] = y.k1, p[v * 2 + 1] = y.k2;
    }
    for (var A = this._wnafMulAdd(1, h, p, v * 2, l), R = 0; R < v * 2; R++)
      h[R] = null, p[R] = null;
    return A;
  };
  function f(c, u, o, l) {
    r.BasePoint.call(this, c, "affine"), u === null && o === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new t(u, 16), this.y = new t(o, 16), l && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  i(f, r.BasePoint), a.prototype.point = function(u, o, l) {
    return new f(this, u, o, l);
  }, a.prototype.pointFromJSON = function(u, o) {
    return f.fromJSON(this, u, o);
  }, f.prototype._getBeta = function() {
    if (this.curve.endo) {
      var u = this.precomputed;
      if (u && u.beta)
        return u.beta;
      var o = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (u) {
        var l = this.curve, h = function(p) {
          return l.point(p.x.redMul(l.endo.beta), p.y);
        };
        u.beta = o, o.precomputed = {
          beta: null,
          naf: u.naf && {
            wnd: u.naf.wnd,
            points: u.naf.points.map(h)
          },
          doubles: u.doubles && {
            step: u.doubles.step,
            points: u.doubles.points.map(h)
          }
        };
      }
      return o;
    }
  }, f.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, f.fromJSON = function(u, o, l) {
    typeof o == "string" && (o = JSON.parse(o));
    var h = u.point(o[0], o[1], l);
    if (!o[2])
      return h;
    function p(y) {
      return u.point(y[0], y[1], l);
    }
    var v = o[2];
    return h.precomputed = {
      beta: null,
      doubles: v.doubles && {
        step: v.doubles.step,
        points: [h].concat(v.doubles.points.map(p))
      },
      naf: v.naf && {
        wnd: v.naf.wnd,
        points: [h].concat(v.naf.points.map(p))
      }
    }, h;
  }, f.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, f.prototype.isInfinity = function() {
    return this.inf;
  }, f.prototype.add = function(u) {
    if (this.inf)
      return u;
    if (u.inf)
      return this;
    if (this.eq(u))
      return this.dbl();
    if (this.neg().eq(u))
      return this.curve.point(null, null);
    if (this.x.cmp(u.x) === 0)
      return this.curve.point(null, null);
    var o = this.y.redSub(u.y);
    o.cmpn(0) !== 0 && (o = o.redMul(this.x.redSub(u.x).redInvm()));
    var l = o.redSqr().redISub(this.x).redISub(u.x), h = o.redMul(this.x.redSub(l)).redISub(this.y);
    return this.curve.point(l, h);
  }, f.prototype.dbl = function() {
    if (this.inf)
      return this;
    var u = this.y.redAdd(this.y);
    if (u.cmpn(0) === 0)
      return this.curve.point(null, null);
    var o = this.curve.a, l = this.x.redSqr(), h = u.redInvm(), p = l.redAdd(l).redIAdd(l).redIAdd(o).redMul(h), v = p.redSqr().redISub(this.x.redAdd(this.x)), y = p.redMul(this.x.redSub(v)).redISub(this.y);
    return this.curve.point(v, y);
  }, f.prototype.getX = function() {
    return this.x.fromRed();
  }, f.prototype.getY = function() {
    return this.y.fromRed();
  }, f.prototype.mul = function(u) {
    return u = new t(u, 16), this.isInfinity() ? this : this._hasDoubles(u) ? this.curve._fixedNafMul(this, u) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [u]) : this.curve._wnafMul(this, u);
  }, f.prototype.mulAdd = function(u, o, l) {
    var h = [this, o], p = [u, l];
    return this.curve.endo ? this.curve._endoWnafMulAdd(h, p) : this.curve._wnafMulAdd(1, h, p, 2);
  }, f.prototype.jmulAdd = function(u, o, l) {
    var h = [this, o], p = [u, l];
    return this.curve.endo ? this.curve._endoWnafMulAdd(h, p, !0) : this.curve._wnafMulAdd(1, h, p, 2, !0);
  }, f.prototype.eq = function(u) {
    return this === u || this.inf === u.inf && (this.inf || this.x.cmp(u.x) === 0 && this.y.cmp(u.y) === 0);
  }, f.prototype.neg = function(u) {
    if (this.inf)
      return this;
    var o = this.curve.point(this.x, this.y.redNeg());
    if (u && this.precomputed) {
      var l = this.precomputed, h = function(p) {
        return p.neg();
      };
      o.precomputed = {
        naf: l.naf && {
          wnd: l.naf.wnd,
          points: l.naf.points.map(h)
        },
        doubles: l.doubles && {
          step: l.doubles.step,
          points: l.doubles.points.map(h)
        }
      };
    }
    return o;
  }, f.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var u = this.curve.jpoint(this.x, this.y, this.curve.one);
    return u;
  };
  function s(c, u, o, l) {
    r.BasePoint.call(this, c, "jacobian"), u === null && o === null && l === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new t(0)) : (this.x = new t(u, 16), this.y = new t(o, 16), this.z = new t(l, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return i(s, r.BasePoint), a.prototype.jpoint = function(u, o, l) {
    return new s(this, u, o, l);
  }, s.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var u = this.z.redInvm(), o = u.redSqr(), l = this.x.redMul(o), h = this.y.redMul(o).redMul(u);
    return this.curve.point(l, h);
  }, s.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, s.prototype.add = function(u) {
    if (this.isInfinity())
      return u;
    if (u.isInfinity())
      return this;
    var o = u.z.redSqr(), l = this.z.redSqr(), h = this.x.redMul(o), p = u.x.redMul(l), v = this.y.redMul(o.redMul(u.z)), y = u.y.redMul(l.redMul(this.z)), w = h.redSub(p), x = v.redSub(y);
    if (w.cmpn(0) === 0)
      return x.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var A = w.redSqr(), R = A.redMul(w), M = h.redMul(A), D = x.redSqr().redIAdd(R).redISub(M).redISub(M), U = x.redMul(M.redISub(D)).redISub(v.redMul(R)), z = this.z.redMul(u.z).redMul(w);
    return this.curve.jpoint(D, U, z);
  }, s.prototype.mixedAdd = function(u) {
    if (this.isInfinity())
      return u.toJ();
    if (u.isInfinity())
      return this;
    var o = this.z.redSqr(), l = this.x, h = u.x.redMul(o), p = this.y, v = u.y.redMul(o).redMul(this.z), y = l.redSub(h), w = p.redSub(v);
    if (y.cmpn(0) === 0)
      return w.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var x = y.redSqr(), A = x.redMul(y), R = l.redMul(x), M = w.redSqr().redIAdd(A).redISub(R).redISub(R), D = w.redMul(R.redISub(M)).redISub(p.redMul(A)), U = this.z.redMul(y);
    return this.curve.jpoint(M, D, U);
  }, s.prototype.dblp = function(u) {
    if (u === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!u)
      return this.dbl();
    var o;
    if (this.curve.zeroA || this.curve.threeA) {
      var l = this;
      for (o = 0; o < u; o++)
        l = l.dbl();
      return l;
    }
    var h = this.curve.a, p = this.curve.tinv, v = this.x, y = this.y, w = this.z, x = w.redSqr().redSqr(), A = y.redAdd(y);
    for (o = 0; o < u; o++) {
      var R = v.redSqr(), M = A.redSqr(), D = M.redSqr(), U = R.redAdd(R).redIAdd(R).redIAdd(h.redMul(x)), z = v.redMul(M), W = U.redSqr().redISub(z.redAdd(z)), G = z.redISub(W), re = U.redMul(G);
      re = re.redIAdd(re).redISub(D);
      var V = A.redMul(w);
      o + 1 < u && (x = x.redMul(D)), v = W, w = V, A = re;
    }
    return this.curve.jpoint(v, A.redMul(p), w);
  }, s.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, s.prototype._zeroDbl = function() {
    var u, o, l;
    if (this.zOne) {
      var h = this.x.redSqr(), p = this.y.redSqr(), v = p.redSqr(), y = this.x.redAdd(p).redSqr().redISub(h).redISub(v);
      y = y.redIAdd(y);
      var w = h.redAdd(h).redIAdd(h), x = w.redSqr().redISub(y).redISub(y), A = v.redIAdd(v);
      A = A.redIAdd(A), A = A.redIAdd(A), u = x, o = w.redMul(y.redISub(x)).redISub(A), l = this.y.redAdd(this.y);
    } else {
      var R = this.x.redSqr(), M = this.y.redSqr(), D = M.redSqr(), U = this.x.redAdd(M).redSqr().redISub(R).redISub(D);
      U = U.redIAdd(U);
      var z = R.redAdd(R).redIAdd(R), W = z.redSqr(), G = D.redIAdd(D);
      G = G.redIAdd(G), G = G.redIAdd(G), u = W.redISub(U).redISub(U), o = z.redMul(U.redISub(u)).redISub(G), l = this.y.redMul(this.z), l = l.redIAdd(l);
    }
    return this.curve.jpoint(u, o, l);
  }, s.prototype._threeDbl = function() {
    var u, o, l;
    if (this.zOne) {
      var h = this.x.redSqr(), p = this.y.redSqr(), v = p.redSqr(), y = this.x.redAdd(p).redSqr().redISub(h).redISub(v);
      y = y.redIAdd(y);
      var w = h.redAdd(h).redIAdd(h).redIAdd(this.curve.a), x = w.redSqr().redISub(y).redISub(y);
      u = x;
      var A = v.redIAdd(v);
      A = A.redIAdd(A), A = A.redIAdd(A), o = w.redMul(y.redISub(x)).redISub(A), l = this.y.redAdd(this.y);
    } else {
      var R = this.z.redSqr(), M = this.y.redSqr(), D = this.x.redMul(M), U = this.x.redSub(R).redMul(this.x.redAdd(R));
      U = U.redAdd(U).redIAdd(U);
      var z = D.redIAdd(D);
      z = z.redIAdd(z);
      var W = z.redAdd(z);
      u = U.redSqr().redISub(W), l = this.y.redAdd(this.z).redSqr().redISub(M).redISub(R);
      var G = M.redSqr();
      G = G.redIAdd(G), G = G.redIAdd(G), G = G.redIAdd(G), o = U.redMul(z.redISub(u)).redISub(G);
    }
    return this.curve.jpoint(u, o, l);
  }, s.prototype._dbl = function() {
    var u = this.curve.a, o = this.x, l = this.y, h = this.z, p = h.redSqr().redSqr(), v = o.redSqr(), y = l.redSqr(), w = v.redAdd(v).redIAdd(v).redIAdd(u.redMul(p)), x = o.redAdd(o);
    x = x.redIAdd(x);
    var A = x.redMul(y), R = w.redSqr().redISub(A.redAdd(A)), M = A.redISub(R), D = y.redSqr();
    D = D.redIAdd(D), D = D.redIAdd(D), D = D.redIAdd(D);
    var U = w.redMul(M).redISub(D), z = l.redAdd(l).redMul(h);
    return this.curve.jpoint(R, U, z);
  }, s.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var u = this.x.redSqr(), o = this.y.redSqr(), l = this.z.redSqr(), h = o.redSqr(), p = u.redAdd(u).redIAdd(u), v = p.redSqr(), y = this.x.redAdd(o).redSqr().redISub(u).redISub(h);
    y = y.redIAdd(y), y = y.redAdd(y).redIAdd(y), y = y.redISub(v);
    var w = y.redSqr(), x = h.redIAdd(h);
    x = x.redIAdd(x), x = x.redIAdd(x), x = x.redIAdd(x);
    var A = p.redIAdd(y).redSqr().redISub(v).redISub(w).redISub(x), R = o.redMul(A);
    R = R.redIAdd(R), R = R.redIAdd(R);
    var M = this.x.redMul(w).redISub(R);
    M = M.redIAdd(M), M = M.redIAdd(M);
    var D = this.y.redMul(A.redMul(x.redISub(A)).redISub(y.redMul(w)));
    D = D.redIAdd(D), D = D.redIAdd(D), D = D.redIAdd(D);
    var U = this.z.redAdd(y).redSqr().redISub(l).redISub(w);
    return this.curve.jpoint(M, D, U);
  }, s.prototype.mul = function(u, o) {
    return u = new t(u, o), this.curve._wnafMul(this, u);
  }, s.prototype.eq = function(u) {
    if (u.type === "affine")
      return this.eq(u.toJ());
    if (this === u)
      return !0;
    var o = this.z.redSqr(), l = u.z.redSqr();
    if (this.x.redMul(l).redISub(u.x.redMul(o)).cmpn(0) !== 0)
      return !1;
    var h = o.redMul(this.z), p = l.redMul(u.z);
    return this.y.redMul(p).redISub(u.y.redMul(h)).cmpn(0) === 0;
  }, s.prototype.eqXToP = function(u) {
    var o = this.z.redSqr(), l = u.toRed(this.curve.red).redMul(o);
    if (this.x.cmp(l) === 0)
      return !0;
    for (var h = u.clone(), p = this.curve.redN.redMul(o); ; ) {
      if (h.iadd(this.curve.n), h.cmp(this.curve.p) >= 0)
        return !1;
      if (l.redIAdd(p), this.x.cmp(l) === 0)
        return !0;
    }
  }, s.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, s.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, Cs;
}
var As, xl;
function qv() {
  if (xl)
    return As;
  xl = 1;
  var e = jt(), t = Ae(), i = ja(), r = cr();
  function n(f) {
    i.call(this, "mont", f), this.a = new e(f.a, 16).toRed(this.red), this.b = new e(f.b, 16).toRed(this.red), this.i4 = new e(4).toRed(this.red).redInvm(), this.two = new e(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  t(n, i), As = n, n.prototype.validate = function(s) {
    var c = s.normalize().x, u = c.redSqr(), o = u.redMul(c).redAdd(u.redMul(this.a)).redAdd(c), l = o.redSqrt();
    return l.redSqr().cmp(o) === 0;
  };
  function a(f, s, c) {
    i.BasePoint.call(this, f, "projective"), s === null && c === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new e(s, 16), this.z = new e(c, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return t(a, i.BasePoint), n.prototype.decodePoint = function(s, c) {
    return this.point(r.toArray(s, c), 1);
  }, n.prototype.point = function(s, c) {
    return new a(this, s, c);
  }, n.prototype.pointFromJSON = function(s) {
    return a.fromJSON(this, s);
  }, a.prototype.precompute = function() {
  }, a.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, a.fromJSON = function(s, c) {
    return new a(s, c[0], c[1] || s.one);
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, a.prototype.dbl = function() {
    var s = this.x.redAdd(this.z), c = s.redSqr(), u = this.x.redSub(this.z), o = u.redSqr(), l = c.redSub(o), h = c.redMul(o), p = l.redMul(o.redAdd(this.curve.a24.redMul(l)));
    return this.curve.point(h, p);
  }, a.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.diffAdd = function(s, c) {
    var u = this.x.redAdd(this.z), o = this.x.redSub(this.z), l = s.x.redAdd(s.z), h = s.x.redSub(s.z), p = h.redMul(u), v = l.redMul(o), y = c.z.redMul(p.redAdd(v).redSqr()), w = c.x.redMul(p.redISub(v).redSqr());
    return this.curve.point(y, w);
  }, a.prototype.mul = function(s) {
    for (var c = s.clone(), u = this, o = this.curve.point(null, null), l = this, h = []; c.cmpn(0) !== 0; c.iushrn(1))
      h.push(c.andln(1));
    for (var p = h.length - 1; p >= 0; p--)
      h[p] === 0 ? (u = u.diffAdd(o, l), o = o.dbl()) : (o = u.diffAdd(o, l), u = u.dbl());
    return o;
  }, a.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.eq = function(s) {
    return this.getX().cmp(s.getX()) === 0;
  }, a.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, a.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, As;
}
var Bs, _l;
function Fv() {
  if (_l)
    return Bs;
  _l = 1;
  var e = cr(), t = jt(), i = Ae(), r = ja(), n = e.assert;
  function a(s) {
    this.twisted = (s.a | 0) !== 1, this.mOneA = this.twisted && (s.a | 0) === -1, this.extended = this.mOneA, r.call(this, "edwards", s), this.a = new t(s.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new t(s.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new t(s.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), n(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (s.c | 0) === 1;
  }
  i(a, r), Bs = a, a.prototype._mulA = function(c) {
    return this.mOneA ? c.redNeg() : this.a.redMul(c);
  }, a.prototype._mulC = function(c) {
    return this.oneC ? c : this.c.redMul(c);
  }, a.prototype.jpoint = function(c, u, o, l) {
    return this.point(c, u, o, l);
  }, a.prototype.pointFromX = function(c, u) {
    c = new t(c, 16), c.red || (c = c.toRed(this.red));
    var o = c.redSqr(), l = this.c2.redSub(this.a.redMul(o)), h = this.one.redSub(this.c2.redMul(this.d).redMul(o)), p = l.redMul(h.redInvm()), v = p.redSqrt();
    if (v.redSqr().redSub(p).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var y = v.fromRed().isOdd();
    return (u && !y || !u && y) && (v = v.redNeg()), this.point(c, v);
  }, a.prototype.pointFromY = function(c, u) {
    c = new t(c, 16), c.red || (c = c.toRed(this.red));
    var o = c.redSqr(), l = o.redSub(this.c2), h = o.redMul(this.d).redMul(this.c2).redSub(this.a), p = l.redMul(h.redInvm());
    if (p.cmp(this.zero) === 0) {
      if (u)
        throw new Error("invalid point");
      return this.point(this.zero, c);
    }
    var v = p.redSqrt();
    if (v.redSqr().redSub(p).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return v.fromRed().isOdd() !== u && (v = v.redNeg()), this.point(v, c);
  }, a.prototype.validate = function(c) {
    if (c.isInfinity())
      return !0;
    c.normalize();
    var u = c.x.redSqr(), o = c.y.redSqr(), l = u.redMul(this.a).redAdd(o), h = this.c2.redMul(this.one.redAdd(this.d.redMul(u).redMul(o)));
    return l.cmp(h) === 0;
  };
  function f(s, c, u, o, l) {
    r.BasePoint.call(this, s, "projective"), c === null && u === null && o === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new t(c, 16), this.y = new t(u, 16), this.z = o ? new t(o, 16) : this.curve.one, this.t = l && new t(l, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return i(f, r.BasePoint), a.prototype.pointFromJSON = function(c) {
    return f.fromJSON(this, c);
  }, a.prototype.point = function(c, u, o, l) {
    return new f(this, c, u, o, l);
  }, f.fromJSON = function(c, u) {
    return new f(c, u[0], u[1], u[2]);
  }, f.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, f.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, f.prototype._extDbl = function() {
    var c = this.x.redSqr(), u = this.y.redSqr(), o = this.z.redSqr();
    o = o.redIAdd(o);
    var l = this.curve._mulA(c), h = this.x.redAdd(this.y).redSqr().redISub(c).redISub(u), p = l.redAdd(u), v = p.redSub(o), y = l.redSub(u), w = h.redMul(v), x = p.redMul(y), A = h.redMul(y), R = v.redMul(p);
    return this.curve.point(w, x, R, A);
  }, f.prototype._projDbl = function() {
    var c = this.x.redAdd(this.y).redSqr(), u = this.x.redSqr(), o = this.y.redSqr(), l, h, p, v, y, w;
    if (this.curve.twisted) {
      v = this.curve._mulA(u);
      var x = v.redAdd(o);
      this.zOne ? (l = c.redSub(u).redSub(o).redMul(x.redSub(this.curve.two)), h = x.redMul(v.redSub(o)), p = x.redSqr().redSub(x).redSub(x)) : (y = this.z.redSqr(), w = x.redSub(y).redISub(y), l = c.redSub(u).redISub(o).redMul(w), h = x.redMul(v.redSub(o)), p = x.redMul(w));
    } else
      v = u.redAdd(o), y = this.curve._mulC(this.z).redSqr(), w = v.redSub(y).redSub(y), l = this.curve._mulC(c.redISub(v)).redMul(w), h = this.curve._mulC(v).redMul(u.redISub(o)), p = v.redMul(w);
    return this.curve.point(l, h, p);
  }, f.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, f.prototype._extAdd = function(c) {
    var u = this.y.redSub(this.x).redMul(c.y.redSub(c.x)), o = this.y.redAdd(this.x).redMul(c.y.redAdd(c.x)), l = this.t.redMul(this.curve.dd).redMul(c.t), h = this.z.redMul(c.z.redAdd(c.z)), p = o.redSub(u), v = h.redSub(l), y = h.redAdd(l), w = o.redAdd(u), x = p.redMul(v), A = y.redMul(w), R = p.redMul(w), M = v.redMul(y);
    return this.curve.point(x, A, M, R);
  }, f.prototype._projAdd = function(c) {
    var u = this.z.redMul(c.z), o = u.redSqr(), l = this.x.redMul(c.x), h = this.y.redMul(c.y), p = this.curve.d.redMul(l).redMul(h), v = o.redSub(p), y = o.redAdd(p), w = this.x.redAdd(this.y).redMul(c.x.redAdd(c.y)).redISub(l).redISub(h), x = u.redMul(v).redMul(w), A, R;
    return this.curve.twisted ? (A = u.redMul(y).redMul(h.redSub(this.curve._mulA(l))), R = v.redMul(y)) : (A = u.redMul(y).redMul(h.redSub(l)), R = this.curve._mulC(v).redMul(y)), this.curve.point(x, A, R);
  }, f.prototype.add = function(c) {
    return this.isInfinity() ? c : c.isInfinity() ? this : this.curve.extended ? this._extAdd(c) : this._projAdd(c);
  }, f.prototype.mul = function(c) {
    return this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve._wnafMul(this, c);
  }, f.prototype.mulAdd = function(c, u, o) {
    return this.curve._wnafMulAdd(1, [this, u], [c, o], 2, !1);
  }, f.prototype.jmulAdd = function(c, u, o) {
    return this.curve._wnafMulAdd(1, [this, u], [c, o], 2, !0);
  }, f.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var c = this.z.redInvm();
    return this.x = this.x.redMul(c), this.y = this.y.redMul(c), this.t && (this.t = this.t.redMul(c)), this.z = this.curve.one, this.zOne = !0, this;
  }, f.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, f.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, f.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, f.prototype.eq = function(c) {
    return this === c || this.getX().cmp(c.getX()) === 0 && this.getY().cmp(c.getY()) === 0;
  }, f.prototype.eqXToP = function(c) {
    var u = c.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(u) === 0)
      return !0;
    for (var o = c.clone(), l = this.curve.redN.redMul(this.z); ; ) {
      if (o.iadd(this.curve.n), o.cmp(this.curve.p) >= 0)
        return !1;
      if (u.redIAdd(l), this.x.cmp(u) === 0)
        return !0;
    }
  }, f.prototype.toP = f.prototype.normalize, f.prototype.mixedAdd = f.prototype.add, Bs;
}
var Sl;
function Od() {
  return Sl || (Sl = 1, function(e) {
    var t = e;
    t.base = ja(), t.short = Ov(), t.mont = qv(), t.edwards = Fv();
  }(Es)), Es;
}
var Ts = {}, Is = {}, it = {}, El;
function Sr() {
  if (El)
    return it;
  El = 1;
  var e = ur(), t = Ae();
  it.inherits = t;
  function i(m, g) {
    return (m.charCodeAt(g) & 64512) !== 55296 || g < 0 || g + 1 >= m.length ? !1 : (m.charCodeAt(g + 1) & 64512) === 56320;
  }
  function r(m, g) {
    if (Array.isArray(m))
      return m.slice();
    if (!m)
      return [];
    var d = [];
    if (typeof m == "string")
      if (g) {
        if (g === "hex")
          for (m = m.replace(/[^a-z0-9]+/ig, ""), m.length % 2 !== 0 && (m = "0" + m), C = 0; C < m.length; C += 2)
            d.push(parseInt(m[C] + m[C + 1], 16));
      } else
        for (var b = 0, C = 0; C < m.length; C++) {
          var E = m.charCodeAt(C);
          E < 128 ? d[b++] = E : E < 2048 ? (d[b++] = E >> 6 | 192, d[b++] = E & 63 | 128) : i(m, C) ? (E = 65536 + ((E & 1023) << 10) + (m.charCodeAt(++C) & 1023), d[b++] = E >> 18 | 240, d[b++] = E >> 12 & 63 | 128, d[b++] = E >> 6 & 63 | 128, d[b++] = E & 63 | 128) : (d[b++] = E >> 12 | 224, d[b++] = E >> 6 & 63 | 128, d[b++] = E & 63 | 128);
        }
    else
      for (C = 0; C < m.length; C++)
        d[C] = m[C] | 0;
    return d;
  }
  it.toArray = r;
  function n(m) {
    for (var g = "", d = 0; d < m.length; d++)
      g += s(m[d].toString(16));
    return g;
  }
  it.toHex = n;
  function a(m) {
    var g = m >>> 24 | m >>> 8 & 65280 | m << 8 & 16711680 | (m & 255) << 24;
    return g >>> 0;
  }
  it.htonl = a;
  function f(m, g) {
    for (var d = "", b = 0; b < m.length; b++) {
      var C = m[b];
      g === "little" && (C = a(C)), d += c(C.toString(16));
    }
    return d;
  }
  it.toHex32 = f;
  function s(m) {
    return m.length === 1 ? "0" + m : m;
  }
  it.zero2 = s;
  function c(m) {
    return m.length === 7 ? "0" + m : m.length === 6 ? "00" + m : m.length === 5 ? "000" + m : m.length === 4 ? "0000" + m : m.length === 3 ? "00000" + m : m.length === 2 ? "000000" + m : m.length === 1 ? "0000000" + m : m;
  }
  it.zero8 = c;
  function u(m, g, d, b) {
    var C = d - g;
    e(C % 4 === 0);
    for (var E = new Array(C / 4), B = 0, T = g; B < E.length; B++, T += 4) {
      var _;
      b === "big" ? _ = m[T] << 24 | m[T + 1] << 16 | m[T + 2] << 8 | m[T + 3] : _ = m[T + 3] << 24 | m[T + 2] << 16 | m[T + 1] << 8 | m[T], E[B] = _ >>> 0;
    }
    return E;
  }
  it.join32 = u;
  function o(m, g) {
    for (var d = new Array(m.length * 4), b = 0, C = 0; b < m.length; b++, C += 4) {
      var E = m[b];
      g === "big" ? (d[C] = E >>> 24, d[C + 1] = E >>> 16 & 255, d[C + 2] = E >>> 8 & 255, d[C + 3] = E & 255) : (d[C + 3] = E >>> 24, d[C + 2] = E >>> 16 & 255, d[C + 1] = E >>> 8 & 255, d[C] = E & 255);
    }
    return d;
  }
  it.split32 = o;
  function l(m, g) {
    return m >>> g | m << 32 - g;
  }
  it.rotr32 = l;
  function h(m, g) {
    return m << g | m >>> 32 - g;
  }
  it.rotl32 = h;
  function p(m, g) {
    return m + g >>> 0;
  }
  it.sum32 = p;
  function v(m, g, d) {
    return m + g + d >>> 0;
  }
  it.sum32_3 = v;
  function y(m, g, d, b) {
    return m + g + d + b >>> 0;
  }
  it.sum32_4 = y;
  function w(m, g, d, b, C) {
    return m + g + d + b + C >>> 0;
  }
  it.sum32_5 = w;
  function x(m, g, d, b) {
    var C = m[g], E = m[g + 1], B = b + E >>> 0, T = (B < b ? 1 : 0) + d + C;
    m[g] = T >>> 0, m[g + 1] = B;
  }
  it.sum64 = x;
  function A(m, g, d, b) {
    var C = g + b >>> 0, E = (C < g ? 1 : 0) + m + d;
    return E >>> 0;
  }
  it.sum64_hi = A;
  function R(m, g, d, b) {
    var C = g + b;
    return C >>> 0;
  }
  it.sum64_lo = R;
  function M(m, g, d, b, C, E, B, T) {
    var _ = 0, I = g;
    I = I + b >>> 0, _ += I < g ? 1 : 0, I = I + E >>> 0, _ += I < E ? 1 : 0, I = I + T >>> 0, _ += I < T ? 1 : 0;
    var S = m + d + C + B + _;
    return S >>> 0;
  }
  it.sum64_4_hi = M;
  function D(m, g, d, b, C, E, B, T) {
    var _ = g + b + E + T;
    return _ >>> 0;
  }
  it.sum64_4_lo = D;
  function U(m, g, d, b, C, E, B, T, _, I) {
    var S = 0, k = g;
    k = k + b >>> 0, S += k < g ? 1 : 0, k = k + E >>> 0, S += k < E ? 1 : 0, k = k + T >>> 0, S += k < T ? 1 : 0, k = k + I >>> 0, S += k < I ? 1 : 0;
    var $ = m + d + C + B + _ + S;
    return $ >>> 0;
  }
  it.sum64_5_hi = U;
  function z(m, g, d, b, C, E, B, T, _, I) {
    var S = g + b + E + T + I;
    return S >>> 0;
  }
  it.sum64_5_lo = z;
  function W(m, g, d) {
    var b = g << 32 - d | m >>> d;
    return b >>> 0;
  }
  it.rotr64_hi = W;
  function G(m, g, d) {
    var b = m << 32 - d | g >>> d;
    return b >>> 0;
  }
  it.rotr64_lo = G;
  function re(m, g, d) {
    return m >>> d;
  }
  it.shr64_hi = re;
  function V(m, g, d) {
    var b = m << 32 - d | g >>> d;
    return b >>> 0;
  }
  return it.shr64_lo = V, it;
}
var Rs = {}, wl;
function Yi() {
  if (wl)
    return Rs;
  wl = 1;
  var e = Sr(), t = ur();
  function i() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return Rs.BlockHash = i, i.prototype.update = function(n, a) {
    if (n = e.toArray(n, a), this.pending ? this.pending = this.pending.concat(n) : this.pending = n, this.pendingTotal += n.length, this.pending.length >= this._delta8) {
      n = this.pending;
      var f = n.length % this._delta8;
      this.pending = n.slice(n.length - f, n.length), this.pending.length === 0 && (this.pending = null), n = e.join32(n, 0, n.length - f, this.endian);
      for (var s = 0; s < n.length; s += this._delta32)
        this._update(n, s, s + this._delta32);
    }
    return this;
  }, i.prototype.digest = function(n) {
    return this.update(this._pad()), t(this.pending === null), this._digest(n);
  }, i.prototype._pad = function() {
    var n = this.pendingTotal, a = this._delta8, f = a - (n + this.padLength) % a, s = new Array(f + this.padLength);
    s[0] = 128;
    for (var c = 1; c < f; c++)
      s[c] = 0;
    if (n <<= 3, this.endian === "big") {
      for (var u = 8; u < this.padLength; u++)
        s[c++] = 0;
      s[c++] = 0, s[c++] = 0, s[c++] = 0, s[c++] = 0, s[c++] = n >>> 24 & 255, s[c++] = n >>> 16 & 255, s[c++] = n >>> 8 & 255, s[c++] = n & 255;
    } else
      for (s[c++] = n & 255, s[c++] = n >>> 8 & 255, s[c++] = n >>> 16 & 255, s[c++] = n >>> 24 & 255, s[c++] = 0, s[c++] = 0, s[c++] = 0, s[c++] = 0, u = 8; u < this.padLength; u++)
        s[c++] = 0;
    return s;
  }, Rs;
}
var ii = {}, dr = {}, Cl;
function qd() {
  if (Cl)
    return dr;
  Cl = 1;
  var e = Sr(), t = e.rotr32;
  function i(o, l, h, p) {
    if (o === 0)
      return r(l, h, p);
    if (o === 1 || o === 3)
      return a(l, h, p);
    if (o === 2)
      return n(l, h, p);
  }
  dr.ft_1 = i;
  function r(o, l, h) {
    return o & l ^ ~o & h;
  }
  dr.ch32 = r;
  function n(o, l, h) {
    return o & l ^ o & h ^ l & h;
  }
  dr.maj32 = n;
  function a(o, l, h) {
    return o ^ l ^ h;
  }
  dr.p32 = a;
  function f(o) {
    return t(o, 2) ^ t(o, 13) ^ t(o, 22);
  }
  dr.s0_256 = f;
  function s(o) {
    return t(o, 6) ^ t(o, 11) ^ t(o, 25);
  }
  dr.s1_256 = s;
  function c(o) {
    return t(o, 7) ^ t(o, 18) ^ o >>> 3;
  }
  dr.g0_256 = c;
  function u(o) {
    return t(o, 17) ^ t(o, 19) ^ o >>> 10;
  }
  return dr.g1_256 = u, dr;
}
var Ms, Al;
function Vv() {
  if (Al)
    return Ms;
  Al = 1;
  var e = Sr(), t = Yi(), i = qd(), r = e.rotl32, n = e.sum32, a = e.sum32_5, f = i.ft_1, s = t.BlockHash, c = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function u() {
    if (!(this instanceof u))
      return new u();
    s.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return e.inherits(u, s), Ms = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 80, u.padLength = 64, u.prototype._update = function(l, h) {
    for (var p = this.W, v = 0; v < 16; v++)
      p[v] = l[h + v];
    for (; v < p.length; v++)
      p[v] = r(p[v - 3] ^ p[v - 8] ^ p[v - 14] ^ p[v - 16], 1);
    var y = this.h[0], w = this.h[1], x = this.h[2], A = this.h[3], R = this.h[4];
    for (v = 0; v < p.length; v++) {
      var M = ~~(v / 20), D = a(r(y, 5), f(M, w, x, A), R, p[v], c[M]);
      R = A, A = x, x = r(w, 30), w = y, y = D;
    }
    this.h[0] = n(this.h[0], y), this.h[1] = n(this.h[1], w), this.h[2] = n(this.h[2], x), this.h[3] = n(this.h[3], A), this.h[4] = n(this.h[4], R);
  }, u.prototype._digest = function(l) {
    return l === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Ms;
}
var Ns, Bl;
function Fd() {
  if (Bl)
    return Ns;
  Bl = 1;
  var e = Sr(), t = Yi(), i = qd(), r = ur(), n = e.sum32, a = e.sum32_4, f = e.sum32_5, s = i.ch32, c = i.maj32, u = i.s0_256, o = i.s1_256, l = i.g0_256, h = i.g1_256, p = t.BlockHash, v = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function y() {
    if (!(this instanceof y))
      return new y();
    p.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = v, this.W = new Array(64);
  }
  return e.inherits(y, p), Ns = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(x, A) {
    for (var R = this.W, M = 0; M < 16; M++)
      R[M] = x[A + M];
    for (; M < R.length; M++)
      R[M] = a(h(R[M - 2]), R[M - 7], l(R[M - 15]), R[M - 16]);
    var D = this.h[0], U = this.h[1], z = this.h[2], W = this.h[3], G = this.h[4], re = this.h[5], V = this.h[6], m = this.h[7];
    for (r(this.k.length === R.length), M = 0; M < R.length; M++) {
      var g = f(m, o(G), s(G, re, V), this.k[M], R[M]), d = n(u(D), c(D, U, z));
      m = V, V = re, re = G, G = n(W, g), W = z, z = U, U = D, D = n(g, d);
    }
    this.h[0] = n(this.h[0], D), this.h[1] = n(this.h[1], U), this.h[2] = n(this.h[2], z), this.h[3] = n(this.h[3], W), this.h[4] = n(this.h[4], G), this.h[5] = n(this.h[5], re), this.h[6] = n(this.h[6], V), this.h[7] = n(this.h[7], m);
  }, y.prototype._digest = function(x) {
    return x === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Ns;
}
var ks, Tl;
function Kv() {
  if (Tl)
    return ks;
  Tl = 1;
  var e = Sr(), t = Fd();
  function i() {
    if (!(this instanceof i))
      return new i();
    t.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return e.inherits(i, t), ks = i, i.blockSize = 512, i.outSize = 224, i.hmacStrength = 192, i.padLength = 64, i.prototype._digest = function(n) {
    return n === "hex" ? e.toHex32(this.h.slice(0, 7), "big") : e.split32(this.h.slice(0, 7), "big");
  }, ks;
}
var Ds, Il;
function Vd() {
  if (Il)
    return Ds;
  Il = 1;
  var e = Sr(), t = Yi(), i = ur(), r = e.rotr64_hi, n = e.rotr64_lo, a = e.shr64_hi, f = e.shr64_lo, s = e.sum64, c = e.sum64_hi, u = e.sum64_lo, o = e.sum64_4_hi, l = e.sum64_4_lo, h = e.sum64_5_hi, p = e.sum64_5_lo, v = t.BlockHash, y = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function w() {
    if (!(this instanceof w))
      return new w();
    v.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = y, this.W = new Array(160);
  }
  e.inherits(w, v), Ds = w, w.blockSize = 1024, w.outSize = 512, w.hmacStrength = 192, w.padLength = 128, w.prototype._prepareBlock = function(d, b) {
    for (var C = this.W, E = 0; E < 32; E++)
      C[E] = d[b + E];
    for (; E < C.length; E += 2) {
      var B = V(C[E - 4], C[E - 3]), T = m(C[E - 4], C[E - 3]), _ = C[E - 14], I = C[E - 13], S = G(C[E - 30], C[E - 29]), k = re(C[E - 30], C[E - 29]), $ = C[E - 32], ee = C[E - 31];
      C[E] = o(
        B,
        T,
        _,
        I,
        S,
        k,
        $,
        ee
      ), C[E + 1] = l(
        B,
        T,
        _,
        I,
        S,
        k,
        $,
        ee
      );
    }
  }, w.prototype._update = function(d, b) {
    this._prepareBlock(d, b);
    var C = this.W, E = this.h[0], B = this.h[1], T = this.h[2], _ = this.h[3], I = this.h[4], S = this.h[5], k = this.h[6], $ = this.h[7], ee = this.h[8], H = this.h[9], N = this.h[10], L = this.h[11], j = this.h[12], Y = this.h[13], F = this.h[14], P = this.h[15];
    i(this.k.length === C.length);
    for (var Z = 0; Z < C.length; Z += 2) {
      var ae = F, se = P, le = z(ee, H), be = W(ee, H), me = x(ee, H, N, L, j), ie = A(ee, H, N, L, j, Y), Be = this.k[Z], pe = this.k[Z + 1], Ce = C[Z], Te = C[Z + 1], xe = h(
        ae,
        se,
        le,
        be,
        me,
        ie,
        Be,
        pe,
        Ce,
        Te
      ), ze = p(
        ae,
        se,
        le,
        be,
        me,
        ie,
        Be,
        pe,
        Ce,
        Te
      );
      ae = D(E, B), se = U(E, B), le = R(E, B, T, _, I), be = M(E, B, T, _, I, S);
      var et = c(ae, se, le, be), Ee = u(ae, se, le, be);
      F = j, P = Y, j = N, Y = L, N = ee, L = H, ee = c(k, $, xe, ze), H = u($, $, xe, ze), k = I, $ = S, I = T, S = _, T = E, _ = B, E = c(xe, ze, et, Ee), B = u(xe, ze, et, Ee);
    }
    s(this.h, 0, E, B), s(this.h, 2, T, _), s(this.h, 4, I, S), s(this.h, 6, k, $), s(this.h, 8, ee, H), s(this.h, 10, N, L), s(this.h, 12, j, Y), s(this.h, 14, F, P);
  }, w.prototype._digest = function(d) {
    return d === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  };
  function x(g, d, b, C, E) {
    var B = g & b ^ ~g & E;
    return B < 0 && (B += 4294967296), B;
  }
  function A(g, d, b, C, E, B) {
    var T = d & C ^ ~d & B;
    return T < 0 && (T += 4294967296), T;
  }
  function R(g, d, b, C, E) {
    var B = g & b ^ g & E ^ b & E;
    return B < 0 && (B += 4294967296), B;
  }
  function M(g, d, b, C, E, B) {
    var T = d & C ^ d & B ^ C & B;
    return T < 0 && (T += 4294967296), T;
  }
  function D(g, d) {
    var b = r(g, d, 28), C = r(d, g, 2), E = r(d, g, 7), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function U(g, d) {
    var b = n(g, d, 28), C = n(d, g, 2), E = n(d, g, 7), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function z(g, d) {
    var b = r(g, d, 14), C = r(g, d, 18), E = r(d, g, 9), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function W(g, d) {
    var b = n(g, d, 14), C = n(g, d, 18), E = n(d, g, 9), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function G(g, d) {
    var b = r(g, d, 1), C = r(g, d, 8), E = a(g, d, 7), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function re(g, d) {
    var b = n(g, d, 1), C = n(g, d, 8), E = f(g, d, 7), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function V(g, d) {
    var b = r(g, d, 19), C = r(d, g, 29), E = a(g, d, 6), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  function m(g, d) {
    var b = n(g, d, 19), C = n(d, g, 29), E = f(g, d, 6), B = b ^ C ^ E;
    return B < 0 && (B += 4294967296), B;
  }
  return Ds;
}
var Ls, Rl;
function Hv() {
  if (Rl)
    return Ls;
  Rl = 1;
  var e = Sr(), t = Vd();
  function i() {
    if (!(this instanceof i))
      return new i();
    t.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return e.inherits(i, t), Ls = i, i.blockSize = 1024, i.outSize = 384, i.hmacStrength = 192, i.padLength = 128, i.prototype._digest = function(n) {
    return n === "hex" ? e.toHex32(this.h.slice(0, 12), "big") : e.split32(this.h.slice(0, 12), "big");
  }, Ls;
}
var Ml;
function jv() {
  return Ml || (Ml = 1, ii.sha1 = Vv(), ii.sha224 = Kv(), ii.sha256 = Fd(), ii.sha384 = Hv(), ii.sha512 = Vd()), ii;
}
var Ps = {}, Nl;
function zv() {
  if (Nl)
    return Ps;
  Nl = 1;
  var e = Sr(), t = Yi(), i = e.rotl32, r = e.sum32, n = e.sum32_3, a = e.sum32_4, f = t.BlockHash;
  function s() {
    if (!(this instanceof s))
      return new s();
    f.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  e.inherits(s, f), Ps.ripemd160 = s, s.blockSize = 512, s.outSize = 160, s.hmacStrength = 192, s.padLength = 64, s.prototype._update = function(w, x) {
    for (var A = this.h[0], R = this.h[1], M = this.h[2], D = this.h[3], U = this.h[4], z = A, W = R, G = M, re = D, V = U, m = 0; m < 80; m++) {
      var g = r(
        i(
          a(A, c(m, R, M, D), w[l[m] + x], u(m)),
          p[m]
        ),
        U
      );
      A = U, U = D, D = i(M, 10), M = R, R = g, g = r(
        i(
          a(z, c(79 - m, W, G, re), w[h[m] + x], o(m)),
          v[m]
        ),
        V
      ), z = V, V = re, re = i(G, 10), G = W, W = g;
    }
    g = n(this.h[1], M, re), this.h[1] = n(this.h[2], D, V), this.h[2] = n(this.h[3], U, z), this.h[3] = n(this.h[4], A, W), this.h[4] = n(this.h[0], R, G), this.h[0] = g;
  }, s.prototype._digest = function(w) {
    return w === "hex" ? e.toHex32(this.h, "little") : e.split32(this.h, "little");
  };
  function c(y, w, x, A) {
    return y <= 15 ? w ^ x ^ A : y <= 31 ? w & x | ~w & A : y <= 47 ? (w | ~x) ^ A : y <= 63 ? w & A | x & ~A : w ^ (x | ~A);
  }
  function u(y) {
    return y <= 15 ? 0 : y <= 31 ? 1518500249 : y <= 47 ? 1859775393 : y <= 63 ? 2400959708 : 2840853838;
  }
  function o(y) {
    return y <= 15 ? 1352829926 : y <= 31 ? 1548603684 : y <= 47 ? 1836072691 : y <= 63 ? 2053994217 : 0;
  }
  var l = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], h = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], p = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], v = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return Ps;
}
var Us, kl;
function Gv() {
  if (kl)
    return Us;
  kl = 1;
  var e = Sr(), t = ur();
  function i(r, n, a) {
    if (!(this instanceof i))
      return new i(r, n, a);
    this.Hash = r, this.blockSize = r.blockSize / 8, this.outSize = r.outSize / 8, this.inner = null, this.outer = null, this._init(e.toArray(n, a));
  }
  return Us = i, i.prototype._init = function(n) {
    n.length > this.blockSize && (n = new this.Hash().update(n).digest()), t(n.length <= this.blockSize);
    for (var a = n.length; a < this.blockSize; a++)
      n.push(0);
    for (a = 0; a < n.length; a++)
      n[a] ^= 54;
    for (this.inner = new this.Hash().update(n), a = 0; a < n.length; a++)
      n[a] ^= 106;
    this.outer = new this.Hash().update(n);
  }, i.prototype.update = function(n, a) {
    return this.inner.update(n, a), this;
  }, i.prototype.digest = function(n) {
    return this.outer.update(this.inner.digest()), this.outer.digest(n);
  }, Us;
}
var Dl;
function u0() {
  return Dl || (Dl = 1, function(e) {
    var t = e;
    t.utils = Sr(), t.common = Yi(), t.sha = jv(), t.ripemd = zv(), t.hmac = Gv(), t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
  }(Is)), Is;
}
var Os, Ll;
function $v() {
  return Ll || (Ll = 1, Os = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Os;
}
var Pl;
function c0() {
  return Pl || (Pl = 1, function(e) {
    var t = e, i = u0(), r = Od(), n = cr(), a = n.assert;
    function f(u) {
      u.type === "short" ? this.curve = new r.short(u) : u.type === "edwards" ? this.curve = new r.edwards(u) : this.curve = new r.mont(u), this.g = this.curve.g, this.n = this.curve.n, this.hash = u.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    t.PresetCurve = f;
    function s(u, o) {
      Object.defineProperty(t, u, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var l = new f(o);
          return Object.defineProperty(t, u, {
            configurable: !0,
            enumerable: !0,
            value: l
          }), l;
        }
      });
    }
    s("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: i.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), s("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: i.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), s("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: i.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), s("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: i.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), s("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: i.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), s("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: i.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), s("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: i.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var c;
    try {
      c = $v();
    } catch {
      c = void 0;
    }
    s("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: i.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        c
      ]
    });
  }(Ts)), Ts;
}
var qs, Ul;
function Wv() {
  if (Ul)
    return qs;
  Ul = 1;
  var e = u0(), t = Ud(), i = ur();
  function r(n) {
    if (!(this instanceof r))
      return new r(n);
    this.hash = n.hash, this.predResist = !!n.predResist, this.outLen = this.hash.outSize, this.minEntropy = n.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var a = t.toArray(n.entropy, n.entropyEnc || "hex"), f = t.toArray(n.nonce, n.nonceEnc || "hex"), s = t.toArray(n.pers, n.persEnc || "hex");
    i(
      a.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(a, f, s);
  }
  return qs = r, r.prototype._init = function(a, f, s) {
    var c = a.concat(f).concat(s);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var u = 0; u < this.V.length; u++)
      this.K[u] = 0, this.V[u] = 1;
    this._update(c), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, r.prototype._hmac = function() {
    return new e.hmac(this.hash, this.K);
  }, r.prototype._update = function(a) {
    var f = this._hmac().update(this.V).update([0]);
    a && (f = f.update(a)), this.K = f.digest(), this.V = this._hmac().update(this.V).digest(), a && (this.K = this._hmac().update(this.V).update([1]).update(a).digest(), this.V = this._hmac().update(this.V).digest());
  }, r.prototype.reseed = function(a, f, s, c) {
    typeof f != "string" && (c = s, s = f, f = null), a = t.toArray(a, f), s = t.toArray(s, c), i(
      a.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(a.concat(s || [])), this._reseed = 1;
  }, r.prototype.generate = function(a, f, s, c) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof f != "string" && (c = s, s = f, f = null), s && (s = t.toArray(s, c || "hex"), this._update(s));
    for (var u = []; u.length < a; )
      this.V = this._hmac().update(this.V).digest(), u = u.concat(this.V);
    var o = u.slice(0, a);
    return this._update(s), this._reseed++, t.encode(o, f);
  }, qs;
}
var Fs, Ol;
function Qv() {
  if (Ol)
    return Fs;
  Ol = 1;
  var e = jt(), t = cr(), i = t.assert;
  function r(n, a) {
    this.ec = n, this.priv = null, this.pub = null, a.priv && this._importPrivate(a.priv, a.privEnc), a.pub && this._importPublic(a.pub, a.pubEnc);
  }
  return Fs = r, r.fromPublic = function(a, f, s) {
    return f instanceof r ? f : new r(a, {
      pub: f,
      pubEnc: s
    });
  }, r.fromPrivate = function(a, f, s) {
    return f instanceof r ? f : new r(a, {
      priv: f,
      privEnc: s
    });
  }, r.prototype.validate = function() {
    var a = this.getPublic();
    return a.isInfinity() ? { result: !1, reason: "Invalid public key" } : a.validate() ? a.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, r.prototype.getPublic = function(a, f) {
    return typeof a == "string" && (f = a, a = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), f ? this.pub.encode(f, a) : this.pub;
  }, r.prototype.getPrivate = function(a) {
    return a === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, r.prototype._importPrivate = function(a, f) {
    this.priv = new e(a, f || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, r.prototype._importPublic = function(a, f) {
    if (a.x || a.y) {
      this.ec.curve.type === "mont" ? i(a.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && i(a.x && a.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(a.x, a.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(a, f);
  }, r.prototype.derive = function(a) {
    return a.validate() || i(a.validate(), "public point not validated"), a.mul(this.priv).getX();
  }, r.prototype.sign = function(a, f, s) {
    return this.ec.sign(a, this, f, s);
  }, r.prototype.verify = function(a, f, s) {
    return this.ec.verify(a, f, this, void 0, s);
  }, r.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, Fs;
}
var Vs, ql;
function Yv() {
  if (ql)
    return Vs;
  ql = 1;
  var e = jt(), t = cr(), i = t.assert;
  function r(c, u) {
    if (c instanceof r)
      return c;
    this._importDER(c, u) || (i(c.r && c.s, "Signature without r or s"), this.r = new e(c.r, 16), this.s = new e(c.s, 16), c.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = c.recoveryParam);
  }
  Vs = r;
  function n() {
    this.place = 0;
  }
  function a(c, u) {
    var o = c[u.place++];
    if (!(o & 128))
      return o;
    var l = o & 15;
    if (l === 0 || l > 4 || c[u.place] === 0)
      return !1;
    for (var h = 0, p = 0, v = u.place; p < l; p++, v++)
      h <<= 8, h |= c[v], h >>>= 0;
    return h <= 127 ? !1 : (u.place = v, h);
  }
  function f(c) {
    for (var u = 0, o = c.length - 1; !c[u] && !(c[u + 1] & 128) && u < o; )
      u++;
    return u === 0 ? c : c.slice(u);
  }
  r.prototype._importDER = function(u, o) {
    u = t.toArray(u, o);
    var l = new n();
    if (u[l.place++] !== 48)
      return !1;
    var h = a(u, l);
    if (h === !1 || h + l.place !== u.length || u[l.place++] !== 2)
      return !1;
    var p = a(u, l);
    if (p === !1 || u[l.place] & 128)
      return !1;
    var v = u.slice(l.place, p + l.place);
    if (l.place += p, u[l.place++] !== 2)
      return !1;
    var y = a(u, l);
    if (y === !1 || u.length !== y + l.place || u[l.place] & 128)
      return !1;
    var w = u.slice(l.place, y + l.place);
    if (v[0] === 0)
      if (v[1] & 128)
        v = v.slice(1);
      else
        return !1;
    if (w[0] === 0)
      if (w[1] & 128)
        w = w.slice(1);
      else
        return !1;
    return this.r = new e(v), this.s = new e(w), this.recoveryParam = null, !0;
  };
  function s(c, u) {
    if (u < 128) {
      c.push(u);
      return;
    }
    var o = 1 + (Math.log(u) / Math.LN2 >>> 3);
    for (c.push(o | 128); --o; )
      c.push(u >>> (o << 3) & 255);
    c.push(u);
  }
  return r.prototype.toDER = function(u) {
    var o = this.r.toArray(), l = this.s.toArray();
    for (o[0] & 128 && (o = [0].concat(o)), l[0] & 128 && (l = [0].concat(l)), o = f(o), l = f(l); !l[0] && !(l[1] & 128); )
      l = l.slice(1);
    var h = [2];
    s(h, o.length), h = h.concat(o), h.push(2), s(h, l.length);
    var p = h.concat(l), v = [48];
    return s(v, p.length), v = v.concat(p), t.encode(v, u);
  }, Vs;
}
var Ks, Fl;
function Xv() {
  if (Fl)
    return Ks;
  Fl = 1;
  var e = jt(), t = Wv(), i = cr(), r = c0(), n = n0(), a = i.assert, f = Qv(), s = Yv();
  function c(u) {
    if (!(this instanceof c))
      return new c(u);
    typeof u == "string" && (a(
      Object.prototype.hasOwnProperty.call(r, u),
      "Unknown curve " + u
    ), u = r[u]), u instanceof r.PresetCurve && (u = { curve: u }), this.curve = u.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = u.curve.g, this.g.precompute(u.curve.n.bitLength() + 1), this.hash = u.hash || u.curve.hash;
  }
  return Ks = c, c.prototype.keyPair = function(o) {
    return new f(this, o);
  }, c.prototype.keyFromPrivate = function(o, l) {
    return f.fromPrivate(this, o, l);
  }, c.prototype.keyFromPublic = function(o, l) {
    return f.fromPublic(this, o, l);
  }, c.prototype.genKeyPair = function(o) {
    o || (o = {});
    for (var l = new t({
      hash: this.hash,
      pers: o.pers,
      persEnc: o.persEnc || "utf8",
      entropy: o.entropy || n(this.hash.hmacStrength),
      entropyEnc: o.entropy && o.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), h = this.n.byteLength(), p = this.n.sub(new e(2)); ; ) {
      var v = new e(l.generate(h));
      if (!(v.cmp(p) > 0))
        return v.iaddn(1), this.keyFromPrivate(v);
    }
  }, c.prototype._truncateToN = function(o, l, h) {
    var p;
    if (e.isBN(o) || typeof o == "number")
      o = new e(o, 16), p = o.byteLength();
    else if (typeof o == "object")
      p = o.length, o = new e(o, 16);
    else {
      var v = o.toString();
      p = v.length + 1 >>> 1, o = new e(v, 16);
    }
    typeof h != "number" && (h = p * 8);
    var y = h - this.n.bitLength();
    return y > 0 && (o = o.ushrn(y)), !l && o.cmp(this.n) >= 0 ? o.sub(this.n) : o;
  }, c.prototype.sign = function(o, l, h, p) {
    if (typeof h == "object" && (p = h, h = null), p || (p = {}), typeof o != "string" && typeof o != "number" && !e.isBN(o)) {
      a(
        typeof o == "object" && o && typeof o.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), a(o.length >>> 0 === o.length);
      for (var v = 0; v < o.length; v++)
        a((o[v] & 255) === o[v]);
    }
    l = this.keyFromPrivate(l, h), o = this._truncateToN(o, !1, p.msgBitLength), a(!o.isNeg(), "Can not sign a negative message");
    var y = this.n.byteLength(), w = l.getPrivate().toArray("be", y), x = o.toArray("be", y);
    a(new e(x).eq(o), "Can not sign message");
    for (var A = new t({
      hash: this.hash,
      entropy: w,
      nonce: x,
      pers: p.pers,
      persEnc: p.persEnc || "utf8"
    }), R = this.n.sub(new e(1)), M = 0; ; M++) {
      var D = p.k ? p.k(M) : new e(A.generate(this.n.byteLength()));
      if (D = this._truncateToN(D, !0), !(D.cmpn(1) <= 0 || D.cmp(R) >= 0)) {
        var U = this.g.mul(D);
        if (!U.isInfinity()) {
          var z = U.getX(), W = z.umod(this.n);
          if (W.cmpn(0) !== 0) {
            var G = D.invm(this.n).mul(W.mul(l.getPrivate()).iadd(o));
            if (G = G.umod(this.n), G.cmpn(0) !== 0) {
              var re = (U.getY().isOdd() ? 1 : 0) | (z.cmp(W) !== 0 ? 2 : 0);
              return p.canonical && G.cmp(this.nh) > 0 && (G = this.n.sub(G), re ^= 1), new s({ r: W, s: G, recoveryParam: re });
            }
          }
        }
      }
    }
  }, c.prototype.verify = function(o, l, h, p, v) {
    v || (v = {}), o = this._truncateToN(o, !1, v.msgBitLength), h = this.keyFromPublic(h, p), l = new s(l, "hex");
    var y = l.r, w = l.s;
    if (y.cmpn(1) < 0 || y.cmp(this.n) >= 0 || w.cmpn(1) < 0 || w.cmp(this.n) >= 0)
      return !1;
    var x = w.invm(this.n), A = x.mul(o).umod(this.n), R = x.mul(y).umod(this.n), M;
    return this.curve._maxwellTrick ? (M = this.g.jmulAdd(A, h.getPublic(), R), M.isInfinity() ? !1 : M.eqXToP(y)) : (M = this.g.mulAdd(A, h.getPublic(), R), M.isInfinity() ? !1 : M.getX().umod(this.n).cmp(y) === 0);
  }, c.prototype.recoverPubKey = function(u, o, l, h) {
    a((3 & l) === l, "The recovery param is more than two bits"), o = new s(o, h);
    var p = this.n, v = new e(u), y = o.r, w = o.s, x = l & 1, A = l >> 1;
    if (y.cmp(this.curve.p.umod(this.curve.n)) >= 0 && A)
      throw new Error("Unable to find sencond key candinate");
    A ? y = this.curve.pointFromX(y.add(this.curve.n), x) : y = this.curve.pointFromX(y, x);
    var R = o.r.invm(p), M = p.sub(v).mul(R).umod(p), D = w.mul(R).umod(p);
    return this.g.mulAdd(M, y, D);
  }, c.prototype.getKeyRecoveryParam = function(u, o, l, h) {
    if (o = new s(o, h), o.recoveryParam !== null)
      return o.recoveryParam;
    for (var p = 0; p < 4; p++) {
      var v;
      try {
        v = this.recoverPubKey(u, o, p);
      } catch {
        continue;
      }
      if (v.eq(l))
        return p;
    }
    throw new Error("Unable to find valid recovery factor");
  }, Ks;
}
var Hs, Vl;
function Zv() {
  if (Vl)
    return Hs;
  Vl = 1;
  var e = cr(), t = e.assert, i = e.parseBytes, r = e.cachedProperty;
  function n(a, f) {
    this.eddsa = a, this._secret = i(f.secret), a.isPoint(f.pub) ? this._pub = f.pub : this._pubBytes = i(f.pub);
  }
  return n.fromPublic = function(f, s) {
    return s instanceof n ? s : new n(f, { pub: s });
  }, n.fromSecret = function(f, s) {
    return s instanceof n ? s : new n(f, { secret: s });
  }, n.prototype.secret = function() {
    return this._secret;
  }, r(n, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), r(n, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), r(n, "privBytes", function() {
    var f = this.eddsa, s = this.hash(), c = f.encodingLength - 1, u = s.slice(0, f.encodingLength);
    return u[0] &= 248, u[c] &= 127, u[c] |= 64, u;
  }), r(n, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), r(n, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), r(n, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), n.prototype.sign = function(f) {
    return t(this._secret, "KeyPair can only verify"), this.eddsa.sign(f, this);
  }, n.prototype.verify = function(f, s) {
    return this.eddsa.verify(f, s, this);
  }, n.prototype.getSecret = function(f) {
    return t(this._secret, "KeyPair is public only"), e.encode(this.secret(), f);
  }, n.prototype.getPublic = function(f) {
    return e.encode(this.pubBytes(), f);
  }, Hs = n, Hs;
}
var js, Kl;
function Jv() {
  if (Kl)
    return js;
  Kl = 1;
  var e = jt(), t = cr(), i = t.assert, r = t.cachedProperty, n = t.parseBytes;
  function a(f, s) {
    this.eddsa = f, typeof s != "object" && (s = n(s)), Array.isArray(s) && (i(s.length === f.encodingLength * 2, "Signature has invalid size"), s = {
      R: s.slice(0, f.encodingLength),
      S: s.slice(f.encodingLength)
    }), i(s.R && s.S, "Signature without R or S"), f.isPoint(s.R) && (this._R = s.R), s.S instanceof e && (this._S = s.S), this._Rencoded = Array.isArray(s.R) ? s.R : s.Rencoded, this._Sencoded = Array.isArray(s.S) ? s.S : s.Sencoded;
  }
  return r(a, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), r(a, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), r(a, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), r(a, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), a.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, a.prototype.toHex = function() {
    return t.encode(this.toBytes(), "hex").toUpperCase();
  }, js = a, js;
}
var zs, Hl;
function ey() {
  if (Hl)
    return zs;
  Hl = 1;
  var e = u0(), t = c0(), i = cr(), r = i.assert, n = i.parseBytes, a = Zv(), f = Jv();
  function s(c) {
    if (r(c === "ed25519", "only tested with ed25519 so far"), !(this instanceof s))
      return new s(c);
    c = t[c].curve, this.curve = c, this.g = c.g, this.g.precompute(c.n.bitLength() + 1), this.pointClass = c.point().constructor, this.encodingLength = Math.ceil(c.n.bitLength() / 8), this.hash = e.sha512;
  }
  return zs = s, s.prototype.sign = function(u, o) {
    u = n(u);
    var l = this.keyFromSecret(o), h = this.hashInt(l.messagePrefix(), u), p = this.g.mul(h), v = this.encodePoint(p), y = this.hashInt(v, l.pubBytes(), u).mul(l.priv()), w = h.add(y).umod(this.curve.n);
    return this.makeSignature({ R: p, S: w, Rencoded: v });
  }, s.prototype.verify = function(u, o, l) {
    if (u = n(u), o = this.makeSignature(o), o.S().gte(o.eddsa.curve.n) || o.S().isNeg())
      return !1;
    var h = this.keyFromPublic(l), p = this.hashInt(o.Rencoded(), h.pubBytes(), u), v = this.g.mul(o.S()), y = o.R().add(h.pub().mul(p));
    return y.eq(v);
  }, s.prototype.hashInt = function() {
    for (var u = this.hash(), o = 0; o < arguments.length; o++)
      u.update(arguments[o]);
    return i.intFromLE(u.digest()).umod(this.curve.n);
  }, s.prototype.keyFromPublic = function(u) {
    return a.fromPublic(this, u);
  }, s.prototype.keyFromSecret = function(u) {
    return a.fromSecret(this, u);
  }, s.prototype.makeSignature = function(u) {
    return u instanceof f ? u : new f(this, u);
  }, s.prototype.encodePoint = function(u) {
    var o = u.getY().toArray("le", this.encodingLength);
    return o[this.encodingLength - 1] |= u.getX().isOdd() ? 128 : 0, o;
  }, s.prototype.decodePoint = function(u) {
    u = i.parseBytes(u);
    var o = u.length - 1, l = u.slice(0, o).concat(u[o] & -129), h = (u[o] & 128) !== 0, p = i.intFromLE(l);
    return this.curve.pointFromY(p, h);
  }, s.prototype.encodeInt = function(u) {
    return u.toArray("le", this.encodingLength);
  }, s.prototype.decodeInt = function(u) {
    return i.intFromLE(u);
  }, s.prototype.isPoint = function(u) {
    return u instanceof this.pointClass;
  }, zs;
}
var jl;
function l0() {
  return jl || (jl = 1, function(e) {
    var t = e;
    t.version = Uv.version, t.utils = cr(), t.rand = n0(), t.curve = Od(), t.curves = c0(), t.ec = Xv(), t.eddsa = ey();
  }(xs)), xs;
}
var rr = {}, Gs = {}, $s = {};
const ty = {}, ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ty
}, Symbol.toStringTag, { value: "Module" })), iy = /* @__PURE__ */ Np(ry);
var zl;
function ay() {
  return zl || (zl = 1, function(e) {
    var t = Xi(), i = Ae(), r = e;
    r.define = function(f, s) {
      return new n(f, s);
    };
    function n(a, f) {
      this.name = a, this.body = f, this.decoders = {}, this.encoders = {};
    }
    n.prototype._createNamed = function(f) {
      var s;
      try {
        s = iy.runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        s = function(u) {
          this._initNamed(u);
        };
      }
      return i(s, f), s.prototype._initNamed = function(u) {
        f.call(this, u);
      }, new s(this);
    }, n.prototype._getDecoder = function(f) {
      return f = f || "der", this.decoders.hasOwnProperty(f) || (this.decoders[f] = this._createNamed(t.decoders[f])), this.decoders[f];
    }, n.prototype.decode = function(f, s, c) {
      return this._getDecoder(s).decode(f, c);
    }, n.prototype._getEncoder = function(f) {
      return f = f || "der", this.encoders.hasOwnProperty(f) || (this.encoders[f] = this._createNamed(t.encoders[f])), this.encoders[f];
    }, n.prototype.encode = function(f, s, c) {
      return this._getEncoder(s).encode(f, c);
    };
  }($s)), $s;
}
var Ws = {}, Qs = {}, Gl;
function ny() {
  if (Gl)
    return Qs;
  Gl = 1;
  var e = Ae();
  function t(r) {
    this._reporterState = {
      obj: null,
      path: [],
      options: r || {},
      errors: []
    };
  }
  Qs.Reporter = t, t.prototype.isError = function(n) {
    return n instanceof i;
  }, t.prototype.save = function() {
    var n = this._reporterState;
    return { obj: n.obj, pathLen: n.path.length };
  }, t.prototype.restore = function(n) {
    var a = this._reporterState;
    a.obj = n.obj, a.path = a.path.slice(0, n.pathLen);
  }, t.prototype.enterKey = function(n) {
    return this._reporterState.path.push(n);
  }, t.prototype.exitKey = function(n) {
    var a = this._reporterState;
    a.path = a.path.slice(0, n - 1);
  }, t.prototype.leaveKey = function(n, a, f) {
    var s = this._reporterState;
    this.exitKey(n), s.obj !== null && (s.obj[a] = f);
  }, t.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, t.prototype.enterObject = function() {
    var n = this._reporterState, a = n.obj;
    return n.obj = {}, a;
  }, t.prototype.leaveObject = function(n) {
    var a = this._reporterState, f = a.obj;
    return a.obj = n, f;
  }, t.prototype.error = function(n) {
    var a, f = this._reporterState, s = n instanceof i;
    if (s ? a = n : a = new i(f.path.map(function(c) {
      return "[" + JSON.stringify(c) + "]";
    }).join(""), n.message || n, n.stack), !f.options.partial)
      throw a;
    return s || f.errors.push(a), a;
  }, t.prototype.wrapResult = function(n) {
    var a = this._reporterState;
    return a.options.partial ? {
      result: this.isError(n) ? null : n,
      errors: a.errors
    } : n;
  };
  function i(r, n) {
    this.path = r, this.rethrow(n);
  }
  return e(i, Error), i.prototype.rethrow = function(n) {
    if (this.message = n + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, i), !this.stack)
      try {
        throw new Error(this.message);
      } catch (a) {
        this.stack = a.stack;
      }
    return this;
  }, Qs;
}
var pa = {}, $l;
function Wl() {
  if ($l)
    return pa;
  $l = 1;
  var e = Ae(), t = Ui().Reporter, i = or.Buffer;
  function r(a, f) {
    if (t.call(this, f), !i.isBuffer(a)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = a, this.offset = 0, this.length = a.length;
  }
  e(r, t), pa.DecoderBuffer = r, r.prototype.save = function() {
    return { offset: this.offset, reporter: t.prototype.save.call(this) };
  }, r.prototype.restore = function(f) {
    var s = new r(this.base);
    return s.offset = f.offset, s.length = this.offset, this.offset = f.offset, t.prototype.restore.call(this, f.reporter), s;
  }, r.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, r.prototype.readUInt8 = function(f) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(f || "DecoderBuffer overrun");
  }, r.prototype.skip = function(f, s) {
    if (!(this.offset + f <= this.length))
      return this.error(s || "DecoderBuffer overrun");
    var c = new r(this.base);
    return c._reporterState = this._reporterState, c.offset = this.offset, c.length = this.offset + f, this.offset += f, c;
  }, r.prototype.raw = function(f) {
    return this.base.slice(f ? f.offset : this.offset, this.length);
  };
  function n(a, f) {
    if (Array.isArray(a))
      this.length = 0, this.value = a.map(function(s) {
        return s instanceof n || (s = new n(s, f)), this.length += s.length, s;
      }, this);
    else if (typeof a == "number") {
      if (!(0 <= a && a <= 255))
        return f.error("non-byte EncoderBuffer value");
      this.value = a, this.length = 1;
    } else if (typeof a == "string")
      this.value = a, this.length = i.byteLength(a);
    else if (i.isBuffer(a))
      this.value = a, this.length = a.length;
    else
      return f.error("Unsupported type: " + typeof a);
  }
  return pa.EncoderBuffer = n, n.prototype.join = function(f, s) {
    return f || (f = new i(this.length)), s || (s = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(c) {
      c.join(f, s), s += c.length;
    }) : (typeof this.value == "number" ? f[s] = this.value : typeof this.value == "string" ? f.write(this.value, s) : i.isBuffer(this.value) && this.value.copy(f, s), s += this.length)), f;
  }, pa;
}
var Ys, Ql;
function fy() {
  if (Ql)
    return Ys;
  Ql = 1;
  var e = Ui().Reporter, t = Ui().EncoderBuffer, i = Ui().DecoderBuffer, r = ur(), n = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], a = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(n), f = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function s(u, o) {
    var l = {};
    this._baseState = l, l.enc = u, l.parent = o || null, l.children = null, l.tag = null, l.args = null, l.reverseArgs = null, l.choice = null, l.optional = !1, l.any = !1, l.obj = !1, l.use = null, l.useDecoder = null, l.key = null, l.default = null, l.explicit = null, l.implicit = null, l.contains = null, l.parent || (l.children = [], this._wrap());
  }
  Ys = s;
  var c = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return s.prototype.clone = function() {
    var o = this._baseState, l = {};
    c.forEach(function(p) {
      l[p] = o[p];
    });
    var h = new this.constructor(l.parent);
    return h._baseState = l, h;
  }, s.prototype._wrap = function() {
    var o = this._baseState;
    a.forEach(function(l) {
      this[l] = function() {
        var p = new this.constructor(this);
        return o.children.push(p), p[l].apply(p, arguments);
      };
    }, this);
  }, s.prototype._init = function(o) {
    var l = this._baseState;
    r(l.parent === null), o.call(this), l.children = l.children.filter(function(h) {
      return h._baseState.parent === this;
    }, this), r.equal(l.children.length, 1, "Root node can have only one child");
  }, s.prototype._useArgs = function(o) {
    var l = this._baseState, h = o.filter(function(p) {
      return p instanceof this.constructor;
    }, this);
    o = o.filter(function(p) {
      return !(p instanceof this.constructor);
    }, this), h.length !== 0 && (r(l.children === null), l.children = h, h.forEach(function(p) {
      p._baseState.parent = this;
    }, this)), o.length !== 0 && (r(l.args === null), l.args = o, l.reverseArgs = o.map(function(p) {
      if (typeof p != "object" || p.constructor !== Object)
        return p;
      var v = {};
      return Object.keys(p).forEach(function(y) {
        y == (y | 0) && (y |= 0);
        var w = p[y];
        v[w] = y;
      }), v;
    }));
  }, f.forEach(function(u) {
    s.prototype[u] = function() {
      var l = this._baseState;
      throw new Error(u + " not implemented for encoding: " + l.enc);
    };
  }), n.forEach(function(u) {
    s.prototype[u] = function() {
      var l = this._baseState, h = Array.prototype.slice.call(arguments);
      return r(l.tag === null), l.tag = u, this._useArgs(h), this;
    };
  }), s.prototype.use = function(o) {
    r(o);
    var l = this._baseState;
    return r(l.use === null), l.use = o, this;
  }, s.prototype.optional = function() {
    var o = this._baseState;
    return o.optional = !0, this;
  }, s.prototype.def = function(o) {
    var l = this._baseState;
    return r(l.default === null), l.default = o, l.optional = !0, this;
  }, s.prototype.explicit = function(o) {
    var l = this._baseState;
    return r(l.explicit === null && l.implicit === null), l.explicit = o, this;
  }, s.prototype.implicit = function(o) {
    var l = this._baseState;
    return r(l.explicit === null && l.implicit === null), l.implicit = o, this;
  }, s.prototype.obj = function() {
    var o = this._baseState, l = Array.prototype.slice.call(arguments);
    return o.obj = !0, l.length !== 0 && this._useArgs(l), this;
  }, s.prototype.key = function(o) {
    var l = this._baseState;
    return r(l.key === null), l.key = o, this;
  }, s.prototype.any = function() {
    var o = this._baseState;
    return o.any = !0, this;
  }, s.prototype.choice = function(o) {
    var l = this._baseState;
    return r(l.choice === null), l.choice = o, this._useArgs(Object.keys(o).map(function(h) {
      return o[h];
    })), this;
  }, s.prototype.contains = function(o) {
    var l = this._baseState;
    return r(l.use === null), l.contains = o, this;
  }, s.prototype._decode = function(o, l) {
    var h = this._baseState;
    if (h.parent === null)
      return o.wrapResult(h.children[0]._decode(o, l));
    var p = h.default, v = !0, y = null;
    if (h.key !== null && (y = o.enterKey(h.key)), h.optional) {
      var w = null;
      if (h.explicit !== null ? w = h.explicit : h.implicit !== null ? w = h.implicit : h.tag !== null && (w = h.tag), w === null && !h.any) {
        var x = o.save();
        try {
          h.choice === null ? this._decodeGeneric(h.tag, o, l) : this._decodeChoice(o, l), v = !0;
        } catch {
          v = !1;
        }
        o.restore(x);
      } else if (v = this._peekTag(o, w, h.any), o.isError(v))
        return v;
    }
    var A;
    if (h.obj && v && (A = o.enterObject()), v) {
      if (h.explicit !== null) {
        var R = this._decodeTag(o, h.explicit);
        if (o.isError(R))
          return R;
        o = R;
      }
      var M = o.offset;
      if (h.use === null && h.choice === null) {
        if (h.any)
          var x = o.save();
        var D = this._decodeTag(
          o,
          h.implicit !== null ? h.implicit : h.tag,
          h.any
        );
        if (o.isError(D))
          return D;
        h.any ? p = o.raw(x) : o = D;
      }
      if (l && l.track && h.tag !== null && l.track(o.path(), M, o.length, "tagged"), l && l.track && h.tag !== null && l.track(o.path(), o.offset, o.length, "content"), h.any ? p = p : h.choice === null ? p = this._decodeGeneric(h.tag, o, l) : p = this._decodeChoice(o, l), o.isError(p))
        return p;
      if (!h.any && h.choice === null && h.children !== null && h.children.forEach(function(W) {
        W._decode(o, l);
      }), h.contains && (h.tag === "octstr" || h.tag === "bitstr")) {
        var U = new i(p);
        p = this._getUse(h.contains, o._reporterState.obj)._decode(U, l);
      }
    }
    return h.obj && v && (p = o.leaveObject(A)), h.key !== null && (p !== null || v === !0) ? o.leaveKey(y, h.key, p) : y !== null && o.exitKey(y), p;
  }, s.prototype._decodeGeneric = function(o, l, h) {
    var p = this._baseState;
    return o === "seq" || o === "set" ? null : o === "seqof" || o === "setof" ? this._decodeList(l, o, p.args[0], h) : /str$/.test(o) ? this._decodeStr(l, o, h) : o === "objid" && p.args ? this._decodeObjid(l, p.args[0], p.args[1], h) : o === "objid" ? this._decodeObjid(l, null, null, h) : o === "gentime" || o === "utctime" ? this._decodeTime(l, o, h) : o === "null_" ? this._decodeNull(l, h) : o === "bool" ? this._decodeBool(l, h) : o === "objDesc" ? this._decodeStr(l, o, h) : o === "int" || o === "enum" ? this._decodeInt(l, p.args && p.args[0], h) : p.use !== null ? this._getUse(p.use, l._reporterState.obj)._decode(l, h) : l.error("unknown tag: " + o);
  }, s.prototype._getUse = function(o, l) {
    var h = this._baseState;
    return h.useDecoder = this._use(o, l), r(h.useDecoder._baseState.parent === null), h.useDecoder = h.useDecoder._baseState.children[0], h.implicit !== h.useDecoder._baseState.implicit && (h.useDecoder = h.useDecoder.clone(), h.useDecoder._baseState.implicit = h.implicit), h.useDecoder;
  }, s.prototype._decodeChoice = function(o, l) {
    var h = this._baseState, p = null, v = !1;
    return Object.keys(h.choice).some(function(y) {
      var w = o.save(), x = h.choice[y];
      try {
        var A = x._decode(o, l);
        if (o.isError(A))
          return !1;
        p = { type: y, value: A }, v = !0;
      } catch {
        return o.restore(w), !1;
      }
      return !0;
    }, this), v ? p : o.error("Choice not matched");
  }, s.prototype._createEncoderBuffer = function(o) {
    return new t(o, this.reporter);
  }, s.prototype._encode = function(o, l, h) {
    var p = this._baseState;
    if (!(p.default !== null && p.default === o)) {
      var v = this._encodeValue(o, l, h);
      if (v !== void 0 && !this._skipDefault(v, l, h))
        return v;
    }
  }, s.prototype._encodeValue = function(o, l, h) {
    var p = this._baseState;
    if (p.parent === null)
      return p.children[0]._encode(o, l || new e());
    var x = null;
    if (this.reporter = l, p.optional && o === void 0)
      if (p.default !== null)
        o = p.default;
      else
        return;
    var v = null, y = !1;
    if (p.any)
      x = this._createEncoderBuffer(o);
    else if (p.choice)
      x = this._encodeChoice(o, l);
    else if (p.contains)
      v = this._getUse(p.contains, h)._encode(o, l), y = !0;
    else if (p.children)
      v = p.children.map(function(M) {
        if (M._baseState.tag === "null_")
          return M._encode(null, l, o);
        if (M._baseState.key === null)
          return l.error("Child should have a key");
        var D = l.enterKey(M._baseState.key);
        if (typeof o != "object")
          return l.error("Child expected, but input is not object");
        var U = M._encode(o[M._baseState.key], l, o);
        return l.leaveKey(D), U;
      }, this).filter(function(M) {
        return M;
      }), v = this._createEncoderBuffer(v);
    else if (p.tag === "seqof" || p.tag === "setof") {
      if (!(p.args && p.args.length === 1))
        return l.error("Too many args for : " + p.tag);
      if (!Array.isArray(o))
        return l.error("seqof/setof, but data is not Array");
      var w = this.clone();
      w._baseState.implicit = null, v = this._createEncoderBuffer(o.map(function(M) {
        var D = this._baseState;
        return this._getUse(D.args[0], o)._encode(M, l);
      }, w));
    } else
      p.use !== null ? x = this._getUse(p.use, h)._encode(o, l) : (v = this._encodePrimitive(p.tag, o), y = !0);
    var x;
    if (!p.any && p.choice === null) {
      var A = p.implicit !== null ? p.implicit : p.tag, R = p.implicit === null ? "universal" : "context";
      A === null ? p.use === null && l.error("Tag could be omitted only for .use()") : p.use === null && (x = this._encodeComposite(A, y, R, v));
    }
    return p.explicit !== null && (x = this._encodeComposite(p.explicit, !1, "context", x)), x;
  }, s.prototype._encodeChoice = function(o, l) {
    var h = this._baseState, p = h.choice[o.type];
    return p || r(
      !1,
      o.type + " not found in " + JSON.stringify(Object.keys(h.choice))
    ), p._encode(o.value, l);
  }, s.prototype._encodePrimitive = function(o, l) {
    var h = this._baseState;
    if (/str$/.test(o))
      return this._encodeStr(l, o);
    if (o === "objid" && h.args)
      return this._encodeObjid(l, h.reverseArgs[0], h.args[1]);
    if (o === "objid")
      return this._encodeObjid(l, null, null);
    if (o === "gentime" || o === "utctime")
      return this._encodeTime(l, o);
    if (o === "null_")
      return this._encodeNull();
    if (o === "int" || o === "enum")
      return this._encodeInt(l, h.args && h.reverseArgs[0]);
    if (o === "bool")
      return this._encodeBool(l);
    if (o === "objDesc")
      return this._encodeStr(l, o);
    throw new Error("Unsupported tag: " + o);
  }, s.prototype._isNumstr = function(o) {
    return /^[0-9 ]*$/.test(o);
  }, s.prototype._isPrintstr = function(o) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(o);
  }, Ys;
}
var Yl;
function Ui() {
  return Yl || (Yl = 1, function(e) {
    var t = e;
    t.Reporter = ny().Reporter, t.DecoderBuffer = Wl().DecoderBuffer, t.EncoderBuffer = Wl().EncoderBuffer, t.Node = fy();
  }(Ws)), Ws;
}
var Xs = {}, Zs = {}, Xl;
function sy() {
  return Xl || (Xl = 1, function(e) {
    var t = Kd();
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = t._reverse(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = t._reverse(e.tag);
  }(Zs)), Zs;
}
var Zl;
function Kd() {
  return Zl || (Zl = 1, function(e) {
    var t = e;
    t._reverse = function(r) {
      var n = {};
      return Object.keys(r).forEach(function(a) {
        (a | 0) == a && (a = a | 0);
        var f = r[a];
        n[f] = a;
      }), n;
    }, t.der = sy();
  }(Xs)), Xs;
}
var Js = {}, eo, Jl;
function Hd() {
  if (Jl)
    return eo;
  Jl = 1;
  var e = Ae(), t = Xi(), i = t.base, r = t.bignum, n = t.constants.der;
  function a(u) {
    this.enc = "der", this.name = u.name, this.entity = u, this.tree = new f(), this.tree._init(u.body);
  }
  eo = a, a.prototype.decode = function(o, l) {
    return o instanceof i.DecoderBuffer || (o = new i.DecoderBuffer(o, l)), this.tree._decode(o, l);
  };
  function f(u) {
    i.Node.call(this, "der", u);
  }
  e(f, i.Node), f.prototype._peekTag = function(o, l, h) {
    if (o.isEmpty())
      return !1;
    var p = o.save(), v = s(o, 'Failed to peek tag: "' + l + '"');
    return o.isError(v) ? v : (o.restore(p), v.tag === l || v.tagStr === l || v.tagStr + "of" === l || h);
  }, f.prototype._decodeTag = function(o, l, h) {
    var p = s(
      o,
      'Failed to decode tag of "' + l + '"'
    );
    if (o.isError(p))
      return p;
    var v = c(
      o,
      p.primitive,
      'Failed to get length of "' + l + '"'
    );
    if (o.isError(v))
      return v;
    if (!h && p.tag !== l && p.tagStr !== l && p.tagStr + "of" !== l)
      return o.error('Failed to match tag: "' + l + '"');
    if (p.primitive || v !== null)
      return o.skip(v, 'Failed to match body of: "' + l + '"');
    var y = o.save(), w = this._skipUntilEnd(
      o,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return o.isError(w) ? w : (v = o.offset - y.offset, o.restore(y), o.skip(v, 'Failed to match body of: "' + l + '"'));
  }, f.prototype._skipUntilEnd = function(o, l) {
    for (; ; ) {
      var h = s(o, l);
      if (o.isError(h))
        return h;
      var p = c(o, h.primitive, l);
      if (o.isError(p))
        return p;
      var v;
      if (h.primitive || p !== null ? v = o.skip(p) : v = this._skipUntilEnd(o, l), o.isError(v))
        return v;
      if (h.tagStr === "end")
        break;
    }
  }, f.prototype._decodeList = function(o, l, h, p) {
    for (var v = []; !o.isEmpty(); ) {
      var y = this._peekTag(o, "end");
      if (o.isError(y))
        return y;
      var w = h.decode(o, "der", p);
      if (o.isError(w) && y)
        break;
      v.push(w);
    }
    return v;
  }, f.prototype._decodeStr = function(o, l) {
    if (l === "bitstr") {
      var h = o.readUInt8();
      return o.isError(h) ? h : { unused: h, data: o.raw() };
    } else if (l === "bmpstr") {
      var p = o.raw();
      if (p.length % 2 === 1)
        return o.error("Decoding of string type: bmpstr length mismatch");
      for (var v = "", y = 0; y < p.length / 2; y++)
        v += String.fromCharCode(p.readUInt16BE(y * 2));
      return v;
    } else if (l === "numstr") {
      var w = o.raw().toString("ascii");
      return this._isNumstr(w) ? w : o.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (l === "octstr")
        return o.raw();
      if (l === "objDesc")
        return o.raw();
      if (l === "printstr") {
        var x = o.raw().toString("ascii");
        return this._isPrintstr(x) ? x : o.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(l) ? o.raw().toString() : o.error("Decoding of string type: " + l + " unsupported");
    }
  }, f.prototype._decodeObjid = function(o, l, h) {
    for (var p, v = [], y = 0; !o.isEmpty(); ) {
      var w = o.readUInt8();
      y <<= 7, y |= w & 127, w & 128 || (v.push(y), y = 0);
    }
    w & 128 && v.push(y);
    var x = v[0] / 40 | 0, A = v[0] % 40;
    if (h ? p = v : p = [x, A].concat(v.slice(1)), l) {
      var R = l[p.join(" ")];
      R === void 0 && (R = l[p.join(".")]), R !== void 0 && (p = R);
    }
    return p;
  }, f.prototype._decodeTime = function(o, l) {
    var h = o.raw().toString();
    if (l === "gentime")
      var p = h.slice(0, 4) | 0, v = h.slice(4, 6) | 0, y = h.slice(6, 8) | 0, w = h.slice(8, 10) | 0, x = h.slice(10, 12) | 0, A = h.slice(12, 14) | 0;
    else if (l === "utctime") {
      var p = h.slice(0, 2) | 0, v = h.slice(2, 4) | 0, y = h.slice(4, 6) | 0, w = h.slice(6, 8) | 0, x = h.slice(8, 10) | 0, A = h.slice(10, 12) | 0;
      p < 70 ? p = 2e3 + p : p = 1900 + p;
    } else
      return o.error("Decoding " + l + " time is not supported yet");
    return Date.UTC(p, v - 1, y, w, x, A, 0);
  }, f.prototype._decodeNull = function(o) {
    return null;
  }, f.prototype._decodeBool = function(o) {
    var l = o.readUInt8();
    return o.isError(l) ? l : l !== 0;
  }, f.prototype._decodeInt = function(o, l) {
    var h = o.raw(), p = new r(h);
    return l && (p = l[p.toString(10)] || p), p;
  }, f.prototype._use = function(o, l) {
    return typeof o == "function" && (o = o(l)), o._getDecoder("der").tree;
  };
  function s(u, o) {
    var l = u.readUInt8(o);
    if (u.isError(l))
      return l;
    var h = n.tagClass[l >> 6], p = (l & 32) === 0;
    if ((l & 31) === 31) {
      var v = l;
      for (l = 0; (v & 128) === 128; ) {
        if (v = u.readUInt8(o), u.isError(v))
          return v;
        l <<= 7, l |= v & 127;
      }
    } else
      l &= 31;
    var y = n.tag[l];
    return {
      cls: h,
      primitive: p,
      tag: l,
      tagStr: y
    };
  }
  function c(u, o, l) {
    var h = u.readUInt8(l);
    if (u.isError(h))
      return h;
    if (!o && h === 128)
      return null;
    if (!(h & 128))
      return h;
    var p = h & 127;
    if (p > 4)
      return u.error("length octect is too long");
    h = 0;
    for (var v = 0; v < p; v++) {
      h <<= 8;
      var y = u.readUInt8(l);
      if (u.isError(y))
        return y;
      h |= y;
    }
    return h;
  }
  return eo;
}
var to, eh;
function oy() {
  if (eh)
    return to;
  eh = 1;
  var e = Ae(), t = or.Buffer, i = Hd();
  function r(n) {
    i.call(this, n), this.enc = "pem";
  }
  return e(r, i), to = r, r.prototype.decode = function(a, f) {
    for (var s = a.toString().split(/[\r\n]+/g), c = f.label.toUpperCase(), u = /^-----(BEGIN|END) ([^-]+)-----$/, o = -1, l = -1, h = 0; h < s.length; h++) {
      var p = s[h].match(u);
      if (p !== null && p[2] === c)
        if (o === -1) {
          if (p[1] !== "BEGIN")
            break;
          o = h;
        } else {
          if (p[1] !== "END")
            break;
          l = h;
          break;
        }
    }
    if (o === -1 || l === -1)
      throw new Error("PEM section not found for: " + c);
    var v = s.slice(o + 1, l).join("");
    v.replace(/[^a-z0-9\+\/=]+/gi, "");
    var y = new t(v, "base64");
    return i.prototype.decode.call(this, y, f);
  }, to;
}
var th;
function uy() {
  return th || (th = 1, function(e) {
    var t = e;
    t.der = Hd(), t.pem = oy();
  }(Js)), Js;
}
var ro = {}, io, rh;
function jd() {
  if (rh)
    return io;
  rh = 1;
  var e = Ae(), t = or.Buffer, i = Xi(), r = i.base, n = i.constants.der;
  function a(u) {
    this.enc = "der", this.name = u.name, this.entity = u, this.tree = new f(), this.tree._init(u.body);
  }
  io = a, a.prototype.encode = function(o, l) {
    return this.tree._encode(o, l).join();
  };
  function f(u) {
    r.Node.call(this, "der", u);
  }
  e(f, r.Node), f.prototype._encodeComposite = function(o, l, h, p) {
    var v = c(o, l, h, this.reporter);
    if (p.length < 128) {
      var x = new t(2);
      return x[0] = v, x[1] = p.length, this._createEncoderBuffer([x, p]);
    }
    for (var y = 1, w = p.length; w >= 256; w >>= 8)
      y++;
    var x = new t(2 + y);
    x[0] = v, x[1] = 128 | y;
    for (var w = 1 + y, A = p.length; A > 0; w--, A >>= 8)
      x[w] = A & 255;
    return this._createEncoderBuffer([x, p]);
  }, f.prototype._encodeStr = function(o, l) {
    if (l === "bitstr")
      return this._createEncoderBuffer([o.unused | 0, o.data]);
    if (l === "bmpstr") {
      for (var h = new t(o.length * 2), p = 0; p < o.length; p++)
        h.writeUInt16BE(o.charCodeAt(p), p * 2);
      return this._createEncoderBuffer(h);
    } else
      return l === "numstr" ? this._isNumstr(o) ? this._createEncoderBuffer(o) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : l === "printstr" ? this._isPrintstr(o) ? this._createEncoderBuffer(o) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(l) ? this._createEncoderBuffer(o) : l === "objDesc" ? this._createEncoderBuffer(o) : this.reporter.error("Encoding of string type: " + l + " unsupported");
  }, f.prototype._encodeObjid = function(o, l, h) {
    if (typeof o == "string") {
      if (!l)
        return this.reporter.error("string objid given, but no values map found");
      if (!l.hasOwnProperty(o))
        return this.reporter.error("objid not found in values map");
      o = l[o].split(/[\s\.]+/g);
      for (var p = 0; p < o.length; p++)
        o[p] |= 0;
    } else if (Array.isArray(o)) {
      o = o.slice();
      for (var p = 0; p < o.length; p++)
        o[p] |= 0;
    }
    if (!Array.isArray(o))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(o));
    if (!h) {
      if (o[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      o.splice(0, 2, o[0] * 40 + o[1]);
    }
    for (var v = 0, p = 0; p < o.length; p++) {
      var y = o[p];
      for (v++; y >= 128; y >>= 7)
        v++;
    }
    for (var w = new t(v), x = w.length - 1, p = o.length - 1; p >= 0; p--) {
      var y = o[p];
      for (w[x--] = y & 127; (y >>= 7) > 0; )
        w[x--] = 128 | y & 127;
    }
    return this._createEncoderBuffer(w);
  };
  function s(u) {
    return u < 10 ? "0" + u : u;
  }
  f.prototype._encodeTime = function(o, l) {
    var h, p = new Date(o);
    return l === "gentime" ? h = [
      s(p.getFullYear()),
      s(p.getUTCMonth() + 1),
      s(p.getUTCDate()),
      s(p.getUTCHours()),
      s(p.getUTCMinutes()),
      s(p.getUTCSeconds()),
      "Z"
    ].join("") : l === "utctime" ? h = [
      s(p.getFullYear() % 100),
      s(p.getUTCMonth() + 1),
      s(p.getUTCDate()),
      s(p.getUTCHours()),
      s(p.getUTCMinutes()),
      s(p.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + l + " time is not supported yet"), this._encodeStr(h, "octstr");
  }, f.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, f.prototype._encodeInt = function(o, l) {
    if (typeof o == "string") {
      if (!l)
        return this.reporter.error("String int or enum given, but no values map");
      if (!l.hasOwnProperty(o))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(o));
      o = l[o];
    }
    if (typeof o != "number" && !t.isBuffer(o)) {
      var h = o.toArray();
      !o.sign && h[0] & 128 && h.unshift(0), o = new t(h);
    }
    if (t.isBuffer(o)) {
      var p = o.length;
      o.length === 0 && p++;
      var y = new t(p);
      return o.copy(y), o.length === 0 && (y[0] = 0), this._createEncoderBuffer(y);
    }
    if (o < 128)
      return this._createEncoderBuffer(o);
    if (o < 256)
      return this._createEncoderBuffer([0, o]);
    for (var p = 1, v = o; v >= 256; v >>= 8)
      p++;
    for (var y = new Array(p), v = y.length - 1; v >= 0; v--)
      y[v] = o & 255, o >>= 8;
    return y[0] & 128 && y.unshift(0), this._createEncoderBuffer(new t(y));
  }, f.prototype._encodeBool = function(o) {
    return this._createEncoderBuffer(o ? 255 : 0);
  }, f.prototype._use = function(o, l) {
    return typeof o == "function" && (o = o(l)), o._getEncoder("der").tree;
  }, f.prototype._skipDefault = function(o, l, h) {
    var p = this._baseState, v;
    if (p.default === null)
      return !1;
    var y = o.join();
    if (p.defaultBuffer === void 0 && (p.defaultBuffer = this._encodeValue(p.default, l, h).join()), y.length !== p.defaultBuffer.length)
      return !1;
    for (v = 0; v < y.length; v++)
      if (y[v] !== p.defaultBuffer[v])
        return !1;
    return !0;
  };
  function c(u, o, l, h) {
    var p;
    if (u === "seqof" ? u = "seq" : u === "setof" && (u = "set"), n.tagByName.hasOwnProperty(u))
      p = n.tagByName[u];
    else if (typeof u == "number" && (u | 0) === u)
      p = u;
    else
      return h.error("Unknown tag: " + u);
    return p >= 31 ? h.error("Multi-octet tag encoding unsupported") : (o || (p |= 32), p |= n.tagClassByName[l || "universal"] << 6, p);
  }
  return io;
}
var ao, ih;
function cy() {
  if (ih)
    return ao;
  ih = 1;
  var e = Ae(), t = jd();
  function i(r) {
    t.call(this, r), this.enc = "pem";
  }
  return e(i, t), ao = i, i.prototype.encode = function(n, a) {
    for (var f = t.prototype.encode.call(this, n), s = f.toString("base64"), c = ["-----BEGIN " + a.label + "-----"], u = 0; u < s.length; u += 64)
      c.push(s.slice(u, u + 64));
    return c.push("-----END " + a.label + "-----"), c.join(`
`);
  }, ao;
}
var ah;
function ly() {
  return ah || (ah = 1, function(e) {
    var t = e;
    t.der = jd(), t.pem = cy();
  }(ro)), ro;
}
var nh;
function Xi() {
  return nh || (nh = 1, function(e) {
    var t = e;
    t.bignum = jt(), t.define = ay().define, t.base = Ui(), t.constants = Kd(), t.decoders = uy(), t.encoders = ly();
  }(Gs)), Gs;
}
var no, fh;
function hy() {
  if (fh)
    return no;
  fh = 1;
  var e = Xi(), t = e.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), i = e.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), r = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), n = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(r),
      this.key("subjectPublicKey").bitstr()
    );
  }), a = e.define("RelativeDistinguishedName", function() {
    this.setof(i);
  }), f = e.define("RDNSequence", function() {
    this.seqof(a);
  }), s = e.define("Name", function() {
    this.choice({
      rdnSequence: this.use(f)
    });
  }), c = e.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(t),
      this.key("notAfter").use(t)
    );
  }), u = e.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), o = e.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(r),
      this.key("issuer").use(s),
      this.key("validity").use(c),
      this.key("subject").use(s),
      this.key("subjectPublicKeyInfo").use(n),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(u).optional()
    );
  }), l = e.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(o),
      this.key("signatureAlgorithm").use(r),
      this.key("signatureValue").bitstr()
    );
  });
  return no = l, no;
}
var sh;
function dy() {
  if (sh)
    return rr;
  sh = 1;
  var e = Xi();
  rr.certificate = hy();
  var t = e.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  rr.RSAPrivateKey = t;
  var i = e.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  rr.RSAPublicKey = i;
  var r = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), n = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(r),
      this.key("subjectPublicKey").bitstr()
    );
  });
  rr.PublicKey = n;
  var a = e.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(r),
      this.key("subjectPrivateKey").octstr()
    );
  });
  rr.PrivateKey = a;
  var f = e.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  rr.EncryptedPrivateKey = f;
  var s = e.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  rr.DSAPrivateKey = s, rr.DSAparam = e.define("DSAparam", function() {
    this.int();
  });
  var c = e.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), u = e.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(c),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return rr.ECPrivateKey = u, rr.signature = e.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), rr;
}
const py = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fo, oh;
function vy() {
  if (oh)
    return fo;
  oh = 1;
  var e = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, t = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, r = Ka(), n = a0(), a = He().Buffer;
  return fo = function(f, s) {
    var c = f.toString(), u = c.match(e), o;
    if (u) {
      var h = "aes" + u[1], p = a.from(u[2], "hex"), v = a.from(u[3].replace(/[\r\n]/g, ""), "base64"), y = r(s, p.slice(0, 8), parseInt(u[1], 10)).key, w = [], x = n.createDecipheriv(h, y, p);
      w.push(x.update(v)), w.push(x.final()), o = a.concat(w);
    } else {
      var l = c.match(i);
      o = a.from(l[2].replace(/[\r\n]/g, ""), "base64");
    }
    var A = c.match(t)[1];
    return {
      tag: A,
      data: o
    };
  }, fo;
}
var so, uh;
function za() {
  if (uh)
    return so;
  uh = 1;
  var e = dy(), t = py, i = vy(), r = a0(), n = Ed(), a = He().Buffer;
  function f(c, u) {
    var o = c.algorithm.decrypt.kde.kdeparams.salt, l = parseInt(c.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), h = t[c.algorithm.decrypt.cipher.algo.join(".")], p = c.algorithm.decrypt.cipher.iv, v = c.subjectPrivateKey, y = parseInt(h.split("-")[1], 10) / 8, w = n.pbkdf2Sync(u, o, l, y, "sha1"), x = r.createDecipheriv(h, w, p), A = [];
    return A.push(x.update(v)), A.push(x.final()), a.concat(A);
  }
  function s(c) {
    var u;
    typeof c == "object" && !a.isBuffer(c) && (u = c.passphrase, c = c.key), typeof c == "string" && (c = a.from(c));
    var o = i(c, u), l = o.tag, h = o.data, p, v;
    switch (l) {
      case "CERTIFICATE":
        v = e.certificate.decode(h, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (v || (v = e.PublicKey.decode(h, "der")), p = v.algorithm.algorithm.join("."), p) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPublicKey.decode(v.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return v.subjectPrivateKey = v.subjectPublicKey, {
              type: "ec",
              data: v
            };
          case "1.2.840.10040.4.1":
            return v.algorithm.params.pub_key = e.DSAparam.decode(v.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: v.algorithm.params
            };
          default:
            throw new Error("unknown key id " + p);
        }
      case "ENCRYPTED PRIVATE KEY":
        h = e.EncryptedPrivateKey.decode(h, "der"), h = f(h, u);
      case "PRIVATE KEY":
        switch (v = e.PrivateKey.decode(h, "der"), p = v.algorithm.algorithm.join("."), p) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPrivateKey.decode(v.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: v.algorithm.curve,
              privateKey: e.ECPrivateKey.decode(v.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return v.algorithm.params.priv_key = e.DSAparam.decode(v.subjectPrivateKey, "der"), {
              type: "dsa",
              params: v.algorithm.params
            };
          default:
            throw new Error("unknown key id " + p);
        }
      case "RSA PUBLIC KEY":
        return e.RSAPublicKey.decode(h, "der");
      case "RSA PRIVATE KEY":
        return e.RSAPrivateKey.decode(h, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: e.DSAPrivateKey.decode(h, "der")
        };
      case "EC PRIVATE KEY":
        return h = e.ECPrivateKey.decode(h, "der"), {
          curve: h.parameters.value,
          privateKey: h.privateKey
        };
      default:
        throw new Error("unknown key type " + l);
    }
  }
  return s.signature = e.signature, so = s, so;
}
const zd = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var ch;
function yy() {
  if (ch)
    return Mi.exports;
  ch = 1;
  var e = He().Buffer, t = gd(), i = o0(), r = l0().ec, n = s0(), a = za(), f = zd, s = 1;
  function c(x, A, R, M, D) {
    var U = a(A);
    if (U.curve) {
      if (M !== "ecdsa" && M !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return u(x, U);
    } else if (U.type === "dsa") {
      if (M !== "dsa")
        throw new Error("wrong private key type");
      return o(x, U, R);
    }
    if (M !== "rsa" && M !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (A.padding !== void 0 && A.padding !== s)
      throw new Error("illegal or unsupported padding mode");
    x = e.concat([D, x]);
    for (var z = U.modulus.byteLength(), W = [0, 1]; x.length + W.length + 1 < z; )
      W.push(255);
    W.push(0);
    for (var G = -1; ++G < x.length; )
      W.push(x[G]);
    var re = i(W, U);
    return re;
  }
  function u(x, A) {
    var R = f[A.curve.join(".")];
    if (!R)
      throw new Error("unknown curve " + A.curve.join("."));
    var M = new r(R), D = M.keyFromPrivate(A.privateKey), U = D.sign(x);
    return e.from(U.toDER());
  }
  function o(x, A, R) {
    for (var M = A.params.priv_key, D = A.params.p, U = A.params.q, z = A.params.g, W = new n(0), G, re = p(x, U).mod(U), V = !1, m = h(M, U, x, R); V === !1; )
      G = y(U, m, R), W = w(z, G, D, U), V = G.invm(U).imul(re.add(M.mul(W))).mod(U), V.cmpn(0) === 0 && (V = !1, W = new n(0));
    return l(W, V);
  }
  function l(x, A) {
    x = x.toArray(), A = A.toArray(), x[0] & 128 && (x = [0].concat(x)), A[0] & 128 && (A = [0].concat(A));
    var R = x.length + A.length + 4, M = [
      48,
      R,
      2,
      x.length
    ];
    return M = M.concat(x, [2, A.length], A), e.from(M);
  }
  function h(x, A, R, M) {
    if (x = e.from(x.toArray()), x.length < A.byteLength()) {
      var D = e.alloc(A.byteLength() - x.length);
      x = e.concat([D, x]);
    }
    var U = R.length, z = v(R, A), W = e.alloc(U);
    W.fill(1);
    var G = e.alloc(U);
    return G = t(M, G).update(W).update(e.from([0])).update(x).update(z).digest(), W = t(M, G).update(W).digest(), G = t(M, G).update(W).update(e.from([1])).update(x).update(z).digest(), W = t(M, G).update(W).digest(), { k: G, v: W };
  }
  function p(x, A) {
    var R = new n(x), M = (x.length << 3) - A.bitLength();
    return M > 0 && R.ishrn(M), R;
  }
  function v(x, A) {
    x = p(x, A), x = x.mod(A);
    var R = e.from(x.toArray());
    if (R.length < A.byteLength()) {
      var M = e.alloc(A.byteLength() - R.length);
      R = e.concat([M, R]);
    }
    return R;
  }
  function y(x, A, R) {
    var M, D;
    do {
      for (M = e.alloc(0); M.length * 8 < x.bitLength(); )
        A.v = t(R, A.k).update(A.v).digest(), M = e.concat([M, A.v]);
      D = p(M, x), A.k = t(R, A.k).update(A.v).update(e.from([0])).digest(), A.v = t(R, A.k).update(A.v).digest();
    } while (D.cmp(x) !== -1);
    return D;
  }
  function w(x, A, R, M) {
    return x.toRed(n.mont(R)).redPow(A).fromRed().mod(M);
  }
  return Mi.exports = c, Mi.exports.getKey = h, Mi.exports.makeKey = y, Mi.exports;
}
var oo, lh;
function gy() {
  if (lh)
    return oo;
  lh = 1;
  var e = He().Buffer, t = s0(), i = l0().ec, r = za(), n = zd;
  function a(u, o, l, h, p) {
    var v = r(l);
    if (v.type === "ec") {
      if (h !== "ecdsa" && h !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return f(u, o, v);
    } else if (v.type === "dsa") {
      if (h !== "dsa")
        throw new Error("wrong public key type");
      return s(u, o, v);
    }
    if (h !== "rsa" && h !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    o = e.concat([p, o]);
    for (var y = v.modulus.byteLength(), w = [1], x = 0; o.length + w.length + 2 < y; )
      w.push(255), x += 1;
    w.push(0);
    for (var A = -1; ++A < o.length; )
      w.push(o[A]);
    w = e.from(w);
    var R = t.mont(v.modulus);
    u = new t(u).toRed(R), u = u.redPow(new t(v.publicExponent)), u = e.from(u.fromRed().toArray());
    var M = x < 8 ? 1 : 0;
    for (y = Math.min(u.length, w.length), u.length !== w.length && (M = 1), A = -1; ++A < y; )
      M |= u[A] ^ w[A];
    return M === 0;
  }
  function f(u, o, l) {
    var h = n[l.data.algorithm.curve.join(".")];
    if (!h)
      throw new Error("unknown curve " + l.data.algorithm.curve.join("."));
    var p = new i(h), v = l.data.subjectPrivateKey.data;
    return p.verify(o, u, v);
  }
  function s(u, o, l) {
    var h = l.data.p, p = l.data.q, v = l.data.g, y = l.data.pub_key, w = r.signature.decode(u, "der"), x = w.s, A = w.r;
    c(x, p), c(A, p);
    var R = t.mont(h), M = x.invm(p), D = v.toRed(R).redPow(new t(o).mul(M).mod(p)).fromRed().mul(y.toRed(R).redPow(A.mul(M).mod(p)).fromRed()).mod(h).mod(p);
    return D.cmp(A) === 0;
  }
  function c(u, o) {
    if (u.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (u.cmp(o) >= 0)
      throw new Error("invalid sig");
  }
  return oo = a, oo;
}
var uo, hh;
function by() {
  if (hh)
    return uo;
  hh = 1;
  var e = He().Buffer, t = $i(), i = Lv(), r = Ae(), n = yy(), a = gy(), f = bd;
  Object.keys(f).forEach(function(l) {
    f[l].id = e.from(f[l].id, "hex"), f[l.toLowerCase()] = f[l];
  });
  function s(l) {
    i.Writable.call(this);
    var h = f[l];
    if (!h)
      throw new Error("Unknown message digest");
    this._hashType = h.hash, this._hash = t(h.hash), this._tag = h.id, this._signType = h.sign;
  }
  r(s, i.Writable), s.prototype._write = function(h, p, v) {
    this._hash.update(h), v();
  }, s.prototype.update = function(h, p) {
    return this._hash.update(typeof h == "string" ? e.from(h, p) : h), this;
  }, s.prototype.sign = function(h, p) {
    this.end();
    var v = this._hash.digest(), y = n(v, h, this._hashType, this._signType, this._tag);
    return p ? y.toString(p) : y;
  };
  function c(l) {
    i.Writable.call(this);
    var h = f[l];
    if (!h)
      throw new Error("Unknown message digest");
    this._hash = t(h.hash), this._tag = h.id, this._signType = h.sign;
  }
  r(c, i.Writable), c.prototype._write = function(h, p, v) {
    this._hash.update(h), v();
  }, c.prototype.update = function(h, p) {
    return this._hash.update(typeof h == "string" ? e.from(h, p) : h), this;
  }, c.prototype.verify = function(h, p, v) {
    var y = typeof p == "string" ? e.from(p, v) : p;
    this.end();
    var w = this._hash.digest();
    return a(y, w, h, this._signType, this._tag);
  };
  function u(l) {
    return new s(l);
  }
  function o(l) {
    return new c(l);
  }
  return uo = {
    Sign: u,
    Verify: o,
    createSign: u,
    createVerify: o
  }, uo;
}
var co, dh;
function my() {
  if (dh)
    return co;
  dh = 1;
  var e = l0(), t = jt();
  co = function(f) {
    return new r(f);
  };
  var i = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  i.p224 = i.secp224r1, i.p256 = i.secp256r1 = i.prime256v1, i.p192 = i.secp192r1 = i.prime192v1, i.p384 = i.secp384r1, i.p521 = i.secp521r1;
  function r(a) {
    this.curveType = i[a], this.curveType || (this.curveType = {
      name: a
    }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
  }
  r.prototype.generateKeys = function(a, f) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(a, f);
  }, r.prototype.computeSecret = function(a, f, s) {
    f = f || "utf8", fe.Buffer.isBuffer(a) || (a = new fe.Buffer(a, f));
    var c = this.curve.keyFromPublic(a).getPublic(), u = c.mul(this.keys.getPrivate()).getX();
    return n(u, s, this.curveType.byteLength);
  }, r.prototype.getPublicKey = function(a, f) {
    var s = this.keys.getPublic(f === "compressed", !0);
    return f === "hybrid" && (s[s.length - 1] % 2 ? s[0] = 7 : s[0] = 6), n(s, a);
  }, r.prototype.getPrivateKey = function(a) {
    return n(this.keys.getPrivate(), a);
  }, r.prototype.setPublicKey = function(a, f) {
    return f = f || "utf8", fe.Buffer.isBuffer(a) || (a = new fe.Buffer(a, f)), this.keys._importPublic(a), this;
  }, r.prototype.setPrivateKey = function(a, f) {
    f = f || "utf8", fe.Buffer.isBuffer(a) || (a = new fe.Buffer(a, f));
    var s = new t(a);
    return s = s.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(s), this;
  };
  function n(a, f, s) {
    Array.isArray(a) || (a = a.toArray());
    var c = new fe.Buffer(a);
    if (s && c.length < s) {
      var u = new fe.Buffer(s - c.length);
      u.fill(0), c = fe.Buffer.concat([u, c]);
    }
    return f ? c.toString(f) : c;
  }
  return co;
}
var lo = {}, ho, ph;
function Gd() {
  if (ph)
    return ho;
  ph = 1;
  var e = $i(), t = He().Buffer;
  ho = function(r, n) {
    for (var a = t.alloc(0), f = 0, s; a.length < n; )
      s = i(f++), a = t.concat([a, e("sha1").update(r).update(s).digest()]);
    return a.slice(0, n);
  };
  function i(r) {
    var n = t.allocUnsafe(4);
    return n.writeUInt32BE(r, 0), n;
  }
  return ho;
}
var po, vh;
function $d() {
  return vh || (vh = 1, po = function(t, i) {
    for (var r = t.length, n = -1; ++n < r; )
      t[n] ^= i[n];
    return t;
  }), po;
}
var vo, yh;
function Wd() {
  if (yh)
    return vo;
  yh = 1;
  var e = jt(), t = He().Buffer;
  function i(r, n) {
    return t.from(r.toRed(e.mont(n.modulus)).redPow(new e(n.publicExponent)).fromRed().toArray());
  }
  return vo = i, vo;
}
var yo, gh;
function xy() {
  if (gh)
    return yo;
  gh = 1;
  var e = za(), t = wi(), i = $i(), r = Gd(), n = $d(), a = jt(), f = Wd(), s = o0(), c = He().Buffer;
  yo = function(p, v, y) {
    var w;
    p.padding ? w = p.padding : y ? w = 1 : w = 4;
    var x = e(p), A;
    if (w === 4)
      A = u(x, v);
    else if (w === 1)
      A = o(x, v, y);
    else if (w === 3) {
      if (A = new a(v), A.cmp(x.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return y ? s(A, x) : f(A, x);
  };
  function u(h, p) {
    var v = h.modulus.byteLength(), y = p.length, w = i("sha1").update(c.alloc(0)).digest(), x = w.length, A = 2 * x;
    if (y > v - A - 2)
      throw new Error("message too long");
    var R = c.alloc(v - y - A - 2), M = v - x - 1, D = t(x), U = n(c.concat([w, R, c.alloc(1, 1), p], M), r(D, M)), z = n(D, r(U, x));
    return new a(c.concat([c.alloc(1), z, U], v));
  }
  function o(h, p, v) {
    var y = p.length, w = h.modulus.byteLength();
    if (y > w - 11)
      throw new Error("message too long");
    var x;
    return v ? x = c.alloc(w - y - 3, 255) : x = l(w - y - 3), new a(c.concat([c.from([0, v ? 1 : 2]), x, c.alloc(1), p], w));
  }
  function l(h) {
    for (var p = c.allocUnsafe(h), v = 0, y = t(h * 2), w = 0, x; v < h; )
      w === y.length && (y = t(h * 2), w = 0), x = y[w++], x && (p[v++] = x);
    return p;
  }
  return yo;
}
var go, bh;
function _y() {
  if (bh)
    return go;
  bh = 1;
  var e = za(), t = Gd(), i = $d(), r = jt(), n = o0(), a = $i(), f = Wd(), s = He().Buffer;
  go = function(h, p, v) {
    var y;
    h.padding ? y = h.padding : v ? y = 1 : y = 4;
    var w = e(h), x = w.modulus.byteLength();
    if (p.length > x || new r(p).cmp(w.modulus) >= 0)
      throw new Error("decryption error");
    var A;
    v ? A = f(new r(p), w) : A = n(p, w);
    var R = s.alloc(x - A.length);
    if (A = s.concat([R, A], x), y === 4)
      return c(w, A);
    if (y === 1)
      return u(w, A, v);
    if (y === 3)
      return A;
    throw new Error("unknown padding");
  };
  function c(l, h) {
    var p = l.modulus.byteLength(), v = a("sha1").update(s.alloc(0)).digest(), y = v.length;
    if (h[0] !== 0)
      throw new Error("decryption error");
    var w = h.slice(1, y + 1), x = h.slice(y + 1), A = i(w, t(x, y)), R = i(x, t(A, p - y - 1));
    if (o(v, R.slice(0, y)))
      throw new Error("decryption error");
    for (var M = y; R[M] === 0; )
      M++;
    if (R[M++] !== 1)
      throw new Error("decryption error");
    return R.slice(M);
  }
  function u(l, h, p) {
    for (var v = h.slice(0, 2), y = 2, w = 0; h[y++] !== 0; )
      if (y >= h.length) {
        w++;
        break;
      }
    var x = h.slice(2, y - 1);
    if ((v.toString("hex") !== "0002" && !p || v.toString("hex") !== "0001" && p) && w++, x.length < 8 && w++, w)
      throw new Error("decryption error");
    return h.slice(y);
  }
  function o(l, h) {
    l = s.from(l), h = s.from(h);
    var p = 0, v = l.length;
    l.length !== h.length && (p++, v = Math.min(l.length, h.length));
    for (var y = -1; ++y < v; )
      p += l[y] ^ h[y];
    return p;
  }
  return go;
}
var mh;
function Sy() {
  return mh || (mh = 1, function(e) {
    e.publicEncrypt = xy(), e.privateDecrypt = _y(), e.privateEncrypt = function(i, r) {
      return e.publicEncrypt(i, r, !0);
    }, e.publicDecrypt = function(i, r) {
      return e.privateDecrypt(i, r, !0);
    };
  }(lo)), lo;
}
var di = {}, xh;
function Ey() {
  if (xh)
    return di;
  xh = 1;
  function e() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var t = He(), i = wi(), r = t.Buffer, n = t.kMaxLength, a = Ge.crypto || Ge.msCrypto, f = Math.pow(2, 32) - 1;
  function s(h, p) {
    if (typeof h != "number" || h !== h)
      throw new TypeError("offset must be a number");
    if (h > f || h < 0)
      throw new TypeError("offset must be a uint32");
    if (h > n || h > p)
      throw new RangeError("offset out of range");
  }
  function c(h, p, v) {
    if (typeof h != "number" || h !== h)
      throw new TypeError("size must be a number");
    if (h > f || h < 0)
      throw new TypeError("size must be a uint32");
    if (h + p > v || h > n)
      throw new RangeError("buffer too small");
  }
  a && a.getRandomValues || !fe.process.browser ? (di.randomFill = u, di.randomFillSync = l) : (di.randomFill = e, di.randomFillSync = e);
  function u(h, p, v, y) {
    if (!r.isBuffer(h) && !(h instanceof Ge.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof p == "function")
      y = p, p = 0, v = h.length;
    else if (typeof v == "function")
      y = v, v = h.length - p;
    else if (typeof y != "function")
      throw new TypeError('"cb" argument must be a function');
    return s(p, h.length), c(v, p, h.length), o(h, p, v, y);
  }
  function o(h, p, v, y) {
    if (fe.process.browser) {
      var w = h.buffer, x = new Uint8Array(w, p, v);
      if (a.getRandomValues(x), y) {
        fe.process.nextTick(function() {
          y(null, h);
        });
        return;
      }
      return h;
    }
    if (y) {
      i(v, function(R, M) {
        if (R)
          return y(R);
        M.copy(h, p), y(null, h);
      });
      return;
    }
    var A = i(v);
    return A.copy(h, p), h;
  }
  function l(h, p, v) {
    if (typeof p > "u" && (p = 0), !r.isBuffer(h) && !(h instanceof Ge.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return s(p, h.length), v === void 0 && (v = h.length - p), c(v, p, h.length), o(h, p, v);
  }
  return di;
}
var _h;
function Ga() {
  if (_h)
    return Ve;
  _h = 1, Ve.randomBytes = Ve.rng = Ve.pseudoRandomBytes = Ve.prng = wi(), Ve.createHash = Ve.Hash = $i(), Ve.createHmac = Ve.Hmac = gd();
  var e = tv(), t = Object.keys(e), i = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(t);
  Ve.getHashes = function() {
    return i;
  };
  var r = Ed();
  Ve.pbkdf2 = r.pbkdf2, Ve.pbkdf2Sync = r.pbkdf2Sync;
  var n = xv();
  Ve.Cipher = n.Cipher, Ve.createCipher = n.createCipher, Ve.Cipheriv = n.Cipheriv, Ve.createCipheriv = n.createCipheriv, Ve.Decipher = n.Decipher, Ve.createDecipher = n.createDecipher, Ve.Decipheriv = n.Decipheriv, Ve.createDecipheriv = n.createDecipheriv, Ve.getCiphers = n.getCiphers, Ve.listCiphers = n.listCiphers;
  var a = Mv();
  Ve.DiffieHellmanGroup = a.DiffieHellmanGroup, Ve.createDiffieHellmanGroup = a.createDiffieHellmanGroup, Ve.getDiffieHellman = a.getDiffieHellman, Ve.createDiffieHellman = a.createDiffieHellman, Ve.DiffieHellman = a.DiffieHellman;
  var f = by();
  Ve.createSign = f.createSign, Ve.Sign = f.Sign, Ve.createVerify = f.createVerify, Ve.Verify = f.Verify, Ve.createECDH = my();
  var s = Sy();
  Ve.publicEncrypt = s.publicEncrypt, Ve.privateEncrypt = s.privateEncrypt, Ve.publicDecrypt = s.publicDecrypt, Ve.privateDecrypt = s.privateDecrypt;
  var c = Ey();
  return Ve.randomFill = c.randomFill, Ve.randomFillSync = c.randomFillSync, Ve.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, Ve.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, Ve;
}
var Gt = je, wy = Gt.pkcs5 = Gt.pkcs5 || {}, Er;
Gt.util.isNodejs && !Gt.options.usePureJavaScript && (Er = Ga());
Gt.pbkdf2 = wy.pbkdf2 = function(e, t, i, r, n, a) {
  if (typeof n == "function" && (a = n, n = null), Gt.util.isNodejs && !Gt.options.usePureJavaScript && Er.pbkdf2 && (n === null || typeof n != "object") && (Er.pbkdf2Sync.length > 4 || !n || n === "sha1"))
    return typeof n != "string" && (n = "sha1"), e = fe.Buffer.from(e, "binary"), t = fe.Buffer.from(t, "binary"), a ? Er.pbkdf2Sync.length === 4 ? Er.pbkdf2(e, t, i, r, function(R, M) {
      if (R)
        return a(R);
      a(null, M.toString("binary"));
    }) : Er.pbkdf2(e, t, i, r, n, function(R, M) {
      if (R)
        return a(R);
      a(null, M.toString("binary"));
    }) : Er.pbkdf2Sync.length === 4 ? Er.pbkdf2Sync(e, t, i, r).toString("binary") : Er.pbkdf2Sync(e, t, i, r, n).toString("binary");
  if ((typeof n > "u" || n === null) && (n = "sha1"), typeof n == "string") {
    if (!(n in Gt.md.algorithms))
      throw new Error("Unknown hash algorithm: " + n);
    n = Gt.md[n].create();
  }
  var f = n.digestLength;
  if (r > 4294967295 * f) {
    var s = new Error("Derived key is too long.");
    if (a)
      return a(s);
    throw s;
  }
  var c = Math.ceil(r / f), u = r - (c - 1) * f, o = Gt.hmac.create();
  o.start(n, e);
  var l = "", h, p, v;
  if (!a) {
    for (var y = 1; y <= c; ++y) {
      o.start(null, null), o.update(t), o.update(Gt.util.int32ToBytes(y)), h = v = o.digest().getBytes();
      for (var w = 2; w <= i; ++w)
        o.start(null, null), o.update(v), p = o.digest().getBytes(), h = Gt.util.xorBytes(h, p, f), v = p;
      l += y < c ? h : h.substr(0, u);
    }
    return l;
  }
  var y = 1, w;
  function x() {
    if (y > c)
      return a(null, l);
    o.start(null, null), o.update(t), o.update(Gt.util.int32ToBytes(y)), h = v = o.digest().getBytes(), w = 2, A();
  }
  function A() {
    if (w <= i)
      return o.start(null, null), o.update(v), p = o.digest().getBytes(), h = Gt.util.xorBytes(h, p, f), v = p, ++w, Gt.util.setImmediate(A);
    l += y < c ? h : h.substr(0, u), ++y, x();
  }
  x();
};
var br = je, Qd = br.sha256 = br.sha256 || {};
br.md.sha256 = br.md.algorithms.sha256 = Qd;
Qd.create = function() {
  Yd || Cy();
  var e = null, t = br.util.createBuffer(), i = new Array(64), r = {
    algorithm: "sha256",
    blockLength: 64,
    digestLength: 32,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var n = r.messageLengthSize / 4, a = 0; a < n; ++a)
      r.fullMessageLength.push(0);
    return t = br.util.createBuffer(), e = {
      h0: 1779033703,
      h1: 3144134277,
      h2: 1013904242,
      h3: 2773480762,
      h4: 1359893119,
      h5: 2600822924,
      h6: 528734635,
      h7: 1541459225
    }, r;
  }, r.start(), r.update = function(n, a) {
    a === "utf8" && (n = br.util.encodeUtf8(n));
    var f = n.length;
    r.messageLength += f, f = [f / 4294967296 >>> 0, f >>> 0];
    for (var s = r.fullMessageLength.length - 1; s >= 0; --s)
      r.fullMessageLength[s] += f[1], f[1] = f[0] + (r.fullMessageLength[s] / 4294967296 >>> 0), r.fullMessageLength[s] = r.fullMessageLength[s] >>> 0, f[0] = f[1] / 4294967296 >>> 0;
    return t.putBytes(n), Sh(e, i, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var n = br.util.createBuffer();
    n.putBytes(t.bytes());
    var a = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, f = a & r.blockLength - 1;
    n.putBytes(Io.substr(0, r.blockLength - f));
    for (var s, c, u = r.fullMessageLength[0] * 8, o = 0; o < r.fullMessageLength.length - 1; ++o)
      s = r.fullMessageLength[o + 1] * 8, c = s / 4294967296 >>> 0, u += c, n.putInt32(u >>> 0), u = s >>> 0;
    n.putInt32(u);
    var l = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3,
      h4: e.h4,
      h5: e.h5,
      h6: e.h6,
      h7: e.h7
    };
    Sh(l, i, n);
    var h = br.util.createBuffer();
    return h.putInt32(l.h0), h.putInt32(l.h1), h.putInt32(l.h2), h.putInt32(l.h3), h.putInt32(l.h4), h.putInt32(l.h5), h.putInt32(l.h6), h.putInt32(l.h7), h;
  }, r;
};
var Io = null, Yd = !1, Xd = null;
function Cy() {
  Io = "", Io += br.util.fillString("\0", 64), Xd = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], Yd = !0;
}
function Sh(e, t, i) {
  for (var r, n, a, f, s, c, u, o, l, h, p, v, y, w, x, A = i.length(); A >= 64; ) {
    for (u = 0; u < 16; ++u)
      t[u] = i.getInt32();
    for (; u < 64; ++u)
      r = t[u - 2], r = (r >>> 17 | r << 15) ^ (r >>> 19 | r << 13) ^ r >>> 10, n = t[u - 15], n = (n >>> 7 | n << 25) ^ (n >>> 18 | n << 14) ^ n >>> 3, t[u] = r + t[u - 7] + n + t[u - 16] | 0;
    for (o = e.h0, l = e.h1, h = e.h2, p = e.h3, v = e.h4, y = e.h5, w = e.h6, x = e.h7, u = 0; u < 64; ++u)
      f = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7), s = w ^ v & (y ^ w), a = (o >>> 2 | o << 30) ^ (o >>> 13 | o << 19) ^ (o >>> 22 | o << 10), c = o & l | h & (o ^ l), r = x + f + s + Xd[u] + t[u], n = a + c, x = w, w = y, y = v, v = p + r >>> 0, p = h, h = l, l = o, o = r + n >>> 0;
    e.h0 = e.h0 + o | 0, e.h1 = e.h1 + l | 0, e.h2 = e.h2 + h | 0, e.h3 = e.h3 + p | 0, e.h4 = e.h4 + v | 0, e.h5 = e.h5 + y | 0, e.h6 = e.h6 + w | 0, e.h7 = e.h7 + x | 0, A -= 64;
  }
}
var vr = je, Sa = null;
vr.util.isNodejs && !vr.options.usePureJavaScript && !fe.process.versions["node-webkit"] && (Sa = Ga());
var Ay = vr.prng = vr.prng || {};
Ay.create = function(e) {
  for (var t = {
    plugin: e,
    key: null,
    seed: null,
    time: null,
    // number of reseeds so far
    reseeds: 0,
    // amount of data generated so far
    generated: 0,
    // no initial key bytes
    keyBytes: ""
  }, i = e.md, r = new Array(32), n = 0; n < 32; ++n)
    r[n] = i.create();
  t.pools = r, t.pool = 0, t.generate = function(u, o) {
    if (!o)
      return t.generateSync(u);
    var l = t.plugin.cipher, h = t.plugin.increment, p = t.plugin.formatKey, v = t.plugin.formatSeed, y = vr.util.createBuffer();
    t.key = null, w();
    function w(x) {
      if (x)
        return o(x);
      if (y.length() >= u)
        return o(null, y.getBytes(u));
      if (t.generated > 1048575 && (t.key = null), t.key === null)
        return vr.util.nextTick(function() {
          a(w);
        });
      var A = l(t.key, t.seed);
      t.generated += A.length, y.putBytes(A), t.key = p(l(t.key, h(t.seed))), t.seed = v(l(t.key, t.seed)), vr.util.setImmediate(w);
    }
  }, t.generateSync = function(u) {
    var o = t.plugin.cipher, l = t.plugin.increment, h = t.plugin.formatKey, p = t.plugin.formatSeed;
    t.key = null;
    for (var v = vr.util.createBuffer(); v.length() < u; ) {
      t.generated > 1048575 && (t.key = null), t.key === null && f();
      var y = o(t.key, t.seed);
      t.generated += y.length, v.putBytes(y), t.key = h(o(t.key, l(t.seed))), t.seed = p(o(t.key, t.seed));
    }
    return v.getBytes(u);
  };
  function a(u) {
    if (t.pools[0].messageLength >= 32)
      return s(), u();
    var o = 32 - t.pools[0].messageLength << 5;
    t.seedFile(o, function(l, h) {
      if (l)
        return u(l);
      t.collect(h), s(), u();
    });
  }
  function f() {
    if (t.pools[0].messageLength >= 32)
      return s();
    var u = 32 - t.pools[0].messageLength << 5;
    t.collect(t.seedFileSync(u)), s();
  }
  function s() {
    t.reseeds = t.reseeds === 4294967295 ? 0 : t.reseeds + 1;
    var u = t.plugin.md.create();
    u.update(t.keyBytes);
    for (var o = 1, l = 0; l < 32; ++l)
      t.reseeds % o === 0 && (u.update(t.pools[l].digest().getBytes()), t.pools[l].start()), o = o << 1;
    t.keyBytes = u.digest().getBytes(), u.start(), u.update(t.keyBytes);
    var h = u.digest().getBytes();
    t.key = t.plugin.formatKey(t.keyBytes), t.seed = t.plugin.formatSeed(h), t.generated = 0;
  }
  function c(u) {
    var o = null, l = vr.util.globalScope, h = l.crypto || l.msCrypto;
    h && h.getRandomValues && (o = function(D) {
      return h.getRandomValues(D);
    });
    var p = vr.util.createBuffer();
    if (o)
      for (; p.length() < u; ) {
        var v = Math.max(1, Math.min(u - p.length(), 65536) / 4), y = new Uint32Array(Math.floor(v));
        try {
          o(y);
          for (var w = 0; w < y.length; ++w)
            p.putInt32(y[w]);
        } catch (D) {
          if (!(typeof QuotaExceededError < "u" && D instanceof QuotaExceededError))
            throw D;
        }
      }
    if (p.length() < u)
      for (var x, A, R, M = Math.floor(Math.random() * 65536); p.length() < u; ) {
        A = 16807 * (M & 65535), x = 16807 * (M >> 16), A += (x & 32767) << 16, A += x >> 15, A = (A & 2147483647) + (A >> 31), M = A & 4294967295;
        for (var w = 0; w < 3; ++w)
          R = M >>> (w << 3), R ^= Math.floor(Math.random() * 256), p.putByte(R & 255);
      }
    return p.getBytes(u);
  }
  return Sa ? (t.seedFile = function(u, o) {
    Sa.randomBytes(u, function(l, h) {
      if (l)
        return o(l);
      o(null, h.toString());
    });
  }, t.seedFileSync = function(u) {
    return Sa.randomBytes(u).toString();
  }) : (t.seedFile = function(u, o) {
    try {
      o(null, c(u));
    } catch (l) {
      o(l);
    }
  }, t.seedFileSync = c), t.collect = function(u) {
    for (var o = u.length, l = 0; l < o; ++l)
      t.pools[t.pool].update(u.substr(l, 1)), t.pool = t.pool === 31 ? 0 : t.pool + 1;
  }, t.collectInt = function(u, o) {
    for (var l = "", h = 0; h < o; h += 8)
      l += String.fromCharCode(u >> h & 255);
    t.collect(l);
  }, t.registerWorker = function(u) {
    if (u === self)
      t.seedFile = function(l, h) {
        function p(v) {
          var y = v.data;
          y.forge && y.forge.prng && (self.removeEventListener("message", p), h(y.forge.prng.err, y.forge.prng.bytes));
        }
        self.addEventListener("message", p), self.postMessage({ forge: { prng: { needed: l } } });
      };
    else {
      var o = function(l) {
        var h = l.data;
        h.forge && h.forge.prng && t.seedFile(h.forge.prng.needed, function(p, v) {
          u.postMessage({ forge: { prng: { err: p, bytes: v } } });
        });
      };
      u.addEventListener("message", o);
    }
  }, t;
};
var Pt = je;
(function() {
  if (Pt.random && Pt.random.getBytes) {
    Pt.random;
    return;
  }
  (function(e) {
    var t = {}, i = new Array(4), r = Pt.util.createBuffer();
    t.formatKey = function(l) {
      var h = Pt.util.createBuffer(l);
      return l = new Array(4), l[0] = h.getInt32(), l[1] = h.getInt32(), l[2] = h.getInt32(), l[3] = h.getInt32(), Pt.aes._expandKey(l, !1);
    }, t.formatSeed = function(l) {
      var h = Pt.util.createBuffer(l);
      return l = new Array(4), l[0] = h.getInt32(), l[1] = h.getInt32(), l[2] = h.getInt32(), l[3] = h.getInt32(), l;
    }, t.cipher = function(l, h) {
      return Pt.aes._updateBlock(l, h, i, !1), r.putInt32(i[0]), r.putInt32(i[1]), r.putInt32(i[2]), r.putInt32(i[3]), r.getBytes();
    }, t.increment = function(l) {
      return ++l[3], l;
    }, t.md = Pt.md.sha256;
    function n() {
      var l = Pt.prng.create(t);
      return l.getBytes = function(h, p) {
        return l.generate(h, p);
      }, l.getBytesSync = function(h) {
        return l.generate(h);
      }, l;
    }
    var a = n(), f = null, s = Pt.util.globalScope, c = s.crypto || s.msCrypto;
    if (c && c.getRandomValues && (f = function(l) {
      return c.getRandomValues(l);
    }), Pt.options.usePureJavaScript || !Pt.util.isNodejs && !f) {
      if (a.collectInt(+/* @__PURE__ */ new Date(), 32), typeof navigator < "u") {
        var u = "";
        for (var o in navigator)
          try {
            typeof navigator[o] == "string" && (u += navigator[o]);
          } catch {
          }
        a.collect(u), u = null;
      }
      e && (e().mousemove(function(l) {
        a.collectInt(l.clientX, 16), a.collectInt(l.clientY, 16);
      }), e().keypress(function(l) {
        a.collectInt(l.charCode, 8);
      }));
    }
    if (!Pt.random)
      Pt.random = a;
    else
      for (var o in a)
        Pt.random[o] = a[o];
    Pt.random.createInstance = n, Pt.random;
  })(typeof jQuery < "u" ? jQuery : null);
})();
var Qt = je, bo = [
  217,
  120,
  249,
  196,
  25,
  221,
  181,
  237,
  40,
  233,
  253,
  121,
  74,
  160,
  216,
  157,
  198,
  126,
  55,
  131,
  43,
  118,
  83,
  142,
  98,
  76,
  100,
  136,
  68,
  139,
  251,
  162,
  23,
  154,
  89,
  245,
  135,
  179,
  79,
  19,
  97,
  69,
  109,
  141,
  9,
  129,
  125,
  50,
  189,
  143,
  64,
  235,
  134,
  183,
  123,
  11,
  240,
  149,
  33,
  34,
  92,
  107,
  78,
  130,
  84,
  214,
  101,
  147,
  206,
  96,
  178,
  28,
  115,
  86,
  192,
  20,
  167,
  140,
  241,
  220,
  18,
  117,
  202,
  31,
  59,
  190,
  228,
  209,
  66,
  61,
  212,
  48,
  163,
  60,
  182,
  38,
  111,
  191,
  14,
  218,
  70,
  105,
  7,
  87,
  39,
  242,
  29,
  155,
  188,
  148,
  67,
  3,
  248,
  17,
  199,
  246,
  144,
  239,
  62,
  231,
  6,
  195,
  213,
  47,
  200,
  102,
  30,
  215,
  8,
  232,
  234,
  222,
  128,
  82,
  238,
  247,
  132,
  170,
  114,
  172,
  53,
  77,
  106,
  42,
  150,
  26,
  210,
  113,
  90,
  21,
  73,
  116,
  75,
  159,
  208,
  94,
  4,
  24,
  164,
  236,
  194,
  224,
  65,
  110,
  15,
  81,
  203,
  204,
  36,
  145,
  175,
  80,
  161,
  244,
  112,
  57,
  153,
  124,
  58,
  133,
  35,
  184,
  180,
  122,
  252,
  2,
  54,
  91,
  37,
  85,
  151,
  49,
  45,
  93,
  250,
  152,
  227,
  138,
  146,
  174,
  5,
  223,
  41,
  16,
  103,
  108,
  186,
  201,
  211,
  0,
  230,
  207,
  225,
  158,
  168,
  44,
  99,
  22,
  1,
  63,
  88,
  226,
  137,
  169,
  13,
  56,
  52,
  27,
  171,
  51,
  255,
  176,
  187,
  72,
  12,
  95,
  185,
  177,
  205,
  46,
  197,
  243,
  219,
  71,
  229,
  165,
  156,
  119,
  10,
  166,
  32,
  104,
  254,
  127,
  193,
  173
], Eh = [1, 2, 3, 5], By = function(e, t) {
  return e << t & 65535 | (e & 65535) >> 16 - t;
}, Ty = function(e, t) {
  return (e & 65535) >> t | e << 16 - t & 65535;
};
Qt.rc2 = Qt.rc2 || {};
Qt.rc2.expandKey = function(e, t) {
  typeof e == "string" && (e = Qt.util.createBuffer(e)), t = t || 128;
  var i = e, r = e.length(), n = t, a = Math.ceil(n / 8), f = 255 >> (n & 7), s;
  for (s = r; s < 128; s++)
    i.putByte(bo[i.at(s - 1) + i.at(s - r) & 255]);
  for (i.setAt(128 - a, bo[i.at(128 - a) & f]), s = 127 - a; s >= 0; s--)
    i.setAt(s, bo[i.at(s + 1) ^ i.at(s + a)]);
  return i;
};
var Zd = function(e, t, i) {
  var r = !1, n = null, a = null, f = null, s, c, u, o, l = [];
  for (e = Qt.rc2.expandKey(e, t), u = 0; u < 64; u++)
    l.push(e.getInt16Le());
  i ? (s = function(v) {
    for (u = 0; u < 4; u++)
      v[u] += l[o] + (v[(u + 3) % 4] & v[(u + 2) % 4]) + (~v[(u + 3) % 4] & v[(u + 1) % 4]), v[u] = By(v[u], Eh[u]), o++;
  }, c = function(v) {
    for (u = 0; u < 4; u++)
      v[u] += l[v[(u + 3) % 4] & 63];
  }) : (s = function(v) {
    for (u = 3; u >= 0; u--)
      v[u] = Ty(v[u], Eh[u]), v[u] -= l[o] + (v[(u + 3) % 4] & v[(u + 2) % 4]) + (~v[(u + 3) % 4] & v[(u + 1) % 4]), o--;
  }, c = function(v) {
    for (u = 3; u >= 0; u--)
      v[u] -= l[v[(u + 3) % 4] & 63];
  });
  var h = function(v) {
    var y = [];
    for (u = 0; u < 4; u++) {
      var w = n.getInt16Le();
      f !== null && (i ? w ^= f.getInt16Le() : f.putInt16Le(w)), y.push(w & 65535);
    }
    o = i ? 0 : 63;
    for (var x = 0; x < v.length; x++)
      for (var A = 0; A < v[x][0]; A++)
        v[x][1](y);
    for (u = 0; u < 4; u++)
      f !== null && (i ? f.putInt16Le(y[u]) : y[u] ^= f.getInt16Le()), a.putInt16Le(y[u]);
  }, p = null;
  return p = {
    /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */
    start: function(v, y) {
      v && typeof v == "string" && (v = Qt.util.createBuffer(v)), r = !1, n = Qt.util.createBuffer(), a = y || new Qt.util.createBuffer(), f = v, p.output = a;
    },
    /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */
    update: function(v) {
      for (r || n.putBuffer(v); n.length() >= 8; )
        h([
          [5, s],
          [1, c],
          [6, s],
          [1, c],
          [5, s]
        ]);
    },
    /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */
    finish: function(v) {
      var y = !0;
      if (i)
        if (v)
          y = v(8, n, !i);
        else {
          var w = n.length() === 8 ? 8 : 8 - n.length();
          n.fillWithByte(w, w);
        }
      if (y && (r = !0, p.update()), !i && (y = n.length() === 0, y))
        if (v)
          y = v(8, a, !i);
        else {
          var x = a.length(), A = a.at(x - 1);
          A > x ? y = !1 : a.truncate(A);
        }
      return y;
    }
  }, p;
};
Qt.rc2.startEncrypting = function(e, t, i) {
  var r = Qt.rc2.createEncryptionCipher(e, 128);
  return r.start(t, i), r;
};
Qt.rc2.createEncryptionCipher = function(e, t) {
  return Zd(e, t, !0);
};
Qt.rc2.startDecrypting = function(e, t, i) {
  var r = Qt.rc2.createDecryptionCipher(e, 128);
  return r.start(t, i), r;
};
Qt.rc2.createDecryptionCipher = function(e, t) {
  return Zd(e, t, !1);
};
var Ro = je;
Ro.jsbn = Ro.jsbn || {};
var Cr;
function ue(e, t, i) {
  this.data = [], e != null && (typeof e == "number" ? this.fromNumber(e, t, i) : t == null && typeof e != "string" ? this.fromString(e, 256) : this.fromString(e, t));
}
Ro.jsbn.BigInteger = ue;
function Je() {
  return new ue(null);
}
function Iy(e, t, i, r, n, a) {
  for (; --a >= 0; ) {
    var f = t * this.data[e++] + i.data[r] + n;
    n = Math.floor(f / 67108864), i.data[r++] = f & 67108863;
  }
  return n;
}
function Ry(e, t, i, r, n, a) {
  for (var f = t & 32767, s = t >> 15; --a >= 0; ) {
    var c = this.data[e] & 32767, u = this.data[e++] >> 15, o = s * c + u * f;
    c = f * c + ((o & 32767) << 15) + i.data[r] + (n & 1073741823), n = (c >>> 30) + (o >>> 15) + s * u + (n >>> 30), i.data[r++] = c & 1073741823;
  }
  return n;
}
function wh(e, t, i, r, n, a) {
  for (var f = t & 16383, s = t >> 14; --a >= 0; ) {
    var c = this.data[e] & 16383, u = this.data[e++] >> 14, o = s * c + u * f;
    c = f * c + ((o & 16383) << 14) + i.data[r] + n, n = (c >> 28) + (o >> 14) + s * u, i.data[r++] = c & 268435455;
  }
  return n;
}
typeof navigator > "u" ? (ue.prototype.am = wh, Cr = 28) : navigator.appName == "Microsoft Internet Explorer" ? (ue.prototype.am = Ry, Cr = 30) : navigator.appName != "Netscape" ? (ue.prototype.am = Iy, Cr = 26) : (ue.prototype.am = wh, Cr = 28);
ue.prototype.DB = Cr;
ue.prototype.DM = (1 << Cr) - 1;
ue.prototype.DV = 1 << Cr;
var h0 = 52;
ue.prototype.FV = Math.pow(2, h0);
ue.prototype.F1 = h0 - Cr;
ue.prototype.F2 = 2 * Cr - h0;
var My = "0123456789abcdefghijklmnopqrstuvwxyz", $a = new Array(), Ti, ar;
Ti = 48;
for (ar = 0; ar <= 9; ++ar)
  $a[Ti++] = ar;
Ti = 97;
for (ar = 10; ar < 36; ++ar)
  $a[Ti++] = ar;
Ti = 65;
for (ar = 10; ar < 36; ++ar)
  $a[Ti++] = ar;
function Ch(e) {
  return My.charAt(e);
}
function Jd(e, t) {
  var i = $a[e.charCodeAt(t)];
  return i ?? -1;
}
function Ny(e) {
  for (var t = this.t - 1; t >= 0; --t)
    e.data[t] = this.data[t];
  e.t = this.t, e.s = this.s;
}
function ky(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this.data[0] = e : e < -1 ? this.data[0] = e + this.DV : this.t = 0;
}
function Mr(e) {
  var t = Je();
  return t.fromInt(e), t;
}
function Dy(e, t) {
  var i;
  if (t == 16)
    i = 4;
  else if (t == 8)
    i = 3;
  else if (t == 256)
    i = 8;
  else if (t == 2)
    i = 1;
  else if (t == 32)
    i = 5;
  else if (t == 4)
    i = 2;
  else {
    this.fromRadix(e, t);
    return;
  }
  this.t = 0, this.s = 0;
  for (var r = e.length, n = !1, a = 0; --r >= 0; ) {
    var f = i == 8 ? e[r] & 255 : Jd(e, r);
    if (f < 0) {
      e.charAt(r) == "-" && (n = !0);
      continue;
    }
    n = !1, a == 0 ? this.data[this.t++] = f : a + i > this.DB ? (this.data[this.t - 1] |= (f & (1 << this.DB - a) - 1) << a, this.data[this.t++] = f >> this.DB - a) : this.data[this.t - 1] |= f << a, a += i, a >= this.DB && (a -= this.DB);
  }
  i == 8 && e[0] & 128 && (this.s = -1, a > 0 && (this.data[this.t - 1] |= (1 << this.DB - a) - 1 << a)), this.clamp(), n && ue.ZERO.subTo(this, this);
}
function Ly() {
  for (var e = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == e; )
    --this.t;
}
function Py(e) {
  if (this.s < 0)
    return "-" + this.negate().toString(e);
  var t;
  if (e == 16)
    t = 4;
  else if (e == 8)
    t = 3;
  else if (e == 2)
    t = 1;
  else if (e == 32)
    t = 5;
  else if (e == 4)
    t = 2;
  else
    return this.toRadix(e);
  var i = (1 << t) - 1, r, n = !1, a = "", f = this.t, s = this.DB - f * this.DB % t;
  if (f-- > 0)
    for (s < this.DB && (r = this.data[f] >> s) > 0 && (n = !0, a = Ch(r)); f >= 0; )
      s < t ? (r = (this.data[f] & (1 << s) - 1) << t - s, r |= this.data[--f] >> (s += this.DB - t)) : (r = this.data[f] >> (s -= t) & i, s <= 0 && (s += this.DB, --f)), r > 0 && (n = !0), n && (a += Ch(r));
  return n ? a : "0";
}
function Uy() {
  var e = Je();
  return ue.ZERO.subTo(this, e), e;
}
function Oy() {
  return this.s < 0 ? this.negate() : this;
}
function qy(e) {
  var t = this.s - e.s;
  if (t != 0)
    return t;
  var i = this.t;
  if (t = i - e.t, t != 0)
    return this.s < 0 ? -t : t;
  for (; --i >= 0; )
    if ((t = this.data[i] - e.data[i]) != 0)
      return t;
  return 0;
}
function Wa(e) {
  var t = 1, i;
  return (i = e >>> 16) != 0 && (e = i, t += 16), (i = e >> 8) != 0 && (e = i, t += 8), (i = e >> 4) != 0 && (e = i, t += 4), (i = e >> 2) != 0 && (e = i, t += 2), (i = e >> 1) != 0 && (e = i, t += 1), t;
}
function Fy() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + Wa(this.data[this.t - 1] ^ this.s & this.DM);
}
function Vy(e, t) {
  var i;
  for (i = this.t - 1; i >= 0; --i)
    t.data[i + e] = this.data[i];
  for (i = e - 1; i >= 0; --i)
    t.data[i] = 0;
  t.t = this.t + e, t.s = this.s;
}
function Ky(e, t) {
  for (var i = e; i < this.t; ++i)
    t.data[i - e] = this.data[i];
  t.t = Math.max(this.t - e, 0), t.s = this.s;
}
function Hy(e, t) {
  var i = e % this.DB, r = this.DB - i, n = (1 << r) - 1, a = Math.floor(e / this.DB), f = this.s << i & this.DM, s;
  for (s = this.t - 1; s >= 0; --s)
    t.data[s + a + 1] = this.data[s] >> r | f, f = (this.data[s] & n) << i;
  for (s = a - 1; s >= 0; --s)
    t.data[s] = 0;
  t.data[a] = f, t.t = this.t + a + 1, t.s = this.s, t.clamp();
}
function jy(e, t) {
  t.s = this.s;
  var i = Math.floor(e / this.DB);
  if (i >= this.t) {
    t.t = 0;
    return;
  }
  var r = e % this.DB, n = this.DB - r, a = (1 << r) - 1;
  t.data[0] = this.data[i] >> r;
  for (var f = i + 1; f < this.t; ++f)
    t.data[f - i - 1] |= (this.data[f] & a) << n, t.data[f - i] = this.data[f] >> r;
  r > 0 && (t.data[this.t - i - 1] |= (this.s & a) << n), t.t = this.t - i, t.clamp();
}
function zy(e, t) {
  for (var i = 0, r = 0, n = Math.min(e.t, this.t); i < n; )
    r += this.data[i] - e.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r -= e.s; i < this.t; )
      r += this.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; i < e.t; )
      r -= e.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
    r -= e.s;
  }
  t.s = r < 0 ? -1 : 0, r < -1 ? t.data[i++] = this.DV + r : r > 0 && (t.data[i++] = r), t.t = i, t.clamp();
}
function Gy(e, t) {
  var i = this.abs(), r = e.abs(), n = i.t;
  for (t.t = n + r.t; --n >= 0; )
    t.data[n] = 0;
  for (n = 0; n < r.t; ++n)
    t.data[n + i.t] = i.am(0, r.data[n], t, n, 0, i.t);
  t.s = 0, t.clamp(), this.s != e.s && ue.ZERO.subTo(t, t);
}
function $y(e) {
  for (var t = this.abs(), i = e.t = 2 * t.t; --i >= 0; )
    e.data[i] = 0;
  for (i = 0; i < t.t - 1; ++i) {
    var r = t.am(i, t.data[i], e, 2 * i, 0, 1);
    (e.data[i + t.t] += t.am(i + 1, 2 * t.data[i], e, 2 * i + 1, r, t.t - i - 1)) >= t.DV && (e.data[i + t.t] -= t.DV, e.data[i + t.t + 1] = 1);
  }
  e.t > 0 && (e.data[e.t - 1] += t.am(i, t.data[i], e, 2 * i, 0, 1)), e.s = 0, e.clamp();
}
function Wy(e, t, i) {
  var r = e.abs();
  if (!(r.t <= 0)) {
    var n = this.abs();
    if (n.t < r.t) {
      t?.fromInt(0), i != null && this.copyTo(i);
      return;
    }
    i == null && (i = Je());
    var a = Je(), f = this.s, s = e.s, c = this.DB - Wa(r.data[r.t - 1]);
    c > 0 ? (r.lShiftTo(c, a), n.lShiftTo(c, i)) : (r.copyTo(a), n.copyTo(i));
    var u = a.t, o = a.data[u - 1];
    if (o != 0) {
      var l = o * (1 << this.F1) + (u > 1 ? a.data[u - 2] >> this.F2 : 0), h = this.FV / l, p = (1 << this.F1) / l, v = 1 << this.F2, y = i.t, w = y - u, x = t ?? Je();
      for (a.dlShiftTo(w, x), i.compareTo(x) >= 0 && (i.data[i.t++] = 1, i.subTo(x, i)), ue.ONE.dlShiftTo(u, x), x.subTo(a, a); a.t < u; )
        a.data[a.t++] = 0;
      for (; --w >= 0; ) {
        var A = i.data[--y] == o ? this.DM : Math.floor(i.data[y] * h + (i.data[y - 1] + v) * p);
        if ((i.data[y] += a.am(0, A, i, w, 0, u)) < A)
          for (a.dlShiftTo(w, x), i.subTo(x, i); i.data[y] < --A; )
            i.subTo(x, i);
      }
      t != null && (i.drShiftTo(u, t), f != s && ue.ZERO.subTo(t, t)), i.t = u, i.clamp(), c > 0 && i.rShiftTo(c, i), f < 0 && ue.ZERO.subTo(i, i);
    }
  }
}
function Qy(e) {
  var t = Je();
  return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(ue.ZERO) > 0 && e.subTo(t, t), t;
}
function ci(e) {
  this.m = e;
}
function Yy(e) {
  return e.s < 0 || e.compareTo(this.m) >= 0 ? e.mod(this.m) : e;
}
function Xy(e) {
  return e;
}
function Zy(e) {
  e.divRemTo(this.m, null, e);
}
function Jy(e, t, i) {
  e.multiplyTo(t, i), this.reduce(i);
}
function e2(e, t) {
  e.squareTo(t), this.reduce(t);
}
ci.prototype.convert = Yy;
ci.prototype.revert = Xy;
ci.prototype.reduce = Zy;
ci.prototype.mulTo = Jy;
ci.prototype.sqrTo = e2;
function t2() {
  if (this.t < 1)
    return 0;
  var e = this.data[0];
  if (!(e & 1))
    return 0;
  var t = e & 3;
  return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function li(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function r2(e) {
  var t = Je();
  return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(ue.ZERO) > 0 && this.m.subTo(t, t), t;
}
function i2(e) {
  var t = Je();
  return e.copyTo(t), this.reduce(t), t;
}
function a2(e) {
  for (; e.t <= this.mt2; )
    e.data[e.t++] = 0;
  for (var t = 0; t < this.m.t; ++t) {
    var i = e.data[t] & 32767, r = i * this.mpl + ((i * this.mph + (e.data[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (i = t + this.m.t, e.data[i] += this.m.am(0, r, e, t, 0, this.m.t); e.data[i] >= e.DV; )
      e.data[i] -= e.DV, e.data[++i]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function n2(e, t) {
  e.squareTo(t), this.reduce(t);
}
function f2(e, t, i) {
  e.multiplyTo(t, i), this.reduce(i);
}
li.prototype.convert = r2;
li.prototype.revert = i2;
li.prototype.reduce = a2;
li.prototype.mulTo = f2;
li.prototype.sqrTo = n2;
function s2() {
  return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
function o2(e, t) {
  if (e > 4294967295 || e < 1)
    return ue.ONE;
  var i = Je(), r = Je(), n = t.convert(this), a = Wa(e) - 1;
  for (n.copyTo(i); --a >= 0; )
    if (t.sqrTo(i, r), (e & 1 << a) > 0)
      t.mulTo(r, n, i);
    else {
      var f = i;
      i = r, r = f;
    }
  return t.revert(i);
}
function u2(e, t) {
  var i;
  return e < 256 || t.isEven() ? i = new ci(t) : i = new li(t), this.exp(e, i);
}
ue.prototype.copyTo = Ny;
ue.prototype.fromInt = ky;
ue.prototype.fromString = Dy;
ue.prototype.clamp = Ly;
ue.prototype.dlShiftTo = Vy;
ue.prototype.drShiftTo = Ky;
ue.prototype.lShiftTo = Hy;
ue.prototype.rShiftTo = jy;
ue.prototype.subTo = zy;
ue.prototype.multiplyTo = Gy;
ue.prototype.squareTo = $y;
ue.prototype.divRemTo = Wy;
ue.prototype.invDigit = t2;
ue.prototype.isEven = s2;
ue.prototype.exp = o2;
ue.prototype.toString = Py;
ue.prototype.negate = Uy;
ue.prototype.abs = Oy;
ue.prototype.compareTo = qy;
ue.prototype.bitLength = Fy;
ue.prototype.mod = Qy;
ue.prototype.modPowInt = u2;
ue.ZERO = Mr(0);
ue.ONE = Mr(1);
function c2() {
  var e = Je();
  return this.copyTo(e), e;
}
function l2() {
  if (this.s < 0) {
    if (this.t == 1)
      return this.data[0] - this.DV;
    if (this.t == 0)
      return -1;
  } else {
    if (this.t == 1)
      return this.data[0];
    if (this.t == 0)
      return 0;
  }
  return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
function h2() {
  return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
function d2() {
  return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
function p2(e) {
  return Math.floor(Math.LN2 * this.DB / Math.log(e));
}
function v2() {
  return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this.data[0] <= 0 ? 0 : 1;
}
function y2(e) {
  if (e == null && (e = 10), this.signum() == 0 || e < 2 || e > 36)
    return "0";
  var t = this.chunkSize(e), i = Math.pow(e, t), r = Mr(i), n = Je(), a = Je(), f = "";
  for (this.divRemTo(r, n, a); n.signum() > 0; )
    f = (i + a.intValue()).toString(e).substr(1) + f, n.divRemTo(r, n, a);
  return a.intValue().toString(e) + f;
}
function g2(e, t) {
  this.fromInt(0), t == null && (t = 10);
  for (var i = this.chunkSize(t), r = Math.pow(t, i), n = !1, a = 0, f = 0, s = 0; s < e.length; ++s) {
    var c = Jd(e, s);
    if (c < 0) {
      e.charAt(s) == "-" && this.signum() == 0 && (n = !0);
      continue;
    }
    f = t * f + c, ++a >= i && (this.dMultiply(r), this.dAddOffset(f, 0), a = 0, f = 0);
  }
  a > 0 && (this.dMultiply(Math.pow(t, a)), this.dAddOffset(f, 0)), n && ue.ZERO.subTo(this, this);
}
function b2(e, t, i) {
  if (typeof t == "number")
    if (e < 2)
      this.fromInt(1);
    else
      for (this.fromNumber(e, i), this.testBit(e - 1) || this.bitwiseTo(ue.ONE.shiftLeft(e - 1), d0, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t); )
        this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(ue.ONE.shiftLeft(e - 1), this);
  else {
    var r = new Array(), n = e & 7;
    r.length = (e >> 3) + 1, t.nextBytes(r), n > 0 ? r[0] &= (1 << n) - 1 : r[0] = 0, this.fromString(r, 256);
  }
}
function m2() {
  var e = this.t, t = new Array();
  t[0] = this.s;
  var i = this.DB - e * this.DB % 8, r, n = 0;
  if (e-- > 0)
    for (i < this.DB && (r = this.data[e] >> i) != (this.s & this.DM) >> i && (t[n++] = r | this.s << this.DB - i); e >= 0; )
      i < 8 ? (r = (this.data[e] & (1 << i) - 1) << 8 - i, r |= this.data[--e] >> (i += this.DB - 8)) : (r = this.data[e] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --e)), r & 128 && (r |= -256), n == 0 && (this.s & 128) != (r & 128) && ++n, (n > 0 || r != this.s) && (t[n++] = r);
  return t;
}
function x2(e) {
  return this.compareTo(e) == 0;
}
function _2(e) {
  return this.compareTo(e) < 0 ? this : e;
}
function S2(e) {
  return this.compareTo(e) > 0 ? this : e;
}
function E2(e, t, i) {
  var r, n, a = Math.min(e.t, this.t);
  for (r = 0; r < a; ++r)
    i.data[r] = t(this.data[r], e.data[r]);
  if (e.t < this.t) {
    for (n = e.s & this.DM, r = a; r < this.t; ++r)
      i.data[r] = t(this.data[r], n);
    i.t = this.t;
  } else {
    for (n = this.s & this.DM, r = a; r < e.t; ++r)
      i.data[r] = t(n, e.data[r]);
    i.t = e.t;
  }
  i.s = t(this.s, e.s), i.clamp();
}
function w2(e, t) {
  return e & t;
}
function C2(e) {
  var t = Je();
  return this.bitwiseTo(e, w2, t), t;
}
function d0(e, t) {
  return e | t;
}
function A2(e) {
  var t = Je();
  return this.bitwiseTo(e, d0, t), t;
}
function ep(e, t) {
  return e ^ t;
}
function B2(e) {
  var t = Je();
  return this.bitwiseTo(e, ep, t), t;
}
function tp(e, t) {
  return e & ~t;
}
function T2(e) {
  var t = Je();
  return this.bitwiseTo(e, tp, t), t;
}
function I2() {
  for (var e = Je(), t = 0; t < this.t; ++t)
    e.data[t] = this.DM & ~this.data[t];
  return e.t = this.t, e.s = ~this.s, e;
}
function R2(e) {
  var t = Je();
  return e < 0 ? this.rShiftTo(-e, t) : this.lShiftTo(e, t), t;
}
function M2(e) {
  var t = Je();
  return e < 0 ? this.lShiftTo(-e, t) : this.rShiftTo(e, t), t;
}
function N2(e) {
  if (e == 0)
    return -1;
  var t = 0;
  return e & 65535 || (e >>= 16, t += 16), e & 255 || (e >>= 8, t += 8), e & 15 || (e >>= 4, t += 4), e & 3 || (e >>= 2, t += 2), e & 1 || ++t, t;
}
function k2() {
  for (var e = 0; e < this.t; ++e)
    if (this.data[e] != 0)
      return e * this.DB + N2(this.data[e]);
  return this.s < 0 ? this.t * this.DB : -1;
}
function D2(e) {
  for (var t = 0; e != 0; )
    e &= e - 1, ++t;
  return t;
}
function L2() {
  for (var e = 0, t = this.s & this.DM, i = 0; i < this.t; ++i)
    e += D2(this.data[i] ^ t);
  return e;
}
function P2(e) {
  var t = Math.floor(e / this.DB);
  return t >= this.t ? this.s != 0 : (this.data[t] & 1 << e % this.DB) != 0;
}
function U2(e, t) {
  var i = ue.ONE.shiftLeft(e);
  return this.bitwiseTo(i, t, i), i;
}
function O2(e) {
  return this.changeBit(e, d0);
}
function q2(e) {
  return this.changeBit(e, tp);
}
function F2(e) {
  return this.changeBit(e, ep);
}
function V2(e, t) {
  for (var i = 0, r = 0, n = Math.min(e.t, this.t); i < n; )
    r += this.data[i] + e.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r += e.s; i < this.t; )
      r += this.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; i < e.t; )
      r += e.data[i], t.data[i++] = r & this.DM, r >>= this.DB;
    r += e.s;
  }
  t.s = r < 0 ? -1 : 0, r > 0 ? t.data[i++] = r : r < -1 && (t.data[i++] = this.DV + r), t.t = i, t.clamp();
}
function K2(e) {
  var t = Je();
  return this.addTo(e, t), t;
}
function H2(e) {
  var t = Je();
  return this.subTo(e, t), t;
}
function j2(e) {
  var t = Je();
  return this.multiplyTo(e, t), t;
}
function z2(e) {
  var t = Je();
  return this.divRemTo(e, t, null), t;
}
function G2(e) {
  var t = Je();
  return this.divRemTo(e, null, t), t;
}
function $2(e) {
  var t = Je(), i = Je();
  return this.divRemTo(e, t, i), new Array(t, i);
}
function W2(e) {
  this.data[this.t] = this.am(0, e - 1, this, 0, 0, this.t), ++this.t, this.clamp();
}
function Q2(e, t) {
  if (e != 0) {
    for (; this.t <= t; )
      this.data[this.t++] = 0;
    for (this.data[t] += e; this.data[t] >= this.DV; )
      this.data[t] -= this.DV, ++t >= this.t && (this.data[this.t++] = 0), ++this.data[t];
  }
}
function Zi() {
}
function rp(e) {
  return e;
}
function Y2(e, t, i) {
  e.multiplyTo(t, i);
}
function X2(e, t) {
  e.squareTo(t);
}
Zi.prototype.convert = rp;
Zi.prototype.revert = rp;
Zi.prototype.mulTo = Y2;
Zi.prototype.sqrTo = X2;
function Z2(e) {
  return this.exp(e, new Zi());
}
function J2(e, t, i) {
  var r = Math.min(this.t + e.t, t);
  for (i.s = 0, i.t = r; r > 0; )
    i.data[--r] = 0;
  var n;
  for (n = i.t - this.t; r < n; ++r)
    i.data[r + this.t] = this.am(0, e.data[r], i, r, 0, this.t);
  for (n = Math.min(e.t, t); r < n; ++r)
    this.am(0, e.data[r], i, r, 0, t - r);
  i.clamp();
}
function eg(e, t, i) {
  --t;
  var r = i.t = this.t + e.t - t;
  for (i.s = 0; --r >= 0; )
    i.data[r] = 0;
  for (r = Math.max(t - this.t, 0); r < e.t; ++r)
    i.data[this.t + r - t] = this.am(t - r, e.data[r], i, 0, 0, this.t + r - t);
  i.clamp(), i.drShiftTo(1, i);
}
function Ii(e) {
  this.r2 = Je(), this.q3 = Je(), ue.ONE.dlShiftTo(2 * e.t, this.r2), this.mu = this.r2.divide(e), this.m = e;
}
function tg(e) {
  if (e.s < 0 || e.t > 2 * this.m.t)
    return e.mod(this.m);
  if (e.compareTo(this.m) < 0)
    return e;
  var t = Je();
  return e.copyTo(t), this.reduce(t), t;
}
function rg(e) {
  return e;
}
function ig(e) {
  for (e.drShiftTo(this.m.t - 1, this.r2), e.t > this.m.t + 1 && (e.t = this.m.t + 1, e.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e.compareTo(this.r2) < 0; )
    e.dAddOffset(1, this.m.t + 1);
  for (e.subTo(this.r2, e); e.compareTo(this.m) >= 0; )
    e.subTo(this.m, e);
}
function ag(e, t) {
  e.squareTo(t), this.reduce(t);
}
function ng(e, t, i) {
  e.multiplyTo(t, i), this.reduce(i);
}
Ii.prototype.convert = tg;
Ii.prototype.revert = rg;
Ii.prototype.reduce = ig;
Ii.prototype.mulTo = ng;
Ii.prototype.sqrTo = ag;
function fg(e, t) {
  var i = e.bitLength(), r, n = Mr(1), a;
  if (i <= 0)
    return n;
  i < 18 ? r = 1 : i < 48 ? r = 3 : i < 144 ? r = 4 : i < 768 ? r = 5 : r = 6, i < 8 ? a = new ci(t) : t.isEven() ? a = new Ii(t) : a = new li(t);
  var f = new Array(), s = 3, c = r - 1, u = (1 << r) - 1;
  if (f[1] = a.convert(this), r > 1) {
    var o = Je();
    for (a.sqrTo(f[1], o); s <= u; )
      f[s] = Je(), a.mulTo(o, f[s - 2], f[s]), s += 2;
  }
  var l = e.t - 1, h, p = !0, v = Je(), y;
  for (i = Wa(e.data[l]) - 1; l >= 0; ) {
    for (i >= c ? h = e.data[l] >> i - c & u : (h = (e.data[l] & (1 << i + 1) - 1) << c - i, l > 0 && (h |= e.data[l - 1] >> this.DB + i - c)), s = r; !(h & 1); )
      h >>= 1, --s;
    if ((i -= s) < 0 && (i += this.DB, --l), p)
      f[h].copyTo(n), p = !1;
    else {
      for (; s > 1; )
        a.sqrTo(n, v), a.sqrTo(v, n), s -= 2;
      s > 0 ? a.sqrTo(n, v) : (y = n, n = v, v = y), a.mulTo(v, f[h], n);
    }
    for (; l >= 0 && !(e.data[l] & 1 << i); )
      a.sqrTo(n, v), y = n, n = v, v = y, --i < 0 && (i = this.DB - 1, --l);
  }
  return a.revert(n);
}
function sg(e) {
  var t = this.s < 0 ? this.negate() : this.clone(), i = e.s < 0 ? e.negate() : e.clone();
  if (t.compareTo(i) < 0) {
    var r = t;
    t = i, i = r;
  }
  var n = t.getLowestSetBit(), a = i.getLowestSetBit();
  if (a < 0)
    return t;
  for (n < a && (a = n), a > 0 && (t.rShiftTo(a, t), i.rShiftTo(a, i)); t.signum() > 0; )
    (n = t.getLowestSetBit()) > 0 && t.rShiftTo(n, t), (n = i.getLowestSetBit()) > 0 && i.rShiftTo(n, i), t.compareTo(i) >= 0 ? (t.subTo(i, t), t.rShiftTo(1, t)) : (i.subTo(t, i), i.rShiftTo(1, i));
  return a > 0 && i.lShiftTo(a, i), i;
}
function og(e) {
  if (e <= 0)
    return 0;
  var t = this.DV % e, i = this.s < 0 ? e - 1 : 0;
  if (this.t > 0)
    if (t == 0)
      i = this.data[0] % e;
    else
      for (var r = this.t - 1; r >= 0; --r)
        i = (t * i + this.data[r]) % e;
  return i;
}
function ug(e) {
  var t = e.isEven();
  if (this.isEven() && t || e.signum() == 0)
    return ue.ZERO;
  for (var i = e.clone(), r = this.clone(), n = Mr(1), a = Mr(0), f = Mr(0), s = Mr(1); i.signum() != 0; ) {
    for (; i.isEven(); )
      i.rShiftTo(1, i), t ? ((!n.isEven() || !a.isEven()) && (n.addTo(this, n), a.subTo(e, a)), n.rShiftTo(1, n)) : a.isEven() || a.subTo(e, a), a.rShiftTo(1, a);
    for (; r.isEven(); )
      r.rShiftTo(1, r), t ? ((!f.isEven() || !s.isEven()) && (f.addTo(this, f), s.subTo(e, s)), f.rShiftTo(1, f)) : s.isEven() || s.subTo(e, s), s.rShiftTo(1, s);
    i.compareTo(r) >= 0 ? (i.subTo(r, i), t && n.subTo(f, n), a.subTo(s, a)) : (r.subTo(i, r), t && f.subTo(n, f), s.subTo(a, s));
  }
  if (r.compareTo(ue.ONE) != 0)
    return ue.ZERO;
  if (s.compareTo(e) >= 0)
    return s.subtract(e);
  if (s.signum() < 0)
    s.addTo(e, s);
  else
    return s;
  return s.signum() < 0 ? s.add(e) : s;
}
var lr = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509], cg = (1 << 26) / lr[lr.length - 1];
function lg(e) {
  var t, i = this.abs();
  if (i.t == 1 && i.data[0] <= lr[lr.length - 1]) {
    for (t = 0; t < lr.length; ++t)
      if (i.data[0] == lr[t])
        return !0;
    return !1;
  }
  if (i.isEven())
    return !1;
  for (t = 1; t < lr.length; ) {
    for (var r = lr[t], n = t + 1; n < lr.length && r < cg; )
      r *= lr[n++];
    for (r = i.modInt(r); t < n; )
      if (r % lr[t++] == 0)
        return !1;
  }
  return i.millerRabin(e);
}
function hg(e) {
  var t = this.subtract(ue.ONE), i = t.getLowestSetBit();
  if (i <= 0)
    return !1;
  for (var r = t.shiftRight(i), n = dg(), a, f = 0; f < e; ++f) {
    do
      a = new ue(this.bitLength(), n);
    while (a.compareTo(ue.ONE) <= 0 || a.compareTo(t) >= 0);
    var s = a.modPow(r, this);
    if (s.compareTo(ue.ONE) != 0 && s.compareTo(t) != 0) {
      for (var c = 1; c++ < i && s.compareTo(t) != 0; )
        if (s = s.modPowInt(2, this), s.compareTo(ue.ONE) == 0)
          return !1;
      if (s.compareTo(t) != 0)
        return !1;
    }
  }
  return !0;
}
function dg() {
  return {
    // x is an array to fill with bytes
    nextBytes: function(e) {
      for (var t = 0; t < e.length; ++t)
        e[t] = Math.floor(Math.random() * 256);
    }
  };
}
ue.prototype.chunkSize = p2;
ue.prototype.toRadix = y2;
ue.prototype.fromRadix = g2;
ue.prototype.fromNumber = b2;
ue.prototype.bitwiseTo = E2;
ue.prototype.changeBit = U2;
ue.prototype.addTo = V2;
ue.prototype.dMultiply = W2;
ue.prototype.dAddOffset = Q2;
ue.prototype.multiplyLowerTo = J2;
ue.prototype.multiplyUpperTo = eg;
ue.prototype.modInt = og;
ue.prototype.millerRabin = hg;
ue.prototype.clone = c2;
ue.prototype.intValue = l2;
ue.prototype.byteValue = h2;
ue.prototype.shortValue = d2;
ue.prototype.signum = v2;
ue.prototype.toByteArray = m2;
ue.prototype.equals = x2;
ue.prototype.min = _2;
ue.prototype.max = S2;
ue.prototype.and = C2;
ue.prototype.or = A2;
ue.prototype.xor = B2;
ue.prototype.andNot = T2;
ue.prototype.not = I2;
ue.prototype.shiftLeft = R2;
ue.prototype.shiftRight = M2;
ue.prototype.getLowestSetBit = k2;
ue.prototype.bitCount = L2;
ue.prototype.testBit = P2;
ue.prototype.setBit = O2;
ue.prototype.clearBit = q2;
ue.prototype.flipBit = F2;
ue.prototype.add = K2;
ue.prototype.subtract = H2;
ue.prototype.multiply = j2;
ue.prototype.divide = z2;
ue.prototype.remainder = G2;
ue.prototype.divideAndRemainder = $2;
ue.prototype.modPow = fg;
ue.prototype.modInverse = ug;
ue.prototype.pow = Z2;
ue.prototype.gcd = sg;
ue.prototype.isProbablePrime = lg;
var mr = je, ip = mr.sha1 = mr.sha1 || {};
mr.md.sha1 = mr.md.algorithms.sha1 = ip;
ip.create = function() {
  ap || pg();
  var e = null, t = mr.util.createBuffer(), i = new Array(80), r = {
    algorithm: "sha1",
    blockLength: 64,
    digestLength: 20,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var n = r.messageLengthSize / 4, a = 0; a < n; ++a)
      r.fullMessageLength.push(0);
    return t = mr.util.createBuffer(), e = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878,
      h4: 3285377520
    }, r;
  }, r.start(), r.update = function(n, a) {
    a === "utf8" && (n = mr.util.encodeUtf8(n));
    var f = n.length;
    r.messageLength += f, f = [f / 4294967296 >>> 0, f >>> 0];
    for (var s = r.fullMessageLength.length - 1; s >= 0; --s)
      r.fullMessageLength[s] += f[1], f[1] = f[0] + (r.fullMessageLength[s] / 4294967296 >>> 0), r.fullMessageLength[s] = r.fullMessageLength[s] >>> 0, f[0] = f[1] / 4294967296 >>> 0;
    return t.putBytes(n), Ah(e, i, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var n = mr.util.createBuffer();
    n.putBytes(t.bytes());
    var a = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, f = a & r.blockLength - 1;
    n.putBytes(Mo.substr(0, r.blockLength - f));
    for (var s, c, u = r.fullMessageLength[0] * 8, o = 0; o < r.fullMessageLength.length - 1; ++o)
      s = r.fullMessageLength[o + 1] * 8, c = s / 4294967296 >>> 0, u += c, n.putInt32(u >>> 0), u = s >>> 0;
    n.putInt32(u);
    var l = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3,
      h4: e.h4
    };
    Ah(l, i, n);
    var h = mr.util.createBuffer();
    return h.putInt32(l.h0), h.putInt32(l.h1), h.putInt32(l.h2), h.putInt32(l.h3), h.putInt32(l.h4), h;
  }, r;
};
var Mo = null, ap = !1;
function pg() {
  Mo = "", Mo += mr.util.fillString("\0", 64), ap = !0;
}
function Ah(e, t, i) {
  for (var r, n, a, f, s, c, u, o, l = i.length(); l >= 64; ) {
    for (n = e.h0, a = e.h1, f = e.h2, s = e.h3, c = e.h4, o = 0; o < 16; ++o)
      r = i.getInt32(), t[o] = r, u = s ^ a & (f ^ s), r = (n << 5 | n >>> 27) + u + c + 1518500249 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    for (; o < 20; ++o)
      r = t[o - 3] ^ t[o - 8] ^ t[o - 14] ^ t[o - 16], r = r << 1 | r >>> 31, t[o] = r, u = s ^ a & (f ^ s), r = (n << 5 | n >>> 27) + u + c + 1518500249 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    for (; o < 32; ++o)
      r = t[o - 3] ^ t[o - 8] ^ t[o - 14] ^ t[o - 16], r = r << 1 | r >>> 31, t[o] = r, u = a ^ f ^ s, r = (n << 5 | n >>> 27) + u + c + 1859775393 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    for (; o < 40; ++o)
      r = t[o - 6] ^ t[o - 16] ^ t[o - 28] ^ t[o - 32], r = r << 2 | r >>> 30, t[o] = r, u = a ^ f ^ s, r = (n << 5 | n >>> 27) + u + c + 1859775393 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    for (; o < 60; ++o)
      r = t[o - 6] ^ t[o - 16] ^ t[o - 28] ^ t[o - 32], r = r << 2 | r >>> 30, t[o] = r, u = a & f | s & (a ^ f), r = (n << 5 | n >>> 27) + u + c + 2400959708 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    for (; o < 80; ++o)
      r = t[o - 6] ^ t[o - 16] ^ t[o - 28] ^ t[o - 32], r = r << 2 | r >>> 30, t[o] = r, u = a ^ f ^ s, r = (n << 5 | n >>> 27) + u + c + 3395469782 + r, c = s, s = f, f = (a << 30 | a >>> 2) >>> 0, a = n, n = r;
    e.h0 = e.h0 + n | 0, e.h1 = e.h1 + a | 0, e.h2 = e.h2 + f | 0, e.h3 = e.h3 + s | 0, e.h4 = e.h4 + c | 0, l -= 64;
  }
}
var xr = je, np = xr.pkcs1 = xr.pkcs1 || {};
np.encode_rsa_oaep = function(e, t, i) {
  var r, n, a, f;
  typeof i == "string" ? (r = i, n = arguments[3] || void 0, a = arguments[4] || void 0) : i && (r = i.label || void 0, n = i.seed || void 0, a = i.md || void 0, i.mgf1 && i.mgf1.md && (f = i.mgf1.md)), a ? a.start() : a = xr.md.sha1.create(), f || (f = a);
  var s = Math.ceil(e.n.bitLength() / 8), c = s - 2 * a.digestLength - 2;
  if (t.length > c) {
    var u = new Error("RSAES-OAEP input message length is too long.");
    throw u.length = t.length, u.maxLength = c, u;
  }
  r || (r = ""), a.update(r, "raw");
  for (var o = a.digest(), l = "", h = c - t.length, p = 0; p < h; p++)
    l += "\0";
  var v = o.getBytes() + l + "" + t;
  if (!n)
    n = xr.random.getBytes(a.digestLength);
  else if (n.length !== a.digestLength) {
    var u = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
    throw u.seedLength = n.length, u.digestLength = a.digestLength, u;
  }
  var y = Ca(n, s - a.digestLength - 1, f), w = xr.util.xorBytes(v, y, v.length), x = Ca(w, a.digestLength, f), A = xr.util.xorBytes(n, x, n.length);
  return "\0" + A + w;
};
np.decode_rsa_oaep = function(e, t, i) {
  var r, n, a;
  typeof i == "string" ? (r = i, n = arguments[3] || void 0) : i && (r = i.label || void 0, n = i.md || void 0, i.mgf1 && i.mgf1.md && (a = i.mgf1.md));
  var f = Math.ceil(e.n.bitLength() / 8);
  if (t.length !== f) {
    var w = new Error("RSAES-OAEP encoded message length is invalid.");
    throw w.length = t.length, w.expectedLength = f, w;
  }
  if (n === void 0 ? n = xr.md.sha1.create() : n.start(), a || (a = n), f < 2 * n.digestLength + 2)
    throw new Error("RSAES-OAEP key is too short for the hash function.");
  r || (r = ""), n.update(r, "raw");
  for (var s = n.digest().getBytes(), c = t.charAt(0), u = t.substring(1, n.digestLength + 1), o = t.substring(1 + n.digestLength), l = Ca(o, n.digestLength, a), h = xr.util.xorBytes(u, l, u.length), p = Ca(h, f - n.digestLength - 1, a), v = xr.util.xorBytes(o, p, o.length), y = v.substring(0, n.digestLength), w = c !== "\0", x = 0; x < n.digestLength; ++x)
    w |= s.charAt(x) !== y.charAt(x);
  for (var A = 1, R = n.digestLength, M = n.digestLength; M < v.length; M++) {
    var D = v.charCodeAt(M), U = D & 1 ^ 1, z = A ? 65534 : 0;
    w |= D & z, A = A & U, R += A;
  }
  if (w || v.charCodeAt(R) !== 1)
    throw new Error("Invalid RSAES-OAEP padding.");
  return v.substring(R + 1);
};
function Ca(e, t, i) {
  i || (i = xr.md.sha1.create());
  for (var r = "", n = Math.ceil(t / i.digestLength), a = 0; a < n; ++a) {
    var f = String.fromCharCode(
      a >> 24 & 255,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255
    );
    i.start(), i.update(e + f), r += i.digest().getBytes();
  }
  return r.substring(0, t);
}
var Br = je;
(function() {
  if (Br.prime) {
    Br.prime;
    return;
  }
  var e = Br.prime = Br.prime || {}, t = Br.jsbn.BigInteger, i = [6, 4, 2, 4, 2, 4, 6, 2], r = new t(null);
  r.fromInt(30);
  var n = function(l, h) {
    return l | h;
  };
  e.generateProbablePrime = function(l, h, p) {
    typeof h == "function" && (p = h, h = {}), h = h || {};
    var v = h.algorithm || "PRIMEINC";
    typeof v == "string" && (v = { name: v }), v.options = v.options || {};
    var y = h.prng || Br.random, w = {
      // x is an array to fill with bytes
      nextBytes: function(x) {
        for (var A = y.getBytesSync(x.length), R = 0; R < x.length; ++R)
          x[R] = A.charCodeAt(R);
      }
    };
    if (v.name === "PRIMEINC")
      return a(l, w, v.options, p);
    throw new Error("Invalid prime generation algorithm: " + v.name);
  };
  function a(l, h, p, v) {
    return "workers" in p ? c(l, h, p, v) : f(l, h, p, v);
  }
  function f(l, h, p, v) {
    var y = u(l, h), w = 0, x = o(y.bitLength());
    "millerRabinTests" in p && (x = p.millerRabinTests);
    var A = 10;
    "maxBlockTime" in p && (A = p.maxBlockTime), s(y, l, h, w, x, A, v);
  }
  function s(l, h, p, v, y, w, x) {
    var A = +/* @__PURE__ */ new Date();
    do {
      if (l.bitLength() > h && (l = u(h, p)), l.isProbablePrime(y))
        return x(null, l);
      l.dAddOffset(i[v++ % 8], 0);
    } while (w < 0 || +/* @__PURE__ */ new Date() - A < w);
    Br.util.setImmediate(function() {
      s(l, h, p, v, y, w, x);
    });
  }
  function c(l, h, p, v) {
    if (typeof Worker > "u")
      return f(l, h, p, v);
    var y = u(l, h), w = p.workers, x = p.workLoad || 100, A = x * 30 / 8, R = p.workerScript || "forge/prime.worker.js";
    if (w === -1)
      return Br.util.estimateCores(function(D, U) {
        D && (U = 2), w = U - 1, M();
      });
    M();
    function M() {
      w = Math.max(1, w);
      for (var D = [], U = 0; U < w; ++U)
        D[U] = new Worker(R);
      for (var U = 0; U < w; ++U)
        D[U].addEventListener("message", W);
      var z = !1;
      function W(G) {
        if (!z) {
          var re = G.data;
          if (re.found) {
            for (var V = 0; V < D.length; ++V)
              D[V].terminate();
            return z = !0, v(null, new t(re.prime, 16));
          }
          y.bitLength() > l && (y = u(l, h));
          var m = y.toString(16);
          G.target.postMessage({
            hex: m,
            workLoad: x
          }), y.dAddOffset(A, 0);
        }
      }
    }
  }
  function u(l, h) {
    var p = new t(l, h), v = l - 1;
    return p.testBit(v) || p.bitwiseTo(t.ONE.shiftLeft(v), n, p), p.dAddOffset(31 - p.mod(r).byteValue(), 0), p;
  }
  function o(l) {
    return l <= 100 ? 27 : l <= 150 ? 18 : l <= 200 ? 15 : l <= 250 ? 12 : l <= 300 ? 9 : l <= 350 ? 8 : l <= 400 ? 7 : l <= 500 ? 6 : l <= 600 ? 5 : l <= 800 ? 4 : l <= 1250 ? 3 : 2;
  }
})();
var _e = je;
if (typeof Ze > "u")
  var Ze = _e.jsbn.BigInteger;
var No = _e.util.isNodejs ? Ga() : null, te = _e.asn1, nr = _e.util;
_e.pki = _e.pki || {};
_e.pki.rsa = _e.rsa = _e.rsa || {};
var Ie = _e.pki, vg = [6, 4, 2, 4, 2, 4, 6, 2], yg = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: te.Class.UNIVERSAL,
  type: te.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: te.Class.UNIVERSAL,
      type: te.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
}, gg = {
  // RSAPrivateKey
  name: "RSAPrivateKey",
  tagClass: te.Class.UNIVERSAL,
  type: te.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "RSAPrivateKey.version",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // modulus (n)
    name: "RSAPrivateKey.modulus",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPrivateKey.publicExponent",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPublicExponent"
  }, {
    // privateExponent (d)
    name: "RSAPrivateKey.privateExponent",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrivateExponent"
  }, {
    // prime1 (p)
    name: "RSAPrivateKey.prime1",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime1"
  }, {
    // prime2 (q)
    name: "RSAPrivateKey.prime2",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime2"
  }, {
    // exponent1 (d mod (p-1))
    name: "RSAPrivateKey.exponent1",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent1"
  }, {
    // exponent2 (d mod (q-1))
    name: "RSAPrivateKey.exponent2",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent2"
  }, {
    // coefficient ((inverse of q) mod p)
    name: "RSAPrivateKey.coefficient",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyCoefficient"
  }]
}, bg = {
  // RSAPublicKey
  name: "RSAPublicKey",
  tagClass: te.Class.UNIVERSAL,
  type: te.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // modulus (n)
    name: "RSAPublicKey.modulus",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPublicKey.exponent",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyExponent"
  }]
}, mg = _e.pki.rsa.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: te.Class.UNIVERSAL,
  type: te.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [{
    name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: te.Class.UNIVERSAL,
      type: te.Type.OID,
      constructed: !1,
      capture: "publicKeyOid"
    }]
  }, {
    // subjectPublicKey
    name: "SubjectPublicKeyInfo.subjectPublicKey",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.BITSTRING,
    constructed: !1,
    value: [{
      // RSAPublicKey
      name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
      tagClass: te.Class.UNIVERSAL,
      type: te.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "rsaPublicKey"
    }]
  }]
}, xg = {
  name: "DigestInfo",
  tagClass: te.Class.UNIVERSAL,
  type: te.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "DigestInfo.DigestAlgorithm",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
      tagClass: te.Class.UNIVERSAL,
      type: te.Type.OID,
      constructed: !1,
      capture: "algorithmIdentifier"
    }, {
      // NULL paramters
      name: "DigestInfo.DigestAlgorithm.parameters",
      tagClass: te.Class.UNIVERSAL,
      type: te.Type.NULL,
      // captured only to check existence for md2 and md5
      capture: "parameters",
      optional: !0,
      constructed: !1
    }]
  }, {
    // digest
    name: "DigestInfo.digest",
    tagClass: te.Class.UNIVERSAL,
    type: te.Type.OCTETSTRING,
    constructed: !1,
    capture: "digest"
  }]
}, _g = function(e) {
  var t;
  if (e.algorithm in Ie.oids)
    t = Ie.oids[e.algorithm];
  else {
    var i = new Error("Unknown message digest algorithm.");
    throw i.algorithm = e.algorithm, i;
  }
  var r = te.oidToDer(t).getBytes(), n = te.create(
    te.Class.UNIVERSAL,
    te.Type.SEQUENCE,
    !0,
    []
  ), a = te.create(
    te.Class.UNIVERSAL,
    te.Type.SEQUENCE,
    !0,
    []
  );
  a.value.push(te.create(
    te.Class.UNIVERSAL,
    te.Type.OID,
    !1,
    r
  )), a.value.push(te.create(
    te.Class.UNIVERSAL,
    te.Type.NULL,
    !1,
    ""
  ));
  var f = te.create(
    te.Class.UNIVERSAL,
    te.Type.OCTETSTRING,
    !1,
    e.digest().getBytes()
  );
  return n.value.push(a), n.value.push(f), te.toDer(n).getBytes();
}, fp = function(e, t, i) {
  if (i)
    return e.modPow(t.e, t.n);
  if (!t.p || !t.q)
    return e.modPow(t.d, t.n);
  t.dP || (t.dP = t.d.mod(t.p.subtract(Ze.ONE))), t.dQ || (t.dQ = t.d.mod(t.q.subtract(Ze.ONE))), t.qInv || (t.qInv = t.q.modInverse(t.p));
  var r;
  do
    r = new Ze(
      _e.util.bytesToHex(_e.random.getBytes(t.n.bitLength() / 8)),
      16
    );
  while (r.compareTo(t.n) >= 0 || !r.gcd(t.n).equals(Ze.ONE));
  e = e.multiply(r.modPow(t.e, t.n)).mod(t.n);
  for (var n = e.mod(t.p).modPow(t.dP, t.p), a = e.mod(t.q).modPow(t.dQ, t.q); n.compareTo(a) < 0; )
    n = n.add(t.p);
  var f = n.subtract(a).multiply(t.qInv).mod(t.p).multiply(t.q).add(a);
  return f = f.multiply(r.modInverse(t.n)).mod(t.n), f;
};
Ie.rsa.encrypt = function(e, t, i) {
  var r = i, n, a = Math.ceil(t.n.bitLength() / 8);
  i !== !1 && i !== !0 ? (r = i === 2, n = sp(e, t, i)) : (n = _e.util.createBuffer(), n.putBytes(e));
  for (var f = new Ze(n.toHex(), 16), s = fp(f, t, r), c = s.toString(16), u = _e.util.createBuffer(), o = a - Math.ceil(c.length / 2); o > 0; )
    u.putByte(0), --o;
  return u.putBytes(_e.util.hexToBytes(c)), u.getBytes();
};
Ie.rsa.decrypt = function(e, t, i, r) {
  var n = Math.ceil(t.n.bitLength() / 8);
  if (e.length !== n) {
    var a = new Error("Encrypted message length is invalid.");
    throw a.length = e.length, a.expected = n, a;
  }
  var f = new Ze(_e.util.createBuffer(e).toHex(), 16);
  if (f.compareTo(t.n) >= 0)
    throw new Error("Encrypted message is invalid.");
  for (var s = fp(f, t, i), c = s.toString(16), u = _e.util.createBuffer(), o = n - Math.ceil(c.length / 2); o > 0; )
    u.putByte(0), --o;
  return u.putBytes(_e.util.hexToBytes(c)), r !== !1 ? Aa(u.getBytes(), t, i) : u.getBytes();
};
Ie.rsa.createKeyPairGenerationState = function(e, t, i) {
  typeof e == "string" && (e = parseInt(e, 10)), e = e || 2048, i = i || {};
  var r = i.prng || _e.random, n = {
    // x is an array to fill with bytes
    nextBytes: function(s) {
      for (var c = r.getBytesSync(s.length), u = 0; u < s.length; ++u)
        s[u] = c.charCodeAt(u);
    }
  }, a = i.algorithm || "PRIMEINC", f;
  if (a === "PRIMEINC")
    f = {
      algorithm: a,
      state: 0,
      bits: e,
      rng: n,
      eInt: t || 65537,
      e: new Ze(null),
      p: null,
      q: null,
      qBits: e >> 1,
      pBits: e - (e >> 1),
      pqState: 0,
      num: null,
      keys: null
    }, f.e.fromInt(f.eInt);
  else
    throw new Error("Invalid key generation algorithm: " + a);
  return f;
};
Ie.rsa.stepKeyPairGenerationState = function(e, t) {
  "algorithm" in e || (e.algorithm = "PRIMEINC");
  var i = new Ze(null);
  i.fromInt(30);
  for (var r = 0, n = function(l, h) {
    return l | h;
  }, a = +/* @__PURE__ */ new Date(), f, s = 0; e.keys === null && (t <= 0 || s < t); ) {
    if (e.state === 0) {
      var c = e.p === null ? e.pBits : e.qBits, u = c - 1;
      e.pqState === 0 ? (e.num = new Ze(c, e.rng), e.num.testBit(u) || e.num.bitwiseTo(
        Ze.ONE.shiftLeft(u),
        n,
        e.num
      ), e.num.dAddOffset(31 - e.num.mod(i).byteValue(), 0), r = 0, ++e.pqState) : e.pqState === 1 ? e.num.bitLength() > c ? e.pqState = 0 : e.num.isProbablePrime(
        Eg(e.num.bitLength())
      ) ? ++e.pqState : e.num.dAddOffset(vg[r++ % 8], 0) : e.pqState === 2 ? e.pqState = e.num.subtract(Ze.ONE).gcd(e.e).compareTo(Ze.ONE) === 0 ? 3 : 0 : e.pqState === 3 && (e.pqState = 0, e.p === null ? e.p = e.num : e.q = e.num, e.p !== null && e.q !== null && ++e.state, e.num = null);
    } else if (e.state === 1)
      e.p.compareTo(e.q) < 0 && (e.num = e.p, e.p = e.q, e.q = e.num), ++e.state;
    else if (e.state === 2)
      e.p1 = e.p.subtract(Ze.ONE), e.q1 = e.q.subtract(Ze.ONE), e.phi = e.p1.multiply(e.q1), ++e.state;
    else if (e.state === 3)
      e.phi.gcd(e.e).compareTo(Ze.ONE) === 0 ? ++e.state : (e.p = null, e.q = null, e.state = 0);
    else if (e.state === 4)
      e.n = e.p.multiply(e.q), e.n.bitLength() === e.bits ? ++e.state : (e.q = null, e.state = 0);
    else if (e.state === 5) {
      var o = e.e.modInverse(e.phi);
      e.keys = {
        privateKey: Ie.rsa.setPrivateKey(
          e.n,
          e.e,
          o,
          e.p,
          e.q,
          o.mod(e.p1),
          o.mod(e.q1),
          e.q.modInverse(e.p)
        ),
        publicKey: Ie.rsa.setPublicKey(e.n, e.e)
      };
    }
    f = +/* @__PURE__ */ new Date(), s += f - a, a = f;
  }
  return e.keys !== null;
};
Ie.rsa.generateKeyPair = function(e, t, i, r) {
  if (arguments.length === 1 ? typeof e == "object" ? (i = e, e = void 0) : typeof e == "function" && (r = e, e = void 0) : arguments.length === 2 ? typeof e == "number" ? typeof t == "function" ? (r = t, t = void 0) : typeof t != "number" && (i = t, t = void 0) : (i = e, r = t, e = void 0, t = void 0) : arguments.length === 3 && (typeof t == "number" ? typeof i == "function" && (r = i, i = void 0) : (r = i, i = t, t = void 0)), i = i || {}, e === void 0 && (e = i.bits || 2048), t === void 0 && (t = i.e || 65537), !_e.options.usePureJavaScript && !i.prng && e >= 256 && e <= 16384 && (t === 65537 || t === 3)) {
    if (r) {
      if (Bh("generateKeyPair"))
        return No.generateKeyPair("rsa", {
          modulusLength: e,
          publicExponent: t,
          publicKeyEncoding: {
            type: "spki",
            format: "pem"
          },
          privateKeyEncoding: {
            type: "pkcs8",
            format: "pem"
          }
        }, function(s, c, u) {
          if (s)
            return r(s);
          r(null, {
            privateKey: Ie.privateKeyFromPem(u),
            publicKey: Ie.publicKeyFromPem(c)
          });
        });
      if (Th("generateKey") && Th("exportKey"))
        return nr.globalScope.crypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: e,
          publicExponent: Rh(t),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]).then(function(s) {
          return nr.globalScope.crypto.subtle.exportKey(
            "pkcs8",
            s.privateKey
          );
        }).then(void 0, function(s) {
          r(s);
        }).then(function(s) {
          if (s) {
            var c = Ie.privateKeyFromAsn1(
              te.fromDer(_e.util.createBuffer(s))
            );
            r(null, {
              privateKey: c,
              publicKey: Ie.setRsaPublicKey(c.n, c.e)
            });
          }
        });
      if (Ih("generateKey") && Ih("exportKey")) {
        var n = nr.globalScope.msCrypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: e,
          publicExponent: Rh(t),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]);
        n.oncomplete = function(s) {
          var c = s.target.result, u = nr.globalScope.msCrypto.subtle.exportKey(
            "pkcs8",
            c.privateKey
          );
          u.oncomplete = function(o) {
            var l = o.target.result, h = Ie.privateKeyFromAsn1(
              te.fromDer(_e.util.createBuffer(l))
            );
            r(null, {
              privateKey: h,
              publicKey: Ie.setRsaPublicKey(h.n, h.e)
            });
          }, u.onerror = function(o) {
            r(o);
          };
        }, n.onerror = function(s) {
          r(s);
        };
        return;
      }
    } else if (Bh("generateKeyPairSync")) {
      var a = No.generateKeyPairSync("rsa", {
        modulusLength: e,
        publicExponent: t,
        publicKeyEncoding: {
          type: "spki",
          format: "pem"
        },
        privateKeyEncoding: {
          type: "pkcs8",
          format: "pem"
        }
      });
      return {
        privateKey: Ie.privateKeyFromPem(a.privateKey),
        publicKey: Ie.publicKeyFromPem(a.publicKey)
      };
    }
  }
  var f = Ie.rsa.createKeyPairGenerationState(e, t, i);
  if (!r)
    return Ie.rsa.stepKeyPairGenerationState(f, 0), f.keys;
  Sg(f, i, r);
};
Ie.setRsaPublicKey = Ie.rsa.setPublicKey = function(e, t) {
  var i = {
    n: e,
    e: t
  };
  return i.encrypt = function(r, n, a) {
    if (typeof n == "string" ? n = n.toUpperCase() : n === void 0 && (n = "RSAES-PKCS1-V1_5"), n === "RSAES-PKCS1-V1_5")
      n = {
        encode: function(s, c, u) {
          return sp(s, c, 2).getBytes();
        }
      };
    else if (n === "RSA-OAEP" || n === "RSAES-OAEP")
      n = {
        encode: function(s, c) {
          return _e.pkcs1.encode_rsa_oaep(c, s, a);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(n) !== -1)
      n = { encode: function(s) {
        return s;
      } };
    else if (typeof n == "string")
      throw new Error('Unsupported encryption scheme: "' + n + '".');
    var f = n.encode(r, i, !0);
    return Ie.rsa.encrypt(f, i, !0);
  }, i.verify = function(r, n, a, f) {
    typeof a == "string" ? a = a.toUpperCase() : a === void 0 && (a = "RSASSA-PKCS1-V1_5"), f === void 0 && (f = {
      _parseAllDigestBytes: !0
    }), "_parseAllDigestBytes" in f || (f._parseAllDigestBytes = !0), a === "RSASSA-PKCS1-V1_5" ? a = {
      verify: function(c, u) {
        u = Aa(u, i, !0);
        var o = te.fromDer(u, {
          parseAllBytes: f._parseAllDigestBytes
        }), l = {}, h = [];
        if (!te.validate(o, xg, l, h)) {
          var p = new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value."
          );
          throw p.errors = h, p;
        }
        var v = te.derToOid(l.algorithmIdentifier);
        if (!(v === _e.oids.md2 || v === _e.oids.md5 || v === _e.oids.sha1 || v === _e.oids.sha224 || v === _e.oids.sha256 || v === _e.oids.sha384 || v === _e.oids.sha512 || v === _e.oids["sha512-224"] || v === _e.oids["sha512-256"])) {
          var p = new Error(
            "Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier."
          );
          throw p.oid = v, p;
        }
        if ((v === _e.oids.md2 || v === _e.oids.md5) && !("parameters" in l))
          throw new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters."
          );
        return c === l.digest;
      }
    } : (a === "NONE" || a === "NULL" || a === null) && (a = {
      verify: function(c, u) {
        return u = Aa(u, i, !0), c === u;
      }
    });
    var s = Ie.rsa.decrypt(n, i, !0, !1);
    return a.verify(r, s, i.n.bitLength());
  }, i;
};
Ie.setRsaPrivateKey = Ie.rsa.setPrivateKey = function(e, t, i, r, n, a, f, s) {
  var c = {
    n: e,
    e: t,
    d: i,
    p: r,
    q: n,
    dP: a,
    dQ: f,
    qInv: s
  };
  return c.decrypt = function(u, o, l) {
    typeof o == "string" ? o = o.toUpperCase() : o === void 0 && (o = "RSAES-PKCS1-V1_5");
    var h = Ie.rsa.decrypt(u, c, !1, !1);
    if (o === "RSAES-PKCS1-V1_5")
      o = { decode: Aa };
    else if (o === "RSA-OAEP" || o === "RSAES-OAEP")
      o = {
        decode: function(p, v) {
          return _e.pkcs1.decode_rsa_oaep(v, p, l);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(o) !== -1)
      o = { decode: function(p) {
        return p;
      } };
    else
      throw new Error('Unsupported encryption scheme: "' + o + '".');
    return o.decode(h, c, !1);
  }, c.sign = function(u, o) {
    var l = !1;
    typeof o == "string" && (o = o.toUpperCase()), o === void 0 || o === "RSASSA-PKCS1-V1_5" ? (o = { encode: _g }, l = 1) : (o === "NONE" || o === "NULL" || o === null) && (o = { encode: function() {
      return u;
    } }, l = 1);
    var h = o.encode(u, c.n.bitLength());
    return Ie.rsa.encrypt(h, c, l);
  }, c;
};
Ie.wrapRsaPrivateKey = function(e) {
  return te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
    // version (0)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      te.integerToDer(0).getBytes()
    ),
    // privateKeyAlgorithm
    te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
      te.create(
        te.Class.UNIVERSAL,
        te.Type.OID,
        !1,
        te.oidToDer(Ie.oids.rsaEncryption).getBytes()
      ),
      te.create(te.Class.UNIVERSAL, te.Type.NULL, !1, "")
    ]),
    // PrivateKey
    te.create(
      te.Class.UNIVERSAL,
      te.Type.OCTETSTRING,
      !1,
      te.toDer(e).getBytes()
    )
  ]);
};
Ie.privateKeyFromAsn1 = function(e) {
  var t = {}, i = [];
  if (te.validate(e, yg, t, i) && (e = te.fromDer(_e.util.createBuffer(t.privateKey))), t = {}, i = [], !te.validate(e, gg, t, i)) {
    var r = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
    throw r.errors = i, r;
  }
  var n, a, f, s, c, u, o, l;
  return n = _e.util.createBuffer(t.privateKeyModulus).toHex(), a = _e.util.createBuffer(t.privateKeyPublicExponent).toHex(), f = _e.util.createBuffer(t.privateKeyPrivateExponent).toHex(), s = _e.util.createBuffer(t.privateKeyPrime1).toHex(), c = _e.util.createBuffer(t.privateKeyPrime2).toHex(), u = _e.util.createBuffer(t.privateKeyExponent1).toHex(), o = _e.util.createBuffer(t.privateKeyExponent2).toHex(), l = _e.util.createBuffer(t.privateKeyCoefficient).toHex(), Ie.setRsaPrivateKey(
    new Ze(n, 16),
    new Ze(a, 16),
    new Ze(f, 16),
    new Ze(s, 16),
    new Ze(c, 16),
    new Ze(u, 16),
    new Ze(o, 16),
    new Ze(l, 16)
  );
};
Ie.privateKeyToAsn1 = Ie.privateKeyToRSAPrivateKey = function(e) {
  return te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
    // version (0 = only 2 primes, 1 multiple primes)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      te.integerToDer(0).getBytes()
    ),
    // modulus (n)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.n)
    ),
    // publicExponent (e)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.e)
    ),
    // privateExponent (d)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.d)
    ),
    // privateKeyPrime1 (p)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.p)
    ),
    // privateKeyPrime2 (q)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.q)
    ),
    // privateKeyExponent1 (dP)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.dP)
    ),
    // privateKeyExponent2 (dQ)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.dQ)
    ),
    // coefficient (qInv)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.qInv)
    )
  ]);
};
Ie.publicKeyFromAsn1 = function(e) {
  var t = {}, i = [];
  if (te.validate(e, mg, t, i)) {
    var r = te.derToOid(t.publicKeyOid);
    if (r !== Ie.oids.rsaEncryption) {
      var n = new Error("Cannot read public key. Unknown OID.");
      throw n.oid = r, n;
    }
    e = t.rsaPublicKey;
  }
  if (i = [], !te.validate(e, bg, t, i)) {
    var n = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
    throw n.errors = i, n;
  }
  var a = _e.util.createBuffer(t.publicKeyModulus).toHex(), f = _e.util.createBuffer(t.publicKeyExponent).toHex();
  return Ie.setRsaPublicKey(
    new Ze(a, 16),
    new Ze(f, 16)
  );
};
Ie.publicKeyToAsn1 = Ie.publicKeyToSubjectPublicKeyInfo = function(e) {
  return te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
    // AlgorithmIdentifier
    te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
      // algorithm
      te.create(
        te.Class.UNIVERSAL,
        te.Type.OID,
        !1,
        te.oidToDer(Ie.oids.rsaEncryption).getBytes()
      ),
      // parameters (null)
      te.create(te.Class.UNIVERSAL, te.Type.NULL, !1, "")
    ]),
    // subjectPublicKey
    te.create(te.Class.UNIVERSAL, te.Type.BITSTRING, !1, [
      Ie.publicKeyToRSAPublicKey(e)
    ])
  ]);
};
Ie.publicKeyToRSAPublicKey = function(e) {
  return te.create(te.Class.UNIVERSAL, te.Type.SEQUENCE, !0, [
    // modulus (n)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.n)
    ),
    // publicExponent (e)
    te.create(
      te.Class.UNIVERSAL,
      te.Type.INTEGER,
      !1,
      pr(e.e)
    )
  ]);
};
function sp(e, t, i) {
  var r = _e.util.createBuffer(), n = Math.ceil(t.n.bitLength() / 8);
  if (e.length > n - 11) {
    var a = new Error("Message is too long for PKCS#1 v1.5 padding.");
    throw a.length = e.length, a.max = n - 11, a;
  }
  r.putByte(0), r.putByte(i);
  var f = n - 3 - e.length, s;
  if (i === 0 || i === 1) {
    s = i === 0 ? 0 : 255;
    for (var c = 0; c < f; ++c)
      r.putByte(s);
  } else
    for (; f > 0; ) {
      for (var u = 0, o = _e.random.getBytes(f), c = 0; c < f; ++c)
        s = o.charCodeAt(c), s === 0 ? ++u : r.putByte(s);
      f = u;
    }
  return r.putByte(0), r.putBytes(e), r;
}
function Aa(e, t, i, r) {
  var n = Math.ceil(t.n.bitLength() / 8), a = _e.util.createBuffer(e), f = a.getByte(), s = a.getByte();
  if (f !== 0 || i && s !== 0 && s !== 1 || !i && s != 2 || i && s === 0 && typeof r > "u")
    throw new Error("Encryption block is invalid.");
  var c = 0;
  if (s === 0) {
    c = n - 3 - r;
    for (var u = 0; u < c; ++u)
      if (a.getByte() !== 0)
        throw new Error("Encryption block is invalid.");
  } else if (s === 1)
    for (c = 0; a.length() > 1; ) {
      if (a.getByte() !== 255) {
        --a.read;
        break;
      }
      ++c;
    }
  else if (s === 2)
    for (c = 0; a.length() > 1; ) {
      if (a.getByte() === 0) {
        --a.read;
        break;
      }
      ++c;
    }
  var o = a.getByte();
  if (o !== 0 || c !== n - 3 - a.length())
    throw new Error("Encryption block is invalid.");
  return a.getBytes();
}
function Sg(e, t, i) {
  typeof t == "function" && (i = t, t = {}), t = t || {};
  var r = {
    algorithm: {
      name: t.algorithm || "PRIMEINC",
      options: {
        workers: t.workers || 2,
        workLoad: t.workLoad || 100,
        workerScript: t.workerScript
      }
    }
  };
  "prng" in t && (r.prng = t.prng), n();
  function n() {
    a(e.pBits, function(s, c) {
      if (s)
        return i(s);
      if (e.p = c, e.q !== null)
        return f(s, e.q);
      a(e.qBits, f);
    });
  }
  function a(s, c) {
    _e.prime.generateProbablePrime(s, r, c);
  }
  function f(s, c) {
    if (s)
      return i(s);
    if (e.q = c, e.p.compareTo(e.q) < 0) {
      var u = e.p;
      e.p = e.q, e.q = u;
    }
    if (e.p.subtract(Ze.ONE).gcd(e.e).compareTo(Ze.ONE) !== 0) {
      e.p = null, n();
      return;
    }
    if (e.q.subtract(Ze.ONE).gcd(e.e).compareTo(Ze.ONE) !== 0) {
      e.q = null, a(e.qBits, f);
      return;
    }
    if (e.p1 = e.p.subtract(Ze.ONE), e.q1 = e.q.subtract(Ze.ONE), e.phi = e.p1.multiply(e.q1), e.phi.gcd(e.e).compareTo(Ze.ONE) !== 0) {
      e.p = e.q = null, n();
      return;
    }
    if (e.n = e.p.multiply(e.q), e.n.bitLength() !== e.bits) {
      e.q = null, a(e.qBits, f);
      return;
    }
    var o = e.e.modInverse(e.phi);
    e.keys = {
      privateKey: Ie.rsa.setPrivateKey(
        e.n,
        e.e,
        o,
        e.p,
        e.q,
        o.mod(e.p1),
        o.mod(e.q1),
        e.q.modInverse(e.p)
      ),
      publicKey: Ie.rsa.setPublicKey(e.n, e.e)
    }, i(null, e.keys);
  }
}
function pr(e) {
  var t = e.toString(16);
  t[0] >= "8" && (t = "00" + t);
  var i = _e.util.hexToBytes(t);
  return i.length > 1 && // leading 0x00 for positive integer
  (i.charCodeAt(0) === 0 && !(i.charCodeAt(1) & 128) || // leading 0xFF for negative integer
  i.charCodeAt(0) === 255 && (i.charCodeAt(1) & 128) === 128) ? i.substr(1) : i;
}
function Eg(e) {
  return e <= 100 ? 27 : e <= 150 ? 18 : e <= 200 ? 15 : e <= 250 ? 12 : e <= 300 ? 9 : e <= 350 ? 8 : e <= 400 ? 7 : e <= 500 ? 6 : e <= 600 ? 5 : e <= 800 ? 4 : e <= 1250 ? 3 : 2;
}
function Bh(e) {
  return _e.util.isNodejs && typeof No[e] == "function";
}
function Th(e) {
  return typeof nr.globalScope < "u" && typeof nr.globalScope.crypto == "object" && typeof nr.globalScope.crypto.subtle == "object" && typeof nr.globalScope.crypto.subtle[e] == "function";
}
function Ih(e) {
  return typeof nr.globalScope < "u" && typeof nr.globalScope.msCrypto == "object" && typeof nr.globalScope.msCrypto.subtle == "object" && typeof nr.globalScope.msCrypto.subtle[e] == "function";
}
function Rh(e) {
  for (var t = _e.util.hexToBytes(e.toString(16)), i = new Uint8Array(t.length), r = 0; r < t.length; ++r)
    i[r] = t.charCodeAt(r);
  return i;
}
var ge = je;
if (typeof wg > "u")
  var wg = ge.jsbn.BigInteger;
var ne = ge.asn1, Ke = ge.pki = ge.pki || {};
Ke.pbe = ge.pbe = ge.pbe || {};
var ai = Ke.oids, Cg = {
  name: "EncryptedPrivateKeyInfo",
  tagClass: ne.Class.UNIVERSAL,
  type: ne.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.OID,
      constructed: !1,
      capture: "encryptionOid"
    }, {
      name: "AlgorithmIdentifier.parameters",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "encryptionParams"
    }]
  }, {
    // encryptedData
    name: "EncryptedPrivateKeyInfo.encryptedData",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.OCTETSTRING,
    constructed: !1,
    capture: "encryptedData"
  }]
}, Ag = {
  name: "PBES2Algorithms",
  tagClass: ne.Class.UNIVERSAL,
  type: ne.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "PBES2Algorithms.keyDerivationFunc",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.keyDerivationFunc.oid",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.OID,
      constructed: !1,
      capture: "kdfOid"
    }, {
      name: "PBES2Algorithms.params",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PBES2Algorithms.params.salt",
        tagClass: ne.Class.UNIVERSAL,
        type: ne.Type.OCTETSTRING,
        constructed: !1,
        capture: "kdfSalt"
      }, {
        name: "PBES2Algorithms.params.iterationCount",
        tagClass: ne.Class.UNIVERSAL,
        type: ne.Type.INTEGER,
        constructed: !1,
        capture: "kdfIterationCount"
      }, {
        name: "PBES2Algorithms.params.keyLength",
        tagClass: ne.Class.UNIVERSAL,
        type: ne.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "keyLength"
      }, {
        // prf
        name: "PBES2Algorithms.params.prf",
        tagClass: ne.Class.UNIVERSAL,
        type: ne.Type.SEQUENCE,
        constructed: !0,
        optional: !0,
        value: [{
          name: "PBES2Algorithms.params.prf.algorithm",
          tagClass: ne.Class.UNIVERSAL,
          type: ne.Type.OID,
          constructed: !1,
          capture: "prfOid"
        }]
      }]
    }]
  }, {
    name: "PBES2Algorithms.encryptionScheme",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.encryptionScheme.oid",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.OID,
      constructed: !1,
      capture: "encOid"
    }, {
      name: "PBES2Algorithms.encryptionScheme.iv",
      tagClass: ne.Class.UNIVERSAL,
      type: ne.Type.OCTETSTRING,
      constructed: !1,
      capture: "encIv"
    }]
  }]
}, Bg = {
  name: "pkcs-12PbeParams",
  tagClass: ne.Class.UNIVERSAL,
  type: ne.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "pkcs-12PbeParams.salt",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.OCTETSTRING,
    constructed: !1,
    capture: "salt"
  }, {
    name: "pkcs-12PbeParams.iterations",
    tagClass: ne.Class.UNIVERSAL,
    type: ne.Type.INTEGER,
    constructed: !1,
    capture: "iterations"
  }]
};
Ke.encryptPrivateKeyInfo = function(e, t, i) {
  i = i || {}, i.saltSize = i.saltSize || 8, i.count = i.count || 2048, i.algorithm = i.algorithm || "aes128", i.prfAlgorithm = i.prfAlgorithm || "sha1";
  var r = ge.random.getBytesSync(i.saltSize), n = i.count, a = ne.integerToDer(n), f, s, c;
  if (i.algorithm.indexOf("aes") === 0 || i.algorithm === "des") {
    var u, o, l;
    switch (i.algorithm) {
      case "aes128":
        f = 16, u = 16, o = ai["aes128-CBC"], l = ge.aes.createEncryptionCipher;
        break;
      case "aes192":
        f = 24, u = 16, o = ai["aes192-CBC"], l = ge.aes.createEncryptionCipher;
        break;
      case "aes256":
        f = 32, u = 16, o = ai["aes256-CBC"], l = ge.aes.createEncryptionCipher;
        break;
      case "des":
        f = 8, u = 8, o = ai.desCBC, l = ge.des.createEncryptionCipher;
        break;
      default:
        var h = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        throw h.algorithm = i.algorithm, h;
    }
    var p = "hmacWith" + i.prfAlgorithm.toUpperCase(), v = up(p), y = ge.pkcs5.pbkdf2(t, r, n, f, v), w = ge.random.getBytesSync(u), x = l(y);
    x.start(w), x.update(ne.toDer(e)), x.finish(), c = x.output.getBytes();
    var A = Tg(r, a, f, p);
    s = ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.SEQUENCE,
      !0,
      [
        ne.create(
          ne.Class.UNIVERSAL,
          ne.Type.OID,
          !1,
          ne.oidToDer(ai.pkcs5PBES2).getBytes()
        ),
        ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
          // keyDerivationFunc
          ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
            ne.create(
              ne.Class.UNIVERSAL,
              ne.Type.OID,
              !1,
              ne.oidToDer(ai.pkcs5PBKDF2).getBytes()
            ),
            // PBKDF2-params
            A
          ]),
          // encryptionScheme
          ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
            ne.create(
              ne.Class.UNIVERSAL,
              ne.Type.OID,
              !1,
              ne.oidToDer(o).getBytes()
            ),
            // iv
            ne.create(
              ne.Class.UNIVERSAL,
              ne.Type.OCTETSTRING,
              !1,
              w
            )
          ])
        ])
      ]
    );
  } else if (i.algorithm === "3des") {
    f = 24;
    var R = new ge.util.ByteBuffer(r), y = Ke.pbe.generatePkcs12Key(t, R, 1, n, f), w = Ke.pbe.generatePkcs12Key(t, R, 2, n, f), x = ge.des.createEncryptionCipher(y);
    x.start(w), x.update(ne.toDer(e)), x.finish(), c = x.output.getBytes(), s = ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.SEQUENCE,
      !0,
      [
        ne.create(
          ne.Class.UNIVERSAL,
          ne.Type.OID,
          !1,
          ne.oidToDer(ai["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()
        ),
        // pkcs-12PbeParams
        ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
          // salt
          ne.create(ne.Class.UNIVERSAL, ne.Type.OCTETSTRING, !1, r),
          // iteration count
          ne.create(
            ne.Class.UNIVERSAL,
            ne.Type.INTEGER,
            !1,
            a.getBytes()
          )
        ])
      ]
    );
  } else {
    var h = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
    throw h.algorithm = i.algorithm, h;
  }
  var M = ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
    // encryptionAlgorithm
    s,
    // encryptedData
    ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.OCTETSTRING,
      !1,
      c
    )
  ]);
  return M;
};
Ke.decryptPrivateKeyInfo = function(e, t) {
  var i = null, r = {}, n = [];
  if (!ne.validate(e, Cg, r, n)) {
    var a = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw a.errors = n, a;
  }
  var f = ne.derToOid(r.encryptionOid), s = Ke.pbe.getCipher(f, r.encryptionParams, t), c = ge.util.createBuffer(r.encryptedData);
  return s.update(c), s.finish() && (i = ne.fromDer(s.output)), i;
};
Ke.encryptedPrivateKeyToPem = function(e, t) {
  var i = {
    type: "ENCRYPTED PRIVATE KEY",
    body: ne.toDer(e).getBytes()
  };
  return ge.pem.encode(i, { maxline: t });
};
Ke.encryptedPrivateKeyFromPem = function(e) {
  var t = ge.pem.decode(e)[0];
  if (t.type !== "ENCRYPTED PRIVATE KEY") {
    var i = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
    throw i.headerType = t.type, i;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
  return ne.fromDer(t.body);
};
Ke.encryptRsaPrivateKey = function(e, t, i) {
  if (i = i || {}, !i.legacy) {
    var r = Ke.wrapRsaPrivateKey(Ke.privateKeyToAsn1(e));
    return r = Ke.encryptPrivateKeyInfo(r, t, i), Ke.encryptedPrivateKeyToPem(r);
  }
  var n, a, f, s;
  switch (i.algorithm) {
    case "aes128":
      n = "AES-128-CBC", f = 16, a = ge.random.getBytesSync(16), s = ge.aes.createEncryptionCipher;
      break;
    case "aes192":
      n = "AES-192-CBC", f = 24, a = ge.random.getBytesSync(16), s = ge.aes.createEncryptionCipher;
      break;
    case "aes256":
      n = "AES-256-CBC", f = 32, a = ge.random.getBytesSync(16), s = ge.aes.createEncryptionCipher;
      break;
    case "3des":
      n = "DES-EDE3-CBC", f = 24, a = ge.random.getBytesSync(8), s = ge.des.createEncryptionCipher;
      break;
    case "des":
      n = "DES-CBC", f = 8, a = ge.random.getBytesSync(8), s = ge.des.createEncryptionCipher;
      break;
    default:
      var c = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + i.algorithm + '".');
      throw c.algorithm = i.algorithm, c;
  }
  var u = ge.pbe.opensslDeriveBytes(t, a.substr(0, 8), f), o = s(u);
  o.start(a), o.update(ne.toDer(Ke.privateKeyToAsn1(e))), o.finish();
  var l = {
    type: "RSA PRIVATE KEY",
    procType: {
      version: "4",
      type: "ENCRYPTED"
    },
    dekInfo: {
      algorithm: n,
      parameters: ge.util.bytesToHex(a).toUpperCase()
    },
    body: o.output.getBytes()
  };
  return ge.pem.encode(l);
};
Ke.decryptRsaPrivateKey = function(e, t) {
  var i = null, r = ge.pem.decode(e)[0];
  if (r.type !== "ENCRYPTED PRIVATE KEY" && r.type !== "PRIVATE KEY" && r.type !== "RSA PRIVATE KEY") {
    var n = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
    throw n.headerType = n, n;
  }
  if (r.procType && r.procType.type === "ENCRYPTED") {
    var a, f;
    switch (r.dekInfo.algorithm) {
      case "DES-CBC":
        a = 8, f = ge.des.createDecryptionCipher;
        break;
      case "DES-EDE3-CBC":
        a = 24, f = ge.des.createDecryptionCipher;
        break;
      case "AES-128-CBC":
        a = 16, f = ge.aes.createDecryptionCipher;
        break;
      case "AES-192-CBC":
        a = 24, f = ge.aes.createDecryptionCipher;
        break;
      case "AES-256-CBC":
        a = 32, f = ge.aes.createDecryptionCipher;
        break;
      case "RC2-40-CBC":
        a = 5, f = function(l) {
          return ge.rc2.createDecryptionCipher(l, 40);
        };
        break;
      case "RC2-64-CBC":
        a = 8, f = function(l) {
          return ge.rc2.createDecryptionCipher(l, 64);
        };
        break;
      case "RC2-128-CBC":
        a = 16, f = function(l) {
          return ge.rc2.createDecryptionCipher(l, 128);
        };
        break;
      default:
        var n = new Error('Could not decrypt private key; unsupported encryption algorithm "' + r.dekInfo.algorithm + '".');
        throw n.algorithm = r.dekInfo.algorithm, n;
    }
    var s = ge.util.hexToBytes(r.dekInfo.parameters), c = ge.pbe.opensslDeriveBytes(t, s.substr(0, 8), a), u = f(c);
    if (u.start(s), u.update(ge.util.createBuffer(r.body)), u.finish())
      i = u.output.getBytes();
    else
      return i;
  } else
    i = r.body;
  return r.type === "ENCRYPTED PRIVATE KEY" ? i = Ke.decryptPrivateKeyInfo(ne.fromDer(i), t) : i = ne.fromDer(i), i !== null && (i = Ke.privateKeyFromAsn1(i)), i;
};
Ke.pbe.generatePkcs12Key = function(e, t, i, r, n, a) {
  var f, s;
  if (typeof a > "u" || a === null) {
    if (!("sha1" in ge.md))
      throw new Error('"sha1" hash algorithm unavailable.');
    a = ge.md.sha1.create();
  }
  var c = a.digestLength, u = a.blockLength, o = new ge.util.ByteBuffer(), l = new ge.util.ByteBuffer();
  if (e != null) {
    for (s = 0; s < e.length; s++)
      l.putInt16(e.charCodeAt(s));
    l.putInt16(0);
  }
  var h = l.length(), p = t.length(), v = new ge.util.ByteBuffer();
  v.fillWithByte(i, u);
  var y = u * Math.ceil(p / u), w = new ge.util.ByteBuffer();
  for (s = 0; s < y; s++)
    w.putByte(t.at(s % p));
  var x = u * Math.ceil(h / u), A = new ge.util.ByteBuffer();
  for (s = 0; s < x; s++)
    A.putByte(l.at(s % h));
  var R = w;
  R.putBuffer(A);
  for (var M = Math.ceil(n / c), D = 1; D <= M; D++) {
    var U = new ge.util.ByteBuffer();
    U.putBytes(v.bytes()), U.putBytes(R.bytes());
    for (var z = 0; z < r; z++)
      a.start(), a.update(U.getBytes()), U = a.digest();
    var W = new ge.util.ByteBuffer();
    for (s = 0; s < u; s++)
      W.putByte(U.at(s % c));
    var G = Math.ceil(p / u) + Math.ceil(h / u), re = new ge.util.ByteBuffer();
    for (f = 0; f < G; f++) {
      var V = new ge.util.ByteBuffer(R.getBytes(u)), m = 511;
      for (s = W.length() - 1; s >= 0; s--)
        m = m >> 8, m += W.at(s) + V.at(s), V.setAt(s, m & 255);
      re.putBuffer(V);
    }
    R = re, o.putBuffer(U);
  }
  return o.truncate(o.length() - n), o;
};
Ke.pbe.getCipher = function(e, t, i) {
  switch (e) {
    case Ke.oids.pkcs5PBES2:
      return Ke.pbe.getCipherForPBES2(e, t, i);
    case Ke.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
    case Ke.oids["pbewithSHAAnd40BitRC2-CBC"]:
      return Ke.pbe.getCipherForPKCS12PBE(e, t, i);
    default:
      var r = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
      throw r.oid = e, r.supportedOids = [
        "pkcs5PBES2",
        "pbeWithSHAAnd3-KeyTripleDES-CBC",
        "pbewithSHAAnd40BitRC2-CBC"
      ], r;
  }
};
Ke.pbe.getCipherForPBES2 = function(e, t, i) {
  var r = {}, n = [];
  if (!ne.validate(t, Ag, r, n)) {
    var a = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw a.errors = n, a;
  }
  if (e = ne.derToOid(r.kdfOid), e !== Ke.oids.pkcs5PBKDF2) {
    var a = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
    throw a.oid = e, a.supportedOids = ["pkcs5PBKDF2"], a;
  }
  if (e = ne.derToOid(r.encOid), e !== Ke.oids["aes128-CBC"] && e !== Ke.oids["aes192-CBC"] && e !== Ke.oids["aes256-CBC"] && e !== Ke.oids["des-EDE3-CBC"] && e !== Ke.oids.desCBC) {
    var a = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
    throw a.oid = e, a.supportedOids = [
      "aes128-CBC",
      "aes192-CBC",
      "aes256-CBC",
      "des-EDE3-CBC",
      "desCBC"
    ], a;
  }
  var f = r.kdfSalt, s = ge.util.createBuffer(r.kdfIterationCount);
  s = s.getInt(s.length() << 3);
  var c, u;
  switch (Ke.oids[e]) {
    case "aes128-CBC":
      c = 16, u = ge.aes.createDecryptionCipher;
      break;
    case "aes192-CBC":
      c = 24, u = ge.aes.createDecryptionCipher;
      break;
    case "aes256-CBC":
      c = 32, u = ge.aes.createDecryptionCipher;
      break;
    case "des-EDE3-CBC":
      c = 24, u = ge.des.createDecryptionCipher;
      break;
    case "desCBC":
      c = 8, u = ge.des.createDecryptionCipher;
      break;
  }
  var o = op(r.prfOid), l = ge.pkcs5.pbkdf2(i, f, s, c, o), h = r.encIv, p = u(l);
  return p.start(h), p;
};
Ke.pbe.getCipherForPKCS12PBE = function(e, t, i) {
  var r = {}, n = [];
  if (!ne.validate(t, Bg, r, n)) {
    var a = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw a.errors = n, a;
  }
  var f = ge.util.createBuffer(r.salt), s = ge.util.createBuffer(r.iterations);
  s = s.getInt(s.length() << 3);
  var c, u, o;
  switch (e) {
    case Ke.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
      c = 24, u = 8, o = ge.des.startDecrypting;
      break;
    case Ke.oids["pbewithSHAAnd40BitRC2-CBC"]:
      c = 5, u = 8, o = function(y, w) {
        var x = ge.rc2.createDecryptionCipher(y, 40);
        return x.start(w, null), x;
      };
      break;
    default:
      var a = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
      throw a.oid = e, a;
  }
  var l = op(r.prfOid), h = Ke.pbe.generatePkcs12Key(i, f, 1, s, c, l);
  l.start();
  var p = Ke.pbe.generatePkcs12Key(i, f, 2, s, u, l);
  return o(h, p);
};
Ke.pbe.opensslDeriveBytes = function(e, t, i, r) {
  if (typeof r > "u" || r === null) {
    if (!("md5" in ge.md))
      throw new Error('"md5" hash algorithm unavailable.');
    r = ge.md.md5.create();
  }
  t === null && (t = "");
  for (var n = [Mh(r, e + t)], a = 16, f = 1; a < i; ++f, a += 16)
    n.push(Mh(r, n[f - 1] + e + t));
  return n.join("").substr(0, i);
};
function Mh(e, t) {
  return e.start().update(t).digest().getBytes();
}
function op(e) {
  var t;
  if (!e)
    t = "hmacWithSHA1";
  else if (t = Ke.oids[ne.derToOid(e)], !t) {
    var i = new Error("Unsupported PRF OID.");
    throw i.oid = e, i.supported = [
      "hmacWithSHA1",
      "hmacWithSHA224",
      "hmacWithSHA256",
      "hmacWithSHA384",
      "hmacWithSHA512"
    ], i;
  }
  return up(t);
}
function up(e) {
  var t = ge.md;
  switch (e) {
    case "hmacWithSHA224":
      t = ge.md.sha512;
    case "hmacWithSHA1":
    case "hmacWithSHA256":
    case "hmacWithSHA384":
    case "hmacWithSHA512":
      e = e.substr(8).toLowerCase();
      break;
    default:
      var i = new Error("Unsupported PRF algorithm.");
      throw i.algorithm = e, i.supported = [
        "hmacWithSHA1",
        "hmacWithSHA224",
        "hmacWithSHA256",
        "hmacWithSHA384",
        "hmacWithSHA512"
      ], i;
  }
  if (!t || !(e in t))
    throw new Error("Unknown hash algorithm: " + e);
  return t[e].create();
}
function Tg(e, t, i, r) {
  var n = ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
    // salt
    ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.OCTETSTRING,
      !1,
      e
    ),
    // iteration count
    ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.INTEGER,
      !1,
      t.getBytes()
    )
  ]);
  return r !== "hmacWithSHA1" && n.value.push(
    // key length
    ne.create(
      ne.Class.UNIVERSAL,
      ne.Type.INTEGER,
      !1,
      ge.util.hexToBytes(i.toString(16))
    ),
    // AlgorithmIdentifier
    ne.create(ne.Class.UNIVERSAL, ne.Type.SEQUENCE, !0, [
      // algorithm
      ne.create(
        ne.Class.UNIVERSAL,
        ne.Type.OID,
        !1,
        ne.oidToDer(Ke.oids[r]).getBytes()
      ),
      // parameters (null)
      ne.create(ne.Class.UNIVERSAL, ne.Type.NULL, !1, "")
    ])
  ), n;
}
var xi = je, ye = xi.asn1, Ri = xi.pkcs7asn1 = xi.pkcs7asn1 || {};
xi.pkcs7 = xi.pkcs7 || {};
xi.pkcs7.asn1 = Ri;
var cp = {
  name: "ContentInfo",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "ContentInfo.ContentType",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: ye.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    captureAsn1: "content"
  }]
};
Ri.contentInfoValidator = cp;
var lp = {
  name: "EncryptedContentInfo",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedContentInfo.contentType",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "EncryptedContentInfo.contentEncryptionAlgorithm",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
      tagClass: ye.Class.UNIVERSAL,
      captureAsn1: "encParameter"
    }]
  }, {
    name: "EncryptedContentInfo.encryptedContent",
    tagClass: ye.Class.CONTEXT_SPECIFIC,
    type: 0,
    /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */
    capture: "encryptedContent",
    captureAsn1: "encryptedContentAsn1"
  }]
};
Ri.envelopedDataValidator = {
  name: "EnvelopedData",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EnvelopedData.Version",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "EnvelopedData.RecipientInfos",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SET,
    constructed: !0,
    captureAsn1: "recipientInfos"
  }].concat(lp)
};
Ri.encryptedDataValidator = {
  name: "EncryptedData",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedData.Version",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }].concat(lp)
};
var Ig = {
  name: "SignerInfo",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SignerInfo.version",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.INTEGER,
    constructed: !1
  }, {
    name: "SignerInfo.issuerAndSerialNumber",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.issuerAndSerialNumber.issuer",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "SignerInfo.issuerAndSerialNumber.serialNumber",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "SignerInfo.digestAlgorithm",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.digestAlgorithm.algorithm",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.OID,
      constructed: !1,
      capture: "digestAlgorithm"
    }, {
      name: "SignerInfo.digestAlgorithm.parameter",
      tagClass: ye.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "digestParameter",
      optional: !0
    }]
  }, {
    name: "SignerInfo.authenticatedAttributes",
    tagClass: ye.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    capture: "authenticatedAttributes"
  }, {
    name: "SignerInfo.digestEncryptionAlgorithm",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    capture: "signatureAlgorithm"
  }, {
    name: "SignerInfo.encryptedDigest",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.OCTETSTRING,
    constructed: !1,
    capture: "signature"
  }, {
    name: "SignerInfo.unauthenticatedAttributes",
    tagClass: ye.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    optional: !0,
    capture: "unauthenticatedAttributes"
  }]
};
Ri.signedDataValidator = {
  name: "SignedData",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "SignedData.Version",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    {
      name: "SignedData.DigestAlgorithms",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.SET,
      constructed: !0,
      captureAsn1: "digestAlgorithms"
    },
    cp,
    {
      name: "SignedData.Certificates",
      tagClass: ye.Class.CONTEXT_SPECIFIC,
      type: 0,
      optional: !0,
      captureAsn1: "certificates"
    },
    {
      name: "SignedData.CertificateRevocationLists",
      tagClass: ye.Class.CONTEXT_SPECIFIC,
      type: 1,
      optional: !0,
      captureAsn1: "crls"
    },
    {
      name: "SignedData.SignerInfos",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.SET,
      capture: "signerInfos",
      optional: !0,
      value: [Ig]
    }
  ]
};
Ri.recipientInfoValidator = {
  name: "RecipientInfo",
  tagClass: ye.Class.UNIVERSAL,
  type: ye.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "RecipientInfo.version",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "RecipientInfo.issuerAndSerial",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.issuerAndSerial.issuer",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "RecipientInfo.issuerAndSerial.serialNumber",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "RecipientInfo.keyEncryptionAlgorithm",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
      tagClass: ye.Class.UNIVERSAL,
      type: ye.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
      tagClass: ye.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "encParameter",
      optional: !0
    }]
  }, {
    name: "RecipientInfo.encryptedKey",
    tagClass: ye.Class.UNIVERSAL,
    type: ye.Type.OCTETSTRING,
    constructed: !1,
    capture: "encKey"
  }]
};
var ui = je;
ui.mgf = ui.mgf || {};
var Rg = ui.mgf.mgf1 = ui.mgf1 = ui.mgf1 || {};
Rg.create = function(e) {
  var t = {
    /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */
    generate: function(i, r) {
      for (var n = new ui.util.ByteBuffer(), a = Math.ceil(r / e.digestLength), f = 0; f < a; f++) {
        var s = new ui.util.ByteBuffer();
        s.putInt32(f), e.start(), e.update(i + s.getBytes()), n.putBuffer(e.digest());
      }
      return n.truncate(n.length() - r), n.getBytes();
    }
  };
  return t;
};
var Ba = je;
Ba.mgf = Ba.mgf || {};
Ba.mgf.mgf1 = Ba.mgf1;
var ni = je, Mg = ni.pss = ni.pss || {};
Mg.create = function(e) {
  arguments.length === 3 && (e = {
    md: arguments[0],
    mgf: arguments[1],
    saltLength: arguments[2]
  });
  var t = e.md, i = e.mgf, r = t.digestLength, n = e.salt || null;
  typeof n == "string" && (n = ni.util.createBuffer(n));
  var a;
  if ("saltLength" in e)
    a = e.saltLength;
  else if (n !== null)
    a = n.length();
  else
    throw new Error("Salt length not specified or specific salt not given.");
  if (n !== null && n.length() !== a)
    throw new Error("Given salt length does not match length of given salt.");
  var f = e.prng || ni.random, s = {};
  return s.encode = function(c, u) {
    var o, l = u - 1, h = Math.ceil(l / 8), p = c.digest().getBytes();
    if (h < r + a + 2)
      throw new Error("Message is too long to encrypt.");
    var v;
    n === null ? v = f.getBytesSync(a) : v = n.bytes();
    var y = new ni.util.ByteBuffer();
    y.fillWithByte(0, 8), y.putBytes(p), y.putBytes(v), t.start(), t.update(y.getBytes());
    var w = t.digest().getBytes(), x = new ni.util.ByteBuffer();
    x.fillWithByte(0, h - a - r - 2), x.putByte(1), x.putBytes(v);
    var A = x.getBytes(), R = h - r - 1, M = i.generate(w, R), D = "";
    for (o = 0; o < R; o++)
      D += String.fromCharCode(A.charCodeAt(o) ^ M.charCodeAt(o));
    var U = 65280 >> 8 * h - l & 255;
    return D = String.fromCharCode(D.charCodeAt(0) & ~U) + D.substr(1), D + w + "¼";
  }, s.verify = function(c, u, o) {
    var l, h = o - 1, p = Math.ceil(h / 8);
    if (u = u.substr(-p), p < r + a + 2)
      throw new Error("Inconsistent parameters to PSS signature verification.");
    if (u.charCodeAt(p - 1) !== 188)
      throw new Error("Encoded message does not end in 0xBC.");
    var v = p - r - 1, y = u.substr(0, v), w = u.substr(v, r), x = 65280 >> 8 * p - h & 255;
    if (y.charCodeAt(0) & x)
      throw new Error("Bits beyond keysize not zero as expected.");
    var A = i.generate(w, v), R = "";
    for (l = 0; l < v; l++)
      R += String.fromCharCode(y.charCodeAt(l) ^ A.charCodeAt(l));
    R = String.fromCharCode(R.charCodeAt(0) & ~x) + R.substr(1);
    var M = p - r - a - 2;
    for (l = 0; l < M; l++)
      if (R.charCodeAt(l) !== 0)
        throw new Error("Leftmost octets not zero as expected");
    if (R.charCodeAt(M) !== 1)
      throw new Error("Inconsistent PSS signature, 0x01 marker not found");
    var D = R.substr(-a), U = new ni.util.ByteBuffer();
    U.fillWithByte(0, 8), U.putBytes(c), U.putBytes(D), t.start(), t.update(U.getBytes());
    var z = t.digest().getBytes();
    return w === z;
  }, s;
};
var Se = je, O = Se.asn1, he = Se.pki = Se.pki || {}, Xe = he.oids, Dt = {};
Dt.CN = Xe.commonName;
Dt.commonName = "CN";
Dt.C = Xe.countryName;
Dt.countryName = "C";
Dt.L = Xe.localityName;
Dt.localityName = "L";
Dt.ST = Xe.stateOrProvinceName;
Dt.stateOrProvinceName = "ST";
Dt.O = Xe.organizationName;
Dt.organizationName = "O";
Dt.OU = Xe.organizationalUnitName;
Dt.organizationalUnitName = "OU";
Dt.E = Xe.emailAddress;
Dt.emailAddress = "E";
var hp = Se.pki.rsa.publicKeyValidator, Ng = {
  name: "Certificate",
  tagClass: O.Class.UNIVERSAL,
  type: O.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Certificate.TBSCertificate",
    tagClass: O.Class.UNIVERSAL,
    type: O.Type.SEQUENCE,
    constructed: !0,
    captureAsn1: "tbsCertificate",
    value: [
      {
        name: "Certificate.TBSCertificate.version",
        tagClass: O.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.version.integer",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.INTEGER,
          constructed: !1,
          capture: "certVersion"
        }]
      },
      {
        name: "Certificate.TBSCertificate.serialNumber",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.INTEGER,
        constructed: !1,
        capture: "certSerialNumber"
      },
      {
        name: "Certificate.TBSCertificate.signature",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.TBSCertificate.signature.algorithm",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.OID,
          constructed: !1,
          capture: "certinfoSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: O.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "certinfoSignatureParams"
        }]
      },
      {
        name: "Certificate.TBSCertificate.issuer",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certIssuer"
      },
      {
        name: "Certificate.TBSCertificate.validity",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        // Note: UTC and generalized times may both appear so the capture
        // names are based on their detected order, the names used below
        // are only for the common case, which validity time really means
        // "notBefore" and which means "notAfter" will be determined by order
        value: [{
          // notBefore (Time) (UTC time case)
          name: "Certificate.TBSCertificate.validity.notBefore (utc)",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity1UTCTime"
        }, {
          // notBefore (Time) (generalized time case)
          name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity2GeneralizedTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (utc)",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity3UTCTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity4GeneralizedTime"
        }]
      },
      {
        // Name (subject) (RDNSequence)
        name: "Certificate.TBSCertificate.subject",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certSubject"
      },
      // SubjectPublicKeyInfo
      hp,
      {
        // issuerUniqueID (optional)
        name: "Certificate.TBSCertificate.issuerUniqueID",
        tagClass: O.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.issuerUniqueID.id",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certIssuerUniqueId"
        }]
      },
      {
        // subjectUniqueID (optional)
        name: "Certificate.TBSCertificate.subjectUniqueID",
        tagClass: O.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.subjectUniqueID.id",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certSubjectUniqueId"
        }]
      },
      {
        // Extensions (optional)
        name: "Certificate.TBSCertificate.extensions",
        tagClass: O.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: !0,
        captureAsn1: "certExtensions",
        optional: !0
      }
    ]
  }, {
    // AlgorithmIdentifier (signature algorithm)
    name: "Certificate.signatureAlgorithm",
    tagClass: O.Class.UNIVERSAL,
    type: O.Type.SEQUENCE,
    constructed: !0,
    value: [{
      // algorithm
      name: "Certificate.signatureAlgorithm.algorithm",
      tagClass: O.Class.UNIVERSAL,
      type: O.Type.OID,
      constructed: !1,
      capture: "certSignatureOid"
    }, {
      name: "Certificate.TBSCertificate.signature.parameters",
      tagClass: O.Class.UNIVERSAL,
      optional: !0,
      captureAsn1: "certSignatureParams"
    }]
  }, {
    // SignatureValue
    name: "Certificate.signatureValue",
    tagClass: O.Class.UNIVERSAL,
    type: O.Type.BITSTRING,
    constructed: !1,
    captureBitStringValue: "certSignature"
  }]
}, kg = {
  name: "rsapss",
  tagClass: O.Class.UNIVERSAL,
  type: O.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "rsapss.hashAlgorithm",
    tagClass: O.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    value: [{
      name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
      tagClass: O.Class.UNIVERSAL,
      type: O.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.OID,
        constructed: !1,
        capture: "hashOid"
        /* parameter block omitted, for SHA1 NULL anyhow. */
      }]
    }]
  }, {
    name: "rsapss.maskGenAlgorithm",
    tagClass: O.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    value: [{
      name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
      tagClass: O.Class.UNIVERSAL,
      type: O.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.OID,
        constructed: !1,
        capture: "maskGenOid"
      }, {
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.OID,
          constructed: !1,
          capture: "maskGenHashOid"
          /* parameter block omitted, for SHA1 NULL anyhow. */
        }]
      }]
    }]
  }, {
    name: "rsapss.saltLength",
    tagClass: O.Class.CONTEXT_SPECIFIC,
    type: 2,
    optional: !0,
    value: [{
      name: "rsapss.saltLength.saltLength",
      tagClass: O.Class.UNIVERSAL,
      type: O.Class.INTEGER,
      constructed: !1,
      capture: "saltLength"
    }]
  }, {
    name: "rsapss.trailerField",
    tagClass: O.Class.CONTEXT_SPECIFIC,
    type: 3,
    optional: !0,
    value: [{
      name: "rsapss.trailer.trailer",
      tagClass: O.Class.UNIVERSAL,
      type: O.Class.INTEGER,
      constructed: !1,
      capture: "trailer"
    }]
  }]
}, Dg = {
  name: "CertificationRequestInfo",
  tagClass: O.Class.UNIVERSAL,
  type: O.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "certificationRequestInfo",
  value: [
    {
      name: "CertificationRequestInfo.integer",
      tagClass: O.Class.UNIVERSAL,
      type: O.Type.INTEGER,
      constructed: !1,
      capture: "certificationRequestInfoVersion"
    },
    {
      // Name (subject) (RDNSequence)
      name: "CertificationRequestInfo.subject",
      tagClass: O.Class.UNIVERSAL,
      type: O.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "certificationRequestInfoSubject"
    },
    // SubjectPublicKeyInfo
    hp,
    {
      name: "CertificationRequestInfo.attributes",
      tagClass: O.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: !0,
      optional: !0,
      capture: "certificationRequestInfoAttributes",
      value: [{
        name: "CertificationRequestInfo.attributes",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "CertificationRequestInfo.attributes.type",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.OID,
          constructed: !1
        }, {
          name: "CertificationRequestInfo.attributes.value",
          tagClass: O.Class.UNIVERSAL,
          type: O.Type.SET,
          constructed: !0
        }]
      }]
    }
  ]
}, Lg = {
  name: "CertificationRequest",
  tagClass: O.Class.UNIVERSAL,
  type: O.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "csr",
  value: [
    Dg,
    {
      // AlgorithmIdentifier (signature algorithm)
      name: "CertificationRequest.signatureAlgorithm",
      tagClass: O.Class.UNIVERSAL,
      type: O.Type.SEQUENCE,
      constructed: !0,
      value: [{
        // algorithm
        name: "CertificationRequest.signatureAlgorithm.algorithm",
        tagClass: O.Class.UNIVERSAL,
        type: O.Type.OID,
        constructed: !1,
        capture: "csrSignatureOid"
      }, {
        name: "CertificationRequest.signatureAlgorithm.parameters",
        tagClass: O.Class.UNIVERSAL,
        optional: !0,
        captureAsn1: "csrSignatureParams"
      }]
    },
    {
      // signature
      name: "CertificationRequest.signature",
      tagClass: O.Class.UNIVERSAL,
      type: O.Type.BITSTRING,
      constructed: !1,
      captureBitStringValue: "csrSignature"
    }
  ]
};
he.RDNAttributesAsArray = function(e, t) {
  for (var i = [], r, n, a, f = 0; f < e.value.length; ++f) {
    r = e.value[f];
    for (var s = 0; s < r.value.length; ++s)
      a = {}, n = r.value[s], a.type = O.derToOid(n.value[0].value), a.value = n.value[1].value, a.valueTagClass = n.value[1].type, a.type in Xe && (a.name = Xe[a.type], a.name in Dt && (a.shortName = Dt[a.name])), t && (t.update(a.type), t.update(a.value)), i.push(a);
  }
  return i;
};
he.CRIAttributesAsArray = function(e) {
  for (var t = [], i = 0; i < e.length; ++i)
    for (var r = e[i], n = O.derToOid(r.value[0].value), a = r.value[1].value, f = 0; f < a.length; ++f) {
      var s = {};
      if (s.type = n, s.value = a[f].value, s.valueTagClass = a[f].type, s.type in Xe && (s.name = Xe[s.type], s.name in Dt && (s.shortName = Dt[s.name])), s.type === Xe.extensionRequest) {
        s.extensions = [];
        for (var c = 0; c < s.value.length; ++c)
          s.extensions.push(he.certificateExtensionFromAsn1(s.value[c]));
      }
      t.push(s);
    }
  return t;
};
function Lr(e, t) {
  typeof t == "string" && (t = { shortName: t });
  for (var i = null, r, n = 0; i === null && n < e.attributes.length; ++n)
    r = e.attributes[n], (t.type && t.type === r.type || t.name && t.name === r.name || t.shortName && t.shortName === r.shortName) && (i = r);
  return i;
}
var Ta = function(e, t, i) {
  var r = {};
  if (e !== Xe["RSASSA-PSS"])
    return r;
  i && (r = {
    hash: {
      algorithmOid: Xe.sha1
    },
    mgf: {
      algorithmOid: Xe.mgf1,
      hash: {
        algorithmOid: Xe.sha1
      }
    },
    saltLength: 20
  });
  var n = {}, a = [];
  if (!O.validate(t, kg, n, a)) {
    var f = new Error("Cannot read RSASSA-PSS parameter block.");
    throw f.errors = a, f;
  }
  return n.hashOid !== void 0 && (r.hash = r.hash || {}, r.hash.algorithmOid = O.derToOid(n.hashOid)), n.maskGenOid !== void 0 && (r.mgf = r.mgf || {}, r.mgf.algorithmOid = O.derToOid(n.maskGenOid), r.mgf.hash = r.mgf.hash || {}, r.mgf.hash.algorithmOid = O.derToOid(n.maskGenHashOid)), n.saltLength !== void 0 && (r.saltLength = n.saltLength.charCodeAt(0)), r;
}, Qa = function(e) {
  switch (Xe[e.signatureOid]) {
    case "sha1WithRSAEncryption":
    case "sha1WithRSASignature":
      return Se.md.sha1.create();
    case "md5WithRSAEncryption":
      return Se.md.md5.create();
    case "sha256WithRSAEncryption":
      return Se.md.sha256.create();
    case "sha384WithRSAEncryption":
      return Se.md.sha384.create();
    case "sha512WithRSAEncryption":
      return Se.md.sha512.create();
    case "RSASSA-PSS":
      return Se.md.sha256.create();
    default:
      var t = new Error(
        "Could not compute " + e.type + " digest. Unknown signature OID."
      );
      throw t.signatureOid = e.signatureOid, t;
  }
}, dp = function(e) {
  var t = e.certificate, i;
  switch (t.signatureOid) {
    case Xe.sha1WithRSAEncryption:
    case Xe.sha1WithRSASignature:
      break;
    case Xe["RSASSA-PSS"]:
      var r, n;
      if (r = Xe[t.signatureParameters.mgf.hash.algorithmOid], r === void 0 || Se.md[r] === void 0) {
        var a = new Error("Unsupported MGF hash function.");
        throw a.oid = t.signatureParameters.mgf.hash.algorithmOid, a.name = r, a;
      }
      if (n = Xe[t.signatureParameters.mgf.algorithmOid], n === void 0 || Se.mgf[n] === void 0) {
        var a = new Error("Unsupported MGF function.");
        throw a.oid = t.signatureParameters.mgf.algorithmOid, a.name = n, a;
      }
      if (n = Se.mgf[n].create(Se.md[r].create()), r = Xe[t.signatureParameters.hash.algorithmOid], r === void 0 || Se.md[r] === void 0) {
        var a = new Error("Unsupported RSASSA-PSS hash function.");
        throw a.oid = t.signatureParameters.hash.algorithmOid, a.name = r, a;
      }
      i = Se.pss.create(
        Se.md[r].create(),
        n,
        t.signatureParameters.saltLength
      );
      break;
  }
  return t.publicKey.verify(
    e.md.digest().getBytes(),
    e.signature,
    i
  );
};
he.certificateFromPem = function(e, t, i) {
  var r = Se.pem.decode(e)[0];
  if (r.type !== "CERTIFICATE" && r.type !== "X509 CERTIFICATE" && r.type !== "TRUSTED CERTIFICATE") {
    var n = new Error(
      'Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".'
    );
    throw n.headerType = r.type, n;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error(
      "Could not convert certificate from PEM; PEM is encrypted."
    );
  var a = O.fromDer(r.body, i);
  return he.certificateFromAsn1(a, t);
};
he.certificateToPem = function(e, t) {
  var i = {
    type: "CERTIFICATE",
    body: O.toDer(he.certificateToAsn1(e)).getBytes()
  };
  return Se.pem.encode(i, { maxline: t });
};
he.publicKeyFromPem = function(e) {
  var t = Se.pem.decode(e)[0];
  if (t.type !== "PUBLIC KEY" && t.type !== "RSA PUBLIC KEY") {
    var i = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
    throw i.headerType = t.type, i;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert public key from PEM; PEM is encrypted.");
  var r = O.fromDer(t.body);
  return he.publicKeyFromAsn1(r);
};
he.publicKeyToPem = function(e, t) {
  var i = {
    type: "PUBLIC KEY",
    body: O.toDer(he.publicKeyToAsn1(e)).getBytes()
  };
  return Se.pem.encode(i, { maxline: t });
};
he.publicKeyToRSAPublicKeyPem = function(e, t) {
  var i = {
    type: "RSA PUBLIC KEY",
    body: O.toDer(he.publicKeyToRSAPublicKey(e)).getBytes()
  };
  return Se.pem.encode(i, { maxline: t });
};
he.getPublicKeyFingerprint = function(e, t) {
  t = t || {};
  var i = t.md || Se.md.sha1.create(), r = t.type || "RSAPublicKey", n;
  switch (r) {
    case "RSAPublicKey":
      n = O.toDer(he.publicKeyToRSAPublicKey(e)).getBytes();
      break;
    case "SubjectPublicKeyInfo":
      n = O.toDer(he.publicKeyToAsn1(e)).getBytes();
      break;
    default:
      throw new Error('Unknown fingerprint type "' + t.type + '".');
  }
  i.start(), i.update(n);
  var a = i.digest();
  if (t.encoding === "hex") {
    var f = a.toHex();
    return t.delimiter ? f.match(/.{2}/g).join(t.delimiter) : f;
  } else {
    if (t.encoding === "binary")
      return a.getBytes();
    if (t.encoding)
      throw new Error('Unknown encoding "' + t.encoding + '".');
  }
  return a;
};
he.certificationRequestFromPem = function(e, t, i) {
  var r = Se.pem.decode(e)[0];
  if (r.type !== "CERTIFICATE REQUEST") {
    var n = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
    throw n.headerType = r.type, n;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
  var a = O.fromDer(r.body, i);
  return he.certificationRequestFromAsn1(a, t);
};
he.certificationRequestToPem = function(e, t) {
  var i = {
    type: "CERTIFICATE REQUEST",
    body: O.toDer(he.certificationRequestToAsn1(e)).getBytes()
  };
  return Se.pem.encode(i, { maxline: t });
};
he.createCertificate = function() {
  var e = {};
  return e.version = 2, e.serialNumber = "00", e.signatureOid = null, e.signature = null, e.siginfo = {}, e.siginfo.algorithmOid = null, e.validity = {}, e.validity.notBefore = /* @__PURE__ */ new Date(), e.validity.notAfter = /* @__PURE__ */ new Date(), e.issuer = {}, e.issuer.getField = function(t) {
    return Lr(e.issuer, t);
  }, e.issuer.addField = function(t) {
    fr([t]), e.issuer.attributes.push(t);
  }, e.issuer.attributes = [], e.issuer.hash = null, e.subject = {}, e.subject.getField = function(t) {
    return Lr(e.subject, t);
  }, e.subject.addField = function(t) {
    fr([t]), e.subject.attributes.push(t);
  }, e.subject.attributes = [], e.subject.hash = null, e.extensions = [], e.publicKey = null, e.md = null, e.setSubject = function(t, i) {
    fr(t), e.subject.attributes = t, delete e.subject.uniqueId, i && (e.subject.uniqueId = i), e.subject.hash = null;
  }, e.setIssuer = function(t, i) {
    fr(t), e.issuer.attributes = t, delete e.issuer.uniqueId, i && (e.issuer.uniqueId = i), e.issuer.hash = null;
  }, e.setExtensions = function(t) {
    for (var i = 0; i < t.length; ++i)
      pp(t[i], { cert: e });
    e.extensions = t;
  }, e.getExtension = function(t) {
    typeof t == "string" && (t = { name: t });
    for (var i = null, r, n = 0; i === null && n < e.extensions.length; ++n)
      r = e.extensions[n], (t.id && r.id === t.id || t.name && r.name === t.name) && (i = r);
    return i;
  }, e.sign = function(t, i) {
    e.md = i || Se.md.sha1.create();
    var r = Xe[e.md.algorithm + "WithRSAEncryption"];
    if (!r) {
      var n = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
      throw n.algorithm = e.md.algorithm, n;
    }
    e.signatureOid = e.siginfo.algorithmOid = r, e.tbsCertificate = he.getTBSCertificate(e);
    var a = O.toDer(e.tbsCertificate);
    e.md.update(a.getBytes()), e.signature = t.sign(e.md);
  }, e.verify = function(t) {
    var i = !1;
    if (!e.issued(t)) {
      var r = t.issuer, n = e.subject, a = new Error(
        "The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject."
      );
      throw a.expectedIssuer = n.attributes, a.actualIssuer = r.attributes, a;
    }
    var f = t.md;
    if (f === null) {
      f = Qa({
        signatureOid: t.signatureOid,
        type: "certificate"
      });
      var s = t.tbsCertificate || he.getTBSCertificate(t), c = O.toDer(s);
      f.update(c.getBytes());
    }
    return f !== null && (i = dp({
      certificate: e,
      md: f,
      signature: t.signature
    })), i;
  }, e.isIssuer = function(t) {
    var i = !1, r = e.issuer, n = t.subject;
    if (r.hash && n.hash)
      i = r.hash === n.hash;
    else if (r.attributes.length === n.attributes.length) {
      i = !0;
      for (var a, f, s = 0; i && s < r.attributes.length; ++s)
        a = r.attributes[s], f = n.attributes[s], (a.type !== f.type || a.value !== f.value) && (i = !1);
    }
    return i;
  }, e.issued = function(t) {
    return t.isIssuer(e);
  }, e.generateSubjectKeyIdentifier = function() {
    return he.getPublicKeyFingerprint(e.publicKey, { type: "RSAPublicKey" });
  }, e.verifySubjectKeyIdentifier = function() {
    for (var t = Xe.subjectKeyIdentifier, i = 0; i < e.extensions.length; ++i) {
      var r = e.extensions[i];
      if (r.id === t) {
        var n = e.generateSubjectKeyIdentifier().getBytes();
        return Se.util.hexToBytes(r.subjectKeyIdentifier) === n;
      }
    }
    return !1;
  }, e;
};
he.certificateFromAsn1 = function(e, t) {
  var i = {}, r = [];
  if (!O.validate(e, Ng, i, r)) {
    var n = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
    throw n.errors = r, n;
  }
  var a = O.derToOid(i.publicKeyOid);
  if (a !== he.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var f = he.createCertificate();
  f.version = i.certVersion ? i.certVersion.charCodeAt(0) : 0;
  var s = Se.util.createBuffer(i.certSerialNumber);
  f.serialNumber = s.toHex(), f.signatureOid = Se.asn1.derToOid(i.certSignatureOid), f.signatureParameters = Ta(
    f.signatureOid,
    i.certSignatureParams,
    !0
  ), f.siginfo.algorithmOid = Se.asn1.derToOid(i.certinfoSignatureOid), f.siginfo.parameters = Ta(
    f.siginfo.algorithmOid,
    i.certinfoSignatureParams,
    !1
  ), f.signature = i.certSignature;
  var c = [];
  if (i.certValidity1UTCTime !== void 0 && c.push(O.utcTimeToDate(i.certValidity1UTCTime)), i.certValidity2GeneralizedTime !== void 0 && c.push(O.generalizedTimeToDate(
    i.certValidity2GeneralizedTime
  )), i.certValidity3UTCTime !== void 0 && c.push(O.utcTimeToDate(i.certValidity3UTCTime)), i.certValidity4GeneralizedTime !== void 0 && c.push(O.generalizedTimeToDate(
    i.certValidity4GeneralizedTime
  )), c.length > 2)
    throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
  if (c.length < 2)
    throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
  if (f.validity.notBefore = c[0], f.validity.notAfter = c[1], f.tbsCertificate = i.tbsCertificate, t) {
    f.md = Qa({
      signatureOid: f.signatureOid,
      type: "certificate"
    });
    var u = O.toDer(f.tbsCertificate);
    f.md.update(u.getBytes());
  }
  var o = Se.md.sha1.create(), l = O.toDer(i.certIssuer);
  o.update(l.getBytes()), f.issuer.getField = function(v) {
    return Lr(f.issuer, v);
  }, f.issuer.addField = function(v) {
    fr([v]), f.issuer.attributes.push(v);
  }, f.issuer.attributes = he.RDNAttributesAsArray(i.certIssuer), i.certIssuerUniqueId && (f.issuer.uniqueId = i.certIssuerUniqueId), f.issuer.hash = o.digest().toHex();
  var h = Se.md.sha1.create(), p = O.toDer(i.certSubject);
  return h.update(p.getBytes()), f.subject.getField = function(v) {
    return Lr(f.subject, v);
  }, f.subject.addField = function(v) {
    fr([v]), f.subject.attributes.push(v);
  }, f.subject.attributes = he.RDNAttributesAsArray(i.certSubject), i.certSubjectUniqueId && (f.subject.uniqueId = i.certSubjectUniqueId), f.subject.hash = h.digest().toHex(), i.certExtensions ? f.extensions = he.certificateExtensionsFromAsn1(i.certExtensions) : f.extensions = [], f.publicKey = he.publicKeyFromAsn1(i.subjectPublicKeyInfo), f;
};
he.certificateExtensionsFromAsn1 = function(e) {
  for (var t = [], i = 0; i < e.value.length; ++i)
    for (var r = e.value[i], n = 0; n < r.value.length; ++n)
      t.push(he.certificateExtensionFromAsn1(r.value[n]));
  return t;
};
he.certificateExtensionFromAsn1 = function(e) {
  var t = {};
  if (t.id = O.derToOid(e.value[0].value), t.critical = !1, e.value[1].type === O.Type.BOOLEAN ? (t.critical = e.value[1].value.charCodeAt(0) !== 0, t.value = e.value[2].value) : t.value = e.value[1].value, t.id in Xe) {
    if (t.name = Xe[t.id], t.name === "keyUsage") {
      var i = O.fromDer(t.value), r = 0, n = 0;
      i.value.length > 1 && (r = i.value.charCodeAt(1), n = i.value.length > 2 ? i.value.charCodeAt(2) : 0), t.digitalSignature = (r & 128) === 128, t.nonRepudiation = (r & 64) === 64, t.keyEncipherment = (r & 32) === 32, t.dataEncipherment = (r & 16) === 16, t.keyAgreement = (r & 8) === 8, t.keyCertSign = (r & 4) === 4, t.cRLSign = (r & 2) === 2, t.encipherOnly = (r & 1) === 1, t.decipherOnly = (n & 128) === 128;
    } else if (t.name === "basicConstraints") {
      var i = O.fromDer(t.value);
      i.value.length > 0 && i.value[0].type === O.Type.BOOLEAN ? t.cA = i.value[0].value.charCodeAt(0) !== 0 : t.cA = !1;
      var a = null;
      i.value.length > 0 && i.value[0].type === O.Type.INTEGER ? a = i.value[0].value : i.value.length > 1 && (a = i.value[1].value), a !== null && (t.pathLenConstraint = O.derToInteger(a));
    } else if (t.name === "extKeyUsage")
      for (var i = O.fromDer(t.value), f = 0; f < i.value.length; ++f) {
        var s = O.derToOid(i.value[f].value);
        s in Xe ? t[Xe[s]] = !0 : t[s] = !0;
      }
    else if (t.name === "nsCertType") {
      var i = O.fromDer(t.value), r = 0;
      i.value.length > 1 && (r = i.value.charCodeAt(1)), t.client = (r & 128) === 128, t.server = (r & 64) === 64, t.email = (r & 32) === 32, t.objsign = (r & 16) === 16, t.reserved = (r & 8) === 8, t.sslCA = (r & 4) === 4, t.emailCA = (r & 2) === 2, t.objCA = (r & 1) === 1;
    } else if (t.name === "subjectAltName" || t.name === "issuerAltName") {
      t.altNames = [];
      for (var c, i = O.fromDer(t.value), u = 0; u < i.value.length; ++u) {
        c = i.value[u];
        var o = {
          type: c.type,
          value: c.value
        };
        switch (t.altNames.push(o), c.type) {
          case 1:
          case 2:
          case 6:
            break;
          case 7:
            o.ip = Se.util.bytesToIP(c.value);
            break;
          case 8:
            o.oid = O.derToOid(c.value);
            break;
        }
      }
    } else if (t.name === "subjectKeyIdentifier") {
      var i = O.fromDer(t.value);
      t.subjectKeyIdentifier = Se.util.bytesToHex(i.value);
    }
  }
  return t;
};
he.certificationRequestFromAsn1 = function(e, t) {
  var i = {}, r = [];
  if (!O.validate(e, Lg, i, r)) {
    var n = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
    throw n.errors = r, n;
  }
  var a = O.derToOid(i.publicKeyOid);
  if (a !== he.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var f = he.createCertificationRequest();
  if (f.version = i.csrVersion ? i.csrVersion.charCodeAt(0) : 0, f.signatureOid = Se.asn1.derToOid(i.csrSignatureOid), f.signatureParameters = Ta(
    f.signatureOid,
    i.csrSignatureParams,
    !0
  ), f.siginfo.algorithmOid = Se.asn1.derToOid(i.csrSignatureOid), f.siginfo.parameters = Ta(
    f.siginfo.algorithmOid,
    i.csrSignatureParams,
    !1
  ), f.signature = i.csrSignature, f.certificationRequestInfo = i.certificationRequestInfo, t) {
    f.md = Qa({
      signatureOid: f.signatureOid,
      type: "certification request"
    });
    var s = O.toDer(f.certificationRequestInfo);
    f.md.update(s.getBytes());
  }
  var c = Se.md.sha1.create();
  return f.subject.getField = function(u) {
    return Lr(f.subject, u);
  }, f.subject.addField = function(u) {
    fr([u]), f.subject.attributes.push(u);
  }, f.subject.attributes = he.RDNAttributesAsArray(
    i.certificationRequestInfoSubject,
    c
  ), f.subject.hash = c.digest().toHex(), f.publicKey = he.publicKeyFromAsn1(i.subjectPublicKeyInfo), f.getAttribute = function(u) {
    return Lr(f, u);
  }, f.addAttribute = function(u) {
    fr([u]), f.attributes.push(u);
  }, f.attributes = he.CRIAttributesAsArray(
    i.certificationRequestInfoAttributes || []
  ), f;
};
he.createCertificationRequest = function() {
  var e = {};
  return e.version = 0, e.signatureOid = null, e.signature = null, e.siginfo = {}, e.siginfo.algorithmOid = null, e.subject = {}, e.subject.getField = function(t) {
    return Lr(e.subject, t);
  }, e.subject.addField = function(t) {
    fr([t]), e.subject.attributes.push(t);
  }, e.subject.attributes = [], e.subject.hash = null, e.publicKey = null, e.attributes = [], e.getAttribute = function(t) {
    return Lr(e, t);
  }, e.addAttribute = function(t) {
    fr([t]), e.attributes.push(t);
  }, e.md = null, e.setSubject = function(t) {
    fr(t), e.subject.attributes = t, e.subject.hash = null;
  }, e.setAttributes = function(t) {
    fr(t), e.attributes = t;
  }, e.sign = function(t, i) {
    e.md = i || Se.md.sha1.create();
    var r = Xe[e.md.algorithm + "WithRSAEncryption"];
    if (!r) {
      var n = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
      throw n.algorithm = e.md.algorithm, n;
    }
    e.signatureOid = e.siginfo.algorithmOid = r, e.certificationRequestInfo = he.getCertificationRequestInfo(e);
    var a = O.toDer(e.certificationRequestInfo);
    e.md.update(a.getBytes()), e.signature = t.sign(e.md);
  }, e.verify = function() {
    var t = !1, i = e.md;
    if (i === null) {
      i = Qa({
        signatureOid: e.signatureOid,
        type: "certification request"
      });
      var r = e.certificationRequestInfo || he.getCertificationRequestInfo(e), n = O.toDer(r);
      i.update(n.getBytes());
    }
    return i !== null && (t = dp({
      certificate: e,
      md: i,
      signature: e.signature
    })), t;
  }, e;
};
function _i(e) {
  for (var t = O.create(
    O.Class.UNIVERSAL,
    O.Type.SEQUENCE,
    !0,
    []
  ), i, r, n = e.attributes, a = 0; a < n.length; ++a) {
    i = n[a];
    var f = i.value, s = O.Type.PRINTABLESTRING;
    "valueTagClass" in i && (s = i.valueTagClass, s === O.Type.UTF8 && (f = Se.util.encodeUtf8(f))), r = O.create(O.Class.UNIVERSAL, O.Type.SET, !0, [
      O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
        // AttributeType
        O.create(
          O.Class.UNIVERSAL,
          O.Type.OID,
          !1,
          O.oidToDer(i.type).getBytes()
        ),
        // AttributeValue
        O.create(O.Class.UNIVERSAL, s, !1, f)
      ])
    ]), t.value.push(r);
  }
  return t;
}
function fr(e) {
  for (var t, i = 0; i < e.length; ++i) {
    if (t = e[i], typeof t.name > "u" && (t.type && t.type in he.oids ? t.name = he.oids[t.type] : t.shortName && t.shortName in Dt && (t.name = he.oids[Dt[t.shortName]])), typeof t.type > "u")
      if (t.name && t.name in he.oids)
        t.type = he.oids[t.name];
      else {
        var r = new Error("Attribute type not specified.");
        throw r.attribute = t, r;
      }
    if (typeof t.shortName > "u" && t.name && t.name in Dt && (t.shortName = Dt[t.name]), t.type === Xe.extensionRequest && (t.valueConstructed = !0, t.valueTagClass = O.Type.SEQUENCE, !t.value && t.extensions)) {
      t.value = [];
      for (var n = 0; n < t.extensions.length; ++n)
        t.value.push(he.certificateExtensionToAsn1(
          pp(t.extensions[n])
        ));
    }
    if (typeof t.value > "u") {
      var r = new Error("Attribute value not specified.");
      throw r.attribute = t, r;
    }
  }
}
function pp(e, t) {
  if (t = t || {}, typeof e.name > "u" && e.id && e.id in he.oids && (e.name = he.oids[e.id]), typeof e.id > "u")
    if (e.name && e.name in he.oids)
      e.id = he.oids[e.name];
    else {
      var i = new Error("Extension ID not specified.");
      throw i.extension = e, i;
    }
  if (typeof e.value < "u")
    return e;
  if (e.name === "keyUsage") {
    var r = 0, n = 0, a = 0;
    e.digitalSignature && (n |= 128, r = 7), e.nonRepudiation && (n |= 64, r = 6), e.keyEncipherment && (n |= 32, r = 5), e.dataEncipherment && (n |= 16, r = 4), e.keyAgreement && (n |= 8, r = 3), e.keyCertSign && (n |= 4, r = 2), e.cRLSign && (n |= 2, r = 1), e.encipherOnly && (n |= 1, r = 0), e.decipherOnly && (a |= 128, r = 7);
    var f = String.fromCharCode(r);
    a !== 0 ? f += String.fromCharCode(n) + String.fromCharCode(a) : n !== 0 && (f += String.fromCharCode(n)), e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.BITSTRING,
      !1,
      f
    );
  } else if (e.name === "basicConstraints")
    e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.SEQUENCE,
      !0,
      []
    ), e.cA && e.value.value.push(O.create(
      O.Class.UNIVERSAL,
      O.Type.BOOLEAN,
      !1,
      "ÿ"
    )), "pathLenConstraint" in e && e.value.value.push(O.create(
      O.Class.UNIVERSAL,
      O.Type.INTEGER,
      !1,
      O.integerToDer(e.pathLenConstraint).getBytes()
    ));
  else if (e.name === "extKeyUsage") {
    e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.SEQUENCE,
      !0,
      []
    );
    var s = e.value.value;
    for (var c in e)
      e[c] === !0 && (c in Xe ? s.push(O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(Xe[c]).getBytes()
      )) : c.indexOf(".") !== -1 && s.push(O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(c).getBytes()
      )));
  } else if (e.name === "nsCertType") {
    var r = 0, n = 0;
    e.client && (n |= 128, r = 7), e.server && (n |= 64, r = 6), e.email && (n |= 32, r = 5), e.objsign && (n |= 16, r = 4), e.reserved && (n |= 8, r = 3), e.sslCA && (n |= 4, r = 2), e.emailCA && (n |= 2, r = 1), e.objCA && (n |= 1, r = 0);
    var f = String.fromCharCode(r);
    n !== 0 && (f += String.fromCharCode(n)), e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.BITSTRING,
      !1,
      f
    );
  } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
    e.value = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, []);
    for (var u, o = 0; o < e.altNames.length; ++o) {
      u = e.altNames[o];
      var f = u.value;
      if (u.type === 7 && u.ip) {
        if (f = Se.util.bytesFromIP(u.ip), f === null) {
          var i = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw i.extension = e, i;
        }
      } else
        u.type === 8 && (u.oid ? f = O.oidToDer(O.oidToDer(u.oid)) : f = O.oidToDer(f));
      e.value.value.push(O.create(
        O.Class.CONTEXT_SPECIFIC,
        u.type,
        !1,
        f
      ));
    }
  } else if (e.name === "nsComment" && t.cert) {
    if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128)
      throw new Error('Invalid "nsComment" content.');
    e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.IA5STRING,
      !1,
      e.comment
    );
  } else if (e.name === "subjectKeyIdentifier" && t.cert) {
    var l = t.cert.generateSubjectKeyIdentifier();
    e.subjectKeyIdentifier = l.toHex(), e.value = O.create(
      O.Class.UNIVERSAL,
      O.Type.OCTETSTRING,
      !1,
      l.getBytes()
    );
  } else if (e.name === "authorityKeyIdentifier" && t.cert) {
    e.value = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, []);
    var s = e.value.value;
    if (e.keyIdentifier) {
      var h = e.keyIdentifier === !0 ? t.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
      s.push(
        O.create(O.Class.CONTEXT_SPECIFIC, 0, !1, h)
      );
    }
    if (e.authorityCertIssuer) {
      var p = [
        O.create(O.Class.CONTEXT_SPECIFIC, 4, !0, [
          _i(e.authorityCertIssuer === !0 ? t.cert.issuer : e.authorityCertIssuer)
        ])
      ];
      s.push(
        O.create(O.Class.CONTEXT_SPECIFIC, 1, !0, p)
      );
    }
    if (e.serialNumber) {
      var v = Se.util.hexToBytes(e.serialNumber === !0 ? t.cert.serialNumber : e.serialNumber);
      s.push(
        O.create(O.Class.CONTEXT_SPECIFIC, 2, !1, v)
      );
    }
  } else if (e.name === "cRLDistributionPoints") {
    e.value = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, []);
    for (var s = e.value.value, y = O.create(
      O.Class.UNIVERSAL,
      O.Type.SEQUENCE,
      !0,
      []
    ), w = O.create(
      O.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      []
    ), u, o = 0; o < e.altNames.length; ++o) {
      u = e.altNames[o];
      var f = u.value;
      if (u.type === 7 && u.ip) {
        if (f = Se.util.bytesFromIP(u.ip), f === null) {
          var i = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw i.extension = e, i;
        }
      } else
        u.type === 8 && (u.oid ? f = O.oidToDer(O.oidToDer(u.oid)) : f = O.oidToDer(f));
      w.value.push(O.create(
        O.Class.CONTEXT_SPECIFIC,
        u.type,
        !1,
        f
      ));
    }
    y.value.push(O.create(
      O.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      [w]
    )), s.push(y);
  }
  if (typeof e.value > "u") {
    var i = new Error("Extension value not specified.");
    throw i.extension = e, i;
  }
  return e;
}
function p0(e, t) {
  switch (e) {
    case Xe["RSASSA-PSS"]:
      var i = [];
      return t.hash.algorithmOid !== void 0 && i.push(O.create(O.Class.CONTEXT_SPECIFIC, 0, !0, [
        O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
          O.create(
            O.Class.UNIVERSAL,
            O.Type.OID,
            !1,
            O.oidToDer(t.hash.algorithmOid).getBytes()
          ),
          O.create(O.Class.UNIVERSAL, O.Type.NULL, !1, "")
        ])
      ])), t.mgf.algorithmOid !== void 0 && i.push(O.create(O.Class.CONTEXT_SPECIFIC, 1, !0, [
        O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
          O.create(
            O.Class.UNIVERSAL,
            O.Type.OID,
            !1,
            O.oidToDer(t.mgf.algorithmOid).getBytes()
          ),
          O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
            O.create(
              O.Class.UNIVERSAL,
              O.Type.OID,
              !1,
              O.oidToDer(t.mgf.hash.algorithmOid).getBytes()
            ),
            O.create(O.Class.UNIVERSAL, O.Type.NULL, !1, "")
          ])
        ])
      ])), t.saltLength !== void 0 && i.push(O.create(O.Class.CONTEXT_SPECIFIC, 2, !0, [
        O.create(
          O.Class.UNIVERSAL,
          O.Type.INTEGER,
          !1,
          O.integerToDer(t.saltLength).getBytes()
        )
      ])), O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, i);
    default:
      return O.create(O.Class.UNIVERSAL, O.Type.NULL, !1, "");
  }
}
function Pg(e) {
  var t = O.create(O.Class.CONTEXT_SPECIFIC, 0, !0, []);
  if (e.attributes.length === 0)
    return t;
  for (var i = e.attributes, r = 0; r < i.length; ++r) {
    var n = i[r], a = n.value, f = O.Type.UTF8;
    "valueTagClass" in n && (f = n.valueTagClass), f === O.Type.UTF8 && (a = Se.util.encodeUtf8(a));
    var s = !1;
    "valueConstructed" in n && (s = n.valueConstructed);
    var c = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
      // AttributeType
      O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(n.type).getBytes()
      ),
      O.create(O.Class.UNIVERSAL, O.Type.SET, !0, [
        // AttributeValue
        O.create(
          O.Class.UNIVERSAL,
          f,
          s,
          a
        )
      ])
    ]);
    t.value.push(c);
  }
  return t;
}
var Ug = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), Og = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z");
function Nh(e) {
  return e >= Ug && e < Og ? O.create(
    O.Class.UNIVERSAL,
    O.Type.UTCTIME,
    !1,
    O.dateToUtcTime(e)
  ) : O.create(
    O.Class.UNIVERSAL,
    O.Type.GENERALIZEDTIME,
    !1,
    O.dateToGeneralizedTime(e)
  );
}
he.getTBSCertificate = function(e) {
  var t = Nh(e.validity.notBefore), i = Nh(e.validity.notAfter), r = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
    // version
    O.create(O.Class.CONTEXT_SPECIFIC, 0, !0, [
      // integer
      O.create(
        O.Class.UNIVERSAL,
        O.Type.INTEGER,
        !1,
        O.integerToDer(e.version).getBytes()
      )
    ]),
    // serialNumber
    O.create(
      O.Class.UNIVERSAL,
      O.Type.INTEGER,
      !1,
      Se.util.hexToBytes(e.serialNumber)
    ),
    // signature
    O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
      // algorithm
      O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(e.siginfo.algorithmOid).getBytes()
      ),
      // parameters
      p0(
        e.siginfo.algorithmOid,
        e.siginfo.parameters
      )
    ]),
    // issuer
    _i(e.issuer),
    // validity
    O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
      t,
      i
    ]),
    // subject
    _i(e.subject),
    // SubjectPublicKeyInfo
    he.publicKeyToAsn1(e.publicKey)
  ]);
  return e.issuer.uniqueId && r.value.push(
    O.create(O.Class.CONTEXT_SPECIFIC, 1, !0, [
      O.create(
        O.Class.UNIVERSAL,
        O.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        "\0" + e.issuer.uniqueId
      )
    ])
  ), e.subject.uniqueId && r.value.push(
    O.create(O.Class.CONTEXT_SPECIFIC, 2, !0, [
      O.create(
        O.Class.UNIVERSAL,
        O.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        "\0" + e.subject.uniqueId
      )
    ])
  ), e.extensions.length > 0 && r.value.push(he.certificateExtensionsToAsn1(e.extensions)), r;
};
he.getCertificationRequestInfo = function(e) {
  var t = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
    // version
    O.create(
      O.Class.UNIVERSAL,
      O.Type.INTEGER,
      !1,
      O.integerToDer(e.version).getBytes()
    ),
    // subject
    _i(e.subject),
    // SubjectPublicKeyInfo
    he.publicKeyToAsn1(e.publicKey),
    // attributes
    Pg(e)
  ]);
  return t;
};
he.distinguishedNameToAsn1 = function(e) {
  return _i(e);
};
he.certificateToAsn1 = function(e) {
  var t = e.tbsCertificate || he.getTBSCertificate(e);
  return O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
    // TBSCertificate
    t,
    // AlgorithmIdentifier (signature algorithm)
    O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
      // algorithm
      O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(e.signatureOid).getBytes()
      ),
      // parameters
      p0(e.signatureOid, e.signatureParameters)
    ]),
    // SignatureValue
    O.create(
      O.Class.UNIVERSAL,
      O.Type.BITSTRING,
      !1,
      "\0" + e.signature
    )
  ]);
};
he.certificateExtensionsToAsn1 = function(e) {
  var t = O.create(O.Class.CONTEXT_SPECIFIC, 3, !0, []), i = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, []);
  t.value.push(i);
  for (var r = 0; r < e.length; ++r)
    i.value.push(he.certificateExtensionToAsn1(e[r]));
  return t;
};
he.certificateExtensionToAsn1 = function(e) {
  var t = O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, []);
  t.value.push(O.create(
    O.Class.UNIVERSAL,
    O.Type.OID,
    !1,
    O.oidToDer(e.id).getBytes()
  )), e.critical && t.value.push(O.create(
    O.Class.UNIVERSAL,
    O.Type.BOOLEAN,
    !1,
    "ÿ"
  ));
  var i = e.value;
  return typeof e.value != "string" && (i = O.toDer(i).getBytes()), t.value.push(O.create(
    O.Class.UNIVERSAL,
    O.Type.OCTETSTRING,
    !1,
    i
  )), t;
};
he.certificationRequestToAsn1 = function(e) {
  var t = e.certificationRequestInfo || he.getCertificationRequestInfo(e);
  return O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
    // CertificationRequestInfo
    t,
    // AlgorithmIdentifier (signature algorithm)
    O.create(O.Class.UNIVERSAL, O.Type.SEQUENCE, !0, [
      // algorithm
      O.create(
        O.Class.UNIVERSAL,
        O.Type.OID,
        !1,
        O.oidToDer(e.signatureOid).getBytes()
      ),
      // parameters
      p0(e.signatureOid, e.signatureParameters)
    ]),
    // signature
    O.create(
      O.Class.UNIVERSAL,
      O.Type.BITSTRING,
      !1,
      "\0" + e.signature
    )
  ]);
};
he.createCaStore = function(e) {
  var t = {
    // stored certificates
    certs: {}
  };
  t.getIssuer = function(f) {
    var s = i(f.issuer);
    return s;
  }, t.addCertificate = function(f) {
    if (typeof f == "string" && (f = Se.pki.certificateFromPem(f)), r(f.subject), !t.hasCertificate(f))
      if (f.subject.hash in t.certs) {
        var s = t.certs[f.subject.hash];
        Se.util.isArray(s) || (s = [s]), s.push(f), t.certs[f.subject.hash] = s;
      } else
        t.certs[f.subject.hash] = f;
  }, t.hasCertificate = function(f) {
    typeof f == "string" && (f = Se.pki.certificateFromPem(f));
    var s = i(f.subject);
    if (!s)
      return !1;
    Se.util.isArray(s) || (s = [s]);
    for (var c = O.toDer(he.certificateToAsn1(f)).getBytes(), u = 0; u < s.length; ++u) {
      var o = O.toDer(he.certificateToAsn1(s[u])).getBytes();
      if (c === o)
        return !0;
    }
    return !1;
  }, t.listAllCertificates = function() {
    var f = [];
    for (var s in t.certs)
      if (t.certs.hasOwnProperty(s)) {
        var c = t.certs[s];
        if (!Se.util.isArray(c))
          f.push(c);
        else
          for (var u = 0; u < c.length; ++u)
            f.push(c[u]);
      }
    return f;
  }, t.removeCertificate = function(f) {
    var s;
    if (typeof f == "string" && (f = Se.pki.certificateFromPem(f)), r(f.subject), !t.hasCertificate(f))
      return null;
    var c = i(f.subject);
    if (!Se.util.isArray(c))
      return s = t.certs[f.subject.hash], delete t.certs[f.subject.hash], s;
    for (var u = O.toDer(he.certificateToAsn1(f)).getBytes(), o = 0; o < c.length; ++o) {
      var l = O.toDer(he.certificateToAsn1(c[o])).getBytes();
      u === l && (s = c[o], c.splice(o, 1));
    }
    return c.length === 0 && delete t.certs[f.subject.hash], s;
  };
  function i(f) {
    return r(f), t.certs[f.hash] || null;
  }
  function r(f) {
    if (!f.hash) {
      var s = Se.md.sha1.create();
      f.attributes = he.RDNAttributesAsArray(_i(f), s), f.hash = s.digest().toHex();
    }
  }
  if (e)
    for (var n = 0; n < e.length; ++n) {
      var a = e[n];
      t.addCertificate(a);
    }
  return t;
};
he.certificateError = {
  bad_certificate: "forge.pki.BadCertificate",
  unsupported_certificate: "forge.pki.UnsupportedCertificate",
  certificate_revoked: "forge.pki.CertificateRevoked",
  certificate_expired: "forge.pki.CertificateExpired",
  certificate_unknown: "forge.pki.CertificateUnknown",
  unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
he.verifyCertificateChain = function(e, t, i) {
  typeof i == "function" && (i = { verify: i }), i = i || {}, t = t.slice(0);
  var r = t.slice(0), n = i.validityCheckDate;
  typeof n > "u" && (n = /* @__PURE__ */ new Date());
  var a = !0, f = null, s = 0;
  do {
    var c = t.shift(), u = null, o = !1;
    if (n && (n < c.validity.notBefore || n > c.validity.notAfter) && (f = {
      message: "Certificate is not valid yet or has expired.",
      error: he.certificateError.certificate_expired,
      notBefore: c.validity.notBefore,
      notAfter: c.validity.notAfter,
      // TODO: we might want to reconsider renaming 'now' to
      // 'validityCheckDate' should this API be changed in the future.
      now: n
    }), f === null) {
      if (u = t[0] || e.getIssuer(c), u === null && c.isIssuer(c) && (o = !0, u = c), u) {
        var l = u;
        Se.util.isArray(l) || (l = [l]);
        for (var h = !1; !h && l.length > 0; ) {
          u = l.shift();
          try {
            h = u.verify(c);
          } catch {
          }
        }
        h || (f = {
          message: "Certificate signature is invalid.",
          error: he.certificateError.bad_certificate
        });
      }
      f === null && (!u || o) && !e.hasCertificate(c) && (f = {
        message: "Certificate is not trusted.",
        error: he.certificateError.unknown_ca
      });
    }
    if (f === null && u && !c.isIssuer(u) && (f = {
      message: "Certificate issuer is invalid.",
      error: he.certificateError.bad_certificate
    }), f === null)
      for (var p = {
        keyUsage: !0,
        basicConstraints: !0
      }, v = 0; f === null && v < c.extensions.length; ++v) {
        var y = c.extensions[v];
        y.critical && !(y.name in p) && (f = {
          message: "Certificate has an unsupported critical extension.",
          error: he.certificateError.unsupported_certificate
        });
      }
    if (f === null && (!a || t.length === 0 && (!u || o))) {
      var w = c.getExtension("basicConstraints"), x = c.getExtension("keyUsage");
      if (x !== null && (!x.keyCertSign || w === null) && (f = {
        message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
        error: he.certificateError.bad_certificate
      }), f === null && w !== null && !w.cA && (f = {
        message: "Certificate basicConstraints indicates the certificate is not a CA.",
        error: he.certificateError.bad_certificate
      }), f === null && x !== null && "pathLenConstraint" in w) {
        var A = s - 1;
        A > w.pathLenConstraint && (f = {
          message: "Certificate basicConstraints pathLenConstraint violated.",
          error: he.certificateError.bad_certificate
        });
      }
    }
    var R = f === null ? !0 : f.error, M = i.verify ? i.verify(R, s, r) : R;
    if (M === !0)
      f = null;
    else
      throw R === !0 && (f = {
        message: "The application rejected the certificate.",
        error: he.certificateError.bad_certificate
      }), (M || M === 0) && (typeof M == "object" && !Se.util.isArray(M) ? (M.message && (f.message = M.message), M.error && (f.error = M.error)) : typeof M == "string" && (f.error = M)), f;
    a = !1, ++s;
  } while (t.length > 0);
  return !0;
};
var nt = je, Q = nt.asn1, $e = nt.pki, Vi = nt.pkcs12 = nt.pkcs12 || {}, vp = {
  name: "ContentInfo",
  tagClass: Q.Class.UNIVERSAL,
  type: Q.Type.SEQUENCE,
  // a ContentInfo
  constructed: !0,
  value: [{
    name: "ContentInfo.contentType",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: Q.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "content"
  }]
}, qg = {
  name: "PFX",
  tagClass: Q.Class.UNIVERSAL,
  type: Q.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "PFX.version",
      tagClass: Q.Class.UNIVERSAL,
      type: Q.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    vp,
    {
      name: "PFX.macData",
      tagClass: Q.Class.UNIVERSAL,
      type: Q.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "mac",
      value: [{
        name: "PFX.macData.mac",
        tagClass: Q.Class.UNIVERSAL,
        type: Q.Type.SEQUENCE,
        // DigestInfo
        constructed: !0,
        value: [{
          name: "PFX.macData.mac.digestAlgorithm",
          tagClass: Q.Class.UNIVERSAL,
          type: Q.Type.SEQUENCE,
          // DigestAlgorithmIdentifier
          constructed: !0,
          value: [{
            name: "PFX.macData.mac.digestAlgorithm.algorithm",
            tagClass: Q.Class.UNIVERSAL,
            type: Q.Type.OID,
            constructed: !1,
            capture: "macAlgorithm"
          }, {
            name: "PFX.macData.mac.digestAlgorithm.parameters",
            tagClass: Q.Class.UNIVERSAL,
            captureAsn1: "macAlgorithmParameters"
          }]
        }, {
          name: "PFX.macData.mac.digest",
          tagClass: Q.Class.UNIVERSAL,
          type: Q.Type.OCTETSTRING,
          constructed: !1,
          capture: "macDigest"
        }]
      }, {
        name: "PFX.macData.macSalt",
        tagClass: Q.Class.UNIVERSAL,
        type: Q.Type.OCTETSTRING,
        constructed: !1,
        capture: "macSalt"
      }, {
        name: "PFX.macData.iterations",
        tagClass: Q.Class.UNIVERSAL,
        type: Q.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "macIterations"
      }]
    }
  ]
}, Fg = {
  name: "SafeBag",
  tagClass: Q.Class.UNIVERSAL,
  type: Q.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SafeBag.bagId",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.OID,
    constructed: !1,
    capture: "bagId"
  }, {
    name: "SafeBag.bagValue",
    tagClass: Q.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "bagValue"
  }, {
    name: "SafeBag.bagAttributes",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.SET,
    constructed: !0,
    optional: !0,
    capture: "bagAttributes"
  }]
}, Vg = {
  name: "Attribute",
  tagClass: Q.Class.UNIVERSAL,
  type: Q.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Attribute.attrId",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.OID,
    constructed: !1,
    capture: "oid"
  }, {
    name: "Attribute.attrValues",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.SET,
    constructed: !0,
    capture: "values"
  }]
}, Kg = {
  name: "CertBag",
  tagClass: Q.Class.UNIVERSAL,
  type: Q.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "CertBag.certId",
    tagClass: Q.Class.UNIVERSAL,
    type: Q.Type.OID,
    constructed: !1,
    capture: "certId"
  }, {
    name: "CertBag.certValue",
    tagClass: Q.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */
    value: [{
      name: "CertBag.certValue[0]",
      tagClass: Q.Class.UNIVERSAL,
      type: Q.Class.OCTETSTRING,
      constructed: !1,
      capture: "cert"
    }]
  }]
};
function Ni(e, t, i, r) {
  for (var n = [], a = 0; a < e.length; a++)
    for (var f = 0; f < e[a].safeBags.length; f++) {
      var s = e[a].safeBags[f];
      if (!(r !== void 0 && s.type !== r)) {
        if (t === null) {
          n.push(s);
          continue;
        }
        s.attributes[t] !== void 0 && s.attributes[t].indexOf(i) >= 0 && n.push(s);
      }
    }
  return n;
}
Vi.pkcs12FromAsn1 = function(e, t, i) {
  typeof t == "string" ? (i = t, t = !0) : t === void 0 && (t = !0);
  var r = {}, n = [];
  if (!Q.validate(e, qg, r, n)) {
    var a = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
    throw a.errors = a, a;
  }
  var f = {
    version: r.version.charCodeAt(0),
    safeContents: [],
    /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */
    getBags: function(w) {
      var x = {}, A;
      return "localKeyId" in w ? A = w.localKeyId : "localKeyIdHex" in w && (A = nt.util.hexToBytes(w.localKeyIdHex)), A === void 0 && !("friendlyName" in w) && "bagType" in w && (x[w.bagType] = Ni(
        f.safeContents,
        null,
        null,
        w.bagType
      )), A !== void 0 && (x.localKeyId = Ni(
        f.safeContents,
        "localKeyId",
        A,
        w.bagType
      )), "friendlyName" in w && (x.friendlyName = Ni(
        f.safeContents,
        "friendlyName",
        w.friendlyName,
        w.bagType
      )), x;
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */
    getBagsByFriendlyName: function(w, x) {
      return Ni(
        f.safeContents,
        "friendlyName",
        w,
        x
      );
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */
    getBagsByLocalKeyId: function(w, x) {
      return Ni(
        f.safeContents,
        "localKeyId",
        w,
        x
      );
    }
  };
  if (r.version.charCodeAt(0) !== 3) {
    var a = new Error("PKCS#12 PFX of version other than 3 not supported.");
    throw a.version = r.version.charCodeAt(0), a;
  }
  if (Q.derToOid(r.contentType) !== $e.oids.data) {
    var a = new Error("Only PKCS#12 PFX in password integrity mode supported.");
    throw a.oid = Q.derToOid(r.contentType), a;
  }
  var s = r.content.value[0];
  if (s.tagClass !== Q.Class.UNIVERSAL || s.type !== Q.Type.OCTETSTRING)
    throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
  if (s = v0(s), r.mac) {
    var c = null, u = 0, o = Q.derToOid(r.macAlgorithm);
    switch (o) {
      case $e.oids.sha1:
        c = nt.md.sha1.create(), u = 20;
        break;
      case $e.oids.sha256:
        c = nt.md.sha256.create(), u = 32;
        break;
      case $e.oids.sha384:
        c = nt.md.sha384.create(), u = 48;
        break;
      case $e.oids.sha512:
        c = nt.md.sha512.create(), u = 64;
        break;
      case $e.oids.md5:
        c = nt.md.md5.create(), u = 16;
        break;
    }
    if (c === null)
      throw new Error("PKCS#12 uses unsupported MAC algorithm: " + o);
    var l = new nt.util.ByteBuffer(r.macSalt), h = "macIterations" in r ? parseInt(nt.util.bytesToHex(r.macIterations), 16) : 1, p = Vi.generateKey(
      i,
      l,
      3,
      h,
      u,
      c
    ), v = nt.hmac.create();
    v.start(c, p), v.update(s.value);
    var y = v.getMac();
    if (y.getBytes() !== r.macDigest)
      throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
  }
  return Hg(f, s.value, t, i), f;
};
function v0(e) {
  if (e.composed || e.constructed) {
    for (var t = nt.util.createBuffer(), i = 0; i < e.value.length; ++i)
      t.putBytes(e.value[i].value);
    e.composed = e.constructed = !1, e.value = t.getBytes();
  }
  return e;
}
function Hg(e, t, i, r) {
  if (t = Q.fromDer(t, i), t.tagClass !== Q.Class.UNIVERSAL || t.type !== Q.Type.SEQUENCE || t.constructed !== !0)
    throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
  for (var n = 0; n < t.value.length; n++) {
    var a = t.value[n], f = {}, s = [];
    if (!Q.validate(a, vp, f, s)) {
      var c = new Error("Cannot read ContentInfo.");
      throw c.errors = s, c;
    }
    var u = {
      encrypted: !1
    }, o = null, l = f.content.value[0];
    switch (Q.derToOid(f.contentType)) {
      case $e.oids.data:
        if (l.tagClass !== Q.Class.UNIVERSAL || l.type !== Q.Type.OCTETSTRING)
          throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
        o = v0(l).value;
        break;
      case $e.oids.encryptedData:
        o = jg(l, r), u.encrypted = !0;
        break;
      default:
        var c = new Error("Unsupported PKCS#12 contentType.");
        throw c.contentType = Q.derToOid(f.contentType), c;
    }
    u.safeBags = zg(o, i, r), e.safeContents.push(u);
  }
}
function jg(e, t) {
  var i = {}, r = [];
  if (!Q.validate(
    e,
    nt.pkcs7.asn1.encryptedDataValidator,
    i,
    r
  )) {
    var n = new Error("Cannot read EncryptedContentInfo.");
    throw n.errors = r, n;
  }
  var a = Q.derToOid(i.contentType);
  if (a !== $e.oids.data) {
    var n = new Error(
      "PKCS#12 EncryptedContentInfo ContentType is not Data."
    );
    throw n.oid = a, n;
  }
  a = Q.derToOid(i.encAlgorithm);
  var f = $e.pbe.getCipher(a, i.encParameter, t), s = v0(i.encryptedContentAsn1), c = nt.util.createBuffer(s.value);
  if (f.update(c), !f.finish())
    throw new Error("Failed to decrypt PKCS#12 SafeContents.");
  return f.output.getBytes();
}
function zg(e, t, i) {
  if (!t && e.length === 0)
    return [];
  if (e = Q.fromDer(e, t), e.tagClass !== Q.Class.UNIVERSAL || e.type !== Q.Type.SEQUENCE || e.constructed !== !0)
    throw new Error(
      "PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag."
    );
  for (var r = [], n = 0; n < e.value.length; n++) {
    var a = e.value[n], f = {}, s = [];
    if (!Q.validate(a, Fg, f, s)) {
      var c = new Error("Cannot read SafeBag.");
      throw c.errors = s, c;
    }
    var u = {
      type: Q.derToOid(f.bagId),
      attributes: Gg(f.bagAttributes)
    };
    r.push(u);
    var o, l, h = f.bagValue.value[0];
    switch (u.type) {
      case $e.oids.pkcs8ShroudedKeyBag:
        if (h = $e.decryptPrivateKeyInfo(h, i), h === null)
          throw new Error(
            "Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?"
          );
      case $e.oids.keyBag:
        try {
          u.key = $e.privateKeyFromAsn1(h);
        } catch {
          u.key = null, u.asn1 = h;
        }
        continue;
      case $e.oids.certBag:
        o = Kg, l = function() {
          if (Q.derToOid(f.certId) !== $e.oids.x509Certificate) {
            var v = new Error(
              "Unsupported certificate type, only X.509 supported."
            );
            throw v.oid = Q.derToOid(f.certId), v;
          }
          var y = Q.fromDer(f.cert, t);
          try {
            u.cert = $e.certificateFromAsn1(y, !0);
          } catch {
            u.cert = null, u.asn1 = y;
          }
        };
        break;
      default:
        var c = new Error("Unsupported PKCS#12 SafeBag type.");
        throw c.oid = u.type, c;
    }
    if (o !== void 0 && !Q.validate(h, o, f, s)) {
      var c = new Error("Cannot read PKCS#12 " + o.name);
      throw c.errors = s, c;
    }
    l();
  }
  return r;
}
function Gg(e) {
  var t = {};
  if (e !== void 0)
    for (var i = 0; i < e.length; ++i) {
      var r = {}, n = [];
      if (!Q.validate(e[i], Vg, r, n)) {
        var a = new Error("Cannot read PKCS#12 BagAttribute.");
        throw a.errors = n, a;
      }
      var f = Q.derToOid(r.oid);
      if ($e.oids[f] !== void 0) {
        t[$e.oids[f]] = [];
        for (var s = 0; s < r.values.length; ++s)
          t[$e.oids[f]].push(r.values[s].value);
      }
    }
  return t;
}
Vi.toPkcs12Asn1 = function(e, t, i, r) {
  r = r || {}, r.saltSize = r.saltSize || 8, r.count = r.count || 2048, r.algorithm = r.algorithm || r.encAlgorithm || "aes128", "useMac" in r || (r.useMac = !0), "localKeyId" in r || (r.localKeyId = null), "generateLocalKeyId" in r || (r.generateLocalKeyId = !0);
  var n = r.localKeyId, a;
  if (n !== null)
    n = nt.util.hexToBytes(n);
  else if (r.generateLocalKeyId)
    if (t) {
      var f = nt.util.isArray(t) ? t[0] : t;
      typeof f == "string" && (f = $e.certificateFromPem(f));
      var s = nt.md.sha1.create();
      s.update(Q.toDer($e.certificateToAsn1(f)).getBytes()), n = s.digest().getBytes();
    } else
      n = nt.random.getBytes(20);
  var c = [];
  n !== null && c.push(
    // localKeyID
    Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // attrId
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        Q.oidToDer($e.oids.localKeyId).getBytes()
      ),
      // attrValues
      Q.create(Q.Class.UNIVERSAL, Q.Type.SET, !0, [
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.OCTETSTRING,
          !1,
          n
        )
      ])
    ])
  ), "friendlyName" in r && c.push(
    // friendlyName
    Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // attrId
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        Q.oidToDer($e.oids.friendlyName).getBytes()
      ),
      // attrValues
      Q.create(Q.Class.UNIVERSAL, Q.Type.SET, !0, [
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.BMPSTRING,
          !1,
          r.friendlyName
        )
      ])
    ])
  ), c.length > 0 && (a = Q.create(Q.Class.UNIVERSAL, Q.Type.SET, !0, c));
  var u = [], o = [];
  t !== null && (nt.util.isArray(t) ? o = t : o = [t]);
  for (var l = [], h = 0; h < o.length; ++h) {
    t = o[h], typeof t == "string" && (t = $e.certificateFromPem(t));
    var p = h === 0 ? a : void 0, v = $e.certificateToAsn1(t), y = Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // bagId
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        Q.oidToDer($e.oids.certBag).getBytes()
      ),
      // bagValue
      Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
        // CertBag
        Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
          // certId
          Q.create(
            Q.Class.UNIVERSAL,
            Q.Type.OID,
            !1,
            Q.oidToDer($e.oids.x509Certificate).getBytes()
          ),
          // certValue (x509Certificate)
          Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
            Q.create(
              Q.Class.UNIVERSAL,
              Q.Type.OCTETSTRING,
              !1,
              Q.toDer(v).getBytes()
            )
          ])
        ])
      ]),
      // bagAttributes (OPTIONAL)
      p
    ]);
    l.push(y);
  }
  if (l.length > 0) {
    var w = Q.create(
      Q.Class.UNIVERSAL,
      Q.Type.SEQUENCE,
      !0,
      l
    ), x = (
      // PKCS#7 ContentInfo
      Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
        // contentType
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.OID,
          !1,
          // OID for the content type is 'data'
          Q.oidToDer($e.oids.data).getBytes()
        ),
        // content
        Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
          Q.create(
            Q.Class.UNIVERSAL,
            Q.Type.OCTETSTRING,
            !1,
            Q.toDer(w).getBytes()
          )
        ])
      ])
    );
    u.push(x);
  }
  var A = null;
  if (e !== null) {
    var R = $e.wrapRsaPrivateKey($e.privateKeyToAsn1(e));
    i === null ? A = Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // bagId
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        Q.oidToDer($e.oids.keyBag).getBytes()
      ),
      // bagValue
      Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
        // PrivateKeyInfo
        R
      ]),
      // bagAttributes (OPTIONAL)
      a
    ]) : A = Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // bagId
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        Q.oidToDer($e.oids.pkcs8ShroudedKeyBag).getBytes()
      ),
      // bagValue
      Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
        // EncryptedPrivateKeyInfo
        $e.encryptPrivateKeyInfo(R, i, r)
      ]),
      // bagAttributes (OPTIONAL)
      a
    ]);
    var M = Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [A]), D = (
      // PKCS#7 ContentInfo
      Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
        // contentType
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.OID,
          !1,
          // OID for the content type is 'data'
          Q.oidToDer($e.oids.data).getBytes()
        ),
        // content
        Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
          Q.create(
            Q.Class.UNIVERSAL,
            Q.Type.OCTETSTRING,
            !1,
            Q.toDer(M).getBytes()
          )
        ])
      ])
    );
    u.push(D);
  }
  var U = Q.create(
    Q.Class.UNIVERSAL,
    Q.Type.SEQUENCE,
    !0,
    u
  ), z;
  if (r.useMac) {
    var s = nt.md.sha1.create(), W = new nt.util.ByteBuffer(
      nt.random.getBytes(r.saltSize)
    ), G = r.count, e = Vi.generateKey(i, W, 3, G, 20), re = nt.hmac.create();
    re.start(s, e), re.update(Q.toDer(U).getBytes());
    var V = re.getMac();
    z = Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // mac DigestInfo
      Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
        // digestAlgorithm
        Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
          // algorithm = SHA-1
          Q.create(
            Q.Class.UNIVERSAL,
            Q.Type.OID,
            !1,
            Q.oidToDer($e.oids.sha1).getBytes()
          ),
          // parameters = Null
          Q.create(Q.Class.UNIVERSAL, Q.Type.NULL, !1, "")
        ]),
        // digest
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.OCTETSTRING,
          !1,
          V.getBytes()
        )
      ]),
      // macSalt OCTET STRING
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OCTETSTRING,
        !1,
        W.getBytes()
      ),
      // iterations INTEGER (XXX: Only support count < 65536)
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.INTEGER,
        !1,
        Q.integerToDer(G).getBytes()
      )
    ]);
  }
  return Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
    // version (3)
    Q.create(
      Q.Class.UNIVERSAL,
      Q.Type.INTEGER,
      !1,
      Q.integerToDer(3).getBytes()
    ),
    // PKCS#7 ContentInfo
    Q.create(Q.Class.UNIVERSAL, Q.Type.SEQUENCE, !0, [
      // contentType
      Q.create(
        Q.Class.UNIVERSAL,
        Q.Type.OID,
        !1,
        // OID for the content type is 'data'
        Q.oidToDer($e.oids.data).getBytes()
      ),
      // content
      Q.create(Q.Class.CONTEXT_SPECIFIC, 0, !0, [
        Q.create(
          Q.Class.UNIVERSAL,
          Q.Type.OCTETSTRING,
          !1,
          Q.toDer(U).getBytes()
        )
      ])
    ]),
    z
  ]);
};
Vi.generateKey = nt.pbe.generatePkcs12Key;
var Pr = je, y0 = Pr.asn1, Si = Pr.pki = Pr.pki || {};
Si.pemToDer = function(e) {
  var t = Pr.pem.decode(e)[0];
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PEM to DER; PEM is encrypted.");
  return Pr.util.createBuffer(t.body);
};
Si.privateKeyFromPem = function(e) {
  var t = Pr.pem.decode(e)[0];
  if (t.type !== "PRIVATE KEY" && t.type !== "RSA PRIVATE KEY") {
    var i = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
    throw i.headerType = t.type, i;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert private key from PEM; PEM is encrypted.");
  var r = y0.fromDer(t.body);
  return Si.privateKeyFromAsn1(r);
};
Si.privateKeyToPem = function(e, t) {
  var i = {
    type: "RSA PRIVATE KEY",
    body: y0.toDer(Si.privateKeyToAsn1(e)).getBytes()
  };
  return Pr.pem.encode(i, { maxline: t });
};
Si.privateKeyInfoToPem = function(e, t) {
  var i = {
    type: "PRIVATE KEY",
    body: y0.toDer(e).getBytes()
  };
  return Pr.pem.encode(i, { maxline: t });
};
var oe = je, Ya = function(e, t, i, r) {
  var n = oe.util.createBuffer(), a = e.length >> 1, f = a + (e.length & 1), s = e.substr(0, f), c = e.substr(a, f), u = oe.util.createBuffer(), o = oe.hmac.create();
  i = t + i;
  var l = Math.ceil(r / 16), h = Math.ceil(r / 20);
  o.start("MD5", s);
  var p = oe.util.createBuffer();
  u.putBytes(i);
  for (var v = 0; v < l; ++v)
    o.start(null, null), o.update(u.getBytes()), u.putBuffer(o.digest()), o.start(null, null), o.update(u.bytes() + i), p.putBuffer(o.digest());
  o.start("SHA1", c);
  var y = oe.util.createBuffer();
  u.clear(), u.putBytes(i);
  for (var v = 0; v < h; ++v)
    o.start(null, null), o.update(u.getBytes()), u.putBuffer(o.digest()), o.start(null, null), o.update(u.bytes() + i), y.putBuffer(o.digest());
  return n.putBytes(oe.util.xorBytes(
    p.getBytes(),
    y.getBytes(),
    r
  )), n;
}, $g = function(e, t, i) {
  var r = oe.hmac.create();
  r.start("SHA1", e);
  var n = oe.util.createBuffer();
  return n.putInt32(t[0]), n.putInt32(t[1]), n.putByte(i.type), n.putByte(i.version.major), n.putByte(i.version.minor), n.putInt16(i.length), n.putBytes(i.fragment.bytes()), r.update(n.getBytes()), r.digest().getBytes();
}, Wg = function(e, t, i) {
  var r = !1;
  try {
    var n = e.deflate(t.fragment.getBytes());
    t.fragment = oe.util.createBuffer(n), t.length = n.length, r = !0;
  } catch {
  }
  return r;
}, Qg = function(e, t, i) {
  var r = !1;
  try {
    var n = e.inflate(t.fragment.getBytes());
    t.fragment = oe.util.createBuffer(n), t.length = n.length, r = !0;
  } catch {
  }
  return r;
}, Zt = function(e, t) {
  var i = 0;
  switch (t) {
    case 1:
      i = e.getByte();
      break;
    case 2:
      i = e.getInt16();
      break;
    case 3:
      i = e.getInt24();
      break;
    case 4:
      i = e.getInt32();
      break;
  }
  return oe.util.createBuffer(e.getBytes(i));
}, ir = function(e, t, i) {
  e.putInt(i.length(), t << 3), e.putBuffer(i);
}, K = {};
K.Versions = {
  TLS_1_0: { major: 3, minor: 1 },
  TLS_1_1: { major: 3, minor: 2 },
  TLS_1_2: { major: 3, minor: 3 }
};
K.SupportedVersions = [
  K.Versions.TLS_1_1,
  K.Versions.TLS_1_0
];
K.Version = K.SupportedVersions[0];
K.MaxFragment = 15360;
K.ConnectionEnd = {
  server: 0,
  client: 1
};
K.PRFAlgorithm = {
  tls_prf_sha256: 0
};
K.BulkCipherAlgorithm = {
  none: null,
  rc4: 0,
  des3: 1,
  aes: 2
};
K.CipherType = {
  stream: 0,
  block: 1,
  aead: 2
};
K.MACAlgorithm = {
  none: null,
  hmac_md5: 0,
  hmac_sha1: 1,
  hmac_sha256: 2,
  hmac_sha384: 3,
  hmac_sha512: 4
};
K.CompressionMethod = {
  none: 0,
  deflate: 1
};
K.ContentType = {
  change_cipher_spec: 20,
  alert: 21,
  handshake: 22,
  application_data: 23,
  heartbeat: 24
};
K.HandshakeType = {
  hello_request: 0,
  client_hello: 1,
  server_hello: 2,
  certificate: 11,
  server_key_exchange: 12,
  certificate_request: 13,
  server_hello_done: 14,
  certificate_verify: 15,
  client_key_exchange: 16,
  finished: 20
};
K.Alert = {};
K.Alert.Level = {
  warning: 1,
  fatal: 2
};
K.Alert.Description = {
  close_notify: 0,
  unexpected_message: 10,
  bad_record_mac: 20,
  decryption_failed: 21,
  record_overflow: 22,
  decompression_failure: 30,
  handshake_failure: 40,
  bad_certificate: 42,
  unsupported_certificate: 43,
  certificate_revoked: 44,
  certificate_expired: 45,
  certificate_unknown: 46,
  illegal_parameter: 47,
  unknown_ca: 48,
  access_denied: 49,
  decode_error: 50,
  decrypt_error: 51,
  export_restriction: 60,
  protocol_version: 70,
  insufficient_security: 71,
  internal_error: 80,
  user_canceled: 90,
  no_renegotiation: 100
};
K.HeartbeatMessageType = {
  heartbeat_request: 1,
  heartbeat_response: 2
};
K.CipherSuites = {};
K.getCipherSuite = function(e) {
  var t = null;
  for (var i in K.CipherSuites) {
    var r = K.CipherSuites[i];
    if (r.id[0] === e.charCodeAt(0) && r.id[1] === e.charCodeAt(1)) {
      t = r;
      break;
    }
  }
  return t;
};
K.handleUnexpected = function(e, t) {
  var i = !e.open && e.entity === K.ConnectionEnd.client;
  i || e.error(e, {
    message: "Unexpected message. Received TLS record out of order.",
    send: !0,
    alert: {
      level: K.Alert.Level.fatal,
      description: K.Alert.Description.unexpected_message
    }
  });
};
K.handleHelloRequest = function(e, t, i) {
  !e.handshaking && e.handshakes > 0 && (K.queue(e, K.createAlert(e, {
    level: K.Alert.Level.warning,
    description: K.Alert.Description.no_renegotiation
  })), K.flush(e)), e.process();
};
K.parseHelloMessage = function(e, t, i) {
  var r = null, n = e.entity === K.ConnectionEnd.client;
  if (i < 38)
    e.error(e, {
      message: n ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.illegal_parameter
      }
    });
  else {
    var a = t.fragment, f = a.length();
    if (r = {
      version: {
        major: a.getByte(),
        minor: a.getByte()
      },
      random: oe.util.createBuffer(a.getBytes(32)),
      session_id: Zt(a, 1),
      extensions: []
    }, n ? (r.cipher_suite = a.getBytes(2), r.compression_method = a.getByte()) : (r.cipher_suites = Zt(a, 2), r.compression_methods = Zt(a, 1)), f = i - (f - a.length()), f > 0) {
      for (var s = Zt(a, 2); s.length() > 0; )
        r.extensions.push({
          type: [s.getByte(), s.getByte()],
          data: Zt(s, 2)
        });
      if (!n)
        for (var c = 0; c < r.extensions.length; ++c) {
          var u = r.extensions[c];
          if (u.type[0] === 0 && u.type[1] === 0)
            for (var o = Zt(u.data, 2); o.length() > 0; ) {
              var l = o.getByte();
              if (l !== 0)
                break;
              e.session.extensions.server_name.serverNameList.push(
                Zt(o, 2).getBytes()
              );
            }
        }
    }
    if (e.session.version && (r.version.major !== e.session.version.major || r.version.minor !== e.session.version.minor))
      return e.error(e, {
        message: "TLS version change is disallowed during renegotiation.",
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.protocol_version
        }
      });
    if (n)
      e.session.cipherSuite = K.getCipherSuite(r.cipher_suite);
    else
      for (var h = oe.util.createBuffer(r.cipher_suites.bytes()); h.length() > 0 && (e.session.cipherSuite = K.getCipherSuite(h.getBytes(2)), e.session.cipherSuite === null); )
        ;
    if (e.session.cipherSuite === null)
      return e.error(e, {
        message: "No cipher suites in common.",
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.handshake_failure
        },
        cipherSuite: oe.util.bytesToHex(r.cipher_suite)
      });
    n ? e.session.compressionMethod = r.compression_method : e.session.compressionMethod = K.CompressionMethod.none;
  }
  return r;
};
K.createSecurityParameters = function(e, t) {
  var i = e.entity === K.ConnectionEnd.client, r = t.random.bytes(), n = i ? e.session.sp.client_random : r, a = i ? r : K.createRandom().getBytes();
  e.session.sp = {
    entity: e.entity,
    prf_algorithm: K.PRFAlgorithm.tls_prf_sha256,
    bulk_cipher_algorithm: null,
    cipher_type: null,
    enc_key_length: null,
    block_length: null,
    fixed_iv_length: null,
    record_iv_length: null,
    mac_algorithm: null,
    mac_length: null,
    mac_key_length: null,
    compression_algorithm: e.session.compressionMethod,
    pre_master_secret: null,
    master_secret: null,
    client_random: n,
    server_random: a
  };
};
K.handleServerHello = function(e, t, i) {
  var r = K.parseHelloMessage(e, t, i);
  if (!e.fail) {
    if (r.version.minor <= e.version.minor)
      e.version.minor = r.version.minor;
    else
      return e.error(e, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.protocol_version
        }
      });
    e.session.version = e.version;
    var n = r.session_id.bytes();
    n.length > 0 && n === e.session.id ? (e.expect = yp, e.session.resuming = !0, e.session.sp.server_random = r.random.bytes()) : (e.expect = Xg, e.session.resuming = !1, K.createSecurityParameters(e, r)), e.session.id = n, e.process();
  }
};
K.handleClientHello = function(e, t, i) {
  var r = K.parseHelloMessage(e, t, i);
  if (!e.fail) {
    var n = r.session_id.bytes(), a = null;
    if (e.sessionCache && (a = e.sessionCache.getSession(n), a === null ? n = "" : (a.version.major !== r.version.major || a.version.minor > r.version.minor) && (a = null, n = "")), n.length === 0 && (n = oe.random.getBytes(32)), e.session.id = n, e.session.clientHelloVersion = r.version, e.session.sp = {}, a)
      e.version = e.session.version = a.version, e.session.sp = a.sp;
    else {
      for (var f, s = 1; s < K.SupportedVersions.length && (f = K.SupportedVersions[s], !(f.minor <= r.version.minor)); ++s)
        ;
      e.version = { major: f.major, minor: f.minor }, e.session.version = e.version;
    }
    a !== null ? (e.expect = g0, e.session.resuming = !0, e.session.sp.client_random = r.random.bytes()) : (e.expect = e.verifyClient !== !1 ? ab : ko, e.session.resuming = !1, K.createSecurityParameters(e, r)), e.open = !0, K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createServerHello(e)
    })), e.session.resuming ? (K.queue(e, K.createRecord(e, {
      type: K.ContentType.change_cipher_spec,
      data: K.createChangeCipherSpec()
    })), e.state.pending = K.createConnectionState(e), e.state.current.write = e.state.pending.write, K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createFinished(e)
    }))) : (K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createCertificate(e)
    })), e.fail || (K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createServerKeyExchange(e)
    })), e.verifyClient !== !1 && K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createCertificateRequest(e)
    })), K.queue(e, K.createRecord(e, {
      type: K.ContentType.handshake,
      data: K.createServerHelloDone(e)
    })))), K.flush(e), e.process();
  }
};
K.handleCertificate = function(e, t, i) {
  if (i < 3)
    return e.error(e, {
      message: "Invalid Certificate message. Message too short.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment, n = {
    certificate_list: Zt(r, 3)
  }, a, f, s = [];
  try {
    for (; n.certificate_list.length() > 0; )
      a = Zt(n.certificate_list, 3), f = oe.asn1.fromDer(a), a = oe.pki.certificateFromAsn1(f, !0), s.push(a);
  } catch (u) {
    return e.error(e, {
      message: "Could not parse certificate list.",
      cause: u,
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.bad_certificate
      }
    });
  }
  var c = e.entity === K.ConnectionEnd.client;
  (c || e.verifyClient === !0) && s.length === 0 ? e.error(e, {
    message: c ? "No server certificate provided." : "No client certificate provided.",
    send: !0,
    alert: {
      level: K.Alert.Level.fatal,
      description: K.Alert.Description.illegal_parameter
    }
  }) : s.length === 0 ? e.expect = c ? kh : ko : (c ? e.session.serverCertificate = s[0] : e.session.clientCertificate = s[0], K.verifyCertificateChain(e, s) && (e.expect = c ? kh : ko)), e.process();
};
K.handleServerKeyExchange = function(e, t, i) {
  if (i > 0)
    return e.error(e, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.unsupported_certificate
      }
    });
  e.expect = Zg, e.process();
};
K.handleClientKeyExchange = function(e, t, i) {
  if (i < 48)
    return e.error(e, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.unsupported_certificate
      }
    });
  var r = t.fragment, n = {
    enc_pre_master_secret: Zt(r, 2).getBytes()
  }, a = null;
  if (e.getPrivateKey)
    try {
      a = e.getPrivateKey(e, e.session.serverCertificate), a = oe.pki.privateKeyFromPem(a);
    } catch (c) {
      e.error(e, {
        message: "Could not get private key.",
        cause: c,
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.internal_error
        }
      });
    }
  if (a === null)
    return e.error(e, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.internal_error
      }
    });
  try {
    var f = e.session.sp;
    f.pre_master_secret = a.decrypt(n.enc_pre_master_secret);
    var s = e.session.clientHelloVersion;
    if (s.major !== f.pre_master_secret.charCodeAt(0) || s.minor !== f.pre_master_secret.charCodeAt(1))
      throw new Error("TLS version rollback attack detected.");
  } catch {
    f.pre_master_secret = oe.random.getBytes(48);
  }
  e.expect = g0, e.session.clientCertificate !== null && (e.expect = nb), e.process();
};
K.handleCertificateRequest = function(e, t, i) {
  if (i < 3)
    return e.error(e, {
      message: "Invalid CertificateRequest. Message too short.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment, n = {
    certificate_types: Zt(r, 1),
    certificate_authorities: Zt(r, 2)
  };
  e.session.certificateRequest = n, e.expect = Jg, e.process();
};
K.handleCertificateVerify = function(e, t, i) {
  if (i < 2)
    return e.error(e, {
      message: "Invalid CertificateVerify. Message too short.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment;
  r.read -= 4;
  var n = r.bytes();
  r.read += 4;
  var a = {
    signature: Zt(r, 2).getBytes()
  }, f = oe.util.createBuffer();
  f.putBuffer(e.session.md5.digest()), f.putBuffer(e.session.sha1.digest()), f = f.getBytes();
  try {
    var s = e.session.clientCertificate;
    if (!s.publicKey.verify(f, a.signature, "NONE"))
      throw new Error("CertificateVerify signature does not match.");
    e.session.md5.update(n), e.session.sha1.update(n);
  } catch {
    return e.error(e, {
      message: "Bad signature in CertificateVerify.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.handshake_failure
      }
    });
  }
  e.expect = g0, e.process();
};
K.handleServerHelloDone = function(e, t, i) {
  if (i > 0)
    return e.error(e, {
      message: "Invalid ServerHelloDone message. Invalid length.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.record_overflow
      }
    });
  if (e.serverCertificate === null) {
    var r = {
      message: "No server certificate provided. Not enough security.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.insufficient_security
      }
    }, n = 0, a = e.verify(e, r.alert.description, n, []);
    if (a !== !0)
      return (a || a === 0) && (typeof a == "object" && !oe.util.isArray(a) ? (a.message && (r.message = a.message), a.alert && (r.alert.description = a.alert)) : typeof a == "number" && (r.alert.description = a)), e.error(e, r);
  }
  e.session.certificateRequest !== null && (t = K.createRecord(e, {
    type: K.ContentType.handshake,
    data: K.createCertificate(e)
  }), K.queue(e, t)), t = K.createRecord(e, {
    type: K.ContentType.handshake,
    data: K.createClientKeyExchange(e)
  }), K.queue(e, t), e.expect = rb;
  var f = function(s, c) {
    s.session.certificateRequest !== null && s.session.clientCertificate !== null && K.queue(s, K.createRecord(s, {
      type: K.ContentType.handshake,
      data: K.createCertificateVerify(s, c)
    })), K.queue(s, K.createRecord(s, {
      type: K.ContentType.change_cipher_spec,
      data: K.createChangeCipherSpec()
    })), s.state.pending = K.createConnectionState(s), s.state.current.write = s.state.pending.write, K.queue(s, K.createRecord(s, {
      type: K.ContentType.handshake,
      data: K.createFinished(s)
    })), s.expect = yp, K.flush(s), s.process();
  };
  if (e.session.certificateRequest === null || e.session.clientCertificate === null)
    return f(e, null);
  K.getClientSignature(e, f);
};
K.handleChangeCipherSpec = function(e, t) {
  if (t.fragment.getByte() !== 1)
    return e.error(e, {
      message: "Invalid ChangeCipherSpec message received.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.illegal_parameter
      }
    });
  var i = e.entity === K.ConnectionEnd.client;
  (e.session.resuming && i || !e.session.resuming && !i) && (e.state.pending = K.createConnectionState(e)), e.state.current.read = e.state.pending.read, (!e.session.resuming && i || e.session.resuming && !i) && (e.state.pending = null), e.expect = i ? eb : fb, e.process();
};
K.handleFinished = function(e, t, i) {
  var r = t.fragment;
  r.read -= 4;
  var n = r.bytes();
  r.read += 4;
  var a = t.fragment.getBytes();
  r = oe.util.createBuffer(), r.putBuffer(e.session.md5.digest()), r.putBuffer(e.session.sha1.digest());
  var f = e.entity === K.ConnectionEnd.client, s = f ? "server finished" : "client finished", c = e.session.sp, u = 12, o = Ya;
  if (r = o(c.master_secret, s, r.getBytes(), u), r.getBytes() !== a)
    return e.error(e, {
      message: "Invalid verify_data in Finished message.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.decrypt_error
      }
    });
  e.session.md5.update(n), e.session.sha1.update(n), (e.session.resuming && f || !e.session.resuming && !f) && (K.queue(e, K.createRecord(e, {
    type: K.ContentType.change_cipher_spec,
    data: K.createChangeCipherSpec()
  })), e.state.current.write = e.state.pending.write, e.state.pending = null, K.queue(e, K.createRecord(e, {
    type: K.ContentType.handshake,
    data: K.createFinished(e)
  }))), e.expect = f ? tb : sb, e.handshaking = !1, ++e.handshakes, e.peerCertificate = f ? e.session.serverCertificate : e.session.clientCertificate, K.flush(e), e.isConnected = !0, e.connected(e), e.process();
};
K.handleAlert = function(e, t) {
  var i = t.fragment, r = {
    level: i.getByte(),
    description: i.getByte()
  }, n;
  switch (r.description) {
    case K.Alert.Description.close_notify:
      n = "Connection closed.";
      break;
    case K.Alert.Description.unexpected_message:
      n = "Unexpected message.";
      break;
    case K.Alert.Description.bad_record_mac:
      n = "Bad record MAC.";
      break;
    case K.Alert.Description.decryption_failed:
      n = "Decryption failed.";
      break;
    case K.Alert.Description.record_overflow:
      n = "Record overflow.";
      break;
    case K.Alert.Description.decompression_failure:
      n = "Decompression failed.";
      break;
    case K.Alert.Description.handshake_failure:
      n = "Handshake failure.";
      break;
    case K.Alert.Description.bad_certificate:
      n = "Bad certificate.";
      break;
    case K.Alert.Description.unsupported_certificate:
      n = "Unsupported certificate.";
      break;
    case K.Alert.Description.certificate_revoked:
      n = "Certificate revoked.";
      break;
    case K.Alert.Description.certificate_expired:
      n = "Certificate expired.";
      break;
    case K.Alert.Description.certificate_unknown:
      n = "Certificate unknown.";
      break;
    case K.Alert.Description.illegal_parameter:
      n = "Illegal parameter.";
      break;
    case K.Alert.Description.unknown_ca:
      n = "Unknown certificate authority.";
      break;
    case K.Alert.Description.access_denied:
      n = "Access denied.";
      break;
    case K.Alert.Description.decode_error:
      n = "Decode error.";
      break;
    case K.Alert.Description.decrypt_error:
      n = "Decrypt error.";
      break;
    case K.Alert.Description.export_restriction:
      n = "Export restriction.";
      break;
    case K.Alert.Description.protocol_version:
      n = "Unsupported protocol version.";
      break;
    case K.Alert.Description.insufficient_security:
      n = "Insufficient security.";
      break;
    case K.Alert.Description.internal_error:
      n = "Internal error.";
      break;
    case K.Alert.Description.user_canceled:
      n = "User canceled.";
      break;
    case K.Alert.Description.no_renegotiation:
      n = "Renegotiation not supported.";
      break;
    default:
      n = "Unknown error.";
      break;
  }
  if (r.description === K.Alert.Description.close_notify)
    return e.close();
  e.error(e, {
    message: n,
    send: !1,
    // origin is the opposite end
    origin: e.entity === K.ConnectionEnd.client ? "server" : "client",
    alert: r
  }), e.process();
};
K.handleHandshake = function(e, t) {
  var i = t.fragment, r = i.getByte(), n = i.getInt24();
  if (n > i.length())
    return e.fragmented = t, t.fragment = oe.util.createBuffer(), i.read -= 4, e.process();
  e.fragmented = null, i.read -= 4;
  var a = i.bytes(n + 4);
  i.read += 4, r in Ia[e.entity][e.expect] ? (e.entity === K.ConnectionEnd.server && !e.open && !e.fail && (e.handshaking = !0, e.session = {
    version: null,
    extensions: {
      server_name: {
        serverNameList: []
      }
    },
    cipherSuite: null,
    compressionMethod: null,
    serverCertificate: null,
    clientCertificate: null,
    md5: oe.md.md5.create(),
    sha1: oe.md.sha1.create()
  }), r !== K.HandshakeType.hello_request && r !== K.HandshakeType.certificate_verify && r !== K.HandshakeType.finished && (e.session.md5.update(a), e.session.sha1.update(a)), Ia[e.entity][e.expect][r](e, t, n)) : K.handleUnexpected(e, t);
};
K.handleApplicationData = function(e, t) {
  e.data.putBuffer(t.fragment), e.dataReady(e), e.process();
};
K.handleHeartbeat = function(e, t) {
  var i = t.fragment, r = i.getByte(), n = i.getInt16(), a = i.getBytes(n);
  if (r === K.HeartbeatMessageType.heartbeat_request) {
    if (e.handshaking || n > a.length)
      return e.process();
    K.queue(e, K.createRecord(e, {
      type: K.ContentType.heartbeat,
      data: K.createHeartbeat(
        K.HeartbeatMessageType.heartbeat_response,
        a
      )
    })), K.flush(e);
  } else if (r === K.HeartbeatMessageType.heartbeat_response) {
    if (a !== e.expectedHeartbeatPayload)
      return e.process();
    e.heartbeatReceived && e.heartbeatReceived(e, oe.util.createBuffer(a));
  }
  e.process();
};
var Yg = 0, Xg = 1, kh = 2, Zg = 3, Jg = 4, yp = 5, eb = 6, tb = 7, rb = 8, ib = 0, ab = 1, ko = 2, nb = 3, g0 = 4, fb = 5, sb = 6, q = K.handleUnexpected, gp = K.handleChangeCipherSpec, Vt = K.handleAlert, $t = K.handleHandshake, bp = K.handleApplicationData, Kt = K.handleHeartbeat, b0 = [];
b0[K.ConnectionEnd.client] = [
  //      CC,AL,HS,AD,HB
  /*SHE*/
  [q, Vt, $t, q, Kt],
  /*SCE*/
  [q, Vt, $t, q, Kt],
  /*SKE*/
  [q, Vt, $t, q, Kt],
  /*SCR*/
  [q, Vt, $t, q, Kt],
  /*SHD*/
  [q, Vt, $t, q, Kt],
  /*SCC*/
  [gp, Vt, q, q, Kt],
  /*SFI*/
  [q, Vt, $t, q, Kt],
  /*SAD*/
  [q, Vt, $t, bp, Kt],
  /*SER*/
  [q, Vt, $t, q, Kt]
];
b0[K.ConnectionEnd.server] = [
  //      CC,AL,HS,AD
  /*CHE*/
  [q, Vt, $t, q, Kt],
  /*CCE*/
  [q, Vt, $t, q, Kt],
  /*CKE*/
  [q, Vt, $t, q, Kt],
  /*CCV*/
  [q, Vt, $t, q, Kt],
  /*CCC*/
  [gp, Vt, q, q, Kt],
  /*CFI*/
  [q, Vt, $t, q, Kt],
  /*CAD*/
  [q, Vt, $t, bp, Kt],
  /*CER*/
  [q, Vt, $t, q, Kt]
];
var Tr = K.handleHelloRequest, ob = K.handleServerHello, mp = K.handleCertificate, Dh = K.handleServerKeyExchange, mo = K.handleCertificateRequest, va = K.handleServerHelloDone, xp = K.handleFinished, Ia = [];
Ia[K.ConnectionEnd.client] = [
  //      HR,01,SH,03,04,05,06,07,08,09,10,SC,SK,CR,HD,15,CK,17,18,19,FI
  /*SHE*/
  [q, q, ob, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*SCE*/
  [Tr, q, q, q, q, q, q, q, q, q, q, mp, Dh, mo, va, q, q, q, q, q, q],
  /*SKE*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, Dh, mo, va, q, q, q, q, q, q],
  /*SCR*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, mo, va, q, q, q, q, q, q],
  /*SHD*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, q, va, q, q, q, q, q, q],
  /*SCC*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*SFI*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, xp],
  /*SAD*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*SER*/
  [Tr, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q]
];
var ub = K.handleClientHello, cb = K.handleClientKeyExchange, lb = K.handleCertificateVerify;
Ia[K.ConnectionEnd.server] = [
  //      01,CH,02,03,04,05,06,07,08,09,10,CC,12,13,14,CV,CK,17,18,19,FI
  /*CHE*/
  [q, ub, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*CCE*/
  [q, q, q, q, q, q, q, q, q, q, q, mp, q, q, q, q, q, q, q, q, q],
  /*CKE*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, cb, q, q, q, q],
  /*CCV*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, lb, q, q, q, q, q],
  /*CCC*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*CFI*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, xp],
  /*CAD*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q],
  /*CER*/
  [q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q, q]
];
K.generateKeys = function(e, t) {
  var i = Ya, r = t.client_random + t.server_random;
  e.session.resuming || (t.master_secret = i(
    t.pre_master_secret,
    "master secret",
    r,
    48
  ).bytes(), t.pre_master_secret = null), r = t.server_random + t.client_random;
  var n = 2 * t.mac_key_length + 2 * t.enc_key_length, a = e.version.major === K.Versions.TLS_1_0.major && e.version.minor === K.Versions.TLS_1_0.minor;
  a && (n += 2 * t.fixed_iv_length);
  var f = i(t.master_secret, "key expansion", r, n), s = {
    client_write_MAC_key: f.getBytes(t.mac_key_length),
    server_write_MAC_key: f.getBytes(t.mac_key_length),
    client_write_key: f.getBytes(t.enc_key_length),
    server_write_key: f.getBytes(t.enc_key_length)
  };
  return a && (s.client_write_IV = f.getBytes(t.fixed_iv_length), s.server_write_IV = f.getBytes(t.fixed_iv_length)), s;
};
K.createConnectionState = function(e) {
  var t = e.entity === K.ConnectionEnd.client, i = function() {
    var a = {
      // two 32-bit numbers, first is most significant
      sequenceNumber: [0, 0],
      macKey: null,
      macLength: 0,
      macFunction: null,
      cipherState: null,
      cipherFunction: function(f) {
        return !0;
      },
      compressionState: null,
      compressFunction: function(f) {
        return !0;
      },
      updateSequenceNumber: function() {
        a.sequenceNumber[1] === 4294967295 ? (a.sequenceNumber[1] = 0, ++a.sequenceNumber[0]) : ++a.sequenceNumber[1];
      }
    };
    return a;
  }, r = {
    read: i(),
    write: i()
  };
  if (r.read.update = function(a, f) {
    return r.read.cipherFunction(f, r.read) ? r.read.compressFunction(a, f, r.read) || a.error(a, {
      message: "Could not decompress record.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.decompression_failure
      }
    }) : a.error(a, {
      message: "Could not decrypt record or bad MAC.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        // doesn't matter if decryption failed or MAC was
        // invalid, return the same error so as not to reveal
        // which one occurred
        description: K.Alert.Description.bad_record_mac
      }
    }), !a.fail;
  }, r.write.update = function(a, f) {
    return r.write.compressFunction(a, f, r.write) ? r.write.cipherFunction(f, r.write) || a.error(a, {
      message: "Could not encrypt record.",
      send: !1,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.internal_error
      }
    }) : a.error(a, {
      message: "Could not compress record.",
      send: !1,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.internal_error
      }
    }), !a.fail;
  }, e.session) {
    var n = e.session.sp;
    switch (e.session.cipherSuite.initSecurityParameters(n), n.keys = K.generateKeys(e, n), r.read.macKey = t ? n.keys.server_write_MAC_key : n.keys.client_write_MAC_key, r.write.macKey = t ? n.keys.client_write_MAC_key : n.keys.server_write_MAC_key, e.session.cipherSuite.initConnectionState(r, e, n), n.compression_algorithm) {
      case K.CompressionMethod.none:
        break;
      case K.CompressionMethod.deflate:
        r.read.compressFunction = Qg, r.write.compressFunction = Wg;
        break;
      default:
        throw new Error("Unsupported compression algorithm.");
    }
  }
  return r;
};
K.createRandom = function() {
  var e = /* @__PURE__ */ new Date(), t = +e + e.getTimezoneOffset() * 6e4, i = oe.util.createBuffer();
  return i.putInt32(t), i.putBytes(oe.random.getBytes(28)), i;
};
K.createRecord = function(e, t) {
  if (!t.data)
    return null;
  var i = {
    type: t.type,
    version: {
      major: e.version.major,
      minor: e.version.minor
    },
    length: t.data.length(),
    fragment: t.data
  };
  return i;
};
K.createAlert = function(e, t) {
  var i = oe.util.createBuffer();
  return i.putByte(t.level), i.putByte(t.description), K.createRecord(e, {
    type: K.ContentType.alert,
    data: i
  });
};
K.createClientHello = function(e) {
  e.session.clientHelloVersion = {
    major: e.version.major,
    minor: e.version.minor
  };
  for (var t = oe.util.createBuffer(), i = 0; i < e.cipherSuites.length; ++i) {
    var r = e.cipherSuites[i];
    t.putByte(r.id[0]), t.putByte(r.id[1]);
  }
  var n = t.length(), a = oe.util.createBuffer();
  a.putByte(K.CompressionMethod.none);
  var f = a.length(), s = oe.util.createBuffer();
  if (e.virtualHost) {
    var c = oe.util.createBuffer();
    c.putByte(0), c.putByte(0);
    var u = oe.util.createBuffer();
    u.putByte(0), ir(u, 2, oe.util.createBuffer(e.virtualHost));
    var o = oe.util.createBuffer();
    ir(o, 2, u), ir(c, 2, o), s.putBuffer(c);
  }
  var l = s.length();
  l > 0 && (l += 2);
  var h = e.session.id, p = h.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + n + // cipher suites vector
  1 + f + // compression methods vector
  l, v = oe.util.createBuffer();
  return v.putByte(K.HandshakeType.client_hello), v.putInt24(p), v.putByte(e.version.major), v.putByte(e.version.minor), v.putBytes(e.session.sp.client_random), ir(v, 1, oe.util.createBuffer(h)), ir(v, 2, t), ir(v, 1, a), l > 0 && ir(v, 2, s), v;
};
K.createServerHello = function(e) {
  var t = e.session.id, i = t.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + // chosen cipher suite
  1, r = oe.util.createBuffer();
  return r.putByte(K.HandshakeType.server_hello), r.putInt24(i), r.putByte(e.version.major), r.putByte(e.version.minor), r.putBytes(e.session.sp.server_random), ir(r, 1, oe.util.createBuffer(t)), r.putByte(e.session.cipherSuite.id[0]), r.putByte(e.session.cipherSuite.id[1]), r.putByte(e.session.compressionMethod), r;
};
K.createCertificate = function(e) {
  var t = e.entity === K.ConnectionEnd.client, i = null;
  if (e.getCertificate) {
    var r;
    t ? r = e.session.certificateRequest : r = e.session.extensions.server_name.serverNameList, i = e.getCertificate(e, r);
  }
  var n = oe.util.createBuffer();
  if (i !== null)
    try {
      oe.util.isArray(i) || (i = [i]);
      for (var a = null, f = 0; f < i.length; ++f) {
        var s = oe.pem.decode(i[f])[0];
        if (s.type !== "CERTIFICATE" && s.type !== "X509 CERTIFICATE" && s.type !== "TRUSTED CERTIFICATE") {
          var c = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
          throw c.headerType = s.type, c;
        }
        if (s.procType && s.procType.type === "ENCRYPTED")
          throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
        var u = oe.util.createBuffer(s.body);
        a === null && (a = oe.asn1.fromDer(u.bytes(), !1));
        var o = oe.util.createBuffer();
        ir(o, 3, u), n.putBuffer(o);
      }
      i = oe.pki.certificateFromAsn1(a), t ? e.session.clientCertificate = i : e.session.serverCertificate = i;
    } catch (p) {
      return e.error(e, {
        message: "Could not send certificate list.",
        cause: p,
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.bad_certificate
        }
      });
    }
  var l = 3 + n.length(), h = oe.util.createBuffer();
  return h.putByte(K.HandshakeType.certificate), h.putInt24(l), ir(h, 3, n), h;
};
K.createClientKeyExchange = function(e) {
  var t = oe.util.createBuffer();
  t.putByte(e.session.clientHelloVersion.major), t.putByte(e.session.clientHelloVersion.minor), t.putBytes(oe.random.getBytes(46));
  var i = e.session.sp;
  i.pre_master_secret = t.getBytes();
  var r = e.session.serverCertificate.publicKey;
  t = r.encrypt(i.pre_master_secret);
  var n = t.length + 2, a = oe.util.createBuffer();
  return a.putByte(K.HandshakeType.client_key_exchange), a.putInt24(n), a.putInt16(t.length), a.putBytes(t), a;
};
K.createServerKeyExchange = function(e) {
  var t = oe.util.createBuffer();
  return t;
};
K.getClientSignature = function(e, t) {
  var i = oe.util.createBuffer();
  i.putBuffer(e.session.md5.digest()), i.putBuffer(e.session.sha1.digest()), i = i.getBytes(), e.getSignature = e.getSignature || function(r, n, a) {
    var f = null;
    if (r.getPrivateKey)
      try {
        f = r.getPrivateKey(r, r.session.clientCertificate), f = oe.pki.privateKeyFromPem(f);
      } catch (s) {
        r.error(r, {
          message: "Could not get private key.",
          cause: s,
          send: !0,
          alert: {
            level: K.Alert.Level.fatal,
            description: K.Alert.Description.internal_error
          }
        });
      }
    f === null ? r.error(r, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: K.Alert.Description.internal_error
      }
    }) : n = f.sign(n, null), a(r, n);
  }, e.getSignature(e, i, t);
};
K.createCertificateVerify = function(e, t) {
  var i = t.length + 2, r = oe.util.createBuffer();
  return r.putByte(K.HandshakeType.certificate_verify), r.putInt24(i), r.putInt16(t.length), r.putBytes(t), r;
};
K.createCertificateRequest = function(e) {
  var t = oe.util.createBuffer();
  t.putByte(1);
  var i = oe.util.createBuffer();
  for (var r in e.caStore.certs) {
    var n = e.caStore.certs[r], a = oe.pki.distinguishedNameToAsn1(n.subject), f = oe.asn1.toDer(a);
    i.putInt16(f.length()), i.putBuffer(f);
  }
  var s = 1 + t.length() + 2 + i.length(), c = oe.util.createBuffer();
  return c.putByte(K.HandshakeType.certificate_request), c.putInt24(s), ir(c, 1, t), ir(c, 2, i), c;
};
K.createServerHelloDone = function(e) {
  var t = oe.util.createBuffer();
  return t.putByte(K.HandshakeType.server_hello_done), t.putInt24(0), t;
};
K.createChangeCipherSpec = function() {
  var e = oe.util.createBuffer();
  return e.putByte(1), e;
};
K.createFinished = function(e) {
  var t = oe.util.createBuffer();
  t.putBuffer(e.session.md5.digest()), t.putBuffer(e.session.sha1.digest());
  var i = e.entity === K.ConnectionEnd.client, r = e.session.sp, n = 12, a = Ya, f = i ? "client finished" : "server finished";
  t = a(r.master_secret, f, t.getBytes(), n);
  var s = oe.util.createBuffer();
  return s.putByte(K.HandshakeType.finished), s.putInt24(t.length()), s.putBuffer(t), s;
};
K.createHeartbeat = function(e, t, i) {
  typeof i > "u" && (i = t.length);
  var r = oe.util.createBuffer();
  r.putByte(e), r.putInt16(i), r.putBytes(t);
  var n = r.length(), a = Math.max(16, n - i - 3);
  return r.putBytes(oe.random.getBytes(a)), r;
};
K.queue = function(e, t) {
  if (t && !(t.fragment.length() === 0 && (t.type === K.ContentType.handshake || t.type === K.ContentType.alert || t.type === K.ContentType.change_cipher_spec))) {
    if (t.type === K.ContentType.handshake) {
      var i = t.fragment.bytes();
      e.session.md5.update(i), e.session.sha1.update(i), i = null;
    }
    var r;
    if (t.fragment.length() <= K.MaxFragment)
      r = [t];
    else {
      r = [];
      for (var n = t.fragment.bytes(); n.length > K.MaxFragment; )
        r.push(K.createRecord(e, {
          type: t.type,
          data: oe.util.createBuffer(n.slice(0, K.MaxFragment))
        })), n = n.slice(K.MaxFragment);
      n.length > 0 && r.push(K.createRecord(e, {
        type: t.type,
        data: oe.util.createBuffer(n)
      }));
    }
    for (var a = 0; a < r.length && !e.fail; ++a) {
      var f = r[a], s = e.state.current.write;
      s.update(e, f) && e.records.push(f);
    }
  }
};
K.flush = function(e) {
  for (var t = 0; t < e.records.length; ++t) {
    var i = e.records[t];
    e.tlsData.putByte(i.type), e.tlsData.putByte(i.version.major), e.tlsData.putByte(i.version.minor), e.tlsData.putInt16(i.fragment.length()), e.tlsData.putBuffer(e.records[t].fragment);
  }
  return e.records = [], e.tlsDataReady(e);
};
var xo = function(e) {
  switch (e) {
    case !0:
      return !0;
    case oe.pki.certificateError.bad_certificate:
      return K.Alert.Description.bad_certificate;
    case oe.pki.certificateError.unsupported_certificate:
      return K.Alert.Description.unsupported_certificate;
    case oe.pki.certificateError.certificate_revoked:
      return K.Alert.Description.certificate_revoked;
    case oe.pki.certificateError.certificate_expired:
      return K.Alert.Description.certificate_expired;
    case oe.pki.certificateError.certificate_unknown:
      return K.Alert.Description.certificate_unknown;
    case oe.pki.certificateError.unknown_ca:
      return K.Alert.Description.unknown_ca;
    default:
      return K.Alert.Description.bad_certificate;
  }
}, hb = function(e) {
  switch (e) {
    case !0:
      return !0;
    case K.Alert.Description.bad_certificate:
      return oe.pki.certificateError.bad_certificate;
    case K.Alert.Description.unsupported_certificate:
      return oe.pki.certificateError.unsupported_certificate;
    case K.Alert.Description.certificate_revoked:
      return oe.pki.certificateError.certificate_revoked;
    case K.Alert.Description.certificate_expired:
      return oe.pki.certificateError.certificate_expired;
    case K.Alert.Description.certificate_unknown:
      return oe.pki.certificateError.certificate_unknown;
    case K.Alert.Description.unknown_ca:
      return oe.pki.certificateError.unknown_ca;
    default:
      return oe.pki.certificateError.bad_certificate;
  }
};
K.verifyCertificateChain = function(e, t) {
  try {
    var i = {};
    for (var r in e.verifyOptions)
      i[r] = e.verifyOptions[r];
    i.verify = function(a, f, s) {
      var c = xo(a), u = e.verify(e, a, f, s);
      if (u !== !0) {
        if (typeof u == "object" && !oe.util.isArray(u)) {
          var o = new Error("The application rejected the certificate.");
          throw o.send = !0, o.alert = {
            level: K.Alert.Level.fatal,
            description: K.Alert.Description.bad_certificate
          }, u.message && (o.message = u.message), u.alert && (o.alert.description = u.alert), o;
        }
        u !== a && (u = hb(u));
      }
      return u;
    }, oe.pki.verifyCertificateChain(e.caStore, t, i);
  } catch (a) {
    var n = a;
    (typeof n != "object" || oe.util.isArray(n)) && (n = {
      send: !0,
      alert: {
        level: K.Alert.Level.fatal,
        description: xo(a)
      }
    }), "send" in n || (n.send = !0), "alert" in n || (n.alert = {
      level: K.Alert.Level.fatal,
      description: xo(n.error)
    }), e.error(e, n);
  }
  return !e.fail;
};
K.createSessionCache = function(e, t) {
  var i = null;
  if (e && e.getSession && e.setSession && e.order)
    i = e;
  else {
    i = {}, i.cache = e || {}, i.capacity = Math.max(t || 100, 1), i.order = [];
    for (var r in e)
      i.order.length <= t ? i.order.push(r) : delete e[r];
    i.getSession = function(n) {
      var a = null, f = null;
      if (n ? f = oe.util.bytesToHex(n) : i.order.length > 0 && (f = i.order[0]), f !== null && f in i.cache) {
        a = i.cache[f], delete i.cache[f];
        for (var s in i.order)
          if (i.order[s] === f) {
            i.order.splice(s, 1);
            break;
          }
      }
      return a;
    }, i.setSession = function(n, a) {
      if (i.order.length === i.capacity) {
        var f = i.order.shift();
        delete i.cache[f];
      }
      var f = oe.util.bytesToHex(n);
      i.order.push(f), i.cache[f] = a;
    };
  }
  return i;
};
K.createConnection = function(e) {
  var t = null;
  e.caStore ? oe.util.isArray(e.caStore) ? t = oe.pki.createCaStore(e.caStore) : t = e.caStore : t = oe.pki.createCaStore();
  var i = e.cipherSuites || null;
  if (i === null) {
    i = [];
    for (var r in K.CipherSuites)
      i.push(K.CipherSuites[r]);
  }
  var n = e.server ? K.ConnectionEnd.server : K.ConnectionEnd.client, a = e.sessionCache ? K.createSessionCache(e.sessionCache) : null, f = {
    version: { major: K.Version.major, minor: K.Version.minor },
    entity: n,
    sessionId: e.sessionId,
    caStore: t,
    sessionCache: a,
    cipherSuites: i,
    connected: e.connected,
    virtualHost: e.virtualHost || null,
    verifyClient: e.verifyClient || !1,
    verify: e.verify || function(o, l, h, p) {
      return l;
    },
    verifyOptions: e.verifyOptions || {},
    getCertificate: e.getCertificate || null,
    getPrivateKey: e.getPrivateKey || null,
    getSignature: e.getSignature || null,
    input: oe.util.createBuffer(),
    tlsData: oe.util.createBuffer(),
    data: oe.util.createBuffer(),
    tlsDataReady: e.tlsDataReady,
    dataReady: e.dataReady,
    heartbeatReceived: e.heartbeatReceived,
    closed: e.closed,
    error: function(o, l) {
      l.origin = l.origin || (o.entity === K.ConnectionEnd.client ? "client" : "server"), l.send && (K.queue(o, K.createAlert(o, l.alert)), K.flush(o));
      var h = l.fatal !== !1;
      h && (o.fail = !0), e.error(o, l), h && o.close(!1);
    },
    deflate: e.deflate || null,
    inflate: e.inflate || null
  };
  f.reset = function(o) {
    f.version = { major: K.Version.major, minor: K.Version.minor }, f.record = null, f.session = null, f.peerCertificate = null, f.state = {
      pending: null,
      current: null
    }, f.expect = f.entity === K.ConnectionEnd.client ? Yg : ib, f.fragmented = null, f.records = [], f.open = !1, f.handshakes = 0, f.handshaking = !1, f.isConnected = !1, f.fail = !(o || typeof o > "u"), f.input.clear(), f.tlsData.clear(), f.data.clear(), f.state.current = K.createConnectionState(f);
  }, f.reset();
  var s = function(o, l) {
    var h = l.type - K.ContentType.change_cipher_spec, p = b0[o.entity][o.expect];
    h in p ? p[h](o, l) : K.handleUnexpected(o, l);
  }, c = function(o) {
    var l = 0, h = o.input, p = h.length();
    if (p < 5)
      l = 5 - p;
    else {
      o.record = {
        type: h.getByte(),
        version: {
          major: h.getByte(),
          minor: h.getByte()
        },
        length: h.getInt16(),
        fragment: oe.util.createBuffer(),
        ready: !1
      };
      var v = o.record.version.major === o.version.major;
      v && o.session && o.session.version && (v = o.record.version.minor === o.version.minor), v || o.error(o, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.protocol_version
        }
      });
    }
    return l;
  }, u = function(o) {
    var l = 0, h = o.input, p = h.length();
    if (p < o.record.length)
      l = o.record.length - p;
    else {
      o.record.fragment.putBytes(h.getBytes(o.record.length)), h.compact();
      var v = o.state.current.read;
      v.update(o, o.record) && (o.fragmented !== null && (o.fragmented.type === o.record.type ? (o.fragmented.fragment.putBuffer(o.record.fragment), o.record = o.fragmented) : o.error(o, {
        message: "Invalid fragmented record.",
        send: !0,
        alert: {
          level: K.Alert.Level.fatal,
          description: K.Alert.Description.unexpected_message
        }
      })), o.record.ready = !0);
    }
    return l;
  };
  return f.handshake = function(o) {
    if (f.entity !== K.ConnectionEnd.client)
      f.error(f, {
        message: "Cannot initiate handshake as a server.",
        fatal: !1
      });
    else if (f.handshaking)
      f.error(f, {
        message: "Handshake already in progress.",
        fatal: !1
      });
    else {
      f.fail && !f.open && f.handshakes === 0 && (f.fail = !1), f.handshaking = !0, o = o || "";
      var l = null;
      o.length > 0 && (f.sessionCache && (l = f.sessionCache.getSession(o)), l === null && (o = "")), o.length === 0 && f.sessionCache && (l = f.sessionCache.getSession(), l !== null && (o = l.id)), f.session = {
        id: o,
        version: null,
        cipherSuite: null,
        compressionMethod: null,
        serverCertificate: null,
        certificateRequest: null,
        clientCertificate: null,
        sp: {},
        md5: oe.md.md5.create(),
        sha1: oe.md.sha1.create()
      }, l && (f.version = l.version, f.session.sp = l.sp), f.session.sp.client_random = K.createRandom().getBytes(), f.open = !0, K.queue(f, K.createRecord(f, {
        type: K.ContentType.handshake,
        data: K.createClientHello(f)
      })), K.flush(f);
    }
  }, f.process = function(o) {
    var l = 0;
    return o && f.input.putBytes(o), f.fail || (f.record !== null && f.record.ready && f.record.fragment.isEmpty() && (f.record = null), f.record === null && (l = c(f)), !f.fail && f.record !== null && !f.record.ready && (l = u(f)), !f.fail && f.record !== null && f.record.ready && s(f, f.record)), l;
  }, f.prepare = function(o) {
    return K.queue(f, K.createRecord(f, {
      type: K.ContentType.application_data,
      data: oe.util.createBuffer(o)
    })), K.flush(f);
  }, f.prepareHeartbeatRequest = function(o, l) {
    return o instanceof oe.util.ByteBuffer && (o = o.bytes()), typeof l > "u" && (l = o.length), f.expectedHeartbeatPayload = o, K.queue(f, K.createRecord(f, {
      type: K.ContentType.heartbeat,
      data: K.createHeartbeat(
        K.HeartbeatMessageType.heartbeat_request,
        o,
        l
      )
    })), K.flush(f);
  }, f.close = function(o) {
    if (!f.fail && f.sessionCache && f.session) {
      var l = {
        id: f.session.id,
        version: f.session.version,
        sp: f.session.sp
      };
      l.sp.keys = null, f.sessionCache.setSession(l.id, l);
    }
    f.open && (f.open = !1, f.input.clear(), (f.isConnected || f.handshaking) && (f.isConnected = f.handshaking = !1, K.queue(f, K.createAlert(f, {
      level: K.Alert.Level.warning,
      description: K.Alert.Description.close_notify
    })), K.flush(f)), f.closed(f)), f.reset(o);
  }, f;
};
oe.tls = oe.tls || {};
for (var _o in K)
  typeof K[_o] != "function" && (oe.tls[_o] = K[_o]);
oe.tls.prf_tls1 = Ya;
oe.tls.hmac_sha1 = $g;
oe.tls.createSessionCache = K.createSessionCache;
oe.tls.createConnection = K.createConnection;
var Dr = je, sr = Dr.tls;
sr.CipherSuites.TLS_RSA_WITH_AES_128_CBC_SHA = {
  id: [0, 47],
  name: "TLS_RSA_WITH_AES_128_CBC_SHA",
  initSecurityParameters: function(e) {
    e.bulk_cipher_algorithm = sr.BulkCipherAlgorithm.aes, e.cipher_type = sr.CipherType.block, e.enc_key_length = 16, e.block_length = 16, e.fixed_iv_length = 16, e.record_iv_length = 16, e.mac_algorithm = sr.MACAlgorithm.hmac_sha1, e.mac_length = 20, e.mac_key_length = 20;
  },
  initConnectionState: _p
};
sr.CipherSuites.TLS_RSA_WITH_AES_256_CBC_SHA = {
  id: [0, 53],
  name: "TLS_RSA_WITH_AES_256_CBC_SHA",
  initSecurityParameters: function(e) {
    e.bulk_cipher_algorithm = sr.BulkCipherAlgorithm.aes, e.cipher_type = sr.CipherType.block, e.enc_key_length = 32, e.block_length = 16, e.fixed_iv_length = 16, e.record_iv_length = 16, e.mac_algorithm = sr.MACAlgorithm.hmac_sha1, e.mac_length = 20, e.mac_key_length = 20;
  },
  initConnectionState: _p
};
function _p(e, t, i) {
  var r = t.entity === Dr.tls.ConnectionEnd.client;
  e.read.cipherState = {
    init: !1,
    cipher: Dr.cipher.createDecipher("AES-CBC", r ? i.keys.server_write_key : i.keys.client_write_key),
    iv: r ? i.keys.server_write_IV : i.keys.client_write_IV
  }, e.write.cipherState = {
    init: !1,
    cipher: Dr.cipher.createCipher("AES-CBC", r ? i.keys.client_write_key : i.keys.server_write_key),
    iv: r ? i.keys.client_write_IV : i.keys.server_write_IV
  }, e.read.cipherFunction = yb, e.write.cipherFunction = db, e.read.macLength = e.write.macLength = i.mac_length, e.read.macFunction = e.write.macFunction = sr.hmac_sha1;
}
function db(e, t) {
  var i = !1, r = t.macFunction(t.macKey, t.sequenceNumber, e);
  e.fragment.putBytes(r), t.updateSequenceNumber();
  var n;
  e.version.minor === sr.Versions.TLS_1_0.minor ? n = t.cipherState.init ? null : t.cipherState.iv : n = Dr.random.getBytesSync(16), t.cipherState.init = !0;
  var a = t.cipherState.cipher;
  return a.start({ iv: n }), e.version.minor >= sr.Versions.TLS_1_1.minor && a.output.putBytes(n), a.update(e.fragment), a.finish(pb) && (e.fragment = a.output, e.length = e.fragment.length(), i = !0), i;
}
function pb(e, t, i) {
  if (!i) {
    var r = e - t.length() % e;
    t.fillWithByte(r - 1, r);
  }
  return !0;
}
function vb(e, t, i) {
  var r = !0;
  if (i) {
    for (var n = t.length(), a = t.last(), f = n - 1 - a; f < n - 1; ++f)
      r = r && t.at(f) == a;
    r && t.truncate(a + 1);
  }
  return r;
}
function yb(e, t) {
  var i = !1, r;
  e.version.minor === sr.Versions.TLS_1_0.minor ? r = t.cipherState.init ? null : t.cipherState.iv : r = e.fragment.getBytes(16), t.cipherState.init = !0;
  var n = t.cipherState.cipher;
  n.start({ iv: r }), n.update(e.fragment), i = n.finish(vb);
  var a = t.macLength, f = Dr.random.getBytesSync(a), s = n.output.length();
  s >= a ? (e.fragment = n.output.getBytes(s - a), f = n.output.getBytes(a)) : e.fragment = n.output.getBytes(), e.fragment = Dr.util.createBuffer(e.fragment), e.length = e.fragment.length();
  var c = t.macFunction(t.macKey, t.sequenceNumber, e);
  return t.updateSequenceNumber(), i = gb(t.macKey, f, c) && i, i;
}
function gb(e, t, i) {
  var r = Dr.hmac.create();
  return r.start("SHA1", e), r.update(t), t = r.digest().getBytes(), r.start(null, null), r.update(i), i = r.digest().getBytes(), t === i;
}
var ot = je, Ji = ot.sha512 = ot.sha512 || {};
ot.md.sha512 = ot.md.algorithms.sha512 = Ji;
var Sp = ot.sha384 = ot.sha512.sha384 = ot.sha512.sha384 || {};
Sp.create = function() {
  return Ji.create("SHA-384");
};
ot.md.sha384 = ot.md.algorithms.sha384 = Sp;
ot.sha512.sha256 = ot.sha512.sha256 || {
  create: function() {
    return Ji.create("SHA-512/256");
  }
};
ot.md["sha512/256"] = ot.md.algorithms["sha512/256"] = ot.sha512.sha256;
ot.sha512.sha224 = ot.sha512.sha224 || {
  create: function() {
    return Ji.create("SHA-512/224");
  }
};
ot.md["sha512/224"] = ot.md.algorithms["sha512/224"] = ot.sha512.sha224;
Ji.create = function(e) {
  if (Ep || bb(), typeof e > "u" && (e = "SHA-512"), !(e in fi))
    throw new Error("Invalid SHA-512 algorithm: " + e);
  for (var t = fi[e], i = null, r = ot.util.createBuffer(), n = new Array(80), a = 0; a < 80; ++a)
    n[a] = new Array(2);
  var f = 64;
  switch (e) {
    case "SHA-384":
      f = 48;
      break;
    case "SHA-512/256":
      f = 32;
      break;
    case "SHA-512/224":
      f = 28;
      break;
  }
  var s = {
    // SHA-512 => sha512
    algorithm: e.replace("-", "").toLowerCase(),
    blockLength: 128,
    digestLength: f,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 16
  };
  return s.start = function() {
    s.messageLength = 0, s.fullMessageLength = s.messageLength128 = [];
    for (var c = s.messageLengthSize / 4, u = 0; u < c; ++u)
      s.fullMessageLength.push(0);
    r = ot.util.createBuffer(), i = new Array(t.length);
    for (var u = 0; u < t.length; ++u)
      i[u] = t[u].slice(0);
    return s;
  }, s.start(), s.update = function(c, u) {
    u === "utf8" && (c = ot.util.encodeUtf8(c));
    var o = c.length;
    s.messageLength += o, o = [o / 4294967296 >>> 0, o >>> 0];
    for (var l = s.fullMessageLength.length - 1; l >= 0; --l)
      s.fullMessageLength[l] += o[1], o[1] = o[0] + (s.fullMessageLength[l] / 4294967296 >>> 0), s.fullMessageLength[l] = s.fullMessageLength[l] >>> 0, o[0] = o[1] / 4294967296 >>> 0;
    return r.putBytes(c), Lh(i, n, r), (r.read > 2048 || r.length() === 0) && r.compact(), s;
  }, s.digest = function() {
    var c = ot.util.createBuffer();
    c.putBytes(r.bytes());
    var u = s.fullMessageLength[s.fullMessageLength.length - 1] + s.messageLengthSize, o = u & s.blockLength - 1;
    c.putBytes(Do.substr(0, s.blockLength - o));
    for (var l, h, p = s.fullMessageLength[0] * 8, v = 0; v < s.fullMessageLength.length - 1; ++v)
      l = s.fullMessageLength[v + 1] * 8, h = l / 4294967296 >>> 0, p += h, c.putInt32(p >>> 0), p = l >>> 0;
    c.putInt32(p);
    for (var y = new Array(i.length), v = 0; v < i.length; ++v)
      y[v] = i[v].slice(0);
    Lh(y, n, c);
    var w = ot.util.createBuffer(), x;
    e === "SHA-512" ? x = y.length : e === "SHA-384" ? x = y.length - 2 : x = y.length - 4;
    for (var v = 0; v < x; ++v)
      w.putInt32(y[v][0]), (v !== x - 1 || e !== "SHA-512/224") && w.putInt32(y[v][1]);
    return w;
  }, s;
};
var Do = null, Ep = !1, Lo = null, fi = null;
function bb() {
  Do = "", Do += ot.util.fillString("\0", 128), Lo = [
    [1116352408, 3609767458],
    [1899447441, 602891725],
    [3049323471, 3964484399],
    [3921009573, 2173295548],
    [961987163, 4081628472],
    [1508970993, 3053834265],
    [2453635748, 2937671579],
    [2870763221, 3664609560],
    [3624381080, 2734883394],
    [310598401, 1164996542],
    [607225278, 1323610764],
    [1426881987, 3590304994],
    [1925078388, 4068182383],
    [2162078206, 991336113],
    [2614888103, 633803317],
    [3248222580, 3479774868],
    [3835390401, 2666613458],
    [4022224774, 944711139],
    [264347078, 2341262773],
    [604807628, 2007800933],
    [770255983, 1495990901],
    [1249150122, 1856431235],
    [1555081692, 3175218132],
    [1996064986, 2198950837],
    [2554220882, 3999719339],
    [2821834349, 766784016],
    [2952996808, 2566594879],
    [3210313671, 3203337956],
    [3336571891, 1034457026],
    [3584528711, 2466948901],
    [113926993, 3758326383],
    [338241895, 168717936],
    [666307205, 1188179964],
    [773529912, 1546045734],
    [1294757372, 1522805485],
    [1396182291, 2643833823],
    [1695183700, 2343527390],
    [1986661051, 1014477480],
    [2177026350, 1206759142],
    [2456956037, 344077627],
    [2730485921, 1290863460],
    [2820302411, 3158454273],
    [3259730800, 3505952657],
    [3345764771, 106217008],
    [3516065817, 3606008344],
    [3600352804, 1432725776],
    [4094571909, 1467031594],
    [275423344, 851169720],
    [430227734, 3100823752],
    [506948616, 1363258195],
    [659060556, 3750685593],
    [883997877, 3785050280],
    [958139571, 3318307427],
    [1322822218, 3812723403],
    [1537002063, 2003034995],
    [1747873779, 3602036899],
    [1955562222, 1575990012],
    [2024104815, 1125592928],
    [2227730452, 2716904306],
    [2361852424, 442776044],
    [2428436474, 593698344],
    [2756734187, 3733110249],
    [3204031479, 2999351573],
    [3329325298, 3815920427],
    [3391569614, 3928383900],
    [3515267271, 566280711],
    [3940187606, 3454069534],
    [4118630271, 4000239992],
    [116418474, 1914138554],
    [174292421, 2731055270],
    [289380356, 3203993006],
    [460393269, 320620315],
    [685471733, 587496836],
    [852142971, 1086792851],
    [1017036298, 365543100],
    [1126000580, 2618297676],
    [1288033470, 3409855158],
    [1501505948, 4234509866],
    [1607167915, 987167468],
    [1816402316, 1246189591]
  ], fi = {}, fi["SHA-512"] = [
    [1779033703, 4089235720],
    [3144134277, 2227873595],
    [1013904242, 4271175723],
    [2773480762, 1595750129],
    [1359893119, 2917565137],
    [2600822924, 725511199],
    [528734635, 4215389547],
    [1541459225, 327033209]
  ], fi["SHA-384"] = [
    [3418070365, 3238371032],
    [1654270250, 914150663],
    [2438529370, 812702999],
    [355462360, 4144912697],
    [1731405415, 4290775857],
    [2394180231, 1750603025],
    [3675008525, 1694076839],
    [1203062813, 3204075428]
  ], fi["SHA-512/256"] = [
    [573645204, 4230739756],
    [2673172387, 3360449730],
    [596883563, 1867755857],
    [2520282905, 1497426621],
    [2519219938, 2827943907],
    [3193839141, 1401305490],
    [721525244, 746961066],
    [246885852, 2177182882]
  ], fi["SHA-512/224"] = [
    [2352822216, 424955298],
    [1944164710, 2312950998],
    [502970286, 855612546],
    [1738396948, 1479516111],
    [258812777, 2077511080],
    [2011393907, 79989058],
    [1067287976, 1780299464],
    [286451373, 2446758561]
  ], Ep = !0;
}
function Lh(e, t, i) {
  for (var r, n, a, f, s, c, u, o, l, h, p, v, y, w, x, A, R, M, D, U, z, W, G, re, V, m, g, d, b, C, E, B, T, _, I, S = i.length(); S >= 128; ) {
    for (b = 0; b < 16; ++b)
      t[b][0] = i.getInt32() >>> 0, t[b][1] = i.getInt32() >>> 0;
    for (; b < 80; ++b)
      B = t[b - 2], C = B[0], E = B[1], r = ((C >>> 19 | E << 13) ^ // ROTR 19
      (E >>> 29 | C << 3) ^ // ROTR 61/(swap + ROTR 29)
      C >>> 6) >>> 0, n = ((C << 13 | E >>> 19) ^ // ROTR 19
      (E << 3 | C >>> 29) ^ // ROTR 61/(swap + ROTR 29)
      (C << 26 | E >>> 6)) >>> 0, _ = t[b - 15], C = _[0], E = _[1], a = ((C >>> 1 | E << 31) ^ // ROTR 1
      (C >>> 8 | E << 24) ^ // ROTR 8
      C >>> 7) >>> 0, f = ((C << 31 | E >>> 1) ^ // ROTR 1
      (C << 24 | E >>> 8) ^ // ROTR 8
      (C << 25 | E >>> 7)) >>> 0, T = t[b - 7], I = t[b - 16], E = n + T[1] + f + I[1], t[b][0] = r + T[0] + a + I[0] + (E / 4294967296 >>> 0) >>> 0, t[b][1] = E >>> 0;
    for (y = e[0][0], w = e[0][1], x = e[1][0], A = e[1][1], R = e[2][0], M = e[2][1], D = e[3][0], U = e[3][1], z = e[4][0], W = e[4][1], G = e[5][0], re = e[5][1], V = e[6][0], m = e[6][1], g = e[7][0], d = e[7][1], b = 0; b < 80; ++b)
      u = ((z >>> 14 | W << 18) ^ // ROTR 14
      (z >>> 18 | W << 14) ^ // ROTR 18
      (W >>> 9 | z << 23)) >>> 0, o = ((z << 18 | W >>> 14) ^ // ROTR 14
      (z << 14 | W >>> 18) ^ // ROTR 18
      (W << 23 | z >>> 9)) >>> 0, l = (V ^ z & (G ^ V)) >>> 0, h = (m ^ W & (re ^ m)) >>> 0, s = ((y >>> 28 | w << 4) ^ // ROTR 28
      (w >>> 2 | y << 30) ^ // ROTR 34/(swap + ROTR 2)
      (w >>> 7 | y << 25)) >>> 0, c = ((y << 4 | w >>> 28) ^ // ROTR 28
      (w << 30 | y >>> 2) ^ // ROTR 34/(swap + ROTR 2)
      (w << 25 | y >>> 7)) >>> 0, p = (y & x | R & (y ^ x)) >>> 0, v = (w & A | M & (w ^ A)) >>> 0, E = d + o + h + Lo[b][1] + t[b][1], r = g + u + l + Lo[b][0] + t[b][0] + (E / 4294967296 >>> 0) >>> 0, n = E >>> 0, E = c + v, a = s + p + (E / 4294967296 >>> 0) >>> 0, f = E >>> 0, g = V, d = m, V = G, m = re, G = z, re = W, E = U + n, z = D + r + (E / 4294967296 >>> 0) >>> 0, W = E >>> 0, D = R, U = M, R = x, M = A, x = y, A = w, E = n + f, y = r + a + (E / 4294967296 >>> 0) >>> 0, w = E >>> 0;
    E = e[0][1] + w, e[0][0] = e[0][0] + y + (E / 4294967296 >>> 0) >>> 0, e[0][1] = E >>> 0, E = e[1][1] + A, e[1][0] = e[1][0] + x + (E / 4294967296 >>> 0) >>> 0, e[1][1] = E >>> 0, E = e[2][1] + M, e[2][0] = e[2][0] + R + (E / 4294967296 >>> 0) >>> 0, e[2][1] = E >>> 0, E = e[3][1] + U, e[3][0] = e[3][0] + D + (E / 4294967296 >>> 0) >>> 0, e[3][1] = E >>> 0, E = e[4][1] + W, e[4][0] = e[4][0] + z + (E / 4294967296 >>> 0) >>> 0, e[4][1] = E >>> 0, E = e[5][1] + re, e[5][0] = e[5][0] + G + (E / 4294967296 >>> 0) >>> 0, e[5][1] = E >>> 0, E = e[6][1] + m, e[6][0] = e[6][0] + V + (E / 4294967296 >>> 0) >>> 0, e[6][1] = E >>> 0, E = e[7][1] + d, e[7][0] = e[7][0] + g + (E / 4294967296 >>> 0) >>> 0, e[7][1] = E >>> 0, S -= 128;
  }
}
var m0 = {}, mb = je, Ut = mb.asn1;
m0.privateKeyValidator = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: Ut.Class.UNIVERSAL,
  type: Ut.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: Ut.Class.UNIVERSAL,
    type: Ut.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: Ut.Class.UNIVERSAL,
    type: Ut.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: Ut.Class.UNIVERSAL,
      type: Ut.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: Ut.Class.UNIVERSAL,
    type: Ut.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
};
m0.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: Ut.Class.UNIVERSAL,
  type: Ut.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [
    {
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: Ut.Class.UNIVERSAL,
      type: Ut.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: Ut.Class.UNIVERSAL,
        type: Ut.Type.OID,
        constructed: !1,
        capture: "publicKeyOid"
      }]
    },
    // capture group for ed25519PublicKey
    {
      tagClass: Ut.Class.UNIVERSAL,
      type: Ut.Type.BITSTRING,
      constructed: !1,
      composed: !0,
      captureBitStringValue: "ed25519PublicKey"
    }
    // FIXME: this is capture group for rsaPublicKey, use it in this API or
    // discard?
    /* {
      // subjectPublicKey
      name: 'SubjectPublicKeyInfo.subjectPublicKey',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      value: [{
        // RSAPublicKey
        name: 'SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        optional: true,
        captureAsn1: 'rsaPublicKey'
      }]
    } */
  ]
};
var Ht = je, wp = m0, xb = wp.publicKeyValidator, _b = wp.privateKeyValidator;
if (typeof Sb > "u")
  var Sb = Ht.jsbn.BigInteger;
var Po = Ht.util.ByteBuffer, Yt = typeof fe.Buffer > "u" ? Uint8Array : fe.Buffer;
Ht.pki = Ht.pki || {};
Ht.pki.ed25519 = Ht.ed25519 = Ht.ed25519 || {};
var We = Ht.ed25519;
We.constants = {};
We.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
We.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
We.constants.SEED_BYTE_LENGTH = 32;
We.constants.SIGN_BYTE_LENGTH = 64;
We.constants.HASH_BYTE_LENGTH = 64;
We.generateKeyPair = function(e) {
  e = e || {};
  var t = e.seed;
  if (t === void 0)
    t = Ht.random.getBytesSync(We.constants.SEED_BYTE_LENGTH);
  else if (typeof t == "string") {
    if (t.length !== We.constants.SEED_BYTE_LENGTH)
      throw new TypeError(
        '"seed" must be ' + We.constants.SEED_BYTE_LENGTH + " bytes in length."
      );
  } else if (!(t instanceof Uint8Array))
    throw new TypeError(
      '"seed" must be a node.js Buffer, Uint8Array, or a binary string.'
    );
  t = Ar({ message: t, encoding: "binary" });
  for (var i = new Yt(We.constants.PUBLIC_KEY_BYTE_LENGTH), r = new Yt(We.constants.PRIVATE_KEY_BYTE_LENGTH), n = 0; n < 32; ++n)
    r[n] = t[n];
  return Ab(i, r), { publicKey: i, privateKey: r };
};
We.privateKeyFromAsn1 = function(e) {
  var t = {}, i = [], r = Ht.asn1.validate(e, _b, t, i);
  if (!r) {
    var n = new Error("Invalid Key.");
    throw n.errors = i, n;
  }
  var a = Ht.asn1.derToOid(t.privateKeyOid), f = Ht.oids.EdDSA25519;
  if (a !== f)
    throw new Error('Invalid OID "' + a + '"; OID must be "' + f + '".');
  var s = t.privateKey, c = Ar({
    message: Ht.asn1.fromDer(s).value,
    encoding: "binary"
  });
  return { privateKeyBytes: c };
};
We.publicKeyFromAsn1 = function(e) {
  var t = {}, i = [], r = Ht.asn1.validate(e, xb, t, i);
  if (!r) {
    var n = new Error("Invalid Key.");
    throw n.errors = i, n;
  }
  var a = Ht.asn1.derToOid(t.publicKeyOid), f = Ht.oids.EdDSA25519;
  if (a !== f)
    throw new Error('Invalid OID "' + a + '"; OID must be "' + f + '".');
  var s = t.ed25519PublicKey;
  if (s.length !== We.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new Error("Key length is invalid.");
  return Ar({
    message: s,
    encoding: "binary"
  });
};
We.publicKeyFromPrivateKey = function(e) {
  e = e || {};
  var t = Ar({
    message: e.privateKey,
    encoding: "binary"
  });
  if (t.length !== We.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + We.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  for (var i = new Yt(We.constants.PUBLIC_KEY_BYTE_LENGTH), r = 0; r < i.length; ++r)
    i[r] = t[32 + r];
  return i;
};
We.sign = function(e) {
  e = e || {};
  var t = Ar(e), i = Ar({
    message: e.privateKey,
    encoding: "binary"
  });
  if (i.length === We.constants.SEED_BYTE_LENGTH) {
    var r = We.generateKeyPair({ seed: i });
    i = r.privateKey;
  } else if (i.length !== We.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + We.constants.SEED_BYTE_LENGTH + " or " + We.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  var n = new Yt(
    We.constants.SIGN_BYTE_LENGTH + t.length
  );
  Bb(n, t, t.length, i);
  for (var a = new Yt(We.constants.SIGN_BYTE_LENGTH), f = 0; f < a.length; ++f)
    a[f] = n[f];
  return a;
};
We.verify = function(e) {
  e = e || {};
  var t = Ar(e);
  if (e.signature === void 0)
    throw new TypeError(
      '"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.'
    );
  var i = Ar({
    message: e.signature,
    encoding: "binary"
  });
  if (i.length !== We.constants.SIGN_BYTE_LENGTH)
    throw new TypeError(
      '"options.signature" must have a byte length of ' + We.constants.SIGN_BYTE_LENGTH
    );
  var r = Ar({
    message: e.publicKey,
    encoding: "binary"
  });
  if (r.length !== We.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.publicKey" must have a byte length of ' + We.constants.PUBLIC_KEY_BYTE_LENGTH
    );
  var n = new Yt(We.constants.SIGN_BYTE_LENGTH + t.length), a = new Yt(We.constants.SIGN_BYTE_LENGTH + t.length), f;
  for (f = 0; f < We.constants.SIGN_BYTE_LENGTH; ++f)
    n[f] = i[f];
  for (f = 0; f < t.length; ++f)
    n[f + We.constants.SIGN_BYTE_LENGTH] = t[f];
  return Tb(a, n, n.length, r) >= 0;
};
function Ar(e) {
  var t = e.message;
  if (t instanceof Uint8Array || t instanceof Yt)
    return t;
  var i = e.encoding;
  if (t === void 0)
    if (e.md)
      t = e.md.digest().getBytes(), i = "binary";
    else
      throw new TypeError('"options.message" or "options.md" not specified.');
  if (typeof t == "string" && !i)
    throw new TypeError('"options.encoding" must be "binary" or "utf8".');
  if (typeof t == "string") {
    if (typeof fe.Buffer < "u")
      return fe.Buffer.from(t, i);
    t = new Po(t, i);
  } else if (!(t instanceof Po))
    throw new TypeError(
      '"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.'
    );
  for (var r = new Yt(t.length()), n = 0; n < r.length; ++n)
    r[n] = t.at(n);
  return r;
}
var Uo = we(), Ra = we([1]), Eb = we([
  30883,
  4953,
  19914,
  30187,
  55467,
  16705,
  2637,
  112,
  59544,
  30585,
  16505,
  36039,
  65139,
  11119,
  27886,
  20995
]), wb = we([
  61785,
  9906,
  39828,
  60374,
  45398,
  33411,
  5274,
  224,
  53552,
  61171,
  33010,
  6542,
  64743,
  22239,
  55772,
  9222
]), Ph = we([
  54554,
  36645,
  11616,
  51542,
  42930,
  38181,
  51040,
  26924,
  56412,
  64982,
  57905,
  49316,
  21502,
  52590,
  14035,
  8553
]), Uh = we([
  26200,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214
]), So = new Float64Array([
  237,
  211,
  245,
  92,
  26,
  99,
  18,
  88,
  214,
  156,
  247,
  162,
  222,
  249,
  222,
  20,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  16
]), Cb = we([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function Oi(e, t) {
  var i = Ht.md.sha512.create(), r = new Po(e);
  i.update(r.getBytes(t), "binary");
  var n = i.digest().getBytes();
  if (typeof fe.Buffer < "u")
    return fe.Buffer.from(n, "binary");
  for (var a = new Yt(We.constants.HASH_BYTE_LENGTH), f = 0; f < 64; ++f)
    a[f] = n.charCodeAt(f);
  return a;
}
function Ab(e, t) {
  var i = [we(), we(), we(), we()], r, n = Oi(t, 32);
  for (n[0] &= 248, n[31] &= 127, n[31] |= 64, _0(i, n), x0(e, i), r = 0; r < 32; ++r)
    t[r + 32] = e[r];
  return 0;
}
function Bb(e, t, i, r) {
  var n, a, f = new Float64Array(64), s = [we(), we(), we(), we()], c = Oi(r, 32);
  c[0] &= 248, c[31] &= 127, c[31] |= 64;
  var u = i + 64;
  for (n = 0; n < i; ++n)
    e[64 + n] = t[n];
  for (n = 0; n < 32; ++n)
    e[32 + n] = c[32 + n];
  var o = Oi(e.subarray(32), i + 32);
  for (Oo(o), _0(s, o), x0(e, s), n = 32; n < 64; ++n)
    e[n] = r[n];
  var l = Oi(e, i + 64);
  for (Oo(l), n = 32; n < 64; ++n)
    f[n] = 0;
  for (n = 0; n < 32; ++n)
    f[n] = o[n];
  for (n = 0; n < 32; ++n)
    for (a = 0; a < 32; a++)
      f[n + a] += l[n] * c[a];
  return Cp(e.subarray(32), f), u;
}
function Tb(e, t, i, r) {
  var n, a, f = new Yt(32), s = [we(), we(), we(), we()], c = [we(), we(), we(), we()];
  if (a = -1, i < 64 || Ib(c, r))
    return -1;
  for (n = 0; n < i; ++n)
    e[n] = t[n];
  for (n = 0; n < 32; ++n)
    e[n + 32] = r[n];
  var u = Oi(e, i);
  if (Oo(u), Tp(s, c, u), _0(c, t.subarray(32)), qo(s, c), x0(f, s), i -= 64, Ap(t, 0, f, 0)) {
    for (n = 0; n < i; ++n)
      e[n] = 0;
    return -1;
  }
  for (n = 0; n < i; ++n)
    e[n] = t[n + 64];
  return a = i, a;
}
function Cp(e, t) {
  var i, r, n, a;
  for (r = 63; r >= 32; --r) {
    for (i = 0, n = r - 32, a = r - 12; n < a; ++n)
      t[n] += i - 16 * t[r] * So[n - (r - 32)], i = t[n] + 128 >> 8, t[n] -= i * 256;
    t[n] += i, t[r] = 0;
  }
  for (i = 0, n = 0; n < 32; ++n)
    t[n] += i - (t[31] >> 4) * So[n], i = t[n] >> 8, t[n] &= 255;
  for (n = 0; n < 32; ++n)
    t[n] -= i * So[n];
  for (r = 0; r < 32; ++r)
    t[r + 1] += t[r] >> 8, e[r] = t[r] & 255;
}
function Oo(e) {
  for (var t = new Float64Array(64), i = 0; i < 64; ++i)
    t[i] = e[i], e[i] = 0;
  Cp(e, t);
}
function qo(e, t) {
  var i = we(), r = we(), n = we(), a = we(), f = we(), s = we(), c = we(), u = we(), o = we();
  yi(i, e[1], e[0]), yi(o, t[1], t[0]), at(i, i, o), pi(r, e[0], e[1]), pi(o, t[0], t[1]), at(r, r, o), at(n, e[3], t[3]), at(n, n, wb), at(a, e[2], t[2]), pi(a, a, a), yi(f, r, i), yi(s, a, n), pi(c, a, n), pi(u, r, i), at(e[0], f, s), at(e[1], u, c), at(e[2], c, s), at(e[3], f, u);
}
function Oh(e, t, i) {
  for (var r = 0; r < 4; ++r)
    Ip(e[r], t[r], i);
}
function x0(e, t) {
  var i = we(), r = we(), n = we();
  kb(n, t[2]), at(i, t[0], n), at(r, t[1], n), Ma(e, r), e[31] ^= Bp(i) << 7;
}
function Ma(e, t) {
  var i, r, n, a = we(), f = we();
  for (i = 0; i < 16; ++i)
    f[i] = t[i];
  for (Eo(f), Eo(f), Eo(f), r = 0; r < 2; ++r) {
    for (a[0] = f[0] - 65517, i = 1; i < 15; ++i)
      a[i] = f[i] - 65535 - (a[i - 1] >> 16 & 1), a[i - 1] &= 65535;
    a[15] = f[15] - 32767 - (a[14] >> 16 & 1), n = a[15] >> 16 & 1, a[14] &= 65535, Ip(f, a, 1 - n);
  }
  for (i = 0; i < 16; i++)
    e[2 * i] = f[i] & 255, e[2 * i + 1] = f[i] >> 8;
}
function Ib(e, t) {
  var i = we(), r = we(), n = we(), a = we(), f = we(), s = we(), c = we();
  return Nr(e[2], Ra), Rb(e[1], t), si(n, e[1]), at(a, n, Eb), yi(n, n, e[2]), pi(a, e[2], a), si(f, a), si(s, f), at(c, s, f), at(i, c, n), at(i, i, a), Mb(i, i), at(i, i, n), at(i, i, a), at(i, i, a), at(e[0], i, a), si(r, e[0]), at(r, r, a), qh(r, n) && at(e[0], e[0], Cb), si(r, e[0]), at(r, r, a), qh(r, n) ? -1 : (Bp(e[0]) === t[31] >> 7 && yi(e[0], Uo, e[0]), at(e[3], e[0], e[1]), 0);
}
function Rb(e, t) {
  var i;
  for (i = 0; i < 16; ++i)
    e[i] = t[2 * i] + (t[2 * i + 1] << 8);
  e[15] &= 32767;
}
function Mb(e, t) {
  var i = we(), r;
  for (r = 0; r < 16; ++r)
    i[r] = t[r];
  for (r = 250; r >= 0; --r)
    si(i, i), r !== 1 && at(i, i, t);
  for (r = 0; r < 16; ++r)
    e[r] = i[r];
}
function qh(e, t) {
  var i = new Yt(32), r = new Yt(32);
  return Ma(i, e), Ma(r, t), Ap(i, 0, r, 0);
}
function Ap(e, t, i, r) {
  return Nb(e, t, i, r, 32);
}
function Nb(e, t, i, r, n) {
  var a, f = 0;
  for (a = 0; a < n; ++a)
    f |= e[t + a] ^ i[r + a];
  return (1 & f - 1 >>> 8) - 1;
}
function Bp(e) {
  var t = new Yt(32);
  return Ma(t, e), t[0] & 1;
}
function Tp(e, t, i) {
  var r, n;
  for (Nr(e[0], Uo), Nr(e[1], Ra), Nr(e[2], Ra), Nr(e[3], Uo), n = 255; n >= 0; --n)
    r = i[n / 8 | 0] >> (n & 7) & 1, Oh(e, t, r), qo(t, e), qo(e, e), Oh(e, t, r);
}
function _0(e, t) {
  var i = [we(), we(), we(), we()];
  Nr(i[0], Ph), Nr(i[1], Uh), Nr(i[2], Ra), at(i[3], Ph, Uh), Tp(e, i, t);
}
function Nr(e, t) {
  var i;
  for (i = 0; i < 16; i++)
    e[i] = t[i] | 0;
}
function kb(e, t) {
  var i = we(), r;
  for (r = 0; r < 16; ++r)
    i[r] = t[r];
  for (r = 253; r >= 0; --r)
    si(i, i), r !== 2 && r !== 4 && at(i, i, t);
  for (r = 0; r < 16; ++r)
    e[r] = i[r];
}
function Eo(e) {
  var t, i, r = 1;
  for (t = 0; t < 16; ++t)
    i = e[t] + r + 65535, r = Math.floor(i / 65536), e[t] = i - r * 65536;
  e[0] += r - 1 + 37 * (r - 1);
}
function Ip(e, t, i) {
  for (var r, n = ~(i - 1), a = 0; a < 16; ++a)
    r = n & (e[a] ^ t[a]), e[a] ^= r, t[a] ^= r;
}
function we(e) {
  var t, i = new Float64Array(16);
  if (e)
    for (t = 0; t < e.length; ++t)
      i[t] = e[t];
  return i;
}
function pi(e, t, i) {
  for (var r = 0; r < 16; ++r)
    e[r] = t[r] + i[r];
}
function yi(e, t, i) {
  for (var r = 0; r < 16; ++r)
    e[r] = t[r] - i[r];
}
function si(e, t) {
  at(e, t, t);
}
function at(e, t, i) {
  var r, n, a = 0, f = 0, s = 0, c = 0, u = 0, o = 0, l = 0, h = 0, p = 0, v = 0, y = 0, w = 0, x = 0, A = 0, R = 0, M = 0, D = 0, U = 0, z = 0, W = 0, G = 0, re = 0, V = 0, m = 0, g = 0, d = 0, b = 0, C = 0, E = 0, B = 0, T = 0, _ = i[0], I = i[1], S = i[2], k = i[3], $ = i[4], ee = i[5], H = i[6], N = i[7], L = i[8], j = i[9], Y = i[10], F = i[11], P = i[12], Z = i[13], ae = i[14], se = i[15];
  r = t[0], a += r * _, f += r * I, s += r * S, c += r * k, u += r * $, o += r * ee, l += r * H, h += r * N, p += r * L, v += r * j, y += r * Y, w += r * F, x += r * P, A += r * Z, R += r * ae, M += r * se, r = t[1], f += r * _, s += r * I, c += r * S, u += r * k, o += r * $, l += r * ee, h += r * H, p += r * N, v += r * L, y += r * j, w += r * Y, x += r * F, A += r * P, R += r * Z, M += r * ae, D += r * se, r = t[2], s += r * _, c += r * I, u += r * S, o += r * k, l += r * $, h += r * ee, p += r * H, v += r * N, y += r * L, w += r * j, x += r * Y, A += r * F, R += r * P, M += r * Z, D += r * ae, U += r * se, r = t[3], c += r * _, u += r * I, o += r * S, l += r * k, h += r * $, p += r * ee, v += r * H, y += r * N, w += r * L, x += r * j, A += r * Y, R += r * F, M += r * P, D += r * Z, U += r * ae, z += r * se, r = t[4], u += r * _, o += r * I, l += r * S, h += r * k, p += r * $, v += r * ee, y += r * H, w += r * N, x += r * L, A += r * j, R += r * Y, M += r * F, D += r * P, U += r * Z, z += r * ae, W += r * se, r = t[5], o += r * _, l += r * I, h += r * S, p += r * k, v += r * $, y += r * ee, w += r * H, x += r * N, A += r * L, R += r * j, M += r * Y, D += r * F, U += r * P, z += r * Z, W += r * ae, G += r * se, r = t[6], l += r * _, h += r * I, p += r * S, v += r * k, y += r * $, w += r * ee, x += r * H, A += r * N, R += r * L, M += r * j, D += r * Y, U += r * F, z += r * P, W += r * Z, G += r * ae, re += r * se, r = t[7], h += r * _, p += r * I, v += r * S, y += r * k, w += r * $, x += r * ee, A += r * H, R += r * N, M += r * L, D += r * j, U += r * Y, z += r * F, W += r * P, G += r * Z, re += r * ae, V += r * se, r = t[8], p += r * _, v += r * I, y += r * S, w += r * k, x += r * $, A += r * ee, R += r * H, M += r * N, D += r * L, U += r * j, z += r * Y, W += r * F, G += r * P, re += r * Z, V += r * ae, m += r * se, r = t[9], v += r * _, y += r * I, w += r * S, x += r * k, A += r * $, R += r * ee, M += r * H, D += r * N, U += r * L, z += r * j, W += r * Y, G += r * F, re += r * P, V += r * Z, m += r * ae, g += r * se, r = t[10], y += r * _, w += r * I, x += r * S, A += r * k, R += r * $, M += r * ee, D += r * H, U += r * N, z += r * L, W += r * j, G += r * Y, re += r * F, V += r * P, m += r * Z, g += r * ae, d += r * se, r = t[11], w += r * _, x += r * I, A += r * S, R += r * k, M += r * $, D += r * ee, U += r * H, z += r * N, W += r * L, G += r * j, re += r * Y, V += r * F, m += r * P, g += r * Z, d += r * ae, b += r * se, r = t[12], x += r * _, A += r * I, R += r * S, M += r * k, D += r * $, U += r * ee, z += r * H, W += r * N, G += r * L, re += r * j, V += r * Y, m += r * F, g += r * P, d += r * Z, b += r * ae, C += r * se, r = t[13], A += r * _, R += r * I, M += r * S, D += r * k, U += r * $, z += r * ee, W += r * H, G += r * N, re += r * L, V += r * j, m += r * Y, g += r * F, d += r * P, b += r * Z, C += r * ae, E += r * se, r = t[14], R += r * _, M += r * I, D += r * S, U += r * k, z += r * $, W += r * ee, G += r * H, re += r * N, V += r * L, m += r * j, g += r * Y, d += r * F, b += r * P, C += r * Z, E += r * ae, B += r * se, r = t[15], M += r * _, D += r * I, U += r * S, z += r * k, W += r * $, G += r * ee, re += r * H, V += r * N, m += r * L, g += r * j, d += r * Y, b += r * F, C += r * P, E += r * Z, B += r * ae, T += r * se, a += 38 * D, f += 38 * U, s += 38 * z, c += 38 * W, u += 38 * G, o += 38 * re, l += 38 * V, h += 38 * m, p += 38 * g, v += 38 * d, y += 38 * b, w += 38 * C, x += 38 * E, A += 38 * B, R += 38 * T, n = 1, r = a + n + 65535, n = Math.floor(r / 65536), a = r - n * 65536, r = f + n + 65535, n = Math.floor(r / 65536), f = r - n * 65536, r = s + n + 65535, n = Math.floor(r / 65536), s = r - n * 65536, r = c + n + 65535, n = Math.floor(r / 65536), c = r - n * 65536, r = u + n + 65535, n = Math.floor(r / 65536), u = r - n * 65536, r = o + n + 65535, n = Math.floor(r / 65536), o = r - n * 65536, r = l + n + 65535, n = Math.floor(r / 65536), l = r - n * 65536, r = h + n + 65535, n = Math.floor(r / 65536), h = r - n * 65536, r = p + n + 65535, n = Math.floor(r / 65536), p = r - n * 65536, r = v + n + 65535, n = Math.floor(r / 65536), v = r - n * 65536, r = y + n + 65535, n = Math.floor(r / 65536), y = r - n * 65536, r = w + n + 65535, n = Math.floor(r / 65536), w = r - n * 65536, r = x + n + 65535, n = Math.floor(r / 65536), x = r - n * 65536, r = A + n + 65535, n = Math.floor(r / 65536), A = r - n * 65536, r = R + n + 65535, n = Math.floor(r / 65536), R = r - n * 65536, r = M + n + 65535, n = Math.floor(r / 65536), M = r - n * 65536, a += n - 1 + 37 * (n - 1), n = 1, r = a + n + 65535, n = Math.floor(r / 65536), a = r - n * 65536, r = f + n + 65535, n = Math.floor(r / 65536), f = r - n * 65536, r = s + n + 65535, n = Math.floor(r / 65536), s = r - n * 65536, r = c + n + 65535, n = Math.floor(r / 65536), c = r - n * 65536, r = u + n + 65535, n = Math.floor(r / 65536), u = r - n * 65536, r = o + n + 65535, n = Math.floor(r / 65536), o = r - n * 65536, r = l + n + 65535, n = Math.floor(r / 65536), l = r - n * 65536, r = h + n + 65535, n = Math.floor(r / 65536), h = r - n * 65536, r = p + n + 65535, n = Math.floor(r / 65536), p = r - n * 65536, r = v + n + 65535, n = Math.floor(r / 65536), v = r - n * 65536, r = y + n + 65535, n = Math.floor(r / 65536), y = r - n * 65536, r = w + n + 65535, n = Math.floor(r / 65536), w = r - n * 65536, r = x + n + 65535, n = Math.floor(r / 65536), x = r - n * 65536, r = A + n + 65535, n = Math.floor(r / 65536), A = r - n * 65536, r = R + n + 65535, n = Math.floor(r / 65536), R = r - n * 65536, r = M + n + 65535, n = Math.floor(r / 65536), M = r - n * 65536, a += n - 1 + 37 * (n - 1), e[0] = a, e[1] = f, e[2] = s, e[3] = c, e[4] = u, e[5] = o, e[6] = l, e[7] = h, e[8] = p, e[9] = v, e[10] = y, e[11] = w, e[12] = x, e[13] = A, e[14] = R, e[15] = M;
}
var Jt = je;
Jt.kem = Jt.kem || {};
var Fh = Jt.jsbn.BigInteger;
Jt.kem.rsa = {};
Jt.kem.rsa.create = function(e, t) {
  t = t || {};
  var i = t.prng || Jt.random, r = {};
  return r.encrypt = function(n, a) {
    var f = Math.ceil(n.n.bitLength() / 8), s;
    do
      s = new Fh(
        Jt.util.bytesToHex(i.getBytesSync(f)),
        16
      ).mod(n.n);
    while (s.compareTo(Fh.ONE) <= 0);
    s = Jt.util.hexToBytes(s.toString(16));
    var c = f - s.length;
    c > 0 && (s = Jt.util.fillString("\0", c) + s);
    var u = n.encrypt(s, "NONE"), o = e.generate(s, a);
    return { encapsulation: u, key: o };
  }, r.decrypt = function(n, a, f) {
    var s = n.decrypt(a, "NONE");
    return e.generate(s, f);
  }, r;
};
Jt.kem.kdf1 = function(e, t) {
  Rp(this, e, 0, t || e.digestLength);
};
Jt.kem.kdf2 = function(e, t) {
  Rp(this, e, 1, t || e.digestLength);
};
function Rp(e, t, i, r) {
  e.generate = function(n, a) {
    for (var f = new Jt.util.ByteBuffer(), s = Math.ceil(a / r) + i, c = new Jt.util.ByteBuffer(), u = i; u < s; ++u) {
      c.putInt32(u), t.start(), t.update(n + c.getBytes());
      var o = t.digest();
      f.putBytes(o.getBytes(r));
    }
    return f.truncate(f.length() - a), f.getBytes();
  };
}
var Ye = je;
Ye.log = Ye.log || {};
Ye.log.levels = [
  "none",
  "error",
  "warning",
  "info",
  "debug",
  "verbose",
  "max"
];
var Na = {}, Fo = [], qi = null;
Ye.log.LEVEL_LOCKED = 2;
Ye.log.NO_LEVEL_CHECK = 4;
Ye.log.INTERPOLATE = 8;
for (var kr = 0; kr < Ye.log.levels.length; ++kr) {
  var Vh = Ye.log.levels[kr];
  Na[Vh] = {
    index: kr,
    name: Vh.toUpperCase()
  };
}
Ye.log.logMessage = function(e) {
  for (var t = Na[e.level].index, i = 0; i < Fo.length; ++i) {
    var r = Fo[i];
    if (r.flags & Ye.log.NO_LEVEL_CHECK)
      r.f(e);
    else {
      var n = Na[r.level].index;
      t <= n && r.f(r, e);
    }
  }
};
Ye.log.prepareStandard = function(e) {
  "standard" in e || (e.standard = Na[e.level].name + //' ' + +message.timestamp +
  " [" + e.category + "] " + e.message);
};
Ye.log.prepareFull = function(e) {
  if (!("full" in e)) {
    var t = [e.message];
    t = t.concat([]), e.full = Ye.util.format.apply(this, t);
  }
};
Ye.log.prepareStandardFull = function(e) {
  "standardFull" in e || (Ye.log.prepareStandard(e), e.standardFull = e.standard);
};
for (var Kh = ["error", "warning", "info", "debug", "verbose"], kr = 0; kr < Kh.length; ++kr)
  (function(t) {
    Ye.log[t] = function(i, r) {
      var n = Array.prototype.slice.call(arguments).slice(2), a = {
        timestamp: /* @__PURE__ */ new Date(),
        level: t,
        category: i,
        message: r,
        arguments: n
        /*standard*/
        /*full*/
        /*fullMessage*/
      };
      Ye.log.logMessage(a);
    };
  })(Kh[kr]);
Ye.log.makeLogger = function(e) {
  var t = {
    flags: 0,
    f: e
  };
  return Ye.log.setLevel(t, "none"), t;
};
Ye.log.setLevel = function(e, t) {
  var i = !1;
  if (e && !(e.flags & Ye.log.LEVEL_LOCKED))
    for (var r = 0; r < Ye.log.levels.length; ++r) {
      var n = Ye.log.levels[r];
      if (t == n) {
        e.level = t, i = !0;
        break;
      }
    }
  return i;
};
Ye.log.lock = function(e, t) {
  typeof t > "u" || t ? e.flags |= Ye.log.LEVEL_LOCKED : e.flags &= ~Ye.log.LEVEL_LOCKED;
};
Ye.log.addLogger = function(e) {
  Fo.push(e);
};
if (typeof console < "u" && "log" in console) {
  var ki;
  if (console.error && console.warn && console.info && console.debug) {
    var Db = {
      error: console.error,
      warning: console.warn,
      info: console.info,
      debug: console.debug,
      verbose: console.debug
    }, S0 = function(e, t) {
      Ye.log.prepareStandard(t);
      var i = Db[t.level], r = [t.standard];
      r = r.concat(t.arguments.slice()), i.apply(console, r);
    };
    ki = Ye.log.makeLogger(S0);
  } else {
    var S0 = function(t, i) {
      Ye.log.prepareStandardFull(i), console.log(i.standardFull);
    };
    ki = Ye.log.makeLogger(S0);
  }
  Ye.log.setLevel(ki, "debug"), Ye.log.addLogger(ki), qi = ki;
} else
  console = {
    log: function() {
    }
  };
if (qi !== null && typeof window < "u" && window.location) {
  var ya = new URL(window.location.href).searchParams;
  if (ya.has("console.level") && Ye.log.setLevel(
    qi,
    ya.get("console.level").slice(-1)[0]
  ), ya.has("console.lock")) {
    var Lb = ya.get("console.lock").slice(-1)[0];
    Lb == "true" && Ye.log.lock(qi);
  }
}
Ye.log.consoleLogger = qi;
var de = je, X = de.asn1, Wt = de.pkcs7 = de.pkcs7 || {};
Wt.messageFromPem = function(e) {
  var t = de.pem.decode(e)[0];
  if (t.type !== "PKCS7") {
    var i = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
    throw i.headerType = t.type, i;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
  var r = X.fromDer(t.body);
  return Wt.messageFromAsn1(r);
};
Wt.messageToPem = function(e, t) {
  var i = {
    type: "PKCS7",
    body: X.toDer(e.toAsn1()).getBytes()
  };
  return de.pem.encode(i, { maxline: t });
};
Wt.messageFromAsn1 = function(e) {
  var t = {}, i = [];
  if (!X.validate(e, Wt.asn1.contentInfoValidator, t, i)) {
    var r = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
    throw r.errors = i, r;
  }
  var n = X.derToOid(t.contentType), a;
  switch (n) {
    case de.pki.oids.envelopedData:
      a = Wt.createEnvelopedData();
      break;
    case de.pki.oids.encryptedData:
      a = Wt.createEncryptedData();
      break;
    case de.pki.oids.signedData:
      a = Wt.createSignedData();
      break;
    default:
      throw new Error("Cannot read PKCS#7 message. ContentType with OID " + n + " is not (yet) supported.");
  }
  return a.fromAsn1(t.content.value[0]), a;
};
Wt.createSignedData = function() {
  var e = null;
  return e = {
    type: de.pki.oids.signedData,
    version: 1,
    certificates: [],
    crls: [],
    // TODO: add json-formatted signer stuff here?
    signers: [],
    // populated during sign()
    digestAlgorithmIdentifiers: [],
    contentInfo: null,
    signerInfos: [],
    fromAsn1: function(r) {
      if (E0(e, r, Wt.asn1.signedDataValidator), e.certificates = [], e.crls = [], e.digestAlgorithmIdentifiers = [], e.contentInfo = null, e.signerInfos = [], e.rawCapture.certificates)
        for (var n = e.rawCapture.certificates.value, a = 0; a < n.length; ++a)
          e.certificates.push(de.pki.certificateFromAsn1(n[a]));
    },
    toAsn1: function() {
      e.contentInfo || e.sign();
      for (var r = [], n = 0; n < e.certificates.length; ++n)
        r.push(de.pki.certificateToAsn1(e.certificates[n]));
      var a = [], f = X.create(X.Class.CONTEXT_SPECIFIC, 0, !0, [
        X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
          // Version
          X.create(
            X.Class.UNIVERSAL,
            X.Type.INTEGER,
            !1,
            X.integerToDer(e.version).getBytes()
          ),
          // DigestAlgorithmIdentifiers
          X.create(
            X.Class.UNIVERSAL,
            X.Type.SET,
            !0,
            e.digestAlgorithmIdentifiers
          ),
          // ContentInfo
          e.contentInfo
        ])
      ]);
      return r.length > 0 && f.value[0].value.push(
        X.create(X.Class.CONTEXT_SPECIFIC, 0, !0, r)
      ), a.length > 0 && f.value[0].value.push(
        X.create(X.Class.CONTEXT_SPECIFIC, 1, !0, a)
      ), f.value[0].value.push(
        X.create(
          X.Class.UNIVERSAL,
          X.Type.SET,
          !0,
          e.signerInfos
        )
      ), X.create(
        X.Class.UNIVERSAL,
        X.Type.SEQUENCE,
        !0,
        [
          // ContentType
          X.create(
            X.Class.UNIVERSAL,
            X.Type.OID,
            !1,
            X.oidToDer(e.type).getBytes()
          ),
          // [0] SignedData
          f
        ]
      );
    },
    /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */
    addSigner: function(r) {
      var n = r.issuer, a = r.serialNumber;
      if (r.certificate) {
        var f = r.certificate;
        typeof f == "string" && (f = de.pki.certificateFromPem(f)), n = f.issuer.attributes, a = f.serialNumber;
      }
      var s = r.key;
      if (!s)
        throw new Error(
          "Could not add PKCS#7 signer; no private key specified."
        );
      typeof s == "string" && (s = de.pki.privateKeyFromPem(s));
      var c = r.digestAlgorithm || de.pki.oids.sha1;
      switch (c) {
        case de.pki.oids.sha1:
        case de.pki.oids.sha256:
        case de.pki.oids.sha384:
        case de.pki.oids.sha512:
        case de.pki.oids.md5:
          break;
        default:
          throw new Error(
            "Could not add PKCS#7 signer; unknown message digest algorithm: " + c
          );
      }
      var u = r.authenticatedAttributes || [];
      if (u.length > 0) {
        for (var o = !1, l = !1, h = 0; h < u.length; ++h) {
          var p = u[h];
          if (!o && p.type === de.pki.oids.contentType) {
            if (o = !0, l)
              break;
            continue;
          }
          if (!l && p.type === de.pki.oids.messageDigest) {
            if (l = !0, o)
              break;
            continue;
          }
        }
        if (!o || !l)
          throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
      }
      e.signers.push({
        key: s,
        version: 1,
        issuer: n,
        serialNumber: a,
        digestAlgorithm: c,
        signatureAlgorithm: de.pki.oids.rsaEncryption,
        signature: null,
        authenticatedAttributes: u,
        unauthenticatedAttributes: []
      });
    },
    /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */
    sign: function(r) {
      if (r = r || {}, (typeof e.content != "object" || e.contentInfo === null) && (e.contentInfo = X.create(
        X.Class.UNIVERSAL,
        X.Type.SEQUENCE,
        !0,
        [
          // ContentType
          X.create(
            X.Class.UNIVERSAL,
            X.Type.OID,
            !1,
            X.oidToDer(de.pki.oids.data).getBytes()
          )
        ]
      ), "content" in e)) {
        var n;
        e.content instanceof de.util.ByteBuffer ? n = e.content.bytes() : typeof e.content == "string" && (n = de.util.encodeUtf8(e.content)), r.detached ? e.detachedContent = X.create(X.Class.UNIVERSAL, X.Type.OCTETSTRING, !1, n) : e.contentInfo.value.push(
          // [0] EXPLICIT content
          X.create(X.Class.CONTEXT_SPECIFIC, 0, !0, [
            X.create(
              X.Class.UNIVERSAL,
              X.Type.OCTETSTRING,
              !1,
              n
            )
          ])
        );
      }
      if (e.signers.length !== 0) {
        var a = t();
        i(a);
      }
    },
    verify: function() {
      throw new Error("PKCS#7 signature verification not yet implemented.");
    },
    /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */
    addCertificate: function(r) {
      typeof r == "string" && (r = de.pki.certificateFromPem(r)), e.certificates.push(r);
    },
    /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */
    addCertificateRevokationList: function(r) {
      throw new Error("PKCS#7 CRL support not yet implemented.");
    }
  }, e;
  function t() {
    for (var r = {}, n = 0; n < e.signers.length; ++n) {
      var a = e.signers[n], f = a.digestAlgorithm;
      f in r || (r[f] = de.md[de.pki.oids[f]].create()), a.authenticatedAttributes.length === 0 ? a.md = r[f] : a.md = de.md[de.pki.oids[f]].create();
    }
    e.digestAlgorithmIdentifiers = [];
    for (var f in r)
      e.digestAlgorithmIdentifiers.push(
        // AlgorithmIdentifier
        X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
          // algorithm
          X.create(
            X.Class.UNIVERSAL,
            X.Type.OID,
            !1,
            X.oidToDer(f).getBytes()
          ),
          // parameters (null)
          X.create(X.Class.UNIVERSAL, X.Type.NULL, !1, "")
        ])
      );
    return r;
  }
  function i(r) {
    var n;
    if (e.detachedContent ? n = e.detachedContent : (n = e.contentInfo.value[1], n = n.value[0]), !n)
      throw new Error(
        "Could not sign PKCS#7 message; there is no content to sign."
      );
    var a = X.derToOid(e.contentInfo.value[0].value), f = X.toDer(n);
    f.getByte(), X.getBerValueLength(f), f = f.getBytes();
    for (var s in r)
      r[s].start().update(f);
    for (var c = /* @__PURE__ */ new Date(), u = 0; u < e.signers.length; ++u) {
      var o = e.signers[u];
      if (o.authenticatedAttributes.length === 0) {
        if (a !== de.pki.oids.data)
          throw new Error(
            "Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data."
          );
      } else {
        o.authenticatedAttributesAsn1 = X.create(
          X.Class.CONTEXT_SPECIFIC,
          0,
          !0,
          []
        );
        for (var l = X.create(
          X.Class.UNIVERSAL,
          X.Type.SET,
          !0,
          []
        ), h = 0; h < o.authenticatedAttributes.length; ++h) {
          var p = o.authenticatedAttributes[h];
          p.type === de.pki.oids.messageDigest ? p.value = r[o.digestAlgorithm].digest() : p.type === de.pki.oids.signingTime && (p.value || (p.value = c)), l.value.push(Vo(p)), o.authenticatedAttributesAsn1.value.push(Vo(p));
        }
        f = X.toDer(l).getBytes(), o.md.start().update(f);
      }
      o.signature = o.key.sign(o.md, "RSASSA-PKCS1-V1_5");
    }
    e.signerInfos = Vb(e.signers);
  }
};
Wt.createEncryptedData = function() {
  var e = null;
  return e = {
    type: de.pki.oids.encryptedData,
    version: 0,
    encryptedContent: {
      algorithm: de.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */
    fromAsn1: function(t) {
      E0(e, t, Wt.asn1.encryptedDataValidator);
    },
    /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */
    decrypt: function(t) {
      t !== void 0 && (e.encryptedContent.key = t), Mp(e);
    }
  }, e;
};
Wt.createEnvelopedData = function() {
  var e = null;
  return e = {
    type: de.pki.oids.envelopedData,
    version: 0,
    recipients: [],
    encryptedContent: {
      algorithm: de.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */
    fromAsn1: function(t) {
      var i = E0(e, t, Wt.asn1.envelopedDataValidator);
      e.recipients = Ob(i.recipientInfos.value);
    },
    toAsn1: function() {
      return X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
        // ContentType
        X.create(
          X.Class.UNIVERSAL,
          X.Type.OID,
          !1,
          X.oidToDer(e.type).getBytes()
        ),
        // [0] EnvelopedData
        X.create(X.Class.CONTEXT_SPECIFIC, 0, !0, [
          X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
            // Version
            X.create(
              X.Class.UNIVERSAL,
              X.Type.INTEGER,
              !1,
              X.integerToDer(e.version).getBytes()
            ),
            // RecipientInfos
            X.create(
              X.Class.UNIVERSAL,
              X.Type.SET,
              !0,
              qb(e.recipients)
            ),
            // EncryptedContentInfo
            X.create(
              X.Class.UNIVERSAL,
              X.Type.SEQUENCE,
              !0,
              Kb(e.encryptedContent)
            )
          ])
        ])
      ]);
    },
    /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */
    findRecipient: function(t) {
      for (var i = t.issuer.attributes, r = 0; r < e.recipients.length; ++r) {
        var n = e.recipients[r], a = n.issuer;
        if (n.serialNumber === t.serialNumber && a.length === i.length) {
          for (var f = !0, s = 0; s < i.length; ++s)
            if (a[s].type !== i[s].type || a[s].value !== i[s].value) {
              f = !1;
              break;
            }
          if (f)
            return n;
        }
      }
      return null;
    },
    /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */
    decrypt: function(t, i) {
      if (e.encryptedContent.key === void 0 && t !== void 0 && i !== void 0)
        switch (t.encryptedContent.algorithm) {
          case de.pki.oids.rsaEncryption:
          case de.pki.oids.desCBC:
            var r = i.decrypt(t.encryptedContent.content);
            e.encryptedContent.key = de.util.createBuffer(r);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + t.encryptedContent.algorithm);
        }
      Mp(e);
    },
    /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */
    addRecipient: function(t) {
      e.recipients.push({
        version: 0,
        issuer: t.issuer.attributes,
        serialNumber: t.serialNumber,
        encryptedContent: {
          // We simply assume rsaEncryption here, since forge.pki only
          // supports RSA so far.  If the PKI module supports other
          // ciphers one day, we need to modify this one as well.
          algorithm: de.pki.oids.rsaEncryption,
          key: t.publicKey
        }
      });
    },
    /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */
    encrypt: function(t, i) {
      if (e.encryptedContent.content === void 0) {
        i = i || e.encryptedContent.algorithm, t = t || e.encryptedContent.key;
        var r, n, a;
        switch (i) {
          case de.pki.oids["aes128-CBC"]:
            r = 16, n = 16, a = de.aes.createEncryptionCipher;
            break;
          case de.pki.oids["aes192-CBC"]:
            r = 24, n = 16, a = de.aes.createEncryptionCipher;
            break;
          case de.pki.oids["aes256-CBC"]:
            r = 32, n = 16, a = de.aes.createEncryptionCipher;
            break;
          case de.pki.oids["des-EDE3-CBC"]:
            r = 24, n = 8, a = de.des.createEncryptionCipher;
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + i);
        }
        if (t === void 0)
          t = de.util.createBuffer(de.random.getBytes(r));
        else if (t.length() != r)
          throw new Error("Symmetric key has wrong length; got " + t.length() + " bytes, expected " + r + ".");
        e.encryptedContent.algorithm = i, e.encryptedContent.key = t, e.encryptedContent.parameter = de.util.createBuffer(
          de.random.getBytes(n)
        );
        var f = a(t);
        if (f.start(e.encryptedContent.parameter.copy()), f.update(e.content), !f.finish())
          throw new Error("Symmetric encryption failed.");
        e.encryptedContent.content = f.output;
      }
      for (var s = 0; s < e.recipients.length; ++s) {
        var c = e.recipients[s];
        if (c.encryptedContent.content === void 0)
          switch (c.encryptedContent.algorithm) {
            case de.pki.oids.rsaEncryption:
              c.encryptedContent.content = c.encryptedContent.key.encrypt(
                e.encryptedContent.key.data
              );
              break;
            default:
              throw new Error("Unsupported asymmetric cipher, OID " + c.encryptedContent.algorithm);
          }
      }
    }
  }, e;
};
function Pb(e) {
  var t = {}, i = [];
  if (!X.validate(e, Wt.asn1.recipientInfoValidator, t, i)) {
    var r = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
    throw r.errors = i, r;
  }
  return {
    version: t.version.charCodeAt(0),
    issuer: de.pki.RDNAttributesAsArray(t.issuer),
    serialNumber: de.util.createBuffer(t.serial).toHex(),
    encryptedContent: {
      algorithm: X.derToOid(t.encAlgorithm),
      parameter: t.encParameter ? t.encParameter.value : void 0,
      content: t.encKey
    }
  };
}
function Ub(e) {
  return X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
    // Version
    X.create(
      X.Class.UNIVERSAL,
      X.Type.INTEGER,
      !1,
      X.integerToDer(e.version).getBytes()
    ),
    // IssuerAndSerialNumber
    X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
      // Name
      de.pki.distinguishedNameToAsn1({ attributes: e.issuer }),
      // Serial
      X.create(
        X.Class.UNIVERSAL,
        X.Type.INTEGER,
        !1,
        de.util.hexToBytes(e.serialNumber)
      )
    ]),
    // KeyEncryptionAlgorithmIdentifier
    X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
      // Algorithm
      X.create(
        X.Class.UNIVERSAL,
        X.Type.OID,
        !1,
        X.oidToDer(e.encryptedContent.algorithm).getBytes()
      ),
      // Parameter, force NULL, only RSA supported for now.
      X.create(X.Class.UNIVERSAL, X.Type.NULL, !1, "")
    ]),
    // EncryptedKey
    X.create(
      X.Class.UNIVERSAL,
      X.Type.OCTETSTRING,
      !1,
      e.encryptedContent.content
    )
  ]);
}
function Ob(e) {
  for (var t = [], i = 0; i < e.length; ++i)
    t.push(Pb(e[i]));
  return t;
}
function qb(e) {
  for (var t = [], i = 0; i < e.length; ++i)
    t.push(Ub(e[i]));
  return t;
}
function Fb(e) {
  var t = X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
    // version
    X.create(
      X.Class.UNIVERSAL,
      X.Type.INTEGER,
      !1,
      X.integerToDer(e.version).getBytes()
    ),
    // issuerAndSerialNumber
    X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
      // name
      de.pki.distinguishedNameToAsn1({ attributes: e.issuer }),
      // serial
      X.create(
        X.Class.UNIVERSAL,
        X.Type.INTEGER,
        !1,
        de.util.hexToBytes(e.serialNumber)
      )
    ]),
    // digestAlgorithm
    X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
      // algorithm
      X.create(
        X.Class.UNIVERSAL,
        X.Type.OID,
        !1,
        X.oidToDer(e.digestAlgorithm).getBytes()
      ),
      // parameters (null)
      X.create(X.Class.UNIVERSAL, X.Type.NULL, !1, "")
    ])
  ]);
  if (e.authenticatedAttributesAsn1 && t.value.push(e.authenticatedAttributesAsn1), t.value.push(X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
    // algorithm
    X.create(
      X.Class.UNIVERSAL,
      X.Type.OID,
      !1,
      X.oidToDer(e.signatureAlgorithm).getBytes()
    ),
    // parameters (null)
    X.create(X.Class.UNIVERSAL, X.Type.NULL, !1, "")
  ])), t.value.push(X.create(
    X.Class.UNIVERSAL,
    X.Type.OCTETSTRING,
    !1,
    e.signature
  )), e.unauthenticatedAttributes.length > 0) {
    for (var i = X.create(X.Class.CONTEXT_SPECIFIC, 1, !0, []), r = 0; r < e.unauthenticatedAttributes.length; ++r) {
      var n = e.unauthenticatedAttributes[r];
      i.values.push(Vo(n));
    }
    t.value.push(i);
  }
  return t;
}
function Vb(e) {
  for (var t = [], i = 0; i < e.length; ++i)
    t.push(Fb(e[i]));
  return t;
}
function Vo(e) {
  var t;
  if (e.type === de.pki.oids.contentType)
    t = X.create(
      X.Class.UNIVERSAL,
      X.Type.OID,
      !1,
      X.oidToDer(e.value).getBytes()
    );
  else if (e.type === de.pki.oids.messageDigest)
    t = X.create(
      X.Class.UNIVERSAL,
      X.Type.OCTETSTRING,
      !1,
      e.value.bytes()
    );
  else if (e.type === de.pki.oids.signingTime) {
    var i = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), r = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z"), n = e.value;
    if (typeof n == "string") {
      var a = Date.parse(n);
      isNaN(a) ? n.length === 13 ? n = X.utcTimeToDate(n) : n = X.generalizedTimeToDate(n) : n = new Date(a);
    }
    n >= i && n < r ? t = X.create(
      X.Class.UNIVERSAL,
      X.Type.UTCTIME,
      !1,
      X.dateToUtcTime(n)
    ) : t = X.create(
      X.Class.UNIVERSAL,
      X.Type.GENERALIZEDTIME,
      !1,
      X.dateToGeneralizedTime(n)
    );
  }
  return X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
    // AttributeType
    X.create(
      X.Class.UNIVERSAL,
      X.Type.OID,
      !1,
      X.oidToDer(e.type).getBytes()
    ),
    X.create(X.Class.UNIVERSAL, X.Type.SET, !0, [
      // AttributeValue
      t
    ])
  ]);
}
function Kb(e) {
  return [
    // ContentType, always Data for the moment
    X.create(
      X.Class.UNIVERSAL,
      X.Type.OID,
      !1,
      X.oidToDer(de.pki.oids.data).getBytes()
    ),
    // ContentEncryptionAlgorithmIdentifier
    X.create(X.Class.UNIVERSAL, X.Type.SEQUENCE, !0, [
      // Algorithm
      X.create(
        X.Class.UNIVERSAL,
        X.Type.OID,
        !1,
        X.oidToDer(e.algorithm).getBytes()
      ),
      // Parameters (IV)
      e.parameter ? X.create(
        X.Class.UNIVERSAL,
        X.Type.OCTETSTRING,
        !1,
        e.parameter.getBytes()
      ) : void 0
    ]),
    // [0] EncryptedContent
    X.create(X.Class.CONTEXT_SPECIFIC, 0, !0, [
      X.create(
        X.Class.UNIVERSAL,
        X.Type.OCTETSTRING,
        !1,
        e.content.getBytes()
      )
    ])
  ];
}
function E0(e, t, i) {
  var r = {}, n = [];
  if (!X.validate(t, i, r, n)) {
    var a = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
    throw a.errors = a, a;
  }
  var f = X.derToOid(r.contentType);
  if (f !== de.pki.oids.data)
    throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
  if (r.encryptedContent) {
    var s = "";
    if (de.util.isArray(r.encryptedContent))
      for (var c = 0; c < r.encryptedContent.length; ++c) {
        if (r.encryptedContent[c].type !== X.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
        s += r.encryptedContent[c].value;
      }
    else
      s = r.encryptedContent;
    e.encryptedContent = {
      algorithm: X.derToOid(r.encAlgorithm),
      parameter: de.util.createBuffer(r.encParameter.value),
      content: de.util.createBuffer(s)
    };
  }
  if (r.content) {
    var s = "";
    if (de.util.isArray(r.content))
      for (var c = 0; c < r.content.length; ++c) {
        if (r.content[c].type !== X.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
        s += r.content[c].value;
      }
    else
      s = r.content;
    e.content = de.util.createBuffer(s);
  }
  return e.version = r.version.charCodeAt(0), e.rawCapture = r, r;
}
function Mp(e) {
  if (e.encryptedContent.key === void 0)
    throw new Error("Symmetric key not available.");
  if (e.content === void 0) {
    var t;
    switch (e.encryptedContent.algorithm) {
      case de.pki.oids["aes128-CBC"]:
      case de.pki.oids["aes192-CBC"]:
      case de.pki.oids["aes256-CBC"]:
        t = de.aes.createDecryptionCipher(e.encryptedContent.key);
        break;
      case de.pki.oids.desCBC:
      case de.pki.oids["des-EDE3-CBC"]:
        t = de.des.createDecryptionCipher(e.encryptedContent.key);
        break;
      default:
        throw new Error("Unsupported symmetric cipher, OID " + e.encryptedContent.algorithm);
    }
    if (t.start(e.encryptedContent.parameter), t.update(e.encryptedContent.content), !t.finish())
      throw new Error("Symmetric decryption failed.");
    e.content = t.output;
  }
}
var Lt = je, Xa = Lt.ssh = Lt.ssh || {};
Xa.privateKeyToPutty = function(e, t, i) {
  i = i || "", t = t || "";
  var r = "ssh-rsa", n = t === "" ? "none" : "aes256-cbc", a = "PuTTY-User-Key-File-2: " + r + `\r
`;
  a += "Encryption: " + n + `\r
`, a += "Comment: " + i + `\r
`;
  var f = Lt.util.createBuffer();
  gi(f, r), yr(f, e.e), yr(f, e.n);
  var s = Lt.util.encode64(f.bytes(), 64), c = Math.floor(s.length / 66) + 1;
  a += "Public-Lines: " + c + `\r
`, a += s;
  var u = Lt.util.createBuffer();
  yr(u, e.d), yr(u, e.p), yr(u, e.q), yr(u, e.qInv);
  var o;
  if (!t)
    o = Lt.util.encode64(u.bytes(), 64);
  else {
    var l = u.length() + 16 - 1;
    l -= l % 16;
    var h = ga(u.bytes());
    h.truncate(h.length() - l + u.length()), u.putBuffer(h);
    var p = Lt.util.createBuffer();
    p.putBuffer(ga("\0\0\0\0", t)), p.putBuffer(ga("\0\0\0", t));
    var v = Lt.aes.createEncryptionCipher(p.truncate(8), "CBC");
    v.start(Lt.util.createBuffer().fillWithByte(0, 16)), v.update(u.copy()), v.finish();
    var y = v.output;
    y.truncate(16), o = Lt.util.encode64(y.bytes(), 64);
  }
  c = Math.floor(o.length / 66) + 1, a += `\r
Private-Lines: ` + c + `\r
`, a += o;
  var w = ga("putty-private-key-file-mac-key", t), x = Lt.util.createBuffer();
  gi(x, r), gi(x, n), gi(x, i), x.putInt32(f.length()), x.putBuffer(f), x.putInt32(u.length()), x.putBuffer(u);
  var A = Lt.hmac.create();
  return A.start("sha1", w), A.update(x.bytes()), a += `\r
Private-MAC: ` + A.digest().toHex() + `\r
`, a;
};
Xa.publicKeyToOpenSSH = function(e, t) {
  var i = "ssh-rsa";
  t = t || "";
  var r = Lt.util.createBuffer();
  return gi(r, i), yr(r, e.e), yr(r, e.n), i + " " + Lt.util.encode64(r.bytes()) + " " + t;
};
Xa.privateKeyToOpenSSH = function(e, t) {
  return t ? Lt.pki.encryptRsaPrivateKey(
    e,
    t,
    { legacy: !0, algorithm: "aes128" }
  ) : Lt.pki.privateKeyToPem(e);
};
Xa.getPublicKeyFingerprint = function(e, t) {
  t = t || {};
  var i = t.md || Lt.md.md5.create(), r = "ssh-rsa", n = Lt.util.createBuffer();
  gi(n, r), yr(n, e.e), yr(n, e.n), i.start(), i.update(n.getBytes());
  var a = i.digest();
  if (t.encoding === "hex") {
    var f = a.toHex();
    return t.delimiter ? f.match(/.{2}/g).join(t.delimiter) : f;
  } else {
    if (t.encoding === "binary")
      return a.getBytes();
    if (t.encoding)
      throw new Error('Unknown encoding "' + t.encoding + '".');
  }
  return a;
};
function yr(e, t) {
  var i = t.toString(16);
  i[0] >= "8" && (i = "00" + i);
  var r = Lt.util.hexToBytes(i);
  e.putInt32(r.length), e.putBytes(r);
}
function gi(e, t) {
  e.putInt32(t.length), e.putString(t);
}
function ga() {
  for (var e = Lt.md.sha1.create(), t = arguments.length, i = 0; i < t; ++i)
    e.update(arguments[i]);
  return e.digest();
}
var Gb = je;
export {
  Gb as l,
  Ga as r
};
//# sourceMappingURL=index-b-LDu0Rp.js.map
